// export const Slot = [
//   {
//     name: "Crazy777 2",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/6892c3310fb55.png",
//     key: "JILI",
//   },
//   {
//     name: "Super Ace Deluxe",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/6683b86cb51ff.png",
//     key: "JILI",
//   },
//   {
//     name: "Crazy777",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/jili/35_0.jpg",
//     key: "JILI",
//   },
//   {
//     name: "Super Ace",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/jili/49_0.jpg",
//     key: "JILI",
//   },
//   {
//     name: "Crazy Hunter",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/jili/92_0.jpg",
//     key: "JILI",
//   },
//   {
//     name: "Fortune Gems",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/jili/109_0.jpg",
//     key: "JILI",
//   },
//   {
//     name: "Golden Empire",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/jili/103_0.jpg",
//     key: "JILI",
//   },
//   {
//     name: "Lucky Coming",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/jili/91_0.jpg",
//     key: "JILI",
//   },
//   {
//     name: "Pharaoh Treasure",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/jili/85_0.jpg",
//     key: "JILI",
//   },
//   {
//     name: "Boxing King",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/jili/77_0.jpg",
//     key: "JILI",
//   },
//   {
//     name: "Jungle King",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/jili/16_0.jpg",
//     key: "JILI",
//   },
//   {
//     name: "Money Coming",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/jili/51_0.jpg",
//     key: "JILI",
//   },
//   {
//     name: "Treasure Quest",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/6790957557bd1.png",
//     key: "JILI",
//   },
//   {
//     name: "3 Coin Wild Horse",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/67aab565bbefb.png",
//     key: "JILI",
//   },
//   {
//     name: "Roma X Deluxe",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/67b5908386362.png",
//     key: "JILI",
//   },
//   {
//     name: "Super Ace Joker",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/67c80d6a0a087.png",
//     key: "JILI",
//   },
//   {
//     name: "Fortune Coins",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/67da733e4296a.png",
//     key: "JILI",
//   },
//   {
//     name: "3 Charge Buffalo",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/67eca8132eb55.png",
//     key: "JILI",
//   },
//   {
//     name: "3 Coin Treasures 2",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/68006e01c7d70.png",
//     key: "JILI",
//   },
//   {
//     name: "Pirate Queen 2",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/681b2703d9f14.png",
//     key: "JILI",
//   },
//   {
//     name: "3 LUCKY LION",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/682ede39acd23.png",
//     key: "JILI",
//   },
//   {
//     name: "Golden Empire 2",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/685b7f910f978.png",
//     key: "JILI",
//   },
//   {
//     name: "Super Ace II",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/6864f2dd1d0ea.png",
//     key: "JILI",
//   },
//   {
//     name: "Money Coming 2",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/68746c8265352.png",
//     key: "JILI",
//   },
//   {
//     name: "Circus Joker 4096",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/68772b2d34288.png",
//     key: "JILI",
//   },
//   {
//     name: "Rapid Gems 777",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/68ca62897353a.jpg",
//     key: "JILI",
//   },
//   {
//     name: "Jackpot Joker FEVER",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/68d35e9309a8b.jpg",
//     key: "JILI",
//   },
//   {
//     name: "Safari King",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/68dce77abde9c.jpg",
//     key: "JILI",
//   },
//   {
//     name: "ROMA X 10000",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/68e5e29b55657.png",
//     key: "JILI",
//   },
//   {
//     name: "Cash Coin",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/68f8476f617fe.jpg",
//     key: "JILI",
//   },
//   {
//     name: "Joker Coins",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/690af1a8acf19.png",
//     key: "JILI",
//   },
//   {
//     name: "Royal Quest",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/691436ee6b7b8.png",
//     key: "JILI",
//   },
//   {
//     name: "Boxing King Title Match",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/691d2d7d8e59e.png",
//     key: "JILI",
//   },
//   {
//     name: "Fortune Coins 2",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/6926776da7c6a.jpg",
//     key: "JILI",
//   },
//   {
//     name: "Circus Jackpot",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/692fbeb4bdff1.png",
//     key: "JILI",
//   },
//   {
//     name: "10 Sparkling Crown",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/6938dc63e1881.png",
//     key: "JILI",
//   },
//   {
//     name: "Clover Coins 3x3",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/694229047fc83.png",
//     key: "JILI",
//   },
//   {
//     name: "Gallina Fortunata",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/694ba0b915357.jpg",
//     key: "JILI",
//   },
//   {
//     name: "Lucky Jaguar",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/694ba3a0d27a0.png",
//     key: "JILI",
//   },
//   {
//     name: "Legacy of Egypt",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/694ba3c0da3a5.png",
//     key: "JILI",
//   },
//   {
//     name: "3 Witch's Lamp",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/695dcfae1c80a.jpg",
//     key: "JILI",
//   },
//   {
//     name: "3 Coin Golden OX",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/69670cb4c2cb3.png",
//     key: "JILI",
//   },
//   {
//     name: "20 Blazing Clover",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/6982f435c8c43.png",
//     key: "JILI",
//   },
//   {
//     name: "Lucky Jaguar 2",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/699e7232bb498.png",
//     key: "JILI",
//   },
//   {
//     name: "Party Ape",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/69a7dd87e7b20.png",
//     key: "JILI",
//   },
//   {
//     name: "Fortune Garuda 500",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/69e5decee926c.jpg",
//     key: "JILI",
//   },
//   {
//     name: "40 Sparkling Crown",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/69b0d66ae042d.jpg",
//     key: "JILI",
//   },
//   {
//     name: "Coin of Lightning",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/69ba6743ba0d2.jpg",
//     key: "JILI",
//   },
//   {
//     name: "3 Super Ace",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/69c35f6045c93.jpg",
//     key: "JILI",
//   },
//   {
//     name: "Fortune Gems Legend",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/69cb52101e775.jpg",
//     key: "JILI",
//   },
//   {
//     name: "Lucky Jaguar 500",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/69d5cb9f4177a.jpg",
//     key: "JILI",
//   },
//   {
//     name: "Clover Coins 4x4",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/69df892ab9509.jpg",
//     key: "JILI",
//   },
//   {
//     name: "100 Blazing Clover",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/69f17099af886.jpg",
//     key: "JILI",
//   },
//   {
//     name: "Fortune Hook Boom",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/6a040143b6074.jpg",
//     key: "JILI",
//   },
//   {
//     name: "Supernova",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/6a0d22c2d62d0.png",
//     key: "JILI",
//   },
//   {
//     name: "Football Golden Cup",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/6a0d22dde681d.png",
//     key: "JILI",
//   },
//   {
//     name: "Devil Fire Twins",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/6a173c1bdfb1a.jpg",
//     key: "JILI",
//   },
//   {
//     name: "Super Ace SPEED",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/6a2a31a962568.jpg",
//     key: "JILI",
//   },
//   {
//     name: "Crown of Fortune",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/6a3270fe64954.jpg",
//     key: "JILI",
//   },
//   {
//     name: "Jackpot Football",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/6a3276449291d.jpg",
//     key: "JILI",
//   },
//   {
//     name: "Lucky Caramelo",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/6a3b7332525ad.png",
//     key: "JILI",
//   },
//   {
//     name: "Dice & Drop",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/6a41e2cd252f6.jpg",
//     key: "JILI",
//   },
//   {
//     name: "Storm of Seth 2",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/6a41e3117d638.jpg",
//     key: "JILI",
//   },
//   {
//     name: "3 Coin Wild Tiger",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/6a44d30cc208e.png",
//     key: "JILI",
//   },
//   {
//     name: "3 Lucky Baozhu",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/6a44d34302f56.png",
//     key: "JILI",
//   },
//   {
//     name: "3 Pot Dragons",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/6a44d35c56c9f.png",
//     key: "JILI",
//   },
//   {
//     name: "Coin Tree",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/6a44d37ddcc75.png",
//     key: "JILI",
//   },
//   {
//     name: "Egypt's Glow",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/6a44d3ad548b5.png",
//     key: "JILI",
//   },
//   {
//     name: "Golden Bank 2",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/6a44d3d894718.png",
//     key: "JILI",
//   },
//   {
//     name: "Lucky Doggy",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/6a44d41768fc4.png",
//     key: "JILI",
//   },
//   {
//     name: "Lucky Macaw",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/6a44d45b089b6.png",
//     key: "JILI",
//   },
//   {
//     name: "Money Pot Deluxe",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/6a44d47e42b1b.png",
//     key: "JILI",
//   },
//   {
//     name: "Safari Mystery",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/6a44d49c8bc6d.png",
//     key: "JILI",
//   },
//   {
//     name: "Joker's Fortune",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/6a4f24c742e5a.jpg",
//     key: "JILI",
//   },
//   {
//     name: "Thor Dice",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/6a4f266292fd3.jpg",
//     key: "JILI",
//   },
//   {
//     name: "Fortune Gems 500",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/692f016128712.png",
//     key: "JILI",
//   },
//   {
//     name: "Joker Coin Expanded",
//     image:
//       "https://jiliwin.9terawolf.com/images/game_icon/direct/JILI/default/636.png",
//     key: "JILI",
//   },
//   {
//     name: "Bison Fortune Coins",
//     image:
//       "https://jiliwin.9terawolf.com/images/game_icon/direct/JILI/default/720.jpg",
//     key: "JILI",
//   },
//   {
//     name: "3 Lightning Blitz",
//     image:
//       "https://jiliwin.9terawolf.com/images/game_icon/direct/JILI/default/655.jpg",
//     key: "JILI",
//   },
//   {
//     name: "Fortune Coins Unlimited Fortune",
//     image:
//       "https://jiliwin.9terawolf.com/images/game_icon/direct/JILI/default/686.jpg",
//     key: "JILI",
//   },
//   {
//     name: "X7 HOT",
//     image:
//       "https://jiliwin.9terawolf.com/images/game_icon/direct/JILI/default/680.jpg",
//     key: "JILI",
//   },
//   {
//     name: "Lucky Tiger",
//     image:
//       "https://jiliwin.9terawolf.com/images/game_icon/direct/JILI/default/558.jpg",
//     key: "JILI",
//   },
//   {
//     name: "Shōgun",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/6715b78857e1f.png",
//     key: "JILI",
//   },
//   {
//     name: "Money Pot",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/670498385d57e.png",
//     key: "JILI",
//   },
//   {
//     name: "Poseidon",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/66e14cbd17e8a.png",
//     key: "JILI",
//   },
//   {
//     name: "Nightfall Hunting",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/66dfbebd6d8be.png",
//     key: "JILI",
//   },
//   {
//     name: "3 Lucky Piggy",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/66bac067edbcf.png",
//     key: "JILI",
//   },
//   {
//     name: "Party Star",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/66babed200a51.png",
//     key: "JILI",
//   },
//   {
//     name: "Money Coming Expand Bets",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/669f79ef9678e.png",
//     key: "JILI",
//   },
//   {
//     name: "The Pig House",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/66696d3628fec.png",
//     key: "JILI",
//   },
//   {
//     name: "Potion Wizard",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/664c463a29170.png",
//     key: "JILI",
//   },
//   {
//     name: "Crazy Hunter 2",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/664c449680ca7.png",
//     key: "JILI",
//   },
//   {
//     name: "3 Coin Treasures",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/663b93b0195c4.png",
//     key: "JILI",
//   },
//   {
//     name: "Jackpot Joker",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/661fcc1a0ac51.png",
//     key: "JILI",
//   },
//   {
//     name: "Fortune Gems 3",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/661f7f9a2a63f.png",
//     key: "JILI",
//   },
//   {
//     name: "Devil Fire 2",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/6614e78e0fbdd.png",
//     key: "JILI",
//   },
//   {
//     name: "Zeus",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/6614e7226eaf9.png",
//     key: "JILI",
//   },
//   {
//     name: "Trial of Phoenix",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/65e98b2ae682a.png",
//     key: "JILI",
//   },
//   {
//     name: "Arena Fighter",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/65e0472658c88.png",
//     key: "JILI",
//   },
//   {
//     name: "Charge Buffalo Ascent",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/65bb7623a01b4.png",
//     key: "JILI",
//   },
//   {
//     name: "King Arthur",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/65b340337b2a1.png",
//     key: "JILI",
//   },
//   {
//     name: "Fortune Gems 2",
//     image: "ttps://luckmedia.link/jil_fortune_gems_2/thumb.webp",
//     key: "JILI",
//   },
//   {
//     name: "World Cup",
//     image: "https://luckmedia.link/jil_world_cup/thumb.webp",
//     key: "JILI",
//   },
//   {
//     name: "Bone Fortune",
//     image: "https://luckmedia.link/jil_bone_fortune/thumb.webp",
//     key: "JILI",
//   },
//   {
//     name: "Mayan Empire",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/135_0.webp",
//     key: "JILI",
//   },
//   {
//     name: "Gold Rush",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/jili/137_0.jpg",
//     key: "JILI",
//   },
//   {
//     name: "Happy Taxi",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/jili/116_0.jpg",
//     key: "JILI",
//   },
//   {
//     name: "Thor X",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/jili/130_0.jpg",
//     key: "JILI",
//   },
//   {
//     name: "Party Night",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/jili/76_0.jpg",
//     key: "JILI",
//   },
//   {
//     name: "ROMA X",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/jili/102_0.jpg",
//     key: "JILI",
//   },
//   {
//     name: "Monkey Party",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/jili/67_0.jpg",
//     key: "JILI",
//   },
//   {
//     name: "Golden Queen",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/jili/58_0.jpg",
//     key: "JILI",
//   },
//   {
//     name: "Golden Bank",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/jili/45_0.jpg",
//     key: "JILI",
//   },
//   {
//     name: "DiamondParty",
//     image: "https://luckmedia.link/jil_diamondparty/thumb.webp",
//     key: "JILI",
//   },
//   {
//     name: "Hawaii Beauty",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/jili/26_0.jpg",
//     key: "JILI",
//   },
//   {
//     name: "Hyper Burst",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/jili/14_0.jpg",
//     key: "JILI",
//   },
//   {
//     name: "Lucky Ball",
//     image: "https://luckmedia.link/jil_lucky_ball/thumb.webp",
//     key: "JILI",
//   },
//   {
//     name: "Fortune Tree",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/jili/6_0.jpg",
//     key: "JILI",
//   },
//   {
//     name: "Secret Treasure",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/jili/78_0.jpg",
//     key: "JILI",
//   },
//   {
//     name: "Super Rich",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/jili/100_0.jpg",
//     key: "JILI",
//   },
//   {
//     name: "Magic Lamp",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/jili/108_0.jpg",
//     key: "JILI",
//   },
//   {
//     name: "Agent Ace",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/jili/115_0.jpg",
//     key: "JILI",
//   },
//   {
//     name: "Ali Baba",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/jili/110_0.jpg",
//     key: "JILI",
//   },
//   {
//     name: "Hot Chilli",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/jili/5_0.jpg",
//     key: "JILI",
//   },
//   {
//     name: "Night City",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/659392f366e62.png",
//     key: "JILI",
//   },
//   {
//     name: "Sin City",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/658170c632e28.png",
//     key: "JILI",
//   },
//   {
//     name: "Dabanggg",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/656da01ac406f.png",
//     key: "JILI",
//   },
//   {
//     name: "Bonus Hunter",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/654d9859efe12.png",
//     key: "JILI",
//   },
//   {
//     name: "Samba",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/65694af43f2ac.png",
//     key: "JILI",
//   },
//   {
//     name: "JILI CAISHEN",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/65694a36ee915.png",
//     key: "JILI",
//   },
//   {
//     name: "Pirate Queen",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/654d9760907f0.png",
//     key: "JILI",
//   },
//   {
//     name: "Fortune Monkey",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/654b5e012dbaa.png",
//     key: "JILI",
//   },
//   {
//     name: "Aztec Priestess",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/6538c967a6492.png",
//     key: "JILI",
//   },
//   {
//     name: "Bangla Beauty",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/652fcfda012f7.png",
//     key: "JILI",
//   },
//   {
//     name: "Devil Fire",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/6527bc6463143.png",
//     key: "JILI",
//   },
//   {
//     name: "Cricket Sah 75",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/6515358ece936.png",
//     key: "JILI",
//   },
//   {
//     name: "Golden Temple",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/650c059fea719.png",
//     key: "JILI",
//   },
//   {
//     name: "Elf Bingo",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/64ec0e1e52d5f.png",
//     key: "JILI",
//   },
//   {
//     name: "Cricket King 18",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/64d9e479e9afe.png",
//     key: "JILI",
//   },
//   {
//     name: "Sweet Land",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/64c235b5a6465.png",
//     key: "JILI",
//   },
//   {
//     name: "Master Tiger",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/64881e6dd4b04.png",
//     key: "JILI",
//   },
//   {
//     name: "Wild Ace",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/646490e8c2eea.png",
//     key: "JILI",
//   },
//   {
//     name: "Golden Joker",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/6448f47d4aab4.png",
//     key: "JILI",
//   },
//   {
//     name: "Wild Racer",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/63f1d6f128e21.png",
//     key: "JILI",
//   },
//   {
//     name: "Neko Fortune",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/63b84a41315c1.png",
//     key: "JILI",
//   },
//   {
//     name: "Crazy Pusher",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/62e27dc35fa63.png",
//     key: "JILI",
//   },
//   {
//     name: "Medusa",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/jili/101_0.jpg",
//     key: "JILI",
//   },
//   {
//     name: "Book Of Gold",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/jili/87_0.jpg",
//     key: "JILI",
//   },
//   {
//     name: "Mega Ace",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/jili/134_0.jpg",
//     key: "JILI",
//   },
//   {
//     name: "Charge Buffalo",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/jili/47_0.jpg",
//     key: "JILI",
//   },
//   {
//     name: "Dragon Treasure",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/jili/46_0.jpg",
//     key: "JILI",
//   },
//   {
//     name: "Lucky Goldbricks",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/jili/48_0.jpg",
//     key: "JILI",
//   },
//   {
//     name: "Fengshen",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/jili/38_0.jpg",
//     key: "JILI",
//   },
//   {
//     name: "Candy Baby",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/jili/23_0.jpg",
//     key: "JILI",
//   },
//   {
//     name: "FortunePig",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/jili/33_0.jpg",
//     key: "JILI",
//   },
//   {
//     name: "XiYangYang",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/jili/43_0.jpg",
//     key: "JILI",
//   },
//   {
//     name: "Crazy FaFaFa",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/jili/40_0.jpg",
//     key: "JILI",
//   },
//   {
//     name: "Bao boon chin",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/jili/36_0.jpg",
//     key: "JILI",
//   },
//   {
//     name: "Bubble Beauty",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/jili/30_0.jpg",
//     key: "JILI",
//   },
//   {
//     name: "SevenSevenSeven",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/jili/27_0.jpg",
//     key: "JILI",
//   },
//   {
//     name: "God Of Martial",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/jili/4_0.jpg",
//     key: "JILI",
//   },
//   {
//     name: "Fa Fa Fa",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/jili/21_0.jpg",
//     key: "JILI",
//   },
//   {
//     name: "Shanghai Beauty",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/jili/17_0.jpg",
//     key: "JILI",
//   },
//   {
//     name: "War Of Dragons",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/jili/9_0.jpg",
//     key: "JILI",
//   },
//   {
//     name: "Chin Shi Huang",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/jili/2_0.jpg",
//     key: "JILI",
//   },
//   {
//     name: "Gem Party",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/jili/10_0.jpg",
//     key: "JILI",
//   },
//   {
//     name: "TWIN WINS",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/jili/106_0.jpg",
//     key: "JILI",
//   },
//   {
//     name: "Gates of Olympus 1000",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs20olympx.png",
//     key: "PP",
//   },
//   {
//     name: "Book of Golden Sands",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vswaysbook.png",
//     key: "PP",
//   },
//   {
//     name: "Candy Stars",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vswaysstrwild.png",
//     key: "PP",
//   },
//   {
//     name: "Fortune of Olympus",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs20olympgcl.png",
//     key: "PP",
//   },
//   {
//     name: "Starlight Archer 1000",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs20stararx.png",
//     key: "PP",
//   },
//   {
//     name: "Gates of Gatot Kaca Super Scatter",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs20olgatssc.png",
//     key: "PP",
//   },
//   {
//     name: "Sweet Rush Bonanza",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs20swrbon.png",
//     key: "PP",
//   },
//   {
//     name: "Gates of Pyroth",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs20shmnarise.png",
//     key: "PP",
//   },
//   {
//     name: "Big Bass Splash 1000",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs10bbsplashx.png",
//     key: "PP",
//   },
//   {
//     name: "Hammerstorm",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs40hmrstrm.png",
//     key: "PP",
//   },
//   {
//     name: "Sweet Bonanza Super Scatter",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs20swbonsup.png",
//     key: "PP",
//   },
//   {
//     name: "Zombie School Megaways",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vswayspompmr2.png",
//     key: "PP",
//   },
//   {
//     name: "Super Gummy Strike",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs5supergummy.png",
//     key: "PP",
//   },
//   {
//     name: "Fortune Ace Super Scatter",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vswaysfortsup.jpg",
//     key: "PP",
//   },
//   {
//     name: "Big Bass Christmas - Frozen Lake",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs10bbglxmas.png",
//     key: "PP",
//   },
//   {
//     name: "Fire Stampede 2",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vswaysfirest2.png",
//     key: "PP",
//   },
//   {
//     name: "Duel of Night & Day",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vswaysyinyang.png",
//     key: "PP",
//   },
//   {
//     name: "Big Bass Halloween 3",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs10bhallbnza3.png",
//     key: "PP",
//   },
//   {
//     name: "Sweet Craze",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs20chestcol.png",
//     key: "PP",
//   },
//   {
//     name: "Spellmaster",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs10spellmastr.png",
//     key: "PP",
//   },
//   {
//     name: "Oracle of Gold",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs20oragold.png",
//     key: "PP",
//   },
//   {
//     name: "Wild Wild Riches Returns",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vswayswwrichr.png",
//     key: "PP",
//   },
//   {
//     name: "Bigger Barn House Bonanza",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vswaysbbarnh.png",
//     key: "PP",
//   },
//   {
//     name: "Big Bass Reel Repeat",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs10bbrrp.png",
//     key: "PP",
//   },
//   {
//     name: "Mermaid's Treasure Trove",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs20mmdtres.png",
//     key: "PP",
//   },
//   {
//     name: "Bloody Dawn",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vswayswildb.png",
//     key: "PP",
//   },
//   {
//     name: "Bee Keeper",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs10beekeep.png",
//     key: "PP",
//   },
//   {
//     name: "Bingo Mania",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs30bingomania.png",
//     key: "PP",
//   },
//   {
//     name: "Frightening Frankie",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs20frankie.png",
//     key: "PP",
//   },
//   {
//     name: "Jackpot Blaze",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs10jpblaze.png",
//     key: "PP",
//   },
//   {
//     name: "Captain Kraken Megaways",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vswayschilhtwo.png",
//     key: "PP",
//   },
//   {
//     name: "Lobster House",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs20lbstrhouse.png",
//     key: "PP",
//   },
//   {
//     name: "Santa's Slay",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs10santasl.png",
//     key: "PP",
//   },
//   {
//     name: "Genie's Gem Bonanza",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs20gengembnz.png",
//     key: "PP",
//   },
//   {
//     name: "Hundreds and Thousands",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs100hsandks.png",
//     key: "PP",
//   },
//   {
//     name: "Ice Mints",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs20popbottles.png",
//     key: "PP",
//   },
//   {
//     name: "Wolf Gold 4 Pack",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs25quadwolf.png",
//     key: "PP",
//   },
//   {
//     name: "Super Tiki Strike",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/69770523be334.jpg",
//     key: "PP",
//   },
//   {
//     name: "Cyberheist City",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/6977061bb8761.jpg",
//     key: "PP",
//   },
//   {
//     name: "Zeus vs Hades – Gods of War 250",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/69802192ec253.jpg",
//     key: "PP",
//   },
//   {
//     name: "Emerald King – Wheel of Wealth  (Reel Kingdom)",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/6992cc6166fdc.jpg",
//     key: "PP",
//   },
//   {
//     name: "Treasures of Osiris",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/6996ad349d584.jpg",
//     key: "PP",
//   },
//   {
//     name: "Mummy's Jewels 100",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/699c7ab5610d1.jpg",
//     key: "PP",
//   },
//   {
//     name: "Rolling in Treasures",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/699c7af083696.jpg",
//     key: "PP",
//   },
//   {
//     name: "Haunted Crypt",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/69a65533589f7.jpg",
//     key: "PP",
//   },
//   {
//     name: "Wild Skullz",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/69a6555c57f8e.jpg",
//     key: "PP",
//   },
//   {
//     name: "Big Bass Raceday Repeat (Reel Kingdom)",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/69af81f3ebda9.jpg",
//     key: "PP",
//   },
//   {
//     name: "Lucky's Wild Pub 2",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/69b2422be18ed.jpg",
//     key: "PP",
//   },
//   {
//     name: "CULT.",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/69b7b01206b82.jpg",
//     key: "PP",
//   },
//   {
//     name: "Steamin’ Reels",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/69ba3376e278d.jpg",
//     key: "PP",
//   },
//   {
//     name: "Furry Bonanza Megaways™",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/69c0e1490c7b4.jpg",
//     key: "PP",
//   },
//   {
//     name: "Triple Pot Diamond",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/69c0e18b549dd.jpg",
//     key: "PP",
//   },
//   {
//     name: "Idol Pop Fever",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/69cddf634768a.jpg",
//     key: "PP",
//   },
//   {
//     name: "Jelly Express",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/69ce2c7acea60.jpg",
//     key: "PP",
//   },
//   {
//     name: "Inca Queen",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/69d325669fc9b.jpg",
//     key: "PP",
//   },
//   {
//     name: "Snow Party",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/69d3259c54ce3.jpg",
//     key: "PP",
//   },
//   {
//     name: "Cyber Pup Megaways",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/69dc64b272ad8.png",
//     key: "PP",
//   },
//   {
//     name: "Big Bass Trophy Catch",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/69e0684835862.jpg",
//     key: "PP",
//   },
//   {
//     name: "Dragon Pots Megaways",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/69e9958834cc2.jpg",
//     key: "PP",
//   },
//   {
//     name: "Great Ghosts",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/69ef0110a98e8.jpg",
//     key: "PP",
//   },
//   {
//     name: "Sweet Bonanza 2500",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/69ef01539b8f6.jpg",
//     key: "PP",
//   },
//   {
//     name: "Mr Null's Wicked Wares",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/69f85255437e6.jpg",
//     key: "PP",
//   },
//   {
//     name: "Launch to Riches",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/69f852b69ce04.jpg",
//     key: "PP",
//   },
//   {
//     name: "Heartbreakers",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/6a019ba20f415.jpg",
//     key: "PP",
//   },
//   {
//     name: "Triple Pot Plinko – Hercules",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/6a019bf41ccc1.jpg",
//     key: "PP",
//   },
//   {
//     name: "Dragon's Gate-Bonus Choice",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/6a0a927ea600e.jpg",
//     key: "PP",
//   },
//   {
//     name: "The Big Dog House",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/6a0a92ae6c2d9.jpg",
//     key: "PP",
//   },
//   {
//     name: "Candy Rush",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/6a17e4a15e161.jpg",
//     key: "PP",
//   },
//   {
//     name: "Sanatorium Secrets",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/6a1db1845c1c0.jpg",
//     key: "PP",
//   },
//   {
//     name: "Joker's Revenge",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/6a263f03ef176.jpg",
//     key: "PP",
//   },
//   {
//     name: "Mahjong Wins Triple Pot",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/6a263f57c1a3e.jpg",
//     key: "PP",
//   },
//   {
//     name: "Bear Crazy",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/6a3374d079488.jpg",
//     key: "PP",
//   },
//   {
//     name: "Better Barn House Bonanza",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/6a38af9d763e2.png",
//     key: "PP",
//   },
//   {
//     name: "Fury of Anubis",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/6a3cf96f5b248.jpg",
//     key: "PP",
//   },
//   {
//     name: "Hell Butcher",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/6a41e2214d762.jpg",
//     key: "PP",
//   },
//   {
//     name: "Big Bass Blast",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/6a4b22e32a2b0.jpg",
//     key: "PP",
//   },
//   {
//     name: "Out of the Woods",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/6a4f4cc37bf80.jpg",
//     key: "PP",
//   },
//   {
//     name: "Cosmic Clusters",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/6a5d933200551.jpg",
//     key: "PP",
//   },
//   {
//     name: "Sleeping Dragon Ultra Dark",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/6a619a7e8a556.jpg",
//     key: "PP",
//   },
//   {
//     name: "Sunnydaze Asylum",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/6a66cf211e8e3.jpg",
//     key: "PP",
//   },
//   {
//     name: "Death Dominion",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/6a6ac4e7b41ff.jpg",
//     key: "PP",
//   },
//   {
//     name: "Super Serge",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/6a740a06b1232.jpg",
//     key: "PP",
//   },
//   {
//     name: "777 Wheel Blitz",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/6a797cf9b060c.jpg",
//     key: "PP",
//   },
//   {
//     name: "Harvest Moon-Grave Profits",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/6a7d39a08f921.jpg",
//     key: "PP",
//   },
//   {
//     name: "Golden Retriever",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/6a828338aadbf.jpg",
//     key: "PP",
//   },
//   {
//     name: "Bubble Up",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/6a8bbb0c56a6c.jpg",
//     key: "PP",
//   },
//   {
//     name: "Eastern Fury",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/6a8fada8a1f67.jpg",
//     key: "PP",
//   },
//   {
//     name: "Hearts of Venus",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/6a951b3478ddd.jpg",
//     key: "PP",
//   },
//   {
//     name: "Ra vs Osiris",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/6a9941d319856.jpg",
//     key: "PP",
//   },
//   {
//     name: "Lucky Drums 88",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/6a9e30830022a.jpg",
//     key: "PP",
//   },
//   {
//     name: "Eternal Diamonds",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/6aa253debad3f.jpg",
//     key: "PP",
//   },
//   {
//     name: "5 Lions Megaways 2",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vsways5lions2.png",
//     key: "PP",
//   },
//   {
//     name: "Wild West Gold Blazing Bounty",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs20wwgcluster.png",
//     key: "PP",
//   },
//   {
//     name: "Gates of Hades",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs20gtsofhades.png",
//     key: "PP",
//   },
//   {
//     name: "Peppe's Pepperoni Pizza Plaza",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vswaystonypzz.png",
//     key: "PP",
//   },
//   {
//     name: "Club Tropicana - Happy Hour",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs12trpcnhour.png",
//     key: "PP",
//   },
//   {
//     name: "Finger Lick'n Free Spins",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs10fingerlfs.png",
//     key: "PP",
//   },
//   {
//     name: "Bigger Bass Splash",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs12bgrbspl.png",
//     key: "PP",
//   },
//   {
//     name: "Aztec Gems Megaways",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vswaysaztec.png",
//     key: "PP",
//   },
//   {
//     name: "Mummy's Jewels",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vswaysmjwl.png",
//     key: "PP",
//   },
//   {
//     name: "Gold Party 2 - After Hours",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs25goldpartya.png",
//     key: "PP",
//   },
//   {
//     name: "Chilli Heat Spicy Spins",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs10chillihmr.png",
//     key: "PP",
//   },
//   {
//     name: "Big Bass Return to the Races",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs10bbrttr.png",
//     key: "PP",
//   },
//   {
//     name: "Brick House Bonanza",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vswaysbrickhos.png",
//     key: "PP",
//   },
//   {
//     name: "Floating Dragon - Year of the Snake",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs10fdsnake.png",
//     key: "PP",
//   },
//   {
//     name: "Majestic Express - Gold Run",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs25goldrexp.png",
//     key: "PP",
//   },
//   {
//     name: "Volcano Goddess",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vswaysvlcgds.png",
//     key: "PP",
//   },
//   {
//     name: "Alien Invaders",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs20alieninv.png",
//     key: "PP",
//   },
//   {
//     name: "Greedy Fortune Pig",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs10fortnpig.png",
//     key: "PP",
//   },
//   {
//     name: "Raging Waterfall Megaways",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vswaysmltchmgw.png",
//     key: "PP",
//   },
//   {
//     name: "Savannah Legend",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vswayssavlgnd.png",
//     key: "PP",
//   },
//   {
//     name: "Candy Corner",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs20fourmc.png",
//     key: "PP",
//   },
//   {
//     name: "Gem Trio",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs9gemtrio.png",
//     key: "PP",
//   },
//   {
//     name: "Ancient Island Megaways",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vswaysmodfr.png",
//     key: "PP",
//   },
//   {
//     name: "You Can Piggy Bank On It",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs10piggybank.png",
//     key: "PP",
//   },
//   {
//     name: "Temple Guardians",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs10diamondrgh.png",
//     key: "PP",
//   },
//   {
//     name: "John Hunter and Galileo's Secrets",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs10booklight.png",
//     key: "PP",
//   },
//   {
//     name: "Fonzo's Feline Fortunes",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs10fonzofff.png",
//     key: "PP",
//   },
//   {
//     name: "7 Clovers of Fortune",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vswayssevenc.png",
//     key: "PP",
//   },
//   {
//     name: "Release the Kraken Megaways",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vswayskrakenmw.png",
//     key: "PP",
//   },
//   {
//     name: "Starlight Princess Super Scatter",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs20starprss.png",
//     key: "PP",
//   },
//   {
//     name: "Gates of Olympus Super Scatter",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs20olympgold.png",
//     key: "PP",
//   },
//   {
//     name: "Wisdom of Athena 1000 Xmas",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs20procountxm.png",
//     key: "PP",
//   },
//   {
//     name: "Mahjong Wins 2",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vswaysmahwin2.png",
//     key: "PP",
//   },
//   {
//     name: "Anaconda Gold",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vswaysacnd.png",
//     key: "PP",
//   },
//   {
//     name: "Power of Merlin Megaways",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vswayspowzeus.png",
//     key: "PP",
//   },
//   {
//     name: "Vampy Party",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vswayswbounty.png",
//     key: "PP",
//   },
//   {
//     name: "Wisdom of Athena 1000",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs20procountx.png",
//     key: "PP",
//   },
//   {
//     name: "Gates of Olympus Xmas 1000",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs20olympxmas.png",
//     key: "PP",
//   },
//   {
//     name: "Triple Pot Gold",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vswaysasiatrzn.png",
//     key: "PP",
//   },
//   {
//     name: "Anime Mecha Megaways",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vswaysanime.png",
//     key: "PP",
//   },
//   {
//     name: "Zeus vs Typhon",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vswaysreelbtl.png",
//     key: "PP",
//   },
//   {
//     name: "Big Bass Bonanza 1000",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs10bbbnz1000.png",
//     key: "PP",
//   },
//   {
//     name: "5 Lions Reborn",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vsways5lionsr.png",
//     key: "PP",
//   },
//   {
//     name: "Sugar Rush Xmas",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs20sugrux.png",
//     key: "PP",
//   },
//   {
//     name: "Mahjong Wins Super Scatter",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vswaysmwss.png",
//     key: "PP",
//   },
//   {
//     name: "Wisdom of Athena",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs20procount.png",
//     key: "PP",
//   },
//   {
//     name: "Chests of Cai Shen",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs25checaishen.png",
//     key: "PP",
//   },
//   {
//     name: "Sweet Bonanza Dice",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs20bnnzdice.png",
//     key: "PP",
//   },
//   {
//     name: "Mustang Gold Megaways",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vswaysgoldcol.png",
//     key: "PP",
//   },
//   {
//     name: "Big Bass Halloween",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs10bhallbnza.png",
//     key: "PP",
//   },
//   {
//     name: "Big Bass Boxing Bonus Round",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs10bbbbrnd.png",
//     key: "PP",
//   },
//   {
//     name: "American Blackjack",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/bjmb.png",
//     key: "PP",
//   },
//   {
//     name: "Pandemic Rising",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs40pdmrsg.png",
//     key: "PP",
//   },
//   {
//     name: "Resurrecting Riches",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vswaysresurich.png",
//     key: "PP",
//   },
//   {
//     name: "Bandit Megaways",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vswaysbandit.png",
//     key: "PP",
//   },
//   {
//     name: "3 Buzzing Wilds",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs20wildparty.png",
//     key: "PP",
//   },
//   {
//     name: "The Dog House - Royal Hunt",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs20dhsuper.png",
//     key: "PP",
//   },
//   {
//     name: "Big Bass Vegas Double Down Deluxe",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs10bbdoubled.png",
//     key: "PP",
//   },
//   {
//     name: "Mining Rush",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs20minerush.png",
//     key: "PP",
//   },
//   {
//     name: "Money Roll",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/cs5moneyroll.png",
//     key: "PP",
//   },
//   {
//     name: "Angel vs Sinner",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs15fghtmultlv.png",
//     key: "PP",
//   },
//   {
//     name: "Witch Heart Megaways",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vswayswildbrst.png",
//     key: "PP",
//   },
//   {
//     name: "Bermuda Riches",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs20bermuda.png",
//     key: "PP",
//   },
//   {
//     name: "The Dog House - Muttley Crew",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs20dhcluster2.png",
//     key: "PP",
//   },
//   {
//     name: "Tic Tac Take",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs10tictac.png",
//     key: "PP",
//   },
//   {
//     name: "Bounty Hunter",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs20bhunter.png",
//     key: "PP",
//   },
//   {
//     name: "The Dog House Dice Show",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs20dhdice.png",
//     key: "PP",
//   },
//   {
//     name: "The Wild Gang",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vswayswildgang.png",
//     key: "PP",
//   },
//   {
//     name: "Waves of Poseidon",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs20bigmass.png",
//     key: "PP",
//   },
//   {
//     name: "Sleeping Dragon",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs25sleepdrag.png",
//     key: "PP",
//   },
//   {
//     name: "Lucky's Wild Pub",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs25luckwildpb.png",
//     key: "PP",
//   },
//   {
//     name: "Big Bass Christmas Bash",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs10bbsplxmas.png",
//     key: "PP",
//   },
//   {
//     name: "5 Frozen Charms Megaways",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vswayscharms.png",
//     key: "PP",
//   },
//   {
//     name: "Tiny Toads",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs50fatfrogs.png",
//     key: "PP",
//   },
//   {
//     name: "Lava Balls",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vswayslavabls.png",
//     key: "PP",
//   },
//   {
//     name: "Fiesta Fortune",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs10gbseries.png",
//     key: "PP",
//   },
//   {
//     name: "Big Bass Bonanza 3 Reeler",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs5bb3reeler.png",
//     key: "PP",
//   },
//   {
//     name: "Big Bass Halloween 2",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs10bhallbnza2.png",
//     key: "PP",
//   },
//   {
//     name: "Mahjong X",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs20mahjxbnz.png",
//     key: "PP",
//   },
//   {
//     name: "Big Bass Amazon Xtreme",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs10bbextreme.png",
//     key: "PP",
//   },
//   {
//     name: "Happy Fortune",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs20laughluck.png",
//     key: "PP",
//   },
//   {
//     name: "Eye of Spartacus",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs15eyeofspart.png",
//     key: "PP",
//   },
//   {
//     name: "Joker's Jewels Cash",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs5jokerjc.png",
//     key: "PP",
//   },
//   {
//     name: "Dragon Gold 88",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs10dgold88.png",
//     key: "PP",
//   },
//   {
//     name: "Big Bass Xmas Xtreme",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs10bbxext.png",
//     key: "PP",
//   },
//   {
//     name: "Fortune Ace",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs1024fortune.png",
//     key: "PP",
//   },
//   {
//     name: "Queenie",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs243queenie.png",
//     key: "PP",
//   },
//   {
//     name: "Multihand Blackjack",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/bjma.png",
//     key: "PP",
//   },
//   {
//     name: "Wild Wildebeest Wins",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vswaysbufstamp.png",
//     key: "PP",
//   },
//   {
//     name: "Wild Wild Joker",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vswayswwjoker.png",
//     key: "PP",
//   },
//   {
//     name: "Book of Monsters",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs20fatbook.png",
//     key: "PP",
//   },
//   {
//     name: "Gem Fire Fortune",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs20gemfirefor.png",
//     key: "PP",
//   },
//   {
//     name: "Himalayan Wild",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs5himalaw.png",
//     key: "PP",
//   },
//   {
//     name: "Santa's Xmas Rush",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs20rainbowrsh.png",
//     key: "PP",
//   },
//   {
//     name: "Spellbinding Mystery",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs20splmystery.png",
//     key: "PP",
//   },
//   {
//     name: "Wildies",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs25wildies.png",
//     key: "PP",
//   },
//   {
//     name: "Fangtastic Freespins",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs10fangfree.png",
//     key: "PP",
//   },
//   {
//     name: "Argonauts",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vswaysargonts.png",
//     key: "PP",
//   },
//   {
//     name: "Sweet Powernudge",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs20clspwrndg.png",
//     key: "PP",
//   },
//   {
//     name: "Might of Freya Megaways",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vswaysmfreya.png",
//     key: "PP",
//   },
//   {
//     name: "Rainbow Reels",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs40rainbowr.png",
//     key: "PP",
//   },
//   {
//     name: "3 Kingdoms - Battle of Red Cliffs",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs25kingdoms.png",
//     key: "PP",
//   },
//   {
//     name: "Eternal Empress - Freeze Time",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vswaysfreezet.png",
//     key: "PP",
//   },
//   {
//     name: "Aztec Smash",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs20plsmcannon.png",
//     key: "PP",
//   },
//   {
//     name: "Aztec Treasure Hunt",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs20trswild3.png",
//     key: "PP",
//   },
//   {
//     name: "Nile Fortune",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs20nilefort.png",
//     key: "PP",
//   },
//   {
//     name: "Diamonds are Forever 3 Lines",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/cs3w.png",
//     key: "PP",
//   },
//   {
//     name: "Oodles of Noodles",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs10noodles.png",
//     key: "PP",
//   },
//   {
//     name: "Year Of The Dragon King",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs20yotdk.png",
//     key: "PP",
//   },

//   {
//     name: "Fortune Hit'n Roll",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs40wildrun.png",
//     key: "PP",
//   },
//   {
//     name: "Wolf Gold Ultimate",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs25ultwolgol.png",
//     key: "PP",
//   },
//   {
//     name: "Money Stacks Megaways",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vswaysbblitz.png",
//     key: "PP",
//   },
//   {
//     name: "Mystery Mice",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs20powerwild.png",
//     key: "PP",
//   },
//   {
//     name: "Blitz Super Wheel",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs20lightblitz.png",
//     key: "PP",
//   },
//   {
//     name: "Badge Blitz",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs25badge.png",
//     key: "PP",
//   },
//   {
//     name: "Congo Cash XL",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vswayscongcash.png",
//     key: "PP",
//   },
//   {
//     name: "Fat Panda",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs20beefed.png",
//     key: "PP",
//   },
//   {
//     name: "Heroic Spins",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs20shootstars.png",
//     key: "PP",
//   },
//   {
//     name: "Wild Wild Pearls",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vswayspearls.png",
//     key: "PP",
//   },
//   {
//     name: "Frozen Tropics",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vswaysftropics.png",
//     key: "PP",
//   },
//   {
//     name: "Cash Surge",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vswayscashsurg.png",
//     key: "PP",
//   },
//   {
//     name: "Heist for the Golden Nuggets",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs20hstgldngt.png",
//     key: "PP",
//   },
//   {
//     name: "Dragon King Hot Pots",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs10dkinghp.png",
//     key: "PP",
//   },
//   {
//     name: "Irish Charms",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/cs3irishcharms.png",
//     key: "PP",
//   },
//   {
//     name: "Jumbo Safari",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs20jjjack.png",
//     key: "PP",
//   },
//   {
//     name: "Hellvis Wild",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs243nudge4gold.png",
//     key: "PP",
//   },
//   {
//     name: "Joker Race",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs25jokrace.png",
//     key: "PP",
//   },
//   {
//     name: "Escape the Pyramid - Fire & Ice",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs10fireice.png",
//     key: "PP",
//   },
//   {
//     name: "Moleionaire",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs20clreacts.png",
//     key: "PP",
//   },
//   {
//     name: "Hot to Burn 7 Deadly Free Spins",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs10hottb7fs.png",
//     key: "PP",
//   },
//   {
//     name: "Ding Dong Christmas Bells",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs10ddcbells.png",
//     key: "PP",
//   },
//   {
//     name: "Ride the Lightning",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs9ridelightng.png",
//     key: "PP",
//   },
//   {
//     name: "Gold Oasis",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vswaysincwnd.png",
//     key: "PP",
//   },
//   {
//     name: "Irish Crown",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs20irishcrown.png",
//     key: "PP",
//   },
//   {
//     name: "Gem Elevator",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs20elevclust.png",
//     key: "PP",
//   },
//   {
//     name: "Penguins Christmas Party Time",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs25xmasparty.png",
//     key: "PP",
//   },
//   {
//     name: "Sugar Rush Super Scatter",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/200x200/vs20sugrushss.png",
//     key: "PP",
//   },
//   {
//     name: "Floating Dragon Wild Horses",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/200x200/vs10fdwhorses.png",
//     key: "PP",
//   },
//   {
//     name: "Hot Tuna",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/200x200/vs10hottuna.png",
//     key: "PP",
//   },
//   {
//     name: "King of Spear",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/200x200/vs20speark.png",
//     key: "PP",
//   },
//   {
//     name: "Wheel of Happiness",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/200x200/vswayswildeq.png",
//     key: "PP",
//   },
//   {
//     name: "Joker's Jewels Hold & Spin",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/200x200/vs5jokjewhs.png",
//     key: "PP",
//   },
//   {
//     name: "The Dog House Megaways 1000",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/200x200/vswaysdh1000.png",
//     key: "PP",
//   },
//   {
//     name: "Luxor of Cleopatra",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/200x200/vswaysladythf.png",
//     key: "PP",
//   },
//   {
//     name: "Caishen's Cash Pots",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/200x200/vsways4ptgld.png",
//     key: "PP",
//   },
//   {
//     name: "Fire Stampede Ultimate",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/200x200/vswaysfirest3.png",
//     key: "PP",
//   },
//   {
//     name: "Big Bass Football Bonanza",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/200x200/vs10bbwcup.png",
//     key: "PP",
//   },
//   {
//     name: "3 Magic Eggs",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/200x200/vs25wolfgmm.png",
//     key: "PP",
//   },
//   {
//     name: "Dragon Tiger Fortunes",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/200x200/vswayshuffpbh.png",
//     key: "PP",
//   },
//   {
//     name: "Knights vs Barbarians",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/200x200/vs10cenrlgdevl.png",
//     key: "PP",
//   },
//   {
//     name: "Spire+",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/200x200/ar1spire.png",
//     key: "PP",
//   },
//   {
//     name: "Dark Overlord - Final Duel",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/200x200/vs15shadmon.png",
//     key: "PP",
//   },
//   {
//     name: "Forging Wilds",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs20forgewilds.png",
//     key: "PP",
//   },
//   {
//     name: "Jackpot Hunter",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs20jhunter.png",
//     key: "PP",
//   },
//   {
//     name: "Running Sushi",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vswayscashconv.png",
//     key: "PP",
//   },
//   {
//     name: "Yeti Quest",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs20mesmult.png",
//     key: "PP",
//   },
//   {
//     name: "Money Stacks",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs20bblitz.png",
//     key: "PP",
//   },
//   {
//     name: "Bow of Artemis",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs20gembondx.png",
//     key: "PP",
//   },
//   {
//     name: "Sumo Supreme Megaways",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vswaysmegwghts.png",
//     key: "PP",
//   },
//   {
//     name: "Joker's Jewels Hot",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs10jokerhot.png",
//     key: "PP",
//   },
//   {
//     name: "Dynamite Diggin Doug",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs10dyndigd.png",
//     key: "PP",
//   },
//   {
//     name: "6 Jokers",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs5magicdoor.png",
//     key: "PP",
//   },
//   {
//     name: "Wheel O'Gold",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs20multiup.png",
//     key: "PP",
//   },
//   {
//     name: "Pompeii Megareels Megaways",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vswaysmegareel.png",
//     key: "PP",
//   },
//   {
//     name: "Great Lagoon",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs25lagoon.png",
//     key: "PP",
//   },
//   {
//     name: "Mighty Munching Melons",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs20mmmelon.png",
//     key: "PP",
//   },
//   {
//     name: "Strawberry Cocktail",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs10strawberry.png",
//     key: "PP",
//   },
//   {
//     name: "Power of Ninja",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs20ninjapower.png",
//     key: "PP",
//   },
//   {
//     name: "Gates of Olympus Dice",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs20olympdice.png",
//     key: "PP",
//   },
//   {
//     name: "Zombie Train",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs15seoultrain.png",
//     key: "PP",
//   },
//   {
//     name: "Cyber Heist",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs20cbrhst.png",
//     key: "PP",
//   },
//   {
//     name: "Fire Portals",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs20portals.png",
//     key: "PP",
//   },
//   {
//     name: "Medusa's Stone",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs20medusast.png",
//     key: "PP",
//   },
//   {
//     name: "Devilicious",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs20devilic.png",
//     key: "PP",
//   },
//   {
//     name: "Big Bass Bonanza - Reel Action",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs10bbbrlact.png",
//     key: "PP",
//   },
//   {
//     name: "Odds On Winner",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs10frontrun.png",
//     key: "PP",
//   },
//   {
//     name: "Heart of Cleopatra",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs20heartcleo.png",
//     key: "PP",
//   },
//   {
//     name: "Hot To Burn Multiplier",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs5hotbmult.png",
//     key: "PP",
//   },
//   {
//     name: "Samurai Code",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs12scode.png",
//     key: "PP",
//   },
//   {
//     name: "Crank it Up",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs20crankit.png",
//     key: "PP",
//   },
//   {
//     name: "Sweet Kingdom",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs20clustcol.png",
//     key: "PP",
//   },
//   {
//     name: "Hand of Midas 2",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs20midas2.png",
//     key: "PP",
//   },
//   {
//     name: "Buffalo King Untamed Megaways",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vswaysbkingasc.png",
//     key: "PP",
//   },
//   {
//     name: "Big Bass Mission Fishin'",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs10bbfmission.png",
//     key: "PP",
//   },
//   {
//     name: "Starlight Princess Pachi",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vswaysjapan.png",
//     key: "PP",
//   },
//   {
//     name: "Revenge of Loki Megaways",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vswaysloki.png",
//     key: "PP",
//   },
//   {
//     name: "Fruity Treats",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs20fortbon.png",
//     key: "PP",
//   },
//   {
//     name: "Rise of Pyramids",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vswayshexhaus.png",
//     key: "PP",
//   },
//   {
//     name: "Dwarf & Dragon",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vswaysspltsym.png",
//     key: "PP",
//   },
//   {
//     name: "Starlight Princess 1000",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs20starlightx.png",
//     key: "PP",
//   },
//   {
//     name: "Sweet Bonanza 1000",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs20fruitswx.png",
//     key: "PP",
//   },
//   {
//     name: "Sugar Rush 1000",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs20sugarrushx.png",
//     key: "PP",
//   },
//   {
//     name: "Lobster Bob's Sea Food and Win It",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs20lobseafd.png",
//     key: "PP",
//   },
//   {
//     name: "Joker's Jewels Wild",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs5jjwild.png",
//     key: "PP",
//   },
//   {
//     name: "Wukong Rush",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs20mkrush.png",
//     key: "PP",
//   },
//   {
//     name: "Candy Blitz Bombs",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs20candybltz2.png",
//     key: "PP",
//   },
//   {
//     name: "Big Burger Load it up with Xtra Cheese",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs10bburger.png",
//     key: "PP",
//   },
//   {
//     name: "The Dog House - Dog or Alive",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs20doghouse2.png",
//     key: "PP",
//   },
//   {
//     name: "Aztec Powernudge",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs20sbpnudge.png",
//     key: "PP",
//   },
//   {
//     name: "Release the Bison",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs20bison.png",
//     key: "PP",
//   },
//   {
//     name: "Big Bass - Secrets of the Golden Lake",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs10bblotgl.png",
//     key: "PP",
//   },
//   {
//     name: "Ripe Rewards",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs40stckwldlvl.png",
//     key: "PP",
//   },
//   {
//     name: "Ice Lobster",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs20stickypos.png",
//     key: "PP",
//   },
//   {
//     name: "Barnyard Megahays Megaways",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vswaysmegahays.png",
//     key: "PP",
//   },
//   {
//     name: "Gates of Gatot Kaca 1000",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs20gatotx.png",
//     key: "PP",
//   },
//   {
//     name: "Gears of Horus",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs20clustext.png",
//     key: "PP",
//   },
//   {
//     name: "Casino Heist Megaways",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vswayscheist.png",
//     key: "PP",
//   },
//   {
//     name: "Big Bass Day at the Races",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs10bbbnz.png",
//     key: "PP",
//   },
//   {
//     name: "Beware The Deep Megaways",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vswaysbewaretd.png",
//     key: "PP",
//   },
//   {
//     name: "Rise of Samurai 4",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs15samurai4.png",
//     key: "PP",
//   },
//   {
//     name: "Pot of Fortune",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs20stckwldsc.png",
//     key: "PP",
//   },
//   {
//     name: "The Alter Ego",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vswaysalterego.png",
//     key: "PP",
//   },
//   {
//     name: "Big Bass Floats my Boat",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs10bbfloats.png",
//     key: "PP",
//   },
//   {
//     name: "Bali Dragon",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs5balidragon.png",
//     key: "PP",
//   },
//   {
//     name: "Trees of Treasure",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs20treesot.png",
//     key: "PP",
//   },
//   {
//     name: "Blazing Wilds Megaways",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vswaysfirewmw.png",
//     key: "PP",
//   },
//   {
//     name: "Blade & Fangs",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs20mergedwndw.png",
//     key: "PP",
//   },
//   {
//     name: "Loki's Riches",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs20loksriches.png",
//     key: "PP",
//   },
//   {
//     name: "Mahjong Wins Bonus",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs1024mjwinbns.png",
//     key: "PP",
//   },
//   {
//     name: "The Big Dawgs",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs20bigdawgs.png",
//     key: "PP",
//   },
//   {
//     name: "Fortune Dragon",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs243fdragon.png",
//     key: "PP",
//   },
//   {
//     name: "Juicy Fruits Multihold",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs50jfmulthold.png",
//     key: "PP",
//   },
//   {
//     name: "Floating Dragon New Year Festival Ultra Megaways Hold & Spin",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vswaysfltdrgny.png",
//     key: "PP",
//   },
//   {
//     name: "Castle of Fire",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vswaysexpandng.png",
//     key: "PP",
//   },
//   {
//     name: "Good Luck & Good Fortune",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs10luckfort.png",
//     key: "PP",
//   },
//   {
//     name: "Sea Fantasy",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vswaysseastory.png",
//     key: "PP",
//   },
//   {
//     name: "Fire Stampede",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vswaysstampede.png",
//     key: "PP",
//   },
//   {
//     name: "Candy Jar Clusters",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs20cjcluster.png",
//     key: "PP",
//   },
//   {
//     name: "Timber Stacks",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vswaystimber.png",
//     key: "PP",
//   },
//   {
//     name: "Chase For Glory",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vswayscfglory.png",
//     key: "PP",
//   },
//   {
//     name: "Joker's Jewel Dice",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs5jokerdice.png",
//     key: "PP",
//   },
//   {
//     name: "Rujak Bonanza",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs20rujakbnz.png",
//     key: "PP",
//   },
//   {
//     name: "Viking Forge",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs20sugarcoins.png",
//     key: "PP",
//   },
//   {
//     name: "Sugar Supreme Powernudge",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs20sugarnudge.png",
//     key: "PP",
//   },
//   {
//     name: "Grace of Ebisu",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs20olympgrace.png",
//     key: "PP",
//   },
//   {
//     name: "Twilight Princess",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs20dhcluster.png",
//     key: "PP",
//   },
//   {
//     name: "Demon Pots",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs40demonpots.png",
//     key: "PP",
//   },
//   {
//     name: "The Money Men Megaways",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vswaysmoneyman.png",
//     key: "PP",
//   },
//   {
//     name: "888 Bonanza",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs243goldfor.png",
//     key: "PP",
//   },
//   {
//     name: "Tundra's Fortune",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vswaysraghex.png",
//     key: "PP",
//   },
//   {
//     name: "Gemstone",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs5gemstone.png",
//     key: "PP",
//   },
//   {
//     name: "Cash Chips",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs20maskgame.png",
//     key: "PP",
//   },
//   {
//     name: "Gravity Bonanza",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs20gravity.png",
//     key: "PP",
//   },
//   {
//     name: "Infective Wild",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs40infwild.png",
//     key: "PP",
//   },
//   {
//     name: "Fortunes of Aztec",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vswaysstrlght.png",
//     key: "PP",
//   },
//   {
//     name: "Candy Blitz",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs20candyblitz.png",
//     key: "PP",
//   },
//   {
//     name: "Book of Tut Megaways",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vswaystut.png",
//     key: "PP",
//   },
//   {
//     name: "8 Golden Dragon Challenge",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs10gdchalleng.png",
//     key: "PP",
//   },
//   {
//     name: "Saiyan Mania",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs20saiman.png",
//     key: "PP",
//   },
//   {
//     name: "Cyclops Smash",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs20earthquake.png",
//     key: "PP",
//   },
//   {
//     name: "Big Bass Hold & Spinner Megaways",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vswaysbbhas.png",
//     key: "PP",
//   },
//   {
//     name: "Forge of Olympus",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs20forge.png",
//     key: "PP",
//   },
//   {
//     name: "Mahjong Wins",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs1024mahjwins.png",
//     key: "PP",
//   },
//   {
//     name: "Piggy Bankers",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs20piggybank.png",
//     key: "PP",
//   },
//   {
//     name: "Pub Kings",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs20lvlup.png",
//     key: "PP",
//   },
//   {
//     name: "Rocket Blast Megaways",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vswaysrockblst.png",
//     key: "PP",
//   },
//   {
//     name: "Mustang Trail",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs10trail.png",
//     key: "PP",
//   },
//   {
//     name: "Diamond Cascade",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs50dmdcascade.png",
//     key: "PP",
//   },
//   {
//     name: "Lobster Bob's Crazy Crab Shack",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs20lobcrab.png",
//     key: "PP",
//   },
//   {
//     name: "Supermania",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs20supermania.png",
//     key: "PP",
//   },
//   {
//     name: "Sky Bounty",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs50jucier.png",
//     key: "PP",
//   },
//   {
//     name: "Cash Box",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs20cashmachine.png",
//     key: "PP",
//   },
//   {
//     name: "Pirates Pub",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs9outlaw.png",
//     key: "PP",
//   },
//   {
//     name: "Jewel Rush",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs20jewelparty.png",
//     key: "PP",
//   },
//   {
//     name: "Snakes & Ladders - Snake Eyes",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs10snakeeyes.png",
//     key: "PP",
//   },
//   {
//     name: "Book of Aztec King",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs10bookazteck.png",
//     key: "PP",
//   },
//   {
//     name: "Disco Lady",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs243discolady.png",
//     key: "PP",
//   },
//   {
//     name: "Chicken Chase",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs10chkchase.png",
//     key: "PP",
//   },
//   {
//     name: "Bull Fiesta",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/vs25bullfiesta.png",
//     key: "PP",
//   },
//   {
//     name: "Chocolate Deluxe",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PG/default/PGS_1666445.png",
//     key: "PG",
//   },
//   {
//     name: "Honey Trap of Diao Chan",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PG/default/PGS_1.png",
//     key: "PG",
//   },
//   {
//     name: "Candy Bonanza",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PG/default/PGS_100.png",
//     key: "PG",
//   },
//   {
//     name: "Rise of Apollo",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PG/default/PGS_101.png",
//     key: "PG",
//   },
//   {
//     name: "Mermaid Riches",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PG/default/PGS_102.png",
//     key: "PG",
//   },
//   {
//     name: "Crypto Gold",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PG/default/PGS_103.png",
//     key: "PG",
//   },
//   {
//     name: "Wild Bandito",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PG/default/PGS_104.png",
//     key: "PG",
//   },
//   {
//     name: "Heist Stakes",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PG/default/PGS_105.png",
//     key: "PG",
//   },
//   {
//     name: "Ways of the Qilin",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PG/default/PGS_106.png",
//     key: "PG",
//   },
//   {
//     name: "Legendary Monkey King",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PG/default/PGS_107.png",
//     key: "PG",
//   },
//   {
//     name: "Buffalo Win",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PG/default/PGS_108.png",
//     key: "PG",
//   },
//   {
//     name: "Jurassic Kingdom",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PG/default/PGS_110.png",
//     key: "PG",
//   },
//   {
//     name: "Oriental Prosperity",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PG/default/PGS_112.png",
//     key: "PG",
//   },
//   {
//     name: "Raider Jane's Crypt of Fortune",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PG/default/PGS_113.png",
//     key: "PG",
//   },
//   {
//     name: "Emoji Riches",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PG/default/PGS_114.png",
//     key: "PG",
//   },
//   {
//     name: "Supermarket Spree",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PG/default/PGS_115.png",
//     key: "PG",
//   },
//   {
//     name: "Cocktail Nights",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PG/default/PGS_117.png",
//     key: "PG",
//   },
//   {
//     name: "Mask Carnival",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PG/default/PGS_118.png",
//     key: "PG",
//   },
//   {
//     name: "Spirited Wonders",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PG/default/PGS_119.png",
//     key: "PG",
//   },
//   {
//     name: "The Queen's Banquet",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PG/default/PGS_120.png",
//     key: "PG",
//   },
//   {
//     name: "Destiny of Sun & Moon",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PG/default/PGS_121.png",
//     key: "PG",
//   },
//   {
//     name: "Garuda Gems",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PG/default/PGS_122.png",
//     key: "PG",
//   },
//   {
//     name: "Rooster Rumble",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PG/default/PGS_123.png",
//     key: "PG",
//   },
//   {
//     name: "Battleground Royale",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PG/default/PGS_124.png",
//     key: "PG",
//   },
//   {
//     name: "Butterfly Blossom",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PG/default/PGS_125.png",
//     key: "PG",
//   },
//   {
//     name: "Fortune Tiger",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PG/default/PGS_126.png",
//     key: "PG",
//   },
//   {
//     name: "Speed Winner",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PG/default/PGS_127.png",
//     key: "PG",
//   },
//   {
//     name: "Legend of Perseus",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PG/default/PGS_128.png",
//     key: "PG",
//   },
//   {
//     name: "Win Win Fish Prawn Crab",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PG/default/PGS_129.png",
//     key: "PG",
//   },
//   {
//     name: "Lucky Piggy",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PG/default/PGS_130.png",
//     key: "PG",
//   },
//   {
//     name: "Prosperity Fortune Tree",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PG/default/PGS_1312883.png",
//     key: "PG",
//   },
//   {
//     name: "Wild Coaster",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PG/default/PGS_132.png",
//     key: "PG",
//   },
//   {
//     name: "Totem Wonders",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PG/default/PGS_1338274.png",
//     key: "PG",
//   },
//   {
//     name: "Asgardian Rising",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PG/default/PGS_1340277.png",
//     key: "PG",
//   },
//   {
//     name: "Wild Bounty Showdown",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PG/default/PGS_135.png",
//     key: "PG",
//   },
//   {
//     name: "Alchemy Gold",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PG/default/PGS_1368367.png",
//     key: "PG",
//   },
//   {
//     name: "Diner Delights",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PG/default/PGS_1372643.png",
//     key: "PG",
//   },
//   {
//     name: "Hawaiian Tiki",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PG/default/PGS_1381200.png",
//     key: "PG",
//   },
//   {
//     name: "Fruity Candy",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PG/default/PGS_1397455.png",
//     key: "PG",
//   },
//   {
//     name: "Midas Fortune",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PG/default/PGS_1402846.png",
//     key: "PG",
//   },
//   {
//     name: "Bakery Bonanza",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PG/default/PGS_1418544.png",
//     key: "PG",
//   },
//   {
//     name: "Rave Party Fever",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PG/default/PGS_1420892.png",
//     key: "PG",
//   },
//   {
//     name: "Mystical Spirits",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PG/default/PGS_1432733.png",
//     key: "PG",
//   },
//   {
//     name: "Songkran Splash",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PG/default/PGS_1448762.png",
//     key: "PG",
//   },
//   {
//     name: "Dragon Hatch 2",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PG/default/PGS_1451122.png",
//     key: "PG",
//   },
//   {
//     name: "Cruise Royale",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PG/default/PGS_1473388.png",
//     key: "PG",
//   },
//   {
//     name: "Ultimate Striker",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PG/default/PGS_1489936.png",
//     key: "PG",
//   },
//   {
//     name: "Pinata Wins",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PG/default/PGS_1492288.png",
//     key: "PG",
//   },
//   {
//     name: "Wild Ape #3258",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PG/default/PGS_1508783.png",
//     key: "PG",
//   },
//   {
//     name: "Super Golf Drive",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PG/default/PGS_1513328.png",
//     key: "PG",
//   },
//   {
//     name: "Ninja Raccoon Frenzy",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PG/default/PGS_1529867.png",
//     key: "PG",
//   },
//   {
//     name: "Fortune Rabbit",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PG/default/PGS_1543462.png",
//     key: "PG",
//   },
//   {
//     name: "Forge of Wealth",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PG/default/PGS_1555350.png",
//     key: "PG",
//   },
//   {
//     name: "Wild Heist Cashout",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PG/default/PGS_1568554.png",
//     key: "PG",
//   },
//   {
//     name: "Gladiator's Glory",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PG/default/PGS_1572362.png",
//     key: "PG",
//   },
//   {
//     name: "Mafia Mayhem",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PG/default/PGS_1580541.png",
//     key: "PG",
//   },
//   {
//     name: "Safari Wilds",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PG/default/PGS_1594259.png",
//     key: "PG",
//   },
//   {
//     name: "Lucky Clover Riches",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PG/default/PGS_1601012.png",
//     key: "PG",
//   },
//   {
//     name: "WereWolf's Hunt",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PG/default/PGS_1615454.png",
//     key: "PG",
//   },
//   {
//     name: "Anubis Wrath",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PG/default/PGS_1623475.png",
//     key: "PG",
//   },
//   {
//     name: "Zombie Outbreak",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PG/default/PGS_1635221.png",
//     key: "PG",
//   },
//   {
//     name: "Shark Bounty",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PG/default/PGS_1648578.png",
//     key: "PG",
//   },
//   {
//     name: "Tsar Treasures",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PG/default/PGS_1655268.png",
//     key: "PG",
//   },
//   {
//     name: "Gemstones Gold",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PG/default/PGS_1671262.png",
//     key: "PG",
//   },
//   {
//     name: "Cash Mania",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PG/default/PGS_1682240.png",
//     key: "PG",
//   },
//   {
//     name: "Fortune Dragon",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PG/default/PGS_1695365.png",
//     key: "PG",
//   },
//   {
//     name: "Geisha's Revenge",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PG/default/PGS_1702123.png",
//     key: "PG",
//   },
//   {
//     name: "Mystic Potions",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PG/default/PGS_1717688.png",
//     key: "PG",
//   },
//   {
//     name: "Three Crazy Piggies",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PG/default/PGS_1727711.png",
//     key: "PG",
//   },
//   {
//     name: "Wings of Iguazu",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PG/default/PGS_1747549.png",
//     key: "PG",
//   },
//   {
//     name: "Museum Mystery",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PG/default/PGS_1755623.png",
//     key: "PG",
//   },
//   {
//     name: "Yakuza Honor",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PG/default/PGS_1760238.png",
//     key: "PG",
//   },
//   {
//     name: "Futebol Fever",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PG/default/PGS_1778752.png",
//     key: "PG",
//   },
//   {
//     name: "Rio Fantasia",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PG/default/PGS_1786529.png",
//     key: "PG",
//   },
//   {
//     name: "Mr. Treasure’s Fortune",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PG/default/PGS_1799745.png",
//     key: "PG",
//   },
//   {
//     name: "Hood vs Wolf",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PG/default/PGS_18.png",
//     key: "PG",
//   },
//   {
//     name: "Graffiti Rush",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PG/default/PGS_1804577.png",
//     key: "PG",
//   },
//   {
//     name: "Oishi Delights",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PG/default/PGS_1815268.png",
//     key: "PG",
//   },
//   {
//     name: "Doomsday Rampage",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PG/default/PGS_1827457.png",
//     key: "PG",
//   },
//   {
//     name: "Jack the Giant Hunter",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PG/default/PGS_1834850.png",
//     key: "PG",
//   },
//   {
//     name: "Mythical Guardians",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PG/default/PGS_1849515.png",
//     key: "PG",
//   },
//   {
//     name: "Incan Wonders",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PG/default/PGS_1850016.png",
//     key: "PG",
//   },
//   {
//     name: "Dead Man's Riches",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PG/default/PGS_1865521.png",
//     key: "PG",
//   },
//   {
//     name: "Fortune Snake",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PG/default/PGS_1879752.png",
//     key: "PG",
//   },
//   {
//     name: "Knockout Riches",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PG/default/PGS_1881268.png",
//     key: "PG",
//   },
//   {
//     name: "Dragon's Treasure Quest",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PG/default/PGS_1897678.png",
//     key: "PG",
//   },
//   {
//     name: "Grimms' Bounty: Hansel & Gretel",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PG/default/PGS_1903012.png",
//     key: "PG",
//   },
//   {
//     name: "Galaxy Miner",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PG/default/PGS_1918451.png",
//     key: "PG",
//   },
//   {
//     name: "Kraken Gold Rush",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PG/default/PGS_1929177.png",
//     key: "PG",
//   },
//   {
//     name: "Diner Frenzy Spins",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PG/default/PGS_1935269.png",
//     key: "PG",
//   },
//   {
//     name: "Alibaba's Cave of Fortune",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PG/default/PGS_1940257.png",
//     key: "PG",
//   },
//   {
//     name: "Inferno Mayhem",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PG/default/PGS_1950910.png",
//     key: "PG",
//   },
//   {
//     name: "Pharaoh Royals",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PG/default/PGS_1964781.png",
//     key: "PG",
//   },
//   {
//     name: "Majestic Empire",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PG/default/PGS_1971587.png",
//     key: "PG",
//   },
//   {
//     name: "Forbidden Alchemy",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PG/default/PGS_1981965.png",
//     key: "PG",
//   },
//   {
//     name: "Mayan Destiny",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PG/default/PGS_1997301.png",
//     key: "PG",
//   },
//   {
//     name: "Gem Saviour",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PG/default/PGS_2.png",
//     key: "PG",
//   },
//   {
//     name: "Reel Love",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PG/default/PGS_20.png",
//     key: "PG",
//   },
//   {
//     name: "Poker Kingdom Win",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PG/default/PGS_2009635.png",
//     key: "PG",
//   },
//   {
//     name: "Ganesha Fortune",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PG/default/PGS_75.png",
//     key: "PG",
//   },
//   {
//     name: "Skylight Wonders",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PG/default/PGS_2012025.png",
//     key: "PG",
//   },
//   {
//     name: "Fortune Horse",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PG/default/PGS_2100928.png",
//     key: "PG",
//   },
//   {
//     name: "Win Win Won",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PG/default/PGS_24.png",
//     key: "PG",
//   },
//   {
//     name: "Plushie Frenzy",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PG/default/PGS_25.png",
//     key: "PG",
//   },
//   {
//     name: "Tree of Fortune",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PG/default/PGS_26.png",
//     key: "PG",
//   },
//   {
//     name: "Hotpot",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PG/default/PGS_28.png",
//     key: "PG",
//   },
//   {
//     name: "Dragon Legend",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PG/default/PGS_29.png",
//     key: "PG",
//   },
//   {
//     name: "Fortune Gods",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PG/default/PGS_3.png",
//     key: "PG",
//   },
//   {
//     name: "Hip Hop Panda",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PG/default/PGS_33.png",
//     key: "PG",
//   },
//   {
//     name: "Legend of Hou Yi",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PG/default/PGS_34.png",
//     key: "PG",
//   },
//   {
//     name: "Mr. Hallow-Win",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PG/default/PGS_35.png",
//     key: "PG",
//   },
//   {
//     name: "Prosperity Lion",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PG/default/PGS_36.png",
//     key: "PG",
//   },
//   {
//     name: "Santa's Gift Rush",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PG/default/PGS_37.png",
//     key: "PG",
//   },
//   {
//     name: "Gem Saviour Sword",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PG/default/PGS_38.png",
//     key: "PG",
//   },
//   {
//     name: "Piggy Gold",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PG/default/PGS_39.png",
//     key: "PG",
//   },
//   {
//     name: "Jungle Delight",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PG/default/PGS_40.png",
//     key: "PG",
//   },
//   {
//     name: "Symbols of Egypt",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PG/default/PGS_41.png",
//     key: "PG",
//   },
//   {
//     name: "Ganesha Gold",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PG/default/PGS_42.png",
//     key: "PG",
//   },
//   {
//     name: "Emperor's Favour",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PG/default/PGS_44.png",
//     key: "PG",
//   },
//   {
//     name: "Double Fortune",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PG/default/PGS_48.png",
//     key: "PG",
//   },
//   {
//     name: "Journey to the Wealth",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PG/default/PGS_50.png",
//     key: "PG",
//   },
//   {
//     name: "The Great Icescape",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PG/default/PGS_53.png",
//     key: "PG",
//   },
//   {
//     name: "Captain's Bounty",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PG/default/PGS_54.png",
//     key: "PG",
//   },
//   {
//     name: "Dragon Hatch",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PG/default/PGS_57.png",
//     key: "PG",
//   },
//   {
//     name: "Vampire's Charm",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PG/default/PGS_58.png",
//     key: "PG",
//   },
//   {
//     name: "Ninja vs Samurai",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PG/default/PGS_59.png",
//     key: "PG",
//   },
//   {
//     name: "Medusa II",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PG/default/PGS_6.png",
//     key: "PG",
//   },
//   {
//     name: "Leprechaun Riches",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PG/default/PGS_60.png",
//     key: "PG",
//   },
//   {
//     name: "Flirting Scholar",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PG/default/PGS_61.png",
//     key: "PG",
//   },
//   {
//     name: "Gem Saviour Conquest",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PG/default/PGS_62.png",
//     key: "PG",
//   },
//   {
//     name: "Dragon Tiger Luck",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PG/default/PGS_63.png",
//     key: "PG",
//   },
//   {
//     name: "Muay Thai Champion",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PG/default/PGS_64.png",
//     key: "PG",
//   },
//   {
//     name: "Mahjong Ways",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PG/default/PGS_65.png",
//     key: "PG",
//   },
//   {
//     name: "Shaolin Soccer",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PG/default/PGS_67.png",
//     key: "PG",
//   },
//   {
//     name: "Fortune Mouse",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PG/default/PGS_68.png",
//     key: "PG",
//   },
//   {
//     name: "Bikini Paradise",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PG/default/PGS_69.png",
//     key: "PG",
//   },
//   {
//     name: "Medusa",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PG/default/PGS_7.png",
//     key: "PG",
//   },
//   {
//     name: "Candy Burst",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PG/default/PGS_70.png",
//     key: "PG",
//   },
//   {
//     name: "Caishen Wins",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PG/default/PGS_71.png",
//     key: "PG",
//   },
//   {
//     name: "Egypt's Book of Mystery",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PG/default/PGS_73.png",
//     key: "PG",
//   },
//   {
//     name: "Mahjong Ways 2",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PG/default/PGS_74.png",
//     key: "PG",
//   },
//   {
//     name: "Dreams of Macau",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PG/default/PGS_79.png",
//     key: "PG",
//   },
//   {
//     name: "Circus Delight",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PG/default/PGS_80.png",
//     key: "PG",
//   },
//   {
//     name: "Phoenix Rises",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PG/default/PGS_82.png",
//     key: "PG",
//   },
//   {
//     name: "Wild Fireworks",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PG/default/PGS_83.png",
//     key: "PG",
//   },
//   {
//     name: "Queen of Bounty",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PG/default/PGS_84.png",
//     key: "PG",
//   },
//   {
//     name: "Genie's 3 Wishes",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PG/default/PGS_85.png",
//     key: "PG",
//   },
//   {
//     name: "Galactic Gems",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PG/default/PGS_86.png",
//     key: "PG",
//   },
//   {
//     name: "Treasures of Aztec",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PG/default/PGS_87.png",
//     key: "PG",
//   },
//   {
//     name: "Jewels of Prosperity",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PG/default/PGS_88.png",
//     key: "PG",
//   },
//   {
//     name: "Lucky Neko",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PG/default/PGS_89.png",
//     key: "PG",
//   },
//   {
//     name: "Secrets of Cleopatra",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PG/default/PGS_90.png",
//     key: "PG",
//   },
//   {
//     name: "Guardians of Ice & Fire",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PG/default/PGS_91.png",
//     key: "PG",
//   },
//   {
//     name: "Thai River Wonders",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PG/default/PGS_92.png",
//     key: "PG",
//   },
//   {
//     name: "Opera Dynasty",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PG/default/PGS_93.png",
//     key: "PG",
//   },
//   {
//     name: "Bali Vacation",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PG/default/PGS_94.png",
//     key: "PG",
//   },
//   {
//     name: "Majestic Treasures",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PG/default/PGS_95.png",
//     key: "PG",
//   },
//   {
//     name: "Jack Frost's Winter",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PG/default/PGS_97.png",
//     key: "PG",
//   },
//   {
//     name: "Fortune Ox",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PG/default/PGS_98.png",
//     key: "PG",
//   },
//   {
//     name: "4 Bonuses Bonanza - Plinko Spin",
//     image: "https://luckmedia.link/sms_plinko_joker/thumb.webp",
//     key: "SMARTSOFT",
//   },
//   {
//     name: "Multi Hot Ways",
//     image: "https://luckmedia.link/sms_multi_hot_ways/thumb.webp",
//     key: "SMARTSOFT",
//   },
//   {
//     name: "Burning Ice 10",
//     image: "https://luckmedia.link/sms_burning_ice_10/thumb.webp",
//     key: "SMARTSOFT",
//   },
//   {
//     name: "Mad Slot",
//     image: "https://luckmedia.link/sms_mad_slot/thumb.webp",
//     key: "SMARTSOFT",
//   },
//   {
//     name: "Book of Bonanza",
//     image: "https://luckmedia.link/sms_book_of_bonanza/thumb.webp",
//     key: "SMARTSOFT",
//   },
//   {
//     name: "Dracula’s Fortune",
//     image: "https://luckmedia.link/sms_draculas_fortune/thumb.webp",
//     key: "SMARTSOFT",
//   },
//   {
//     name: "Sugar Fiesta",
//     image: "https://luckmedia.link/sms_sugar_fiesta/thumb.webp",
//     key: "SMARTSOFT",
//   },
//   {
//     name: "Safari Simba",
//     image: "https://luckmedia.link/sms_safari_simba/thumb.webp",
//     key: "SMARTSOFT",
//   },
//   {
//     name: "Wild Multi Stars",
//     image: "https://luckmedia.link/sms_wild_multi_stars/thumb.webp",
//     key: "SMARTSOFT",
//   },
//   {
//     name: "Hot Samba",
//     image: "https://luckmedia.link/sms_hot_samba/thumb.webp",
//     key: "SMARTSOFT",
//   },
//   {
//     name: "Book of Futuria",
//     image: "https://luckmedia.link/sms_book_of_futuria/thumb.webp",
//     key: "SMARTSOFT",
//   },
//   {
//     name: "Bao Slot 5X",
//     image: "https://luckmedia.link/sms_bao_slot_5x/thumb.webp",
//     key: "SMARTSOFT",
//   },
//   {
//     name: "Jungle Sisters",
//     image: "https://luckmedia.link/sms_jungle_sisters/thumb.webp",
//     key: "SMARTSOFT",
//   },
//   {
//     name: "Habesha Fortune 5",
//     image: "https://luckmedia.link/sms_habesha_fortune_5/thumb.webp",
//     key: "SMARTSOFT",
//   },
//   {
//     name: "Jungle Sisters Deluxe",
//     image: "https://luckmedia.link/sms_jungle_sisters_deluxe/thumb.webp",
//     key: "SMARTSOFT",
//   },
//   {
//     name: "Bonus Time",
//     image: "https://luckmedia.link/sms_bonus_time/thumb.webp",
//     key: "SMARTSOFT",
//   },
//   {
//     name: "Dragon's Code",
//     image: "https://luckmedia.link/sms_dragons_code/thumb.webp",
//     key: "SMARTSOFT",
//   },
//   {
//     name: "Farm's Fortune",
//     image: "https://luckmedia.link/sms_farms_fortune/thumb.webp",
//     key: "SMARTSOFT",
//   },
//   {
//     name: "Wilds & Gods",
//     image: "https://luckmedia.link/sms_wilds__gods/thumb.webp",
//     key: "SMARTSOFT",
//   },
//   {
//     name: "Foxy Hot 20",
//     image: "https://luckmedia.link/sms_foxy_hot_20/thumb.webp",
//     key: "SMARTSOFT",
//   },
//   {
//     name: "Genie's Bonanza",
//     image: "https://luckmedia.link/sms_genies_bonanza/thumb.webp",
//     key: "SMARTSOFT",
//   },
//   {
//     name: "Vampires",
//     image: "https://luckmedia.link/sms_vampires/thumb.webp",
//     key: "SMARTSOFT",
//   },
//   {
//     name: "Burning Ice 40",
//     image: "https://luckmedia.link/sms_burning_ice_40/thumb.webp",
//     key: "SMARTSOFT",
//   },
//   {
//     name: "Burning Ice",
//     image: "https://luckmedia.link/sms_burning_ice/thumb.webp",
//     key: "SMARTSOFT",
//   },
//   {
//     name: "Multi Hot 5",
//     image: "https://luckmedia.link/sms_multi_hot_5/thumb.webp",
//     key: "SMARTSOFT",
//   },
//   {
//     name: "Boka Jamba 10",
//     image: "https://luckmedia.link/sms_boka_jamba_10/thumb.webp",
//     key: "SMARTSOFT",
//   },
//   {
//     name: "Mariachi Coins",
//     image: "https://luckmedia.link/sms_mariachi_coins/thumb.webp",
//     key: "SMARTSOFT",
//   },
//   {
//     name: "Cai Balao Cappadocia",
//     image: "https://luckmedia.link/sms_cai_ballao_cappadocia/thumb.webp",
//     key: "SMARTSOFT",
//   },
//   {
//     name: "Dracula's Fortune - Halloween Edition",
//     image:
//       "https://luckmedia.link/sms_draculas_fortune__halloween_edition/thumb.webp",
//     key: "SMARTSOFT",
//   },
//   {
//     name: "Multi Hot Wild Ways",
//     image: "https://luckmedia.link/sms_multi_hot_wild_ways/thumb.webp",
//     key: "SMARTSOFT",
//   },
//   {
//     name: "Multi Hot Wheel",
//     image: "https://luckmedia.link/sms_multi_hot_wheel/thumb.webp",
//     key: "SMARTSOFT",
//   },
//   {
//     name: "Multi Hot 5 Wild",
//     image: "https://luckmedia.link/sms_multi_hot_5_wilds/thumb.webp",
//     key: "SMARTSOFT",
//   },
//   {
//     name: "Wheel of Destiny",
//     image: "https://luckmedia.link/sms_wheel_of_destiny/thumb.webp",
//     key: "SMARTSOFT",
//   },
//   {
//     name: "Jingle Bell Bonanza",
//     image: "https://luckmedia.link/sms_jingle_bell_bonanza/thumb.webp",
//     key: "SMARTSOFT",
//   },
//   {
//     name: "Multi Hot 5 Deluxe",
//     image: "https://luckmedia.link/sms_multi_hot_deluxe/thumb.webp",
//     key: "SMARTSOFT",
//   },
//   {
//     name: "Multi Hot 5 Super Wilds",
//     image: "https://luckmedia.link/sms_multi_hot_super_wilds/thumb.webp",
//     key: "SMARTSOFT",
//   },
//   {
//     name: "Multi Hot 5 Burn Wilds",
//     image: "https://luckmedia.link/sms_multi_hot_burn_wilds/thumb.webp",
//     key: "SMARTSOFT",
//   },
//   {
//     name: "Dice Jungle",
//     image: "https://luckmedia.link/sms_dice_jungle/thumb.webp",
//     key: "SMARTSOFT",
//   },
//   {
//     name: "JokersTreasure",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/698db2d551249.jpg",
//     key: "SPADE",
//   },
//   {
//     name: "Galaxy Guardian",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/65b9f7944ce71.png",
//     key: "SPADE",
//   },
//   {
//     name: "Clash of the Giants",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/652f45a0d559b.jpeg",
//     key: "SPADE",
//   },
//   {
//     name: "Moji Mania",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/6513a1f938759.jpg",
//     key: "SPADE",
//   },
//   {
//     name: "Hammer of Thunder",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/spg/SG-SLOT-124_0.jpg",
//     key: "SPADE",
//   },
//   {
//     name: "Farmland Frenzy Maxways",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/spg/SG-SLOT-122_0.jpg",
//     key: "SPADE",
//   },
//   {
//     name: "CAISHEN DELUXE MAXWAYS",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/spg/SG-SLOT-121_0.jpg",
//     key: "SPADE",
//   },
//   {
//     name: "Rabbit Riches",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/spg/SG-SLOT-120_0.jpg",
//     key: "SPADE",
//   },
//   {
//     name: "Christmas Miracles",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/spg/SG-SLOT-119_0.jpg",
//     key: "SPADE",
//   },
//   {
//     name: "Halloween Vacation",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/spg/SG-SLOT-117_0.jpg",
//     key: "SPADE",
//   },
//   {
//     name: "Legacy Of Kong Maxways",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/spg/SG-SLOT-116_0.jpg",
//     key: "SPADE",
//   },
//   {
//     name: "Sugar Party",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/spg/SG-SLOT-115_0.jpg",
//     key: "SPADE",
//   },
//   {
//     name: "Candy Pop",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/6452730cb026b.png",
//     key: "SPADE",
//   },
//   {
//     name: "Captain Golds Fortune",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/spg/SG-SLOT-114_0.jpg",
//     key: "SPADE",
//   },
//   {
//     name: "Journey to the Wild",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/spg/SG-SLOT-113_0.jpg",
//     key: "SPADE",
//   },
//   {
//     name: "Fruits Mania",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/spg/SG-SLOT-112_0.jpg",
//     key: "SPADE",
//   },
//   {
//     name: "Gold Panther Maxways",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/spg/SG-SLOT-111_0.jpg",
//     key: "SPADE",
//   },
//   {
//     name: "Space Conquest",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/spg/SG-SLOT-110_0.jpg",
//     key: "SPADE",
//   },
//   {
//     name: "Caishen",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/spg/SG-SLOT-109_0.jpg",
//     key: "SPADE",
//   },
//   {
//     name: "Joker's Treasure Exclusive",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/spg/SG-SLOT-108_0.jpg",
//     key: "SPADE",
//   },
//   {
//     name: "Lucky Koi Exclusive",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/spg/SG-SLOT-107_0.jpg",
//     key: "SPADE",
//   },
//   {
//     name: "Fiery Sevens Exclusive",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/spg/SG-SLOT-106_0.jpg",
//     key: "SPADE",
//   },
//   {
//     name: "Royale House",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/spg/SG-SLOT-105_0.jpg",
//     key: "SPADE",
//   },
//   {
//     name: "Tiger Dance",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/spg/SG-SLOT-104_0.jpg",
//     key: "SPADE",
//   },
//   {
//     name: "Sexy Vegas",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/spg/SG-SLOT-103_0.jpg",
//     key: "SPADE",
//   },
//   {
//     name: "Roma",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/spg/SG-SLOT-102_0.jpg",
//     key: "SPADE",
//   },
//   {
//     name: "Candy Candy",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/spg/SG-SLOT-101_0.jpg",
//     key: "SPADE",
//   },
//   {
//     name: "Gold Rush Cowboy",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/spg/SG-SLOT-100_0.jpg",
//     key: "SPADE",
//   },
//   {
//     name: "Wild Wet Win",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/spg/SG-SLOT-099_0.jpg",
//     key: "SPADE",
//   },
//   {
//     name: "Royal Katt",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/spg/SG-SLOT-098_0.jpg",
//     key: "SPADE",
//   },
//   {
//     name: "Muay Thai Fighter",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/spg/SG-SLOT-097_0.jpg",
//     key: "SPADE",
//   },
//   {
//     name: "Rich Caishen",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/spg/SG-SLOT-096_0.jpg",
//     key: "SPADE",
//   },
//   {
//     name: "Poker Ways",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/spg/SG-SLOT-095_0.jpg",
//     key: "SPADE",
//   },
//   {
//     name: "Love Idol",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/spg/SG-SLOT-093_0.jpg",
//     key: "SPADE",
//   },
//   {
//     name: "Sugar Bonanza",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/spg/SG-SLOT-092_0.jpg",
//     key: "SPADE",
//   },
//   {
//     name: "Magic Kitty",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/spg/SG-SLOT-091_0.jpg",
//     key: "SPADE",
//   },
//   {
//     name: "Hugon Quest",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/spg/SG-SLOT-089_0.jpg",
//     key: "SPADE",
//   },
//   {
//     name: "Rise Of Werewolves",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/spg/SG-SLOT-087_0.jpg",
//     key: "SPADE",
//   },
//   {
//     name: "Mayan Gems",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/spg/SG-SLOT-086_0.jpg",
//     key: "SPADE",
//   },
//   {
//     name: "ProsperityGods",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/spg/SG-SLOT-085_0.jpg",
//     key: "SPADE",
//   },
//   {
//     name: "BrothersKingdom",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/spg/SG-SLOT-084_0.jpg",
//     key: "SPADE",
//   },
//   {
//     name: "MrChuTycoon",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/spg/SG-SLOT-083_0.jpg",
//     key: "SPADE",
//   },
//   {
//     name: "GoldPanther",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/spg/SG-SLOT-082_0.jpg",
//     key: "SPADE",
//   },
//   {
//     name: "TriplePanda",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/spg/SG-SLOT-081_0.jpg",
//     key: "SPADE",
//   },
//   {
//     name: "MagicalLamp",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/spg/SG-SLOT-080_0.jpg",
//     key: "SPADE",
//   },
//   {
//     name: "FierySevens",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/spg/SG-SLOT-079_0.jpg",
//     key: "SPADE",
//   },
//   {
//     name: "CrazyBomber",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/spg/SG-SLOT-078_0.jpg",
//     key: "SPADE",
//   },
//   {
//     name: "BookofMyth",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/spg/SG-SLOT-077_0.jpg",
//     key: "SPADE",
//   },
//   {
//     name: "DoubleFlame",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/spg/SG-SLOT-076_0.jpg",
//     key: "SPADE",
//   },
//   {
//     name: "Mega7",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/spg/SG-SLOT-074_0.jpg",
//     key: "SPADE",
//   },
//   {
//     name: "ThreeLuckyStars",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/spg/SG-SLOT-073_0.jpg",
//     key: "SPADE",
//   },
//   {
//     name: "SweetBakery",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/spg/SG-SLOT-072_0.jpg",
//     key: "SPADE",
//   },
//   {
//     name: "MoneyMouse",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/spg/SG-SLOT-071_0.jpg",
//     key: "SPADE",
//   },
//   {
//     name: "DancingFever",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/spg/SG-SLOT-070_0.jpg",
//     key: "SPADE",
//   },
//   {
//     name: "888",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/spg/SG-SLOT-069_0.jpg",
//     key: "SPADE",
//   },
//   {
//     name: "HeroesGame",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/spg/SG-SLOT-068_0.jpg",
//     key: "SPADE",
//   },
//   {
//     name: "LuckyMeow",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/spg/SG-SLOT-060_0.jpg",
//     key: "SPADE",
//   },
//   {
//     name: "GoldenWhale",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/spg/SG-SLOT-058_0.jpg",
//     key: "SPADE",
//   },
//   {
//     name: "DaFuXiaoFu",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/spg/SG-SLOT-055_0.jpg",
//     key: "SPADE",
//   },
//   {
//     name: "HighwayFortune",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/spg/SG-SLOT-049_0.jpg",
//     key: "SPADE",
//   },
//   {
//     name: "LuckyFengShui",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/spg/SG-SLOT-046_0.jpg",
//     key: "SPADE",
//   },
//   {
//     name: "Fafafa",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/spg/SG-SLOT-045_0.jpg",
//     key: "SPADE",
//   },
//   {
//     name: "LuckyKoi",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/spg/SG-SLOT-041_0.jpg",
//     key: "SPADE",
//   },
//   {
//     name: "5FortuneDragons",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/spg/SG-SLOT-039_0.jpg",
//     key: "SPADE",
//   },
//   {
//     name: "DoubleFortunes",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/spg/SG-SLOT-038_0.jpg",
//     key: "SPADE",
//   },
//   {
//     name: "CaiShen888",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/spg/SG-SLOT-037_0.jpg",
//     key: "SPADE",
//   },
//   {
//     name: "KingPharaoh",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/spg/SG-SLOT-034_0.jpg",
//     key: "SPADE",
//   },
//   {
//     name: "GoldenLotusSE",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/spg/SG-SLOT-032_0.jpg",
//     key: "SPADE",
//   },
//   {
//     name: "BabyCaiShen",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/spg/SG-SLOT-031_0.jpg",
//     key: "SPADE",
//   },
//   {
//     name: "5FortuneSA",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/spg/SG-SLOT-030_0.jpg",
//     key: "SPADE",
//   },
//   {
//     name: "IcelandSA",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/spg/SG-SLOT-023_0.jpg",
//     key: "SPADE",
//   },
//   {
//     name: "GreatStarsSA",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/spg/SG-SLOT-022_0.jpg",
//     key: "SPADE",
//   },
//   {
//     name: "BigProsperitySA",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/spg/SG-SLOT-021_0.jpg",
//     key: "SPADE",
//   },
//   {
//     name: "DragonGoldSA",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/spg/SG-SLOT-019_0.jpg",
//     key: "SPADE",
//   },
//   {
//     name: "GoldenChicken",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/spg/SG-SLOT-018_0.jpg",
//     key: "SPADE",
//   },
//   {
//     name: "HoYeahMonkey",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/spg/SG-SLOT-017_0.jpg",
//     key: "SPADE",
//   },
//   {
//     name: "ZEUS",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/spg/SG-SLOT-016_0.jpg",
//     key: "SPADE",
//   },
//   {
//     name: "TigerWarrior",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/spg/SG-SLOT-014_0.jpg",
//     key: "SPADE",
//   },
//   {
//     name: "JungleKing",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/spg/SG-SLOT-012_0.jpg",
//     key: "SPADE",
//   },
//   {
//     name: "GoldenMonkey",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/spg/SG-SLOT-009_0.jpg",
//     key: "SPADE",
//   },

//   {
//     name: "FirstLove",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/spg/SG-SLOT-008_0.jpg",
//     key: "SPADE",
//   },
//   {
//     name: "WowProsperity",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/spg/SG-SLOT-006_0.jpg",
//     key: "SPADE",
//   },
//   {
//     name: "PrincessWang",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/spg/SG-SLOT-005_0.jpg",
//     key: "SPADE",
//   },
//   {
//     name: "FaFaFa2",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/spg/SG-SLOT-003_0.jpg",
//     key: "SPADE",
//   },
//   {
//     name: "JUNGLE BANG BANG",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/688d9ff159389.png",
//     key: "FC",
//   },
//   {
//     name: "LUCKY FORTUNES 3x3",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/66a9da1fdd298.png",
//     key: "FC",
//   },
//   {
//     name: "SUPER ELEMENTS",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/652f5a9eb87da.png",
//     key: "FC",
//   },
//   {
//     name: "FORTUNE EGG",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/648a75b7f0c9b.png",
//     key: "FC",
//   },
//   {
//     name: "WIN WIN NEKO",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/64771302861f4.jpg",
//     key: "FC",
//   },
//   {
//     name: "CHINESE NEW YEAR 2",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/fc/FC-SLOT-022_0.jpg",
//     key: "FC",
//   },
//   {
//     name: "Lucky Fortunes",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/fc/FC-SLOT-021_0.jpg",
//     key: "FC",
//   },
//   {
//     name: "Robin Hood",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/fc/FC-SLOT-020_0.jpg",
//     key: "FC",
//   },
//   {
//     name: "GLORY OF ROME",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/fc/FC-SLOT-019_0.jpg",
//     key: "FC",
//   },
//   {
//     name: "RICH MAN",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/fc/FC-SLOT-018_0.jpg",
//     key: "FC",
//   },
//   {
//     name: "GOLD RUSH",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/fc/FC-SLOT-017_0.jpg",
//     key: "FC",
//   },
//   {
//     name: "TREASURE CRUISE",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/fc/FC-SLOT-016_0.jpg",
//     key: "FC",
//   },
//   {
//     name: "WAR OF THE UNIVERSE",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/fc/FC-SLOT-015_0.jpg",
//     key: "FC",
//   },
//   {
//     name: "COWBOYS",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/fc/FC-SLOT-014_0.jpg",
//     key: "FC",
//   },
//   {
//     name: "Magic Beans",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/fc/FC-SLOT-013_0.jpg",
//     key: "FC",
//   },
//   {
//     name: "LUXURY GOLDEN PANTHER",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/fc/FC-SLOT-012_0.jpg",
//     key: "FC",
//   },
//   {
//     name: "ANIMAL RACING",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/fc/FC-SLOT-011_0.jpg",
//     key: "FC",
//   },
//   {
//     name: "DA LE MEN",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/fc/FC-SLOT-010_0.jpg",
//     key: "FC",
//   },
//   {
//     name: "HAPPY DUO BAO",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/fc/FC-SLOT-009_0.jpg",
//     key: "FC",
//   },
//   {
//     name: "FORTUNE KOI",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/fc/FC-SLOT-008_0.jpg",
//     key: "FC",
//   },
//   {
//     name: "CHINESE NEW YEAR",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/fc/FC-SLOT-007_0.jpg",
//     key: "FC",
//   },
//   {
//     name: "PANDA DRAGON BOAT",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/fc/FC-SLOT-006_0.jpg",
//     key: "FC",
//   },
//   {
//     name: "PONG PONG HU",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/fc/FC-SLOT-005_0.jpg",
//     key: "FC",
//   },
//   {
//     name: "NIGHT MARKET",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/fc/FC-SLOT-004_0.jpg",
//     key: "FC",
//   },
//   {
//     name: "HOT POT PARTY",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/fc/FC-SLOT-003_0.jpg",
//     key: "FC",
//   },
//   {
//     name: "THREE LITTLE PIGS",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/fc/FC-SLOT-002_0.jpg",
//     key: "FC",
//   },
//   {
//     name: "GOLDEN PANTHER",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/fc/FC-SLOT-001_0.jpg",
//     key: "FC",
//   },
//   {
//     name: "Lucky Pearl",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/69685f49d63dc.png",
//     key: "JDB",
//   },
//   {
//     name: "Dragon Soar - Hyper Wild",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/668df53a39a88.png",
//     key: "JDB",
//   },
//   {
//     name: "Magic Ace",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/668ced2559514.jpg",
//     key: "JDB",
//   },
//   {
//     name: "Pop Pop Candy",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/652f5bf116874.png",
//     key: "JDB",
//   },
//   {
//     name: "Open Sesame Mega",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/652f5b9b8961c.jpg",
//     key: "JDB",
//   },
//   {
//     name: "Boom Fiesta",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/64f8217c15519.png",
//     key: "JDB",
//   },
//   {
//     name: "Big Three Dragons",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/64f8215a871d8.png",
//     key: "JDB",
//   },
//   {
//     name: "LanternWealth",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/649b92ef99eef.jpg",
//     key: "JDB",
//   },
//   {
//     name: "Moneybags Man 2",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/jdb/JDB-SLOT-108_0.jpg",
//     key: "JDB",
//   },
//   {
//     name: "Trump Card",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/jdb/JDB-SLOT-107_0.jpg",
//     key: "JDB",
//   },
//   {
//     name: "Fortune Neko",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/jdb/JDB-SLOT-106_0.jpg",
//     key: "JDB",
//   },
//   {
//     name: "BookOfMystery",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/jdb/JDB-SLOT-105_0.jpg",
//     key: "JDB",
//   },
//   {
//     name: "Glamorous Girl",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/jdb/JDB-SLOT-103_0.jpg",
//     key: "JDB",
//   },
//   {
//     name: "Blossom Of Wealth",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/jdb/JDB-SLOT-101_0.jpg",
//     key: "JDB",
//   },
//   {
//     name: "ProsperityTiger",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/jdb/JDB-SLOT-100_0.jpg",
//     key: "JDB",
//   },
//   {
//     name: "Maya Gold Crazy",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/jdb/JDB-SLOT-099_0.jpg",
//     key: "JDB",
//   },
//   {
//     name: "MarvelousIV",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/jdb/JDB-SLOT-098_0.jpg",
//     key: "JDB",
//   },
//   {
//     name: "Wonder Elephant",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/jdb/JDB-SLOT-097_0.jpg",
//     key: "JDB",
//   },
//   {
//     name: "Kong",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/jdb/JDB-SLOT-094_0.jpg",
//     key: "JDB",
//   },
//   {
//     name: "LuckyDiamond",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/jdb/JDB-SLOT-093_0.jpg",
//     key: "JDB",
//   },
//   {
//     name: "DragonsGate",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/jdb/JDB-SLOT-092_0.jpg",
//     key: "JDB",
//   },
//   {
//     name: "Spindrift2",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/jdb/JDB-SLOT-090_0.jpg",
//     key: "JDB",
//   },
//   {
//     name: "Spindrift",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/jdb/JDB-SLOT-089_0.jpg",
//     key: "JDB",
//   },
//   {
//     name: "DoubleWilds",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/jdb/JDB-SLOT-087_0.jpg",
//     key: "JDB",
//   },
//   {
//     name: "MoneybagsMan",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/jdb/JDB-SLOT-086_0.jpg",
//     key: "JDB",
//   },
//   {
//     name: "MinerBabe",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/jdb/JDB-SLOT-085_0.jpg",
//     key: "JDB",
//   },
//   {
//     name: "GoldenDisco",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/jdb/JDB-SLOT-084_0.jpg",
//     key: "JDB",
//   },
//   {
//     name: "Lucky Fuwa",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/jdb/JDB-SLOT-079_0.jpg",
//     key: "JDB",
//   },
//   {
//     name: "Super Niubi Deluxe",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/jdb/JDB-SLOT-077_0.jpg",
//     key: "JDB",
//   },
//   {
//     name: "Funky King Kong",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/jdb/JDB-SLOT-076_0.jpg",
//     key: "JDB",
//   },
//   {
//     name: "Treasure Bowl",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/jdb/JDB-SLOT-075_0.jpg",
//     key: "JDB",
//   },
//   {
//     name: "Mjoinir",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/jdb/JDB-SLOT-074_0.jpg",
//     key: "JDB",
//   },
//   {
//     name: "Pirate Treasure",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/jdb/JDB-SLOT-073_0.jpg",
//     key: "JDB",
//   },
//   {
//     name: "Fortune Treasure",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/jdb/JDB-SLOT-072_0.jpg",
//     key: "JDB",
//   },
//   {
//     name: "Egypt Treasure",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/jdb/JDB-SLOT-071_0.jpg",
//     key: "JDB",
//   },
//   {
//     name: "Super Niubi",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/jdb/JDB-SLOT-070_0.jpg",
//     key: "JDB",
//   },
//   {
//     name: "Dragons World",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/jdb/JDB-SLOT-069_0.jpg",
//     key: "JDB",
//   },
//   {
//     name: "GoLaiFu",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/jdb/JDB-SLOT-067_0.jpg",
//     key: "JDB",
//   },
//   {
//     name: "BirdsParty",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/jdb/JDB-SLOT-066_0.jpg",
//     key: "JDB",
//   },
//   {
//     name: "LuckyRacing",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/jdb/JDB-SLOT-065_0.jpg",
//     key: "JDB",
//   },
//   {
//     name: "Daji",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/jdb/JDB-SLOT-063_0.jpg",
//     key: "JDB",
//   },
//   {
//     name: "StreetFighter",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/jdb/JDB-SLOT-060_0.jpg",
//     key: "JDB",
//   },
//   {
//     name: "OnePunchMan",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/jdb/JDB-SLOT-058_0.jpg",
//     key: "JDB",
//   },
//   {
//     name: "MrBao",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/jdb/JDB-SLOT-057_0.jpg",
//     key: "JDB",
//   },
//   {
//     name: "PandaPanda",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/jdb/JDB-SLOT-055_0.jpg",
//     key: "JDB",
//   },
//   {
//     name: "XiYangYang",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/jdb/JDB-SLOT-054_0.jpg",
//     key: "JDB",
//   },
//   {
//     name: "FortuneHorse",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/jdb/JDB-SLOT-053_0.jpg",
//     key: "JDB",
//   },
//   {
//     name: "FlirtingScholarTangII",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/jdb/JDB-SLOT-052_0.jpg",
//     key: "JDB",
//   },
//   {
//     name: "OpenSesameII",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/jdb/JDB-SLOT-051_0.jpg",
//     key: "JDB",
//   },
//   {
//     name: "WinningMaskII",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/jdb/JDB-SLOT-050_0.jpg",
//     key: "JDB",
//   },
//   {
//     name: "LuckyPhoenix",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/jdb/JDB-SLOT-049_0.jpg",
//     key: "JDB",
//   },
//   {
//     name: "Napoleon",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/jdb/JDB-SLOT-048_0.jpg",
//     key: "JDB",
//   },
//   {
//     name: "LuckyLion",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/jdb/JDB-SLOT-046_0.jpg",
//     key: "JDB",
//   },
//   {
//     name: "LuckyDragons",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/jdb/JDB-SLOT-045_0.jpg",
//     key: "JDB",
//   },
//   {
//     name: "Legendary5",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/jdb/JDB-SLOT-044_0.jpg",
//     key: "JDB",
//   },
//   {
//     name: "TripleKingKong",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/jdb/JDB-SLOT-043_0.jpg",
//     key: "JDB",
//   },
//   {
//     name: "OrientAnimals",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/jdb/JDB-SLOT-042_0.jpg",
//     key: "JDB",
//   },
//   {
//     name: "LuckySeven",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/jdb/JDB-SLOT-041_0.jpg",
//     key: "JDB",
//   },
//   {
//     name: "Mining Upstart",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/jdb/JDB-SLOT-039_0.jpg",
//     key: "JDB",
//   },
//   {
//     name: "ChefPanda",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/jdb/JDB-SLOT-036_0.jpg",
//     key: "JDB",
//   },
//   {
//     name: "RollingInMoney",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/jdb/JDB-SLOT-035_0.jpg",
//     key: "JDB",
//   },
//   {
//     name: "Kingsman",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/jdb/JDB-SLOT-033_0.jpg",
//     key: "JDB",
//   },
//   {
//     name: "DragonWarrior",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/jdb/JDB-SLOT-032_0.jpg",
//     key: "JDB",
//   },
//   {
//     name: "Billionaire",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/jdb/JDB-SLOT-031_0.jpg",
//     key: "JDB",
//   },
//   {
//     name: "GuanGong",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/jdb/JDB-SLOT-030_0.jpg",
//     key: "JDB",
//   },
//   {
//     name: "Mahjong",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/jdb/JDB-SLOT-029_0.jpg",
//     key: "JDB",
//   },
//   {
//     name: "MoonlightTreasure",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/jdb/JDB-SLOT-028_0.jpg",
//     key: "JDB",
//   },
//   {
//     name: "MonkeyKing",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/jdb/JDB-SLOT-027_0.jpg",
//     key: "JDB",
//   },
//   {
//     name: "RoosterInLove",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/jdb/JDB-SLOT-026_0.jpg",
//     key: "JDB",
//   },
//   {
//     name: "Dragon",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/jdb/JDB-SLOT-025_0.jpg",
//     key: "JDB",
//   },
//   {
//     name: "OlympianTemple",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/jdb/JDB-SLOT-020_0.jpg",
//     key: "JDB",
//   },
//   {
//     name: "BananaSaga",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/jdb/JDB-SLOT-019_0.jpg",
//     key: "JDB",
//   },
//   {
//     name: "OpenSesame",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/jdb/JDB-SLOT-018_0.jpg",
//     key: "JDB",
//   },
//   {
//     name: "FourTreasures",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/jdb/JDB-SLOT-017_0.jpg",
//     key: "JDB",
//   },
//   {
//     name: "NewYear",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/jdb/JDB-SLOT-016_0.jpg",
//     key: "JDB",
//   },
//   {
//     name: "LuckyQilin",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/jdb/JDB-SLOT-015_0.jpg",
//     key: "JDB",
//   },
//   {
//     name: "FormosaBear",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/jdb/JDB-SLOT-014_0.jpg",
//     key: "JDB",
//   },
//   {
//     name: "LlamaAdventure",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/jdb/JDB-SLOT-013_0.jpg",
//     key: "JDB",
//   },
//   {
//     name: "WuKong",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/jdb/JDB-SLOT-012_0.jpg",
//     key: "JDB",
//   },
//   {
//     name: "WinningMask",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/jdb/JDB-SLOT-011_0.jpg",
//     key: "JDB",
//   },

//   {
//     name: "Cash Explorer",
//     image: "https://luckmedia.link/rtg_cash_explorer/thumb.webp",
//     key: "RT",
//   },
//   {
//     name: "Wild Hot Chilli Reels 2",
//     image: "https://luckmedia.link/rtg_wild_hot_chilli_reels_2/thumb.webp",
//     key: "RT",
//   },
//   {
//     name: "Wings of Ra Megaways",
//     image: "https://luckmedia.link/rtg_wings_of_ra_megaways/thumb.webp",
//     key: "RT",
//   },
//   {
//     name: "Dear Santa",
//     image: "https://luckmedia.link/rtg_dear_santa/thumb.webp",
//     key: "RT",
//   },
//   {
//     name: "Gladiator Ways",
//     image: "https://luckmedia.link/rtg_gladiator_ways/thumb.webp",
//     key: "RT",
//   },
//   {
//     name: "Diamond Doggies",
//     image: "https://luckmedia.link/rtg_diamond_doggies/thumb.webp",
//     key: "RT",
//   },
//   {
//     name: "Sea Boat Adventure Megaways",
//     image: "https://luckmedia.link/rtg_sea_boat_adventure_megaways/thumb.webp",
//     key: "RT",
//   },
//   {
//     name: "The Good, The Bad and The Rich",
//     image:
//       "https://luckmedia.link/rtg_the_good_the_bad_and_the_rich/thumb.webp",
//     key: "RT",
//   },
//   {
//     name: "Zeus Lightning Megaways",
//     image: "https://luckmedia.link/rtg_zeus_lightning_megaways/thumb.webp",
//     key: "RT",
//   },
//   {
//     name: "Atlantis",
//     image: "https://luckmedia.link/rtg_atlantis/thumb.webp",
//     key: "RT",
//   },
//   {
//     name: "Reactor",
//     image: "https://luckmedia.link/rtg_reactor/thumb.webp",
//     key: "RT",
//   },
//   {
//     name: "Bombuster",
//     image: "https://luckmedia.link/rtg_bombuster/thumb.webp",
//     key: "RT",
//   },
//   {
//     name: "Trillionaire",
//     image: "https://luckmedia.link/rtg_trillionaire/thumb.webp",
//     key: "RT",
//   },
//   {
//     name: "Gemtastic",
//     image: "https://luckmedia.link/rtg_gemtastic/thumb.webp",
//     key: "RT",
//   },
//   {
//     name: "Phoenix",
//     image: "https://luckmedia.link/rtg_phoenix/thumb.webp",
//     key: "RT",
//   },
//   {
//     name: "Masquerade",
//     image: "https://luckmedia.link/rtg_masquerade/thumb.webp",
//     key: "RT",
//   },
//   {
//     name: "Dragons’ Lock",
//     image: "https://luckmedia.link/rtg_dragons_lock/thumb.webp",
//     key: "RT",
//   },
//   {
//     name: "7’s Luck",
//     image: "https://luckmedia.link/rtg_7s_luck/thumb.webp",
//     key: "RT",
//   },
//   {
//     name: "Wolf Stacks Megaways",
//     image: "https://luckmedia.link/rtg_wolf_stacks_megaways/thumb.webp",
//     key: "RT",
//   },
//   {
//     name: "Trophy Fish",
//     image: "https://luckmedia.link/rtg_trophy_fish/thumb.webp",
//     key: "RT",
//   },
//   {
//     name: "Trillionaire Megaways",
//     image: "https://luckmedia.link/rtg_trillionaire_megaways/thumb.webp",
//     key: "RT",
//   },
//   {
//     name: "Serpent King",
//     image: "https://luckmedia.link/rtg_serpent_king/thumb.webp",
//     key: "RT",
//   },
//   {
//     name: "Bass Boss Megaways",
//     image: "https://luckmedia.link/rtg_bass_boss_megaways/thumb.webp",
//     key: "RT",
//   },
//   {
//     name: "Farmtastic",
//     image: "https://luckmedia.link/rtg_farmtastic/thumb.webp",
//     key: "RT",
//   },
//   {
//     name: "Jackrabbit Jackpots",
//     image: "https://luckmedia.link/rtg_jackrabbit_jackpots/thumb.webp",
//     key: "RT",
//   },
//   {
//     name: "1942 Sky Warrior",
//     image: "https://luckmedia.link/rtg_1942_sky_warrior/thumb.webp",
//     key: "RT",
//   },
//   {
//     name: "Ali Baba's Luck",
//     image: "https://luckmedia.link/rtg_ali_babas_luck/thumb.webp",
//     key: "RT",
//   },
//   {
//     name: "Blazing Clusters",
//     image: "https://luckmedia.link/rtg_blazing_clusters/thumb.webp",
//     key: "RT",
//   },
//   {
//     name: "Beriched",
//     image: "https://luckmedia.link/rtg_beriched/thumb.webp",
//     key: "RT",
//   },
//   {
//     name: "Big Cat Rescue Megaways",
//     image: "https://luckmedia.link/rtg_big_cat_rescue_megaways/thumb.webp",
//     key: "RT",
//   },
//   {
//     name: "Casino Spin",
//     image: "https://luckmedia.link/rtg_casino_spin/thumb.webp",
//     key: "RT",
//   },
//   {
//     name: "Bulls Run Wild",
//     image: "https://luckmedia.link/rtg_bulls_run_wild/thumb.webp",
//     key: "RT",
//   },
//   {
//     name: "Zillard King Megaways",
//     image: "https://luckmedia.link/rtg_zillard_king_megaways/thumb.webp",
//     key: "RT",
//   },
//   {
//     name: "Cobra Queen",
//     image: "https://luckmedia.link/rtg_cobra_queen/thumb.webp",
//     key: "RT",
//   },
//   {
//     name: "Desert Legends Spins",
//     image: "https://luckmedia.link/rtg_desert_legends_spins/thumb.webp",
//     key: "RT",
//   },
//   {
//     name: "Diamond Royale",
//     image: "https://luckmedia.link/rtg_diamond_royale/thumb.webp",
//     key: "RT",
//   },
//   {
//     name: "Dracula Awakening",
//     image: "https://luckmedia.link/rtg_dracula_awakening/thumb.webp",
//     key: "RT",
//   },
//   {
//     name: "Dragons Clusterbuster",
//     image: "https://luckmedia.link/rtg_dragons_clusterbuster/thumb.webp",
//     key: "RT",
//   },
//   {
//     name: "Dream Destiny",
//     image: "https://luckmedia.link/rtg_dream_destiny/thumb.webp",
//     key: "RT",
//   },
//   {
//     name: "Doggy Riches Megaways",
//     image: "https://luckmedia.link/rtg_doggy_riches_megaways/thumb.webp",
//     key: "RT",
//   },
//   {
//     name: "Zillard King",
//     image: "https://luckmedia.link/rtg_zillard_king/thumb.webp",
//     key: "RT",
//   },
//   {
//     name: "Epic Treasure",
//     image: "https://luckmedia.link/rtg_epic_treasure/thumb.webp",
//     key: "RT",
//   },
//   {
//     name: "Flodder",
//     image: "https://luckmedia.link/rtg_flodder/thumb.webp",
//     key: "RT",
//   },
//   {
//     name: "Fa Fa Babies",
//     image: "https://luckmedia.link/rtg_fa_fa_babies/thumb.webp",
//     key: "RT",
//   },
//   {
//     name: "Genie Nights",
//     image: "https://luckmedia.link/rtg_genie_nights/thumb.webp",
//     key: "RT",
//   },
//   {
//     name: "Jelly Multihops",
//     image: "https://luckmedia.link/rtg_jelly_multihops/thumb.webp",
//     key: "RT",
//   },
//   {
//     name: "Hustling",
//     image: "https://luckmedia.link/rtg_hustling/thumb.webp",
//     key: "RT",
//   },
//   {
//     name: "Hot Hot Chilli Pot",
//     image: "https://luckmedia.link/rtg_hot_hot_chilli_pot/thumb.webp",
//     key: "RT",
//   },
//   {
//     name: "Get The Gold InfiniReels",
//     image: "https://luckmedia.link/rtg_get_the_gold_infinireels/thumb.webp",
//     key: "RT",
//   },
//   {
//     name: "Jingle Ways Megaways",
//     image: "https://luckmedia.link/rtg_jingle_ways_megaways/thumb.webp",
//     key: "RT",
//   },
//   {
//     name: "Miami Rise",
//     image: "https://luckmedia.link/rtg_miami_rise/thumb.webp",
//     key: "RT",
//   },
//   {
//     name: "Last Chance Saloon",
//     image: "https://luckmedia.link/rtg_last_chance_saloon/thumb.webp",
//     key: "RT",
//   },
//   {
//     name: "Mayhem",
//     image: "https://luckmedia.link/rtg_mayhem/thumb.webp",
//     key: "RT",
//   },
//   {
//     name: "Risque Megaways",
//     image: "https://luckmedia.link/rtg_risque_megaways/thumb.webp",
//     key: "RT",
//   },
//   {
//     name: "Viral Spiral",
//     image: "https://luckmedia.link/rtg_viral_spiral/thumb.webp",
//     key: "RT",
//   },
//   {
//     name: "Wild Tundra",
//     image: "https://luckmedia.link/rtg_wild_tundra/thumb.webp",
//     key: "RT",
//   },
//   {
//     name: "Wanted Wildz",
//     image: "https://luckmedia.link/rtg_wanted_wildz/thumb.webp",
//     key: "RT",
//   },
//   {
//     name: "Zaida's Fortune",
//     image: "https://luckmedia.link/rtg_zaidas_fortune/thumb.webp",
//     key: "RT",
//   },
//   {
//     name: "Wild Expedition",
//     image: "https://luckmedia.link/rtg_wild_expedition/thumb.webp",
//     key: "RT",
//   },
//   {
//     name: "Cash Goddess",
//     image: "https://luckmedia.link/rtg_cash_goddess/thumb.webp",
//     key: "RT",
//   },
//   {
//     name: "777 Diamond Strike",
//     image: "https://luckmedia.link/rtg_777_diamond_strike/thumb.webp",
//     key: "RT",
//   },
//   {
//     name: "Rise of Cleopatra",
//     image: "https://luckmedia.link/rtg_rise_of_cleopatra/thumb.webp",
//     key: "RT",
//   },
//   {
//     name: "Big Gains",
//     image: "https://luckmedia.link/rtg_big_gains/thumb.webp",
//     key: "RT",
//   },
//   {
//     name: "Aztec Shamans MegaWays",
//     image: "https://luckmedia.link/rtg_aztec_shamans_megaways/thumb.webp",
//     key: "RT",
//   },
//   {
//     name: "Thor's Rage",
//     image: "https://luckmedia.link/rtg_thors_rage/thumb.webp",
//     key: "RT",
//   },
//   {
//     name: "Fish n Fish",
//     image: "https://luckmedia.link/rtg_fish_n_fish/thumb.webp",
//     key: "RT",
//   },
//   {
//     name: "Play with the Devil MegaWays",
//     image: "https://luckmedia.link/rtg_play_with_the_devil_megaways/thumb.webp",
//     key: "RT",
//   },
//   {
//     name: "Take the Money",
//     image: "https://luckmedia.link/rtg_take_the_money/thumb.webp",
//     key: "RT",
//   },
//   {
//     name: "Lava Joker",
//     image: "https://luckmedia.link/rtg_lava_joker/thumb.webp",
//     key: "RT",
//   },
//   {
//     name: "Cash Lamps",
//     image: "https://luckmedia.link/rtg_cash_lamps/thumb.webp",
//     key: "RT",
//   },
//   {
//     name: "Book Of Desert Legends",
//     image: "https://luckmedia.link/rtg_book_of_desert_legends/thumb.webp",
//     key: "RT",
//   },
//   {
//     name: "Land of Riches",
//     image: "https://luckmedia.link/rtg_land_of_riches/thumb.webp",
//     key: "RT",
//   },
//   {
//     name: "Arc Of Zeus",
//     image: "https://luckmedia.link/rtg_arc_of_zeus/thumb.webp",
//     key: "RT",
//   },
//   {
//     name: "Bloody Murder",
//     image: "https://luckmedia.link/rtg_bloody_murder/thumb.webp",
//     key: "RT",
//   },
//   {
//     name: "Spartan Wildz",
//     image: "https://luckmedia.link/rtg_spartan_wildz/thumb.webp",
//     key: "RT",
//   },
//   {
//     name: "Dragon Duo",
//     image: "https://luckmedia.link/rtg_dragon_duo/thumb.webp",
//     key: "RT",
//   },
//   {
//     name: "Cash Volt Supercharged",
//     image: "https://luckmedia.link/rtg_cash_volt_supercharged/thumb.webp",
//     key: "RT",
//   },
//   {
//     name: "Big Rich Turkeys",
//     image: "https://luckmedia.link/rtg_big_rich_turkeys/thumb.webp",
//     key: "RT",
//   },
//   {
//     name: "Biggest Vault",
//     image: "https://luckmedia.link/rtg_biggest_vault/thumb.webp",
//     key: "RT",
//   },
//   {
//     name: "Jingle Bells Bonanza 2",
//     image: "https://luckmedia.link/rtg_jingle_bells_bonanza_2/thumb.webp",
//     key: "RT",
//   },

//   {
//     name: "Pirates' Plenty: Treasures of the Seas",
//     image:
//       "https://luckmedia.link/rtg_pirates_plenty_treasures_of_the_seas/thumb.webp",
//     key: "RT",
//   },
//   {
//     name: "ROBO Lab",
//     image: "https://luckmedia.link/rtg_robo_lab/thumb.webp",
//     key: "RT",
//   },
//   {
//     name: "Piggy Riches Begins",
//     image: "https://luckmedia.link/rtg_piggy_riches_begins/thumb.webp",
//     key: "RT",
//   },
//   {
//     name: "Revolvero",
//     image: "https://luckmedia.link/rtg_revolvero/thumb.webp",
//     key: "RT",
//   },
//   {
//     name: "Monopoly Cash is King",
//     image: "https://luckmedia.link/rtg_monopoly_cash_is_king/thumb.webp",
//     key: "RT",
//   },
//   {
//     name: "Digging for Wilds",
//     image: "https://luckmedia.link/rtg_digging_for_wilds/thumb.webp",
//     key: "RT",
//   },
//   {
//     name: "Dragon Boyz",
//     image: "https://luckmedia.link/rtg_dragon_boyz/thumb.webp",
//     key: "RT",
//   },
//   {
//     name: "Monopoly Rent Rush",
//     image: "https://luckmedia.link/rtg_monopoly_rent_rush/thumb.webp",
//     key: "RT",
//   },
//   {
//     name: "Monopoly Money Magnate",
//     image: "https://luckmedia.link/rtg_monopoly_money_magnate/thumb.webp",
//     key: "RT",
//   },
//   {
//     name: "Archdragon King",
//     image: "https://luckmedia.link/rtg_archdragon_king/thumb.webp",
//     key: "RT",
//   },
//   {
//     name: "Shark Boss",
//     image: "https://luckmedia.link/rtg_shark_boss/thumb.webp",
//     key: "RT",
//   },
//   {
//     name: "Aztec Tribute",
//     image: "https://luckmedia.link/rtg_aztec_tribute/thumb.webp",
//     key: "RT",
//   },
//   {
//     name: "Dynamite Riches The Mother Lode",
//     image:
//       "https://luckmedia.link/rtg_dynamite_riches_the_mother_lode/thumb.webp",
//     key: "RT",
//   },
//   {
//     name: "Panda Goes Boom",
//     image: "https://luckmedia.link/rtg_panda_goes_boom/thumb.webp",
//     key: "RT",
//   },
//   {
//     name: "Hit the Jungle",
//     image: "https://luckmedia.link/rtg_hit_the_jungle/thumb.webp",
//     key: "RT",
//   },
//   {
//     name: "Diamond Blitz 3",
//     image: "https://luckmedia.link/rtg_diamond_blitz_3/thumb.webp",
//     key: "RT",
//   },
//   {
//     name: "Gold Digger Cluster Buster",
//     image: "https://luckmedia.link/rtg_gold_digger_cluster_buster/thumb.webp",
//     key: "RT",
//   },
//   {
//     name: "Happy Cappy",
//     image: "https://luckmedia.link/rtg_happy_cappy/thumb.webp",
//     key: "RT",
//   },
//   {
//     name: "777 Money Strike",
//     image: "https://luckmedia.link/rtg_777_money_strike/thumb.webp",
//     key: "RT",
//   },
//   {
//     name: "Bounty Cove",
//     image: "https://luckmedia.link/rtg_bounty_cove/thumb.webp",
//     key: "RT",
//   },
//   {
//     name: "Moon Spell",
//     image: "https://luckmedia.link/rtg_moon_spell/thumb.webp",
//     key: "RT",
//   },
//   {
//     name: "Los Muertos Locos",
//     image: "https://luckmedia.link/rtg_los_muertos_locos/thumb.webp",
//     key: "RT",
//   },
//   {
//     name: "Savannah Pride",
//     image: "https://luckmedia.link/rtg_savannah_pride/thumb.webp",
//     key: "RT",
//   },
//   {
//     name: "Egypt Clusterbuster",
//     image: "https://luckmedia.link/rtg_egypt_clusterbuster/thumb.webp",
//     key: "RT",
//   },
//   {
//     name: "Roman Emperors",
//     image: "https://luckmedia.link/rtg_roman_emperors/thumb.webp",
//     key: "RT",
//   },
//   {
//     name: "Turtle Paradise",
//     image: "https://luckmedia.link/rtg_turtle_paradise/thumb.webp",
//     key: "RT",
//   },
//   {
//     name: "Diamond Blitz 2",
//     image: "https://luckmedia.link/rtg_diamond_blitz_2/thumb.webp",
//     key: "RT",
//   },
//   {
//     name: "Fa Fa Babies 2",
//     image: "https://luckmedia.link/rtg_fa_fa_babies_2/thumb.webp",
//     key: "RT",
//   },
//   {
//     name: "Epic Treasure 2",
//     image: "https://luckmedia.link/rtg_epic_treasure_2/thumb.webp",
//     key: "RT",
//   },
//   {
//     name: "Ultra Rich",
//     image: "https://luckmedia.link/rtg_ultra_rich/thumb.webp",
//     key: "RT",
//   },
//   {
//     name: "Emperor of India",
//     image: "https://luckmedia.link/rtg_emperor_of_india/thumb.webp",
//     key: "RT",
//   },
//   {
//     name: "Piggy Riches 2 Megaways",
//     image: "https://luckmedia.link/rtg_piggy_riches_2_megaways/thumb.webp",
//     key: "RT",
//   },
//   {
//     name: "Purr Power",
//     image: "https://luckmedia.link/rtg_purr_power/thumb.webp",
//     key: "RT",
//   },
//   {
//     name: "Cannonball Cash",
//     image: "https://luckmedia.link/rtg_cannonball_cash/thumb.webp",
//     key: "RT",
//   },
//   {
//     name: "Rainbow Jackpots Megaways",
//     image: "https://luckmedia.link/rtg_rainbow_jackpots_megaways/thumb.webp",
//     key: "RT",
//   },
//   {
//     name: "Sword Stomp",
//     image: "https://luckmedia.link/rtg_sword_stomp/thumb.webp",
//     key: "RT",
//   },
//   {
//     name: "Fruit Flash",
//     image: "https://luckmedia.link/rtg_fruit_flash/thumb.webp",
//     key: "RT",
//   },
//   {
//     name: "Viking’s Legacy Everyway",
//     image: "https://luckmedia.link/rtg_vikings_legacy_everyway/thumb.webp",
//     key: "RT",
//   },
//   {
//     name: "Gold Mine Mistress",
//     image: "https://luckmedia.link/rtg_gold_mine_mistress/thumb.webp",
//     key: "RT",
//   },
//   {
//     name: "Primate King Megaways",
//     image: "https://luckmedia.link/rtg_primate_king_megaways/thumb.webp",
//     key: "RT",
//   },
// ];

// export const Table = [
//   {
//     name: "TeenPatti Joker",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/jili/159_0.jpg",
//     key: "JILI",
//   },
//   {
//     name: "Callbreak",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/jili/127_0.jpg",
//     key: "JILI",
//   },
//   {
//     name: "Rummy",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/jili/94_0.jpg",
//     key: "JILI",
//   },
//   {
//     name: "Andar Bahar",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/jili/79_0.jpg",
//     key: "JILI",
//   },
//   {
//     name: "AK47",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/jili/75_0.jpg",
//     key: "JILI",
//   },
//   {
//     name: "Domino Go",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/67e3e88518369.png",
//     key: "JILI",
//   },
//   {
//     name: "Penalty Kick",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/68089732eb04d.png",
//     key: "JILI",
//   },
//   {
//     name: "Golden Treasure",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/6836afa2e8ec9.png",
//     key: "JILI",
//   },
//   {
//     name: "Color Game Extreme",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/6838265a04a9f.png",
//     key: "JILI",
//   },
//   {
//     name: "Chicken Dash",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/68ca2683d926b.jpg",
//     key: "JILI",
//   },
//   {
//     name: "Plinko of Mine",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/68d3ade183e07.png",
//     key: "JILI",
//   },
//   {
//     name: "Drop Ball",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/68ef19cbf2875.jpg",
//     key: "JILI",
//   },
//   {
//     name: "Mines Grand",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/6901dd404aea4.png",
//     key: "JILI",
//   },
//   {
//     name: "Jogo do Bicho",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/6901de3447360.png",
//     key: "JILI",
//   },
//   {
//     name: "Frog Dash",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/690af1ca73201.png",
//     key: "JILI",
//   },
//   {
//     name: "Cricket Roulette",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/694ba3daabb8e.png",
//     key: "JILI",
//   },
//   {
//     name: "Golden Treasure Lightning",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/695b7b37916a2.jpg",
//     key: "JILI",
//   },
//   {
//     name: "Chicken Dash 10000",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/695dd9679c0c9.jpg",
//     key: "JILI",
//   },
//   {
//     name: "Mines Cricket",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/69a5381ebf6ef.jpg",
//     key: "JILI",
//   },
//   {
//     name: "Plinko Football",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/6a2a3057d737a.jpg",
//     key: "JILI",
//   },
//   {
//     name: "Speed AndarBahar",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/6a449c5194724.png",
//     key: "JILI",
//   },
//   {
//     name: "Chicken Dash Jackpot",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/6a54496165dc1.jpg",
//     key: "JILI",
//   },
//   {
//     name: "Grand Golden Treasure",
//     image:
//       "https://jiliwin.9terawolf.com/images/game_icon/direct/JILI/default/719.png",
//     key: "JILI",
//   },
//   {
//     name: "Super E-Sabong",
//     image: "https://jiliwin.9terawolf.com/images/rhinox/305.png",
//     key: "JILI",
//   },
//   {
//     name: "Super Ace Scratch",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/66a8b8c7691d1.png",
//     key: "JILI",
//   },
//   {
//     name: "Jhandi Munda",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/667e8e6698830.png",
//     key: "JILI",
//   },
//   {
//     name: "Speed Baccarat",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/663b91c0be24c.png",
//     key: "JILI",
//   },
//   {
//     name: "Video Poker",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/65e98d1d36be8.png",
//     key: "JILI",
//   },
//   {
//     name: "European Roulette",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/65c09184418f3.png",
//     key: "JILI",
//   },
//   {
//     name: "Caribbean Stud Poker",
//     image: "https://luckmedia.link/jil_caribbean_stud_poker/thumb.webp",
//     key: "JILI",
//   },
//   {
//     name: "TeenPatti 20-20",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/jili/161_0.jpg",
//     key: "JILI",
//   },
//   {
//     name: "Callbreak Quick",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/jili/160_0.jpg",
//     key: "JILI",
//   },
//   {
//     name: "Pearls of Bingo",
//     image: "https://luckmedia.link/jil_pearls_of_bingo/thumb.webp",
//     key: "JILI",
//   },
//   {
//     name: "Magic Lamp Bingo",
//     image: "https://luckmedia.link/jil_magic_lamp_bingo/thumb.webp",
//     key: "JILI",
//   },
//   {
//     name: "West Hunter Bingo",
//     image: "https://luckmedia.link/jil_west_hunter_bingo/thumb.webp",
//     key: "JILI",
//   },
//   {
//     name: "PAPPU",
//     image: "https://luckmedia.link/jil_pappu/thumb.webp",
//     key: "JILI",
//   },
//   {
//     name: "Bingo Carnaval",
//     image: "https://luckmedia.link/jil_bingo_carnaval/thumb.webp",
//     key: "JILI",
//   },
//   {
//     name: "Super Bingo",
//     image: "https://luckmedia.link/jil_super_bingo/thumb.webp",
//     key: "JILI",
//   },
//   {
//     name: "Sic Bo",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/jili/125_0.jpg",
//     key: "JILI",
//   },
//   {
//     name: "Fortune Bingo",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/jili/139_0.jpg",
//     key: "JILI",
//   },

//   {
//     name: "Baccarat",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/jili/152_0.jpg",
//     key: "JILI",
//   },
//   {
//     name: "Big Small",
//     image: "https://luckmedia.link/jil_big_small/thumb.webp",
//     key: "JILI",
//   },
//   {
//     name: "Pool Rummy",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/6572816302ff6.png",
//     key: "JILI",
//   },
//   {
//     name: "MiniFlush",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/65373aaeedfe9.png",
//     key: "JILI",
//   },
//   {
//     name: "Blackjack Lucky Ladies",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/6527bcc88028b.png",
//     key: "JILI",
//   },
//   {
//     name: "HILO",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/651f8efb47736.png",
//     key: "JILI",
//   },
//   {
//     name: "Blackjack",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/64f965982f784.png",
//     key: "JILI",
//   },
//   {
//     name: "Candyland Bingo",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/64d5df4ccd389.png",
//     key: "JILI",
//   },
//   {
//     name: "Plinko",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/64ca4bd80ed06.png",
//     key: "JILI",
//   },
//   {
//     name: "Keno",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/64ae370c5986f.png",
//     key: "JILI",
//   },
//   {
//     name: "Mines Gold",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/64abca428f09c.png",
//     key: "JILI",
//   },
//   {
//     name: "Color Prediction",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/6501afa41ed86.png",
//     key: "JILI",
//   },
//   {
//     name: "Pusoy Go",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/649568f43c680.png",
//     key: "JILI",
//   },
//   {
//     name: "Bingo Adventure",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/645b4951f0c28.png",
//     key: "JILI",
//   },
//   {
//     name: "Tower",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/6450d0af3f37e.png",
//     key: "JILI",
//   },
//   {
//     name: "Tongits Go",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/63f1d5aa2ceda.png",
//     key: "JILI",
//   },
//   {
//     name: "Calaca Bingo",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/63f1d516e06c0.png",
//     key: "JILI",
//   },
//   {
//     name: "Go Goal Bingo",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/63f1d4c6c9e5f.png",
//     key: "JILI",
//   },
//   {
//     name: "Color Game",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/63f1d4557f0c1.png",
//     key: "JILI",
//   },
//   {
//     name: "Jackpot Bingo",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/63f1d425cd836.png",
//     key: "JILI",
//   },
//   {
//     name: "Lucky Bingo",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/63f1d3e9ef0da.png",
//     key: "JILI",
//   },
//   {
//     name: "TeenPatti",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/jili/72_0.jpg",
//     key: "JILI",
//   },
//   {
//     name: "7up7down",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/jili/124_0.jpg",
//     key: "JILI",
//   },
//   {
//     name: "iRich Bingo",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/jili/122_0.jpg",
//     key: "JILI",
//   },
//   {
//     name: "Dragon & Tiger",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/jili/123_0.jpg",
//     key: "JILI",
//   },
//   {
//     name: "Poker King",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/jili/113_0.jpg",
//     key: "JILI",
//   },
//   {
//     name: "Number King",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/jili/111_0.jpg",
//     key: "JILI",
//   },
//   {
//     name: "Hotline",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/spribe/500x500/hotline.png",
//     key: "SPRIBE",
//   },
//   {
//     name: "Dice",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/spribe/500x500/dice.png",
//     key: "SPRIBE",
//   },
//   {
//     name: "Plinko",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/spribe/500x500/plinko.png",
//     key: "SPRIBE",
//   },
//   {
//     name: "Mines",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/spribe/500x500/mines.png",
//     key: "SPRIBE",
//   },
//   {
//     name: "Hi-lo",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/spribe/500x500/hi-lo.png",
//     key: "SPRIBE",
//   },
//   {
//     name: "Keno",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/spribe/500x500/keno.png",
//     key: "SPRIBE",
//   },
//   {
//     name: "Mini Roulette",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/spribe/500x500/mini-roulette.png",
//     key: "SPRIBE",
//   },
//   {
//     name: "Roulette",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/rla.png",
//     key: "PP",
//   },
//   {
//     name: "Dragon Bonus Baccarat",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/bnadvanced.png",
//     key: "PP",
//   },
//   {
//     name: "Baccarat",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/bca.png",
//     key: "PP",
//   },
//   {
//     name: "CardMatka",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/km/KM-TABLE-022_0.jpg",
//     key: "KM",
//   },
//   {
//     name: "Andar Bahar",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/km/KM-TABLE-032_0.jpg",
//     key: "KM",
//   },
//   {
//     name: "Teen Patti",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/km/KM-TABLE-046_0.jpg",
//     key: "KM",
//   },
//   {
//     name: "Teen Patti Blitz",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/688da187518c4.jpg",
//     key: "KM",
//   },
//   {
//     name: "COLOR GAME MEGA BONUS",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/688da2288d89d.jpg",
//     key: "KM",
//   },
//   {
//     name: "Olympus Glory",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/668d0048c6fb2.jpg",
//     key: "KM",
//   },
//   {
//     name: "Bingo Roll",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/64e32ce5d08e8.png",
//     key: "KM",
//   },
//   {
//     name: "Colour Game",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/64e328ab61b97.png",
//     key: "KM",
//   },
//   {
//     name: "HORSE RACING",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/648c24d7bf687.jpg",
//     key: "KM",
//   },
//   {
//     name: "Dota Hi-Lo",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/km/KM-TABLE-044_0.jpg",
//     key: "KM",
//   },
//   {
//     name: "Bonus Dice",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/km/KM-TABLE-043_0.jpg",
//     key: "KM",
//   },
//   {
//     name: "Plinko",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/km/KM-TABLE-040_0.jpg",
//     key: "KM",
//   },
//   {
//     name: "32 Cards",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/km/KM-TABLE-039_0.jpg",
//     key: "KM",
//   },
//   {
//     name: "Blackjack",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/km/KM-TABLE-038_0.jpg",
//     key: "KM",
//   },
//   {
//     name: "Cards Hi Lo",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/km/KM-TABLE-037_0.jpg",
//     key: "KM",
//   },
//   {
//     name: "Coin Toss",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/km/KM-TABLE-036_0.jpg",
//     key: "KM",
//   },
//   {
//     name: "Minesweeper",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/km/KM-TABLE-042_0.jpg",
//     key: "KM",
//   },
//   {
//     name: "Kingmaker Pok Deng",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/km/KM-TABLE-034_0.jpg",
//     key: "KM",
//   },
//   {
//     name: "Pai Kang",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/km/KM-TABLE-033_0.jpg",
//     key: "KM",
//   },
//   {
//     name: "Baccarat",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/km/KM-TABLE-026_0.jpg",
//     key: "KM",
//   },
//   {
//     name: "Jhandi Munda",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/km/KM-TABLE-030_0.jpg",
//     key: "KM",
//   },
//   {
//     name: "7 Up 7 Down",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/km/KM-TABLE-028_0.jpg",
//     key: "KM",
//   },
//   {
//     name: "European Roulette",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/km/KM-TABLE-027_0.jpg",
//     key: "KM",
//   },
//   {
//     name: "Fruit Roulette",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/km/KM-TABLE-025_0.jpg",
//     key: "KM",
//   },
//   {
//     name: "Fan Tan Classic",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/km/KM-TABLE-024_0.jpg",
//     key: "KM",
//   },
//   {
//     name: "Xocdia2",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/km/KM-TABLE-023_0.jpg",
//     key: "KM",
//   },
//   {
//     name: "NumberMatka",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/km/KM-TABLE-021_0.jpg",
//     key: "KM",
//   },
//   {
//     name: "Bài Cào",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/km/KM-TABLE-020_0.jpg",
//     key: "KM",
//   },
//   {
//     name: "Thai-FPC",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/km/KM-TABLE-019_0.jpg",
//     key: "KM",
//   },
//   {
//     name: "TaiXiu",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/km/KM-TABLE-017_0.jpg",
//     key: "KM",
//   },
//   {
//     name: "Sicbo",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/km/KM-TABLE-015_0.jpg",
//     key: "KM",
//   },
//   {
//     name: "VN Fish Prawn Crab",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/km/KM-TABLE-014_0.jpg",
//     key: "KM",
//   },
//   {
//     name: "Fish Prawn Crab 2",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/km/KM-TABLE-013_0.jpg",
//     key: "KM",
//   },
//   {
//     name: "Dragon Tiger 2",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/km/KM-TABLE-011_0.jpg",
//     key: "KM",
//   },
//   {
//     name: "Thai-Hi-Lo2",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/km/KM-TABLE-009_0.jpg",
//     key: "KM",
//   },
//   {
//     name: "Punto Banco",
//     image: "https://luckmedia.link/rtg_punto_banco/thumb.webp",
//     key: "RT",
//   },
//   {
//     name: "European Roulette",
//     image: "https://luckmedia.link/rtg_european_roulette/thumb.webp",
//     key: "RT",
//   },
// ];

// export const Fishing = [
//   {
//     name: "Bombing Fishing",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/jili/20_0.jpg",
//     key: "JILI",
//   },
//   {
//     name: "Jackpot Fishing",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/jili/32_0.jpg",
//     key: "JILI",
//   },
//   {
//     name: "Mega Fishing",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/jili/74_0.jpg",
//     key: "JILI",
//   },
//   {
//     name: "Happy Fishing",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/jili/82_0.jpg",
//     key: "JILI",
//   },
//   {
//     name: "All-star Fishing",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/jili/119_0.jpg",
//     key: "JILI",
//   },
//   {
//     name: "Jackpot Fishing 2",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/69ae3c0daf3b3.jpg",
//     key: "JILI",
//   },
//   {
//     name: "FORTUNE ZOMBIE",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/68712a6a6284b.png",
//     key: "JILI",
//   },
//   {
//     name: "Fortune King Jackpot",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/66def5502f398.jpg",
//     key: "JILI",
//   },
//   {
//     name: "Ocean King Jackpot",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/653893eca3ce9.png",
//     key: "JILI",
//   },
//   {
//     name: "Dinosaur Tycoon II",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/644a39be04362.png",
//     key: "JILI",
//   },
//   {
//     name: "Boom Legend",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/jili/71_0.jpg",
//     key: "JILI",
//   },
//   {
//     name: "Dragon Fortune",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/jili/60_0.jpg",
//     key: "JILI",
//   },
//   {
//     name: "Dinosaur Tycoon",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/jili/42_0.jpg",
//     key: "JILI",
//   },
//   {
//     name: "Royal Fishing",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/jili/1_0.jpg",
//     key: "JILI",
//   },
//   {
//     name: "Zombie Party",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/spg/SG-FISH-004_0.jpg",
//     key: "SPADE",
//   },
//   {
//     name: "Alien Hunter",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/spg/SG-FISH-003_0.jpg",
//     key: "SPADE",
//   },
//   {
//     name: "Fishing War",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/spg/SG-FISH-002_0.jpg",
//     key: "SPADE",
//   },
//   {
//     name: "Fishing God",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/spg/SG-FISH-001_0.jpg",
//     key: "SPADE",
//   },
// ];
export const Cricket = [
  {
    image: "/assets/images/betswiz.webp",
    name: "Velki",
  },
  {
    image: "/assets/images/wicketspro.webp",
    name: "9Wicket",
  },
];

export const sportBook = [
  {
    name: "IBC Sports",
    image: "/assets/images/0_0.jpg",
  },
];

export const Slot = [
  {
    name: "Crazy777 2",
    image: "/assets/slot/crazy777-2.webp",
    key: "JILI",
    gameCode: "JILI-SLOT-149",
    gameType: "SLOT",
    platFormCode: "JILI",
  },
  {
    name: "Super Ace Deluxe",
    image: "/assets/slot/super-ace-deluxe.webp",
    key: "JILI",
    gameCode: "JILI-SLOT-102",
    gameType: "SLOT",
    platFormCode: "JILI",
  },
  {
    name: "Crazy777",
    image: "/assets/slot/crazy777.webp",
    key: "JILI",
    gameCode: "JILI-SLOT-014",
    gameType: "SLOT",
    platFormCode: "JILI",
  },
  {
    name: "Super Ace",
    image: "/assets/slot/super-ace.webp",
    key: "JILI",
    gameCode: "JILI-SLOT-027",
    gameType: "SLOT",
    platFormCode: "JILI",
  },
  {
    name: "Crazy Hunter",
    image: "/assets/slot/crazy-hunter.webp",
    key: "JILI",
    gameCode: "JILI-SLOT-045",
    gameType: "SLOT",
    platFormCode: "JILI",
  },
  {
    name: "Fortune Gems",
    image: "/assets/slot/fortune-gems.webp",
    key: "JILI",
    gameCode: "JILI-SLOT-043",
    gameType: "SLOT",
    platFormCode: "JILI",
  },
  {
    name: "Golden Empire",
    image: "/assets/slot/golden-empire.webp",
    key: "JILI",
    gameCode: "JILI-SLOT-042",
    gameType: "SLOT",
    platFormCode: "JILI",
  },
  {
    name: "Lucky Coming",
    image: "/assets/slot/lucky-coming.webp",
    key: "JILI",
    gameCode: "JILI-SLOT-037",
    gameType: "SLOT",
    platFormCode: "JILI",
  },
  {
    name: "Pharaoh Treasure",
    image: "/assets/slot/pharaoh-treasure.webp",
    key: "JILI",
    gameCode: "JILI-SLOT-038",
    gameType: "SLOT",
    platFormCode: "JILI",
  },
  {
    name: "Boxing King",
    image: "/assets/slot/boxing-king.webp",
    key: "JILI",
    gameCode: "JILI-SLOT-031",
    gameType: "SLOT",
    platFormCode: "JILI",
  },
  {
    name: "Jungle King",
    image: "/assets/slot/jungle-king.webp",
    key: "JILI",
    gameCode: "JILI-SLOT-028",
    gameType: "SLOT",
    platFormCode: "JILI",
  },
  {
    name: "Money Coming",
    image: "/assets/slot/money-coming.webp",
    key: "JILI",
    gameCode: "JILI-SLOT-029",
    gameType: "SLOT",
    platFormCode: "JILI",
  },
  {
    name: "Treasure Quest",
    image: "/assets/slot/treasure-quest.webp",
    key: "JILI",
    gameCode: "JILI-SLOT-114",
    gameType: "SLOT",
    platFormCode: "JILI",
  },
  {
    name: "3 Coin Wild Horse",
    image: "/assets/slot/3-coin-wild-horse.webp",
    key: "JILI",
    gameCode: "JILI-SLOT-126",
    gameType: "SLOT",
    platFormCode: "JILI",
  },
  {
    name: "Roma X Deluxe",
    image: "/assets/slot/roma-x-deluxe.webp",
    key: "JILI",
    gameCode: "JILI-SLOT-124",
    gameType: "SLOT",
    platFormCode: "JILI",
  },
  {
    name: "Super Ace Joker",
    image: "/assets/slot/super-ace-joker.webp",
    key: "JILI",
    gameCode: "JILI-SLOT-118",
    gameType: "SLOT",
    platFormCode: "JILI",
  },
  {
    name: "Fortune Coins",
    image: "/assets/slot/fortune-coins.webp",
    key: "JILI",
    gameCode: "JILI-SLOT-129",
    gameType: "SLOT",
    platFormCode: "JILI",
  },
  {
    name: "3 Charge Buffalo",
    image: "/assets/slot/3-charge-buffalo.webp",
    key: "JILI",
    gameCode: "JILI-SLOT-131",
    gameType: "SLOT",
    platFormCode: "JILI",
  },
  {
    name: "3 Coin Treasures 2",
    image: "/assets/slot/3-coin-treasures-2.webp",
    key: "JILI",
    gameCode: "JILI-SLOT-134",
    gameType: "SLOT",
    platFormCode: "JILI",
  },
  {
    name: "Pirate Queen 2",
    image: "/assets/slot/pirate-queen-2.webp",
    key: "JILI",
    gameCode: "JILI-SLOT-135",
    gameType: "SLOT",
    platFormCode: "JILI",
  },
  {
    name: "3 LUCKY LION",
    image: "/assets/slot/3-lucky-lion.webp",
    key: "JILI",
    gameCode: "JILI-SLOT-140",
    gameType: "SLOT",
    platFormCode: "JILI",
  },
  {
    name: "Golden Empire 2",
    image: "/assets/slot/golden-empire-2.webp",
    key: "JILI",
    gameCode: "JILI-SLOT-143",
    gameType: "SLOT",
    platFormCode: "JILI",
  },
  {
    name: "Super Ace II",
    image: "/assets/slot/super-ace-ii.webp",
    key: "JILI",
  },
  {
    name: "Money Coming 2",
    image: "/assets/slot/money-coming-2.webp",
    key: "JILI",
    gameCode: "JILI-SLOT-146",
    gameType: "SLOT",
    platFormCode: "JILI",
  },
  {
    name: "Circus Joker 4096",
    image: "/assets/slot/circus-joker-4096.webp",
    key: "JILI",
    gameCode: "JILI-SLOT-136",
    gameType: "SLOT",
    platFormCode: "JILI",
  },
  {
    name: "Rapid Gems 777",
    image: "/assets/slot/rapid-gems-777.webp",
    key: "JILI",
    gameCode: "JILI-SLOT-152",
    gameType: "SLOT",
    platFormCode: "JILI",
  },
  {
    name: "Jackpot Joker FEVER",
    image: "/assets/slot/jackpot-joker-fever.webp",
    key: "JILI",
    gameCode: "JILI-SLOT-153",
    gameType: "SLOT",
    platFormCode: "JILI",
  },
  {
    name: "Safari King",
    image: "/assets/slot/safari-king.webp",
    key: "JILI",
    gameCode: "JILI-SLOT-154",
    gameType: "SLOT",
    platFormCode: "JILI",
  },
  {
    name: "ROMA X 10000",
    image: "/assets/slot/roma-x-10000.webp",
    key: "JILI",
    gameCode: "JILI-SLOT-155",
    gameType: "SLOT",
    platFormCode: "JILI",
  },
  {
    name: "Cash Coin",
    image: "/assets/slot/cash-coin.webp",
    key: "JILI",
    gameCode: "JILI-SLOT-157",
    gameType: "SLOT",
    platFormCode: "JILI",
  },
  {
    name: "Joker Coins",
    image: "/assets/slot/joker-coins.webp",
    key: "JILI",
    gameCode: "JILI-SLOT-137",
    gameType: "SLOT",
    platFormCode: "JILI",
  },
  {
    name: "Royal Quest",
    image: "/assets/slot/royal-quest.webp",
    key: "JILI",
    gameCode: "JILI-TABLE-089",
    gameType: "TABLE",
    platFormCode: "JILI",
  },
  {
    name: "Boxing King Title Match",
    image: "/assets/slot/boxing-king-title-match.webp",
    key: "JILI",
    gameCode: "JILI-SLOT-161",
    gameType: "SLOT",
    platFormCode: "JILI",
  },
  {
    name: "Fortune Coins 2",
    image: "/assets/slot/fortune-coins-2.webp",
    key: "JILI",
    gameCode: "JILI-SLOT-147",
    gameType: "SLOT",
    platFormCode: "JILI",
  },
  {
    name: "Circus Jackpot",
    image: "/assets/slot/circus-jackpot.webp",
    key: "JILI",
    gameCode: "JILI-FISH-015",
    gameType: "FH",
    platFormCode: "JILI",
  },
  {
    name: "10 Sparkling Crown",
    image: "/assets/slot/10-sparkling-crown.webp",
    key: "JILI",
    gameCode: "JILI-SLOT-133",
    gameType: "SLOT",
    platFormCode: "JILI",
  },
  {
    name: "Clover Coins 3x3",
    image: "/assets/slot/clover-coins-3x3.webp",
    key: "JILI",
  },
  {
    name: "Gallina Fortunata",
    image: "/assets/slot/gallina-fortunata.webp",
    key: "JILI",
    gameCode: "JILI-TABLE-083",
    gameType: "TABLE",
    platFormCode: "JILI",
  },
  {
    name: "Lucky Jaguar",
    image: "/assets/slot/lucky-jaguar.webp",
    key: "JILI",
    gameCode: "JILI-SLOT-115",
    gameType: "SLOT",
    platFormCode: "JILI",
  },
  {
    name: "Legacy of Egypt",
    image: "/assets/slot/legacy-of-egypt.webp",
    key: "JILI",
    gameCode: "JILI-SLOT-105",
    gameType: "SLOT",
    platFormCode: "JILI",
  },
  {
    name: "3 Witch's Lamp",
    image: "/assets/slot/3-witch-s-lamp.webp",
    key: "JILI",
  },
  {
    name: "3 Coin Golden OX",
    image: "/assets/slot/3-coin-golden-ox.webp",
    key: "JILI",
  },
  {
    name: "20 Blazing Clover",
    image: "/assets/slot/20-blazing-clover.webp",
    key: "JILI",
  },
  {
    name: "Lucky Jaguar 2",
    image: "/assets/slot/lucky-jaguar-2.webp",
    key: "JILI",
  },
  {
    name: "Party Ape",
    image: "/assets/slot/party-ape.webp",
    key: "JILI",
  },
  {
    name: "Fortune Garuda 500",
    image: "/assets/slot/fortune-garuda-500.webp",
    key: "JILI",
  },
  {
    name: "40 Sparkling Crown",
    image: "/assets/slot/40-sparkling-crown.webp",
    key: "JILI",
    gameCode: "JILI-SLOT-145",
    gameType: "SLOT",
    platFormCode: "JILI",
  },
  {
    name: "Coin of Lightning",
    image: "/assets/slot/coin-of-lightning.webp",
    key: "JILI",
  },
  {
    name: "3 Super Ace",
    image: "/assets/slot/3-super-ace.webp",
    key: "JILI",
  },
  {
    name: "Fortune Gems Legend",
    image: "/assets/slot/fortune-gems-legend.webp",
    key: "JILI",
  },
  {
    name: "Lucky Jaguar 500",
    image: "/assets/slot/lucky-jaguar-500.webp",
    key: "JILI",
  },
  {
    name: "Clover Coins 4x4",
    image: "/assets/slot/clover-coins-4x4.webp",
    key: "JILI",
    gameCode: "JILI-SLOT-148",
    gameType: "SLOT",
    platFormCode: "JILI",
  },
  {
    name: "100 Blazing Clover",
    image: "/assets/slot/100-blazing-clover.webp",
    key: "JILI",
  },
  {
    name: "Fortune Hook Boom",
    image: "/assets/slot/fortune-hook-boom.webp",
    key: "JILI",
    gameCode: "JILI-SLOT-156",
    gameType: "SLOT",
    platFormCode: "JILI",
  },
  {
    name: "Supernova",
    image: "/assets/slot/supernova.webp",
    key: "JILI",
  },
  {
    name: "Football Golden Cup",
    image: "/assets/slot/football-golden-cup.webp",
    key: "JILI",
  },
  {
    name: "Devil Fire Twins",
    image: "/assets/slot/devil-fire-twins.webp",
    key: "JILI",
  },
  {
    name: "Super Ace SPEED",
    image: "/assets/slot/super-ace-speed.webp",
    key: "JILI",
    gameCode: "JILI-SLOT-142",
    gameType: "SLOT",
    platFormCode: "JILI",
  },
  {
    name: "Crown of Fortune",
    image: "/assets/slot/crown-of-fortune.webp",
    key: "JILI",
  },
  {
    name: "Jackpot Football",
    image: "/assets/slot/jackpot-football.webp",
    key: "JILI",
  },
  {
    name: "Lucky Caramelo",
    image: "/assets/slot/lucky-caramelo.webp",
    key: "JILI",
  },
  {
    name: "Dice & Drop",
    image: "/assets/slot/dice-drop.webp",
    key: "JILI",
  },
  {
    name: "Storm of Seth 2",
    image: "/assets/slot/storm-of-seth-2.webp",
    key: "JILI",
  },
  {
    name: "3 Coin Wild Tiger",
    image: "/assets/slot/3-coin-wild-tiger.webp",
    key: "JILI",
  },
  {
    name: "3 Lucky Baozhu",
    image: "/assets/slot/3-lucky-baozhu.webp",
    key: "JILI",
    gameCode: "JILI-SLOT-168",
    gameType: "SLOT",
    platFormCode: "JILI",
  },
  {
    name: "3 Pot Dragons",
    image: "/assets/slot/3-pot-dragons.webp",
    key: "JILI",
    gameCode: "JILI-SLOT-106",
    gameType: "SLOT",
    platFormCode: "JILI",
  },
  {
    name: "Coin Tree",
    image: "/assets/slot/coin-tree.webp",
    key: "JILI",
    gameCode: "JILI-SLOT-125",
    gameType: "SLOT",
    platFormCode: "JILI",
  },
  {
    name: "Egypt's Glow",
    image: "/assets/slot/egypt-s-glow.webp",
    key: "JILI",
    gameCode: "JILI-SLOT-108",
    gameType: "SLOT",
    platFormCode: "JILI",
  },
  {
    name: "Golden Bank 2",
    image: "/assets/slot/golden-bank-2.webp",
    key: "JILI",
    gameCode: "JILI-SLOT-116",
    gameType: "SLOT",
    platFormCode: "JILI",
  },
  {
    name: "Lucky Doggy",
    image: "/assets/slot/lucky-doggy.webp",
    key: "JILI",
    gameCode: "JILI-SLOT-117",
    gameType: "SLOT",
    platFormCode: "JILI",
  },
  {
    name: "Lucky Macaw",
    image: "/assets/slot/lucky-macaw.webp",
    key: "JILI",
    gameCode: "JILI-SLOT-158",
    gameType: "SLOT",
    platFormCode: "JILI",
  },
  {
    name: "Money Pot Deluxe",
    image: "/assets/slot/money-pot-deluxe.webp",
    key: "JILI",
  },
  {
    name: "Safari Mystery",
    image: "/assets/slot/safari-mystery.webp",
    key: "JILI",
    gameCode: "JILI-SLOT-123",
    gameType: "SLOT",
    platFormCode: "JILI",
  },
  {
    name: "Joker's Fortune",
    image: "/assets/slot/joker-s-fortune.webp",
    key: "JILI",
  },
  {
    name: "Thor Dice",
    image: "/assets/slot/thor-dice.webp",
    key: "JILI",
  },
  {
    name: "Fortune Gems 500",
    image: "/assets/slot/fortune-gems-500.webp",
    key: "JILI",
  },
  {
    name: "Joker Coin Expanded",
    image: "/assets/slot/joker-coin-expanded.webp",
    key: "JILI",
  },
  {
    name: "Bison Fortune Coins",
    image: "/assets/slot/bison-fortune-coins.webp",
    key: "JILI",
  },
  {
    name: "3 Lightning Blitz",
    image: "/assets/slot/3-lightning-blitz.webp",
    key: "JILI",
  },
  {
    name: "Fortune Coins Unlimited Fortune",
    image: "/assets/slot/fortune-coins-unlimited-fortune.webp",
    key: "JILI",
  },
  {
    name: "X7 HOT",
    image: "/assets/slot/x7-hot.webp",
    key: "JILI",
  },
  {
    name: "Lucky Tiger",
    image: "/assets/slot/lucky-tiger.webp",
    key: "JILI",
    gameCode: "JILI-SLOT-144",
    gameType: "SLOT",
    platFormCode: "JILI",
  },
  {
    name: "Shōgun",
    image: "/assets/slot/shogun.webp",
    key: "JILI",
    gameCode: "JILI-SLOT-110",
    gameType: "SLOT",
    platFormCode: "JILI",
  },
  {
    name: "Money Pot",
    image: "/assets/slot/money-pot.webp",
    key: "JILI",
    gameCode: "JILI-SLOT-112",
    gameType: "SLOT",
    platFormCode: "JILI",
  },
  {
    name: "Poseidon",
    image: "/assets/slot/poseidon.webp",
    key: "JILI",
    gameCode: "JILI-SLOT-121",
    gameType: "SLOT",
    platFormCode: "JILI",
  },
  {
    name: "Nightfall Hunting",
    image: "/assets/slot/nightfall-hunting.webp",
    key: "JILI",
    gameCode: "JILI-SLOT-113",
    gameType: "SLOT",
    platFormCode: "JILI",
  },
  {
    name: "3 Lucky Piggy",
    image: "/assets/slot/3-lucky-piggy.webp",
    key: "JILI",
    gameCode: "JILI-SLOT-109",
    gameType: "SLOT",
    platFormCode: "JILI",
  },
  {
    name: "Party Star",
    image: "/assets/slot/party-star.webp",
    key: "JILI",
    gameCode: "JILI-SLOT-104",
    gameType: "SLOT",
    platFormCode: "JILI",
  },
  {
    name: "Money Coming Expand Bets",
    image: "/assets/slot/money-coming-expand-bets.webp",
    key: "JILI",
    gameCode: "JILI-SLOT-107",
    gameType: "SLOT",
    platFormCode: "JILI",
  },
  {
    name: "The Pig House",
    image: "/assets/slot/the-pig-house.webp",
    key: "JILI",
    gameCode: "JILI-SLOT-103",
    gameType: "SLOT",
    platFormCode: "JILI",
  },
  {
    name: "Potion Wizard",
    image: "/assets/slot/potion-wizard.webp",
    key: "JILI",
    gameCode: "JILI-SLOT-098",
    gameType: "SLOT",
    platFormCode: "JILI",
  },
  {
    name: "Crazy Hunter 2",
    image: "/assets/slot/crazy-hunter-2.webp",
    key: "JILI",
    gameCode: "JILI-SLOT-099",
    gameType: "SLOT",
    platFormCode: "JILI",
  },
  {
    name: "3 Coin Treasures",
    image: "/assets/slot/3-coin-treasures.webp",
    key: "JILI",
    gameCode: "JILI-SLOT-101",
    gameType: "SLOT",
    platFormCode: "JILI",
  },
  {
    name: "Jackpot Joker",
    image: "/assets/slot/jackpot-joker.webp",
    key: "JILI",
    gameCode: "JILI-SLOT-100",
    gameType: "SLOT",
    platFormCode: "JILI",
  },
  {
    name: "Fortune Gems 3",
    image: "/assets/slot/fortune-gems-3.webp",
    key: "JILI",
    gameCode: "JILI-SLOT-096",
    gameType: "SLOT",
    platFormCode: "JILI",
  },
  {
    name: "Devil Fire 2",
    image: "/assets/slot/devil-fire-2.webp",
    key: "JILI",
    gameCode: "JILI-SLOT-094",
    gameType: "SLOT",
    platFormCode: "JILI",
  },
  {
    name: "Zeus",
    image: "/assets/slot/zeus.webp",
    key: "JILI",
    gameCode: "JILI-SLOT-097",
    gameType: "SLOT",
    platFormCode: "JILI",
  },
  {
    name: "Trial of Phoenix",
    image: "/assets/slot/trial-of-phoenix.webp",
    key: "JILI",
    gameCode: "JILI-SLOT-084",
    gameType: "SLOT",
    platFormCode: "JILI",
  },
  {
    name: "Arena Fighter",
    image: "/assets/slot/arena-fighter.webp",
    key: "JILI",
    gameCode: "JILI-SLOT-092",
    gameType: "SLOT",
    platFormCode: "JILI",
  },
  {
    name: "Charge Buffalo Ascent",
    image: "/assets/slot/charge-buffalo-ascent.webp",
    key: "JILI",
    gameCode: "JILI-SLOT-093",
    gameType: "SLOT",
    platFormCode: "JILI",
  },
  {
    name: "King Arthur",
    image: "/assets/slot/king-arthur.webp",
    key: "JILI",
    gameCode: "JILI-SLOT-091",
    gameType: "SLOT",
    platFormCode: "JILI",
  },
  {
    name: "Fortune Gems 2",
    image: "/assets/slot/fortune-gems-2.webp",
    key: "JILI",
    gameCode: "JILI-SLOT-076",
    gameType: "SLOT",
    platFormCode: "JILI",
  },
  {
    name: "World Cup",
    image: "/assets/slot/world-cup.webp",
    key: "JILI",
    gameCode: "JILI-SLOT-063",
    gameType: "SLOT",
    platFormCode: "JILI",
  },
  {
    name: "Bone Fortune",
    image: "/assets/slot/bone-fortune.webp",
    key: "JILI",
    gameCode: "JILI-SLOT-059",
    gameType: "SLOT",
    platFormCode: "JILI",
  },
  {
    name: "Mayan Empire",
    image: "/assets/slot/mayan-empire.webp",
    key: "JILI",
    gameCode: "JILI-SLOT-058",
    gameType: "SLOT",
    platFormCode: "JILI",
  },
  {
    name: "Gold Rush",
    image: "/assets/slot/gold-rush.webp",
    key: "JILI",
    gameCode: "JILI-SLOT-057",
    gameType: "SLOT",
    platFormCode: "JILI",
  },
  {
    name: "Happy Taxi",
    image: "/assets/slot/happy-taxi.webp",
    key: "JILI",
    gameCode: "JILI-SLOT-056",
    gameType: "SLOT",
    platFormCode: "JILI",
  },
  {
    name: "Thor X",
    image: "/assets/slot/thor-x.webp",
    key: "JILI",
    gameCode: "JILI-SLOT-052",
    gameType: "SLOT",
    platFormCode: "JILI",
  },
  {
    name: "Party Night",
    image: "/assets/slot/party-night.webp",
    key: "JILI",
    gameCode: "JILI-SLOT-044",
    gameType: "SLOT",
    platFormCode: "JILI",
  },
  {
    name: "ROMA X",
    image: "/assets/slot/roma-x.webp",
    key: "JILI",
    gameCode: "JILI-SLOT-040",
    gameType: "SLOT",
    platFormCode: "JILI",
  },
  {
    name: "Monkey Party",
    image: "/assets/slot/monkey-party.webp",
    key: "JILI",
  },
  {
    name: "Golden Queen",
    image: "/assets/slot/golden-queen.webp",
    key: "JILI",
    gameCode: "JILI-SLOT-030",
    gameType: "SLOT",
    platFormCode: "JILI",
  },
  {
    name: "Golden Bank",
    image: "/assets/slot/golden-bank.webp",
    key: "JILI",
    gameCode: "JILI-SLOT-023",
    gameType: "SLOT",
    platFormCode: "JILI",
  },
  {
    name: "DiamondParty",
    image: "/assets/slot/diamondparty.webp",
    key: "JILI",
    gameCode: "JILI-SLOT-021",
    gameType: "SLOT",
    platFormCode: "JILI",
  },
  {
    name: "Hawaii Beauty",
    image: "/assets/slot/hawaii-beauty.webp",
    key: "JILI",
    gameCode: "JILI-SLOT-012",
    gameType: "SLOT",
    platFormCode: "JILI",
  },
  {
    name: "Hyper Burst",
    image: "/assets/slot/hyper-burst.webp",
    key: "JILI",
    gameCode: "JILI-SLOT-007",
    gameType: "SLOT",
    platFormCode: "JILI",
  },
  {
    name: "Lucky Ball",
    image: "/assets/slot/lucky-ball.webp",
    key: "JILI",
    gameCode: "JILI-SLOT-006",
    gameType: "SLOT",
    platFormCode: "JILI",
  },
  {
    name: "Fortune Tree",
    image: "/assets/slot/fortune-tree.webp",
    key: "JILI",
    gameCode: "JILI-SLOT-005",
    gameType: "SLOT",
    platFormCode: "JILI",
  },
  {
    name: "Secret Treasure",
    image: "/assets/slot/secret-treasure.webp",
    key: "JILI",
    gameCode: "JILI-SLOT-039",
    gameType: "SLOT",
    platFormCode: "JILI",
  },
  {
    name: "Super Rich",
    image: "/assets/slot/super-rich.webp",
    key: "JILI",
    gameCode: "JILI-SLOT-041",
    gameType: "SLOT",
    platFormCode: "JILI",
  },
  {
    name: "Magic Lamp",
    image: "/assets/slot/magic-lamp.webp",
    key: "JILI",
    gameCode: "JILI-SLOT-046",
    gameType: "SLOT",
    platFormCode: "JILI",
  },
  {
    name: "Agent Ace",
    image: "/assets/slot/agent-ace.webp",
    key: "JILI",
    gameCode: "JILI-SLOT-048",
    gameType: "SLOT",
    platFormCode: "JILI",
  },
  {
    name: "Ali Baba",
    image: "/assets/slot/ali-baba.webp",
    key: "JILI",
    gameCode: "JILI-SLOT-049",
    gameType: "SLOT",
    platFormCode: "JILI",
  },
  {
    name: "Hot Chilli",
    image: "/assets/slot/hot-chilli.webp",
    key: "JILI",
    gameCode: "JILI-SLOT-002",
    gameType: "SLOT",
    platFormCode: "JILI",
  },
  {
    name: "Night City",
    image: "/assets/slot/night-city.webp",
    key: "JILI",
    gameCode: "JILI-SLOT-090",
    gameType: "SLOT",
    platFormCode: "JILI",
  },
  {
    name: "Sin City",
    image: "/assets/slot/sin-city.webp",
    key: "JILI",
    gameCode: "JILI-SLOT-089",
    gameType: "SLOT",
    platFormCode: "JILI",
  },
  {
    name: "Dabanggg",
    image: "/assets/slot/dabanggg.webp",
    key: "JILI",
    gameCode: "JILI-SLOT-088",
    gameType: "SLOT",
    platFormCode: "JILI",
  },
  {
    name: "Bonus Hunter",
    image: "/assets/slot/bonus-hunter.webp",
    key: "JILI",
    gameCode: "JILI-SLOT-062",
    gameType: "SLOT",
    platFormCode: "JILI",
  },
  {
    name: "Samba",
    image: "/assets/slot/samba.webp",
    key: "JILI",
    gameCode: "JILI-SLOT-070",
    gameType: "SLOT",
    platFormCode: "JILI",
  },
  {
    name: "JILI CAISHEN",
    image: "/assets/slot/jili-caishen.webp",
    key: "JILI",
    gameCode: "JILI-SLOT-060",
    gameType: "SLOT",
    platFormCode: "JILI",
  },
  {
    name: "Pirate Queen",
    image: "/assets/slot/pirate-queen.webp",
    key: "JILI",
    gameCode: "JILI-SLOT-073",
    gameType: "SLOT",
    platFormCode: "JILI",
  },
  {
    name: "Fortune Monkey",
    image: "/assets/slot/fortune-monkey.webp",
    key: "JILI",
    gameCode: "JILI-SLOT-087",
    gameType: "SLOT",
    platFormCode: "JILI",
  },
  {
    name: "Aztec Priestess",
    image: "/assets/slot/aztec-priestess.webp",
    key: "JILI",
    gameCode: "JILI-SLOT-083",
    gameType: "SLOT",
    platFormCode: "JILI",
  },
  {
    name: "Bangla Beauty",
    image: "/assets/slot/bangla-beauty.webp",
    key: "JILI",
    gameCode: "JILI-SLOT-086",
    gameType: "SLOT",
    platFormCode: "JILI",
  },
  {
    name: "Devil Fire",
    image: "/assets/slot/devil-fire.webp",
    key: "JILI",
    gameCode: "JILI-SLOT-085",
    gameType: "SLOT",
    platFormCode: "JILI",
  },
  {
    name: "Cricket Sah 75",
    image: "/assets/slot/cricket-sah-75.webp",
    key: "JILI",
    gameCode: "JILI-SLOT-082",
    gameType: "SLOT",
    platFormCode: "JILI",
  },
  {
    name: "Golden Temple",
    image: "/assets/slot/golden-temple.webp",
    key: "JILI",
    gameCode: "JILI-SLOT-080",
    gameType: "SLOT",
    platFormCode: "JILI",
  },
  {
    name: "Elf Bingo",
    image: "/assets/slot/elf-bingo.webp",
    key: "JILI",
    gameCode: "JILI-SLOT-081",
    gameType: "SLOT",
    platFormCode: "JILI",
  },
  {
    name: "Cricket King 18",
    image: "/assets/slot/cricket-king-18.webp",
    key: "JILI",
    gameCode: "JILI-SLOT-078",
    gameType: "SLOT",
    platFormCode: "JILI",
  },
  {
    name: "Sweet Land",
    image: "/assets/slot/sweet-land.webp",
    key: "JILI",
    gameCode: "JILI-SLOT-079",
    gameType: "SLOT",
    platFormCode: "JILI",
  },
  {
    name: "Master Tiger",
    image: "/assets/slot/master-tiger.webp",
    key: "JILI",
    gameCode: "JILI-SLOT-077",
    gameType: "SLOT",
    platFormCode: "JILI",
  },
  {
    name: "Wild Ace",
    image: "/assets/slot/wild-ace.webp",
    key: "JILI",
    gameCode: "JILI-SLOT-075",
    gameType: "SLOT",
    platFormCode: "JILI",
  },
  {
    name: "Golden Joker",
    image: "/assets/slot/golden-joker.webp",
    key: "JILI",
    gameCode: "JILI-SLOT-074",
    gameType: "SLOT",
    platFormCode: "JILI",
  },
  {
    name: "Wild Racer",
    image: "/assets/slot/wild-racer.webp",
    key: "JILI",
    gameCode: "JILI-SLOT-072",
    gameType: "SLOT",
    platFormCode: "JILI",
  },
  {
    name: "Neko Fortune",
    image: "/assets/slot/neko-fortune.webp",
    key: "JILI",
    gameCode: "JILI-SLOT-071",
    gameType: "SLOT",
    platFormCode: "JILI",
  },
  {
    name: "Crazy Pusher",
    image: "/assets/slot/crazy-pusher.webp",
    key: "JILI",
    gameCode: "JILI-SLOT-054",
    gameType: "SLOT",
    platFormCode: "JILI",
  },
  {
    name: "Medusa",
    image: "/assets/slot/medusa.webp",
    key: "JILI",
    gameCode: "JILI-SLOT-050",
    gameType: "SLOT",
    platFormCode: "JILI",
  },
  {
    name: "Book Of Gold",
    image: "/assets/slot/book-of-gold.webp",
    key: "JILI",
    gameCode: "JILI-SLOT-053",
    gameType: "SLOT",
    platFormCode: "JILI",
  },
  {
    name: "Mega Ace",
    image: "/assets/slot/mega-ace.webp",
    key: "JILI",
    gameCode: "JILI-SLOT-051",
    gameType: "SLOT",
    platFormCode: "JILI",
  },
  {
    name: "Charge Buffalo",
    image: "/assets/slot/charge-buffalo.webp",
    key: "JILI",
    gameCode: "JILI-SLOT-026",
    gameType: "SLOT",
    platFormCode: "JILI",
  },
  {
    name: "Dragon Treasure",
    image: "/assets/slot/dragon-treasure.webp",
    key: "JILI",
    gameCode: "JILI-SLOT-025",
    gameType: "SLOT",
    platFormCode: "JILI",
  },
  {
    name: "Lucky Goldbricks",
    image: "/assets/slot/lucky-goldbricks.webp",
    key: "JILI",
    gameCode: "JILI-SLOT-024",
    gameType: "SLOT",
    platFormCode: "JILI",
  },
  {
    name: "Fengshen",
    image: "/assets/slot/fengshen.webp",
    key: "JILI",
    gameCode: "JILI-SLOT-022",
    gameType: "SLOT",
    platFormCode: "JILI",
  },
  {
    name: "Candy Baby",
    image: "/assets/slot/candy-baby.webp",
    key: "JILI",
    gameCode: "JILI-SLOT-020",
    gameType: "SLOT",
    platFormCode: "JILI",
  },
  {
    name: "FortunePig",
    image: "/assets/slot/fortunepig.webp",
    key: "JILI",
    gameCode: "JILI-SLOT-019",
    gameType: "SLOT",
    platFormCode: "JILI",
  },
  {
    name: "XiYangYang",
    image: "/assets/slot/xiyangyang.webp",
    key: "JILI",
    gameCode: "JILI-SLOT-018",
    gameType: "SLOT",
    platFormCode: "JILI",
  },
  {
    name: "Crazy FaFaFa",
    image: "/assets/slot/crazy-fafafa.webp",
    key: "JILI",
    gameCode: "JILI-SLOT-017",
    gameType: "SLOT",
    platFormCode: "JILI",
  },
  {
    name: "Bao boon chin",
    image: "/assets/slot/bao-boon-chin.webp",
    key: "JILI",
    gameCode: "JILI-SLOT-016",
    gameType: "SLOT",
    platFormCode: "JILI",
  },
  {
    name: "Bubble Beauty",
    image: "/assets/slot/bubble-beauty.webp",
    key: "JILI",
    gameCode: "JILI-SLOT-015",
    gameType: "SLOT",
    platFormCode: "JILI",
  },
  {
    name: "SevenSevenSeven",
    image: "/assets/slot/sevensevenseven.webp",
    key: "JILI",
    gameCode: "JILI-SLOT-013",
    gameType: "SLOT",
    platFormCode: "JILI",
  },
  {
    name: "God Of Martial",
    image: "/assets/slot/god-of-martial.webp",
    key: "JILI",
    gameCode: "JILI-SLOT-010",
    gameType: "SLOT",
    platFormCode: "JILI",
  },
  {
    name: "Fa Fa Fa",
    image: "/assets/slot/fa-fa-fa.webp",
    key: "JILI",
    gameCode: "JILI-SLOT-009",
    gameType: "SLOT",
    platFormCode: "JILI",
  },
  {
    name: "Shanghai Beauty",
    image: "/assets/slot/shanghai-beauty.webp",
    key: "JILI",
    gameCode: "JILI-SLOT-008",
    gameType: "SLOT",
    platFormCode: "JILI",
  },
  {
    name: "War Of Dragons",
    image: "/assets/slot/war-of-dragons.webp",
    key: "JILI",
    gameCode: "JILI-SLOT-004",
    gameType: "SLOT",
    platFormCode: "JILI",
  },
  {
    name: "Chin Shi Huang",
    image: "/assets/slot/chin-shi-huang.webp",
    key: "JILI",
    gameCode: "JILI-SLOT-003",
    gameType: "SLOT",
    platFormCode: "JILI",
  },
  {
    name: "Gem Party",
    image: "/assets/slot/gem-party.webp",
    key: "JILI",
  },
  {
    name: "TWIN WINS",
    image: "/assets/slot/twin-wins.webp",
    key: "JILI",
    gameCode: "JILI-SLOT-047",
    gameType: "SLOT",
    platFormCode: "JILI",
  },
  {
    name: "Gates of Olympus 1000",
    image: "/assets/slot/gates-of-olympus-1000.webp",
    key: "PP",
    gameCode: "PP-SLOT-411",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Book of Golden Sands",
    image: "/assets/slot/book-of-golden-sands.webp",
    key: "PP",
    gameCode: "PP-SLOT-288",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Candy Stars",
    image: "/assets/slot/candy-stars.webp",
    key: "PP",
    gameCode: "PP-SLOT-281",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Fortune of Olympus",
    image: "/assets/slot/fortune-of-olympus.webp",
    key: "PP",
  },
  {
    name: "Starlight Archer 1000",
    image: "/assets/slot/starlight-archer-1000.webp",
    key: "PP",
    gameCode: "PP-SLOT-658",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Gates of Gatot Kaca Super Scatter",
    image: "/assets/slot/gates-of-gatot-kaca-super-scatter.webp",
    key: "PP",
    gameCode: "PP-SLOT-663",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Sweet Rush Bonanza",
    image: "/assets/slot/sweet-rush-bonanza.webp",
    key: "PP",
    gameCode: "PP-SLOT-601",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Gates of Pyroth",
    image: "/assets/slot/gates-of-pyroth.webp",
    key: "PP",
  },
  {
    name: "Big Bass Splash 1000",
    image: "/assets/slot/big-bass-splash-1000.webp",
    key: "PP",
    gameCode: "PP-SLOT-654",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Hammerstorm",
    image: "/assets/slot/hammerstorm.webp",
    key: "PP",
  },
  {
    name: "Sweet Bonanza Super Scatter",
    image: "/assets/slot/sweet-bonanza-super-scatter.webp",
    key: "PP",
    gameCode: "PP-SLOT-586",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Zombie School Megaways",
    image: "/assets/slot/zombie-school-megaways.webp",
    key: "PP",
    gameCode: "PP-SLOT-590",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Super Gummy Strike",
    image: "/assets/slot/super-gummy-strike.webp",
    key: "PP",
    gameCode: "PP-SLOT-659",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Fortune Ace Super Scatter",
    image: "/assets/slot/fortune-ace-super-scatter.webp",
    key: "PP",
    gameCode: "PP-SLOT-598",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Big Bass Christmas - Frozen Lake",
    image: "/assets/slot/big-bass-christmas-frozen-lake.webp",
    key: "PP",
    gameCode: "PP-SLOT-612",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Fire Stampede 2",
    image: "/assets/slot/fire-stampede-2.webp",
    key: "PP",
    gameCode: "PP-SLOT-591",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Duel of Night & Day",
    image: "/assets/slot/duel-of-night-day.webp",
    key: "PP",
    gameCode: "PP-SLOT-656",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Big Bass Halloween 3",
    image: "/assets/slot/big-bass-halloween-3.webp",
    key: "PP",
    gameCode: "PP-SLOT-603",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Sweet Craze",
    image: "/assets/slot/sweet-craze.webp",
    key: "PP",
  },
  {
    name: "Spellmaster",
    image: "/assets/slot/spellmaster.webp",
    key: "PP",
    gameCode: "PP-SLOT-589",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Oracle of Gold",
    image: "/assets/slot/oracle-of-gold.webp",
    key: "PP",
    gameCode: "PP-SLOT-611",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Wild Wild Riches Returns",
    image: "/assets/slot/wild-wild-riches-returns.webp",
    key: "PP",
    gameCode: "PP-SLOT-655",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Bigger Barn House Bonanza",
    image: "/assets/slot/bigger-barn-house-bonanza.webp",
    key: "PP",
    gameCode: "PP-SLOT-599",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Big Bass Reel Repeat",
    image: "/assets/slot/big-bass-reel-repeat.webp",
    key: "PP",
    gameCode: "PP-SLOT-585",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Mermaid's Treasure Trove",
    image: "/assets/slot/mermaid-s-treasure-trove.webp",
    key: "PP",
    gameCode: "PP-SLOT-602",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Bloody Dawn",
    image: "/assets/slot/bloody-dawn.webp",
    key: "PP",
  },
  {
    name: "Bee Keeper",
    image: "/assets/slot/bee-keeper.webp",
    key: "PP",
    gameCode: "PP-SLOT-596",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Bingo Mania",
    image: "/assets/slot/bingo-mania.webp",
    key: "PP",
    gameCode: "PP-SLOT-607",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Frightening Frankie",
    image: "/assets/slot/frightening-frankie.webp",
    key: "PP",
    gameCode: "PP-SLOT-608",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Jackpot Blaze",
    image: "/assets/slot/jackpot-blaze.webp",
    key: "PP",
    gameCode: "PP-SLOT-592",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Captain Kraken Megaways",
    image: "/assets/slot/captain-kraken-megaways.webp",
    key: "PP",
    gameCode: "PP-SLOT-594",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Lobster House",
    image: "/assets/slot/lobster-house.webp",
    key: "PP",
    gameCode: "PP-SLOT-595",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Santa's Slay",
    image: "/assets/slot/santa-s-slay.webp",
    key: "PP",
  },
  {
    name: "Genie's Gem Bonanza",
    image: "/assets/slot/genie-s-gem-bonanza.webp",
    key: "PP",
    gameCode: "PP-SLOT-593",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Hundreds and Thousands",
    image: "/assets/slot/hundreds-and-thousands.webp",
    key: "PP",
    gameCode: "PP-SLOT-600",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Ice Mints",
    image: "/assets/slot/ice-mints.webp",
    key: "PP",
    gameCode: "PP-SLOT-588",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Wolf Gold 4 Pack",
    image: "/assets/slot/wolf-gold-4-pack.webp",
    key: "PP",
    gameCode: "PP-SLOT-584",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Super Tiki Strike",
    image: "/assets/slot/super-tiki-strike.webp",
    key: "PP",
  },
  {
    name: "Cyberheist City",
    image: "/assets/slot/cyberheist-city.webp",
    key: "PP",
  },
  {
    name: "Zeus vs Hades – Gods of War 250",
    image: "/assets/slot/zeus-vs-hades-gods-of-war-250.webp",
    key: "PP",
  },
  {
    name: "Emerald King – Wheel of Wealth  (Reel Kingdom)",
    image: "/assets/slot/emerald-king-wheel-of-wealth-reel-kingdom.webp",
    key: "PP",
  },
  {
    name: "Treasures of Osiris",
    image: "/assets/slot/treasures-of-osiris.webp",
    key: "PP",
  },
  {
    name: "Mummy's Jewels 100",
    image: "/assets/slot/mummy-s-jewels-100.webp",
    key: "PP",
  },
  {
    name: "Rolling in Treasures",
    image: "/assets/slot/rolling-in-treasures.webp",
    key: "PP",
  },
  {
    name: "Haunted Crypt",
    image: "/assets/slot/haunted-crypt.webp",
    key: "PP",
  },
  {
    name: "Wild Skullz",
    image: "/assets/slot/wild-skullz.webp",
    key: "PP",
  },
  {
    name: "Big Bass Raceday Repeat (Reel Kingdom)",
    image: "/assets/slot/big-bass-raceday-repeat-reel-kingdom.webp",
    key: "PP",
  },
  {
    name: "Lucky's Wild Pub 2",
    image: "/assets/slot/lucky-s-wild-pub-2.webp",
    key: "PP",
  },
  {
    name: "CULT.",
    image: "/assets/slot/cult.webp",
    key: "PP",
  },
  {
    name: "Steamin’ Reels",
    image: "/assets/slot/steamin-reels.webp",
    key: "PP",
  },
  {
    name: "Furry Bonanza Megaways™",
    image: "/assets/slot/furry-bonanza-megaways.webp",
    key: "PP",
  },
  {
    name: "Triple Pot Diamond",
    image: "/assets/slot/triple-pot-diamond.webp",
    key: "PP",
  },
  {
    name: "Idol Pop Fever",
    image: "/assets/slot/idol-pop-fever.webp",
    key: "PP",
  },
  {
    name: "Jelly Express",
    image: "/assets/slot/jelly-express.webp",
    key: "PP",
  },
  {
    name: "Inca Queen",
    image: "/assets/slot/inca-queen.webp",
    key: "PP",
  },
  {
    name: "Snow Party",
    image: "/assets/slot/snow-party.webp",
    key: "PP",
  },
  {
    name: "Cyber Pup Megaways",
    image: "/assets/slot/cyber-pup-megaways.webp",
    key: "PP",
  },
  {
    name: "Big Bass Trophy Catch",
    image: "/assets/slot/big-bass-trophy-catch.webp",
    key: "PP",
  },
  {
    name: "Dragon Pots Megaways",
    image: "/assets/slot/dragon-pots-megaways.webp",
    key: "PP",
  },
  {
    name: "Great Ghosts",
    image: "/assets/slot/great-ghosts.webp",
    key: "PP",
  },
  {
    name: "Sweet Bonanza 2500",
    image: "/assets/slot/sweet-bonanza-2500.webp",
    key: "PP",
  },
  {
    name: "Mr Null's Wicked Wares",
    image: "/assets/slot/mr-null-s-wicked-wares.webp",
    key: "PP",
  },
  {
    name: "Launch to Riches",
    image: "/assets/slot/launch-to-riches.webp",
    key: "PP",
  },
  {
    name: "Heartbreakers",
    image: "/assets/slot/heartbreakers.webp",
    key: "PP",
  },
  {
    name: "Triple Pot Plinko – Hercules",
    image: "/assets/slot/triple-pot-plinko-hercules.webp",
    key: "PP",
  },
  {
    name: "Dragon's Gate-Bonus Choice",
    image: "/assets/slot/dragon-s-gate-bonus-choice.webp",
    key: "PP",
  },
  {
    name: "The Big Dog House",
    image: "/assets/slot/the-big-dog-house.webp",
    key: "PP",
  },
  {
    name: "Candy Rush",
    image: "/assets/slot/candy-rush.webp",
    key: "PP",
  },
  {
    name: "Sanatorium Secrets",
    image: "/assets/slot/sanatorium-secrets.webp",
    key: "PP",
  },
  {
    name: "Joker's Revenge",
    image: "/assets/slot/joker-s-revenge.webp",
    key: "PP",
  },
  {
    name: "Mahjong Wins Triple Pot",
    image: "/assets/slot/mahjong-wins-triple-pot.webp",
    key: "PP",
  },
  {
    name: "Bear Crazy",
    image: "/assets/slot/bear-crazy.webp",
    key: "PP",
  },
  {
    name: "Better Barn House Bonanza",
    image: "/assets/slot/better-barn-house-bonanza.webp",
    key: "PP",
  },
  {
    name: "Fury of Anubis",
    image: "/assets/slot/fury-of-anubis.webp",
    key: "PP",
  },
  {
    name: "Hell Butcher",
    image: "/assets/slot/hell-butcher.webp",
    key: "PP",
  },
  {
    name: "Big Bass Blast",
    image: "/assets/slot/big-bass-blast.webp",
    key: "PP",
  },
  {
    name: "Out of the Woods",
    image: "/assets/slot/out-of-the-woods.webp",
    key: "PP",
  },
  {
    name: "Cosmic Clusters",
    image: "/assets/slot/cosmic-clusters.webp",
    key: "PP",
  },
  {
    name: "Sleeping Dragon Ultra Dark",
    image: "/assets/slot/sleeping-dragon-ultra-dark.webp",
    key: "PP",
  },
  {
    name: "Sunnydaze Asylum",
    image: "/assets/slot/sunnydaze-asylum.webp",
    key: "PP",
  },
  {
    name: "Death Dominion",
    image: "/assets/slot/death-dominion.webp",
    key: "PP",
  },
  {
    name: "Super Serge",
    image: "/assets/slot/super-serge.webp",
    key: "PP",
  },
  {
    name: "777 Wheel Blitz",
    image: "/assets/slot/777-wheel-blitz.webp",
    key: "PP",
  },
  {
    name: "Harvest Moon-Grave Profits",
    image: "/assets/slot/harvest-moon-grave-profits.webp",
    key: "PP",
  },
  {
    name: "Golden Retriever",
    image: "/assets/slot/golden-retriever.webp",
    key: "PP",
  },
  {
    name: "Bubble Up",
    image: "/assets/slot/bubble-up.webp",
    key: "PP",
  },
  {
    name: "Eastern Fury",
    image: "/assets/slot/eastern-fury.webp",
    key: "PP",
  },
  {
    name: "Hearts of Venus",
    image: "/assets/slot/hearts-of-venus.webp",
    key: "PP",
  },
  {
    name: "Ra vs Osiris",
    image: "/assets/slot/ra-vs-osiris.webp",
    key: "PP",
  },
  {
    name: "Lucky Drums 88",
    image: "/assets/slot/lucky-drums-88.webp",
    key: "PP",
  },
  {
    name: "Eternal Diamonds",
    image: "/assets/slot/eternal-diamonds.webp",
    key: "PP",
  },
  {
    name: "5 Lions Megaways 2",
    image: "/assets/slot/5-lions-megaways-2.webp",
    key: "PP",
  },
  {
    name: "Wild West Gold Blazing Bounty",
    image: "/assets/slot/wild-west-gold-blazing-bounty.webp",
    key: "PP",
    gameCode: "PP-SLOT-576",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Gates of Hades",
    image: "/assets/slot/gates-of-hades.webp",
    key: "PP",
    gameCode: "PP-SLOT-569",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Peppe's Pepperoni Pizza Plaza",
    image: "/assets/slot/peppe-s-pepperoni-pizza-plaza.webp",
    key: "PP",
  },
  {
    name: "Club Tropicana - Happy Hour",
    image: "/assets/slot/club-tropicana-happy-hour.webp",
    key: "PP",
    gameCode: "PP-SLOT-579",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Finger Lick'n Free Spins",
    image: "/assets/slot/finger-lick-n-free-spins.webp",
    key: "PP",
    gameCode: "PP-SLOT-575",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Bigger Bass Splash",
    image: "/assets/slot/bigger-bass-splash.webp",
    key: "PP",
    gameCode: "PP-SLOT-543",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Aztec Gems Megaways",
    image: "/assets/slot/aztec-gems-megaways.webp",
    key: "PP",
    gameCode: "PP-SLOT-535",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Mummy's Jewels",
    image: "/assets/slot/mummy-s-jewels.webp",
    key: "PP",
    gameCode: "PP-SLOT-571",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Gold Party 2 - After Hours",
    image: "/assets/slot/gold-party-2-after-hours.webp",
    key: "PP",
    gameCode: "PP-SLOT-574",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Chilli Heat Spicy Spins",
    image: "/assets/slot/chilli-heat-spicy-spins.webp",
    key: "PP",
    gameCode: "PP-SLOT-582",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Big Bass Return to the Races",
    image: "/assets/slot/big-bass-return-to-the-races.webp",
    key: "PP",
    gameCode: "PP-SLOT-544",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Brick House Bonanza",
    image: "/assets/slot/brick-house-bonanza.webp",
    key: "PP",
    gameCode: "PP-SLOT-534",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Floating Dragon - Year of the Snake",
    image: "/assets/slot/floating-dragon-year-of-the-snake.webp",
    key: "PP",
    gameCode: "PP-SLOT-533",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Majestic Express - Gold Run",
    image: "/assets/slot/majestic-express-gold-run.webp",
    key: "PP",
    gameCode: "PP-SLOT-568",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Volcano Goddess",
    image: "/assets/slot/volcano-goddess.webp",
    key: "PP",
    gameCode: "PP-SLOT-551",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Alien Invaders",
    image: "/assets/slot/alien-invaders.webp",
    key: "PP",
    gameCode: "PP-SLOT-580",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Greedy Fortune Pig",
    image: "/assets/slot/greedy-fortune-pig.webp",
    key: "PP",
    gameCode: "PP-SLOT-547",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Raging Waterfall Megaways",
    image: "/assets/slot/raging-waterfall-megaways.webp",
    key: "PP",
    gameCode: "PP-SLOT-548",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Savannah Legend",
    image: "/assets/slot/savannah-legend.webp",
    key: "PP",
    gameCode: "PP-SLOT-542",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Candy Corner",
    image: "/assets/slot/candy-corner.webp",
    key: "PP",
    gameCode: "PP-SLOT-508",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Gem Trio",
    image: "/assets/slot/gem-trio.webp",
    key: "PP",
    gameCode: "PP-SLOT-583",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Ancient Island Megaways",
    image: "/assets/slot/ancient-island-megaways.webp",
    key: "PP",
    gameCode: "PP-SLOT-540",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "You Can Piggy Bank On It",
    image: "/assets/slot/you-can-piggy-bank-on-it.webp",
    key: "PP",
    gameCode: "PP-SLOT-581",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Temple Guardians",
    image: "/assets/slot/temple-guardians.webp",
    key: "PP",
    gameCode: "PP-SLOT-573",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "John Hunter and Galileo's Secrets",
    image: "/assets/slot/john-hunter-and-galileo-s-secrets.webp",
    key: "PP",
  },
  {
    name: "Fonzo's Feline Fortunes",
    image: "/assets/slot/fonzo-s-feline-fortunes.webp",
    key: "PP",
  },
  {
    name: "7 Clovers of Fortune",
    image: "/assets/slot/7-clovers-of-fortune.webp",
    key: "PP",
    gameCode: "PP-SLOT-507",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Release the Kraken Megaways",
    image: "/assets/slot/release-the-kraken-megaways.webp",
    key: "PP",
    gameCode: "PP-SLOT-503",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Starlight Princess Super Scatter",
    image: "/assets/slot/starlight-princess-super-scatter.webp",
    key: "PP",
    gameCode: "PP-SLOT-610",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Gates of Olympus Super Scatter",
    image: "/assets/slot/gates-of-olympus-super-scatter.webp",
    key: "PP",
    gameCode: "PP-SLOT-562",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Wisdom of Athena 1000 Xmas",
    image: "/assets/slot/wisdom-of-athena-1000-xmas.webp",
    key: "PP",
    gameCode: "PP-SLOT-662",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Mahjong Wins 2",
    image: "/assets/slot/mahjong-wins-2.webp",
    key: "PP",
  },
  {
    name: "Anaconda Gold",
    image: "/assets/slot/anaconda-gold.webp",
    key: "PP",
  },
  {
    name: "Power of Merlin Megaways",
    image: "/assets/slot/power-of-merlin-megaways.webp",
    key: "PP",
    gameCode: "PP-SLOT-362",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Vampy Party",
    image: "/assets/slot/vampy-party.webp",
    key: "PP",
    gameCode: "PP-SLOT-505",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Wisdom of Athena 1000",
    image: "/assets/slot/wisdom-of-athena-1000.webp",
    key: "PP",
    gameCode: "PP-SLOT-499",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Gates of Olympus Xmas 1000",
    image: "/assets/slot/gates-of-olympus-xmas-1000.webp",
    key: "PP",
    gameCode: "PP-SLOT-524",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Triple Pot Gold",
    image: "/assets/slot/triple-pot-gold.webp",
    key: "PP",
    gameCode: "PP-SLOT-553",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Anime Mecha Megaways",
    image: "/assets/slot/anime-mecha-megaways.webp",
    key: "PP",
  },
  {
    name: "Zeus vs Typhon",
    image: "/assets/slot/zeus-vs-typhon.webp",
    key: "PP",
    gameCode: "PP-SLOT-661",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Big Bass Bonanza 1000",
    image: "/assets/slot/big-bass-bonanza-1000.webp",
    key: "PP",
    gameCode: "PP-SLOT-560",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "5 Lions Reborn",
    image: "/assets/slot/5-lions-reborn.webp",
    key: "PP",
    gameCode: "PP-SLOT-559",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Sugar Rush Xmas",
    image: "/assets/slot/sugar-rush-xmas.webp",
    key: "PP",
    gameCode: "PP-SLOT-403",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Mahjong Wins Super Scatter",
    image: "/assets/slot/mahjong-wins-super-scatter.webp",
    key: "PP",
  },
  {
    name: "Wisdom of Athena",
    image: "/assets/slot/wisdom-of-athena.webp",
    key: "PP",
    gameCode: "PP-SLOT-354",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Chests of Cai Shen",
    image: "/assets/slot/chests-of-cai-shen.webp",
    key: "PP",
    gameCode: "PP-SLOT-502",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Sweet Bonanza Dice",
    image: "/assets/slot/sweet-bonanza-dice.webp",
    key: "PP",
    gameCode: "PP-SLOT-388",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Mustang Gold Megaways",
    image: "/assets/slot/mustang-gold-megaways.webp",
    key: "PP",
    gameCode: "PP-SLOT-492",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Big Bass Halloween",
    image: "/assets/slot/big-bass-halloween.webp",
    key: "PP",
    gameCode: "PP-SLOT-389",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Big Bass Boxing Bonus Round",
    image: "/assets/slot/big-bass-boxing-bonus-round.webp",
    key: "PP",
    gameCode: "PP-SLOT-572",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "American Blackjack",
    image: "/assets/slot/american-blackjack.webp",
    key: "PP",
    gameCode: "PP-TABLE-004",
    gameType: "TABLE",
    platFormCode: "PP",
  },
  {
    name: "Pandemic Rising",
    image: "/assets/slot/pandemic-rising.webp",
    key: "PP",
    gameCode: "PP-SLOT-609",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Resurrecting Riches",
    image: "/assets/slot/resurrecting-riches.webp",
    key: "PP",
    gameCode: "PP-SLOT-567",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Bandit Megaways",
    image: "/assets/slot/bandit-megaways.webp",
    key: "PP",
    gameCode: "PP-SLOT-556",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "3 Buzzing Wilds",
    image: "/assets/slot/3-buzzing-wilds.webp",
    key: "PP",
    gameCode: "PP-SLOT-365",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "The Dog House - Royal Hunt",
    image: "/assets/slot/the-dog-house-royal-hunt.webp",
    key: "PP",
    gameCode: "PP-SLOT-552",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Big Bass Vegas Double Down Deluxe",
    image: "/assets/slot/big-bass-vegas-double-down-deluxe.webp",
    key: "PP",
    gameCode: "PP-SLOT-493",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Mining Rush",
    image: "/assets/slot/mining-rush.webp",
    key: "PP",
    gameCode: "PP-SLOT-530",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Money Roll",
    image: "/assets/slot/money-roll.webp",
    key: "PP",
    gameCode: "PP-SLOT-166",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Angel vs Sinner",
    image: "/assets/slot/angel-vs-sinner.webp",
    key: "PP",
    gameCode: "PP-SLOT-491",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Witch Heart Megaways",
    image: "/assets/slot/witch-heart-megaways.webp",
    key: "PP",
    gameCode: "PP-SLOT-563",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Bermuda Riches",
    image: "/assets/slot/bermuda-riches.webp",
    key: "PP",
  },
  {
    name: "The Dog House - Muttley Crew",
    image: "/assets/slot/the-dog-house-muttley-crew.webp",
    key: "PP",
    gameCode: "PP-SLOT-500",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Tic Tac Take",
    image: "/assets/slot/tic-tac-take.webp",
    key: "PP",
    gameCode: "PP-SLOT-248",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Bounty Hunter",
    image: "/assets/slot/bounty-hunter.webp",
    key: "PP",
    gameCode: "PP-SLOT-597",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "The Dog House Dice Show",
    image: "/assets/slot/the-dog-house-dice-show.webp",
    key: "PP",
    gameCode: "PP-SLOT-416",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "The Wild Gang",
    image: "/assets/slot/the-wild-gang.webp",
    key: "PP",
    gameCode: "PP-SLOT-422",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Waves of Poseidon",
    image: "/assets/slot/waves-of-poseidon.webp",
    key: "PP",
    gameCode: "PP-SLOT-578",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Sleeping Dragon",
    image: "/assets/slot/sleeping-dragon.webp",
    key: "PP",
    gameCode: "PP-SLOT-564",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Lucky's Wild Pub",
    image: "/assets/slot/lucky-s-wild-pub.webp",
    key: "PP",
    gameCode: "PP-SLOT-550",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Big Bass Christmas Bash",
    image: "/assets/slot/big-bass-christmas-bash.webp",
    key: "PP",
    gameCode: "PP-SLOT-401",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "5 Frozen Charms Megaways",
    image: "/assets/slot/5-frozen-charms-megaways.webp",
    key: "PP",
    gameCode: "PP-SLOT-418",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Tiny Toads",
    image: "/assets/slot/tiny-toads.webp",
    key: "PP",
    gameCode: "PP-SLOT-526",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Lava Balls",
    image: "/assets/slot/lava-balls.webp",
    key: "PP",
    gameCode: "PP-SLOT-606",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Fiesta Fortune",
    image: "/assets/slot/fiesta-fortune.webp",
    key: "PP",
    gameCode: "PP-SLOT-565",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Big Bass Bonanza 3 Reeler",
    image: "/assets/slot/big-bass-bonanza-3-reeler.webp",
    key: "PP",
    gameCode: "PP-SLOT-529",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Big Bass Halloween 2",
    image: "/assets/slot/big-bass-halloween-2.webp",
    key: "PP",
    gameCode: "PP-SLOT-504",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Mahjong X",
    image: "/assets/slot/mahjong-x.webp",
    key: "PP",
  },
  {
    name: "Big Bass Amazon Xtreme",
    image: "/assets/slot/big-bass-amazon-xtreme.webp",
    key: "PP",
    gameCode: "PP-SLOT-356",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Happy Fortune",
    image: "/assets/slot/happy-fortune.webp",
    key: "PP",
  },
  {
    name: "Eye of Spartacus",
    image: "/assets/slot/eye-of-spartacus.webp",
    key: "PP",
    gameCode: "PP-SLOT-570",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Joker's Jewels Cash",
    image: "/assets/slot/joker-s-jewels-cash.webp",
    key: "PP",
  },
  {
    name: "Dragon Gold 88",
    image: "/assets/slot/dragon-gold-88.webp",
    key: "PP",
    gameCode: "PP-SLOT-489",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Big Bass Xmas Xtreme",
    image: "/assets/slot/big-bass-xmas-xtreme.webp",
    key: "PP",
    gameCode: "PP-SLOT-521",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Fortune Ace",
    image: "/assets/slot/fortune-ace.webp",
    key: "PP",
    gameCode: "PP-SLOT-426",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Queenie",
    image: "/assets/slot/queenie.webp",
    key: "PP",
    gameCode: "PP-SLOT-249",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Multihand Blackjack",
    image: "/assets/slot/multihand-blackjack.webp",
    key: "PP",
    gameCode: "PP-TABLE-005",
    gameType: "TABLE",
    platFormCode: "PP",
  },
  {
    name: "Wild Wildebeest Wins",
    image: "/assets/slot/wild-wildebeest-wins.webp",
    key: "PP",
    gameCode: "PP-SLOT-538",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Wild Wild Joker",
    image: "/assets/slot/wild-wild-joker.webp",
    key: "PP",
    gameCode: "PP-SLOT-549",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Book of Monsters",
    image: "/assets/slot/book-of-monsters.webp",
    key: "PP",
    gameCode: "PP-SLOT-554",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Gem Fire Fortune",
    image: "/assets/slot/gem-fire-fortune.webp",
    key: "PP",
    gameCode: "PP-SLOT-577",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Himalayan Wild",
    image: "/assets/slot/himalayan-wild.webp",
    key: "PP",
    gameCode: "PP-SLOT-519",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Santa's Xmas Rush",
    image: "/assets/slot/santa-s-xmas-rush.webp",
    key: "PP",
    gameCode: "PP-SLOT-525",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Spellbinding Mystery",
    image: "/assets/slot/spellbinding-mystery.webp",
    key: "PP",
    gameCode: "PP-SLOT-363",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Wildies",
    image: "/assets/slot/wildies.webp",
    key: "PP",
    gameCode: "PP-SLOT-465",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Fangtastic Freespins",
    image: "/assets/slot/fangtastic-freespins.webp",
    key: "PP",
    gameCode: "PP-SLOT-506",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Argonauts",
    image: "/assets/slot/argonauts.webp",
    key: "PP",
    gameCode: "PP-SLOT-587",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Sweet Powernudge",
    image: "/assets/slot/sweet-powernudge.webp",
    key: "PP",
    gameCode: "PP-SLOT-310",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Might of Freya Megaways",
    image: "/assets/slot/might-of-freya-megaways.webp",
    key: "PP",
    gameCode: "PP-SLOT-522",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Rainbow Reels",
    image: "/assets/slot/rainbow-reels.webp",
    key: "PP",
    gameCode: "PP-SLOT-390",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "3 Kingdoms - Battle of Red Cliffs",
    image: "/assets/slot/3-kingdoms-battle-of-red-cliffs.webp",
    key: "PP",
    gameCode: "PP-SLOT-126",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Eternal Empress - Freeze Time",
    image: "/assets/slot/eternal-empress-freeze-time.webp",
    key: "PP",
    gameCode: "PP-SLOT-520",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Aztec Smash",
    image: "/assets/slot/aztec-smash.webp",
    key: "PP",
    gameCode: "PP-SLOT-531",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Aztec Treasure Hunt",
    image: "/assets/slot/aztec-treasure-hunt.webp",
    key: "PP",
    gameCode: "PP-SLOT-488",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Nile Fortune",
    image: "/assets/slot/nile-fortune.webp",
    key: "PP",
    gameCode: "PP-SLOT-402",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Diamonds are Forever 3 Lines",
    image: "/assets/slot/diamonds-are-forever-3-lines.webp",
    key: "PP",
    gameCode: "PP-SLOT-170",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Oodles of Noodles",
    image: "/assets/slot/oodles-of-noodles.webp",
    key: "PP",
    gameCode: "PP-SLOT-495",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Year Of The Dragon King",
    image: "/assets/slot/year-of-the-dragon-king.webp",
    key: "PP",
    gameCode: "PP-SLOT-406",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Fortune Hit'n Roll",
    image: "/assets/slot/fortune-hit-n-roll.webp",
    key: "PP",
  },
  {
    name: "Wolf Gold Ultimate",
    image: "/assets/slot/wolf-gold-ultimate.webp",
    key: "PP",
    gameCode: "PP-SLOT-518",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Money Stacks Megaways",
    image: "/assets/slot/money-stacks-megaways.webp",
    key: "PP",
    gameCode: "PP-SLOT-528",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Mystery Mice",
    image: "/assets/slot/mystery-mice.webp",
    key: "PP",
    gameCode: "PP-SLOT-496",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Blitz Super Wheel",
    image: "/assets/slot/blitz-super-wheel.webp",
    key: "PP",
    gameCode: "PP-SLOT-555",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Badge Blitz",
    image: "/assets/slot/badge-blitz.webp",
    key: "PP",
    gameCode: "PP-SLOT-497",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Congo Cash XL",
    image: "/assets/slot/congo-cash-xl.webp",
    key: "PP",
    gameCode: "PP-SLOT-494",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Fat Panda",
    image: "/assets/slot/fat-panda.webp",
    key: "PP",
    gameCode: "PP-SLOT-355",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Heroic Spins",
    image: "/assets/slot/heroic-spins.webp",
    key: "PP",
  },
  {
    name: "Wild Wild Pearls",
    image: "/assets/slot/wild-wild-pearls.webp",
    key: "PP",
    gameCode: "PP-SLOT-536",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Frozen Tropics",
    image: "/assets/slot/frozen-tropics.webp",
    key: "PP",
    gameCode: "PP-SLOT-377",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Cash Surge",
    image: "/assets/slot/cash-surge.webp",
    key: "PP",
    gameCode: "PP-SLOT-561",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Heist for the Golden Nuggets",
    image: "/assets/slot/heist-for-the-golden-nuggets.webp",
    key: "PP",
    gameCode: "PP-SLOT-357",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Dragon King Hot Pots",
    image: "/assets/slot/dragon-king-hot-pots.webp",
    key: "PP",
    gameCode: "PP-SLOT-527",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Irish Charms",
    image: "/assets/slot/irish-charms.webp",
    key: "PP",
    gameCode: "PP-SLOT-168",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Jumbo Safari",
    image: "/assets/slot/jumbo-safari.webp",
    key: "PP",
    gameCode: "PP-SLOT-566",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Hellvis Wild",
    image: "/assets/slot/hellvis-wild.webp",
    key: "PP",
    gameCode: "PP-SLOT-359",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Joker Race",
    image: "/assets/slot/joker-race.webp",
    key: "PP",
    gameCode: "PP-SLOT-358",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Escape the Pyramid - Fire & Ice",
    image: "/assets/slot/escape-the-pyramid-fire-ice.webp",
    key: "PP",
    gameCode: "PP-SLOT-539",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Moleionaire",
    image: "/assets/slot/moleionaire.webp",
    key: "PP",
    gameCode: "PP-SLOT-517",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Hot to Burn 7 Deadly Free Spins",
    image: "/assets/slot/hot-to-burn-7-deadly-free-spins.webp",
    key: "PP",
  },
  {
    name: "Ding Dong Christmas Bells",
    image: "/assets/slot/ding-dong-christmas-bells.webp",
    key: "PP",
    gameCode: "PP-SLOT-417",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Ride the Lightning",
    image: "/assets/slot/ride-the-lightning.webp",
    key: "PP",
    gameCode: "PP-SLOT-558",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Gold Oasis",
    image: "/assets/slot/gold-oasis.webp",
    key: "PP",
    gameCode: "PP-SLOT-378",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Irish Crown",
    image: "/assets/slot/irish-crown.webp",
    key: "PP",
    gameCode: "PP-SLOT-537",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Gem Elevator",
    image: "/assets/slot/gem-elevator.webp",
    key: "PP",
    gameCode: "PP-SLOT-490",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Penguins Christmas Party Time",
    image: "/assets/slot/penguins-christmas-party-time.webp",
    key: "PP",
    gameCode: "PP-SLOT-523",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Sugar Rush Super Scatter",
    image: "/assets/slot/sugar-rush-super-scatter.webp",
    key: "PP",
  },
  {
    name: "Floating Dragon Wild Horses",
    image: "/assets/slot/floating-dragon-wild-horses.webp",
    key: "PP",
  },
  {
    name: "Hot Tuna",
    image: "/assets/slot/hot-tuna.webp",
    key: "PP",
  },
  {
    name: "King of Spear",
    image: "/assets/slot/king-of-spear.webp",
    key: "PP",
  },
  {
    name: "Wheel of Happiness",
    image: "/assets/slot/wheel-of-happiness.webp",
    key: "PP",
  },
  {
    name: "Joker's Jewels Hold & Spin",
    image: "/assets/slot/joker-s-jewels-hold-spin.webp",
    key: "PP",
  },
  {
    name: "The Dog House Megaways 1000",
    image: "/assets/slot/the-dog-house-megaways-1000.webp",
    key: "PP",
  },
  {
    name: "Luxor of Cleopatra",
    image: "/assets/slot/luxor-of-cleopatra.webp",
    key: "PP",
  },
  {
    name: "Caishen's Cash Pots",
    image: "/assets/slot/caishen-s-cash-pots.webp",
    key: "PP",
  },
  {
    name: "Fire Stampede Ultimate",
    image: "/assets/slot/fire-stampede-ultimate.webp",
    key: "PP",
  },
  {
    name: "Big Bass Football Bonanza",
    image: "/assets/slot/big-bass-football-bonanza.webp",
    key: "PP",
  },
  {
    name: "3 Magic Eggs",
    image: "/assets/slot/3-magic-eggs.webp",
    key: "PP",
  },
  {
    name: "Dragon Tiger Fortunes",
    image: "/assets/slot/dragon-tiger-fortunes.webp",
    key: "PP",
  },
  {
    name: "Knights vs Barbarians",
    image: "/assets/slot/knights-vs-barbarians.webp",
    key: "PP",
  },
  {
    name: "Spire+",
    image: "/assets/slot/spire.webp",
    key: "PP",
    gameCode: "PP-EGAME-013",
    gameType: "EGAME",
    platFormCode: "PP",
  },
  {
    name: "Dark Overlord - Final Duel",
    image: "/assets/slot/dark-overlord-final-duel.webp",
    key: "PP",
  },
  {
    name: "Forging Wilds",
    image: "/assets/slot/forging-wilds.webp",
    key: "PP",
    gameCode: "PP-SLOT-486",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Jackpot Hunter",
    image: "/assets/slot/jackpot-hunter.webp",
    key: "PP",
    gameCode: "PP-SLOT-485",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Running Sushi",
    image: "/assets/slot/running-sushi.webp",
    key: "PP",
    gameCode: "PP-SLOT-483",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Yeti Quest",
    image: "/assets/slot/yeti-quest.webp",
    key: "PP",
    gameCode: "PP-SLOT-484",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Money Stacks",
    image: "/assets/slot/money-stacks.webp",
    key: "PP",
    gameCode: "PP-SLOT-482",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Bow of Artemis",
    image: "/assets/slot/bow-of-artemis.webp",
    key: "PP",
    gameCode: "PP-SLOT-481",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Sumo Supreme Megaways",
    image: "/assets/slot/sumo-supreme-megaways.webp",
    key: "PP",
    gameCode: "PP-SLOT-480",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Joker's Jewels Hot",
    image: "/assets/slot/joker-s-jewels-hot.webp",
    key: "PP",
    gameCode: "PP-SLOT-479",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Dynamite Diggin Doug",
    image: "/assets/slot/dynamite-diggin-doug.webp",
    key: "PP",
    gameCode: "PP-SLOT-478",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "6 Jokers",
    image: "/assets/slot/6-jokers.webp",
    key: "PP",
    gameCode: "PP-SLOT-477",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Wheel O'Gold",
    image: "/assets/slot/wheel-o-gold.webp",
    key: "PP",
    gameCode: "PP-SLOT-428",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Pompeii Megareels Megaways",
    image: "/assets/slot/pompeii-megareels-megaways.webp",
    key: "PP",
    gameCode: "PP-SLOT-429",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Great Lagoon",
    image: "/assets/slot/great-lagoon.webp",
    key: "PP",
    gameCode: "PP-SLOT-434",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Mighty Munching Melons",
    image: "/assets/slot/mighty-munching-melons.webp",
    key: "PP",
    gameCode: "PP-SLOT-432",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Strawberry Cocktail",
    image: "/assets/slot/strawberry-cocktail.webp",
    key: "PP",
    gameCode: "PP-SLOT-433",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Power of Ninja",
    image: "/assets/slot/power-of-ninja.webp",
    key: "PP",
    gameCode: "PP-SLOT-435",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Gates of Olympus Dice",
    image: "/assets/slot/gates-of-olympus-dice.webp",
    key: "PP",
    gameCode: "PP-SLOT-436",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Zombie Train",
    image: "/assets/slot/zombie-train.webp",
    key: "PP",
    gameCode: "PP-SLOT-437",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Cyber Heist",
    image: "/assets/slot/cyber-heist.webp",
    key: "PP",
  },
  {
    name: "Fire Portals",
    image: "/assets/slot/fire-portals.webp",
    key: "PP",
    gameCode: "PP-SLOT-444",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Medusa's Stone",
    image: "/assets/slot/medusa-s-stone.webp",
    key: "PP",
    gameCode: "PP-SLOT-468",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Devilicious",
    image: "/assets/slot/devilicious.webp",
    key: "PP",
    gameCode: "PP-SLOT-466",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Big Bass Bonanza - Reel Action",
    image: "/assets/slot/big-bass-bonanza-reel-action.webp",
    key: "PP",
    gameCode: "PP-SLOT-467",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Odds On Winner",
    image: "/assets/slot/odds-on-winner.webp",
    key: "PP",
    gameCode: "PP-SLOT-458",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Heart of Cleopatra",
    image: "/assets/slot/heart-of-cleopatra.webp",
    key: "PP",
    gameCode: "PP-SLOT-457",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Hot To Burn Multiplier",
    image: "/assets/slot/hot-to-burn-multiplier.webp",
    key: "PP",
    gameCode: "PP-SLOT-476",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Samurai Code",
    image: "/assets/slot/samurai-code.webp",
    key: "PP",
    gameCode: "PP-SLOT-475",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Crank it Up",
    image: "/assets/slot/crank-it-up.webp",
    key: "PP",
    gameCode: "PP-SLOT-474",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Sweet Kingdom",
    image: "/assets/slot/sweet-kingdom.webp",
    key: "PP",
    gameCode: "PP-SLOT-473",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Hand of Midas 2",
    image: "/assets/slot/hand-of-midas-2.webp",
    key: "PP",
    gameCode: "PP-SLOT-472",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Buffalo King Untamed Megaways",
    image: "/assets/slot/buffalo-king-untamed-megaways.webp",
    key: "PP",
    gameCode: "PP-SLOT-470",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Big Bass Mission Fishin'",
    image: "/assets/slot/big-bass-mission-fishin.webp",
    key: "PP",
  },
  {
    name: "Starlight Princess Pachi",
    image: "/assets/slot/starlight-princess-pachi.webp",
    key: "PP",
    gameCode: "PP-SLOT-463",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Revenge of Loki Megaways",
    image: "/assets/slot/revenge-of-loki-megaways.webp",
    key: "PP",
    gameCode: "PP-SLOT-462",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Fruity Treats",
    image: "/assets/slot/fruity-treats.webp",
    key: "PP",
    gameCode: "PP-SLOT-461",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Rise of Pyramids",
    image: "/assets/slot/rise-of-pyramids.webp",
    key: "PP",
    gameCode: "PP-SLOT-460",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Dwarf & Dragon",
    image: "/assets/slot/dwarf-dragon.webp",
    key: "PP",
    gameCode: "PP-SLOT-459",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Starlight Princess 1000",
    image: "/assets/slot/starlight-princess-1000.webp",
    key: "PP",
    gameCode: "PP-SLOT-364",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Sweet Bonanza 1000",
    image: "/assets/slot/sweet-bonanza-1000.webp",
    key: "PP",
    gameCode: "PP-SLOT-464",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Sugar Rush 1000",
    image: "/assets/slot/sugar-rush-1000.webp",
    key: "PP",
    gameCode: "PP-SLOT-443",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Lobster Bob's Sea Food and Win It",
    image: "/assets/slot/lobster-bob-s-sea-food-and-win-it.webp",
    key: "PP",
    gameCode: "PP-SLOT-456",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Joker's Jewels Wild",
    image: "/assets/slot/joker-s-jewels-wild.webp",
    key: "PP",
    gameCode: "PP-SLOT-454",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Wukong Rush",
    image: "/assets/slot/wukong-rush.webp",
    key: "PP",
  },
  {
    name: "Candy Blitz Bombs",
    image: "/assets/slot/candy-blitz-bombs.webp",
    key: "PP",
    gameCode: "PP-SLOT-453",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Big Burger Load it up with Xtra Cheese",
    image: "/assets/slot/big-burger-load-it-up-with-xtra-cheese.webp",
    key: "PP",
    gameCode: "PP-SLOT-448",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "The Dog House - Dog or Alive",
    image: "/assets/slot/the-dog-house-dog-or-alive.webp",
    key: "PP",
    gameCode: "PP-SLOT-445",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Aztec Powernudge",
    image: "/assets/slot/aztec-powernudge.webp",
    key: "PP",
    gameCode: "PP-SLOT-447",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Release the Bison",
    image: "/assets/slot/release-the-bison.webp",
    key: "PP",
    gameCode: "PP-SLOT-446",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Big Bass - Secrets of the Golden Lake",
    image: "/assets/slot/big-bass-secrets-of-the-golden-lake.webp",
    key: "PP",
  },
  {
    name: "Ripe Rewards",
    image: "/assets/slot/ripe-rewards.webp",
    key: "PP",
    gameCode: "PP-SLOT-449",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Ice Lobster",
    image: "/assets/slot/ice-lobster.webp",
    key: "PP",
    gameCode: "PP-SLOT-451",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Barnyard Megahays Megaways",
    image: "/assets/slot/barnyard-megahays-megaways.webp",
    key: "PP",
    gameCode: "PP-SLOT-452",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Gates of Gatot Kaca 1000",
    image: "/assets/slot/gates-of-gatot-kaca-1000.webp",
    key: "PP",
    gameCode: "PP-SLOT-439",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Gears of Horus",
    image: "/assets/slot/gears-of-horus.webp",
    key: "PP",
    gameCode: "PP-SLOT-438",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Casino Heist Megaways",
    image: "/assets/slot/casino-heist-megaways.webp",
    key: "PP",
  },
  {
    name: "Big Bass Day at the Races",
    image: "/assets/slot/big-bass-day-at-the-races.webp",
    key: "PP",
    gameCode: "PP-SLOT-441",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Beware The Deep Megaways",
    image: "/assets/slot/beware-the-deep-megaways.webp",
    key: "PP",
    gameCode: "PP-SLOT-440",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Rise of Samurai 4",
    image: "/assets/slot/rise-of-samurai-4.webp",
    key: "PP",
  },
  {
    name: "Pot of Fortune",
    image: "/assets/slot/pot-of-fortune.webp",
    key: "PP",
    gameCode: "PP-SLOT-442",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "The Alter Ego",
    image: "/assets/slot/the-alter-ego.webp",
    key: "PP",
    gameCode: "PP-SLOT-431",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Big Bass Floats my Boat",
    image: "/assets/slot/big-bass-floats-my-boat.webp",
    key: "PP",
    gameCode: "PP-SLOT-430",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Bali Dragon",
    image: "/assets/slot/bali-dragon.webp",
    key: "PP",
  },
  {
    name: "Trees of Treasure",
    image: "/assets/slot/trees-of-treasure.webp",
    key: "PP",
    gameCode: "PP-SLOT-425",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Blazing Wilds Megaways",
    image: "/assets/slot/blazing-wilds-megaways.webp",
    key: "PP",
    gameCode: "PP-SLOT-427",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Blade & Fangs",
    image: "/assets/slot/blade-fangs.webp",
    key: "PP",
    gameCode: "PP-SLOT-414",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Loki's Riches",
    image: "/assets/slot/loki-s-riches.webp",
    key: "PP",
    gameCode: "PP-SLOT-415",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Mahjong Wins Bonus",
    image: "/assets/slot/mahjong-wins-bonus.webp",
    key: "PP",
    gameCode: "PP-SLOT-413",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "The Big Dawgs",
    image: "/assets/slot/the-big-dawgs.webp",
    key: "PP",
    gameCode: "PP-SLOT-410",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Fortune Dragon",
    image: "/assets/slot/fortune-dragon.webp",
    key: "PP",
    gameCode: "PP-SLOT-409",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Juicy Fruits Multihold",
    image: "/assets/slot/juicy-fruits-multihold.webp",
    key: "PP",
    gameCode: "PP-SLOT-424",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Floating Dragon New Year Festival Ultra Megaways Hold & Spin",
    image:
      "/assets/slot/floating-dragon-new-year-festival-ultra-megaways-hold-spin.webp",
    key: "PP",
  },
  {
    name: "Castle of Fire",
    image: "/assets/slot/castle-of-fire.webp",
    key: "PP",
    gameCode: "PP-SLOT-408",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Good Luck & Good Fortune",
    image: "/assets/slot/good-luck-good-fortune.webp",
    key: "PP",
    gameCode: "PP-SLOT-407",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Sea Fantasy",
    image: "/assets/slot/sea-fantasy.webp",
    key: "PP",
    gameCode: "PP-SLOT-419",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Fire Stampede",
    image: "/assets/slot/fire-stampede.webp",
    key: "PP",
    gameCode: "PP-SLOT-420",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Candy Jar Clusters",
    image: "/assets/slot/candy-jar-clusters.webp",
    key: "PP",
    gameCode: "PP-SLOT-421",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Timber Stacks",
    image: "/assets/slot/timber-stacks.webp",
    key: "PP",
    gameCode: "PP-SLOT-400",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Chase For Glory",
    image: "/assets/slot/chase-for-glory.webp",
    key: "PP",
    gameCode: "PP-SLOT-399",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Joker's Jewel Dice",
    image: "/assets/slot/joker-s-jewel-dice.webp",
    key: "PP",
  },
  {
    name: "Rujak Bonanza",
    image: "/assets/slot/rujak-bonanza.webp",
    key: "PP",
    gameCode: "PP-SLOT-395",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Viking Forge",
    image: "/assets/slot/viking-forge.webp",
    key: "PP",
    gameCode: "PP-SLOT-396",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Sugar Supreme Powernudge",
    image: "/assets/slot/sugar-supreme-powernudge.webp",
    key: "PP",
    gameCode: "PP-SLOT-397",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Grace of Ebisu",
    image: "/assets/slot/grace-of-ebisu.webp",
    key: "PP",
  },
  {
    name: "Twilight Princess",
    image: "/assets/slot/twilight-princess.webp",
    key: "PP",
    gameCode: "PP-SLOT-394",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Demon Pots",
    image: "/assets/slot/demon-pots.webp",
    key: "PP",
    gameCode: "PP-SLOT-393",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "The Money Men Megaways",
    image: "/assets/slot/the-money-men-megaways.webp",
    key: "PP",
    gameCode: "PP-SLOT-392",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "888 Bonanza",
    image: "/assets/slot/888-bonanza.webp",
    key: "PP",
    gameCode: "PP-SLOT-391",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Tundra's Fortune",
    image: "/assets/slot/tundra-s-fortune.webp",
    key: "PP",
    gameCode: "PP-SLOT-386",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Gemstone",
    image: "/assets/slot/gemstone.webp",
    key: "PP",
  },
  {
    name: "Cash Chips",
    image: "/assets/slot/cash-chips.webp",
    key: "PP",
    gameCode: "PP-SLOT-387",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Gravity Bonanza",
    image: "/assets/slot/gravity-bonanza.webp",
    key: "PP",
    gameCode: "PP-SLOT-385",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Infective Wild",
    image: "/assets/slot/infective-wild.webp",
    key: "PP",
    gameCode: "PP-SLOT-384",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Fortunes of Aztec",
    image: "/assets/slot/fortunes-of-aztec.webp",
    key: "PP",
    gameCode: "PP-SLOT-382",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Candy Blitz",
    image: "/assets/slot/candy-blitz.webp",
    key: "PP",
    gameCode: "PP-SLOT-381",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Book of Tut Megaways",
    image: "/assets/slot/book-of-tut-megaways.webp",
    key: "PP",
    gameCode: "PP-SLOT-380",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "8 Golden Dragon Challenge",
    image: "/assets/slot/8-golden-dragon-challenge.webp",
    key: "PP",
    gameCode: "PP-SLOT-379",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Saiyan Mania",
    image: "/assets/slot/saiyan-mania.webp",
    key: "PP",
  },
  {
    name: "Cyclops Smash",
    image: "/assets/slot/cyclops-smash.webp",
    key: "PP",
    gameCode: "PP-SLOT-375",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Big Bass Hold & Spinner Megaways",
    image: "/assets/slot/big-bass-hold-spinner-megaways.webp",
    key: "PP",
    gameCode: "PP-SLOT-376",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Forge of Olympus",
    image: "/assets/slot/forge-of-olympus.webp",
    key: "PP",
    gameCode: "PP-SLOT-373",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Mahjong Wins",
    image: "/assets/slot/mahjong-wins.webp",
    key: "PP",
    gameCode: "PP-SLOT-372",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Piggy Bankers",
    image: "/assets/slot/piggy-bankers.webp",
    key: "PP",
    gameCode: "PP-SLOT-370",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Pub Kings",
    image: "/assets/slot/pub-kings.webp",
    key: "PP",
    gameCode: "PP-SLOT-371",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Rocket Blast Megaways",
    image: "/assets/slot/rocket-blast-megaways.webp",
    key: "PP",
    gameCode: "PP-SLOT-369",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Mustang Trail",
    image: "/assets/slot/mustang-trail.webp",
    key: "PP",
    gameCode: "PP-SLOT-368",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Diamond Cascade",
    image: "/assets/slot/diamond-cascade.webp",
    key: "PP",
    gameCode: "PP-SLOT-367",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Lobster Bob's Crazy Crab Shack",
    image: "/assets/slot/lobster-bob-s-crazy-crab-shack.webp",
    key: "PP",
    gameCode: "PP-SLOT-366",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Supermania",
    image: "/assets/slot/supermania.webp",
    key: "PP",
  },
  {
    name: "Sky Bounty",
    image: "/assets/slot/sky-bounty.webp",
    key: "PP",
  },
  {
    name: "Cash Box",
    image: "/assets/slot/cash-box.webp",
    key: "PP",
    gameCode: "PP-SLOT-360",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Pirates Pub",
    image: "/assets/slot/pirates-pub.webp",
    key: "PP",
    gameCode: "PP-SLOT-352",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Jewel Rush",
    image: "/assets/slot/jewel-rush.webp",
    key: "PP",
    gameCode: "PP-SLOT-353",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Snakes & Ladders - Snake Eyes",
    image: "/assets/slot/snakes-ladders-snake-eyes.webp",
    key: "PP",
    gameCode: "PP-SLOT-285",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Book of Aztec King",
    image: "/assets/slot/book-of-aztec-king.webp",
    key: "PP",
    gameCode: "PP-SLOT-241",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Disco Lady",
    image: "/assets/slot/disco-lady.webp",
    key: "PP",
    gameCode: "PP-SLOT-247",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Chicken Chase",
    image: "/assets/slot/chicken-chase.webp",
    key: "PP",
    gameCode: "PP-SLOT-237",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Bull Fiesta",
    image: "/assets/slot/bull-fiesta.webp",
    key: "PP",
    gameCode: "PP-SLOT-242",
    gameType: "SLOT",
    platFormCode: "PP",
  },
  {
    name: "Chocolate Deluxe",
    image: "/assets/slot/chocolate-deluxe.webp",
    key: "PG",
    gameCode: "PG-SLOT-149",
    gameType: "SLOT",
    platFormCode: "PG",
  },
  {
    name: "Honey Trap of Diao Chan",
    image: "/assets/slot/honey-trap-of-diao-chan.webp",
    key: "PG",
    gameCode: "PG-SLOT-001",
    gameType: "SLOT",
    platFormCode: "PG",
  },
  {
    name: "Candy Bonanza",
    image: "/assets/slot/candy-bonanza.webp",
    key: "PG",
    gameCode: "PG-SLOT-074",
    gameType: "SLOT",
    platFormCode: "PG",
  },
  {
    name: "Rise of Apollo",
    image: "/assets/slot/rise-of-apollo.webp",
    key: "PG",
  },
  {
    name: "Mermaid Riches",
    image: "/assets/slot/mermaid-riches.webp",
    key: "PG",
    gameCode: "PG-SLOT-081",
    gameType: "SLOT",
    platFormCode: "PG",
  },
  {
    name: "Crypto Gold",
    image: "/assets/slot/crypto-gold.webp",
    key: "PG",
    gameCode: "PG-SLOT-072",
    gameType: "SLOT",
    platFormCode: "PG",
  },
  {
    name: "Wild Bandito",
    image: "/assets/slot/wild-bandito.webp",
    key: "PG",
    gameCode: "PG-SLOT-075",
    gameType: "SLOT",
    platFormCode: "PG",
  },
  {
    name: "Heist Stakes",
    image: "/assets/slot/heist-stakes.webp",
    key: "PG",
    gameCode: "PG-SLOT-077",
    gameType: "SLOT",
    platFormCode: "PG",
  },
  {
    name: "Ways of the Qilin",
    image: "/assets/slot/ways-of-the-qilin.webp",
    key: "PG",
    gameCode: "PG-SLOT-076",
    gameType: "SLOT",
    platFormCode: "PG",
  },
  {
    name: "Legendary Monkey King",
    image: "/assets/slot/legendary-monkey-king.webp",
    key: "PG",
    gameCode: "PG-SLOT-086",
    gameType: "SLOT",
    platFormCode: "PG",
  },
  {
    name: "Buffalo Win",
    image: "/assets/slot/buffalo-win.webp",
    key: "PG",
    gameCode: "PG-SLOT-085",
    gameType: "SLOT",
    platFormCode: "PG",
  },
  {
    name: "Jurassic Kingdom",
    image: "/assets/slot/jurassic-kingdom.webp",
    key: "PG",
    gameCode: "PG-SLOT-079",
    gameType: "SLOT",
    platFormCode: "PG",
  },
  {
    name: "Oriental Prosperity",
    image: "/assets/slot/oriental-prosperity.webp",
    key: "PG",
    gameCode: "PG-SLOT-092",
    gameType: "SLOT",
    platFormCode: "PG",
  },
  {
    name: "Raider Jane's Crypt of Fortune",
    image: "/assets/slot/raider-jane-s-crypt-of-fortune.webp",
    key: "PG",
    gameCode: "PG-SLOT-083",
    gameType: "SLOT",
    platFormCode: "PG",
  },
  {
    name: "Emoji Riches",
    image: "/assets/slot/emoji-riches.webp",
    key: "PG",
    gameCode: "PG-SLOT-089",
    gameType: "SLOT",
    platFormCode: "PG",
  },
  {
    name: "Supermarket Spree",
    image: "/assets/slot/supermarket-spree.webp",
    key: "PG",
    gameCode: "PG-SLOT-084",
    gameType: "SLOT",
    platFormCode: "PG",
  },
  {
    name: "Cocktail Nights",
    image: "/assets/slot/cocktail-nights.webp",
    key: "PG",
    gameCode: "PG-SLOT-090",
    gameType: "SLOT",
    platFormCode: "PG",
  },
  {
    name: "Mask Carnival",
    image: "/assets/slot/mask-carnival.webp",
    key: "PG",
    gameCode: "PG-SLOT-091",
    gameType: "SLOT",
    platFormCode: "PG",
  },
  {
    name: "Spirited Wonders",
    image: "/assets/slot/spirited-wonders.webp",
    key: "PG",
    gameCode: "PG-SLOT-087",
    gameType: "SLOT",
    platFormCode: "PG",
  },
  {
    name: "The Queen's Banquet",
    image: "/assets/slot/the-queen-s-banquet.webp",
    key: "PG",
    gameCode: "PG-SLOT-098",
    gameType: "SLOT",
    platFormCode: "PG",
  },
  {
    name: "Destiny of Sun & Moon",
    image: "/assets/slot/destiny-of-sun-moon.webp",
    key: "PG",
  },
  {
    name: "Garuda Gems",
    image: "/assets/slot/garuda-gems.webp",
    key: "PG",
    gameCode: "PG-SLOT-094",
    gameType: "SLOT",
    platFormCode: "PG",
  },
  {
    name: "Rooster Rumble",
    image: "/assets/slot/rooster-rumble.webp",
    key: "PG",
    gameCode: "PG-SLOT-097",
    gameType: "SLOT",
    platFormCode: "PG",
  },
  {
    name: "Battleground Royale",
    image: "/assets/slot/battleground-royale.webp",
    key: "PG",
    gameCode: "PG-SLOT-099",
    gameType: "SLOT",
    platFormCode: "PG",
  },
  {
    name: "Butterfly Blossom",
    image: "/assets/slot/butterfly-blossom.webp",
    key: "PG",
    gameCode: "PG-SLOT-096",
    gameType: "SLOT",
    platFormCode: "PG",
  },
  {
    name: "Fortune Tiger",
    image: "/assets/slot/fortune-tiger.webp",
    key: "PG",
    gameCode: "PG-SLOT-093",
    gameType: "SLOT",
    platFormCode: "PG",
  },
  {
    name: "Speed Winner",
    image: "/assets/slot/speed-winner.webp",
    key: "PG",
    gameCode: "PG-SLOT-102",
    gameType: "SLOT",
    platFormCode: "PG",
  },
  {
    name: "Legend of Perseus",
    image: "/assets/slot/legend-of-perseus.webp",
    key: "PG",
    gameCode: "PG-SLOT-103",
    gameType: "SLOT",
    platFormCode: "PG",
  },
  {
    name: "Win Win Fish Prawn Crab",
    image: "/assets/slot/win-win-fish-prawn-crab.webp",
    key: "PG",
    gameCode: "PG-SLOT-100",
    gameType: "SLOT",
    platFormCode: "PG",
  },
  {
    name: "Lucky Piggy",
    image: "/assets/slot/lucky-piggy.webp",
    key: "PG",
    gameCode: "PG-SLOT-101",
    gameType: "SLOT",
    platFormCode: "PG",
  },
  {
    name: "Prosperity Fortune Tree",
    image: "/assets/slot/prosperity-fortune-tree.webp",
    key: "PG",
    gameCode: "PG-SLOT-106",
    gameType: "SLOT",
    platFormCode: "PG",
  },
  {
    name: "Wild Coaster",
    image: "/assets/slot/wild-coaster.webp",
    key: "PG",
    gameCode: "PG-SLOT-104",
    gameType: "SLOT",
    platFormCode: "PG",
  },
  {
    name: "Totem Wonders",
    image: "/assets/slot/totem-wonders.webp",
    key: "PG",
    gameCode: "PG-SLOT-107",
    gameType: "SLOT",
    platFormCode: "PG",
  },
  {
    name: "Asgardian Rising",
    image: "/assets/slot/asgardian-rising.webp",
    key: "PG",
    gameCode: "PG-SLOT-110",
    gameType: "SLOT",
    platFormCode: "PG",
  },
  {
    name: "Wild Bounty Showdown",
    image: "/assets/slot/wild-bounty-showdown.webp",
    key: "PG",
    gameCode: "PG-SLOT-105",
    gameType: "SLOT",
    platFormCode: "PG",
  },
  {
    name: "Alchemy Gold",
    image: "/assets/slot/alchemy-gold.webp",
    key: "PG",
    gameCode: "PG-SLOT-108",
    gameType: "SLOT",
    platFormCode: "PG",
  },
  {
    name: "Diner Delights",
    image: "/assets/slot/diner-delights.webp",
    key: "PG",
    gameCode: "PG-SLOT-109",
    gameType: "SLOT",
    platFormCode: "PG",
  },
  {
    name: "Hawaiian Tiki",
    image: "/assets/slot/hawaiian-tiki.webp",
    key: "PG",
    gameCode: "PG-SLOT-114",
    gameType: "SLOT",
    platFormCode: "PG",
  },
  {
    name: "Fruity Candy",
    image: "/assets/slot/fruity-candy.webp",
    key: "PG",
    gameCode: "PG-SLOT-120",
    gameType: "SLOT",
    platFormCode: "PG",
  },
  {
    name: "Midas Fortune",
    image: "/assets/slot/midas-fortune.webp",
    key: "PG",
    gameCode: "PG-SLOT-111",
    gameType: "SLOT",
    platFormCode: "PG",
  },
  {
    name: "Bakery Bonanza",
    image: "/assets/slot/bakery-bonanza.webp",
    key: "PG",
    gameCode: "PG-SLOT-115",
    gameType: "SLOT",
    platFormCode: "PG",
  },
  {
    name: "Rave Party Fever",
    image: "/assets/slot/rave-party-fever.webp",
    key: "PG",
    gameCode: "PG-SLOT-113",
    gameType: "SLOT",
    platFormCode: "PG",
  },
  {
    name: "Mystical Spirits",
    image: "/assets/slot/mystical-spirits.webp",
    key: "PG",
    gameCode: "PG-SLOT-117",
    gameType: "SLOT",
    platFormCode: "PG",
  },
  {
    name: "Songkran Splash",
    image: "/assets/slot/songkran-splash.webp",
    key: "PG",
    gameCode: "PG-SLOT-116",
    gameType: "SLOT",
    platFormCode: "PG",
  },
  {
    name: "Dragon Hatch 2",
    image: "/assets/slot/dragon-hatch-2.webp",
    key: "PG",
    gameCode: "PG-SLOT-131",
    gameType: "SLOT",
    platFormCode: "PG",
  },
  {
    name: "Cruise Royale",
    image: "/assets/slot/cruise-royale.webp",
    key: "PG",
    gameCode: "PG-SLOT-121",
    gameType: "SLOT",
    platFormCode: "PG",
  },
  {
    name: "Ultimate Striker",
    image: "/assets/slot/ultimate-striker.webp",
    key: "PG",
    gameCode: "PG-SLOT-125",
    gameType: "SLOT",
    platFormCode: "PG",
  },
  {
    name: "Pinata Wins",
    image: "/assets/slot/pinata-wins.webp",
    key: "PG",
    gameCode: "PG-SLOT-136",
    gameType: "SLOT",
    platFormCode: "PG",
  },
  {
    name: "Wild Ape #3258",
    image: "/assets/slot/wild-ape-3258.webp",
    key: "PG",
  },
  {
    name: "Super Golf Drive",
    image: "/assets/slot/super-golf-drive.webp",
    key: "PG",
    gameCode: "PG-SLOT-118",
    gameType: "SLOT",
    platFormCode: "PG",
  },
  {
    name: "Ninja Raccoon Frenzy",
    image: "/assets/slot/ninja-raccoon-frenzy.webp",
    key: "PG",
    gameCode: "PG-SLOT-124",
    gameType: "SLOT",
    platFormCode: "PG",
  },
  {
    name: "Fortune Rabbit",
    image: "/assets/slot/fortune-rabbit.webp",
    key: "PG",
    gameCode: "PG-SLOT-112",
    gameType: "SLOT",
    platFormCode: "PG",
  },
  {
    name: "Forge of Wealth",
    image: "/assets/slot/forge-of-wealth.webp",
    key: "PG",
    gameCode: "PG-SLOT-127",
    gameType: "SLOT",
    platFormCode: "PG",
  },
  {
    name: "Wild Heist Cashout",
    image: "/assets/slot/wild-heist-cashout.webp",
    key: "PG",
    gameCode: "PG-SLOT-126",
    gameType: "SLOT",
    platFormCode: "PG",
  },
  {
    name: "Gladiator's Glory",
    image: "/assets/slot/gladiator-s-glory.webp",
    key: "PG",
    gameCode: "PG-SLOT-123",
    gameType: "SLOT",
    platFormCode: "PG",
  },
  {
    name: "Mafia Mayhem",
    image: "/assets/slot/mafia-mayhem.webp",
    key: "PG",
    gameCode: "PG-SLOT-128",
    gameType: "SLOT",
    platFormCode: "PG",
  },
  {
    name: "Safari Wilds",
    image: "/assets/slot/safari-wilds.webp",
    key: "PG",
    gameCode: "PG-SLOT-122",
    gameType: "SLOT",
    platFormCode: "PG",
  },
  {
    name: "Lucky Clover Riches",
    image: "/assets/slot/lucky-clover-riches.webp",
    key: "PG",
    gameCode: "PG-SLOT-119",
    gameType: "SLOT",
    platFormCode: "PG",
  },
  {
    name: "WereWolf's Hunt",
    image: "/assets/slot/werewolf-s-hunt.webp",
    key: "PG",
    gameCode: "PG-SLOT-130",
    gameType: "SLOT",
    platFormCode: "PG",
  },
  {
    name: "Anubis Wrath",
    image: "/assets/slot/anubis-wrath.webp",
    key: "PG",
    gameCode: "PG-SLOT-138",
    gameType: "SLOT",
    platFormCode: "PG",
  },
  {
    name: "Zombie Outbreak",
    image: "/assets/slot/zombie-outbreak.webp",
    key: "PG",
    gameCode: "PG-SLOT-139",
    gameType: "SLOT",
    platFormCode: "PG",
  },
  {
    name: "Shark Bounty",
    image: "/assets/slot/shark-bounty.webp",
    key: "PG",
    gameCode: "PG-SLOT-142",
    gameType: "SLOT",
    platFormCode: "PG",
  },
  {
    name: "Tsar Treasures",
    image: "/assets/slot/tsar-treasures.webp",
    key: "PG",
    gameCode: "PG-SLOT-129",
    gameType: "SLOT",
    platFormCode: "PG",
  },
  {
    name: "Gemstones Gold",
    image: "/assets/slot/gemstones-gold.webp",
    key: "PG",
    gameCode: "PG-SLOT-133",
    gameType: "SLOT",
    platFormCode: "PG",
  },
  {
    name: "Cash Mania",
    image: "/assets/slot/cash-mania.webp",
    key: "PG",
    gameCode: "PG-SLOT-134",
    gameType: "SLOT",
    platFormCode: "PG",
  },
  {
    name: "Fortune Dragon",
    image: "/assets/slot/pgs-1695365.webp",
    key: "PG",
    gameCode: "PG-SLOT-132",
    gameType: "SLOT",
    platFormCode: "PG",
  },
  {
    name: "Geisha's Revenge",
    image: "/assets/slot/geisha-s-revenge.webp",
    key: "PG",
    gameCode: "PG-SLOT-150",
    gameType: "SLOT",
    platFormCode: "PG",
  },
  {
    name: "Mystic Potions",
    image: "/assets/slot/mystic-potions.webp",
    key: "PG",
  },
  {
    name: "Three Crazy Piggies",
    image: "/assets/slot/three-crazy-piggies.webp",
    key: "PG",
    gameCode: "PG-SLOT-145",
    gameType: "SLOT",
    platFormCode: "PG",
  },
  {
    name: "Wings of Iguazu",
    image: "/assets/slot/wings-of-iguazu.webp",
    key: "PG",
    gameCode: "PG-SLOT-144",
    gameType: "SLOT",
    platFormCode: "PG",
  },
  {
    name: "Museum Mystery",
    image: "/assets/slot/museum-mystery.webp",
    key: "PG",
  },
  {
    name: "Yakuza Honor",
    image: "/assets/slot/yakuza-honor.webp",
    key: "PG",
    gameCode: "PG-SLOT-143",
    gameType: "SLOT",
    platFormCode: "PG",
  },
  {
    name: "Futebol Fever",
    image: "/assets/slot/futebol-fever.webp",
    key: "PG",
    gameCode: "PG-SLOT-141",
    gameType: "SLOT",
    platFormCode: "PG",
  },
  {
    name: "Rio Fantasia",
    image: "/assets/slot/rio-fantasia.webp",
    key: "PG",
    gameCode: "PG-SLOT-148",
    gameType: "SLOT",
    platFormCode: "PG",
  },
  {
    name: "Mr. Treasure’s Fortune",
    image: "/assets/slot/mr-treasure-s-fortune.webp",
    key: "PG",
    gameCode: "PG-SLOT-153",
    gameType: "SLOT",
    platFormCode: "PG",
  },
  {
    name: "Hood vs Wolf",
    image: "/assets/slot/hood-vs-wolf.webp",
    key: "PG",
    gameCode: "PG-SLOT-009",
    gameType: "SLOT",
    platFormCode: "PG",
  },
  {
    name: "Graffiti Rush",
    image: "/assets/slot/graffiti-rush.webp",
    key: "PG",
    gameCode: "PG-SLOT-154",
    gameType: "SLOT",
    platFormCode: "PG",
  },
  {
    name: "Oishi Delights",
    image: "/assets/slot/oishi-delights.webp",
    key: "PG",
    gameCode: "PG-SLOT-146",
    gameType: "SLOT",
    platFormCode: "PG",
  },
  {
    name: "Doomsday Rampage",
    image: "/assets/slot/doomsday-rampage.webp",
    key: "PG",
    gameCode: "PG-SLOT-155",
    gameType: "SLOT",
    platFormCode: "PG",
  },
  {
    name: "Jack the Giant Hunter",
    image: "/assets/slot/jack-the-giant-hunter.webp",
    key: "PG",
    gameCode: "PG-SLOT-158",
    gameType: "SLOT",
    platFormCode: "PG",
  },
  {
    name: "Mythical Guardians",
    image: "/assets/slot/mythical-guardians.webp",
    key: "PG",
  },
  {
    name: "Incan Wonders",
    image: "/assets/slot/incan-wonders.webp",
    key: "PG",
    gameCode: "PG-SLOT-152",
    gameType: "SLOT",
    platFormCode: "PG",
  },
  {
    name: "Dead Man's Riches",
    image: "/assets/slot/dead-man-s-riches.webp",
    key: "PG",
    gameCode: "PG-SLOT-157",
    gameType: "SLOT",
    platFormCode: "PG",
  },
  {
    name: "Fortune Snake",
    image: "/assets/slot/fortune-snake.webp",
    key: "PG",
    gameCode: "PG-SLOT-151",
    gameType: "SLOT",
    platFormCode: "PG",
  },
  {
    name: "Knockout Riches",
    image: "/assets/slot/knockout-riches.webp",
    key: "PG",
    gameCode: "PG-SLOT-156",
    gameType: "SLOT",
    platFormCode: "PG",
  },
  {
    name: "Dragon's Treasure Quest",
    image: "/assets/slot/dragon-s-treasure-quest.webp",
    key: "PG",
    gameCode: "PG-SLOT-160",
    gameType: "SLOT",
    platFormCode: "PG",
  },
  {
    name: "Grimms' Bounty: Hansel & Gretel",
    image: "/assets/slot/grimms-bounty-hansel-gretel.webp",
    key: "PG",
    gameCode: "PG-SLOT-162",
    gameType: "SLOT",
    platFormCode: "PG",
  },
  {
    name: "Galaxy Miner",
    image: "/assets/slot/galaxy-miner.webp",
    key: "PG",
    gameCode: "PG-SLOT-161",
    gameType: "SLOT",
    platFormCode: "PG",
  },
  {
    name: "Kraken Gold Rush",
    image: "/assets/slot/kraken-gold-rush.webp",
    key: "PG",
    gameCode: "PG-SLOT-164",
    gameType: "SLOT",
    platFormCode: "PG",
  },
  {
    name: "Diner Frenzy Spins",
    image: "/assets/slot/diner-frenzy-spins.webp",
    key: "PG",
    gameCode: "PG-SLOT-159",
    gameType: "SLOT",
    platFormCode: "PG",
  },
  {
    name: "Alibaba's Cave of Fortune",
    image: "/assets/slot/alibaba-s-cave-of-fortune.webp",
    key: "PG",
    gameCode: "PG-SLOT-167",
    gameType: "SLOT",
    platFormCode: "PG",
  },
  {
    name: "Inferno Mayhem",
    image: "/assets/slot/inferno-mayhem.webp",
    key: "PG",
  },
  {
    name: "Pharaoh Royals",
    image: "/assets/slot/pharaoh-royals.webp",
    key: "PG",
    gameCode: "PG-SLOT-165",
    gameType: "SLOT",
    platFormCode: "PG",
  },
  {
    name: "Majestic Empire",
    image: "/assets/slot/majestic-empire.webp",
    key: "PG",
    gameCode: "PG-SLOT-163",
    gameType: "SLOT",
    platFormCode: "PG",
  },
  {
    name: "Forbidden Alchemy",
    image: "/assets/slot/forbidden-alchemy.webp",
    key: "PG",
  },
  {
    name: "Mayan Destiny",
    image: "/assets/slot/mayan-destiny.webp",
    key: "PG",
  },
  {
    name: "Gem Saviour",
    image: "/assets/slot/gem-saviour.webp",
    key: "PG",
    gameCode: "PG-SLOT-002",
    gameType: "SLOT",
    platFormCode: "PG",
  },
  {
    name: "Reel Love",
    image: "/assets/slot/reel-love.webp",
    key: "PG",
    gameCode: "PG-SLOT-044",
    gameType: "SLOT",
    platFormCode: "PG",
  },
  {
    name: "Poker Kingdom Win",
    image: "/assets/slot/poker-kingdom-win.webp",
    key: "PG",
  },
  {
    name: "Ganesha Fortune",
    image: "/assets/slot/ganesha-fortune.webp",
    key: "PG",
    gameCode: "PG-SLOT-052",
    gameType: "SLOT",
    platFormCode: "PG",
  },
  {
    name: "Skylight Wonders",
    image: "/assets/slot/skylight-wonders.webp",
    key: "PG",
    gameCode: "PG-SLOT-166",
    gameType: "SLOT",
    platFormCode: "PG",
  },
  {
    name: "Fortune Horse",
    image: "/assets/slot/fortune-horse.webp",
    key: "PG",
  },
  {
    name: "Win Win Won",
    image: "/assets/slot/win-win-won.webp",
    key: "PG",
    gameCode: "PG-SLOT-011",
    gameType: "SLOT",
    platFormCode: "PG",
  },
  {
    name: "Plushie Frenzy",
    image: "/assets/slot/plushie-frenzy.webp",
    key: "PG",
    gameCode: "PG-SLOT-012",
    gameType: "SLOT",
    platFormCode: "PG",
  },
  {
    name: "Tree of Fortune",
    image: "/assets/slot/tree-of-fortune.webp",
    key: "PG",
    gameCode: "PG-SLOT-013",
    gameType: "SLOT",
    platFormCode: "PG",
  },
  {
    name: "Hotpot",
    image: "/assets/slot/hotpot.webp",
    key: "PG",
    gameCode: "PG-SLOT-015",
    gameType: "SLOT",
    platFormCode: "PG",
  },
  {
    name: "Dragon Legend",
    image: "/assets/slot/dragon-legend.webp",
    key: "PG",
    gameCode: "PG-SLOT-016",
    gameType: "SLOT",
    platFormCode: "PG",
  },
  {
    name: "Fortune Gods",
    image: "/assets/slot/fortune-gods.webp",
    key: "PG",
    gameCode: "PG-SLOT-003",
    gameType: "SLOT",
    platFormCode: "PG",
  },
  {
    name: "Hip Hop Panda",
    image: "/assets/slot/hip-hop-panda.webp",
    key: "PG",
    gameCode: "PG-SLOT-017",
    gameType: "SLOT",
    platFormCode: "PG",
  },
  {
    name: "Legend of Hou Yi",
    image: "/assets/slot/legend-of-hou-yi.webp",
    key: "PG",
    gameCode: "PG-SLOT-018",
    gameType: "SLOT",
    platFormCode: "PG",
  },
  {
    name: "Mr. Hallow-Win",
    image: "/assets/slot/mr-hallow-win.webp",
    key: "PG",
  },
  {
    name: "Prosperity Lion",
    image: "/assets/slot/prosperity-lion.webp",
    key: "PG",
    gameCode: "PG-SLOT-020",
    gameType: "SLOT",
    platFormCode: "PG",
  },
  {
    name: "Santa's Gift Rush",
    image: "/assets/slot/santa-s-gift-rush.webp",
    key: "PG",
  },
  {
    name: "Gem Saviour Sword",
    image: "/assets/slot/gem-saviour-sword.webp",
    key: "PG",
    gameCode: "PG-SLOT-022",
    gameType: "SLOT",
    platFormCode: "PG",
  },
  {
    name: "Piggy Gold",
    image: "/assets/slot/piggy-gold.webp",
    key: "PG",
    gameCode: "PG-SLOT-023",
    gameType: "SLOT",
    platFormCode: "PG",
  },
  {
    name: "Jungle Delight",
    image: "/assets/slot/jungle-delight.webp",
    key: "PG",
    gameCode: "PG-SLOT-024",
    gameType: "SLOT",
    platFormCode: "PG",
  },
  {
    name: "Symbols of Egypt",
    image: "/assets/slot/symbols-of-egypt.webp",
    key: "PG",
    gameCode: "PG-SLOT-025",
    gameType: "SLOT",
    platFormCode: "PG",
  },
  {
    name: "Ganesha Gold",
    image: "/assets/slot/ganesha-gold.webp",
    key: "PG",
    gameCode: "PG-SLOT-026",
    gameType: "SLOT",
    platFormCode: "PG",
  },
  {
    name: "Emperor's Favour",
    image: "/assets/slot/emperor-s-favour.webp",
    key: "PG",
  },
  {
    name: "Double Fortune",
    image: "/assets/slot/double-fortune.webp",
    key: "PG",
    gameCode: "PG-SLOT-030",
    gameType: "SLOT",
    platFormCode: "PG",
  },
  {
    name: "Journey to the Wealth",
    image: "/assets/slot/journey-to-the-wealth.webp",
    key: "PG",
    gameCode: "PG-SLOT-037",
    gameType: "SLOT",
    platFormCode: "PG",
  },
  {
    name: "The Great Icescape",
    image: "/assets/slot/the-great-icescape.webp",
    key: "PG",
    gameCode: "PG-SLOT-032",
    gameType: "SLOT",
    platFormCode: "PG",
  },
  {
    name: "Captain's Bounty",
    image: "/assets/slot/captain-s-bounty.webp",
    key: "PG",
  },
  {
    name: "Dragon Hatch",
    image: "/assets/slot/dragon-hatch.webp",
    key: "PG",
    gameCode: "PG-SLOT-042",
    gameType: "SLOT",
    platFormCode: "PG",
  },
  {
    name: "Vampire's Charm",
    image: "/assets/slot/vampire-s-charm.webp",
    key: "PG",
    gameCode: "PG-SLOT-062",
    gameType: "SLOT",
    platFormCode: "PG",
  },
  {
    name: "Ninja vs Samurai",
    image: "/assets/slot/ninja-vs-samurai.webp",
    key: "PG",
    gameCode: "PG-SLOT-040",
    gameType: "SLOT",
    platFormCode: "PG",
  },
  {
    name: "Medusa II",
    image: "/assets/slot/medusa-ii.webp",
    key: "PG",
  },
  {
    name: "Leprechaun Riches",
    image: "/assets/slot/leprechaun-riches.webp",
    key: "PG",
    gameCode: "PG-SLOT-038",
    gameType: "SLOT",
    platFormCode: "PG",
  },
  {
    name: "Flirting Scholar",
    image: "/assets/slot/flirting-scholar.webp",
    key: "PG",
    gameCode: "PG-SLOT-036",
    gameType: "SLOT",
    platFormCode: "PG",
  },
  {
    name: "Gem Saviour Conquest",
    image: "/assets/slot/gem-saviour-conquest.webp",
    key: "PG",
    gameCode: "PG-SLOT-045",
    gameType: "SLOT",
    platFormCode: "PG",
  },
  {
    name: "Dragon Tiger Luck",
    image: "/assets/slot/dragon-tiger-luck.webp",
    key: "PG",
    gameCode: "PG-SLOT-035",
    gameType: "SLOT",
    platFormCode: "PG",
  },
  {
    name: "Muay Thai Champion",
    image: "/assets/slot/muay-thai-champion.webp",
    key: "PG",
    gameCode: "PG-SLOT-039",
    gameType: "SLOT",
    platFormCode: "PG",
  },
  {
    name: "Mahjong Ways",
    image: "/assets/slot/mahjong-ways.webp",
    key: "PG",
    gameCode: "PG-SLOT-041",
    gameType: "SLOT",
    platFormCode: "PG",
  },
  {
    name: "Shaolin Soccer",
    image: "/assets/slot/shaolin-soccer.webp",
    key: "PG",
    gameCode: "PG-SLOT-046",
    gameType: "SLOT",
    platFormCode: "PG",
  },
  {
    name: "Fortune Mouse",
    image: "/assets/slot/fortune-mouse.webp",
    key: "PG",
    gameCode: "PG-SLOT-043",
    gameType: "SLOT",
    platFormCode: "PG",
  },
  {
    name: "Bikini Paradise",
    image: "/assets/slot/bikini-paradise.webp",
    key: "PG",
    gameCode: "PG-SLOT-049",
    gameType: "SLOT",
    platFormCode: "PG",
  },
  {
    name: "Medusa",
    image: "/assets/slot/pgs-7.webp",
    key: "PG",
    gameCode: "PG-SLOT-006",
    gameType: "SLOT",
    platFormCode: "PG",
  },
  {
    name: "Candy Burst",
    image: "/assets/slot/candy-burst.webp",
    key: "PG",
    gameCode: "PG-SLOT-048",
    gameType: "SLOT",
    platFormCode: "PG",
  },
  {
    name: "Caishen Wins",
    image: "/assets/slot/caishen-wins.webp",
    key: "PG",
    gameCode: "PG-SLOT-047",
    gameType: "SLOT",
    platFormCode: "PG",
  },
  {
    name: "Egypt's Book of Mystery",
    image: "/assets/slot/egypt-s-book-of-mystery.webp",
    key: "PG",
    gameCode: "PG-SLOT-051",
    gameType: "SLOT",
    platFormCode: "PG",
  },
  {
    name: "Mahjong Ways 2",
    image: "/assets/slot/mahjong-ways-2.webp",
    key: "PG",
    gameCode: "PG-SLOT-050",
    gameType: "SLOT",
    platFormCode: "PG",
  },
  {
    name: "Dreams of Macau",
    image: "/assets/slot/dreams-of-macau.webp",
    key: "PG",
  },
  {
    name: "Circus Delight",
    image: "/assets/slot/circus-delight.webp",
    key: "PG",
    gameCode: "PG-SLOT-059",
    gameType: "SLOT",
    platFormCode: "PG",
  },
  {
    name: "Phoenix Rises",
    image: "/assets/slot/phoenix-rises.webp",
    key: "PG",
    gameCode: "PG-SLOT-053",
    gameType: "SLOT",
    platFormCode: "PG",
  },
  {
    name: "Wild Fireworks",
    image: "/assets/slot/wild-fireworks.webp",
    key: "PG",
    gameCode: "PG-SLOT-055",
    gameType: "SLOT",
    platFormCode: "PG",
  },
  {
    name: "Queen of Bounty",
    image: "/assets/slot/queen-of-bounty.webp",
    key: "PG",
    gameCode: "PG-SLOT-063",
    gameType: "SLOT",
    platFormCode: "PG",
  },
  {
    name: "Genie's 3 Wishes",
    image: "/assets/slot/genie-s-3-wishes.webp",
    key: "PG",
    gameCode: "PG-SLOT-057",
    gameType: "SLOT",
    platFormCode: "PG",
  },
  {
    name: "Galactic Gems",
    image: "/assets/slot/galactic-gems.webp",
    key: "PG",
    gameCode: "PG-SLOT-067",
    gameType: "SLOT",
    platFormCode: "PG",
  },
  {
    name: "Treasures of Aztec",
    image: "/assets/slot/treasures-of-aztec.webp",
    key: "PG",
    gameCode: "PG-SLOT-058",
    gameType: "SLOT",
    platFormCode: "PG",
  },
  {
    name: "Jewels of Prosperity",
    image: "/assets/slot/jewels-of-prosperity.webp",
    key: "PG",
    gameCode: "PG-SLOT-064",
    gameType: "SLOT",
    platFormCode: "PG",
  },
  {
    name: "Lucky Neko",
    image: "/assets/slot/lucky-neko.webp",
    key: "PG",
    gameCode: "PG-SLOT-065",
    gameType: "SLOT",
    platFormCode: "PG",
  },
  {
    name: "Secrets of Cleopatra",
    image: "/assets/slot/secrets-of-cleopatra.webp",
    key: "PG",
  },
  {
    name: "Guardians of Ice & Fire",
    image: "/assets/slot/guardians-of-ice-fire.webp",
    key: "PG",
  },
  {
    name: "Thai River Wonders",
    image: "/assets/slot/thai-river-wonders.webp",
    key: "PG",
    gameCode: "PG-SLOT-060",
    gameType: "SLOT",
    platFormCode: "PG",
  },
  {
    name: "Opera Dynasty",
    image: "/assets/slot/opera-dynasty.webp",
    key: "PG",
    gameCode: "PG-SLOT-069",
    gameType: "SLOT",
    platFormCode: "PG",
  },
  {
    name: "Bali Vacation",
    image: "/assets/slot/bali-vacation.webp",
    key: "PG",
    gameCode: "PG-SLOT-071",
    gameType: "SLOT",
    platFormCode: "PG",
  },
  {
    name: "Majestic Treasures",
    image: "/assets/slot/majestic-treasures.webp",
    key: "PG",
    gameCode: "PG-SLOT-073",
    gameType: "SLOT",
    platFormCode: "PG",
  },
  {
    name: "Jack Frost's Winter",
    image: "/assets/slot/jack-frost-s-winter.webp",
    key: "PG",
    gameCode: "PG-SLOT-066",
    gameType: "SLOT",
    platFormCode: "PG",
  },
  {
    name: "Fortune Ox",
    image: "/assets/slot/fortune-ox.webp",
    key: "PG",
    gameCode: "PG-SLOT-070",
    gameType: "SLOT",
    platFormCode: "PG",
  },
  {
    name: "4 Bonuses Bonanza - Plinko Spin",
    image: "/assets/slot/4-bonuses-bonanza-plinko-spin.webp",
    key: "SMARTSOFT",
  },
  {
    name: "Multi Hot Ways",
    image: "/assets/slot/multi-hot-ways.webp",
    key: "SMARTSOFT",
  },
  {
    name: "Burning Ice 10",
    image: "/assets/slot/burning-ice-10.webp",
    key: "SMARTSOFT",
  },
  {
    name: "Mad Slot",
    image: "/assets/slot/mad-slot.webp",
    key: "SMARTSOFT",
  },
  {
    name: "Book of Bonanza",
    image: "/assets/slot/book-of-bonanza.webp",
    key: "SMARTSOFT",
  },
  {
    name: "Dracula’s Fortune",
    image: "/assets/slot/dracula-s-fortune.webp",
    key: "SMARTSOFT",
  },
  {
    name: "Sugar Fiesta",
    image: "/assets/slot/sugar-fiesta.webp",
    key: "SMARTSOFT",
  },
  {
    name: "Safari Simba",
    image: "/assets/slot/safari-simba.webp",
    key: "SMARTSOFT",
  },
  {
    name: "Wild Multi Stars",
    image: "/assets/slot/wild-multi-stars.webp",
    key: "SMARTSOFT",
  },
  {
    name: "Hot Samba",
    image: "/assets/slot/hot-samba.webp",
    key: "SMARTSOFT",
  },
  {
    name: "Book of Futuria",
    image: "/assets/slot/book-of-futuria.webp",
    key: "SMARTSOFT",
  },
  {
    name: "Bao Slot 5X",
    image: "/assets/slot/bao-slot-5x.webp",
    key: "SMARTSOFT",
  },
  {
    name: "Jungle Sisters",
    image: "/assets/slot/jungle-sisters.webp",
    key: "SMARTSOFT",
  },
  {
    name: "Habesha Fortune 5",
    image: "/assets/slot/habesha-fortune-5.webp",
    key: "SMARTSOFT",
  },
  {
    name: "Jungle Sisters Deluxe",
    image: "/assets/slot/jungle-sisters-deluxe.webp",
    key: "SMARTSOFT",
  },
  {
    name: "Bonus Time",
    image: "/assets/slot/bonus-time.webp",
    key: "SMARTSOFT",
  },
  {
    name: "Dragon's Code",
    image: "/assets/slot/dragon-s-code.webp",
    key: "SMARTSOFT",
  },
  {
    name: "Farm's Fortune",
    image: "/assets/slot/farm-s-fortune.webp",
    key: "SMARTSOFT",
  },
  {
    name: "Wilds & Gods",
    image: "/assets/slot/wilds-gods.webp",
    key: "SMARTSOFT",
  },
  {
    name: "Foxy Hot 20",
    image: "/assets/slot/foxy-hot-20.webp",
    key: "SMARTSOFT",
  },
  {
    name: "Genie's Bonanza",
    image: "/assets/slot/genie-s-bonanza.webp",
    key: "SMARTSOFT",
  },
  {
    name: "Vampires",
    image: "/assets/slot/vampires.webp",
    key: "SMARTSOFT",
  },
  {
    name: "Burning Ice 40",
    image: "/assets/slot/burning-ice-40.webp",
    key: "SMARTSOFT",
  },
  {
    name: "Burning Ice",
    image: "/assets/slot/burning-ice.webp",
    key: "SMARTSOFT",
  },
  {
    name: "Multi Hot 5",
    image: "/assets/slot/multi-hot-5.webp",
    key: "SMARTSOFT",
  },
  {
    name: "Boka Jamba 10",
    image: "/assets/slot/boka-jamba-10.webp",
    key: "SMARTSOFT",
  },
  {
    name: "Mariachi Coins",
    image: "/assets/slot/mariachi-coins.webp",
    key: "SMARTSOFT",
  },
  {
    name: "Cai Balao Cappadocia",
    image: "/assets/slot/cai-balao-cappadocia.webp",
    key: "SMARTSOFT",
  },
  {
    name: "Dracula's Fortune - Halloween Edition",
    image: "/assets/slot/dracula-s-fortune-halloween-edition.webp",
    key: "SMARTSOFT",
  },
  {
    name: "Multi Hot Wild Ways",
    image: "/assets/slot/multi-hot-wild-ways.webp",
    key: "SMARTSOFT",
  },
  {
    name: "Multi Hot Wheel",
    image: "/assets/slot/multi-hot-wheel.webp",
    key: "SMARTSOFT",
  },
  {
    name: "Multi Hot 5 Wild",
    image: "/assets/slot/multi-hot-5-wild.webp",
    key: "SMARTSOFT",
  },
  {
    name: "Wheel of Destiny",
    image: "/assets/slot/wheel-of-destiny.webp",
    key: "SMARTSOFT",
  },
  {
    name: "Jingle Bell Bonanza",
    image: "/assets/slot/jingle-bell-bonanza.webp",
    key: "SMARTSOFT",
  },
  {
    name: "Multi Hot 5 Deluxe",
    image: "/assets/slot/multi-hot-5-deluxe.webp",
    key: "SMARTSOFT",
  },
  {
    name: "Multi Hot 5 Super Wilds",
    image: "/assets/slot/multi-hot-5-super-wilds.webp",
    key: "SMARTSOFT",
  },
  {
    name: "Multi Hot 5 Burn Wilds",
    image: "/assets/slot/multi-hot-5-burn-wilds.webp",
    key: "SMARTSOFT",
  },
  {
    name: "Dice Jungle",
    image: "/assets/slot/dice-jungle.webp",
    key: "SMARTSOFT",
  },
  {
    name: "JokersTreasure",
    image: "/assets/slot/jokerstreasure.webp",
    key: "SPADE",
    gameCode: "SG-SLOT-075",
    gameType: "SLOT",
    platFormCode: "SPADE",
  },
  {
    name: "Galaxy Guardian",
    image: "/assets/slot/galaxy-guardian.webp",
    key: "SPADE",
    gameCode: "SG-SLOT-142",
    gameType: "SLOT",
    platFormCode: "SPADE",
  },
  {
    name: "Clash of the Giants",
    image: "/assets/slot/clash-of-the-giants.webp",
    key: "SPADE",
    gameCode: "SG-SLOT-139",
    gameType: "SLOT",
    platFormCode: "SPADE",
  },
  {
    name: "Moji Mania",
    image: "/assets/slot/moji-mania.webp",
    key: "SPADE",
    gameCode: "SG-SLOT-127",
    gameType: "SLOT",
    platFormCode: "SPADE",
  },
  {
    name: "Hammer of Thunder",
    image: "/assets/slot/hammer-of-thunder.webp",
    key: "SPADE",
    gameCode: "SG-SLOT-124",
    gameType: "SLOT",
    platFormCode: "SPADE",
  },
  {
    name: "Farmland Frenzy Maxways",
    image: "/assets/slot/farmland-frenzy-maxways.webp",
    key: "SPADE",
    gameCode: "SG-SLOT-122",
    gameType: "SLOT",
    platFormCode: "SPADE",
  },
  {
    name: "CAISHEN DELUXE MAXWAYS",
    image: "/assets/slot/caishen-deluxe-maxways.webp",
    key: "SPADE",
    gameCode: "SG-SLOT-121",
    gameType: "SLOT",
    platFormCode: "SPADE",
  },
  {
    name: "Rabbit Riches",
    image: "/assets/slot/rabbit-riches.webp",
    key: "SPADE",
    gameCode: "SG-SLOT-120",
    gameType: "SLOT",
    platFormCode: "SPADE",
  },
  {
    name: "Christmas Miracles",
    image: "/assets/slot/christmas-miracles.webp",
    key: "SPADE",
    gameCode: "SG-SLOT-119",
    gameType: "SLOT",
    platFormCode: "SPADE",
  },
  {
    name: "Halloween Vacation",
    image: "/assets/slot/halloween-vacation.webp",
    key: "SPADE",
    gameCode: "SG-SLOT-117",
    gameType: "SLOT",
    platFormCode: "SPADE",
  },
  {
    name: "Legacy Of Kong Maxways",
    image: "/assets/slot/legacy-of-kong-maxways.webp",
    key: "SPADE",
    gameCode: "SG-SLOT-116",
    gameType: "SLOT",
    platFormCode: "SPADE",
  },
  {
    name: "Sugar Party",
    image: "/assets/slot/sugar-party.webp",
    key: "SPADE",
    gameCode: "SG-SLOT-115",
    gameType: "SLOT",
    platFormCode: "SPADE",
  },
  {
    name: "Candy Pop",
    image: "/assets/slot/candy-pop.webp",
    key: "SPADE",
    gameCode: "SG-SLOT-001",
    gameType: "SLOT",
    platFormCode: "SPADE",
  },
  {
    name: "Captain Golds Fortune",
    image: "/assets/slot/captain-golds-fortune.webp",
    key: "SPADE",
    gameCode: "SG-SLOT-114",
    gameType: "SLOT",
    platFormCode: "SPADE",
  },
  {
    name: "Journey to the Wild",
    image: "/assets/slot/journey-to-the-wild.webp",
    key: "SPADE",
    gameCode: "SG-SLOT-113",
    gameType: "SLOT",
    platFormCode: "SPADE",
  },
  {
    name: "Fruits Mania",
    image: "/assets/slot/fruits-mania.webp",
    key: "SPADE",
    gameCode: "SG-SLOT-112",
    gameType: "SLOT",
    platFormCode: "SPADE",
  },
  {
    name: "Gold Panther Maxways",
    image: "/assets/slot/gold-panther-maxways.webp",
    key: "SPADE",
    gameCode: "SG-SLOT-111",
    gameType: "SLOT",
    platFormCode: "SPADE",
  },
  {
    name: "Space Conquest",
    image: "/assets/slot/space-conquest.webp",
    key: "SPADE",
    gameCode: "SG-SLOT-110",
    gameType: "SLOT",
    platFormCode: "SPADE",
  },
  {
    name: "Caishen",
    image: "/assets/slot/caishen.webp",
    key: "SPADE",
    gameCode: "SG-SLOT-109",
    gameType: "SLOT",
    platFormCode: "SPADE",
  },
  {
    name: "Joker's Treasure Exclusive",
    image: "/assets/slot/joker-s-treasure-exclusive.webp",
    key: "SPADE",
    gameCode: "SG-SLOT-108",
    gameType: "SLOT",
    platFormCode: "SPADE",
  },
  {
    name: "Lucky Koi Exclusive",
    image: "/assets/slot/lucky-koi-exclusive.webp",
    key: "SPADE",
    gameCode: "SG-SLOT-107",
    gameType: "SLOT",
    platFormCode: "SPADE",
  },
  {
    name: "Fiery Sevens Exclusive",
    image: "/assets/slot/fiery-sevens-exclusive.webp",
    key: "SPADE",
    gameCode: "SG-SLOT-106",
    gameType: "SLOT",
    platFormCode: "SPADE",
  },
  {
    name: "Royale House",
    image: "/assets/slot/royale-house.webp",
    key: "SPADE",
    gameCode: "SG-SLOT-105",
    gameType: "SLOT",
    platFormCode: "SPADE",
  },
  {
    name: "Tiger Dance",
    image: "/assets/slot/tiger-dance.webp",
    key: "SPADE",
    gameCode: "SG-SLOT-104",
    gameType: "SLOT",
    platFormCode: "SPADE",
  },
  {
    name: "Sexy Vegas",
    image: "/assets/slot/sexy-vegas.webp",
    key: "SPADE",
    gameCode: "SG-SLOT-103",
    gameType: "SLOT",
    platFormCode: "SPADE",
  },
  {
    name: "Roma",
    image: "/assets/slot/roma.webp",
    key: "SPADE",
    gameCode: "SG-SLOT-102",
    gameType: "SLOT",
    platFormCode: "SPADE",
  },
  {
    name: "Candy Candy",
    image: "/assets/slot/candy-candy.webp",
    key: "SPADE",
    gameCode: "SG-SLOT-101",
    gameType: "SLOT",
    platFormCode: "SPADE",
  },
  {
    name: "Gold Rush Cowboy",
    image: "/assets/slot/gold-rush-cowboy.webp",
    key: "SPADE",
    gameCode: "SG-SLOT-100",
    gameType: "SLOT",
    platFormCode: "SPADE",
  },
  {
    name: "Wild Wet Win",
    image: "/assets/slot/wild-wet-win.webp",
    key: "SPADE",
    gameCode: "SG-SLOT-099",
    gameType: "SLOT",
    platFormCode: "SPADE",
  },
  {
    name: "Royal Katt",
    image: "/assets/slot/royal-katt.webp",
    key: "SPADE",
    gameCode: "SG-SLOT-098",
    gameType: "SLOT",
    platFormCode: "SPADE",
  },
  {
    name: "Muay Thai Fighter",
    image: "/assets/slot/muay-thai-fighter.webp",
    key: "SPADE",
    gameCode: "SG-SLOT-097",
    gameType: "SLOT",
    platFormCode: "SPADE",
  },
  {
    name: "Rich Caishen",
    image: "/assets/slot/rich-caishen.webp",
    key: "SPADE",
    gameCode: "SG-SLOT-096",
    gameType: "SLOT",
    platFormCode: "SPADE",
  },
  {
    name: "Poker Ways",
    image: "/assets/slot/poker-ways.webp",
    key: "SPADE",
    gameCode: "SG-SLOT-095",
    gameType: "SLOT",
    platFormCode: "SPADE",
  },
  {
    name: "Love Idol",
    image: "/assets/slot/love-idol.webp",
    key: "SPADE",
    gameCode: "SG-SLOT-093",
    gameType: "SLOT",
    platFormCode: "SPADE",
  },
  {
    name: "Sugar Bonanza",
    image: "/assets/slot/sugar-bonanza.webp",
    key: "SPADE",
    gameCode: "SG-SLOT-092",
    gameType: "SLOT",
    platFormCode: "SPADE",
  },
  {
    name: "Magic Kitty",
    image: "/assets/slot/magic-kitty.webp",
    key: "SPADE",
    gameCode: "SG-SLOT-091",
    gameType: "SLOT",
    platFormCode: "SPADE",
  },
  {
    name: "Hugon Quest",
    image: "/assets/slot/hugon-quest.webp",
    key: "SPADE",
    gameCode: "SG-SLOT-089",
    gameType: "SLOT",
    platFormCode: "SPADE",
  },
  {
    name: "Rise Of Werewolves",
    image: "/assets/slot/rise-of-werewolves.webp",
    key: "SPADE",
    gameCode: "SG-SLOT-087",
    gameType: "SLOT",
    platFormCode: "SPADE",
  },
  {
    name: "Mayan Gems",
    image: "/assets/slot/mayan-gems.webp",
    key: "SPADE",
    gameCode: "SG-SLOT-086",
    gameType: "SLOT",
    platFormCode: "SPADE",
  },
  {
    name: "ProsperityGods",
    image: "/assets/slot/prosperitygods.webp",
    key: "SPADE",
    gameCode: "SG-SLOT-085",
    gameType: "SLOT",
    platFormCode: "SPADE",
  },
  {
    name: "BrothersKingdom",
    image: "/assets/slot/brotherskingdom.webp",
    key: "SPADE",
    gameCode: "SG-SLOT-084",
    gameType: "SLOT",
    platFormCode: "SPADE",
  },
  {
    name: "MrChuTycoon",
    image: "/assets/slot/mrchutycoon.webp",
    key: "SPADE",
    gameCode: "SG-SLOT-083",
    gameType: "SLOT",
    platFormCode: "SPADE",
  },
  {
    name: "GoldPanther",
    image: "/assets/slot/goldpanther.webp",
    key: "SPADE",
    gameCode: "SG-SLOT-082",
    gameType: "SLOT",
    platFormCode: "SPADE",
  },
  {
    name: "TriplePanda",
    image: "/assets/slot/triplepanda.webp",
    key: "SPADE",
    gameCode: "SG-SLOT-081",
    gameType: "SLOT",
    platFormCode: "SPADE",
  },
  {
    name: "MagicalLamp",
    image: "/assets/slot/magicallamp.webp",
    key: "SPADE",
    gameCode: "SG-SLOT-080",
    gameType: "SLOT",
    platFormCode: "SPADE",
  },
  {
    name: "FierySevens",
    image: "/assets/slot/fierysevens.webp",
    key: "SPADE",
    gameCode: "SG-SLOT-079",
    gameType: "SLOT",
    platFormCode: "SPADE",
  },
  {
    name: "CrazyBomber",
    image: "/assets/slot/crazybomber.webp",
    key: "SPADE",
    gameCode: "SG-SLOT-078",
    gameType: "SLOT",
    platFormCode: "SPADE",
  },
  {
    name: "BookofMyth",
    image: "/assets/slot/bookofmyth.webp",
    key: "SPADE",
    gameCode: "SG-SLOT-077",
    gameType: "SLOT",
    platFormCode: "SPADE",
  },
  {
    name: "DoubleFlame",
    image: "/assets/slot/doubleflame.webp",
    key: "SPADE",
    gameCode: "SG-SLOT-076",
    gameType: "SLOT",
    platFormCode: "SPADE",
  },
  {
    name: "Mega7",
    image: "/assets/slot/mega7.webp",
    key: "SPADE",
    gameCode: "SG-SLOT-074",
    gameType: "SLOT",
    platFormCode: "SPADE",
  },
  {
    name: "ThreeLuckyStars",
    image: "/assets/slot/threeluckystars.webp",
    key: "SPADE",
    gameCode: "SG-SLOT-073",
    gameType: "SLOT",
    platFormCode: "SPADE",
  },
  {
    name: "SweetBakery",
    image: "/assets/slot/sweetbakery.webp",
    key: "SPADE",
    gameCode: "SG-SLOT-072",
    gameType: "SLOT",
    platFormCode: "SPADE",
  },
  {
    name: "MoneyMouse",
    image: "/assets/slot/moneymouse.webp",
    key: "SPADE",
    gameCode: "SG-SLOT-071",
    gameType: "SLOT",
    platFormCode: "SPADE",
  },
  {
    name: "DancingFever",
    image: "/assets/slot/dancingfever.webp",
    key: "SPADE",
    gameCode: "SG-SLOT-070",
    gameType: "SLOT",
    platFormCode: "SPADE",
  },
  {
    name: "888",
    image: "/assets/slot/888.webp",
    key: "SPADE",
    gameCode: "SG-SLOT-069",
    gameType: "SLOT",
    platFormCode: "SPADE",
  },
  {
    name: "HeroesGame",
    image: "/assets/slot/heroesgame.webp",
    key: "SPADE",
    gameCode: "SG-SLOT-068",
    gameType: "SLOT",
    platFormCode: "SPADE",
  },
  {
    name: "LuckyMeow",
    image: "/assets/slot/luckymeow.webp",
    key: "SPADE",
    gameCode: "SG-SLOT-060",
    gameType: "SLOT",
    platFormCode: "SPADE",
  },
  {
    name: "GoldenWhale",
    image: "/assets/slot/goldenwhale.webp",
    key: "SPADE",
    gameCode: "SG-SLOT-058",
    gameType: "SLOT",
    platFormCode: "SPADE",
  },
  {
    name: "DaFuXiaoFu",
    image: "/assets/slot/dafuxiaofu.webp",
    key: "SPADE",
    gameCode: "SG-SLOT-055",
    gameType: "SLOT",
    platFormCode: "SPADE",
  },
  {
    name: "HighwayFortune",
    image: "/assets/slot/highwayfortune.webp",
    key: "SPADE",
    gameCode: "SG-SLOT-049",
    gameType: "SLOT",
    platFormCode: "SPADE",
  },
  {
    name: "LuckyFengShui",
    image: "/assets/slot/luckyfengshui.webp",
    key: "SPADE",
    gameCode: "SG-SLOT-046",
    gameType: "SLOT",
    platFormCode: "SPADE",
  },
  {
    name: "Fafafa",
    image: "/assets/slot/fafafa.webp",
    key: "SPADE",
    gameCode: "SG-SLOT-045",
    gameType: "SLOT",
    platFormCode: "SPADE",
  },
  {
    name: "LuckyKoi",
    image: "/assets/slot/luckykoi.webp",
    key: "SPADE",
    gameCode: "SG-SLOT-041",
    gameType: "SLOT",
    platFormCode: "SPADE",
  },
  {
    name: "5FortuneDragons",
    image: "/assets/slot/5fortunedragons.webp",
    key: "SPADE",
    gameCode: "SG-SLOT-039",
    gameType: "SLOT",
    platFormCode: "SPADE",
  },
  {
    name: "DoubleFortunes",
    image: "/assets/slot/doublefortunes.webp",
    key: "SPADE",
    gameCode: "SG-SLOT-038",
    gameType: "SLOT",
    platFormCode: "SPADE",
  },
  {
    name: "CaiShen888",
    image: "/assets/slot/caishen888.webp",
    key: "SPADE",
    gameCode: "SG-SLOT-037",
    gameType: "SLOT",
    platFormCode: "SPADE",
  },
  {
    name: "KingPharaoh",
    image: "/assets/slot/kingpharaoh.webp",
    key: "SPADE",
    gameCode: "SG-SLOT-034",
    gameType: "SLOT",
    platFormCode: "SPADE",
  },
  {
    name: "GoldenLotusSE",
    image: "/assets/slot/goldenlotusse.webp",
    key: "SPADE",
    gameCode: "SG-SLOT-032",
    gameType: "SLOT",
    platFormCode: "SPADE",
  },
  {
    name: "BabyCaiShen",
    image: "/assets/slot/babycaishen.webp",
    key: "SPADE",
    gameCode: "SG-SLOT-031",
    gameType: "SLOT",
    platFormCode: "SPADE",
  },
  {
    name: "5FortuneSA",
    image: "/assets/slot/5fortunesa.webp",
    key: "SPADE",
    gameCode: "SG-SLOT-030",
    gameType: "SLOT",
    platFormCode: "SPADE",
  },
  {
    name: "IcelandSA",
    image: "/assets/slot/icelandsa.webp",
    key: "SPADE",
    gameCode: "SG-SLOT-023",
    gameType: "SLOT",
    platFormCode: "SPADE",
  },
  {
    name: "GreatStarsSA",
    image: "/assets/slot/greatstarssa.webp",
    key: "SPADE",
    gameCode: "SG-SLOT-022",
    gameType: "SLOT",
    platFormCode: "SPADE",
  },
  {
    name: "BigProsperitySA",
    image: "/assets/slot/bigprosperitysa.webp",
    key: "SPADE",
    gameCode: "SG-SLOT-021",
    gameType: "SLOT",
    platFormCode: "SPADE",
  },
  {
    name: "DragonGoldSA",
    image: "/assets/slot/dragongoldsa.webp",
    key: "SPADE",
    gameCode: "SG-SLOT-019",
    gameType: "SLOT",
    platFormCode: "SPADE",
  },
  {
    name: "GoldenChicken",
    image: "/assets/slot/goldenchicken.webp",
    key: "SPADE",
    gameCode: "SG-SLOT-018",
    gameType: "SLOT",
    platFormCode: "SPADE",
  },
  {
    name: "HoYeahMonkey",
    image: "/assets/slot/hoyeahmonkey.webp",
    key: "SPADE",
    gameCode: "SG-SLOT-017",
    gameType: "SLOT",
    platFormCode: "SPADE",
  },
  {
    name: "ZEUS",
    image: "/assets/slot/zeus.webp",
    key: "SPADE",
    gameCode: "SG-SLOT-016",
    gameType: "SLOT",
    platFormCode: "SPADE",
  },
  {
    name: "TigerWarrior",
    image: "/assets/slot/tigerwarrior.webp",
    key: "SPADE",
    gameCode: "SG-SLOT-014",
    gameType: "SLOT",
    platFormCode: "SPADE",
  },
  {
    name: "JungleKing",
    image: "/assets/slot/jungleking.webp",
    key: "SPADE",
    gameCode: "SG-SLOT-012",
    gameType: "SLOT",
    platFormCode: "SPADE",
  },
  {
    name: "GoldenMonkey",
    image: "/assets/slot/goldenmonkey.webp",
    key: "SPADE",
    gameCode: "SG-SLOT-009",
    gameType: "SLOT",
    platFormCode: "SPADE",
  },
  {
    name: "FirstLove",
    image: "/assets/slot/firstlove.webp",
    key: "SPADE",
    gameCode: "SG-SLOT-008",
    gameType: "SLOT",
    platFormCode: "SPADE",
  },
  {
    name: "WowProsperity",
    image: "/assets/slot/wowprosperity.webp",
    key: "SPADE",
    gameCode: "SG-SLOT-006",
    gameType: "SLOT",
    platFormCode: "SPADE",
  },
  {
    name: "PrincessWang",
    image: "/assets/slot/princesswang.webp",
    key: "SPADE",
    gameCode: "SG-SLOT-005",
    gameType: "SLOT",
    platFormCode: "SPADE",
  },
  {
    name: "FaFaFa2",
    image: "/assets/slot/fafafa2.webp",
    key: "SPADE",
    gameCode: "SG-SLOT-003",
    gameType: "SLOT",
    platFormCode: "SPADE",
  },
  {
    name: "JUNGLE BANG BANG",
    image: "/assets/slot/jungle-bang-bang.webp",
    key: "FC",
    gameCode: "FC-SLOT-051",
    gameType: "SLOT",
    platFormCode: "FC",
  },
  {
    name: "LUCKY FORTUNES 3x3",
    image: "/assets/slot/lucky-fortunes-3x3.webp",
    key: "FC",
    gameCode: "FC-SLOT-038",
    gameType: "SLOT",
    platFormCode: "FC",
  },
  {
    name: "SUPER ELEMENTS",
    image: "/assets/slot/super-elements.webp",
    key: "FC",
    gameCode: "FC-SLOT-033",
    gameType: "SLOT",
    platFormCode: "FC",
  },
  {
    name: "FORTUNE EGG",
    image: "/assets/slot/fortune-egg.webp",
    key: "FC",
    gameCode: "FC-SLOT-031",
    gameType: "SLOT",
    platFormCode: "FC",
  },
  {
    name: "WIN WIN NEKO",
    image: "/assets/slot/win-win-neko.webp",
    key: "FC",
    gameCode: "FC-SLOT-030",
    gameType: "SLOT",
    platFormCode: "FC",
  },
  {
    name: "CHINESE NEW YEAR 2",
    image: "/assets/slot/chinese-new-year-2.webp",
    key: "FC",
    gameCode: "FC-SLOT-022",
    gameType: "SLOT",
    platFormCode: "FC",
  },
  {
    name: "Lucky Fortunes",
    image: "/assets/slot/lucky-fortunes.webp",
    key: "FC",
    gameCode: "FC-SLOT-021",
    gameType: "SLOT",
    platFormCode: "FC",
  },
  {
    name: "Robin Hood",
    image: "/assets/slot/robin-hood.webp",
    key: "FC",
    gameCode: "FC-SLOT-020",
    gameType: "SLOT",
    platFormCode: "FC",
  },
  {
    name: "GLORY OF ROME",
    image: "/assets/slot/glory-of-rome.webp",
    key: "FC",
    gameCode: "FC-SLOT-019",
    gameType: "SLOT",
    platFormCode: "FC",
  },
  {
    name: "RICH MAN",
    image: "/assets/slot/rich-man.webp",
    key: "FC",
    gameCode: "FC-SLOT-018",
    gameType: "SLOT",
    platFormCode: "FC",
  },
  {
    name: "GOLD RUSH",
    image: "/assets/slot/gold-rush-2.webp",
    key: "FC",
    gameCode: "FC-SLOT-017",
    gameType: "SLOT",
    platFormCode: "FC",
  },
  {
    name: "TREASURE CRUISE",
    image: "/assets/slot/treasure-cruise.webp",
    key: "FC",
    gameCode: "FC-SLOT-016",
    gameType: "SLOT",
    platFormCode: "FC",
  },
  {
    name: "WAR OF THE UNIVERSE",
    image: "/assets/slot/war-of-the-universe.webp",
    key: "FC",
    gameCode: "FC-SLOT-015",
    gameType: "SLOT",
    platFormCode: "FC",
  },
  {
    name: "COWBOYS",
    image: "/assets/slot/cowboys.webp",
    key: "FC",
    gameCode: "FC-SLOT-014",
    gameType: "SLOT",
    platFormCode: "FC",
  },
  {
    name: "Magic Beans",
    image: "/assets/slot/magic-beans.webp",
    key: "FC",
    gameCode: "FC-SLOT-013",
    gameType: "SLOT",
    platFormCode: "FC",
  },
  {
    name: "LUXURY GOLDEN PANTHER",
    image: "/assets/slot/luxury-golden-panther.webp",
    key: "FC",
    gameCode: "FC-SLOT-012",
    gameType: "SLOT",
    platFormCode: "FC",
  },
  {
    name: "ANIMAL RACING",
    image: "/assets/slot/animal-racing.webp",
    key: "FC",
    gameCode: "FC-SLOT-011",
    gameType: "SLOT",
    platFormCode: "FC",
  },
  {
    name: "DA LE MEN",
    image: "/assets/slot/da-le-men.webp",
    key: "FC",
    gameCode: "FC-SLOT-010",
    gameType: "SLOT",
    platFormCode: "FC",
  },
  {
    name: "HAPPY DUO BAO",
    image: "/assets/slot/happy-duo-bao.webp",
    key: "FC",
    gameCode: "FC-SLOT-009",
    gameType: "SLOT",
    platFormCode: "FC",
  },
  {
    name: "FORTUNE KOI",
    image: "/assets/slot/fortune-koi.webp",
    key: "FC",
    gameCode: "FC-SLOT-008",
    gameType: "SLOT",
    platFormCode: "FC",
  },
  {
    name: "CHINESE NEW YEAR",
    image: "/assets/slot/chinese-new-year.webp",
    key: "FC",
    gameCode: "FC-SLOT-007",
    gameType: "SLOT",
    platFormCode: "FC",
  },
  {
    name: "PANDA DRAGON BOAT",
    image: "/assets/slot/panda-dragon-boat.webp",
    key: "FC",
    gameCode: "FC-SLOT-006",
    gameType: "SLOT",
    platFormCode: "FC",
  },
  {
    name: "PONG PONG HU",
    image: "/assets/slot/pong-pong-hu.webp",
    key: "FC",
    gameCode: "FC-SLOT-005",
    gameType: "SLOT",
    platFormCode: "FC",
  },
  {
    name: "NIGHT MARKET",
    image: "/assets/slot/night-market.webp",
    key: "FC",
    gameCode: "FC-SLOT-004",
    gameType: "SLOT",
    platFormCode: "FC",
  },
  {
    name: "HOT POT PARTY",
    image: "/assets/slot/hot-pot-party.webp",
    key: "FC",
    gameCode: "FC-SLOT-003",
    gameType: "SLOT",
    platFormCode: "FC",
  },
  {
    name: "THREE LITTLE PIGS",
    image: "/assets/slot/three-little-pigs.webp",
    key: "FC",
    gameCode: "FC-SLOT-002",
    gameType: "SLOT",
    platFormCode: "FC",
  },
  {
    name: "GOLDEN PANTHER",
    image: "/assets/slot/golden-panther.webp",
    key: "FC",
    gameCode: "FC-SLOT-001",
    gameType: "SLOT",
    platFormCode: "FC",
  },
  {
    name: "Lucky Pearl",
    image: "/assets/slot/lucky-pearl.webp",
    key: "JDB",
  },
  {
    name: "Dragon Soar - Hyper Wild",
    image: "/assets/slot/dragon-soar-hyper-wild.webp",
    key: "JDB",
    gameCode: "JDB-SLOT-125",
    gameType: "SLOT",
    platFormCode: "JDB",
  },
  {
    name: "Magic Ace",
    image: "/assets/slot/magic-ace.webp",
    key: "JDB",
    gameCode: "JDB-SLOT-124",
    gameType: "SLOT",
    platFormCode: "JDB",
  },
  {
    name: "Pop Pop Candy",
    image: "/assets/slot/pop-pop-candy.webp",
    key: "JDB",
    gameCode: "JDB-SLOT-120",
    gameType: "SLOT",
    platFormCode: "JDB",
  },
  {
    name: "Open Sesame Mega",
    image: "/assets/slot/open-sesame-mega.webp",
    key: "JDB",
    gameCode: "JDB-SLOT-119",
    gameType: "SLOT",
    platFormCode: "JDB",
  },
  {
    name: "Boom Fiesta",
    image: "/assets/slot/boom-fiesta.webp",
    key: "JDB",
  },
  {
    name: "Big Three Dragons",
    image: "/assets/slot/big-three-dragons.webp",
    key: "JDB",
    gameCode: "JDB-SLOT-117",
    gameType: "SLOT",
    platFormCode: "JDB",
  },
  {
    name: "LanternWealth",
    image: "/assets/slot/lanternwealth.webp",
    key: "JDB",
    gameCode: "JDB-SLOT-115",
    gameType: "SLOT",
    platFormCode: "JDB",
  },
  {
    name: "Moneybags Man 2",
    image: "/assets/slot/moneybags-man-2.webp",
    key: "JDB",
    gameCode: "JDB-SLOT-108",
    gameType: "SLOT",
    platFormCode: "JDB",
  },
  {
    name: "Trump Card",
    image: "/assets/slot/trump-card.webp",
    key: "JDB",
    gameCode: "JDB-SLOT-107",
    gameType: "SLOT",
    platFormCode: "JDB",
  },
  {
    name: "Fortune Neko",
    image: "/assets/slot/fortune-neko.webp",
    key: "JDB",
    gameCode: "JDB-SLOT-106",
    gameType: "SLOT",
    platFormCode: "JDB",
  },
  {
    name: "BookOfMystery",
    image: "/assets/slot/bookofmystery.webp",
    key: "JDB",
    gameCode: "JDB-SLOT-105",
    gameType: "SLOT",
    platFormCode: "JDB",
  },
  {
    name: "Glamorous Girl",
    image: "/assets/slot/glamorous-girl.webp",
    key: "JDB",
    gameCode: "JDB-SLOT-103",
    gameType: "SLOT",
    platFormCode: "JDB",
  },
  {
    name: "Blossom Of Wealth",
    image: "/assets/slot/blossom-of-wealth.webp",
    key: "JDB",
    gameCode: "JDB-SLOT-101",
    gameType: "SLOT",
    platFormCode: "JDB",
  },
  {
    name: "ProsperityTiger",
    image: "/assets/slot/prosperitytiger.webp",
    key: "JDB",
    gameCode: "JDB-SLOT-100",
    gameType: "SLOT",
    platFormCode: "JDB",
  },
  {
    name: "Maya Gold Crazy",
    image: "/assets/slot/maya-gold-crazy.webp",
    key: "JDB",
    gameCode: "JDB-SLOT-099",
    gameType: "SLOT",
    platFormCode: "JDB",
  },
  {
    name: "MarvelousIV",
    image: "/assets/slot/marvelousiv.webp",
    key: "JDB",
    gameCode: "JDB-SLOT-098",
    gameType: "SLOT",
    platFormCode: "JDB",
  },
  {
    name: "Wonder Elephant",
    image: "/assets/slot/wonder-elephant.webp",
    key: "JDB",
    gameCode: "JDB-SLOT-097",
    gameType: "SLOT",
    platFormCode: "JDB",
  },
  {
    name: "Kong",
    image: "/assets/slot/kong.webp",
    key: "JDB",
    gameCode: "JDB-SLOT-094",
    gameType: "SLOT",
    platFormCode: "JDB",
  },
  {
    name: "LuckyDiamond",
    image: "/assets/slot/luckydiamond.webp",
    key: "JDB",
    gameCode: "JDB-SLOT-093",
    gameType: "SLOT",
    platFormCode: "JDB",
  },
  {
    name: "DragonsGate",
    image: "/assets/slot/dragonsgate.webp",
    key: "JDB",
    gameCode: "JDB-SLOT-092",
    gameType: "SLOT",
    platFormCode: "JDB",
  },
  {
    name: "Spindrift2",
    image: "/assets/slot/spindrift2.webp",
    key: "JDB",
    gameCode: "JDB-SLOT-090",
    gameType: "SLOT",
    platFormCode: "JDB",
  },
  {
    name: "Spindrift",
    image: "/assets/slot/spindrift.webp",
    key: "JDB",
    gameCode: "JDB-SLOT-089",
    gameType: "SLOT",
    platFormCode: "JDB",
  },
  {
    name: "DoubleWilds",
    image: "/assets/slot/doublewilds.webp",
    key: "JDB",
    gameCode: "JDB-SLOT-087",
    gameType: "SLOT",
    platFormCode: "JDB",
  },
  {
    name: "MoneybagsMan",
    image: "/assets/slot/moneybagsman.webp",
    key: "JDB",
    gameCode: "JDB-SLOT-086",
    gameType: "SLOT",
    platFormCode: "JDB",
  },
  {
    name: "MinerBabe",
    image: "/assets/slot/minerbabe.webp",
    key: "JDB",
    gameCode: "JDB-SLOT-085",
    gameType: "SLOT",
    platFormCode: "JDB",
  },
  {
    name: "GoldenDisco",
    image: "/assets/slot/goldendisco.webp",
    key: "JDB",
    gameCode: "JDB-SLOT-084",
    gameType: "SLOT",
    platFormCode: "JDB",
  },
  {
    name: "Lucky Fuwa",
    image: "/assets/slot/lucky-fuwa.webp",
    key: "JDB",
  },
  {
    name: "Super Niubi Deluxe",
    image: "/assets/slot/super-niubi-deluxe.webp",
    key: "JDB",
    gameCode: "JDB-SLOT-077",
    gameType: "SLOT",
    platFormCode: "JDB",
  },
  {
    name: "Funky King Kong",
    image: "/assets/slot/funky-king-kong.webp",
    key: "JDB",
    gameCode: "JDB-SLOT-076",
    gameType: "SLOT",
    platFormCode: "JDB",
  },
  {
    name: "Treasure Bowl",
    image: "/assets/slot/treasure-bowl.webp",
    key: "JDB",
    gameCode: "JDB-SLOT-075",
    gameType: "SLOT",
    platFormCode: "JDB",
  },
  {
    name: "Mjoinir",
    image: "/assets/slot/mjoinir.webp",
    key: "JDB",
    gameCode: "JDB-SLOT-074",
    gameType: "SLOT",
    platFormCode: "JDB",
  },
  {
    name: "Pirate Treasure",
    image: "/assets/slot/pirate-treasure.webp",
    key: "JDB",
  },
  {
    name: "Fortune Treasure",
    image: "/assets/slot/fortune-treasure.webp",
    key: "JDB",
    gameCode: "JDB-SLOT-072",
    gameType: "SLOT",
    platFormCode: "JDB",
  },
  {
    name: "Egypt Treasure",
    image: "/assets/slot/egypt-treasure.webp",
    key: "JDB",
  },
  {
    name: "Super Niubi",
    image: "/assets/slot/super-niubi.webp",
    key: "JDB",
    gameCode: "JDB-SLOT-070",
    gameType: "SLOT",
    platFormCode: "JDB",
  },
  {
    name: "Dragons World",
    image: "/assets/slot/dragons-world.webp",
    key: "JDB",
    gameCode: "JDB-SLOT-069",
    gameType: "SLOT",
    platFormCode: "JDB",
  },
  {
    name: "GoLaiFu",
    image: "/assets/slot/golaifu.webp",
    key: "JDB",
    gameCode: "JDB-SLOT-067",
    gameType: "SLOT",
    platFormCode: "JDB",
  },
  {
    name: "BirdsParty",
    image: "/assets/slot/birdsparty.webp",
    key: "JDB",
    gameCode: "JDB-SLOT-066",
    gameType: "SLOT",
    platFormCode: "JDB",
  },
  {
    name: "LuckyRacing",
    image: "/assets/slot/luckyracing.webp",
    key: "JDB",
  },
  {
    name: "Daji",
    image: "/assets/slot/daji.webp",
    key: "JDB",
  },
  {
    name: "StreetFighter",
    image: "/assets/slot/streetfighter.webp",
    key: "JDB",
  },
  {
    name: "OnePunchMan",
    image: "/assets/slot/onepunchman.webp",
    key: "JDB",
  },
  {
    name: "MrBao",
    image: "/assets/slot/mrbao.webp",
    key: "JDB",
  },
  {
    name: "PandaPanda",
    image: "/assets/slot/pandapanda.webp",
    key: "JDB",
  },
  {
    name: "XiYangYang",
    image: "/assets/slot/jdb-slot-054-0.webp",
    key: "JDB",
    gameCode: "JDB-SLOT-054",
    gameType: "SLOT",
    platFormCode: "JDB",
  },
  {
    name: "FortuneHorse",
    image: "/assets/slot/fortunehorse.webp",
    key: "JDB",
    gameCode: "JDB-SLOT-053",
    gameType: "SLOT",
    platFormCode: "JDB",
  },
  {
    name: "FlirtingScholarTangII",
    image: "/assets/slot/flirtingscholartangii.webp",
    key: "JDB",
  },
  {
    name: "OpenSesameII",
    image: "/assets/slot/opensesameii.webp",
    key: "JDB",
    gameCode: "JDB-SLOT-051",
    gameType: "SLOT",
    platFormCode: "JDB",
  },
  {
    name: "WinningMaskII",
    image: "/assets/slot/winningmaskii.webp",
    key: "JDB",
    gameCode: "JDB-SLOT-050",
    gameType: "SLOT",
    platFormCode: "JDB",
  },
  {
    name: "LuckyPhoenix",
    image: "/assets/slot/luckyphoenix.webp",
    key: "JDB",
  },
  {
    name: "Napoleon",
    image: "/assets/slot/napoleon.webp",
    key: "JDB",
    gameCode: "JDB-SLOT-048",
    gameType: "SLOT",
    platFormCode: "JDB",
  },
  {
    name: "LuckyLion",
    image: "/assets/slot/luckylion.webp",
    key: "JDB",
  },
  {
    name: "LuckyDragons",
    image: "/assets/slot/luckydragons.webp",
    key: "JDB",
    gameCode: "JDB-SLOT-045",
    gameType: "SLOT",
    platFormCode: "JDB",
  },
  {
    name: "Legendary5",
    image: "/assets/slot/legendary5.webp",
    key: "JDB",
    gameCode: "JDB-SLOT-044",
    gameType: "SLOT",
    platFormCode: "JDB",
  },
  {
    name: "TripleKingKong",
    image: "/assets/slot/triplekingkong.webp",
    key: "JDB",
    gameCode: "JDB-SLOT-043",
    gameType: "SLOT",
    platFormCode: "JDB",
  },
  {
    name: "OrientAnimals",
    image: "/assets/slot/orientanimals.webp",
    key: "JDB",
    gameCode: "JDB-SLOT-042",
    gameType: "SLOT",
    platFormCode: "JDB",
  },
  {
    name: "LuckySeven",
    image: "/assets/slot/luckyseven.webp",
    key: "JDB",
    gameCode: "JDB-SLOT-041",
    gameType: "SLOT",
    platFormCode: "JDB",
  },
  {
    name: "Mining Upstart",
    image: "/assets/slot/mining-upstart.webp",
    key: "JDB",
  },
  {
    name: "ChefPanda",
    image: "/assets/slot/chefpanda.webp",
    key: "JDB",
  },
  {
    name: "RollingInMoney",
    image: "/assets/slot/rollinginmoney.webp",
    key: "JDB",
  },
  {
    name: "Kingsman",
    image: "/assets/slot/kingsman.webp",
    key: "JDB",
    gameCode: "JDB-SLOT-033",
    gameType: "SLOT",
    platFormCode: "JDB",
  },
  {
    name: "DragonWarrior",
    image: "/assets/slot/dragonwarrior.webp",
    key: "JDB",
    gameCode: "JDB-SLOT-032",
    gameType: "SLOT",
    platFormCode: "JDB",
  },
  {
    name: "Billionaire",
    image: "/assets/slot/billionaire.webp",
    key: "JDB",
    gameCode: "JDB-SLOT-031",
    gameType: "SLOT",
    platFormCode: "JDB",
  },
  {
    name: "GuanGong",
    image: "/assets/slot/guangong.webp",
    key: "JDB",
  },
  {
    name: "Mahjong",
    image: "/assets/slot/mahjong.webp",
    key: "JDB",
    gameCode: "JDB-SLOT-029",
    gameType: "SLOT",
    platFormCode: "JDB",
  },
  {
    name: "MoonlightTreasure",
    image: "/assets/slot/moonlighttreasure.webp",
    key: "JDB",
    gameCode: "JDB-SLOT-028",
    gameType: "SLOT",
    platFormCode: "JDB",
  },
  {
    name: "MonkeyKing",
    image: "/assets/slot/monkeyking.webp",
    key: "JDB",
  },
  {
    name: "RoosterInLove",
    image: "/assets/slot/roosterinlove.webp",
    key: "JDB",
    gameCode: "JDB-SLOT-026",
    gameType: "SLOT",
    platFormCode: "JDB",
  },
  {
    name: "Dragon",
    image: "/assets/slot/dragon.webp",
    key: "JDB",
    gameCode: "JDB-SLOT-025",
    gameType: "SLOT",
    platFormCode: "JDB",
  },
  {
    name: "OlympianTemple",
    image: "/assets/slot/olympiantemple.webp",
    key: "JDB",
    gameCode: "JDB-SLOT-020",
    gameType: "SLOT",
    platFormCode: "JDB",
  },
  {
    name: "BananaSaga",
    image: "/assets/slot/bananasaga.webp",
    key: "JDB",
    gameCode: "JDB-SLOT-019",
    gameType: "SLOT",
    platFormCode: "JDB",
  },
  {
    name: "OpenSesame",
    image: "/assets/slot/opensesame.webp",
    key: "JDB",
    gameCode: "JDB-SLOT-018",
    gameType: "SLOT",
    platFormCode: "JDB",
  },
  {
    name: "FourTreasures",
    image: "/assets/slot/fourtreasures.webp",
    key: "JDB",
    gameCode: "JDB-SLOT-017",
    gameType: "SLOT",
    platFormCode: "JDB",
  },
  {
    name: "NewYear",
    image: "/assets/slot/newyear.webp",
    key: "JDB",
    gameCode: "JDB-SLOT-016",
    gameType: "SLOT",
    platFormCode: "JDB",
  },
  {
    name: "LuckyQilin",
    image: "/assets/slot/luckyqilin.webp",
    key: "JDB",
  },
  {
    name: "FormosaBear",
    image: "/assets/slot/formosabear.webp",
    key: "JDB",
    gameCode: "JDB-SLOT-014",
    gameType: "SLOT",
    platFormCode: "JDB",
  },
  {
    name: "LlamaAdventure",
    image: "/assets/slot/llamaadventure.webp",
    key: "JDB",
    gameCode: "JDB-SLOT-013",
    gameType: "SLOT",
    platFormCode: "JDB",
  },
  {
    name: "WuKong",
    image: "/assets/slot/wukong.webp",
    key: "JDB",
    gameCode: "JDB-SLOT-012",
    gameType: "SLOT",
    platFormCode: "JDB",
  },
  {
    name: "WinningMask",
    image: "/assets/slot/winningmask.webp",
    key: "JDB",
    gameCode: "JDB-SLOT-011",
    gameType: "SLOT",
    platFormCode: "JDB",
  },
  {
    name: "Cash Explorer",
    image: "/assets/slot/cash-explorer.webp",
    key: "RT",
    gameCode: "RT-SLOT-339",
    gameType: "SLOT",
    platFormCode: "RT",
  },
  {
    name: "Wild Hot Chilli Reels 2",
    image: "/assets/slot/wild-hot-chilli-reels-2.webp",
    key: "RT",
    gameCode: "RT-SLOT-342",
    gameType: "SLOT",
    platFormCode: "RT",
  },
  {
    name: "Wings of Ra Megaways",
    image: "/assets/slot/wings-of-ra-megaways.webp",
    key: "RT",
    gameCode: "RT-SLOT-335",
    gameType: "SLOT",
    platFormCode: "RT",
  },
  {
    name: "Dear Santa",
    image: "/assets/slot/dear-santa.webp",
    key: "RT",
    gameCode: "RT-SLOT-336",
    gameType: "SLOT",
    platFormCode: "RT",
  },
  {
    name: "Gladiator Ways",
    image: "/assets/slot/gladiator-ways.webp",
    key: "RT",
    gameCode: "RT-SLOT-359",
    gameType: "SLOT",
    platFormCode: "RT",
  },
  {
    name: "Diamond Doggies",
    image: "/assets/slot/diamond-doggies.webp",
    key: "RT",
    gameCode: "RT-SLOT-332",
    gameType: "SLOT",
    platFormCode: "RT",
  },
  {
    name: "Sea Boat Adventure Megaways",
    image: "/assets/slot/sea-boat-adventure-megaways.webp",
    key: "RT",
    gameCode: "RT-SLOT-333",
    gameType: "SLOT",
    platFormCode: "RT",
  },
  {
    name: "The Good, The Bad and The Rich",
    image: "/assets/slot/the-good-the-bad-and-the-rich.webp",
    key: "RT",
    gameCode: "RT-SLOT-331",
    gameType: "SLOT",
    platFormCode: "RT",
  },
  {
    name: "Zeus Lightning Megaways",
    image: "/assets/slot/zeus-lightning-megaways.webp",
    key: "RT",
    gameCode: "RT-SLOT-334",
    gameType: "SLOT",
    platFormCode: "RT",
  },
  {
    name: "Atlantis",
    image: "/assets/slot/atlantis.webp",
    key: "RT",
    gameCode: "RT-SLOT-113",
    gameType: "SLOT",
    platFormCode: "RT",
  },
  {
    name: "Reactor",
    image: "/assets/slot/reactor.webp",
    key: "RT",
    gameCode: "RT-SLOT-062",
    gameType: "SLOT",
    platFormCode: "RT",
  },
  {
    name: "Bombuster",
    image: "/assets/slot/bombuster.webp",
    key: "RT",
    gameCode: "RT-SLOT-143",
    gameType: "SLOT",
    platFormCode: "RT",
  },
  {
    name: "Trillionaire",
    image: "/assets/slot/trillionaire.webp",
    key: "RT",
    gameCode: "RT-SLOT-166",
    gameType: "SLOT",
    platFormCode: "RT",
  },
  {
    name: "Gemtastic",
    image: "/assets/slot/gemtastic.webp",
    key: "RT",
    gameCode: "RT-SLOT-024",
    gameType: "SLOT",
    platFormCode: "RT",
  },
  {
    name: "Phoenix",
    image: "/assets/slot/phoenix.webp",
    key: "RT",
    gameCode: "RT-SLOT-064",
    gameType: "SLOT",
    platFormCode: "RT",
  },
  {
    name: "Masquerade",
    image: "/assets/slot/masquerade.webp",
    key: "RT",
    gameCode: "RT-SLOT-044",
    gameType: "SLOT",
    platFormCode: "RT",
  },
  {
    name: "Dragons’ Lock",
    image: "/assets/slot/dragons-lock.webp",
    key: "RT",
    gameCode: "RT-SLOT-338",
    gameType: "SLOT",
    platFormCode: "RT",
  },
  {
    name: "7’s Luck",
    image: "/assets/slot/7-s-luck.webp",
    key: "RT",
  },
  {
    name: "Wolf Stacks Megaways",
    image: "/assets/slot/wolf-stacks-megaways.webp",
    key: "RT",
    gameCode: "RT-SLOT-344",
    gameType: "SLOT",
    platFormCode: "RT",
  },
  {
    name: "Trophy Fish",
    image: "/assets/slot/trophy-fish.webp",
    key: "RT",
    gameCode: "RT-SLOT-343",
    gameType: "SLOT",
    platFormCode: "RT",
  },
  {
    name: "Trillionaire Megaways",
    image: "/assets/slot/trillionaire-megaways.webp",
    key: "RT",
    gameCode: "RT-SLOT-345",
    gameType: "SLOT",
    platFormCode: "RT",
  },
  {
    name: "Serpent King",
    image: "/assets/slot/serpent-king.webp",
    key: "RT",
    gameCode: "RT-SLOT-348",
    gameType: "SLOT",
    platFormCode: "RT",
  },
  {
    name: "Bass Boss Megaways",
    image: "/assets/slot/bass-boss-megaways.webp",
    key: "RT",
    gameCode: "RT-SLOT-350",
    gameType: "SLOT",
    platFormCode: "RT",
  },
  {
    name: "Farmtastic",
    image: "/assets/slot/farmtastic.webp",
    key: "RT",
    gameCode: "RT-SLOT-357",
    gameType: "SLOT",
    platFormCode: "RT",
  },
  {
    name: "Jackrabbit Jackpots",
    image: "/assets/slot/jackrabbit-jackpots.webp",
    key: "RT",
    gameCode: "RT-SLOT-356",
    gameType: "SLOT",
    platFormCode: "RT",
  },
  {
    name: "1942 Sky Warrior",
    image: "/assets/slot/1942-sky-warrior.webp",
    key: "RT",
  },
  {
    name: "Ali Baba's Luck",
    image: "/assets/slot/ali-baba-s-luck.webp",
    key: "RT",
    gameCode: "RT-SLOT-247",
    gameType: "SLOT",
    platFormCode: "RT",
  },
  {
    name: "Blazing Clusters",
    image: "/assets/slot/blazing-clusters.webp",
    key: "RT",
    gameCode: "RT-SLOT-172",
    gameType: "SLOT",
    platFormCode: "RT",
  },
  {
    name: "Beriched",
    image: "/assets/slot/beriched.webp",
    key: "RT",
    gameCode: "RT-SLOT-217",
    gameType: "SLOT",
    platFormCode: "RT",
  },
  {
    name: "Big Cat Rescue Megaways",
    image: "/assets/slot/big-cat-rescue-megaways.webp",
    key: "RT",
    gameCode: "RT-SLOT-182",
    gameType: "SLOT",
    platFormCode: "RT",
  },
  {
    name: "Casino Spin",
    image: "/assets/slot/casino-spin.webp",
    key: "RT",
    gameCode: "RT-SLOT-275",
    gameType: "SLOT",
    platFormCode: "RT",
  },
  {
    name: "Bulls Run Wild",
    image: "/assets/slot/bulls-run-wild.webp",
    key: "RT",
    gameCode: "RT-SLOT-180",
    gameType: "SLOT",
    platFormCode: "RT",
  },
  {
    name: "Zillard King Megaways",
    image: "/assets/slot/zillard-king-megaways.webp",
    key: "RT",
    gameCode: "RT-SLOT-355",
    gameType: "SLOT",
    platFormCode: "RT",
  },
  {
    name: "Cobra Queen",
    image: "/assets/slot/cobra-queen.webp",
    key: "RT",
    gameCode: "RT-SLOT-276",
    gameType: "SLOT",
    platFormCode: "RT",
  },
  {
    name: "Desert Legends Spins",
    image: "/assets/slot/desert-legends-spins.webp",
    key: "RT",
  },
  {
    name: "Diamond Royale",
    image: "/assets/slot/diamond-royale.webp",
    key: "RT",
    gameCode: "RT-SLOT-183",
    gameType: "SLOT",
    platFormCode: "RT",
  },
  {
    name: "Dracula Awakening",
    image: "/assets/slot/dracula-awakening.webp",
    key: "RT",
    gameCode: "RT-SLOT-220",
    gameType: "SLOT",
    platFormCode: "RT",
  },
  {
    name: "Dragons Clusterbuster",
    image: "/assets/slot/dragons-clusterbuster.webp",
    key: "RT",
    gameCode: "RT-SLOT-117",
    gameType: "SLOT",
    platFormCode: "RT",
  },
  {
    name: "Dream Destiny",
    image: "/assets/slot/dream-destiny.webp",
    key: "RT",
    gameCode: "RT-SLOT-278",
    gameType: "SLOT",
    platFormCode: "RT",
  },
  {
    name: "Doggy Riches Megaways",
    image: "/assets/slot/doggy-riches-megaways.webp",
    key: "RT",
    gameCode: "RT-SLOT-177",
    gameType: "SLOT",
    platFormCode: "RT",
  },
  {
    name: "Zillard King",
    image: "/assets/slot/zillard-king.webp",
    key: "RT",
    gameCode: "RT-SLOT-102",
    gameType: "SLOT",
    platFormCode: "RT",
  },
  {
    name: "Epic Treasure",
    image: "/assets/slot/epic-treasure.webp",
    key: "RT",
    gameCode: "RT-SLOT-279",
    gameType: "SLOT",
    platFormCode: "RT",
  },
  {
    name: "Flodder",
    image: "/assets/slot/flodder.webp",
    key: "RT",
    gameCode: "RT-SLOT-184",
    gameType: "SLOT",
    platFormCode: "RT",
  },
  {
    name: "Fa Fa Babies",
    image: "/assets/slot/fa-fa-babies.webp",
    key: "RT",
    gameCode: "RT-SLOT-175",
    gameType: "SLOT",
    platFormCode: "RT",
  },
  {
    name: "Genie Nights",
    image: "/assets/slot/genie-nights.webp",
    key: "RT",
    gameCode: "RT-SLOT-178",
    gameType: "SLOT",
    platFormCode: "RT",
  },
  {
    name: "Jelly Multihops",
    image: "/assets/slot/jelly-multihops.webp",
    key: "RT",
    gameCode: "RT-SLOT-246",
    gameType: "SLOT",
    platFormCode: "RT",
  },
  {
    name: "Hustling",
    image: "/assets/slot/hustling.webp",
    key: "RT",
    gameCode: "RT-SLOT-173",
    gameType: "SLOT",
    platFormCode: "RT",
  },
  {
    name: "Hot Hot Chilli Pot",
    image: "/assets/slot/hot-hot-chilli-pot.webp",
    key: "RT",
    gameCode: "RT-SLOT-219",
    gameType: "SLOT",
    platFormCode: "RT",
  },
  {
    name: "Get The Gold InfiniReels",
    image: "/assets/slot/get-the-gold-infinireels.webp",
    key: "RT",
    gameCode: "RT-SLOT-174",
    gameType: "SLOT",
    platFormCode: "RT",
  },
  {
    name: "Jingle Ways Megaways",
    image: "/assets/slot/jingle-ways-megaways.webp",
    key: "RT",
    gameCode: "RT-SLOT-171",
    gameType: "SLOT",
    platFormCode: "RT",
  },
  {
    name: "Miami Rise",
    image: "/assets/slot/miami-rise.webp",
    key: "RT",
    gameCode: "RT-SLOT-354",
    gameType: "SLOT",
    platFormCode: "RT",
  },
  {
    name: "Last Chance Saloon",
    image: "/assets/slot/last-chance-saloon.webp",
    key: "RT",
    gameCode: "RT-SLOT-176",
    gameType: "SLOT",
    platFormCode: "RT",
  },
  {
    name: "Mayhem",
    image: "/assets/slot/mayhem.webp",
    key: "RT",
    gameCode: "RT-SLOT-181",
    gameType: "SLOT",
    platFormCode: "RT",
  },
  {
    name: "Risque Megaways",
    image: "/assets/slot/risque-megaways.webp",
    key: "RT",
    gameCode: "RT-SLOT-185",
    gameType: "SLOT",
    platFormCode: "RT",
  },
  {
    name: "Viral Spiral",
    image: "/assets/slot/viral-spiral.webp",
    key: "RT",
    gameCode: "RT-SLOT-132",
    gameType: "SLOT",
    platFormCode: "RT",
  },
  {
    name: "Wild Tundra",
    image: "/assets/slot/wild-tundra.webp",
    key: "RT",
    gameCode: "RT-SLOT-189",
    gameType: "SLOT",
    platFormCode: "RT",
  },
  {
    name: "Wanted Wildz",
    image: "/assets/slot/wanted-wildz.webp",
    key: "RT",
    gameCode: "RT-SLOT-280",
    gameType: "SLOT",
    platFormCode: "RT",
  },
  {
    name: "Zaida's Fortune",
    image: "/assets/slot/zaida-s-fortune.webp",
    key: "RT",
    gameCode: "RT-SLOT-186",
    gameType: "SLOT",
    platFormCode: "RT",
  },
  {
    name: "Wild Expedition",
    image: "/assets/slot/wild-expedition.webp",
    key: "RT",
    gameCode: "RT-SLOT-218",
    gameType: "SLOT",
    platFormCode: "RT",
  },
  {
    name: "Cash Goddess",
    image: "/assets/slot/cash-goddess.webp",
    key: "RT",
    gameCode: "RT-SLOT-353",
    gameType: "SLOT",
    platFormCode: "RT",
  },
  {
    name: "777 Diamond Strike",
    image: "/assets/slot/777-diamond-strike.webp",
    key: "RT",
    gameCode: "RT-SLOT-352",
    gameType: "SLOT",
    platFormCode: "RT",
  },
  {
    name: "Rise of Cleopatra",
    image: "/assets/slot/rise-of-cleopatra.webp",
    key: "RT",
    gameCode: "RT-SLOT-351",
    gameType: "SLOT",
    platFormCode: "RT",
  },
  {
    name: "Big Gains",
    image: "/assets/slot/big-gains.webp",
    key: "RT",
    gameCode: "RT-SLOT-358",
    gameType: "SLOT",
    platFormCode: "RT",
  },
  {
    name: "Aztec Shamans MegaWays",
    image: "/assets/slot/aztec-shamans-megaways.webp",
    key: "RT",
    gameCode: "RT-SLOT-361",
    gameType: "SLOT",
    platFormCode: "RT",
  },
  {
    name: "Thor's Rage",
    image: "/assets/slot/thor-s-rage.webp",
    key: "RT",
    gameCode: "RT-SLOT-360",
    gameType: "SLOT",
    platFormCode: "RT",
  },
  {
    name: "Fish n Fish",
    image: "/assets/slot/fish-n-fish.webp",
    key: "RT",
    gameCode: "RT-SLOT-363",
    gameType: "SLOT",
    platFormCode: "RT",
  },
  {
    name: "Play with the Devil MegaWays",
    image: "/assets/slot/play-with-the-devil-megaways.webp",
    key: "RT",
    gameCode: "RT-SLOT-362",
    gameType: "SLOT",
    platFormCode: "RT",
  },
  {
    name: "Take the Money",
    image: "/assets/slot/take-the-money.webp",
    key: "RT",
    gameCode: "RT-SLOT-365",
    gameType: "SLOT",
    platFormCode: "RT",
  },
  {
    name: "Lava Joker",
    image: "/assets/slot/lava-joker.webp",
    key: "RT",
    gameCode: "RT-SLOT-364",
    gameType: "SLOT",
    platFormCode: "RT",
  },
  {
    name: "Cash Lamps",
    image: "/assets/slot/cash-lamps.webp",
    key: "RT",
    gameCode: "RT-SLOT-366",
    gameType: "SLOT",
    platFormCode: "RT",
  },
  {
    name: "Book Of Desert Legends",
    image: "/assets/slot/book-of-desert-legends.webp",
    key: "RT",
    gameCode: "RT-SLOT-367",
    gameType: "SLOT",
    platFormCode: "RT",
  },
  {
    name: "Land of Riches",
    image: "/assets/slot/land-of-riches.webp",
    key: "RT",
    gameCode: "RT-SLOT-368",
    gameType: "SLOT",
    platFormCode: "RT",
  },
  {
    name: "Arc Of Zeus",
    image: "/assets/slot/arc-of-zeus.webp",
    key: "RT",
    gameCode: "RT-SLOT-369",
    gameType: "SLOT",
    platFormCode: "RT",
  },
  {
    name: "Bloody Murder",
    image: "/assets/slot/bloody-murder.webp",
    key: "RT",
    gameCode: "RT-SLOT-371",
    gameType: "SLOT",
    platFormCode: "RT",
  },
  {
    name: "Spartan Wildz",
    image: "/assets/slot/spartan-wildz.webp",
    key: "RT",
    gameCode: "RT-SLOT-370",
    gameType: "SLOT",
    platFormCode: "RT",
  },
  {
    name: "Dragon Duo",
    image: "/assets/slot/dragon-duo.webp",
    key: "RT",
  },
  {
    name: "Cash Volt Supercharged",
    image: "/assets/slot/cash-volt-supercharged.webp",
    key: "RT",
  },
  {
    name: "Big Rich Turkeys",
    image: "/assets/slot/big-rich-turkeys.webp",
    key: "RT",
  },
  {
    name: "Biggest Vault",
    image: "/assets/slot/biggest-vault.webp",
    key: "RT",
  },
  {
    name: "Jingle Bells Bonanza 2",
    image: "/assets/slot/jingle-bells-bonanza-2.webp",
    key: "RT",
  },
  {
    name: "Pirates' Plenty: Treasures of the Seas",
    image: "/assets/slot/pirates-plenty-treasures-of-the-seas.webp",
    key: "RT",
  },
  {
    name: "ROBO Lab",
    image: "/assets/slot/robo-lab.webp",
    key: "RT",
  },
  {
    name: "Piggy Riches Begins",
    image: "/assets/slot/piggy-riches-begins.webp",
    key: "RT",
  },
  {
    name: "Revolvero",
    image: "/assets/slot/revolvero.webp",
    key: "RT",
  },
  {
    name: "Monopoly Cash is King",
    image: "/assets/slot/monopoly-cash-is-king.webp",
    key: "RT",
  },
  {
    name: "Digging for Wilds",
    image: "/assets/slot/digging-for-wilds.webp",
    key: "RT",
  },
  {
    name: "Dragon Boyz",
    image: "/assets/slot/dragon-boyz.webp",
    key: "RT",
  },
  {
    name: "Monopoly Rent Rush",
    image: "/assets/slot/monopoly-rent-rush.webp",
    key: "RT",
  },
  {
    name: "Monopoly Money Magnate",
    image: "/assets/slot/monopoly-money-magnate.webp",
    key: "RT",
  },
  {
    name: "Archdragon King",
    image: "/assets/slot/archdragon-king.webp",
    key: "RT",
  },
  {
    name: "Shark Boss",
    image: "/assets/slot/shark-boss.webp",
    key: "RT",
  },
  {
    name: "Aztec Tribute",
    image: "/assets/slot/aztec-tribute.webp",
    key: "RT",
  },
  {
    name: "Dynamite Riches The Mother Lode",
    image: "/assets/slot/dynamite-riches-the-mother-lode.webp",
    key: "RT",
  },
  {
    name: "Panda Goes Boom",
    image: "/assets/slot/panda-goes-boom.webp",
    key: "RT",
  },
  {
    name: "Hit the Jungle",
    image: "/assets/slot/hit-the-jungle.webp",
    key: "RT",
  },
  {
    name: "Diamond Blitz 3",
    image: "/assets/slot/diamond-blitz-3.webp",
    key: "RT",
  },
  {
    name: "Gold Digger Cluster Buster",
    image: "/assets/slot/gold-digger-cluster-buster.webp",
    key: "RT",
  },
  {
    name: "Happy Cappy",
    image: "/assets/slot/happy-cappy.webp",
    key: "RT",
  },
  {
    name: "777 Money Strike",
    image: "/assets/slot/777-money-strike.webp",
    key: "RT",
  },
  {
    name: "Bounty Cove",
    image: "/assets/slot/bounty-cove.webp",
    key: "RT",
  },
  {
    name: "Moon Spell",
    image: "/assets/slot/moon-spell.webp",
    key: "RT",
    gameCode: "RT-SLOT-330",
    gameType: "SLOT",
    platFormCode: "RT",
  },
  {
    name: "Los Muertos Locos",
    image: "/assets/slot/los-muertos-locos.webp",
    key: "RT",
    gameCode: "RT-SLOT-329",
    gameType: "SLOT",
    platFormCode: "RT",
  },
  {
    name: "Savannah Pride",
    image: "/assets/slot/savannah-pride.webp",
    key: "RT",
    gameCode: "RT-SLOT-328",
    gameType: "SLOT",
    platFormCode: "RT",
  },
  {
    name: "Egypt Clusterbuster",
    image: "/assets/slot/egypt-clusterbuster.webp",
    key: "RT",
    gameCode: "RT-SLOT-327",
    gameType: "SLOT",
    platFormCode: "RT",
  },
  {
    name: "Roman Emperors",
    image: "/assets/slot/roman-emperors.webp",
    key: "RT",
    gameCode: "RT-SLOT-326",
    gameType: "SLOT",
    platFormCode: "RT",
  },
  {
    name: "Turtle Paradise",
    image: "/assets/slot/turtle-paradise.webp",
    key: "RT",
    gameCode: "RT-SLOT-325",
    gameType: "SLOT",
    platFormCode: "RT",
  },
  {
    name: "Diamond Blitz 2",
    image: "/assets/slot/diamond-blitz-2.webp",
    key: "RT",
    gameCode: "RT-SLOT-323",
    gameType: "SLOT",
    platFormCode: "RT",
  },
  {
    name: "Fa Fa Babies 2",
    image: "/assets/slot/fa-fa-babies-2.webp",
    key: "RT",
    gameCode: "RT-SLOT-322",
    gameType: "SLOT",
    platFormCode: "RT",
  },
  {
    name: "Epic Treasure 2",
    image: "/assets/slot/epic-treasure-2.webp",
    key: "RT",
    gameCode: "RT-SLOT-319",
    gameType: "SLOT",
    platFormCode: "RT",
  },
  {
    name: "Ultra Rich",
    image: "/assets/slot/ultra-rich.webp",
    key: "RT",
    gameCode: "RT-SLOT-320",
    gameType: "SLOT",
    platFormCode: "RT",
  },
  {
    name: "Emperor of India",
    image: "/assets/slot/emperor-of-india.webp",
    key: "RT",
    gameCode: "RT-SLOT-315",
    gameType: "SLOT",
    platFormCode: "RT",
  },
  {
    name: "Piggy Riches 2 Megaways",
    image: "/assets/slot/piggy-riches-2-megaways.webp",
    key: "RT",
  },
  {
    name: "Purr Power",
    image: "/assets/slot/purr-power.webp",
    key: "RT",
    gameCode: "RT-SLOT-317",
    gameType: "SLOT",
    platFormCode: "RT",
  },
  {
    name: "Cannonball Cash",
    image: "/assets/slot/cannonball-cash.webp",
    key: "RT",
    gameCode: "RT-SLOT-314",
    gameType: "SLOT",
    platFormCode: "RT",
  },
  {
    name: "Rainbow Jackpots Megaways",
    image: "/assets/slot/rainbow-jackpots-megaways.webp",
    key: "RT",
    gameCode: "RT-SLOT-313",
    gameType: "SLOT",
    platFormCode: "RT",
  },
  {
    name: "Sword Stomp",
    image: "/assets/slot/sword-stomp.webp",
    key: "RT",
    gameCode: "RT-SLOT-318",
    gameType: "SLOT",
    platFormCode: "RT",
  },
  {
    name: "Fruit Flash",
    image: "/assets/slot/fruit-flash.webp",
    key: "RT",
    gameCode: "RT-SLOT-312",
    gameType: "SLOT",
    platFormCode: "RT",
  },
  {
    name: "Viking’s Legacy Everyway",
    image: "/assets/slot/viking-s-legacy-everyway.webp",
    key: "RT",
  },
  {
    name: "Gold Mine Mistress",
    image: "/assets/slot/gold-mine-mistress.webp",
    key: "RT",
    gameCode: "RT-SLOT-289",
    gameType: "SLOT",
    platFormCode: "RT",
  },
  {
    name: "Primate King Megaways",
    image: "/assets/slot/primate-king-megaways.webp",
    key: "RT",
    gameCode: "RT-SLOT-308",
    gameType: "SLOT",
    platFormCode: "RT",
  },
];
export const Table = [
  {
    name: "TeenPatti Joker",
    image: "/assets/table/teenpatti-joker.webp",
    key: "JILI",
    gameCode: "JILI-TABLE-010",
    gameType: "TABLE",
    platFormCode: "JILI",
  },
  {
    name: "Callbreak",
    image: "/assets/table/callbreak.webp",
    key: "JILI",
    gameCode: "JILI-TABLE-009",
    gameType: "TABLE",
    platFormCode: "JILI",
  },
  {
    name: "Rummy",
    image: "/assets/table/rummy.webp",
    key: "JILI",
    gameCode: "JILI-TABLE-004",
    gameType: "TABLE",
    platFormCode: "JILI",
  },
  {
    name: "Andar Bahar",
    image: "/assets/table/andar-bahar.webp",
    key: "JILI",
    gameCode: "JILI-TABLE-003",
    gameType: "TABLE",
    platFormCode: "JILI",
  },
  {
    name: "AK47",
    image: "/assets/table/ak47.webp",
    key: "JILI",
    gameCode: "JILI-TABLE-002",
    gameType: "TABLE",
    platFormCode: "JILI",
  },
  {
    name: "Domino Go",
    image: "/assets/table/domino-go.webp",
    key: "JILI",
    gameCode: "JILI-TABLE-073",
    gameType: "TABLE",
    platFormCode: "JILI",
  },
  {
    name: "Penalty Kick",
    image: "/assets/table/penalty-kick.webp",
    key: "JILI",
    gameCode: "JILI-TABLE-072",
    gameType: "TABLE",
    platFormCode: "JILI",
  },
  {
    name: "Golden Treasure",
    image: "/assets/table/golden-treasure.webp",
    key: "JILI",
    gameCode: "JILI-TABLE-077",
    gameType: "TABLE",
    platFormCode: "JILI",
  },
  {
    name: "Color Game Extreme",
    image: "/assets/table/color-game-extreme.webp",
    key: "JILI",
    gameCode: "JILI-TABLE-078",
    gameType: "TABLE",
    platFormCode: "JILI",
  },
  {
    name: "Chicken Dash",
    image: "/assets/table/chicken-dash.webp",
    key: "JILI",
    gameCode: "JILI-TABLE-082",
    gameType: "TABLE",
    platFormCode: "JILI",
  },
  {
    name: "Plinko of Mine",
    image: "/assets/table/plinko-of-mine.webp",
    key: "JILI",
    gameCode: "JILI-TABLE-085",
    gameType: "TABLE",
    platFormCode: "JILI",
  },
  {
    name: "Drop Ball",
    image: "/assets/table/drop-ball.webp",
    key: "JILI",
    gameCode: "JILI-TABLE-086",
    gameType: "TABLE",
    platFormCode: "JILI",
  },
  {
    name: "Mines Grand",
    image: "/assets/table/mines-grand.webp",
    key: "JILI",
    gameCode: "JILI-TABLE-076",
    gameType: "TABLE",
    platFormCode: "JILI",
  },
  {
    name: "Jogo do Bicho",
    image: "/assets/table/jogo-do-bicho.webp",
    key: "JILI",
    gameCode: "JILI-TABLE-052",
    gameType: "TABLE",
    platFormCode: "JILI",
  },
  {
    name: "Frog Dash",
    image: "/assets/table/frog-dash.webp",
    key: "JILI",
    gameCode: "JILI-TABLE-088",
    gameType: "TABLE",
    platFormCode: "JILI",
  },
  {
    name: "Cricket Roulette",
    image: "/assets/table/cricket-roulette.webp",
    key: "JILI",
    gameCode: "JILI-TABLE-060",
    gameType: "TABLE",
    platFormCode: "JILI",
  },
  {
    name: "Golden Treasure Lightning",
    image: "/assets/table/golden-treasure-lightning.webp",
    key: "JILI",
    gameCode: "JILI-TABLE-079",
    gameType: "TABLE",
    platFormCode: "JILI",
  },
  {
    name: "Chicken Dash 10000",
    image: "/assets/table/chicken-dash-10000.webp",
    key: "JILI",
  },
  {
    name: "Mines Cricket",
    image: "/assets/table/mines-cricket.webp",
    key: "JILI",
    gameCode: "JILI-TABLE-080",
    gameType: "TABLE",
    platFormCode: "JILI",
  },
  {
    name: "Plinko Football",
    image: "/assets/table/plinko-football.webp",
    key: "JILI",
  },
  {
    name: "Speed AndarBahar",
    image: "/assets/table/speed-andarbahar.webp",
    key: "JILI",
  },
  {
    name: "Chicken Dash Jackpot",
    image: "/assets/table/chicken-dash-jackpot.webp",
    key: "JILI",
  },
  {
    name: "Grand Golden Treasure",
    image: "/assets/table/grand-golden-treasure.webp",
    key: "JILI",
  },
  {
    name: "Super E-Sabong",
    image: "/assets/table/super-e-sabong.webp",
    key: "JILI",
    gameCode: "JILI-TABLE-064",
    gameType: "TABLE",
    platFormCode: "JILI",
  },
  {
    name: "Super Ace Scratch",
    image: "/assets/table/super-ace-scratch.webp",
    key: "JILI",
    gameCode: "JILI-TABLE-059",
    gameType: "TABLE",
    platFormCode: "JILI",
  },
  {
    name: "Jhandi Munda",
    image: "/assets/table/jhandi-munda.webp",
    key: "JILI",
    gameCode: "JILI-TABLE-056",
    gameType: "TABLE",
    platFormCode: "JILI",
  },
  {
    name: "Speed Baccarat",
    image: "/assets/table/speed-baccarat.webp",
    key: "JILI",
    gameCode: "JILI-TABLE-054",
    gameType: "TABLE",
    platFormCode: "JILI",
  },
  {
    name: "Video Poker",
    image: "/assets/table/video-poker.webp",
    key: "JILI",
    gameCode: "JILI-TABLE-050",
    gameType: "TABLE",
    platFormCode: "JILI",
  },
  {
    name: "European Roulette",
    image: "/assets/table/european-roulette.webp",
    key: "JILI",
    gameCode: "JILI-TABLE-053",
    gameType: "TABLE",
    platFormCode: "JILI",
  },
  {
    name: "Caribbean Stud Poker",
    image: "/assets/table/caribbean-stud-poker.webp",
    key: "JILI",
    gameCode: "JILI-TABLE-049",
    gameType: "TABLE",
    platFormCode: "JILI",
  },
  {
    name: "TeenPatti 20-20",
    image: "/assets/table/teenpatti-20-20.webp",
    key: "JILI",
    gameCode: "JILI-TABLE-016",
    gameType: "TABLE",
    platFormCode: "JILI",
  },
  {
    name: "Callbreak Quick",
    image: "/assets/table/callbreak-quick.webp",
    key: "JILI",
    gameCode: "JILI-TABLE-013",
    gameType: "TABLE",
    platFormCode: "JILI",
  },
  {
    name: "Pearls of Bingo",
    image: "/assets/table/pearls-of-bingo.webp",
    key: "JILI",
    gameCode: "JILI-TABLE-051",
    gameType: "TABLE",
    platFormCode: "JILI",
  },
  {
    name: "Magic Lamp Bingo",
    image: "/assets/table/magic-lamp-bingo.webp",
    key: "JILI",
    gameCode: "JILI-TABLE-045",
    gameType: "TABLE",
    platFormCode: "JILI",
  },
  {
    name: "West Hunter Bingo",
    image: "/assets/table/west-hunter-bingo.webp",
    key: "JILI",
    gameCode: "JILI-TABLE-029",
    gameType: "TABLE",
    platFormCode: "JILI",
  },
  {
    name: "PAPPU",
    image: "/assets/table/pappu.webp",
    key: "JILI",
    gameCode: "JILI-TABLE-028",
    gameType: "TABLE",
    platFormCode: "JILI",
  },
  {
    name: "Bingo Carnaval",
    image: "/assets/table/bingo-carnaval.webp",
    key: "JILI",
    gameCode: "JILI-TABLE-019",
    gameType: "TABLE",
    platFormCode: "JILI",
  },
  {
    name: "Super Bingo",
    image: "/assets/table/super-bingo.webp",
    key: "JILI",
    gameCode: "JILI-TABLE-018",
    gameType: "TABLE",
    platFormCode: "JILI",
  },
  {
    name: "Sic Bo",
    image: "/assets/table/sic-bo.webp",
    key: "JILI",
    gameCode: "JILI-TABLE-017",
    gameType: "TABLE",
    platFormCode: "JILI",
  },
  {
    name: "Fortune Bingo",
    image: "/assets/table/fortune-bingo.webp",
    key: "JILI",
    gameCode: "JILI-TABLE-015",
    gameType: "TABLE",
    platFormCode: "JILI",
  },
  {
    name: "Baccarat",
    image: "/assets/table/baccarat.webp",
    key: "JILI",
    gameCode: "JILI-TABLE-014",
    gameType: "TABLE",
    platFormCode: "JILI",
  },
  {
    name: "Big Small",
    image: "/assets/table/big-small.webp",
    key: "JILI",
    gameCode: "JILI-TABLE-007",
    gameType: "TABLE",
    platFormCode: "JILI",
  },
  {
    name: "Pool Rummy",
    image: "/assets/table/pool-rummy.webp",
    key: "JILI",
    gameCode: "JILI-TABLE-048",
    gameType: "TABLE",
    platFormCode: "JILI",
  },
  {
    name: "MiniFlush",
    image: "/assets/table/miniflush.webp",
    key: "JILI",
    gameCode: "JILI-TABLE-042",
    gameType: "TABLE",
    platFormCode: "JILI",
  },
  {
    name: "Blackjack Lucky Ladies",
    image: "/assets/table/blackjack-lucky-ladies.webp",
    key: "JILI",
    gameCode: "JILI-TABLE-046",
    gameType: "TABLE",
    platFormCode: "JILI",
  },
  {
    name: "HILO",
    image: "/assets/table/hilo.webp",
    key: "JILI",
    gameCode: "JILI-TABLE-032",
    gameType: "TABLE",
    platFormCode: "JILI",
  },
  {
    name: "Blackjack",
    image: "/assets/table/blackjack.webp",
    key: "JILI",
    gameCode: "JILI-TABLE-044",
    gameType: "TABLE",
    platFormCode: "JILI",
  },
  {
    name: "Candyland Bingo",
    image: "/assets/table/candyland-bingo.webp",
    key: "JILI",
    gameCode: "JILI-TABLE-043",
    gameType: "TABLE",
    platFormCode: "JILI",
  },
  {
    name: "Plinko",
    image: "/assets/table/plinko.webp",
    key: "JILI",
    gameCode: "JILI-TABLE-041",
    gameType: "TABLE",
    platFormCode: "JILI",
  },
  {
    name: "Keno",
    image: "/assets/table/keno.webp",
    key: "JILI",
    gameCode: "JILI-TABLE-040",
    gameType: "TABLE",
    platFormCode: "JILI",
  },
  {
    name: "Mines Gold",
    image: "/assets/table/mines-gold.webp",
    key: "JILI",
    gameCode: "JILI-TABLE-037",
    gameType: "TABLE",
    platFormCode: "JILI",
  },
  {
    name: "Color Prediction",
    image: "/assets/table/color-prediction.webp",
    key: "JILI",
    gameCode: "JILI-TABLE-039",
    gameType: "TABLE",
    platFormCode: "JILI",
  },
  {
    name: "Pusoy Go",
    image: "/assets/table/pusoy-go.webp",
    key: "JILI",
    gameCode: "JILI-TABLE-038",
    gameType: "TABLE",
    platFormCode: "JILI",
  },
  {
    name: "Bingo Adventure",
    image: "/assets/table/bingo-adventure.webp",
    key: "JILI",
    gameCode: "JILI-TABLE-034",
    gameType: "TABLE",
    platFormCode: "JILI",
  },
  {
    name: "Tower",
    image: "/assets/table/tower.webp",
    key: "JILI",
    gameCode: "JILI-TABLE-031",
    gameType: "TABLE",
    platFormCode: "JILI",
  },
  {
    name: "Tongits Go",
    image: "/assets/table/tongits-go.webp",
    key: "JILI",
    gameCode: "JILI-TABLE-025",
    gameType: "TABLE",
    platFormCode: "JILI",
  },
  {
    name: "Calaca Bingo",
    image: "/assets/table/calaca-bingo.webp",
    key: "JILI",
    gameCode: "JILI-TABLE-026",
    gameType: "TABLE",
    platFormCode: "JILI",
  },
  {
    name: "Go Goal Bingo",
    image: "/assets/table/go-goal-bingo.webp",
    key: "JILI",
    gameCode: "JILI-TABLE-022",
    gameType: "TABLE",
    platFormCode: "JILI",
  },
  {
    name: "Color Game",
    image: "/assets/table/color-game.webp",
    key: "JILI",
    gameCode: "JILI-TABLE-023",
    gameType: "TABLE",
    platFormCode: "JILI",
  },
  {
    name: "Jackpot Bingo",
    image: "/assets/table/jackpot-bingo.webp",
    key: "JILI",
    gameCode: "JILI-TABLE-024",
    gameType: "TABLE",
    platFormCode: "JILI",
  },
  {
    name: "Lucky Bingo",
    image: "/assets/table/lucky-bingo.webp",
    key: "JILI",
    gameCode: "JILI-TABLE-020",
    gameType: "TABLE",
    platFormCode: "JILI",
  },
  {
    name: "TeenPatti",
    image: "/assets/table/teenpatti.webp",
    key: "JILI",
    gameCode: "JILI-TABLE-001",
    gameType: "TABLE",
    platFormCode: "JILI",
  },
  {
    name: "7up7down",
    image: "/assets/table/7up7down.webp",
    key: "JILI",
    gameCode: "JILI-TABLE-011",
    gameType: "TABLE",
    platFormCode: "JILI",
  },
  {
    name: "iRich Bingo",
    image: "/assets/table/irich-bingo.webp",
    key: "JILI",
    gameCode: "JILI-TABLE-008",
    gameType: "TABLE",
    platFormCode: "JILI",
  },
  {
    name: "Dragon & Tiger",
    image: "/assets/table/dragon-tiger.webp",
    key: "JILI",
    gameCode: "JILI-TABLE-012",
    gameType: "TABLE",
    platFormCode: "JILI",
  },
  {
    name: "Poker King",
    image: "/assets/table/poker-king.webp",
    key: "JILI",
    gameCode: "JILI-TABLE-006",
    gameType: "TABLE",
    platFormCode: "JILI",
  },
  {
    name: "Number King",
    image: "/assets/table/number-king.webp",
    key: "JILI",
    gameCode: "JILI-TABLE-005",
    gameType: "TABLE",
    platFormCode: "JILI",
  },
  {
    name: "Hotline",
    image: "/assets/table/hotline.webp",
    key: "SPRIBE",
    gameCode: "SPRIBE-EGAME-009",
    gameType: "EGAME",
    platFormCode: "SPRIBE",
  },
  {
    name: "Dice",
    image: "/assets/table/dice.webp",
    key: "SPRIBE",
    gameCode: "SPRIBE-EGAME-003",
    gameType: "EGAME",
    platFormCode: "SPRIBE",
  },
  {
    name: "Plinko",
    image: "/assets/table/plinko-2.webp",
    key: "SPRIBE",
    gameCode: "SPRIBE-EGAME-004",
    gameType: "EGAME",
    platFormCode: "SPRIBE",
  },
  {
    name: "Mines",
    image: "/assets/table/mines.webp",
    key: "SPRIBE",
    gameCode: "SPRIBE-EGAME-005",
    gameType: "EGAME",
    platFormCode: "SPRIBE",
  },
  {
    name: "Hi-lo",
    image: "/assets/table/hi-lo.webp",
    key: "SPRIBE",
  },
  {
    name: "Keno",
    image: "/assets/table/keno-2.webp",
    key: "SPRIBE",
    gameCode: "SPRIBE-EGAME-007",
    gameType: "EGAME",
    platFormCode: "SPRIBE",
  },
  {
    name: "Mini Roulette",
    image: "/assets/table/mini-roulette.webp",
    key: "SPRIBE",
    gameCode: "SPRIBE-EGAME-008",
    gameType: "EGAME",
    platFormCode: "SPRIBE",
  },
  {
    name: "Roulette",
    image: "/assets/table/roulette.webp",
    key: "PP",
    gameCode: "PP-TABLE-006",
    gameType: "TABLE",
    platFormCode: "PP",
  },
  {
    name: "Dragon Bonus Baccarat",
    image: "/assets/table/dragon-bonus-baccarat.webp",
    key: "PP",
    gameCode: "PP-TABLE-002",
    gameType: "TABLE",
    platFormCode: "PP",
  },
  {
    name: "Baccarat",
    image: "/assets/table/bca.webp",
    key: "PP",
    gameCode: "PP-TABLE-003",
    gameType: "TABLE",
    platFormCode: "PP",
  },
  {
    name: "CardMatka",
    image: "/assets/table/cardmatka.webp",
    key: "KM",
    gameCode: "KM-TABLE-022",
    gameType: "TABLE",
    platFormCode: "KINGMAKER",
  },
  {
    name: "Andar Bahar",
    image: "/assets/table/km-table-032-0.webp",
    key: "KM",
    gameCode: "KM-TABLE-032",
    gameType: "TABLE",
    platFormCode: "KINGMAKER",
  },
  {
    name: "Teen Patti",
    image: "/assets/table/teen-patti.webp",
    key: "KM",
    gameCode: "KM-TABLE-046",
    gameType: "TABLE",
    platFormCode: "KINGMAKER",
  },
  {
    name: "Teen Patti Blitz",
    image: "/assets/table/teen-patti-blitz.webp",
    key: "KM",
    gameCode: "KM-TABLE-085",
    gameType: "TABLE",
    platFormCode: "KINGMAKER",
  },
  {
    name: "COLOR GAME MEGA BONUS",
    image: "/assets/table/color-game-mega-bonus.webp",
    key: "KM",
    gameCode: "KM-TABLE-087",
    gameType: "TABLE",
    platFormCode: "KINGMAKER",
  },
  {
    name: "Olympus Glory",
    image: "/assets/table/olympus-glory.webp",
    key: "KM",
    gameCode: "KM-TABLE-071",
    gameType: "TABLE",
    platFormCode: "KINGMAKER",
  },
  {
    name: "Bingo Roll",
    image: "/assets/table/bingo-roll.webp",
    key: "KM",
  },
  {
    name: "Colour Game",
    image: "/assets/table/colour-game.webp",
    key: "KM",
    gameCode: "KM-TABLE-050",
    gameType: "TABLE",
    platFormCode: "KINGMAKER",
  },
  {
    name: "HORSE RACING",
    image: "/assets/table/horse-racing.webp",
    key: "KM",
    gameCode: "KM-TABLE-048",
    gameType: "TABLE",
    platFormCode: "KINGMAKER",
  },
  {
    name: "Dota Hi-Lo",
    image: "/assets/table/dota-hi-lo.webp",
    key: "KM",
    gameCode: "KM-TABLE-044",
    gameType: "TABLE",
    platFormCode: "KINGMAKER",
  },
  {
    name: "Bonus Dice",
    image: "/assets/table/bonus-dice.webp",
    key: "KM",
    gameCode: "KM-TABLE-043",
    gameType: "TABLE",
    platFormCode: "KINGMAKER",
  },
  {
    name: "Plinko",
    image: "/assets/table/km-table-040-0.webp",
    key: "KM",
    gameCode: "KM-TABLE-040",
    gameType: "TABLE",
    platFormCode: "KINGMAKER",
  },
  {
    name: "32 Cards",
    image: "/assets/table/32-cards.webp",
    key: "KM",
    gameCode: "KM-TABLE-039",
    gameType: "TABLE",
    platFormCode: "KINGMAKER",
  },
  {
    name: "Blackjack",
    image: "/assets/table/km-table-038-0.webp",
    key: "KM",
    gameCode: "KM-TABLE-038",
    gameType: "TABLE",
    platFormCode: "KINGMAKER",
  },
  {
    name: "Cards Hi Lo",
    image: "/assets/table/cards-hi-lo.webp",
    key: "KM",
    gameCode: "KM-TABLE-037",
    gameType: "TABLE",
    platFormCode: "KINGMAKER",
  },
  {
    name: "Coin Toss",
    image: "/assets/table/coin-toss.webp",
    key: "KM",
    gameCode: "KM-TABLE-036",
    gameType: "TABLE",
    platFormCode: "KINGMAKER",
  },
  {
    name: "Minesweeper",
    image: "/assets/table/minesweeper.webp",
    key: "KM",
    gameCode: "KM-TABLE-042",
    gameType: "TABLE",
    platFormCode: "KINGMAKER",
  },
  {
    name: "Kingmaker Pok Deng",
    image: "/assets/table/kingmaker-pok-deng.webp",
    key: "KM",
  },
  {
    name: "Pai Kang",
    image: "/assets/table/pai-kang.webp",
    key: "KM",
    gameCode: "KM-TABLE-033",
    gameType: "TABLE",
    platFormCode: "KINGMAKER",
  },
  {
    name: "Baccarat",
    image: "/assets/table/km-table-026-0.webp",
    key: "KM",
    gameCode: "KM-TABLE-026",
    gameType: "TABLE",
    platFormCode: "KINGMAKER",
  },
  {
    name: "Jhandi Munda",
    image: "/assets/table/km-table-030-0.webp",
    key: "KM",
    gameCode: "KM-TABLE-030",
    gameType: "TABLE",
    platFormCode: "KINGMAKER",
  },
  {
    name: "7 Up 7 Down",
    image: "/assets/table/7-up-7-down.webp",
    key: "KM",
    gameCode: "KM-TABLE-028",
    gameType: "TABLE",
    platFormCode: "KINGMAKER",
  },
  {
    name: "European Roulette",
    image: "/assets/table/km-table-027-0.webp",
    key: "KM",
    gameCode: "KM-TABLE-027",
    gameType: "TABLE",
    platFormCode: "KINGMAKER",
  },
  {
    name: "Fruit Roulette",
    image: "/assets/table/fruit-roulette.webp",
    key: "KM",
    gameCode: "KM-TABLE-025",
    gameType: "TABLE",
    platFormCode: "KINGMAKER",
  },
  {
    name: "Fan Tan Classic",
    image: "/assets/table/fan-tan-classic.webp",
    key: "KM",
    gameCode: "KM-TABLE-024",
    gameType: "TABLE",
    platFormCode: "KINGMAKER",
  },
  {
    name: "Xocdia2",
    image: "/assets/table/xocdia2.webp",
    key: "KM",
    gameCode: "KM-TABLE-023",
    gameType: "TABLE",
    platFormCode: "KINGMAKER",
  },
  {
    name: "NumberMatka",
    image: "/assets/table/numbermatka.webp",
    key: "KM",
    gameCode: "KM-TABLE-021",
    gameType: "TABLE",
    platFormCode: "KINGMAKER",
  },
  {
    name: "Bài Cào",
    image: "/assets/table/bai-cao.webp",
    key: "KM",
    gameCode: "KM-TABLE-020",
    gameType: "TABLE",
    platFormCode: "KINGMAKER",
  },
  {
    name: "Thai-FPC",
    image: "/assets/table/thai-fpc.webp",
    key: "KM",
    gameCode: "KM-TABLE-019",
    gameType: "TABLE",
    platFormCode: "KINGMAKER",
  },
  {
    name: "TaiXiu",
    image: "/assets/table/taixiu.webp",
    key: "KM",
    gameCode: "KM-TABLE-017",
    gameType: "TABLE",
    platFormCode: "KINGMAKER",
  },
  {
    name: "Sicbo",
    image: "/assets/table/sicbo.webp",
    key: "KM",
    gameCode: "KM-TABLE-015",
    gameType: "TABLE",
    platFormCode: "KINGMAKER",
  },
  {
    name: "VN Fish Prawn Crab",
    image: "/assets/table/vn-fish-prawn-crab.webp",
    key: "KM",
  },
  {
    name: "Fish Prawn Crab 2",
    image: "/assets/table/fish-prawn-crab-2.webp",
    key: "KM",
  },
  {
    name: "Dragon Tiger 2",
    image: "/assets/table/dragon-tiger-2.webp",
    key: "KM",
  },
  {
    name: "Thai-Hi-Lo2",
    image: "/assets/table/thai-hi-lo2.webp",
    key: "KM",
    gameCode: "KM-TABLE-009",
    gameType: "TABLE",
    platFormCode: "KINGMAKER",
  },
  {
    name: "Punto Banco",
    image: "/assets/table/punto-banco.webp",
    key: "RT",
    gameCode: "RT-TABLE-001",
    gameType: "TABLE",
    platFormCode: "RT",
  },
  {
    name: "European Roulette",
    image: "/assets/table/rtg-european-roulette.webp",
    key: "RT",
    gameCode: "RT-TABLE-002",
    gameType: "TABLE",
    platFormCode: "RT",
  },
];
export const Fishing = [
  {
    name: "Bombing Fishing",
    image: "/assets/fishing/bombing-fishing.webp",
    key: "JILI",
    gameCode: "JILI-FISH-002",
    gameType: "FH",
    platFormCode: "JILI",
  },
  {
    name: "Jackpot Fishing",
    image: "/assets/fishing/jackpot-fishing.webp",
    key: "JILI",
    gameCode: "JILI-FISH-003",
    gameType: "FH",
    platFormCode: "JILI",
  },
  {
    name: "Mega Fishing",
    image: "/assets/fishing/mega-fishing.webp",
    key: "JILI",
    gameCode: "JILI-FISH-007",
    gameType: "FH",
    platFormCode: "JILI",
  },
  {
    name: "Happy Fishing",
    image: "/assets/fishing/happy-fishing.webp",
    key: "JILI",
    gameCode: "JILI-FISH-005",
    gameType: "FH",
    platFormCode: "JILI",
  },
  {
    name: "All-star Fishing",
    image: "/assets/fishing/all-star-fishing.webp",
    key: "JILI",
    gameCode: "JILI-FISH-009",
    gameType: "FH",
    platFormCode: "JILI",
  },
  {
    name: "Jackpot Fishing 2",
    image: "/assets/fishing/jackpot-fishing-2.webp",
    key: "JILI",
  },
  {
    name: "FORTUNE ZOMBIE",
    image: "/assets/fishing/fortune-zombie.webp",
    key: "JILI",
    gameCode: "JILI-FISH-014",
    gameType: "FH",
    platFormCode: "JILI",
  },
  {
    name: "Fortune King Jackpot",
    image: "/assets/fishing/fortune-king-jackpot.webp",
    key: "JILI",
    gameCode: "JILI-FISH-013",
    gameType: "FH",
    platFormCode: "JILI",
  },
  {
    name: "Ocean King Jackpot",
    image: "/assets/fishing/ocean-king-jackpot.webp",
    key: "JILI",
    gameCode: "JILI-FISH-012",
    gameType: "FH",
    platFormCode: "JILI",
  },
  {
    name: "Dinosaur Tycoon II",
    image: "/assets/fishing/dinosaur-tycoon-ii.webp",
    key: "JILI",
    gameCode: "JILI-FISH-011",
    gameType: "FH",
    platFormCode: "JILI",
  },
  {
    name: "Boom Legend",
    image: "/assets/fishing/boom-legend.webp",
    key: "JILI",
    gameCode: "JILI-FISH-008",
    gameType: "FH",
    platFormCode: "JILI",
  },
  {
    name: "Dragon Fortune",
    image: "/assets/fishing/dragon-fortune.webp",
    key: "JILI",
    gameCode: "JILI-FISH-006",
    gameType: "FH",
    platFormCode: "JILI",
  },
  {
    name: "Dinosaur Tycoon",
    image: "/assets/fishing/dinosaur-tycoon.webp",
    key: "JILI",
    gameCode: "JILI-FISH-004",
    gameType: "FH",
    platFormCode: "JILI",
  },
  {
    name: "Royal Fishing",
    image: "/assets/fishing/royal-fishing.webp",
    key: "JILI",
    gameCode: "JILI-FISH-001",
    gameType: "FH",
    platFormCode: "JILI",
  },
  {
    name: "Zombie Party",
    image: "/assets/fishing/zombie-party.webp",
    key: "SPADE",
    gameCode: "SG-FISH-004",
    gameType: "FH",
    platFormCode: "SPADE",
  },
  {
    name: "Alien Hunter",
    image: "/assets/fishing/alien-hunter.webp",
    key: "SPADE",
    gameCode: "SG-FISH-003",
    gameType: "FH",
    platFormCode: "SPADE",
  },
  {
    name: "Fishing War",
    image: "/assets/fishing/fishing-war.webp",
    key: "SPADE",
    gameCode: "SG-FISH-002",
    gameType: "FH",
    platFormCode: "SPADE",
  },
  {
    name: "Fishing God",
    image: "/assets/fishing/fishing-god.webp",
    key: "SPADE",
    gameCode: "SG-FISH-001",
    gameType: "FH",
    platFormCode: "SPADE",
  },
];

export const Crash = [
  {
    name: "Aviator Studio",
    image: "/assets/crash/aviator-studio.webp",
    key: "AVIATOR",
    platFormCode: "SPRIBE",
    gameType: "EGAME",
    casinoType: "SPRIBE-EGAME-001",
  },
  {
    name: "Red Baron",
    image: "/assets/crash/red-baron.webp",
    key: "EVOLUTION",
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-455",
  },
  {
    name: "Crash Cricket Legend",
    image: "/assets/crash/crash-cricket-legend.webp",
    key: "JILI",
    platFormCode: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-058",
  },
  {
    name: "Crash Trader",
    image: "/assets/crash/crash-trader.webp",
    key: "JILI",
    gameCode: "JILI-TABLE-087",
    gameType: "TABLE",
    platFormCode: "JILI",
  },
  {
    name: "Cash Stack",
    image: "/assets/crash/cash-stack.webp",
    key: "JILI",
    gameCode: "JILI-TABLE-090",
    gameType: "TABLE",
    platFormCode: "JILI",
  },
  // {
  //   name: "Crash Fruit",
  //   image: "/assets/crash/crash-fruit.webp",
  //   key: "JILI",
  // },
  // {
  //   name: "Mines football",
  //   image: "/assets/crash/mines-football.webp",
  //   key: "JILI",
  // },
  // {
  //   name: "Cash Balloon",
  //   image: "/assets/crash/cash-balloon.webp",
  //   key: "JILI",
  // },
  {
    name: "Crash Puck",
    image: "/assets/crash/crash-puck.webp",
    key: "JILI",
    gameCode: "JILI-TABLE-081",
    gameType: "TABLE",
    platFormCode: "JILI",
  },
  {
    name: "Crash Touchdown",
    image: "/assets/crash/crash-touchdown.webp",
    key: "JILI",
    gameCode: "JILI-TABLE-070",
    gameType: "TABLE",
    platFormCode: "JILI",
  },
  {
    name: "Crash Cricket",
    image: "/assets/crash/crash-cricket.webp",
    key: "JILI",
    gameCode: "JILI-TABLE-058",
    gameType: "TABLE",
    platFormCode: "JILI",
  },
  {
    name: "Crash Goal",
    image: "/assets/crash/crash-goal.webp",
    key: "JILI",
    gameCode: "JILI-TABLE-055",
    gameType: "TABLE",
    platFormCode: "JILI",
  },
  {
    name: "Mines",
    image: "/assets/crash/mines.webp",
    key: "JILI",
    gameCode: "JILI-TABLE-033",
    gameType: "TABLE",
    platFormCode: "JILI",
  },
  {
    name: "Crash Bonus",
    image: "/assets/crash/crash-bonus.webp",
    key: "JILI",
    gameCode: "JILI-TABLE-047",
    gameType: "TABLE",
    platFormCode: "JILI",
  },
  {
    name: "Wheel",
    image: "/assets/crash/wheel.webp",
    key: "JILI",
    gameCode: "JILI-TABLE-036",
    gameType: "TABLE",
    platFormCode: "JILI",
  },
  {
    name: "Limbo",
    image: "/assets/crash/limbo.webp",
    key: "JILI",
    gameCode: "JILI-TABLE-035",
    gameType: "TABLE",
    platFormCode: "JILI",
  },
  {
    name: "Go Rush",
    image: "/assets/crash/go-rush.webp",
    key: "JILI",
    gameCode: "JILI-TABLE-030",
    gameType: "TABLE",
    platFormCode: "JILI",
  },
  {
    name: "Win Drop",
    image: "/assets/crash/win-drop.webp",
    key: "JILI",
    gameCode: "JILI-SLOT-061",
    gameType: "SLOT",
    platFormCode: "JILI",
  },
  {
    name: "Chicken+",
    image: "/assets/crash/chicken.webp",
    key: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-196",
    Name: "Chicken Drop",
    platFormCode: "PP",
  },
  {
    name: "High Flyer",
    image: "/assets/crash/high-flyer.webp",
    key: "PP",
    gameCode: "PP-EGAME-008",
    gameType: "EGAME",
    platFormCode: "PP",
  },
  {
    name: "Big Bass Crash",
    image: "/assets/crash/big-bass-crash.webp",
    key: "PP",
    gameCode: "PP-EGAME-009",
    gameType: "EGAME",
    platFormCode: "PP",
  },
  {
    name: "Limbo+",
    image: "/assets/crash/limbo-2.webp",
    key: "PP",
    platFormCode: "JJ",
    casinoType: "2J-EGAME-003",
    Name: "LIMBO",
    gameType: "EGAME",
  },
  {
    name: "Plinko+",
    image: "/assets/crash/plinko.webp",
    key: "PP",
    gameCode: "PP-EGAME-012",
    gameType: "EGAME",
    platFormCode: "PP",
  },
  {
    name: "Mines+",
    image: "/assets/crash/mines.webp",
    key: "PP",
    gameCode: "PP-EGAME-014",
    gameType: "EGAME",
    platFormCode: "PP",
  },
  {
    name: "Spaceman",
    image: "/assets/crash/spaceman.webp",
    key: "PP",
    gameCode: "PP-EGAME-001",
    gameType: "EGAME",
    platFormCode: "PP",
  },
  {
    name: "Aviator",
    image: "/assets/crash/aviator.webp",
    key: "SPRIBE",
    gameCode: "SPRIBE-EGAME-001",
    gameType: "EGAME",
    platFormCode: "SPRIBE",
  },
  {
    name: "Interstellar Run",
    image: "/assets/crash/interstellar-run.webp",
    key: "KM",
    gameCode: "KM-TABLE-070",
    gameType: "TABLE",
    platFormCode: "KINGMAKER",
  },
  {
    name: "Elite Aviator Club",
    image: "/assets/crash/elite-aviator-club.webp",
    key: "KM",
    gameCode: "KM-TABLE-069",
    gameType: "TABLE",
    platFormCode: "KINGMAKER",
  },
  {
    name: "Cash Rocket",
    image: "/assets/crash/cash-rocket.webp",
    key: "KM",
    gameCode: "KM-TABLE-041",
    gameType: "TABLE",
    platFormCode: "KINGMAKER",
  },
  {
    name: "Chicky Run",
    image: "/assets/crash/chicky-run.webp",
    key: "PG",
    gameCode: "PG-SLOT-140",
    gameType: "SLOT",
    platFormCode: "PG",
  },
  {
    name: "JetX",
    image: "/assets/crash/jetx.webp",
    key: "SMARTSOFT",
    gameCode: "SMARTSOFT-EGAME-001",
    gameType: "EGAME",
    platFormCode: "SMARTSOFT",
  },
  {
    name: "PlinkoX",
    image: "/assets/crash/plinkox.webp",
    key: "SMARTSOFT",
    gameCode: "SMARTSOFT-EGAME-004",
    gameType: "EGAME",
    platFormCode: "SMARTSOFT",
  },
  {
    name: "Balloon",
    image: "/assets/crash/balloon.webp",
    key: "SMARTSOFT",
    gameCode: "SMARTSOFT-EGAME-002",
    gameType: "EGAME",
    platFormCode: "SMARTSOFT",
  },
  // {
  //   name: "CricketX",
  //   image: "/assets/crash/cricketx.webp",
  //   key: "SMARTSOFT",
  // },
  {
    name: "JetX3",
    image: "/assets/crash/jetx3.webp",
    key: "SMARTSOFT",
    gameCode: "SMARTSOFT-EGAME-001",
    gameType: "EGAME",
    platFormCode: "SMARTSOFT",
  },
  // {
  //   name: "CarX",
  //   image: "/assets/crash/carx.webp",
  //   key: "SMARTSOFT",
  // },
  // {
  //   name: "Gates of Merlyn",
  //   image: "/assets/crash/gates-of-merlyn.webp",
  //   key: "SMARTSOFT",
  // },
  // {
  //   name: "Chicken Ways",
  //   image: "/assets/crash/chicken-ways.webp",
  //   key: "SMARTSOFT",
  // },
  // {
  //   name: "Cheesy Road Classic",
  //   image: "/assets/crash/cheesy-road-classic.webp",
  //   key: "SMARTSOFT",
  // },
  // {
  //   name: "Bottle Mania",
  //   image: "/assets/crash/bottle-mania.webp",
  //   key: "SMARTSOFT",
  // },
  // {
  //   name: "Cheesy Road",
  //   image: "/assets/crash/cheesy-road.webp",
  //   key: "SMARTSOFT",
  // },
  // {
  //   name: "Chicken Highway",
  //   image: "/assets/crash/chicken-highway.webp",
  //   key: "SMARTSOFT",
  // },
  // {
  //   name: "Gems Crown Charging Wilds",
  //   image: "/assets/crash/gems-crown-charging-wilds.webp",
  //   key: "SMARTSOFT",
  // },
  // {
  //   name: "Multi Fruits Charging Wilds",
  //   image: "/assets/crash/multi-fruits-charging-wilds.webp",
  //   key: "SMARTSOFT",
  // },
  // {
  //   name: "Power of Tiger",
  //   image: "/assets/crash/power-of-tiger.webp",
  //   key: "SMARTSOFT",
  // },
  // {
  //   name: "Fortune Catch",
  //   image: "/assets/crash/fortune-catch.webp",
  //   key: "SMARTSOFT",
  // },
  // {
  //   name: "Multi Hot 40",
  //   image: "/assets/crash/multi-hot-40.webp",
  //   key: "SMARTSOFT",
  // },
  // {
  //   name: "Multi Hot 100",
  //   image: "/assets/crash/multi-hot-100.webp",
  //   key: "SMARTSOFT",
  // },
  // {
  //   name: "Propel X",
  //   image: "/assets/crash/propel-x.webp",
  //   key: "SMARTSOFT",
  // },
  // {
  //   name: "Multi Hot 20",
  //   image: "/assets/crash/multi-hot-20.webp",
  //   key: "SMARTSOFT",
  // },
  // {
  //   name: "Multi Hot 10",
  //   image: "/assets/crash/multi-hot-10.webp",
  //   key: "SMARTSOFT",
  // },
  // {
  //   name: "Plinko X Classic",
  //   image: "/assets/crash/plinko-x-classic.webp",
  //   key: "SMARTSOFT",
  // },
  // {
  //   name: "Cricketer X",
  //   image: "/assets/crash/cricketer-x.webp",
  //   key: "SMARTSOFT",
  // },
  // {
  //   name: "Multi Hot 5",
  //   image: "/assets/crash/multi-hot-5.webp",
  //   key: "SMARTSOFT",
  // },
  // {
  //   name: "Smash X",
  //   image: "/assets/crash/smash-x.webp",
  //   key: "SMARTSOFT",
  // },
  // {
  //   name: "Roll X",
  //   image: "/assets/crash/roll-x.webp",
  //   key: "SMARTSOFT",
  // },
  // {
  //   name: "Crash Duel X",
  //   image: "/assets/crash/crash-duel-x.webp",
  //   key: "SMARTSOFT",
  // },
  {
    name: "Mine Island",
    image: "/assets/crash/mine-island.webp",
    key: "SMARTSOFT",
    gameCode: "SMARTSOFT-EGAME-005",
    gameType: "EGAME",
    platFormCode: "SMARTSOFT",
  },
  // {
  //   name: "Helicopter X",
  //   image: "/assets/crash/helicopter-x.webp",
  //   key: "SMARTSOFT",
  // },
  // {
  //   name: "DoubleX",
  //   image: "/assets/crash/doublex.webp",
  //   key: "SMARTSOFT",
  // },
  // {
  //   name: "TowerX",
  //   image: "/assets/crash/towerx.webp",
  //   key: "SMARTSOFT",
  // },
  {
    name: "FootballX",
    image: "/assets/crash/footballx.webp",
    key: "SMARTSOFT",
    gameCode: "SMARTSOFT-EGAME-003",
    gameType: "EGAME",
    platFormCode: "SMARTSOFT",
  },
];

export const games = [
  {
    name: "Sexy",
    image: "/assets/casino/sexy.webp",
    badge: "hot",
    key: "SEXY",
    platFormCode: "SEXYBCRT",
    gameType: "LIVE",
    casinoType: "MX-LIVE-001",
  },
  {
    name: "Game Shows Lobby",
    image: "/assets/casino/game-shows-lobby.webp",
    badge: "hot",
    key: "EVOLUTION",
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
  },
  {
    name: "Evo Funky Time",
    image: "/assets/casino/evo-funky-time.webp",
    badge: "hot",
    key: "EVOLUTION",
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-183",
  },
  {
    name: "Evo Imperial Quest",
    image: "/assets/casino/evo-imperial-quest.webp",
    badge: "hot",
    key: "EVOLUTION",
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-169",
  },
  {
    name: "Crazy Time (20,000x)",
    image: "/assets/casino/crazy-time-20-000x.webp",
    badge: "hot",
    key: "EVOLUTION",
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-006",
  },
  {
    name: "Dream Catcher",
    image: "/assets/casino/dream-catcher.webp",
    badge: "hot",
    key: "EVOLUTION",
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-035",
  },
  {
    name: "MONOPOLY Live",
    image: "/assets/casino/monopoly-live.webp",
    badge: "hot",
    key: "EVOLUTION",
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-007",
  },
  {
    name: "Auto Lightning Roulette",
    image: "/assets/casino/auto-lightning-roulette.webp",
    badge: "hot",
    key: "EVOLUTION",
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-040",
  },
  {
    name: "Mega Ball",
    image: "/assets/casino/mega-ball.webp",
    badge: "hot",
    key: "EVOLUTION",   platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-010",
  },
  {
    name: "Lightning Dice",
    image: "/assets/casino/lightning-dice.webp",
    badge: "hot",
    key: "EVOLUTION",      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-011",
  },
  {
    name: "Lightning Baccarat",
    image: "/assets/casino/lightning-baccarat.webp",
    badge: "hot",
    key: "EVOLUTION",    platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-133",
  },
  // {
  //   name: "Evo Top Games",
  //   image: "/assets/casino/evo-top-games.webp",
  //   badge: "new",
  //   key: "EVOLUTION",
  // },
  // {
  //   name: "Korean Prosperity Tree Baccarat",
  //   image: "/assets/casino/korean-prosperity-tree-baccarat.webp",
  //   badge: "new",
  //   key: "EVOLUTION",
  // },
  {
    name: "Thai Speed Baccarat A",
    image: "/assets/casino/thai-speed-baccarat-a.webp",
    badge: "new",
    key: "EVOLUTION",   platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-415",
  },
  {
    name: "Lotus Speed Baccarat A",
    image: "/assets/casino/lotus-speed-baccarat-a.webp",
    badge: "new",
    key: "EVOLUTION",  platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-416",
  },
  // {
  //   name: "Korean Golden Wealth Baccarat",
  //   image: "/assets/casino/korean-golden-wealth-baccarat.webp",
  //   badge: "new",
  //   key: "EVOLUTION",
  // },
  {
    name: "Lotus Roulette",
    image: "/assets/casino/lotus-roulette.webp",
    badge: "new",
    key: "EVOLUTION",  platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-417",
  },
  {
    name: "Salon Privé Blackjack O",
    image: "/assets/casino/salon-prive-blackjack-o.webp",
    badge: "new",
    key: "EVOLUTION",   platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-215",
  },
  {
    name: "Salon Privé Blackjack P",
    image: "/assets/casino/salon-prive-blackjack-p.webp",
    badge: "new",
    key: "EVOLUTION", platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-216",
  },
  {
    name: "Salon Privé Blackjack Q",
    image: "/assets/casino/salon-prive-blackjack-q.webp",
    badge: "new",
    key: "EVOLUTION",  platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-217",
  },
  // {
  //   name: "Japanese Speed Blackjack C",
  //   image: "/assets/casino/japanese-speed-blackjack-c.webp",
  //   badge: "new",
  //   key: "EVOLUTION",
  // },
  {
    name: "Emperor Golden Wealth Baccarat",
    image: "/assets/casino/emperor-golden-wealth-baccarat.webp",
    badge: "new",
    key: "EVOLUTION",    platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-414",
  },
  {
    name: "Korean Salon Prive Baccarat",
    image: "/assets/casino/korean-salon-prive-baccarat.webp",
    badge: "new",
    key: "EVOLUTION",
  },
  {
    name: "Lotus Sic Bo",
    image: "/assets/casino/lotus-sic-bo.webp",
    badge: "new",
    key: "EVOLUTION",     platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-411",
  },
  {
    name: "Korean Speed Blackjack D",
    image: "/assets/casino/korean-speed-blackjack-d.webp",
    badge: "new",
    key: "EVOLUTION",
  },
  {
    name: "Korean Speed Blackjack E",
    image: "/assets/casino/korean-speed-blackjack-e.webp",
    badge: "new",
    key: "EVOLUTION",
  },
  {
    name: "Korean Speed Blackjack F",
    image: "/assets/casino/korean-speed-blackjack-f.webp",
    badge: "new",
    key: "EVOLUTION",
  },
  {
    name: "Korean Speed Blackjack G",
    image: "/assets/casino/korean-speed-blackjack-g.webp",
    badge: "new",
    key: "EVOLUTION",
  },
  {
    name: "Easy Blackjack",
    image: "/assets/casino/easy-blackjack.webp",
    badge: "new",
    key: "EVOLUTION",   platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-413",
  },
  {
    name: "Infinite Bet Stacker Blackjack",
    image: "/assets/casino/infinite-bet-stacker-blackjack.webp",
    badge: "new",
    key: "EVOLUTION",  platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-412",
  },
  {
    name: "Speed Super Sic Bo",
    image: "/assets/casino/speed-super-sic-bo.webp",
    badge: "new",
    key: "EVOLUTION", platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-260",
  },
  {
    name: "Crazy Balls",
    image: "/assets/casino/crazy-balls.webp",
    badge: "new",
    key: "EVOLUTION",    platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-409",
  },
  {
    name: "Always 8 Baccarat",
    image: "/assets/casino/always-8-baccarat.webp",
    badge: "new",
    key: "EVOLUTION",
  },
  {
    name: "Platinum Privé Blackjack 1",
    image: "/assets/casino/platinum-prive-blackjack-1.webp",
    badge: "new",
    key: "EVOLUTION",
  },
  {
    name: "Platinum Privé Blackjack 2",
    image: "/assets/casino/platinum-prive-blackjack-2.webp",
    badge: "new",
    key: "EVOLUTION",
  },
  {
    name: "Platinum Privé Blackjack 3",
    image: "/assets/casino/platinum-prive-blackjack-3.webp",
    badge: "new",
    key: "EVOLUTION",
  },
  {
    name: "Japanese Speed Blackjack B",
    image: "/assets/casino/japanese-speed-blackjack-b.webp",
    badge: "new",
    key: "EVOLUTION",
  },
  {
    name: "Japanese Speed Blackjack F",
    image: "/assets/casino/japanese-speed-blackjack-f.webp",
    badge: "new",
    key: "EVOLUTION",
  },
  {
    name: "Grand Japanese Speed Blackjack",
    image: "/assets/casino/grand-japanese-speed-blackjack.webp",
    badge: "new",
    key: "EVOLUTION",
  },
  {
    name: "Japanese Lightning Baccarat",
    image: "/assets/casino/japanese-lightning-baccarat.webp",
    badge: "new",
    key: "EVOLUTION",
  },
  {
    name: "Salon Privé Baccarat G",
    image: "/assets/casino/salon-prive-baccarat-g.webp",
    badge: "new",
    key: "EVOLUTION",
  },
  {
    name: "Salon Privé Baccarat F",
    image: "/assets/casino/salon-prive-baccarat-f.webp",
    badge: "new",
    key: "EVOLUTION",
  },
  {
    name: "Speed Baccarat X",
    image: "/assets/casino/speed-baccarat-x.webp",
    badge: "new",
    key: "EVOLUTION",
  },
  {
    name: "Japanese Speed Blackjack D",
    image: "/assets/casino/japanese-speed-blackjack-d.webp",
    badge: "new",
    key: "EVOLUTION",
  },
  {
    name: "Japanese Salon Prive Baccarat",
    image: "/assets/casino/japanese-salon-prive-baccarat.webp",
    badge: "new",
    key: "EVOLUTION",
  },
  {
    name: "Fútbol Studio",
    image: "/assets/casino/futbol-studio.webp",
    badge: "new",
    key: "EVOLUTION",
  },
  {
    name: "Bacará Rápido",
    image: "/assets/casino/bacara-rapido.webp",
    badge: "new",
    key: "EVOLUTION",
  },
  {
    name: "Roleta Relâmpago",
    image: "/assets/casino/roleta-relampago.webp",
    badge: "new",
    key: "EVOLUTION",
  },
  {
    name: "Craps",
    image: "/assets/casino/craps.webp",
    badge: "new",
    key: "EVOLUTION",
  },
  {
    name: "Bet Stacker Blackjack 4",
    image: "/assets/casino/bet-stacker-blackjack-4.webp",
    badge: "new",
    key: "EVOLUTION",
  },
  {
    name: "Bet Stacker Blackjack 2",
    image: "/assets/casino/bet-stacker-blackjack-2.webp",
    badge: "new",
    key: "EVOLUTION",
  },
  {
    name: "Bet Stacker Blackjack 3",
    image: "/assets/casino/bet-stacker-blackjack-3.webp",
    badge: "new",
    key: "EVOLUTION",
  },
  {
    name: "Bet Stacker Blackjack 1",
    image: "/assets/casino/bet-stacker-blackjack-1.webp",
    badge: "new",
    key: "EVOLUTION",
  },
  {
    name: "Race Track A",
    image: "/assets/casino/race-track-a.webp",
    badge: "new",
    key: "EVOLUTION",
  },
  {
    name: "Race Track",
    image: "/assets/casino/race-track.webp",
    badge: "new",
    key: "EVOLUTION",
  },
  {
    name: "Japanese Prosperity Tree Baccarat",
    image: "/assets/casino/japanese-prosperity-tree-baccarat.webp",
    badge: "new",
    key: "EVOLUTION",
  },
  {
    name: "Korean Speed Baccarat H",
    image: "/assets/casino/korean-speed-baccarat-h.webp",
    badge: "new",
    key: "EVOLUTION",
  },
  {
    name: "Korean Speed Baccarat G",
    image: "/assets/casino/korean-speed-baccarat-g.webp",
    badge: "new",
    key: "EVOLUTION",
  },
  {
    name: "War",
    image: "/assets/casino/war.webp",
    badge: "new",
    key: "EVOLUTION",
  },
  {
    name: "Marble Race",
    image: "/assets/casino/marble-race.webp",
    badge: "new",
    key: "EVOLUTION",
  },
  {
    name: "Korean Dragon Tiger",
    image: "/assets/casino/korean-dragon-tiger.webp",
    badge: "new",
    key: "EVOLUTION",
  },
  {
    name: "Super Color Game",
    image: "/assets/casino/super-color-game.webp",
    badge: "new",
    key: "EVOLUTION",
  },
  {
    name: "Fireball Roulette",
    image: "/assets/casino/fireball-roulette.webp",
    badge: "new",
    key: "EVOLUTION",
  },
  {
    name: "VIP Blackjack en Español 8",
    image: "/assets/casino/vip-blackjack-en-espanol-8.webp",
    badge: "new",
    key: "EVOLUTION",
  },
  {
    name: "VIP Blackjack em Português 3",
    image: "/assets/casino/vip-blackjack-em-portugues-3.webp",
    badge: "new",
    key: "EVOLUTION",
  },
  {
    name: "VIP Blackjack en Español 7",
    image: "/assets/casino/vip-blackjack-en-espanol-7.webp",
    badge: "new",
    key: "EVOLUTION",
  },
  {
    name: "VIP Blackjack en Español 9",
    image: "/assets/casino/vip-blackjack-en-espanol-9.webp",
    badge: "new",
    key: "EVOLUTION",
  },
  {
    name: "VIP Blackjack em Português 2",
    image: "/assets/casino/vip-blackjack-em-portugues-2.webp",
    badge: "new",
    key: "EVOLUTION",
  },
  {
    name: "VIP Blackjack em Português",
    image: "/assets/casino/vip-blackjack-em-portugues.webp",
    badge: "new",
    key: "EVOLUTION",
  },
  {
    name: "VIP Blackjack em Português 4",
    image: "/assets/casino/vip-blackjack-em-portugues-4.webp",
    badge: "new",
    key: "EVOLUTION",
  },
  {
    name: "VIP Blackjack em Português 5",
    image: "/assets/casino/vip-blackjack-em-portugues-5.webp",
    badge: "new",
    key: "EVOLUTION",
  },
  {
    name: "VIP Blackjack en Español",
    image: "/assets/casino/vip-blackjack-en-espanol.webp",
    badge: "new",
    key: "EVOLUTION",
  },
  {
    name: "VIP Blackjack en Español 2",
    image: "/assets/casino/vip-blackjack-en-espanol-2.webp",
    badge: "new",
    key: "EVOLUTION",
  },
  {
    name: "VIP Blackjack en Español 3",
    image: "/assets/casino/vip-blackjack-en-espanol-3.webp",
    badge: "new",
    key: "EVOLUTION",
  },
  {
    name: "VIP Blackjack en Español 4",
    image: "/assets/casino/vip-blackjack-en-espanol-4.webp",
    badge: "new",
    key: "EVOLUTION",
  },
  {
    name: "VIP Blackjack en Español 5",
    image: "/assets/casino/vip-blackjack-en-espanol-5.webp",
    badge: "new",
    key: "EVOLUTION",
  },
  {
    name: "VIP Blackjack en Español 6",
    image: "/assets/casino/vip-blackjack-en-espanol-6.webp",
    badge: "new",
    key: "EVOLUTION",
  },
  {
    name: "Blackjack en Español 1",
    image: "/assets/casino/blackjack-en-espanol-1.webp",
    badge: "new",
    key: "EVOLUTION",
  },
  {
    name: "Ruleta en Vivo",
    image: "/assets/casino/ruleta-en-vivo.webp",
    badge: "new",
    key: "EVOLUTION",
  },
  {
    name: "Ruleta Bola Rápida en Vivo",
    image: "/assets/casino/ruleta-bola-rapida-en-vivo.webp",
    badge: "new",
    key: "EVOLUTION",
  },
  {
    name: "Blackjack em Português 1",
    image: "/assets/casino/blackjack-em-portugues-1.webp",
    badge: "new",
    key: "EVOLUTION",
  },
  {
    name: "Blackjack em Português Ouro",
    image: "/assets/casino/blackjack-em-portugues-ouro.webp",
    badge: "new",
    key: "EVOLUTION",
  },
  {
    name: "Roleta ao Vivo",
    image: "/assets/casino/roleta-ao-vivo.webp",
    badge: "new",
    key: "EVOLUTION",
  },
  {
    name: "Blackjack en Español 2",
    image: "/assets/casino/blackjack-en-espanol-2.webp",
    badge: "new",
    key: "EVOLUTION",
  },
  {
    name: "Blackjack en Español 3",
    image: "/assets/casino/blackjack-en-espanol-3.webp",
    badge: "new",
    key: "EVOLUTION",
  },
  {
    name: "Easy Blackjack em Português",
    image: "/assets/casino/easy-blackjack-em-portugues.webp",
    badge: "new",
    key: "EVOLUTION",
  },
  {
    name: "Bac Bo Ao Vivo",
    image: "/assets/casino/bac-bo-ao-vivo.webp",
    badge: "new",
    key: "EVOLUTION",
  },
  {
    name: "Blackjack Ilimitado Ao Vivo",
    image: "/assets/casino/blackjack-ilimitado-ao-vivo.webp",
    badge: "new",
    key: "EVOLUTION",
  },
  {
    name: "Blackjack Ilimitado en Vivo",
    image: "/assets/casino/blackjack-ilimitado-en-vivo.webp",
    badge: "new",
    key: "EVOLUTION",
  },
  {
    name: "Ruleta en Español",
    image: "/assets/casino/ruleta-en-espanol.webp",
    badge: "new",
    key: "EVOLUTION",
  },
  {
    name: "Baccarat Rápido ao Vivo 1",
    image: "/assets/casino/baccarat-rapido-ao-vivo-1.webp",
    badge: "new",
    key: "EVOLUTION",
  },
  {
    name: "Baccarat Rápido ao Vivo 3",
    image: "/assets/casino/baccarat-rapido-ao-vivo-3.webp",
    badge: "new",
    key: "EVOLUTION",
  },
  {
    name: "Korean Speed Blackjack H",
    image: "/assets/casino/korean-speed-blackjack-h.webp",
    badge: "new",
    key: "EVOLUTION",
  },
  {
    name: "Korean Speed Blackjack I",
    image: "/assets/casino/korean-speed-blackjack-i.webp",
    badge: "new",
    key: "EVOLUTION",
  },
  {
    name: "Korean Lightning Baccarat",
    image: "/assets/casino/korean-lightning-baccarat.webp",
    badge: "new",
    key: "EVOLUTION",
  },
  {
    name: "Korean Speed Blackjack J",
    image: "/assets/casino/korean-speed-blackjack-j.webp",
    badge: "new",
    key: "EVOLUTION",
  },
  {
    name: "Korean Speed Blackjack K",
    image: "/assets/casino/korean-speed-blackjack-k.webp",
    badge: "new",
    key: "EVOLUTION",
  },
  {
    name: "Korean Speed Blackjack L",
    image: "/assets/casino/korean-speed-blackjack-l.webp",
    badge: "new",
    key: "EVOLUTION",
  },
  {
    name: "Korean Speed Blackjack M",
    image: "/assets/casino/korean-speed-blackjack-m.webp",
    badge: "new",
    key: "EVOLUTION",
  },
  {
    name: "Ice Fishing",
    image: "/assets/casino/ice-fishing.webp",
    badge: "new",
    key: "EVOLUTION",
  },
  {
    name: "Korean Lightning Dragon Tiger",
    image: "/assets/casino/korean-lightning-dragon-tiger.webp",
    key: "EVOLUTION",
  },
  {
    name: "Korean Platinum Private Blackjack 1",
    image: "/assets/casino/korean-platinum-private-blackjack-1.webp",
    key: "EVOLUTION",
  },
  {
    name: "Korean Platinum Private Blackjack 2",
    image: "/assets/casino/korean-platinum-private-blackjack-2.webp",
    key: "EVOLUTION",
  },
  {
    name: "Japanese Platinum Private Blackjack 1",
    image: "/assets/casino/japanese-platinum-private-blackjack-1.webp",
    key: "EVOLUTION",
  },
  {
    name: "Platinum Privé Blackjack 4",
    image: "/assets/casino/platinum-prive-blackjack-4.webp",
    key: "EVOLUTION",
  },
  {
    name: "Platinum Privé Blackjack 5",
    image: "/assets/casino/platinum-prive-blackjack-5.webp",
    key: "EVOLUTION",
  },
  {
    name: "Platinum Privé Blackjack 6",
    image: "/assets/casino/platinum-prive-blackjack-6.webp",
    key: "EVOLUTION",
  },
  {
    name: "Super Speed Dragon Tiger",
    image: "/assets/casino/super-speed-dragon-tiger.webp",
    key: "EVOLUTION",
  },
  {
    name: "Salon Privé Auto-Roulette A",
    image: "/assets/casino/salon-prive-auto-roulette-a.webp",
    key: "EVOLUTION",
  },
  {
    name: "Insurance Baccarat",
    image: "/assets/casino/insurance-baccarat.webp",
    key: "EVOLUTION",
  },
  {
    name: "Lotus Speed Baccarat C",
    image: "/assets/casino/lotus-speed-baccarat-c.webp",
    key: "EVOLUTION",
  },
  {
    name: "Thai Speed Baccarat C",
    image: "/assets/casino/thai-speed-baccarat-c.webp",
    key: "EVOLUTION",
  },
  {
    name: "Thai Speed Baccarat B",
    image: "/assets/casino/thai-speed-baccarat-b.webp",
    key: "EVOLUTION",
  },
  {
    name: "Lotus Speed Baccarat B",
    image: "/assets/casino/lotus-speed-baccarat-b.webp",
    key: "EVOLUTION",
  },
  {
    name: "Dragon Tiger Phoenix",
    image: "/assets/casino/dragon-tiger-phoenix.webp",
    key: "EVOLUTION",
  },
  {
    name: "Ultimate Texas Hold'em",
    image: "/assets/casino/ultimate-texas-hold-em.webp",
    key: "EVOLUTION",
  },
  {
    name: "Three Card Poker",
    image: "/assets/casino/three-card-poker.webp",
    key: "EVOLUTION",
  },
  {
    name: "Always 9 Baccarat",
    image: "/assets/casino/always-9-baccarat.webp",
    key: "EVOLUTION",
  },
  {
    name: "Speed Baccarat 1",
    image: "/assets/casino/speed-baccarat-1.webp",
    key: "EVOLUTION",
  },
  {
    name: "Speed Baccarat 2",
    image: "/assets/casino/speed-baccarat-2.webp",
    key: "EVOLUTION",
  },
  {
    name: "Speed Baccarat 3",
    image: "/assets/casino/speed-baccarat-3.webp",
    key: "EVOLUTION",
  },
  {
    name: "Salon Privé Baccarat K",
    image: "/assets/casino/salon-prive-baccarat-k.webp",
    key: "EVOLUTION",
  },
  {
    name: "Salon Privé Baccarat L",
    image: "/assets/casino/salon-prive-baccarat-l.webp",
    key: "EVOLUTION",
  },
  {
    name: "Blackjack Rápido Clásico en Español 9",
    image: "/assets/casino/blackjack-rapido-clasico-en-espanol-9.webp",
    key: "EVOLUTION",
  },
  {
    name: "Blackjack Clasico en Español 37",
    image: "/assets/casino/blackjack-clasico-en-espanol-37.webp",
    key: "EVOLUTION",
  },
  {
    name: "Blackjack Rápido Clásico en Español 8",
    image: "/assets/casino/blackjack-rapido-clasico-en-espanol-8.webp",
    key: "EVOLUTION",
  },
  {
    name: "Blackjack Rápido Clásico en Español 7",
    image: "/assets/casino/blackjack-rapido-clasico-en-espanol-7.webp",
    key: "EVOLUTION",
  },
  {
    name: "Speed VIP Blackjack S",
    image: "/assets/casino/speed-vip-blackjack-s.webp",
    key: "EVOLUTION",
  },
  {
    name: "Platinum Private Blackjack 13",
    image: "/assets/casino/platinum-private-blackjack-13.webp",
    key: "EVOLUTION",
  },
  {
    name: "Platinum Private Blackjack 11",
    image: "/assets/casino/platinum-private-blackjack-11.webp",
    key: "EVOLUTION",
  },
  {
    name: "Platinum Private Blackjack 14",
    image: "/assets/casino/platinum-private-blackjack-14.webp",
    key: "EVOLUTION",
  },
  {
    name: "VIP Bet Stacker Blackjack 6",
    image: "/assets/casino/vip-bet-stacker-blackjack-6.webp",
    key: "EVOLUTION",
  },
  {
    name: "VIP Bet Stacker Blackjack 5",
    image: "/assets/casino/vip-bet-stacker-blackjack-5.webp",
    key: "EVOLUTION",
  },
  {
    name: "Platinum Private Blackjack 12",
    image: "/assets/casino/platinum-private-blackjack-12.webp",
    key: "EVOLUTION",
  },
  {
    name: "Platinum Private Blackjack 10",
    image: "/assets/casino/platinum-private-blackjack-10.webp",
    key: "EVOLUTION",
  },
  {
    name: "Platinum Private Blackjack 15",
    image: "/assets/casino/platinum-private-blackjack-15.webp",
    key: "EVOLUTION",
  },
  {
    name: "VIP Bet Stacker Blackjack 7",
    image: "/assets/casino/vip-bet-stacker-blackjack-7.webp",
    key: "EVOLUTION",
  },
  {
    name: "VIP Bet Stacker Blackjack 8",
    image: "/assets/casino/vip-bet-stacker-blackjack-8.webp",
    key: "EVOLUTION",
  },
  {
    name: "Dynasty Lightning Roulette",
    image: "/assets/casino/dynasty-lightning-roulette.webp",
    key: "EVOLUTION",
  },
  {
    name: "Dynasty Speed Baccarat 1",
    image: "/assets/casino/dynasty-speed-baccarat-1.webp",
    key: "EVOLUTION",
  },
  {
    name: "Dynasty Speed Baccarat 7",
    image: "/assets/casino/dynasty-speed-baccarat-7.webp",
    key: "EVOLUTION",
  },
  {
    name: "Dynasty Speed Baccarat 8",
    image: "/assets/casino/dynasty-speed-baccarat-8.webp",
    key: "EVOLUTION",
  },
  {
    name: "Dynasty Speed Baccarat 2",
    image: "/assets/casino/dynasty-speed-baccarat-2.webp",
    key: "EVOLUTION",
  },
  {
    name: "Dynasty Speed Baccarat 6",
    image: "/assets/casino/dynasty-speed-baccarat-6.webp",
    key: "EVOLUTION",
  },
  {
    name: "Dynasty Speed Baccarat 5",
    image: "/assets/casino/dynasty-speed-baccarat-5.webp",
    key: "EVOLUTION",
  },
  {
    name: "Dynasty Speed Baccarat 3",
    image: "/assets/casino/dynasty-speed-baccarat-3.webp",
    key: "EVOLUTION",
  },
  {
    name: "Dynasty Speed Baccarat 4",
    image: "/assets/casino/dynasty-speed-baccarat-4.webp",
    key: "EVOLUTION",
  },
  {
    name: "Baccarat Lobby",
    image: "/assets/casino/baccarat-lobby.webp",
    key: "PP",
  },
  {
    name: "Dynasty Roulette",
    image: "/assets/casino/dynasty-roulette.webp",
    key: "EVOLUTION",
  },
  {
    name: "Salon Privé Auto-Roulette B",
    image: "/assets/casino/salon-prive-auto-roulette-b.webp",
    key: "EVOLUTION",
  },
  {
    name: "Super Speed Baccarat A",
    image: "/assets/casino/super-speed-baccarat-a.webp",
    key: "EVOLUTION",
  },
  {
    name: "Dynasty Classic Blackjack 6",
    image: "/assets/casino/dynasty-classic-blackjack-6.webp",
    key: "EVOLUTION",
  },
  {
    name: "Dynasty Classic Blackjack 7",
    image: "/assets/casino/dynasty-classic-blackjack-7.webp",
    key: "EVOLUTION",
  },
  {
    name: "Dynasty Classic Blackjack 8",
    image: "/assets/casino/dynasty-classic-blackjack-8.webp",
    key: "EVOLUTION",
  },
  {
    name: "Dynasty Classic Blackjack 9",
    image: "/assets/casino/dynasty-classic-blackjack-9.webp",
    key: "EVOLUTION",
  },
  {
    name: "Dragon Dragon",
    image: "/assets/casino/dragon-dragon.webp",
    key: "EVOLUTION",
  },
  {
    name: "Dynasty Speed Baccarat 11",
    image: "/assets/casino/dynasty-speed-baccarat-11.webp",
    key: "EVOLUTION",
  },
  {
    name: "Dynasty Speed Baccarat 9",
    image: "/assets/casino/dynasty-speed-baccarat-9.webp",
    key: "EVOLUTION",
  },
  {
    name: "Dynasty Speed Baccarat 10",
    image: "/assets/casino/dynasty-speed-baccarat-10.webp",
    key: "EVOLUTION",
  },
  {
    name: "Dynasty Speed Baccarat 15",
    image: "/assets/casino/dynasty-speed-baccarat-15.webp",
    key: "EVOLUTION",
  },
  {
    name: "Dynasty Speed Baccarat 13",
    image: "/assets/casino/dynasty-speed-baccarat-13.webp",
    key: "EVOLUTION",
  },
  {
    name: "Dynasty Speed Baccarat 16",
    image: "/assets/casino/dynasty-speed-baccarat-16.webp",
    key: "EVOLUTION",
  },
  {
    name: "Dynasty Speed Baccarat 17",
    image: "/assets/casino/dynasty-speed-baccarat-17.webp",
    key: "EVOLUTION",
  },
  {
    name: "Dynasty Speed Baccarat 12",
    image: "/assets/casino/dynasty-speed-baccarat-12.webp",
    key: "EVOLUTION",
  },
  {
    name: "Dynasty Speed Baccarat 14",
    image: "/assets/casino/dynasty-speed-baccarat-14.webp",
    key: "EVOLUTION",
  },
  {
    name: "MONOPOLY Roulette",
    image: "/assets/casino/monopoly-roulette.webp",
    key: "EVOLUTION",
  },
  {
    name: "Amazing Baccarat",
    image: "/assets/casino/amazing-baccarat.webp",
    key: "PP",
  },
  {
    name: "MONOPOLY Roll 'em",
    image: "/assets/casino/monopoly-roll-em.webp",
    key: "EVOLUTION",
  },
  {
    name: "Dynasty VIP Blackjack 2",
    image: "/assets/casino/dynasty-vip-blackjack-2.webp",
    key: "EVOLUTION",
  },
  {
    name: "Dynasty VIP Blackjack 1",
    image: "/assets/casino/dynasty-vip-blackjack-1.webp",
    key: "EVOLUTION",
  },
  {
    name: "Ice Fishing Brasil",
    image: "/assets/casino/ice-fishing-brasil.webp",
    key: "EVOLUTION",
  },
  {
    name: "Dynasty VIP Blackjack 3",
    image: "/assets/casino/dynasty-vip-blackjack-3.webp",
    key: "EVOLUTION",
  },
  {
    name: "Dynasty VIP Blackjack 4",
    image: "/assets/casino/dynasty-vip-blackjack-4.webp",
    key: "EVOLUTION",
  },
  {
    name: "Dynasty VIP Blackjack 5",
    image: "/assets/casino/dynasty-vip-blackjack-5.webp",
    key: "EVOLUTION",
  },
  {
    name: "Color Game Bonanza",
    image: "/assets/casino/color-game-bonanza.webp",
    key: "PP",
  },
  {
    name: "Dynasty VIP Blackjack 8",
    image: "/assets/casino/dynasty-vip-blackjack-8.webp",
    key: "EVOLUTION",
  },
  {
    name: "Dynasty VIP Blackjack 7",
    image: "/assets/casino/dynasty-vip-blackjack-7.webp",
    key: "EVOLUTION",
  },
  {
    name: "Dynasty VIP Blackjack 6",
    image: "/assets/casino/dynasty-vip-blackjack-6.webp",
    key: "EVOLUTION",
  },
  {
    name: "Disco Balls",
    image: "/assets/casino/disco-balls.webp",
    key: "EVOLUTION",
  },
  {
    name: "Dice City",
    image: "/assets/casino/dice-city.webp",
    key: "PP",
    gameCode: "PP-LIVE-049",
    gameType: "LIVE",
    platFormCode: "PP",
  },
  {
    name: "American Roulette",
    image: "/assets/casino/american-roulette.webp",
    key: "PP",
    gameCode: "PP-LIVE-176",
    gameType: "LIVE",
    platFormCode: "PP",
  },
  {
    name: "Casino Hold'em",
    image: "/assets/casino/casino-hold-em.webp",
    key: "PP",
  },
  {
    name: "Immersive Roulette Deluxe",
    image: "/assets/casino/immersive-roulette-deluxe.webp",
    key: "PP",
    gameCode: "PP-LIVE-175",
    gameType: "LIVE",
    platFormCode: "PP",
  },
  {
    name: "Indonesian ONE Blackjack",
    image: "/assets/casino/indonesian-one-blackjack.webp",
    key: "PP",
  },
  {
    name: "Privé Lounge Roulette Deluxe",
    image: "/assets/casino/prive-lounge-roulette-deluxe.webp",
    key: "PP",
    gameCode: "PP-LIVE-184",
    gameType: "LIVE",
    platFormCode: "PP",
  },
  {
    name: "Vietnamese Speed Baccarat 2",
    image: "/assets/casino/vietnamese-speed-baccarat-2.webp",
    key: "PP",
    gameCode: "PP-LIVE-174",
    gameType: "LIVE",
    platFormCode: "PP",
  },
  {
    name: "Gates of Olympus Roulette",
    image: "/assets/casino/gates-of-olympus-roulette.webp",
    key: "PP",
  },
  {
    name: "Hi-Lo Baccarat",
    image: "/assets/casino/hi-lo-baccarat.webp",
    key: "PP",
  },
  {
    name: "Infinite Fun Fun 21 Blackjack",
    image: "/assets/casino/infinite-fun-fun-21-blackjack.webp",
    key: "EVOLUTION",
  },
  {
    name: "Super Speed Baccarat",
    image: "/assets/casino/super-speed-baccarat.webp",
    key: "EVOLUTION",
  },
  {
    name: "Speed Baccarat 2",
    image: "/assets/casino/403.webp",
    key: "PP",
    gameCode: "PP-LIVE-014",
    gameType: "LIVE",
    platFormCode: "PP",
  },
  {
    name: "Korean Speed Baccarat 1",
    image: "/assets/casino/korean-speed-baccarat-1.webp",
    key: "PP",
    gameCode: "PP-LIVE-056",
    gameType: "LIVE",
    platFormCode: "PP",
  },
  {
    name: "Korean Speed Baccarat 2",
    image: "/assets/casino/korean-speed-baccarat-2.webp",
    key: "PP",
    gameCode: "PP-LIVE-057",
    gameType: "LIVE",
    platFormCode: "PP",
  },
  {
    name: "Lucky 6 Roulette",
    image: "/assets/casino/lucky-6-roulette.webp",
    key: "PP",
    gameCode: "PP-LIVE-077",
    gameType: "LIVE",
    platFormCode: "PP",
  },
  {
    name: "Korean Speed Baccarat 3",
    image: "/assets/casino/korean-speed-baccarat-3.webp",
    key: "PP",
    gameCode: "PP-LIVE-070",
    gameType: "LIVE",
    platFormCode: "PP",
  },
  {
    name: "Mega Roulette",
    image: "/assets/casino/mega-roulette.webp",
    key: "PP",
    gameCode: "PP-LIVE-039",
    gameType: "LIVE",
    platFormCode: "PP",
  },
  {
    name: "Indonesia Speed Baccarat 1",
    image: "/assets/casino/indonesia-speed-baccarat-1.webp",
    key: "PP",
  },
  {
    name: "Mega Baccarat",
    image: "/assets/casino/mega-baccarat.webp",
    key: "PP",
    gameCode: "PP-LIVE-061",
    gameType: "LIVE",
    platFormCode: "PP",
  },
  {
    name: "Roulette Macao",
    image: "/assets/casino/roulette-macao.webp",
    key: "PP",
    gameCode: "PP-LIVE-034",
    gameType: "LIVE",
    platFormCode: "PP",
  },
  {
    name: "Dragon Tiger",
    image: "/assets/casino/dragon-tiger.webp",
    key: "PP",
    gameCode: "PP-TABLE-001",
    gameType: "TABLE",
    platFormCode: "PP",
  },
  {
    name: "Thai Speed Baccarat 1",
    image: "/assets/casino/thai-speed-baccarat-1.webp",
    key: "PP",
    gameCode: "PP-LIVE-069",
    gameType: "LIVE",
    platFormCode: "PP",
  },
  {
    name: "Roulette 1",
    image: "/assets/casino/roulette-1.webp",
    key: "PP",
    gameCode: "PP-LIVE-028",
    gameType: "LIVE",
    platFormCode: "PP",
  },
  {
    name: "Baccarat 2",
    image: "/assets/casino/baccarat-2.webp",
    key: "PP",
    gameCode: "PP-LIVE-002",
    gameType: "LIVE",
    platFormCode: "PP",
  },
  {
    name: "Privé Lounge Baccarat 1",
    image: "/assets/casino/prive-lounge-baccarat-1.webp",
    key: "PP",
  },
  {
    name: "Mega Sic Bac",
    image: "/assets/casino/mega-sic-bac.webp",
    key: "PP",
  },
  {
    name: "Japanese Speed Baccarat 1",
    image: "/assets/casino/japanese-speed-baccarat-1.webp",
    key: "PP",
    gameCode: "PP-LIVE-118",
    gameType: "LIVE",
    platFormCode: "PP",
  },
  {
    name: "Chinese Speed Baccarat 1",
    image: "/assets/casino/chinese-speed-baccarat-1.webp",
    key: "PP",
    gameCode: "PP-LIVE-080",
    gameType: "LIVE",
    platFormCode: "PP",
  },
  {
    name: "Korean Baccarat 1",
    image: "/assets/casino/korean-baccarat-1.webp",
    key: "PP",
    gameCode: "PP-LIVE-071",
    gameType: "LIVE",
    platFormCode: "PP",
  },
  {
    name: "Korean Speed Baccarat 5",
    image: "/assets/casino/korean-speed-baccarat-5.webp",
    key: "PP",
    gameCode: "PP-LIVE-117",
    gameType: "LIVE",
    platFormCode: "PP",
  },
  {
    name: "Korean Turbo Baccarat 1",
    image: "/assets/casino/korean-turbo-baccarat-1.webp",
    key: "PP",
  },
  {
    name: "Japanese Speed Baccarat 2",
    image: "/assets/casino/japanese-speed-baccarat-2.webp",
    key: "PP",
    gameCode: "PP-LIVE-119",
    gameType: "LIVE",
    platFormCode: "PP",
  },
  {
    name: "Japanese Speed Baccarat 3",
    image: "/assets/casino/japanese-speed-baccarat-3.webp",
    key: "PP",
    gameCode: "PP-LIVE-099",
    gameType: "LIVE",
    platFormCode: "PP",
  },
  {
    name: "Chinese Speed Baccarat 2",
    image: "/assets/casino/chinese-speed-baccarat-2.webp",
    key: "PP",
    gameCode: "PP-LIVE-114",
    gameType: "LIVE",
    platFormCode: "PP",
  },
  {
    name: "Chinese Speed Baccarat 3",
    image: "/assets/casino/chinese-speed-baccarat-3.webp",
    key: "PP",
    gameCode: "PP-LIVE-139",
    gameType: "LIVE",
    platFormCode: "PP",
  },
  {
    name: "Vietnamese Speed Baccarat 1",
    image: "/assets/casino/vietnamese-speed-baccarat-1.webp",
    key: "PP",
    gameCode: "PP-LIVE-115",
    gameType: "LIVE",
    platFormCode: "PP",
  },
  {
    name: "Fortune 6 Baccarat",
    image: "/assets/casino/fortune-6-baccarat.webp",
    key: "PP",
    gameCode: "PP-LIVE-047",
    gameType: "LIVE",
    platFormCode: "PP",
  },
  {
    name: "Super 8 Baccarat",
    image: "/assets/casino/super-8-baccarat.webp",
    key: "PP",
    gameCode: "PP-LIVE-045",
    gameType: "LIVE",
    platFormCode: "PP",
  },
  {
    name: "Privé Lounge Baccarat 2",
    image: "/assets/casino/prive-lounge-baccarat-2.webp",
    key: "PP",
  },
  {
    name: "Privé Lounge Baccarat 3",
    image: "/assets/casino/prive-lounge-baccarat-3.webp",
    key: "PP",
  },
  {
    name: "Privé Lounge Baccarat 5",
    image: "/assets/casino/prive-lounge-baccarat-5.webp",
    key: "PP",
  },
  {
    name: "Privé Lounge Baccarat 6",
    image: "/assets/casino/prive-lounge-baccarat-6.webp",
    key: "PP",
  },
  {
    name: "Privé Lounge Baccarat 7",
    image: "/assets/casino/prive-lounge-baccarat-7.webp",
    key: "PP",
  },
  {
    name: "Privé Lounge Baccarat 8",
    image: "/assets/casino/prive-lounge-baccarat-8.webp",
    key: "PP",
  },
  {
    name: "Speed Baccarat 3",
    image: "/assets/casino/412.webp",
    key: "PP",
    gameCode: "PP-LIVE-015",
    gameType: "LIVE",
    platFormCode: "PP",
  },
  {
    name: "Speed Baccarat 5",
    image: "/assets/casino/speed-baccarat-5.webp",
    key: "PP",
    gameCode: "PP-LIVE-016",
    gameType: "LIVE",
    platFormCode: "PP",
  },
  {
    name: "Speed Baccarat 6",
    image: "/assets/casino/speed-baccarat-6.webp",
    key: "PP",
    gameCode: "PP-LIVE-017",
    gameType: "LIVE",
    platFormCode: "PP",
  },
  {
    name: "Speed Baccarat 7",
    image: "/assets/casino/speed-baccarat-7.webp",
    key: "PP",
    gameCode: "PP-LIVE-018",
    gameType: "LIVE",
    platFormCode: "PP",
  },
  {
    name: "Speed Baccarat 8",
    image: "/assets/casino/speed-baccarat-8.webp",
    key: "PP",
    gameCode: "PP-LIVE-019",
    gameType: "LIVE",
    platFormCode: "PP",
  },
  {
    name: "Speed Baccarat 9",
    image: "/assets/casino/speed-baccarat-9.webp",
    key: "PP",
    gameCode: "PP-LIVE-020",
    gameType: "LIVE",
    platFormCode: "PP",
  },
  {
    name: "Speed Baccarat 10",
    image: "/assets/casino/speed-baccarat-10.webp",
    key: "PP",
    gameCode: "PP-LIVE-021",
    gameType: "LIVE",
    platFormCode: "PP",
  },
  {
    name: "Speed Baccarat 11",
    image: "/assets/casino/speed-baccarat-11.webp",
    key: "PP",
    gameCode: "PP-LIVE-022",
    gameType: "LIVE",
    platFormCode: "PP",
  },
  {
    name: "Speed Baccarat 12",
    image: "/assets/casino/speed-baccarat-12.webp",
    key: "PP",
    gameCode: "PP-LIVE-023",
    gameType: "LIVE",
    platFormCode: "PP",
  },
  {
    name: "Speed Baccarat 13",
    image: "/assets/casino/speed-baccarat-13.webp",
    key: "PP",
    gameCode: "PP-LIVE-024",
    gameType: "LIVE",
    platFormCode: "PP",
  },
  {
    name: "Speed Baccarat 18",
    image: "/assets/casino/speed-baccarat-18.webp",
    key: "PP",
  },
  {
    name: "Speed Baccarat 15",
    image: "/assets/casino/speed-baccarat-15.webp",
    key: "PP",
    gameCode: "PP-LIVE-008",
    gameType: "LIVE",
    platFormCode: "PP",
  },
  {
    name: "Speed Baccarat 16",
    image: "/assets/casino/speed-baccarat-16.webp",
    key: "PP",
    gameCode: "PP-LIVE-050",
    gameType: "LIVE",
    platFormCode: "PP",
  },
  {
    name: "Speed Baccarat 17",
    image: "/assets/casino/speed-baccarat-17.webp",
    key: "PP",
    gameCode: "PP-LIVE-051",
    gameType: "LIVE",
    platFormCode: "PP",
  },
  {
    name: "Baccarat 3",
    image: "/assets/casino/baccarat-3.webp",
    key: "PP",
    gameCode: "PP-LIVE-010",
    gameType: "LIVE",
    platFormCode: "PP",
  },
  {
    name: "Baccarat 5",
    image: "/assets/casino/baccarat-5.webp",
    key: "PP",
    gameCode: "PP-LIVE-004",
    gameType: "LIVE",
    platFormCode: "PP",
  },
  {
    name: "Baccarat 6",
    image: "/assets/casino/baccarat-6.webp",
    key: "PP",
    gameCode: "PP-LIVE-005",
    gameType: "LIVE",
    platFormCode: "PP",
  },
  {
    name: "Baccarat 7",
    image: "/assets/casino/baccarat-7.webp",
    key: "PP",
    gameCode: "PP-LIVE-006",
    gameType: "LIVE",
    platFormCode: "PP",
  },
  {
    name: "Turbo Baccarat",
    image: "/assets/casino/turbo-baccarat.webp",
    key: "PP",
  },
  {
    name: "Baccarat 9",
    image: "/assets/casino/baccarat-9.webp",
    key: "PP",
    gameCode: "PP-LIVE-052",
    gameType: "LIVE",
    platFormCode: "PP",
  },
  {
    name: "Roulette 3",
    image: "/assets/casino/roulette-3.webp",
    key: "PP",
    gameCode: "PP-LIVE-037",
    gameType: "LIVE",
    platFormCode: "PP",
  },
  {
    name: "PowerUP Roulette",
    image: "/assets/casino/powerup-roulette.webp",
    key: "PP",
    gameCode: "PP-LIVE-055",
    gameType: "LIVE",
    platFormCode: "PP",
  },
  {
    name: "Auto Roulette",
    image: "/assets/casino/auto-roulette.webp",
    key: "PP",
  },
  {
    name: "Auto Roulette VIP",
    image: "/assets/casino/auto-roulette-vip.webp",
    key: "PP",
  },
  {
    name: "Korean Roulette",
    image: "/assets/casino/korean-roulette.webp",
    key: "PP",
    gameCode: "PP-LIVE-073",
    gameType: "LIVE",
    platFormCode: "PP",
  },
  {
    name: "Vietnamese Roulette",
    image: "/assets/casino/vietnamese-roulette.webp",
    key: "PP",
    gameCode: "PP-LIVE-068",
    gameType: "LIVE",
    platFormCode: "PP",
  },
  {
    name: "Brazilian Roulette",
    image: "/assets/casino/brazilian-roulette.webp",
    key: "PP",
    gameCode: "PP-LIVE-074",
    gameType: "LIVE",
    platFormCode: "PP",
  },
  {
    name: "German Roulette",
    image: "/assets/casino/german-roulette.webp",
    key: "PP",
    gameCode: "PP-LIVE-031",
    gameType: "LIVE",
    platFormCode: "PP",
  },
  {
    name: "Turkish Roulette",
    image: "/assets/casino/turkish-roulette.webp",
    key: "PP",
    gameCode: "PP-LIVE-033",
    gameType: "LIVE",
    platFormCode: "PP",
  },
  {
    name: "Russian Roulette",
    image: "/assets/casino/russian-roulette.webp",
    key: "PP",
    gameCode: "PP-LIVE-030",
    gameType: "LIVE",
    platFormCode: "PP",
  },
  {
    name: "Auto Mega Roulette",
    image: "/assets/casino/auto-mega-roulette.webp",
    key: "PP",
    gameCode: "PP-LIVE-075",
    gameType: "LIVE",
    platFormCode: "PP",
  },
  {
    name: "Speed Auto Roulette",
    image: "/assets/casino/speed-auto-roulette.webp",
    key: "PP",
  },
  {
    name: "Roulette Latina",
    image: "/assets/casino/roulette-latina.webp",
    key: "PP",
    gameCode: "PP-LIVE-053",
    gameType: "LIVE",
    platFormCode: "PP",
  },
  {
    name: "Speed Roulette 2",
    image: "/assets/casino/speed-roulette-2.webp",
    key: "PP",
    gameCode: "PP-LIVE-054",
    gameType: "LIVE",
    platFormCode: "PP",
  },
  {
    name: "Italian Roulette",
    image: "/assets/casino/italian-roulette.webp",
    key: "PP",
  },
  {
    name: "Turkish Mega Roulette",
    image: "/assets/casino/turkish-mega-roulette.webp",
    key: "PP",
    gameCode: "PP-LIVE-081",
    gameType: "LIVE",
    platFormCode: "PP",
  },
  {
    name: "Mega Roulette - Brazilian",
    image: "/assets/casino/mega-roulette-brazilian.webp",
    key: "PP",
    gameCode: "PP-LIVE-141",
    gameType: "LIVE",
    platFormCode: "PP",
  },
  {
    name: "Romanian Roulette",
    image: "/assets/casino/romanian-roulette.webp",
    key: "PP",
  },
  {
    name: "Treasure Island",
    image: "/assets/casino/treasure-island.webp",
    key: "PP",
    gameCode: "PP-LIVE-078",
    gameType: "LIVE",
    platFormCode: "PP",
  },
  {
    name: "Snake & Ladders Live",
    image: "/assets/casino/snake-ladders-live.webp",
    key: "PP",
  },
  {
    name: "SicBo",
    image: "/assets/casino/sicbo.webp",
    key: "PP",
    gameCode: "PP-LIVE-079",
    gameType: "LIVE",
    platFormCode: "PP",
  },
  {
    name: "Football Blitz",
    image: "/assets/casino/football-blitz.webp",
    key: "PP",
  },
  {
    name: "Bet Behind Pro Blackjack",
    image: "/assets/casino/bet-behind-pro-blackjack.webp",
    key: "PP",
    gameCode: "PP-LIVE-143",
    gameType: "LIVE",
    platFormCode: "PP",
  },
  {
    name: "ONE Blackjack 2",
    image: "/assets/casino/one-blackjack-2.webp",
    key: "PP",
  },
  {
    name: "BlackjackX 3",
    image: "/assets/casino/blackjackx-3.webp",
    key: "PP",
    gameCode: "PP-LIVE-084",
    gameType: "LIVE",
    platFormCode: "PP",
  },
  {
    name: "BlackjackX 1",
    image: "/assets/casino/blackjackx-1.webp",
    key: "PP",
    gameCode: "PP-LIVE-082",
    gameType: "LIVE",
    platFormCode: "PP",
  },
  {
    name: "BlackjackX 5",
    image: "/assets/casino/blackjackx-5.webp",
    key: "PP",
    gameCode: "PP-LIVE-086",
    gameType: "LIVE",
    platFormCode: "PP",
  },
  {
    name: "BlackjackX 6",
    image: "/assets/casino/blackjackx-6.webp",
    key: "PP",
    gameCode: "PP-LIVE-087",
    gameType: "LIVE",
    platFormCode: "PP",
  },
  {
    name: "BlackjackX 2",
    image: "/assets/casino/blackjackx-2.webp",
    key: "PP",
    gameCode: "PP-LIVE-083",
    gameType: "LIVE",
    platFormCode: "PP",
  },
  {
    name: "BlackjackX 4",
    image: "/assets/casino/blackjackx-4.webp",
    key: "PP",
    gameCode: "PP-LIVE-085",
    gameType: "LIVE",
    platFormCode: "PP",
  },
  {
    name: "BlackjackX 8",
    image: "/assets/casino/blackjackx-8.webp",
    key: "PP",
    gameCode: "PP-LIVE-089",
    gameType: "LIVE",
    platFormCode: "PP",
  },
  {
    name: "BlackjackX 7",
    image: "/assets/casino/blackjackx-7.webp",
    key: "PP",
    gameCode: "PP-LIVE-088",
    gameType: "LIVE",
    platFormCode: "PP",
  },
  {
    name: "BlackjackX 14",
    image: "/assets/casino/blackjackx-14.webp",
    key: "PP",
    gameCode: "PP-LIVE-092",
    gameType: "LIVE",
    platFormCode: "PP",
  },
  {
    name: "BlackjackX 15",
    image: "/assets/casino/blackjackx-15.webp",
    key: "PP",
    gameCode: "PP-LIVE-093",
    gameType: "LIVE",
    platFormCode: "PP",
  },
  {
    name: "BlackjackX 16",
    image: "/assets/casino/blackjackx-16.webp",
    key: "PP",
    gameCode: "PP-LIVE-094",
    gameType: "LIVE",
    platFormCode: "PP",
  },
  {
    name: "BlackjackX 21",
    image: "/assets/casino/blackjackx-21.webp",
    key: "PP",
    gameCode: "PP-LIVE-120",
    gameType: "LIVE",
    platFormCode: "PP",
  },
  {
    name: "BlackjackX 9",
    image: "/assets/casino/blackjackx-9.webp",
    key: "PP",
    gameCode: "PP-LIVE-090",
    gameType: "LIVE",
    platFormCode: "PP",
  },
  {
    name: "BlackjackX 10",
    image: "/assets/casino/blackjackx-10.webp",
    key: "PP",
    gameCode: "PP-LIVE-091",
    gameType: "LIVE",
    platFormCode: "PP",
  },
  {
    name: "BlackjackX 24",
    image: "/assets/casino/blackjackx-24.webp",
    key: "PP",
    gameCode: "PP-LIVE-121",
    gameType: "LIVE",
    platFormCode: "PP",
  },
  {
    name: "BlackjackX 25",
    image: "/assets/casino/blackjackx-25.webp",
    key: "PP",
    gameCode: "PP-LIVE-122",
    gameType: "LIVE",
    platFormCode: "PP",
  },
  {
    name: "BlackjackX 17",
    image: "/assets/casino/blackjackx-17.webp",
    key: "PP",
    gameCode: "PP-LIVE-095",
    gameType: "LIVE",
    platFormCode: "PP",
  },
  {
    name: "BlackjackX 18",
    image: "/assets/casino/blackjackx-18.webp",
    key: "PP",
    gameCode: "PP-LIVE-096",
    gameType: "LIVE",
    platFormCode: "PP",
  },
  {
    name: "BlackjackX 19",
    image: "/assets/casino/blackjackx-19.webp",
    key: "PP",
    gameCode: "PP-LIVE-097",
    gameType: "LIVE",
    platFormCode: "PP",
  },
  {
    name: "BlackjackX 20",
    image: "/assets/casino/blackjackx-20.webp",
    key: "PP",
    gameCode: "PP-LIVE-098",
    gameType: "LIVE",
    platFormCode: "PP",
  },
  {
    name: "BlackjackX 11",
    image: "/assets/casino/blackjackx-11.webp",
    key: "PP",
    gameCode: "PP-LIVE-112",
    gameType: "LIVE",
    platFormCode: "PP",
  },
  {
    name: "BlackjackX 12",
    image: "/assets/casino/blackjackx-12.webp",
    key: "PP",
    gameCode: "PP-LIVE-111",
    gameType: "LIVE",
    platFormCode: "PP",
  },
  {
    name: "BlackjackX 13",
    image: "/assets/casino/blackjackx-13.webp",
    key: "PP",
    gameCode: "PP-LIVE-110",
    gameType: "LIVE",
    platFormCode: "PP",
  },
  {
    name: "BlackjackX 22",
    image: "/assets/casino/blackjackx-22.webp",
    key: "PP",
    gameCode: "PP-LIVE-109",
    gameType: "LIVE",
    platFormCode: "PP",
  },
  {
    name: "BlackjackX 29",
    image: "/assets/casino/blackjackx-29.webp",
    key: "PP",
    gameCode: "PP-LIVE-104",
    gameType: "LIVE",
    platFormCode: "PP",
  },
  {
    name: "BlackjackX 30",
    image: "/assets/casino/blackjackx-30.webp",
    key: "PP",
    gameCode: "PP-LIVE-103",
    gameType: "LIVE",
    platFormCode: "PP",
  },
  {
    name: "BlackjackX 23",
    image: "/assets/casino/blackjackx-23.webp",
    key: "PP",
    gameCode: "PP-LIVE-108",
    gameType: "LIVE",
    platFormCode: "PP",
  },
  {
    name: "BlackjackX 26",
    image: "/assets/casino/blackjackx-26.webp",
    key: "PP",
    gameCode: "PP-LIVE-107",
    gameType: "LIVE",
    platFormCode: "PP",
  },
  {
    name: "BlackjackX 27",
    image: "/assets/casino/blackjackx-27.webp",
    key: "PP",
    gameCode: "PP-LIVE-106",
    gameType: "LIVE",
    platFormCode: "PP",
  },
  {
    name: "BlackjackX 28",
    image: "/assets/casino/blackjackx-28.webp",
    key: "PP",
    gameCode: "PP-LIVE-105",
    gameType: "LIVE",
    platFormCode: "PP",
  },
  {
    name: "Asian Games",
    image: "/assets/casino/asian-games.webp",
    key: "PP",
  },
  {
    name: "Blackjack Lobby",
    image: "/assets/casino/blackjack-lobby.webp",
    key: "PP",
  },
  {
    name: "BlackjackX 31",
    image: "/assets/casino/blackjackx-31.webp",
    key: "PP",
    gameCode: "PP-LIVE-152",
    gameType: "LIVE",
    platFormCode: "PP",
  },
  {
    name: "BlackjackX 32",
    image: "/assets/casino/blackjackx-32.webp",
    key: "PP",
    gameCode: "PP-LIVE-153",
    gameType: "LIVE",
    platFormCode: "PP",
  },
  {
    name: "BlackjackX 33",
    image: "/assets/casino/blackjackx-33.webp",
    key: "PP",
    gameCode: "PP-LIVE-154",
    gameType: "LIVE",
    platFormCode: "PP",
  },
  {
    name: "BlackjackX 34",
    image: "/assets/casino/blackjackx-34.webp",
    key: "PP",
    gameCode: "PP-LIVE-155",
    gameType: "LIVE",
    platFormCode: "PP",
  },
  {
    name: "BlackjackX 35",
    image: "/assets/casino/blackjackx-35.webp",
    key: "PP",
    gameCode: "PP-LIVE-156",
    gameType: "LIVE",
    platFormCode: "PP",
  },
  {
    name: "BlackjackX 36",
    image: "/assets/casino/blackjackx-36.webp",
    key: "PP",
    gameCode: "PP-LIVE-157",
    gameType: "LIVE",
    platFormCode: "PP",
  },
  {
    name: "BlackjackX 37",
    image: "/assets/casino/blackjackx-37.webp",
    key: "PP",
    gameCode: "PP-LIVE-158",
    gameType: "LIVE",
    platFormCode: "PP",
  },
  {
    name: "BlackjackX 38",
    image: "/assets/casino/blackjackx-38.webp",
    key: "PP",
    gameCode: "PP-LIVE-159",
    gameType: "LIVE",
    platFormCode: "PP",
  },
  {
    name: "BlackjackX 39",
    image: "/assets/casino/blackjackx-39.webp",
    key: "PP",
    gameCode: "PP-LIVE-160",
    gameType: "LIVE",
    platFormCode: "PP",
  },
  {
    name: "BlackjackX 40",
    image: "/assets/casino/blackjackx-40.webp",
    key: "PP",
    gameCode: "PP-LIVE-161",
    gameType: "LIVE",
    platFormCode: "PP",
  },
  {
    name: "D&W",
    image: "/assets/casino/d-w.webp",
    key: "PP",
  },
  {
    name: "Dragon Tiger",
    image: "",
    key: "PP",
    gameCode: "PP-TABLE-001",
    gameType: "TABLE",
    platFormCode: "PP",
  },
  {
    name: "Fortune Roulette",
    image: "/assets/casino/fortune-roulette.webp",
    key: "PP",
    gameCode: "PP-LIVE-163",
    gameType: "LIVE",
    platFormCode: "PP",
  },
  {
    name: "French Roulette la Partage",
    image: "/assets/casino/french-roulette-la-partage.webp",
    key: "PP",
  },
  {
    name: "Indonesian BlackjackX 1",
    image: "/assets/casino/indonesian-blackjackx-1.webp",
    key: "PP",
    gameCode: "PP-LIVE-147",
    gameType: "LIVE",
    platFormCode: "PP",
  },
  {
    name: "Indonesian BlackjackX 10",
    image: "/assets/casino/indonesian-blackjackx-10.webp",
    key: "PP",
    gameCode: "PP-LIVE-168",
    gameType: "LIVE",
    platFormCode: "PP",
  },
  {
    name: "Indonesian BlackjackX 11",
    image: "/assets/casino/indonesian-blackjackx-11.webp",
    key: "PP",
    gameCode: "PP-LIVE-169",
    gameType: "LIVE",
    platFormCode: "PP",
  },
  {
    name: "Indonesian BlackjackX 12",
    image: "/assets/casino/indonesian-blackjackx-12.webp",
    key: "PP",
    gameCode: "PP-LIVE-170",
    gameType: "LIVE",
    platFormCode: "PP",
  },
  {
    name: "Indonesian BlackjackX 13",
    image: "/assets/casino/indonesian-blackjackx-13.webp",
    key: "PP",
    gameCode: "PP-LIVE-171",
    gameType: "LIVE",
    platFormCode: "PP",
  },
  {
    name: "Indonesian BlackjackX 14",
    image: "/assets/casino/indonesian-blackjackx-14.webp",
    key: "PP",
    gameCode: "PP-LIVE-172",
    gameType: "LIVE",
    platFormCode: "PP",
  },
  {
    name: "Indonesian BlackjackX 15",
    image: "/assets/casino/indonesian-blackjackx-15.webp",
    key: "PP",
    gameCode: "PP-LIVE-173",
    gameType: "LIVE",
    platFormCode: "PP",
  },
  {
    name: "Indonesian BlackjackX 16",
    image: "/assets/casino/indonesian-blackjackx-16.webp",
    key: "PP",
  },
  {
    name: "Indonesian BlackjackX 17",
    image: "/assets/casino/indonesian-blackjackx-17.webp",
    key: "PP",
  },
  {
    name: "Indonesian BlackjackX 18",
    image: "/assets/casino/indonesian-blackjackx-18.webp",
    key: "PP",
  },
  {
    name: "Indonesian BlackjackX 19",
    image: "/assets/casino/indonesian-blackjackx-19.webp",
    key: "PP",
  },
  {
    name: "Indonesian BlackjackX 2",
    image: "/assets/casino/indonesian-blackjackx-2.webp",
    key: "PP",
    gameCode: "PP-LIVE-148",
    gameType: "LIVE",
    platFormCode: "PP",
  },
  {
    name: "Indonesian BlackjackX 20",
    image: "/assets/casino/indonesian-blackjackx-20.webp",
    key: "PP",
  },
  {
    name: "Indonesian BlackjackX 3",
    image: "/assets/casino/indonesian-blackjackx-3.webp",
    key: "PP",
    gameCode: "PP-LIVE-149",
    gameType: "LIVE",
    platFormCode: "PP",
  },
  {
    name: "Indonesian BlackjackX 4",
    image: "/assets/casino/indonesian-blackjackx-4.webp",
    key: "PP",
    gameCode: "PP-LIVE-150",
    gameType: "LIVE",
    platFormCode: "PP",
  },
  {
    name: "Indonesian BlackjackX 5",
    image: "/assets/casino/indonesian-blackjackx-5.webp",
    key: "PP",
    gameCode: "PP-LIVE-151",
    gameType: "LIVE",
    platFormCode: "PP",
  },
  {
    name: "Indonesian BlackjackX 6",
    image: "/assets/casino/indonesian-blackjackx-6.webp",
    key: "PP",
    gameCode: "PP-LIVE-164",
    gameType: "LIVE",
    platFormCode: "PP",
  },
  {
    name: "Indonesian BlackjackX 7",
    image: "/assets/casino/indonesian-blackjackx-7.webp",
    key: "PP",
    gameCode: "PP-LIVE-165",
    gameType: "LIVE",
    platFormCode: "PP",
  },
  {
    name: "Indonesian BlackjackX 8",
    image: "/assets/casino/indonesian-blackjackx-8.webp",
    key: "PP",
    gameCode: "PP-LIVE-166",
    gameType: "LIVE",
    platFormCode: "PP",
  },
  {
    name: "Indonesian BlackjackX 9",
    image: "/assets/casino/indonesian-blackjackx-9.webp",
    key: "PP",
    gameCode: "PP-LIVE-167",
    gameType: "LIVE",
    platFormCode: "PP",
  },
  {
    name: "Indonesian Roulette",
    image: "/assets/casino/indonesian-roulette.webp",
    key: "PP",
    gameCode: "PP-LIVE-146",
    gameType: "LIVE",
    platFormCode: "PP",
  },
  {
    name: "Jacks or Better Draw Poker",
    image: "/assets/casino/jacks-or-better-draw-poker.webp",
    key: "PP",
    gameCode: "PP-LIVE-183",
    gameType: "LIVE",
    platFormCode: "PP",
  },
  {
    name: "Korean Baccarat 2",
    image: "/assets/casino/korean-baccarat-2.webp",
    key: "PP",
    gameCode: "PP-LIVE-180",
    gameType: "LIVE",
    platFormCode: "PP",
  },
  {
    name: "Korean ONE Blackjack",
    image: "/assets/casino/korean-one-blackjack.webp",
    key: "PP",
  },
  {
    name: "LOBBY_LOCALISED",
    image: "",
    key: "PP",
  },
  {
    name: "Live Casino Lobby",
    image: "",
    key: "PP",
  },
  {
    name: "MegaRoulette3000",
    image: "/assets/casino/megaroulette3000.webp",
    key: "PP",
    gameCode: "PP-LIVE-189",
    gameType: "LIVE",
    platFormCode: "PP",
  },
  {
    name: "Other Promos",
    image: "",
    key: "PP",
  },
  {
    name: "Poker",
    image: "/assets/casino/poker.webp",
    key: "PP",
  },
  {
    name: "Power Ball",
    image: "",
    key: "PP",
  },
  {
    name: "Privé Lounge Roulette",
    image: "/assets/casino/prive-lounge-roulette.webp",
    key: "PP",
  },
  {
    name: "Roulette Lobby",
    image: "/assets/casino/roulette-lobby.webp",
    key: "PP",
  },
  {
    name: "Sic Bo & Dragon Tiger",
    image: "",
    key: "PP",
  },
  {
    name: "Squeeze Baccarat",
    image: "/assets/casino/squeeze-baccarat.webp",
    key: "PP",
    gameCode: "PP-LIVE-179",
    gameType: "LIVE",
    platFormCode: "PP",
  },
  {
    name: "Thai Roulette",
    image: "/assets/casino/thai-roulette.webp",
    key: "PP",
    gameCode: "PP-LIVE-178",
    gameType: "LIVE",
    platFormCode: "PP",
  },
  {
    name: "Thai Speed Baccarat 2",
    image: "/assets/casino/thai-speed-baccarat-2.webp",
    key: "PP",
    gameCode: "PP-LIVE-162",
    gameType: "LIVE",
    platFormCode: "PP",
  },
  {
    name: "Vietnamese Speed Baccarat 3",
    image: "/assets/casino/vietnamese-speed-baccarat-3.webp",
    key: "PP",
    gameCode: "PP-LIVE-177",
    gameType: "LIVE",
    platFormCode: "PP",
  },
  {
    name: "Brazilian ONE Blackjack",
    image: "/assets/casino/brazilian-one-blackjack.webp",
    key: "PP",
  },
  {
    name: "Turkish ONE Blackjack",
    image: "/assets/casino/turkish-one-blackjack.webp",
    key: "PP",
  },
  {
    name: "Lightning Ball",
    image: "/assets/casino/lightning-ball.webp",
    key: "EVOLUTION",
  },
  {
    name: "Baccarat 3",
    image: "/assets/casino/422.webp",
    key: "PP",
    gameCode: "PP-LIVE-010",
    gameType: "LIVE",
    platFormCode: "PP",
  },
  {
    name: "Big Small Baccarat",
    image: "/assets/casino/big-small-baccarat.webp",
    key: "PP",
  },
  {
    name: "Crystal Roulette",
    image: "/assets/casino/crystal-roulette.webp",
    key: "PP",
  },
  {
    name: "Free Bet Blackjack 1",
    image: "/assets/casino/free-bet-blackjack-1.webp",
    key: "PP",
  },
  {
    name: "Free Bet Blackjack 2",
    image: "/assets/casino/free-bet-blackjack-2.webp",
    key: "PP",
  },
  {
    name: "Indonesian Speed Baccarat 2",
    image: "/assets/casino/indonesian-speed-baccarat-2.webp",
    key: "PP",
  },
  {
    name: "Money Time",
    image: "/assets/casino/money-time.webp",
    key: "PP",
    gameCode: "PP-LIVE-188",
    gameType: "LIVE",
    platFormCode: "PP",
  },
  {
    name: "MultiTable Play",
    image: "/assets/casino/multitable-play.webp",
    key: "PP",
  },
  {
    name: "Privé Lounge Russian Poker",
    image: "/assets/casino/prive-lounge-russian-poker.webp",
    key: "PP",
  },
  {
    name: "Roulette 3",
    image: "/assets/casino/230.webp",
    key: "PP",
    gameCode: "PP-LIVE-037",
    gameType: "LIVE",
    platFormCode: "PP",
  },
  {
    name: "Seotda Baccarat",
    image: "/assets/casino/seotda-baccarat.webp",
    key: "PP",
  },
  {
    name: "Sicbo",
    image: "/assets/casino/sicbo-2.webp",
    key: "PP",
    gameCode: "PP-LIVE-079",
    gameType: "LIVE",
    platFormCode: "PP",
  },
  {
    name: "Speed Baccarat 11",
    image: "/assets/casino/424.webp",
    key: "PP",
    gameCode: "PP-LIVE-022",
    gameType: "LIVE",
    platFormCode: "PP",
  },
  {
    name: "Speed Baccarat 12",
    image: "/assets/casino/421.webp",
    key: "PP",
    gameCode: "PP-LIVE-023",
    gameType: "LIVE",
    platFormCode: "PP",
  },
  {
    name: "Speed Baccarat 13",
    image: "/assets/casino/438.webp",
    key: "PP",
    gameCode: "PP-LIVE-024",
    gameType: "LIVE",
    platFormCode: "PP",
  },
  {
    name: "Speed Baccarat 15",
    image: "/assets/casino/427.webp",
    key: "PP",
    gameCode: "PP-LIVE-008",
    gameType: "LIVE",
    platFormCode: "PP",
  },
  {
    name: "Thai Baccarat 1",
    image: "/assets/casino/thai-baccarat-1.webp",
    key: "PP",
  },
  {
    name: "Turbo Baccarat",
    image: "/assets/casino/426.webp",
    key: "PP",
  },
  {
    name: "ONE Blackjack 2",
    image: "/assets/casino/902.webp",
    key: "PP",
  },
  {
    name: "Lightning Storm",
    image: "/assets/casino/lightning-storm.webp",
    key: "EVOLUTION",
  },
  {
    name: "Salon Privé Blackjack N",
    image: "/assets/casino/salon-prive-blackjack-n.webp",
    key: "EVOLUTION",
  },
  {
    name: "Salon Privé Blackjack M",
    image: "/assets/casino/salon-prive-blackjack-m.webp",
    key: "EVOLUTION",
  },
  {
    name: "Salon Privé Blackjack L",
    image: "/assets/casino/salon-prive-blackjack-l.webp",
    key: "EVOLUTION",
  },
  {
    name: "Salon Privé Blackjack K",
    image: "/assets/casino/salon-prive-blackjack-k.webp",
    key: "EVOLUTION",
  },
  {
    name: "Hindi Speed Baccarat B",
    image: "/assets/casino/hindi-speed-baccarat-b.webp",
    key: "EVOLUTION",
  },
  {
    name: "Korean Speed Blackjack C",
    image: "/assets/casino/korean-speed-blackjack-c.webp",
    key: "EVOLUTION",
  },
  {
    name: "Korean Speed Blackjack B",
    image: "/assets/casino/korean-speed-blackjack-b.webp",
    key: "EVOLUTION",
  },
  {
    name: "Korean Speed Blackjack A",
    image: "/assets/casino/korean-speed-blackjack-a.webp",
    key: "EVOLUTION",
  },
  {
    name: "Evo Speed Blackjack 2",
    image: "/assets/casino/evo-speed-blackjack-2.webp",
    key: "EVOLUTION",
  },
  {
    name: "Evo Speed Blackjack 3",
    image: "/assets/casino/evo-speed-blackjack-3.webp",
    key: "EVOLUTION",
  },
  {
    name: "Evo Speed Blackjack 4",
    image: "/assets/casino/evo-speed-blackjack-4.webp",
    key: "EVOLUTION",
  },
  {
    name: "Evo Speed Blackjack 6",
    image: "/assets/casino/evo-speed-blackjack-6.webp",
    key: "EVOLUTION",
  },
  {
    name: "Evo Speed Blackjack 7",
    image: "/assets/casino/evo-speed-blackjack-7.webp",
    key: "EVOLUTION",
  },
  {
    name: "Evo Speed Blackjack 10",
    image: "/assets/casino/evo-speed-blackjack-10.webp",
    key: "EVOLUTION",
  },
  {
    name: "Evo Speed Blackjack 11",
    image: "/assets/casino/evo-speed-blackjack-11.webp",
    key: "EVOLUTION",
  },
  {
    name: "Evo Speed Blackjack 1",
    image: "/assets/casino/evo-speed-blackjack-1.webp",
    key: "EVOLUTION",
  },
  {
    name: "Blackjack VIP 49",
    image: "/assets/casino/blackjack-vip-49.webp",
    key: "EVOLUTION",
  },
  {
    name: "Blackjack VIP 44",
    image: "/assets/casino/blackjack-vip-44.webp",
    key: "EVOLUTION",
  },
  {
    name: "Blackjack VIP 34",
    image: "/assets/casino/blackjack-vip-34.webp",
    key: "EVOLUTION",
  },
  {
    name: "Blackjack VIP 35",
    image: "/assets/casino/blackjack-vip-35.webp",
    key: "EVOLUTION",
  },
  {
    name: "Blackjack VIP 39",
    image: "/assets/casino/blackjack-vip-39.webp",
    key: "EVOLUTION",
  },
  {
    name: "Blackjack VIP 38",
    image: "/assets/casino/blackjack-vip-38.webp",
    key: "EVOLUTION",
  },
  {
    name: "Blackjack VIP 36",
    image: "/assets/casino/blackjack-vip-36.webp",
    key: "EVOLUTION",
  },
  {
    name: "Blackjack VIP 37",
    image: "/assets/casino/blackjack-vip-37.webp",
    key: "EVOLUTION",
  },
  {
    name: "Blackjack VIP 41",
    image: "/assets/casino/blackjack-vip-41.webp",
    key: "EVOLUTION",
  },
  {
    name: "Salon Privé Baccarat M",
    image: "/assets/casino/salon-prive-baccarat-m.webp",
    key: "EVOLUTION",
  },
  {
    name: "Balloon Race",
    image: "/assets/casino/balloon-race.webp",
    key: "EVOLUTION",
  },
  {
    name: "Speed VIP Blackjack R",
    image: "/assets/casino/speed-vip-blackjack-r.webp",
    key: "EVOLUTION",
  },
  {
    name: "Speed VIP Blackjack Q",
    image: "/assets/casino/speed-vip-blackjack-q.webp",
    key: "EVOLUTION",
  },
  {
    name: "Speed VIP Blackjack N",
    image: "/assets/casino/speed-vip-blackjack-n.webp",
    key: "EVOLUTION",
  },
  {
    name: "Blackjack VIP 32",
    image: "/assets/casino/blackjack-vip-32.webp",
    key: "EVOLUTION",
  },
  {
    name: "Blackjack VIP 31",
    image: "/assets/casino/blackjack-vip-31.webp",
    key: "EVOLUTION",
  },
  {
    name: "Blackjack VIP 28",
    image: "/assets/casino/blackjack-vip-28.webp",
    key: "EVOLUTION",
  },
  {
    name: "Bonsai Speed Baccarat C",
    image: "/assets/casino/bonsai-speed-baccarat-c.webp",
    key: "EVOLUTION",
  },
  {
    name: "Bonsai Speed Baccarat B",
    image: "/assets/casino/bonsai-speed-baccarat-b.webp",
    key: "EVOLUTION",
  },
  {
    name: "Bonsai Speed Baccarat A",
    image: "/assets/casino/bonsai-speed-baccarat-a.webp",
    key: "EVOLUTION",
  },
  {
    name: "Salon Privé Blackjack J",
    image: "/assets/casino/salon-prive-blackjack-j.webp",
    key: "EVOLUTION",
  },
  {
    name: "Evo Speed Blackjack 5",
    image: "/assets/casino/evo-speed-blackjack-5.webp",
    key: "EVOLUTION",
  },
  {
    name: "Blackjack VIP 33",
    image: "/assets/casino/blackjack-vip-33.webp",
    key: "EVOLUTION",
  },
  {
    name: "Salon Privé Baccarat N",
    image: "/assets/casino/salon-prive-baccarat-n.webp",
    key: "EVOLUTION",
  },
  {
    name: "Blackjack VIP 30",
    image: "/assets/casino/blackjack-vip-30.webp",
    key: "EVOLUTION",
  },
  {
    name: "Lightning Sic Bo",
    image: "/assets/casino/lightning-sic-bo.webp",
    key: "EVOLUTION",
  },
  {
    name: "Lightning Dragon Tiger",
    image: "/assets/casino/lightning-dragon-tiger.webp",
    key: "EVOLUTION",
  },
  {
    name: "Stock Market",
    image: "/assets/casino/stock-market.webp",
    key: "EVOLUTION",
  },
  {
    name: "Japanese Speed Blackjack A",
    image: "/assets/casino/japanese-speed-blackjack-a.webp",
    key: "EVOLUTION",
  },
  {
    name: "Japanese Speed Baccarat A",
    image: "/assets/casino/japanese-speed-baccarat-a.webp",
    key: "EVOLUTION",
  },
  {
    name: "Crazy Pachinko",
    image: "/assets/casino/crazy-pachinko.webp",
    key: "EVOLUTION",
  },
  {
    name: "Red Door Roulette",
    image: "/assets/casino/red-door-roulette.webp",
    key: "EVOLUTION",
  },
  {
    name: "XXXtreme Lightning Baccarat",
    image: "/assets/casino/xxxtreme-lightning-baccarat.webp",
    key: "EVOLUTION",
  },
  {
    name: "Prosperity Tree Baccarat",
    image: "/assets/casino/prosperity-tree-baccarat.webp",
    key: "EVOLUTION",
  },
  {
    name: "Gold Vault Roulette",
    image: "/assets/casino/gold-vault-roulette.webp",
    key: "EVOLUTION",
  },
  {
    name: "Emperor Sic Bo A",
    image: "/assets/casino/emperor-sic-bo-a.webp",
    key: "EVOLUTION",
  },
  {
    name: "Grand Korean Blackjack",
    image: "/assets/casino/grand-korean-blackjack.webp",
    key: "EVOLUTION",
  },
  {
    name: "Salon Privé Baccarat J",
    image: "/assets/casino/salon-prive-baccarat-j.webp",
    key: "EVOLUTION",
  },
  {
    name: "Korean Speed Baccarat E",
    image: "/assets/casino/korean-speed-baccarat-e.webp",
    key: "EVOLUTION",
  },
  {
    name: "Korean Speed Baccarat D",
    image: "/assets/casino/korean-speed-baccarat-d.webp",
    key: "EVOLUTION",
  },
  {
    name: "Emperor Speed Baccarat D",
    image: "/assets/casino/emperor-speed-baccarat-d.webp",
    key: "EVOLUTION",
  },
  {
    name: "Extra Chilli Epic Spins",
    image: "/assets/casino/extra-chilli-epic-spins.webp",
    key: "EVOLUTION",
  },
  {
    name: "Speed Baccarat Z",
    image: "/assets/casino/speed-baccarat-z.webp",
    key: "EVOLUTION",
  },
  {
    name: "Crazy Time A",
    image: "/assets/casino/crazy-time-a.webp",
    key: "EVOLUTION",
  },
  {
    name: "Football Studio Dice",
    image: "/assets/casino/football-studio-dice.webp",
    key: "EVOLUTION",
  },
  {
    name: "Salon Privé Blackjack I",
    image: "/assets/casino/salon-prive-blackjack-i.webp",
    key: "EVOLUTION",
  },
  {
    name: "Salon Privé Blackjack H",
    image: "/assets/casino/salon-prive-blackjack-h.webp",
    key: "EVOLUTION",
  },
  {
    name: "Salon Privé Baccarat I",
    image: "/assets/casino/salon-prive-baccarat-i.webp",
    key: "EVOLUTION",
  },
  {
    name: "Salon Privé Baccarat H",
    image: "/assets/casino/salon-prive-baccarat-h.webp",
    key: "EVOLUTION",
  },
  {
    name: "Dead or Alive Saloon",
    image: "/assets/casino/dead-or-alive-saloon.webp",
    key: "EVOLUTION",
  },
  {
    name: "Dice Lobby",
    image: "/assets/casino/dice-lobby.webp",
    key: "EVOLUTION",
  },
  {
    name: "Korean Dealer Lobby",
    image: "/assets/casino/korean-dealer-lobby.webp",
    key: "EVOLUTION",
  },
  {
    name: "Hindi Lobby",
    image: "/assets/casino/hindi-lobby.webp",
    key: "EVOLUTION",
  },
  {
    name: "Speed VIP Blackjack M",
    image: "/assets/casino/speed-vip-blackjack-m.webp",
    key: "EVOLUTION",
  },
  {
    name: "Speed VIP Blackjack L",
    image: "/assets/casino/speed-vip-blackjack-l.webp",
    key: "EVOLUTION",
  },
  {
    name: "Speed VIP Blackjack K",
    image: "/assets/casino/speed-vip-blackjack-k.webp",
    key: "EVOLUTION",
  },
  {
    name: "Speed VIP Blackjack J",
    image: "/assets/casino/speed-vip-blackjack-j.webp",
    key: "EVOLUTION",
  },
  {
    name: "Speed VIP Blackjack I",
    image: "/assets/casino/speed-vip-blackjack-i.webp",
    key: "EVOLUTION",
  },
  {
    name: "Speed Baccarat W",
    image: "/assets/casino/speed-baccarat-w.webp",
    key: "EVOLUTION",
  },
  {
    name: "Speed Baccarat V",
    image: "/assets/casino/speed-baccarat-v.webp",
    key: "EVOLUTION",
  },
  {
    name: "Speed Baccarat U",
    image: "/assets/casino/speed-baccarat-u.webp",
    key: "EVOLUTION",
  },
  {
    name: "Speed Baccarat T",
    image: "/assets/casino/speed-baccarat-t.webp",
    key: "EVOLUTION",
  },
  {
    name: "Salon Privé Blackjack G",
    image: "/assets/casino/salon-prive-blackjack-g.webp",
    key: "EVOLUTION",
  },
  {
    name: "Korean Speed Baccarat C",
    image: "/assets/casino/korean-speed-baccarat-c.webp",
    key: "EVOLUTION",
  },
  {
    name: "Korean Speed Baccarat B",
    image: "/assets/casino/korean-speed-baccarat-b.webp",
    key: "EVOLUTION",
  },
  {
    name: "Hindi Speed Baccarat",
    image: "/assets/casino/hindi-speed-baccarat.webp",
    key: "EVOLUTION",
  },
  {
    name: "Hindi Lightning Roulette",
    image: "/assets/casino/hindi-lightning-roulette.webp",
    key: "EVOLUTION",
  },
  {
    name: "Casino Malta Roulette",
    image: "/assets/casino/casino-malta-roulette.webp",
    key: "EVOLUTION",
  },
  {
    name: "Blackjack VIP 27",
    image: "/assets/casino/blackjack-vip-27.webp",
    key: "EVOLUTION",
  },
  {
    name: "Blackjack VIP 26",
    image: "/assets/casino/blackjack-vip-26.webp",
    key: "EVOLUTION",
  },
  {
    name: "Blackjack VIP 25",
    image: "/assets/casino/blackjack-vip-25.webp",
    key: "EVOLUTION",
  },
  {
    name: "Monopoly Big Baller",
    image: "/assets/casino/monopoly-big-baller.webp",
    key: "EVOLUTION",
  },
  {
    name: "Poker Lobby",
    image: "/assets/casino/poker-lobby.webp",
    key: "EVOLUTION",
  },
  {
    name: "Blackjack Lobby",
    image: "/assets/casino/evo-blackjack-lobby.webp",
    key: "EVOLUTION",
  },
  {
    name: "Roulette Lobby",
    image: "/assets/casino/evo-roulette-lobby.webp",
    key: "EVOLUTION",
  },
  {
    name: "Teen Patti",
    image: "/assets/casino/teen-patti.webp",
    key: "EVOLUTION",
  },
  {
    name: "Crazy Coin Flip",
    image: "/assets/casino/crazy-coin-flip.webp",
    key: "EVOLUTION",
  },
  {
    name: "XXXtreme Lightning Roulette",
    image: "/assets/casino/xxxtreme-lightning-roulette.webp",
    key: "EVOLUTION",
  },
  {
    name: "Super Andar Bahar",
    image: "/assets/casino/super-andar-bahar.webp",
    key: "EVOLUTION",
  },
  {
    name: "Emperor Sic Bo",
    image: "/assets/casino/emperor-sic-bo.webp",
    key: "EVOLUTION",
  },
  {
    name: "Korean Speaking Speed Baccarat 2",
    image: "/assets/casino/korean-speaking-speed-baccarat-2.webp",
    key: "EVOLUTION",
  },
  {
    name: "Blackjack VIP 22",
    image: "/assets/casino/blackjack-vip-22.webp",
    key: "EVOLUTION",
  },
  {
    name: "Speed VIP Blackjack H",
    image: "/assets/casino/speed-vip-blackjack-h.webp",
    key: "EVOLUTION",
  },
  {
    name: "Korean Dealer Speed Blackjack",
    image: "/assets/casino/korean-dealer-speed-blackjack.webp",
    key: "EVOLUTION",
  },
  {
    name: "Peek Baccarat",
    image: "/assets/casino/peek-baccarat.webp",
    key: "EVOLUTION",
  },
  {
    name: "Korean Speaking Speed Baccarat",
    image: "/assets/casino/korean-speaking-speed-baccarat.webp",
    key: "EVOLUTION",
  },
  {
    name: "Blackjack VIP 20",
    image: "/assets/casino/blackjack-vip-20.webp",
    key: "EVOLUTION",
  },
  {
    name: "Korean Dealer Power Blackjack",
    image: "/assets/casino/korean-dealer-power-blackjack.webp",
    key: "EVOLUTION",
  },
  {
    name: "Baccarat Lobby",
    image: "/assets/casino/evo-baccarat-lobby.webp",
    key: "EVOLUTION",
  },
  {
    name: "Emperor Speed Baccarat C",
    image: "/assets/casino/emperor-speed-baccarat-c.webp",
    key: "EVOLUTION",
  },
  {
    name: "Hindi Roulette",
    image: "/assets/casino/hindi-roulette.webp",
    key: "EVOLUTION",
  },
  {
    name: "Emperor Roulette",
    image: "/assets/casino/emperor-roulette.webp",
    key: "EVOLUTION",
  },
  {
    name: "Emperor Speed Baccarat A",
    image: "/assets/casino/emperor-speed-baccarat-a.webp",
    key: "EVOLUTION",
  },
  {
    name: "Emperor Speed Baccarat B",
    image: "/assets/casino/emperor-speed-baccarat-b.webp",
    key: "EVOLUTION",
  },
  {
    name: "Golden Wealth Baccarat",
    image: "/assets/casino/golden-wealth-baccarat.webp",
    key: "EVOLUTION",
  },
  {
    name: "Emperor Dragon Tiger",
    image: "/assets/casino/emperor-dragon-tiger.webp",
    key: "EVOLUTION",
  },
  {
    name: "Lightning Blackjack",
    image: "/assets/casino/lightning-blackjack.webp",
    key: "EVOLUTION",
  },
  {
    name: "Bac Bo",
    image: "/assets/casino/bac-bo.webp",
    key: "EVOLUTION",
  },
  {
    name: "Lightning Roulette",
    image: "/assets/casino/lightning-roulette.webp",
    key: "EVOLUTION",
  },
  {
    name: "VIP Roulette",
    image: "/assets/casino/vip-roulette.webp",
    key: "PP",
    gameCode: "PP-LIVE-036",
    gameType: "LIVE",
    platFormCode: "PP",
  },
  {
    name: "Andar Bahar",
    image: "/assets/casino/andar-bahar.webp",
    key: "PP",
    gameCode: "PP-LIVE-043",
    gameType: "LIVE",
    platFormCode: "PP",
  },
  {
    name: "Roulette 2 Extra Time",
    image: "/assets/casino/roulette-2-extra-time.webp",
    key: "PP",
    gameCode: "PP-LIVE-029",
    gameType: "LIVE",
    platFormCode: "PP",
  },
  {
    name: "ONE Blackjack 1",
    image: "/assets/casino/one-blackjack-1.webp",
    key: "PP",
  },
  {
    name: "Speed Roulette 1",
    image: "/assets/casino/speed-roulette-1.webp",
    key: "PP",
    gameCode: "PP-LIVE-027",
    gameType: "LIVE",
    platFormCode: "PP",
  },
  {
    name: "Mega Wheel",
    image: "/assets/casino/mega-wheel.webp",
    key: "PP",
    gameCode: "PP-LIVE-038",
    gameType: "LIVE",
    platFormCode: "PP",
  },
  {
    name: "Mega Sic Bo",
    image: "/assets/casino/mega-sic-bo.webp",
    key: "PP",
    gameCode: "PP-LIVE-025",
    gameType: "LIVE",
    platFormCode: "PP",
  },
  {
    name: "Speed Baccarat 1",
    image: "/assets/casino/402.webp",
    key: "PP",
    gameCode: "PP-LIVE-013",
    gameType: "LIVE",
    platFormCode: "PP",
  },
  {
    name: "Baccarat 1",
    image: "/assets/casino/baccarat-1.webp",
    key: "PP",
    gameCode: "PP-LIVE-001",
    gameType: "LIVE",
    platFormCode: "PP",
  },
  {
    name: "Gameshows",
    image: "/assets/casino/gameshows.webp",
    key: "PP",
  },
  {
    name: "Sic Bo",
    image: "",
    key: "PP",
    gameCode: "PP-LIVE-079",
    gameType: "LIVE",
    platFormCode: "PP",
  },
  {
    name: "Sweet Bonanza CandyLand",
    image: "/assets/casino/sweet-bonanza-candyland.webp",
    key: "PP",
    gameCode: "PP-LIVE-044",
    gameType: "LIVE",
    platFormCode: "PP",
  },
  {
    name: "Casino Hold'em",
    image: "/assets/casino/evo-casino-holdem.webp",
    key: "EVOLUTION",
  },
  {
    name: "2 Hand Casino Hold'em",
    image: "/assets/casino/2-hand-casino-hold-em.webp",
    key: "EVOLUTION",
  },
  {
    name: "Football Studio",
    image: "/assets/casino/football-studio.webp",
    key: "EVOLUTION",
  },
  {
    name: "Caribbean Stud Poker",
    image: "/assets/casino/caribbean-stud-poker.webp",
    key: "EVOLUTION",
  },
  {
    name: "Salon Privé Roulette",
    image: "/assets/casino/salon-prive-roulette.webp",
    key: "EVOLUTION",
  },
  {
    name: "Texas Hold'em Bonus Poker",
    image: "/assets/casino/texas-hold-em-bonus-poker.webp",
    key: "EVOLUTION",
  },
  {
    name: "Auto-Roulette VIP",
    image: "/assets/casino/auto-roulette-vip.webp",
    key: "EVOLUTION",
  },
  {
    name: "Japanese Roulette",
    image: "/assets/casino/japanese-roulette.webp",
    key: "EVOLUTION",
  },
  {
    name: "Speed Auto Roulette",
    image: "/assets/casino/evo-speed-auto-roulette.webp",
    key: "EVOLUTION",
  },
  {
    name: "Double Ball Roulette",
    image: "/assets/casino/double-ball-roulette.webp",
    key: "EVOLUTION",
  },
  {
    name: "American Roulette",
    image: "/assets/casino/evo-american-roulette.webp",
    key: "EVOLUTION",
  },
  {
    name: "VIP Roulette",
    image: "/assets/casino/evo-vip-roulette.webp",
    key: "EVOLUTION",
  },
  {
    name: "Speed Roulette",
    image: "/assets/casino/speed-roulette.webp",
    key: "EVOLUTION",
  },
  {
    name: "Auto-Roulette",
    image: "/assets/casino/auto-roulette.webp",
    key: "EVOLUTION",
  },
  {
    name: "Instant Roulette",
    image: "/assets/casino/instant-roulette.webp",
    key: "EVOLUTION",
  },
  {
    name: "Immersive Roulette",
    image: "/assets/casino/immersive-roulette.webp",
    key: "EVOLUTION",
  },
  {
    name: "Roulette",
    image: "/assets/casino/roulette.webp",
    key: "EVOLUTION",
  },
  {
    name: "Salon Privé Blackjack F",
    image: "/assets/casino/salon-prive-blackjack-f.webp",
    key: "EVOLUTION",
  },
  {
    name: "Salon Privé Blackjack E",
    image: "/assets/casino/salon-prive-blackjack-e.webp",
    key: "EVOLUTION",
  },
  {
    name: "Salon Privé Blackjack D",
    image: "/assets/casino/salon-prive-blackjack-d.webp",
    key: "EVOLUTION",
  },
  {
    name: "Salon Privé Blackjack C",
    image: "/assets/casino/salon-prive-blackjack-c.webp",
    key: "EVOLUTION",
  },
  {
    name: "Salon Privé Blackjack B",
    image: "/assets/casino/salon-prive-blackjack-b.webp",
    key: "EVOLUTION",
  },
  {
    name: "Salon Privé Blackjack A",
    image: "/assets/casino/salon-prive-blackjack-a.webp",
    key: "EVOLUTION",
  },
  {
    name: "Blackjack Diamond VIP",
    image: "/assets/casino/blackjack-diamond-vip.webp",
    key: "EVOLUTION",
  },
  {
    name: "Blackjack Grand VIP",
    image: "/assets/casino/blackjack-grand-vip.webp",
    key: "EVOLUTION",
  },
  {
    name: "Blackjack Fortune VIP",
    image: "/assets/casino/blackjack-fortune-vip.webp",
    key: "EVOLUTION",
  },
  {
    name: "Blackjack Platinum VIP",
    image: "/assets/casino/blackjack-platinum-vip.webp",
    key: "EVOLUTION",
  },
  {
    name: "Blackjack VIP Gamma",
    image: "/assets/casino/blackjack-vip-gamma.webp",
    key: "EVOLUTION",
  },
  {
    name: "Blackjack VIP Beta",
    image: "/assets/casino/blackjack-vip-beta.webp",
    key: "EVOLUTION",
  },
  {
    name: "Blackjack VIP Z",
    image: "/assets/casino/blackjack-vip-z.webp",
    key: "EVOLUTION",
  },
  {
    name: "Blackjack VIP X",
    image: "/assets/casino/blackjack-vip-x.webp",
    key: "EVOLUTION",
  },
  {
    name: "Blackjack VIP V",
    image: "/assets/casino/blackjack-vip-v.webp",
    key: "EVOLUTION",
  },
  {
    name: "Blackjack VIP U",
    image: "/assets/casino/blackjack-vip-u.webp",
    key: "EVOLUTION",
  },
  {
    name: "Blackjack VIP T",
    image: "/assets/casino/blackjack-vip-t.webp",
    key: "EVOLUTION",
  },
  {
    name: "Blackjack VIP S",
    image: "/assets/casino/blackjack-vip-s.webp",
    key: "EVOLUTION",
  },
  {
    name: "Blackjack VIP R",
    image: "/assets/casino/blackjack-vip-r.webp",
    key: "EVOLUTION",
  },
  {
    name: "Blackjack VIP Q",
    image: "/assets/casino/blackjack-vip-q.webp",
    key: "EVOLUTION",
  },
  {
    name: "Blackjack VIP P",
    image: "/assets/casino/blackjack-vip-p.webp",
    key: "EVOLUTION",
  },
  {
    name: "Blackjack VIP O",
    image: "/assets/casino/blackjack-vip-o.webp",
    key: "EVOLUTION",
  },
  {
    name: "Blackjack VIP N",
    image: "/assets/casino/blackjack-vip-n.webp",
    key: "EVOLUTION",
  },
  {
    name: "Blackjack VIP M",
    image: "/assets/casino/blackjack-vip-m.webp",
    key: "EVOLUTION",
  },
  {
    name: "Blackjack VIP K",
    image: "/assets/casino/blackjack-vip-k.webp",
    key: "EVOLUTION",
  },
  {
    name: "Blackjack VIP I",
    image: "/assets/casino/blackjack-vip-i.webp",
    key: "EVOLUTION",
  },
  {
    name: "Blackjack VIP H",
    image: "/assets/casino/blackjack-vip-h.webp",
    key: "EVOLUTION",
  },
  {
    name: "Blackjack VIP G",
    image: "/assets/casino/blackjack-vip-g.webp",
    key: "EVOLUTION",
  },
  {
    name: "Blackjack VIP F",
    image: "/assets/casino/blackjack-vip-f.webp",
    key: "EVOLUTION",
  },
  {
    name: "Blackjack VIP E",
    image: "/assets/casino/blackjack-vip-e.webp",
    key: "EVOLUTION",
  },
  {
    name: "Blackjack VIP D",
    image: "/assets/casino/blackjack-vip-d.webp",
    key: "EVOLUTION",
  },
  {
    name: "Blackjack VIP C",
    image: "/assets/casino/blackjack-vip-c.webp",
    key: "EVOLUTION",
  },
  {
    name: "Blackjack VIP B",
    image: "/assets/casino/blackjack-vip-b.webp",
    key: "EVOLUTION",
  },
  {
    name: "Blackjack VIP A",
    image: "/assets/casino/blackjack-vip-a.webp",
    key: "EVOLUTION",
  },
  {
    name: "Blackjack Silver G",
    image: "/assets/casino/blackjack-silver-g.webp",
    key: "EVOLUTION",
  },
  {
    name: "Blackjack Silver F",
    image: "/assets/casino/blackjack-silver-f.webp",
    key: "EVOLUTION",
  },
  {
    name: "Blackjack Silver E",
    image: "/assets/casino/blackjack-silver-e.webp",
    key: "EVOLUTION",
  },
  {
    name: "Blackjack Silver D",
    image: "/assets/casino/blackjack-silver-d.webp",
    key: "EVOLUTION",
  },
  {
    name: "Blackjack Silver C",
    image: "/assets/casino/blackjack-silver-c.webp",
    key: "EVOLUTION",
  },
  {
    name: "Blackjack Silver B",
    image: "/assets/casino/blackjack-silver-b.webp",
    key: "EVOLUTION",
  },
  {
    name: "Blackjack Silver A",
    image: "/assets/casino/blackjack-silver-a.webp",
    key: "EVOLUTION",
  },
  {
    name: "Speed Blackjack I",
    image: "/assets/casino/speed-blackjack-i.webp",
    key: "EVOLUTION",
  },
  {
    name: "Blackjack C",
    image: "/assets/casino/blackjack-c.webp",
    key: "EVOLUTION",
  },
  {
    name: "Blackjack VIP 19",
    image: "/assets/casino/blackjack-vip-19.webp",
    key: "EVOLUTION",
  },
  {
    name: "Blackjack VIP 17",
    image: "/assets/casino/blackjack-vip-17.webp",
    key: "EVOLUTION",
  },
  {
    name: "Blackjack VIP 16",
    image: "/assets/casino/blackjack-vip-16.webp",
    key: "EVOLUTION",
  },
  {
    name: "Blackjack VIP 15",
    image: "/assets/casino/blackjack-vip-15.webp",
    key: "EVOLUTION",
  },
  {
    name: "Blackjack VIP 14",
    image: "/assets/casino/blackjack-vip-14.webp",
    key: "EVOLUTION",
  },
  {
    name: "Blackjack VIP 13",
    image: "/assets/casino/blackjack-vip-13.webp",
    key: "EVOLUTION",
  },
  {
    name: "Blackjack VIP 12",
    image: "/assets/casino/blackjack-vip-12.webp",
    key: "EVOLUTION",
  },
  {
    name: "Blackjack VIP 11",
    image: "/assets/casino/blackjack-vip-11.webp",
    key: "EVOLUTION",
  },
  {
    name: "Blackjack VIP 10",
    image: "/assets/casino/blackjack-vip-10.webp",
    key: "EVOLUTION",
  },
  {
    name: "Blackjack VIP 9",
    image: "/assets/casino/blackjack-vip-9.webp",
    key: "EVOLUTION",
  },
  {
    name: "Blackjack VIP 8",
    image: "/assets/casino/blackjack-vip-8.webp",
    key: "EVOLUTION",
  },
  {
    name: "Blackjack VIP 7",
    image: "/assets/casino/blackjack-vip-7.webp",
    key: "EVOLUTION",
  },
  {
    name: "Blackjack VIP 6",
    image: "/assets/casino/blackjack-vip-6.webp",
    key: "EVOLUTION",
  },
  {
    name: "Blackjack VIP 5",
    image: "/assets/casino/blackjack-vip-5.webp",
    key: "EVOLUTION",
  },
  {
    name: "Blackjack VIP 4",
    image: "/assets/casino/blackjack-vip-4.webp",
    key: "EVOLUTION",
  },
  {
    name: "Blackjack VIP 3",
    image: "/assets/casino/blackjack-vip-3.webp",
    key: "EVOLUTION",
  },
  {
    name: "Blackjack VIP 2",
    image: "/assets/casino/blackjack-vip-2.webp",
    key: "EVOLUTION",
  },
  {
    name: "Blackjack VIP 1",
    image: "/assets/casino/blackjack-vip-1.webp",
    key: "EVOLUTION",
  },
  {
    name: "Speed VIP Blackjack G",
    image: "/assets/casino/speed-vip-blackjack-g.webp",
    key: "EVOLUTION",
  },
  {
    name: "Speed VIP Blackjack F",
    image: "/assets/casino/speed-vip-blackjack-f.webp",
    key: "EVOLUTION",
  },
  {
    name: "Speed VIP Blackjack E",
    image: "/assets/casino/speed-vip-blackjack-e.webp",
    key: "EVOLUTION",
  },
  {
    name: "Speed VIP Blackjack D",
    image: "/assets/casino/speed-vip-blackjack-d.webp",
    key: "EVOLUTION",
  },
  {
    name: "Speed VIP Blackjack C",
    image: "/assets/casino/speed-vip-blackjack-c.webp",
    key: "EVOLUTION",
  },
  {
    name: "Speed VIP Blackjack B",
    image: "/assets/casino/speed-vip-blackjack-b.webp",
    key: "EVOLUTION",
  },
  {
    name: "Speed VIP Blackjack A",
    image: "/assets/casino/speed-vip-blackjack-a.webp",
    key: "EVOLUTION",
  },
  {
    name: "Blackjack Party",
    image: "/assets/casino/blackjack-party.webp",
    key: "EVOLUTION",
  },
  {
    name: "Infinite Blackjack",
    image: "/assets/casino/infinite-blackjack.webp",
    key: "EVOLUTION",
  },
  {
    name: "Power Blackjack",
    image: "/assets/casino/power-blackjack.webp",
    key: "EVOLUTION",
  },
  {
    name: "Free Bet Blackjack",
    image: "/assets/casino/free-bet-blackjack.webp",
    key: "EVOLUTION",
  },
  {
    name: "Blackjack B",
    image: "/assets/casino/blackjack-b.webp",
    key: "EVOLUTION",
  },
  {
    name: "Blackjack A",
    image: "/assets/casino/blackjack-a.webp",
    key: "EVOLUTION",
  },
  {
    name: "Korean Speed Baccarat A",
    image: "/assets/casino/korean-speed-baccarat-a.webp",
    key: "EVOLUTION",
  },
  {
    name: "Salon Privé Baccarat E",
    image: "/assets/casino/salon-prive-baccarat-e.webp",
    key: "EVOLUTION",
  },
  {
    name: "Salon Privé Baccarat D",
    image: "/assets/casino/salon-prive-baccarat-d.webp",
    key: "EVOLUTION",
  },
  {
    name: "Salon Privé Baccarat C",
    image: "/assets/casino/salon-prive-baccarat-c.webp",
    key: "EVOLUTION",
  },
  {
    name: "Salon Privé Baccarat B",
    image: "/assets/casino/salon-prive-baccarat-b.webp",
    key: "EVOLUTION",
  },
  {
    name: "Salon Privé Baccarat A",
    image: "/assets/casino/salon-prive-baccarat-a.webp",
    key: "EVOLUTION",
  },
  {
    name: "Baccarat Control Squeeze",
    image: "/assets/casino/baccarat-control-squeeze.webp",
    key: "EVOLUTION",
  },
  {
    name: "Baccarat Squeeze",
    image: "/assets/casino/baccarat-squeeze.webp",
    key: "EVOLUTION",
  },
  {
    name: "Baccarat B",
    image: "/assets/casino/baccarat-b.webp",
    key: "EVOLUTION",
  },
  {
    name: "Baccarat A",
    image: "/assets/casino/baccarat-a.webp",
    key: "EVOLUTION",
  },
  {
    name: "No Commission Baccarat",
    image: "/assets/casino/no-commission-baccarat.webp",
    key: "EVOLUTION",
  },
  {
    name: "Speed Baccarat S",
    image: "/assets/casino/speed-baccarat-s.webp",
    key: "EVOLUTION",
  },
  {
    name: "Speed Baccarat R",
    image: "/assets/casino/speed-baccarat-r.webp",
    key: "EVOLUTION",
  },
  {
    name: "Speed Baccarat Q",
    image: "/assets/casino/speed-baccarat-q.webp",
    key: "EVOLUTION",
  },
  {
    name: "Speed Baccarat N",
    image: "/assets/casino/speed-baccarat-n.webp",
    key: "EVOLUTION",
  },
  {
    name: "Speed Baccarat L",
    image: "/assets/casino/speed-baccarat-l.webp",
    key: "EVOLUTION",
  },
  {
    name: "Speed Baccarat J",
    image: "/assets/casino/speed-baccarat-j.webp",
    key: "EVOLUTION",
  },
  {
    name: "Speed Baccarat I",
    image: "/assets/casino/speed-baccarat-i.webp",
    key: "EVOLUTION",
  },
  {
    name: "Speed Baccarat H",
    image: "/assets/casino/speed-baccarat-h.webp",
    key: "EVOLUTION",
  },
  {
    name: "Speed Baccarat G",
    image: "/assets/casino/speed-baccarat-g.webp",
    key: "EVOLUTION",
  },
  {
    name: "Speed Baccarat F",
    image: "/assets/casino/speed-baccarat-f.webp",
    key: "EVOLUTION",
  },
  {
    name: "Speed Baccarat E",
    image: "/assets/casino/speed-baccarat-e.webp",
    key: "EVOLUTION",
  },
  {
    name: "Speed Baccarat D",
    image: "/assets/casino/speed-baccarat-d.webp",
    key: "EVOLUTION",
  },
  {
    name: "Speed Baccarat C",
    image: "/assets/casino/speed-baccarat-c.webp",
    key: "EVOLUTION",
  },
  {
    name: "Speed Baccarat B",
    image: "/assets/casino/speed-baccarat-b.webp",
    key: "EVOLUTION",
  },
  {
    name: "Speed Baccarat A",
    image: "/assets/casino/speed-baccarat-a.webp",
    key: "EVOLUTION",
  },
  {
    name: "Fan Tan",
    image: "/assets/casino/fan-tan.webp",
    key: "EVOLUTION",
  },
  {
    name: "Dragon Tiger",
    image: "/assets/casino/evo-dragon-tiger.webp",
    key: "EVOLUTION",
  },
  {
    name: "Super Sic Bo",
    image: "/assets/casino/super-sic-bo.webp",
    key: "EVOLUTION",
  },
];
// export const Crash = [
//   {
//     name: "Aviator Studio",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/66072164042d5_1.png",
//     key: "AVIATOR",
//   },
//   {
//     name: "Red Baron",
//     image: "https://luckmedia.link/evo_red_baron/thumb.webp",
//     key: "EVOLUTION",
//   },
//   {
//     name: "Crash Cricket Legend",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/69cb5270abb2c.jpg",
//     key: "JILI",
//   },
//   {
//     name: "Crash Trader",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/69c35f80da7a0.jpg",
//     key: "JILI",
//   },
//   {
//     name: "Cash Stack",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/6970877ab402d.jpg",
//     key: "JILI",
//   },
//   {
//     name: "Crash Fruit",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/6a040165a3bcb.jpg",
//     key: "JILI",
//   },
//   {
//     name: "Mines football",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/6a173c6ab2917.jpg",
//     key: "JILI",
//   },
//   {
//     name: "Cash Balloon",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/6a3b735d3a602.png",
//     key: "JILI",
//   },
//   {
//     name: "Crash Puck",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/68c0fe5f4151a.png",
//     key: "JILI",
//   },
//   {
//     name: "Crash Touchdown",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/67be95afc57ab.png",
//     key: "JILI",
//   },
//   {
//     name: "Crash Cricket",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/6683b84cb19ed.png",
//     key: "JILI",
//   },
//   {
//     name: "Crash Goal",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/66696c32b08c2.png",
//     key: "JILI",
//   },
//   {
//     name: "Mines",
//     image: "https://luckmedia.link/jil_mines/thumb.webp",
//     key: "JILI",
//   },
//   {
//     name: "Crash Bonus",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/653117c69a82d.png",
//     key: "JILI",
//   },
//   {
//     name: "Wheel",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/64770936e5b0c.png",
//     key: "JILI",
//   },
//   {
//     name: "Limbo",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/6477088193020.png",
//     key: "JILI",
//   },
//   {
//     name: "Go Rush",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/646c363d76997.png",
//     key: "JILI",
//   },
//   {
//     name: "Win Drop",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/63f1d3a489eb8.png",
//     key: "JILI",
//   },
//   {
//     name: "Chicken+",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/699c7b3884970.jpg",
//     key: "PP",
//   },
//   {
//     name: "High Flyer",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/2201.png",
//     key: "PP",
//   },
//   {
//     name: "Big Bass Crash",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/1320.png",
//     key: "PP",
//   },
//   {
//     name: "Limbo+",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/ar1limboplus.png",
//     key: "PP",
//   },
//   {
//     name: "Plinko+",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/ar10plinko.png",
//     key: "PP",
//   },
//   {
//     name: "Mines+",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/200x200/ar1minehnt.png",
//     key: "PP",
//   },
//   {
//     name: "Spaceman",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PP2/325x234/1301.png",
//     key: "PP",
//   },
//   {
//     name: "Aviator",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/spribe/500x500/aviator.png",
//     key: "SPRIBE",
//   },
//   {
//     name: "Interstellar Run",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/668d008f3272c.jpg",
//     key: "KM",
//   },
//   {
//     name: "Elite Aviator Club",
//     image: "https://jiliwin.9terawolf.com/cms/h8/image/668d003236c79.jpg",
//     key: "KM",
//   },
//   {
//     name: "Cash Rocket",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icons/en/km/KM-TABLE-041_0.jpg",
//     key: "KM",
//   },

//   {
//     name: "Chicky Run",
//     image:
//       "https://jiliwin.9terawolf.com/images/jaya9/game_icon/PG/default/PGS_1738001.png",
//     key: "PG",
//   },

//   {
//     name: "JetX",
//     image: "https://luckmedia.link/sms_jetx/thumb.webp",
//     key: "SMARTSOFT",
//   },
//   {
//     name: "PlinkoX",
//     image: "https://luckmedia.link/sms_plinkox/thumb.webp",
//     key: "SMARTSOFT",
//   },
//   {
//     name: "Balloon",
//     image: "https://luckmedia.link/sms_baloon/thumb.webp",
//     key: "SMARTSOFT",
//   },
//   {
//     name: "CricketX",
//     image: "https://luckmedia.link/sms_cricketx/thumb.webp",
//     key: "SMARTSOFT",
//   },
//   {
//     name: "JetX3",
//     image: "https://luckmedia.link/sms_jetx3/thumb.webp",
//     key: "SMARTSOFT",
//   },
//   {
//     name: "CarX",
//     image: "https://luckmedia.link/sms_carx/thumb.webp",
//     key: "SMARTSOFT",
//   },
//   {
//     name: "Gates of Merlyn",
//     image: "https://luckmedia.link/sms_gates_of_merlyn/thumb.webp",
//     key: "SMARTSOFT",
//   },
//   {
//     name: "Chicken Ways",
//     image: "https://luckmedia.link/sms_chicken_ways/thumb.webp",
//     key: "SMARTSOFT",
//   },
//   {
//     name: "Cheesy Road Classic",
//     image: "https://luckmedia.link/sms_cheesy_road_classic/thumb.webp",
//     key: "SMARTSOFT",
//   },
//   {
//     name: "Bottle Mania",
//     image: "https://luckmedia.link/sms_bottle_mania/thumb.webp",
//     key: "SMARTSOFT",
//   },
//   {
//     name: "Cheesy Road",
//     image: "https://luckmedia.link/sms_cheesy_road/thumb.webp",
//     key: "SMARTSOFT",
//   },
//   {
//     name: "Chicken Highway",
//     image: "https://luckmedia.link/sms_chicken_highway/thumb.webp",
//     key: "SMARTSOFT",
//   },
//   {
//     name: "Gems Crown Charging Wilds",
//     image: "https://luckmedia.link/sms_gems_crown_charging_wilds/thumb.webp",
//     key: "SMARTSOFT",
//   },
//   {
//     name: "Multi Fruits Charging Wilds",
//     image: "https://luckmedia.link/sms_multi_fruits_charging_wilds/thumb.webp",
//     key: "SMARTSOFT",
//   },
//   {
//     name: "Power of Tiger",
//     image: "https://luckmedia.link/sms_power_of_tiger/thumb.webp",
//     key: "SMARTSOFT",
//   },
//   {
//     name: "Fortune Catch",
//     image: "https://luckmedia.link/sms_fortune_catch/thumb.webp",
//     key: "SMARTSOFT",
//   },
//   {
//     name: "Multi Hot 40",
//     image: "https://luckmedia.link/sms_multi_hot_40/thumb.webp",
//     key: "SMARTSOFT",
//   },
//   {
//     name: "Multi Hot 100",
//     image: "https://luckmedia.link/sms_multi_hot_100/thumb.webp",
//     key: "SMARTSOFT",
//   },
//   {
//     name: "Propel X",
//     image: "https://luckmedia.link/sms_propel_x/thumb.webp",
//     key: "SMARTSOFT",
//   },
//   {
//     name: "Multi Hot 20",
//     image: "https://luckmedia.link/sms_multi_hot_20/thumb.webp",
//     key: "SMARTSOFT",
//   },
//   {
//     name: "Multi Hot 10",
//     image: "https://luckmedia.link/sms_multi_hot_10/thumb.webp",
//     key: "SMARTSOFT",
//   },
//   {
//     name: "Plinko X Classic",
//     image: "https://luckmedia.link/sms_plinko_x_classic/thumb.webp",
//     key: "SMARTSOFT",
//   },
//   {
//     name: "Cricketer X",
//     image: "https://luckmedia.link/sms_cricketer_x/thumb.webp",
//     key: "SMARTSOFT",
//   },
//   {
//     name: "Multi Hot 5",
//     image: "https://luckmedia.link/sms_multi_hot_5/thumb.webp",
//     key: "SMARTSOFT",
//   },
//   {
//     name: "Smash X",
//     image: "https://luckmedia.link/sms_smash_x/thumb.webp",
//     key: "SMARTSOFT",
//   },
//   {
//     name: "Roll X",
//     image: "https://luckmedia.link/sms_roll_x/thumb.webp",
//     key: "SMARTSOFT",
//   },
//   {
//     name: "Crash Duel X",
//     image: "https://luckmedia.link/sms_crash_duel_x/thumb.webp",
//     key: "SMARTSOFT",
//   },
//   {
//     name: "Mine Island",
//     image: "https://luckmedia.link/sms_mine_island/thumb.webp",
//     key: "SMARTSOFT",
//   },
//   {
//     name: "Helicopter X",
//     image: "https://luckmedia.link/sms_helicopter_x/thumb.webp",
//     key: "SMARTSOFT",
//   },
//   {
//     name: "DoubleX",
//     image: "https://luckmedia.link/sms_slicerx/thumb.webp",
//     key: "SMARTSOFT",
//   },
//   {
//     name: "TowerX",
//     image: "https://luckmedia.link/sms_towerx/thumb.webp",
//     key: "SMARTSOFT",
//   },
//   {
//     name: "FootballX",
//     image: "https://luckmedia.link/sms_footballx/thumb.webp",
//     key: "SMARTSOFT",
//   },
// ];

export const vendorListCasino = [
  { name: "EVO", key: "EVOLUTION" },
  { name: "PP", key: "PP" },
  { name: "AE", key: "SEXY" },
];
export const vendorListSlot = [
  { name: "JILI", key: "JILI" },
  { name: "PP", key: "PP" },
  { name: "PG", key: "PG" },
  { name: "SMART", key: "SMARTSOFT" },
  { name: "SPG", key: "SPADE" },
  { name: "FC", key: "FC" },
  { name: "JDB", key: "JDB" },
  { name: "RT", key: "RT" },
];
export const vendorListTable = [
  { name: "JILI", key: "JILI" },
  { name: "SPIRBE", key: "SPIRBE" },
  { name: "PP", key: "PP" },
  { name: "KM", key: "KM" },
  { name: "RT", key: "RT" },
];
export const vendorListFishing = [
  { name: "JILI", key: "JILI" },
  { name: "SPG", key: "SPADE" },
];
export const vendorListCrash = [
  { name: "Aviator", key: "AVIATOR" },
  { name: "EVO", key: "EVOLUTION" },
  { name: "JILI", key: "JILI" },
  { name: "PP", key: "PP" },
  { name: "SPIRBE", key: "SPIRBE" },
  { name: "KM", key: "KM" },
  { name: "PG", key: "PG" },
  { name: "SMART", key: "SMARTSOFT" },
];
// slot PP - 9 | RT - 3

export const PlatforAWC = {
  JILI: [
    {
      platFormCode: "JILI",
      gameType: "FH",
      casinoType: "JILI-FISH-001",
      Name: "Royal Fishing",
    },
    {
      platFormCode: "JILI",
      gameType: "FH",
      casinoType: "JILI-FISH-002",
      Name: "Bombing Fishing",
    },
    {
      platFormCode: "JILI",
      gameType: "FH",
      casinoType: "JILI-FISH-003",
      Name: "Jackpot Fishing",
    },
    {
      platFormCode: "JILI",
      gameType: "FH",
      casinoType: "JILI-FISH-004",
      Name: "Dinosaur Tycoon",
    },
    {
      platFormCode: "JILI",
      gameType: "FH",
      casinoType: "JILI-FISH-005",
      Name: "Happy Fishing",
    },
    {
      platFormCode: "JILI",
      gameType: "FH",
      casinoType: "JILI-FISH-006",
      Name: "Dragon Fortune",
    },
    {
      platFormCode: "JILI",
      gameType: "FH",
      casinoType: "JILI-FISH-007",
      Name: "Mega Fishing",
    },
    {
      platFormCode: "JILI",
      gameType: "FH",
      casinoType: "JILI-FISH-008",
      Name: "Boom Legend",
    },
    {
      platFormCode: "JILI",
      gameType: "FH",
      casinoType: "JILI-FISH-009",
      Name: "All-star Fishing",
    },
    {
      platFormCode: "JILI",
      gameType: "FH",
      casinoType: "JILI-FISH-011",
      Name: "Dinosaur Tycoon II",
    },
    {
      platFormCode: "JILI",
      gameType: "FH",
      casinoType: "JILI-FISH-012",
      Name: "Ocean King Jackpot",
    },
    {
      platFormCode: "JILI",
      gameType: "FH",
      casinoType: "JILI-FISH-013",
      Name: "Fortune King Jackpot",
    },
    {
      platFormCode: "JILI",
      gameType: "FH",
      casinoType: "JILI-FISH-014",
      Name: "FORTUNE ZOMBIE",
    },
    {
      platFormCode: "JILI",
      gameType: "FH",
      casinoType: "JILI-FISH-015",
      Name: "Circus Jackpot",
    },
    {
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-002",
      Name: "Hot Chilli",
    },
    {
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-003",
      Name: "Chin Shi Huang",
    },
    {
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-004",
      Name: "War Of Dragons",
    },
    {
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-005",
      Name: "Fortune Tree",
    },
    {
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-006",
      Name: "Lucky Ball",
    },
    {
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-007",
      Name: "Hyper Burst",
    },
    {
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-008",
      Name: "Shanghai Beauty",
    },
    {
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-009",
      Name: "Fa Fa Fa",
    },
    {
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-010",
      Name: "God Of Martial",
    },
    {
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-012",
      Name: "Hawaii Beauty",
    },
    {
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-013",
      Name: "SevenSevenSeven",
    },
    {
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-014",
      Name: "Crazy777",
    },
    {
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-015",
      Name: "Bubble Beauty",
    },
    {
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-016",
      Name: "Bao boon chin",
    },
    {
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-017",
      Name: "Crazy FaFaFa",
    },
    {
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-018",
      Name: "XiYangYang",
    },
    {
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-019",
      Name: "FortunePig",
    },
    {
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-020",
      Name: "Candy Baby",
    },
    {
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-021",
      Name: "Diamond Party",
    },
    {
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-022",
      Name: "Fengshen",
    },
    {
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-023",
      Name: "Golden Bank",
    },
    {
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-024",
      Name: "Lucky Goldbricks",
    },
    {
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-025",
      Name: "Dragon Treasure",
    },
    {
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-026",
      Name: "Charge Buffalo",
    },
    {
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-027",
      Name: "Super Ace",
    },
    {
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-028",
      Name: "Jungle King",
    },
    {
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-029",
      Name: "Money Coming",
    },
    {
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-030",
      Name: "Golden Queen",
    },
    {
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-031",
      Name: "Boxing King",
    },
    {
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-032",
      Name: "Matka India",
    },
    {
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-033",
      Name: "Dice",
    },
    {
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-034",
      Name: "DragonTiger",
    },
    {
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-035",
      Name: "7 UP-DOWN",
    },
    {
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-036",
      Name: "Lucky Number",
    },
    {
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-037",
      Name: "Lucky Coming",
    },
    {
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-038",
      Name: "Pharaoh Treasure",
    },
    {
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-039",
      Name: "Secret Treasure",
    },
    {
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-040",
      Name: "RomaX",
    },
    {
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-041",
      Name: "Super Rich",
    },
    {
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-042",
      Name: "Golden Empire",
    },
    {
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-043",
      Name: "Fortune Gems",
    },
    {
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-044",
      Name: "Party Night",
    },
    {
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-045",
      Name: "Crazy Hunter",
    },
    {
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-046",
      Name: "Magic Lamp",
    },
    {
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-047",
      Name: "TWIN WINS",
    },
    {
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-048",
      Name: "Agent Ace",
    },
    {
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-049",
      Name: "Alibaba",
    },
    {
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-050",
      Name: "Medusa",
    },
    {
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-051",
      Name: "Mega Ace",
    },
    {
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-052",
      Name: "Thor X",
    },
    {
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-053",
      Name: "Book of Gold",
    },
    {
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-054",
      Name: "Crazy Pusher",
    },
    {
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-056",
      Name: "Happy Taxi",
    },
    {
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-057",
      Name: "Gold Rush",
    },
    {
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-058",
      Name: "Mayan Empire",
    },
    {
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-059",
      Name: "Bone Fortune",
    },
    {
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-060",
      Name: "JILI CAISHEN",
    },
    {
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-061",
      Name: "Win Drop",
    },
    {
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-062",
      Name: "Bonus Hunter",
    },
    {
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-063",
      Name: "World Cup",
    },
    {
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-070",
      Name: "Samba",
    },
    {
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-071",
      Name: "Neko Fortune",
    },
    {
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-072",
      Name: "Wild Racer",
    },
    {
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-073",
      Name: "Pirate Queen",
    },
    {
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-074",
      Name: "Golden Joker",
    },
    {
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-075",
      Name: "Wild Ace",
    },
    {
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-076",
      Name: "Fortune Gems 2",
    },
    {
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-077",
      Name: "Master Tiger",
    },
    {
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-078",
      Name: "Cricket King 18",
    },
    {
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-079",
      Name: "Sweet Land",
    },
    {
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-080",
      Name: "Golden Temple",
    },
    {
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-081",
      Name: "Elf Bingo",
    },
    {
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-082",
      Name: "Cricket Sah 75",
    },
    {
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-083",
      Name: "Aztec Priestess",
    },
    {
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-084",
      Name: "Trial of Phoenix",
    },
    {
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-085",
      Name: "Devil Fire",
    },
    {
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-086",
      Name: "Bangla Beauty",
    },
    {
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-087",
      Name: "Fortune Monkey",
    },
    {
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-088",
      Name: "Dabanggg",
    },
    {
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-089",
      Name: "Sin City",
    },
    {
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-090",
      Name: "Night City",
    },
    {
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-091",
      Name: "King Arthur",
    },
    {
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-092",
      Name: "Arena Fighter",
    },
    {
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-093",
      Name: "Charge Buffalo Ascent",
    },
    {
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-094",
      Name: "Devil Fire 2",
    },
    {
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-095",
      Name: "Witches Night",
    },
    {
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-096",
      Name: "Fortune Gems 3",
    },
    {
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-097",
      Name: "Zeus",
    },
    {
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-098",
      Name: "Potion Wizard",
    },
    {
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-099",
      Name: "Crazy Hunter 2",
    },
    {
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-100",
      Name: "Jackpot Joker",
    },
    {
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-101",
      Name: "3 Coin Treasures",
    },
    {
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-102",
      Name: "Super Ace Deluxe",
    },
    {
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-103",
      Name: "The Pig House",
    },
    {
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-104",
      Name: "Party Star",
    },
    {
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-105",
      Name: "Legacy of Egypt",
    },
    {
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-106",
      Name: "3 Pot Dragons ",
    },
    {
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-107",
      Name: "Money Coming Expand Bets",
    },
    {
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-108",
      Name: "Egypt's Glow",
    },
    {
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-109",
      Name: "3 Lucky Piggy",
    },
    {
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-110",
      Name: "Shōgun",
    },
    {
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-111",
      Name: "Fruity Wheel",
    },
    {
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-112",
      Name: "Money Pot",
    },
    {
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-113",
      Name: "Nightfall Hunting",
    },
    {
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-114",
      Name: "Treasure Quest",
    },
    {
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-115",
      Name: "Lucky Jaguar",
    },
    {
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-116",
      Name: "Golden Bank 2",
    },
    {
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-117",
      Name: "Lucky Doggy",
    },
    {
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-118",
      Name: "Super Ace Joker",
    },
    {
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-121",
      Name: "Poseidon",
    },
    {
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-122",
      Name: "Coin Infinity",
    },
    {
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-123",
      Name: "Safari Mystery",
    },
    {
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-124",
      Name: "Roma X Deluxe",
    },
    {
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-125",
      Name: "Coin Tree",
    },
    {
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-126",
      Name: "3 Coin Wild Horse",
    },
    {
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-127",
      Name: "Bikini Lady",
    },
    {
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-128",
      Name: "Crystal 777 DELUXE",
    },
    {
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-129",
      Name: "Fortune Coins",
    },
    {
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-130",
      Name: "Super Ace 2",
    },
    {
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-131",
      Name: "3 Charge Buffalo",
    },
    {
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-133",
      Name: "10 Sparkling Crown",
    },
    {
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-134",
      Name: "3 Coin Treasures 2 ",
    },
    {
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-135",
      Name: "Pirate Queen 2 ",
    },
    {
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-136",
      Name: "Circus Joker 4096",
    },
    {
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-137",
      Name: "Joker Coins",
    },
    {
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-139",
      Name: "Lion 2 Dance",
    },
    {
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-140",
      Name: "3 LUCKY LION",
    },
    {
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-141",
      Name: "Gallina Vince",
    },
    {
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-142",
      Name: "Super Ace Speed",
    },
    {
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-143",
      Name: "Golden Empire 2",
    },
    {
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-144",
      Name: "Lucky Tiger",
    },
    {
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-145",
      Name: "40 Sparkling Crown",
    },
    {
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-146",
      Name: "Money Coming 2",
    },
    {
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-147",
      Name: "Fortune Coins 2",
    },
    {
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-148",
      Name: "Clover Coins 4x4 ",
    },
    {
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-149",
      Name: "Crazy777 2",
    },
    {
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-150",
      Name: "Sweet Magic",
    },
    {
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-152",
      Name: "Rapid Gems 777 ",
    },
    {
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-153",
      Name: "Jackpot Joker FEVER",
    },
    {
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-154",
      Name: "Safari King",
    },
    {
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-155",
      Name: "ROMA X 10000",
    },
    {
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-156",
      Name: "Fortune Hook Boom",
    },
    {
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-157",
      Name: "Cash Coin",
    },
    {
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-158",
      Name: "Lucky Macaw",
    },
    {
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-159",
      Name: "3 Mummy Treasures",
    },
    {
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-161",
      Name: "Boxing King Title Match",
    },
    {
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-168",
      Name: "3 Lucky Baozhu",
    },
    {
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-001",
      Name: "Teen Patti",
    },
    {
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-002",
      Name: "AK47",
    },
    {
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-003",
      Name: "Andar Bahar",
    },
    {
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-004",
      Name: "Rummy",
    },
    {
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-005",
      Name: "Number King",
    },
    {
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-006",
      Name: "Poker King",
    },
    {
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-007",
      Name: "Big small",
    },
    {
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-008",
      Name: "iRich Bingo",
    },
    {
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-009",
      Name: "Callbreak",
    },
    {
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-010",
      Name: "TeenPatti Joker",
    },
    {
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-011",
      Name: "7up7down",
    },
    {
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-012",
      Name: "Dragon & Tiger",
    },
    {
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-013",
      Name: "Callbreak Quick",
    },
    {
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-014",
      Name: "Baccarat",
    },
    {
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-015",
      Name: "Fortune Bingo",
    },
    {
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-016",
      Name: "TeenPatti 20-20",
    },
    {
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-017",
      Name: "Sic Bo",
    },
    {
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-018",
      Name: "Super Bingo",
    },
    {
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-019",
      Name: "Bingo Carnaval",
    },
    {
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-020",
      Name: "Lucky Bingo",
    },
    {
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-021",
      Name: "Ludo Quick",
    },
    {
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-022",
      Name: "Go Goal Bingo",
    },
    {
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-023",
      Name: "Color Game",
    },
    {
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-024",
      Name: "Jackpot Bingo",
    },
    {
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-025",
      Name: "Tongits Go",
    },
    {
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-026",
      Name: "Calaca Bingo",
    },
    {
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-027",
      Name: "Golden Land",
    },
    {
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-028",
      Name: "PAPPU",
    },
    {
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-029",
      Name: "West Hunter Bingo",
    },
    {
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-030",
      Name: "Go Rush",
    },
    {
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-031",
      Name: "Tower",
    },
    {
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-032",
      Name: "HILO",
    },
    {
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-033",
      Name: "Mines",
    },
    {
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-034",
      Name: "Bingo Adventure",
    },
    {
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-035",
      Name: "Limbo",
    },
    {
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-036",
      Name: "wheel ",
    },
    {
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-037",
      Name: "Mines Gold",
    },
    {
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-038",
      Name: "Pusoy Go",
    },
    {
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-039",
      Name: "Color Prediction",
    },
    {
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-040",
      Name: "Keno",
    },
    {
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-041",
      Name: "Plinko",
    },
    {
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-042",
      Name: "MINI FLUSH",
    },
    {
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-043",
      Name: "Candyland Bingo",
    },
    {
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-044",
      Name: "Blackjack",
    },
    {
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-045",
      Name: "Magic Lamp Bingo",
    },
    {
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-046",
      Name: "Blackjack Lucky Ladies",
    },
    {
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-047",
      Name: "Crash Bonus",
    },
    {
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-048",
      Name: "Pool Rummy",
    },
    {
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-049",
      Name: "Caribbean Stud Poker",
    },
    {
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-050",
      Name: "Video Poker",
    },
    {
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-051",
      Name: "Pearls of Bingo",
    },
    {
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-052",
      Name: "Jogo do Bicho",
    },
    {
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-053",
      Name: "European Roulette",
    },
    {
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-054",
      Name: "Speed Baccarat",
    },
    {
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-055",
      Name: "Crash Goal",
    },
    {
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-056",
      Name: "Jhandi Munda",
    },
    {
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-057",
      Name: "Fish Prawn Crab",
    },
    {
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-058",
      Name: "Crash Cricket",
    },
    {
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-059",
      Name: "Super Ace Scratch",
    },
    {
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-060",
      Name: "Cricket Roulette",
    },
    {
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-061",
      Name: "Ultimate Texas Hold'em",
    },
    {
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-062",
      Name: "Boxing Extravaganza",
    },
    {
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-063",
      Name: "Thai Hilo",
    },
    {
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-064",
      Name: "Super E-Sabong",
    },
    {
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-065",
      Name: "Keno Bonus Number",
    },
    {
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-066",
      Name: "Fortune Roulette",
    },
    {
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-067",
      Name: "Go For Champion",
    },
    {
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-068",
      Name: "Fortune Gems Scratch",
    },
    {
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-069",
      Name: "Cricket War",
    },
    {
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-070",
      Name: "Crash Touchdown",
    },
    {
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-071",
      Name: "Keno Super Chance",
    },
    {
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-072",
      Name: "Penalty Kick",
    },
    {
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-073",
      Name: "Domino Go",
    },
    {
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-074",
      Name: "Keno Extra Bet",
    },
    {
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-076",
      Name: "Mines Grand",
    },
    {
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-077",
      Name: "Golden Treasure",
    },
    {
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-078",
      Name: "Color Game Extreme",
    },
    {
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-079",
      Name: "Golden Treasure Lightning",
    },
    {
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-080",
      Name: "Mines Cricket",
    },
    {
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-081",
      Name: "Crash Puck",
    },
    {
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-082",
      Name: "Chicken Dash",
    },
    {
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-083",
      Name: "Gallina Fortunata",
    },
    {
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-084",
      Name: "Big Small Casino Royale",
    },
    {
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-085",
      Name: "Plinko of Mine",
    },
    {
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-086",
      Name: "Drop Ball",
    },
    {
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-087",
      Name: "Crash Trader",
    },
    {
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-088",
      Name: "Frog Dash",
    },
    {
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-089",
      Name: "Royal Quest",
    },
    {
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-090",
      Name: "Cash Stack",
    },
  ],
  KM: [
    {
      gameType: "SLOT",
      casinoType: "KM-SLOT-001",
      Name: "Sugar Blast",
      platFormCode: "KINGMAKER",
    },
    {
      gameType: "SLOT",
      casinoType: "KM-SLOT-002",
      Name: "Gems of Valhalla",
      platFormCode: "KINGMAKER",
    },
    {
      gameType: "SLOT",
      casinoType: "KM-SLOT-003",
      Name: "Sugar Blast Frenzy",
      platFormCode: "KINGMAKER",
    },
    {
      gameType: "SLOT",
      casinoType: "KM-SLOT-004",
      Name: "Cleopatra's Treasure",
      platFormCode: "KINGMAKER",
    },
    {
      gameType: "SLOT",
      casinoType: "KM-SLOT-005",
      Name: "Rooster Blitz",
      platFormCode: "KINGMAKER",
    },
    {
      gameType: "SLOT",
      casinoType: "KM-SLOT-006",
      Name: "Gold Mine",
      platFormCode: "KINGMAKER",
    },
    {
      gameType: "SLOT",
      casinoType: "KM-SLOT-007",
      Name: "ALMIGHTY GREEK",
      platFormCode: "KINGMAKER",
    },
    {
      gameType: "SLOT",
      casinoType: "KM-SLOT-008",
      Name: "WARRIORS TEMPLE",
      platFormCode: "KINGMAKER",
    },
    {
      gameType: "SLOT",
      casinoType: "KM-SLOT-009",
      Name: "LEPPY LOOT",
      platFormCode: "KINGMAKER",
    },
    {
      gameType: "SLOT",
      casinoType: "KM-SLOT-010",
      Name: "GOLD RUSH BONANZA",
      platFormCode: "KINGMAKER",
    },
    {
      gameType: "SLOT",
      casinoType: "KM-SLOT-011",
      Name: "PIGGY HEIST",
      platFormCode: "KINGMAKER",
    },
    {
      gameType: "SLOT",
      casinoType: "KM-SLOT-012",
      Name: "MERLIN'S SAGA",
      platFormCode: "KINGMAKER",
    },
    {
      gameType: "SLOT",
      casinoType: "KM-SLOT-013",
      Name: "LONDON MYSTERY",
      platFormCode: "KINGMAKER",
    },
    {
      gameType: "SLOT",
      casinoType: "KM-SLOT-014",
      Name: "HORUS GLORY",
      platFormCode: "KINGMAKER",
    },
    {
      gameType: "SLOT",
      casinoType: "KM-SLOT-015",
      Name: "PIRATE'S TREASURE",
      platFormCode: "KINGMAKER",
    },
    {
      gameType: "SLOT",
      casinoType: "KM-SLOT-016",
      Name: "Hippo Splash",
      platFormCode: "KINGMAKER",
    },
    {
      gameType: "SLOT",
      casinoType: "KM-SLOT-017",
      Name: "Cupid Archery",
      platFormCode: "KINGMAKER",
    },
    {
      gameType: "SLOT",
      casinoType: "KM-SLOT-018",
      Name: "ROME GLADIATOR",
      platFormCode: "KINGMAKER",
    },
    {
      gameType: "SLOT",
      casinoType: "KM-SLOT-019",
      Name: "Hunk Cai Shen",
      platFormCode: "KINGMAKER",
    },
    {
      gameType: "SLOT",
      casinoType: "KM-SLOT-020",
      Name: "Dear Senpai",
      platFormCode: "KINGMAKER",
    },
    {
      gameType: "SLOT",
      casinoType: "KM-SLOT-021",
      Name: "Salsa Fury",
      platFormCode: "KINGMAKER",
    },
    {
      gameType: "SLOT",
      casinoType: "KM-SLOT-022",
      Name: "Aztec Fortune",
      platFormCode: "KINGMAKER",
    },
    {
      gameType: "SLOT",
      casinoType: "KM-SLOT-023",
      Name: "Treasures of Olympus 1000",
      platFormCode: "KINGMAKER",
    },
    {
      gameType: "SLOT",
      casinoType: "KM-SLOT-024",
      Name: "Bunny VIP Night",
      platFormCode: "KINGMAKER",
    },
    {
      gameType: "SLOT",
      casinoType: "KM-SLOT-025",
      Name: "Cleopatra’s Fortune Ways",
      platFormCode: "KINGMAKER",
    },
    {
      gameType: "SLOT",
      casinoType: "KM-SLOT-026",
      Name: "Mahjong Dragon Ways",
      platFormCode: "KINGMAKER",
    },
    {
      gameType: "SLOT",
      casinoType: "KM-SLOT-027",
      Name: "Mahjong Beauty",
      platFormCode: "KINGMAKER",
    },
    {
      gameType: "SLOT",
      casinoType: "KM-SLOT-028",
      Name: "Lucky Cat Gala",
      platFormCode: "KINGMAKER",
    },
    {
      gameType: "TABLE",
      casinoType: "KM-TABLE-009",
      Name: "thai-hi-lo2",
      platFormCode: "KINGMAKER",
    },
    {
      gameType: "TABLE",
      casinoType: "KM-TABLE-010",
      Name: "belangkai2",
      platFormCode: "KINGMAKER",
    },
    {
      gameType: "TABLE",
      casinoType: "KM-TABLE-011",
      Name: "dragon-tiger2",
      platFormCode: "KINGMAKER",
    },
    {
      gameType: "TABLE",
      casinoType: "KM-TABLE-013",
      Name: "fish-prawn-crab2",
      platFormCode: "KINGMAKER",
    },
    {
      gameType: "TABLE",
      casinoType: "KM-TABLE-014",
      Name: "vn_fish-prawn-crab",
      platFormCode: "KINGMAKER",
    },
    {
      gameType: "TABLE",
      casinoType: "KM-TABLE-015",
      Name: "sicbo",
      platFormCode: "KINGMAKER",
    },
    {
      gameType: "TABLE",
      casinoType: "KM-TABLE-017",
      Name: "taixiu",
      platFormCode: "KINGMAKER",
    },
    {
      gameType: "TABLE",
      casinoType: "KM-TABLE-018",
      Name: "keno",
      platFormCode: "KINGMAKER",
    },
    {
      gameType: "TABLE",
      casinoType: "KM-TABLE-019",
      Name: "thai-fpc",
      platFormCode: "KINGMAKER",
    },
    {
      gameType: "TABLE",
      casinoType: "KM-TABLE-020",
      Name: "Bài Cào",
      platFormCode: "KINGMAKER",
    },
    {
      gameType: "TABLE",
      casinoType: "KM-TABLE-021",
      Name: "Number Matka",
      platFormCode: "KINGMAKER",
    },
    {
      gameType: "TABLE",
      casinoType: "KM-TABLE-022",
      Name: "Card Matka",
      platFormCode: "KINGMAKER",
    },
    {
      gameType: "TABLE",
      casinoType: "KM-TABLE-023",
      Name: "xocdia2",
      platFormCode: "KINGMAKER",
    },
    {
      gameType: "TABLE",
      casinoType: "KM-TABLE-024",
      Name: "FanTan Classic",
      platFormCode: "KINGMAKER",
    },
    {
      gameType: "TABLE",
      casinoType: "KM-TABLE-025",
      Name: "Fruit Roulette",
      platFormCode: "KINGMAKER",
    },
    {
      gameType: "TABLE",
      casinoType: "KM-TABLE-026",
      Name: "Baccarat",
      platFormCode: "KINGMAKER",
    },
    {
      gameType: "TABLE",
      casinoType: "KM-TABLE-027",
      Name: "european roulette",
      platFormCode: "KINGMAKER",
    },
    {
      gameType: "TABLE",
      casinoType: "KM-TABLE-028",
      Name: "7 Up 7 Down",
      platFormCode: "KINGMAKER",
    },
    {
      gameType: "TABLE",
      casinoType: "KM-TABLE-029",
      Name: "bai buu",
      platFormCode: "KINGMAKER",
    },
    {
      gameType: "TABLE",
      casinoType: "KM-TABLE-030",
      Name: "jhandimunda",
      platFormCode: "KINGMAKER",
    },
    {
      gameType: "TABLE",
      casinoType: "KM-TABLE-032",
      Name: "Andar Bahar",
      platFormCode: "KINGMAKER",
    },
    {
      gameType: "TABLE",
      casinoType: "KM-TABLE-033",
      Name: "Pai Kang",
      platFormCode: "KINGMAKER",
    },
    {
      gameType: "TABLE",
      casinoType: "KM-TABLE-034",
      Name: "KM Pok Deng",
      platFormCode: "KINGMAKER",
    },
    {
      gameType: "TABLE",
      casinoType: "KM-TABLE-035",
      Name: "Bola Golek",
      platFormCode: "KINGMAKER",
    },
    {
      gameType: "TABLE",
      casinoType: "KM-TABLE-036",
      Name: "Coin Toss",
      platFormCode: "KINGMAKER",
    },
    {
      gameType: "TABLE",
      casinoType: "KM-TABLE-037",
      Name: "Cards Hi Lo",
      platFormCode: "KINGMAKER",
    },
    {
      gameType: "TABLE",
      casinoType: "KM-TABLE-038",
      Name: "Blackjack",
      platFormCode: "KINGMAKER",
    },
    {
      gameType: "TABLE",
      casinoType: "KM-TABLE-039",
      Name: "32 Cards",
      platFormCode: "KINGMAKER",
    },
    {
      gameType: "TABLE",
      casinoType: "KM-TABLE-040",
      Name: "Plinko",
      platFormCode: "KINGMAKER",
    },
    {
      gameType: "TABLE",
      casinoType: "KM-TABLE-041",
      Name: "Cash Rocket",
      platFormCode: "KINGMAKER",
    },
    {
      gameType: "TABLE",
      casinoType: "KM-TABLE-042",
      Name: "Minesweeper",
      platFormCode: "KINGMAKER",
    },
    {
      gameType: "TABLE",
      casinoType: "KM-TABLE-043",
      Name: "Bonus Dice",
      platFormCode: "KINGMAKER",
    },
    {
      gameType: "TABLE",
      casinoType: "KM-TABLE-044",
      Name: "Dota Hi-Lo",
      platFormCode: "KINGMAKER",
    },
    {
      gameType: "TABLE",
      casinoType: "KM-TABLE-045",
      Name: "Monkey King Roulette",
      platFormCode: "KINGMAKER",
    },
    {
      gameType: "TABLE",
      casinoType: "KM-TABLE-046",
      Name: "Teen Patti",
      platFormCode: "KINGMAKER",
    },
    {
      gameType: "TABLE",
      casinoType: "KM-TABLE-047",
      Name: "Heist",
      platFormCode: "KINGMAKER",
    },
    {
      gameType: "TABLE",
      casinoType: "KM-TABLE-048",
      Name: "HorseRacing",
      platFormCode: "KINGMAKER",
    },
    {
      gameType: "TABLE",
      casinoType: "KM-TABLE-049",
      Name: "5 Card Poker",
      platFormCode: "KINGMAKER",
    },
    {
      gameType: "TABLE",
      casinoType: "KM-TABLE-050",
      Name: "Colour Game",
      platFormCode: "KINGMAKER",
    },
    {
      gameType: "TABLE",
      casinoType: "KM-TABLE-051",
      Name: "KM Power Ball",
      platFormCode: "KINGMAKER",
    },
    {
      gameType: "TABLE",
      casinoType: "KM-TABLE-052",
      Name: "BolaTangkas",
      platFormCode: "KINGMAKER",
    },
    {
      gameType: "TABLE",
      casinoType: "KM-TABLE-053",
      Name: "Marble Knockout",
      platFormCode: "KINGMAKER",
    },
    {
      gameType: "TABLE",
      casinoType: "KM-TABLE-055",
      Name: "KM Virtual Greyhound Racing",
      platFormCode: "KINGMAKER",
    },
    {
      gameType: "TABLE",
      casinoType: "KM-TABLE-058",
      Name: "KM Virtual Treadmill Racing",
      platFormCode: "KINGMAKER",
    },
    {
      gameType: "TABLE",
      casinoType: "KM-TABLE-060",
      Name: "Ludo",
      platFormCode: "KINGMAKER",
    },
    {
      gameType: "TABLE",
      casinoType: "KM-TABLE-062",
      Name: "KM Virtual Animal Race",
      platFormCode: "KINGMAKER",
    },
    {
      gameType: "TABLE",
      casinoType: "KM-TABLE-063",
      Name: "Tongits",
      platFormCode: "KINGMAKER",
    },
    {
      gameType: "TABLE",
      casinoType: "KM-TABLE-065",
      Name: "Pusoy",
      platFormCode: "KINGMAKER",
    },
    {
      gameType: "TABLE",
      casinoType: "KM-TABLE-066",
      Name: "Coin Pusher",
      platFormCode: "KINGMAKER",
    },
    {
      gameType: "TABLE",
      casinoType: "KM-TABLE-067",
      Name: "Cockfighting Arena",
      platFormCode: "KINGMAKER",
    },
    {
      gameType: "TABLE",
      casinoType: "KM-TABLE-069",
      Name: "Elite Aviator Club",
      platFormCode: "KINGMAKER",
    },
    {
      gameType: "TABLE",
      casinoType: "KM-TABLE-070",
      Name: "Interstellar Run",
      platFormCode: "KINGMAKER",
    },
    {
      gameType: "TABLE",
      casinoType: "KM-TABLE-071",
      Name: "Olympus Glory",
      platFormCode: "KINGMAKER",
    },
    {
      gameType: "TABLE",
      casinoType: "KM-TABLE-073",
      Name: "video-poker",
      platFormCode: "KINGMAKER",
    },
    {
      gameType: "TABLE",
      casinoType: "KM-TABLE-075",
      Name: "Iron Dome",
      platFormCode: "KINGMAKER",
    },
    {
      gameType: "TABLE",
      casinoType: "KM-TABLE-076",
      Name: "TOON CRASH",
      platFormCode: "KINGMAKER",
    },
    {
      gameType: "TABLE",
      casinoType: "KM-TABLE-078",
      Name: "Dice Duet",
      platFormCode: "KINGMAKER",
    },
    {
      gameType: "TABLE",
      casinoType: "KM-TABLE-079",
      Name: "LADDER GAME",
      platFormCode: "KINGMAKER",
    },
    {
      gameType: "TABLE",
      casinoType: "KM-TABLE-080",
      Name: "Jogo de Bozó",
      platFormCode: "KINGMAKER",
    },
    {
      gameType: "TABLE",
      casinoType: "KM-TABLE-081",
      Name: "Egyptian Mines",
      platFormCode: "KINGMAKER",
    },
    {
      gameType: "TABLE",
      casinoType: "KM-TABLE-082",
      Name: "Bicho",
      platFormCode: "KINGMAKER",
    },
    {
      gameType: "TABLE",
      casinoType: "KM-TABLE-083",
      Name: "BURMESE 6 ANIMALS",
      platFormCode: "KINGMAKER",
    },
    {
      gameType: "TABLE",
      casinoType: "KM-TABLE-084",
      Name: "Speedy Andar Bahar",
      platFormCode: "KINGMAKER",
    },
    {
      gameType: "TABLE",
      casinoType: "KM-TABLE-085",
      Name: "Teen Patti Blitz",
      platFormCode: "KINGMAKER",
    },
    {
      gameType: "TABLE",
      casinoType: "KM-TABLE-086",
      Name: "CHICKEN CROSSY",
      platFormCode: "KINGMAKER",
    },
    {
      gameType: "TABLE",
      casinoType: "KM-TABLE-087",
      Name: "COLOR GAME MEGA BONUS",
      platFormCode: "KINGMAKER",
    },
    {
      gameType: "TABLE",
      casinoType: "KM-TABLE-088",
      Name: "7 Up 7 Down Rush",
      platFormCode: "KINGMAKER",
    },
    {
      gameType: "TABLE",
      casinoType: "KM-TABLE-089",
      Name: "Thai Fish Prawn Crab GO!",
      platFormCode: "KINGMAKER",
    },
    {
      gameType: "TABLE",
      casinoType: "KM-TABLE-090",
      Name: "Money Wheel Deluxe",
      platFormCode: "KINGMAKER",
    },
    {
      gameType: "TABLE",
      casinoType: "KM-TABLE-092",
      Name: "Teen Patti Versus",
      platFormCode: "KINGMAKER",
    },
    {
      gameType: "TABLE",
      casinoType: "KM-TABLE-093",
      Name: "Bai Cao Mystic Four",
      platFormCode: "KINGMAKER",
    },
    {
      gameType: "TABLE",
      casinoType: "KM-TABLE-094",
      Name: "Vietnam Rock Paper Scissors",
      platFormCode: "KINGMAKER",
    },
  ],
  PP: [
    {
      gameType: "EGAME",
      casinoType: "PP-EGAME-001",
      Name: "Spaceman",
      platFormCode: "PP",
    },
    {
      gameType: "EGAME",
      casinoType: "PP-EGAME-002",
      Name: "Penalty Shootout",
      platFormCode: "PP",
    },
    {
      gameType: "EGAME",
      casinoType: "PP-EGAME-003",
      Name: "Horse Racing",
      platFormCode: "PP",
    },
    {
      gameType: "EGAME",
      casinoType: "PP-EGAME-004",
      Name: "Fantastic League",
      platFormCode: "PP",
    },
    {
      gameType: "EGAME",
      casinoType: "PP-EGAME-005",
      Name: "Greyhound Racing",
      platFormCode: "PP",
    },
    {
      gameType: "EGAME",
      casinoType: "PP-EGAME-006",
      Name: "Force 1",
      platFormCode: "PP",
    },
    {
      gameType: "EGAME",
      casinoType: "PP-EGAME-007",
      Name: "Darts",
      platFormCode: "PP",
    },
    {
      gameType: "EGAME",
      casinoType: "PP-EGAME-008",
      Name: "High Flyer ",
      platFormCode: "PP",
    },
    {
      gameType: "EGAME",
      casinoType: "PP-EGAME-009",
      Name: "Big Bass Crash",
      platFormCode: "PP",
    },
    {
      gameType: "EGAME",
      casinoType: "PP-EGAME-010",
      Name: "Steeplechase",
      platFormCode: "PP",
    },
    {
      gameType: "EGAME",
      casinoType: "PP-EGAME-011",
      Name: "Penalty Shootout Live",
      platFormCode: "PP",
    },
    {
      gameType: "EGAME",
      casinoType: "PP-EGAME-012",
      Name: "Plinko+",
      platFormCode: "PP",
    },
    {
      gameType: "EGAME",
      casinoType: "PP-EGAME-013",
      Name: "Spire+",
      platFormCode: "PP",
    },
    {
      gameType: "EGAME",
      casinoType: "PP-EGAME-014",
      Name: "Mines+",
      platFormCode: "PP",
    },
    {
      gameType: "LIVE",
      casinoType: "PP-LIVE-007",
      Name: "Baccarat 8",
      platFormCode: "PP",
    },
    {
      gameType: "LIVE",
      casinoType: "PP-LIVE-008",
      Name: "Speed Baccarat 15",
      platFormCode: "PP",
    },
    {
      gameType: "LIVE",
      casinoType: "PP-LIVE-010",
      Name: "Baccarat 3",
      platFormCode: "PP",
    },
    {
      gameType: "LIVE",
      casinoType: "PP-LIVE-022",
      Name: "Speed Baccarat 11",
      platFormCode: "PP",
    },
    {
      gameType: "LIVE",
      casinoType: "PP-LIVE-023",
      Name: "Speed Baccarat 12",
      platFormCode: "PP",
    },
    {
      gameType: "LIVE",
      casinoType: "PP-LIVE-024",
      Name: "Speed Baccarat 13",
      platFormCode: "PP",
    },
    {
      gameType: "LIVE",
      casinoType: "PP-LIVE-037",
      Name: "Roulette 3",
      platFormCode: "PP",
    },
    {
      gameType: "LIVE",
      casinoType: "PP-LIVE-077",
      Name: "Lucky 6 Roulette ",
      platFormCode: "PP",
    },
    {
      gameType: "LIVE",
      casinoType: "PP-LIVE-079",
      Name: "Sic Bo",
      platFormCode: "PP",
    },
    {
      gameType: "LIVE",
      casinoType: "PP-LIVE-001",
      Name: "Baccarat 1",
      platFormCode: "PP",
    },
    {
      gameType: "LIVE",
      casinoType: "PP-LIVE-002",
      Name: "Baccarat 2",
      platFormCode: "PP",
    },
    {
      gameType: "LIVE",
      casinoType: "PP-LIVE-003",
      Name: "Speed Baccarat 14",
      platFormCode: "PP",
    },
    {
      gameType: "LIVE",
      casinoType: "PP-LIVE-004",
      Name: "Baccarat 5",
      platFormCode: "PP",
    },
    {
      gameType: "LIVE",
      casinoType: "PP-LIVE-005",
      Name: "Baccarat 6",
      platFormCode: "PP",
    },
    {
      gameType: "LIVE",
      casinoType: "PP-LIVE-006",
      Name: "Baccarat 7",
      platFormCode: "PP",
    },
    {
      gameType: "LIVE",
      casinoType: "PP-LIVE-007",
      Name: "Baccarat 8",
      platFormCode: "PP",
    },
    {
      gameType: "LIVE",
      casinoType: "PP-LIVE-008",
      Name: "Speed Baccarat 15",
      platFormCode: "PP",
    },
    {
      gameType: "LIVE",
      casinoType: "PP-LIVE-010",
      Name: "Baccarat 3",
      platFormCode: "PP",
    },
    {
      gameType: "LIVE",
      casinoType: "PP-LIVE-013",
      Name: "Speed Baccarat 1",
      platFormCode: "PP",
    },
    {
      gameType: "LIVE",
      casinoType: "PP-LIVE-014",
      Name: "Speed Baccarat 2",
      platFormCode: "PP",
    },
    {
      gameType: "LIVE",
      casinoType: "PP-LIVE-015",
      Name: "Speed Baccarat 3",
      platFormCode: "PP",
    },
    {
      gameType: "LIVE",
      casinoType: "PP-LIVE-016",
      Name: "Speed Baccarat 5",
      platFormCode: "PP",
    },
    {
      gameType: "LIVE",
      casinoType: "PP-LIVE-017",
      Name: "Speed Baccarat 6",
      platFormCode: "PP",
    },
    {
      gameType: "LIVE",
      casinoType: "PP-LIVE-018",
      Name: "Speed Baccarat 7",
      platFormCode: "PP",
    },
    {
      gameType: "LIVE",
      casinoType: "PP-LIVE-019",
      Name: "Speed Baccarat 8",
      platFormCode: "PP",
    },
    {
      gameType: "LIVE",
      casinoType: "PP-LIVE-020",
      Name: "Speed Baccarat 9",
      platFormCode: "PP",
    },
    {
      gameType: "LIVE",
      casinoType: "PP-LIVE-021",
      Name: "Speed Baccarat 10",
      platFormCode: "PP",
    },
    {
      gameType: "LIVE",
      casinoType: "PP-LIVE-022",
      Name: "Speed Baccarat 11",
      platFormCode: "PP",
    },
    {
      gameType: "LIVE",
      casinoType: "PP-LIVE-023",
      Name: "Speed Baccarat 12",
      platFormCode: "PP",
    },
    {
      gameType: "LIVE",
      casinoType: "PP-LIVE-024",
      Name: "Speed Baccarat 13",
      platFormCode: "PP",
    },
    {
      gameType: "LIVE",
      casinoType: "PP-LIVE-025",
      Name: "Mega Sic Bo",
      platFormCode: "PP",
    },
    {
      gameType: "LIVE",
      casinoType: "PP-LIVE-026",
      Name: "Auto-Roulette ",
      platFormCode: "PP",
    },
    {
      gameType: "LIVE",
      casinoType: "PP-LIVE-027",
      Name: "Speed Roulette 1",
      platFormCode: "PP",
    },
    {
      gameType: "LIVE",
      casinoType: "PP-LIVE-028",
      Name: "Roulette 1",
      platFormCode: "PP",
    },
    {
      gameType: "LIVE",
      casinoType: "PP-LIVE-029",
      Name: "Roulette 2 Extra Time",
      platFormCode: "PP",
    },
    {
      gameType: "LIVE",
      casinoType: "PP-LIVE-030",
      Name: "Russian Roulette",
      platFormCode: "PP",
    },
    {
      gameType: "LIVE",
      casinoType: "PP-LIVE-031",
      Name: "German Roulette",
      platFormCode: "PP",
    },
    {
      gameType: "LIVE",
      casinoType: "PP-LIVE-032",
      Name: "Roulette Italia Tricolore",
      platFormCode: "PP",
    },
    {
      gameType: "LIVE",
      casinoType: "PP-LIVE-033",
      Name: "Turkish Roulette",
      platFormCode: "PP",
    },
    {
      gameType: "LIVE",
      casinoType: "PP-LIVE-034",
      Name: "Roulette Macao",
      platFormCode: "PP",
    },
    {
      gameType: "LIVE",
      casinoType: "PP-LIVE-036",
      Name: "VIP Roulette",
      platFormCode: "PP",
    },
    {
      gameType: "LIVE",
      casinoType: "PP-LIVE-037",
      Name: "Roulette 3 ",
      platFormCode: "PP",
    },
    {
      gameType: "LIVE",
      casinoType: "PP-LIVE-038",
      Name: "Mega Wheel",
      platFormCode: "PP",
    },
    {
      gameType: "LIVE",
      casinoType: "PP-LIVE-039",
      Name: "Mega Roulette",
      platFormCode: "PP",
    },
    {
      gameType: "LIVE",
      casinoType: "PP-LIVE-042",
      Name: "Dragon Tiger",
      platFormCode: "PP",
    },
    {
      gameType: "LIVE",
      casinoType: "PP-LIVE-043",
      Name: "Andar Bahar",
      platFormCode: "PP",
    },
    {
      gameType: "LIVE",
      casinoType: "PP-LIVE-044",
      Name: "Sweet Bonanza Candyland",
      platFormCode: "PP",
    },
    {
      gameType: "LIVE",
      casinoType: "PP-LIVE-045",
      Name: "Super 8 Baccarat",
      platFormCode: "PP",
    },
    {
      gameType: "LIVE",
      casinoType: "PP-LIVE-047",
      Name: "Fortune 6 Baccarat",
      platFormCode: "PP",
    },
    {
      gameType: "LIVE",
      casinoType: "PP-LIVE-048",
      Name: "Romanian Roulett",
      platFormCode: "PP",
    },
    {
      gameType: "LIVE",
      casinoType: "PP-LIVE-049",
      Name: "Dice City ",
      platFormCode: "PP",
    },
    {
      gameType: "LIVE",
      casinoType: "PP-LIVE-050",
      Name: "Speed Baccarat 16",
      platFormCode: "PP",
    },
    {
      gameType: "LIVE",
      casinoType: "PP-LIVE-051",
      Name: "Speed Baccarat 17",
      platFormCode: "PP",
    },
    {
      gameType: "LIVE",
      casinoType: "PP-LIVE-052",
      Name: "Baccarat 9",
      platFormCode: "PP",
    },
    {
      gameType: "LIVE",
      casinoType: "PP-LIVE-053",
      Name: "Roulette Latina",
      platFormCode: "PP",
    },
    {
      gameType: "LIVE",
      casinoType: "PP-LIVE-054",
      Name: "Speed Roulette 2",
      platFormCode: "PP",
    },
    {
      gameType: "LIVE",
      casinoType: "PP-LIVE-055",
      Name: "PowerUp Roulette",
      platFormCode: "PP",
    },
    {
      gameType: "LIVE",
      casinoType: "PP-LIVE-056",
      Name: "Korean Speed Baccarat 1",
      platFormCode: "PP",
    },
    {
      gameType: "LIVE",
      casinoType: "PP-LIVE-057",
      Name: "Korean Speed Baccarat 2",
      platFormCode: "PP",
    },
    {
      gameType: "LIVE",
      casinoType: "PP-LIVE-060",
      Name: "Speed Auto-Roulette 1",
      platFormCode: "PP",
    },
    {
      gameType: "LIVE",
      casinoType: "PP-LIVE-061",
      Name: "Mega Baccarat",
      platFormCode: "PP",
    },
    {
      gameType: "LIVE",
      casinoType: "PP-LIVE-062",
      Name: "Snakes & Ladders Live",
      platFormCode: "PP",
    },
    {
      gameType: "LIVE",
      casinoType: "PP-LIVE-068",
      Name: "Vietnamese Roulette",
      platFormCode: "PP",
    },
    {
      gameType: "LIVE",
      casinoType: "PP-LIVE-069",
      Name: "Thai Speed Baccarat 1",
      platFormCode: "PP",
    },
    {
      gameType: "LIVE",
      casinoType: "PP-LIVE-070",
      Name: "Korean Speed Baccarat 3",
      platFormCode: "PP",
    },
    {
      gameType: "LIVE",
      casinoType: "PP-LIVE-071",
      Name: "Korean Baccarat 1 ",
      platFormCode: "PP",
    },
    {
      gameType: "LIVE",
      casinoType: "PP-LIVE-072",
      Name: "Indonesian Speed Baccarat 1",
      platFormCode: "PP",
    },
    {
      gameType: "LIVE",
      casinoType: "PP-LIVE-073",
      Name: "Korean Roulette",
      platFormCode: "PP",
    },
    {
      gameType: "LIVE",
      casinoType: "PP-LIVE-074",
      Name: "Brazilian Roulette",
      platFormCode: "PP",
    },
    {
      gameType: "LIVE",
      casinoType: "PP-LIVE-075",
      Name: "Auto Mega Roulette",
      platFormCode: "PP",
    },
    {
      gameType: "LIVE",
      casinoType: "PP-LIVE-076",
      Name: "Vegas Ball Bonanza",
      platFormCode: "PP",
    },
    {
      gameType: "LIVE",
      casinoType: "PP-LIVE-077",
      Name: "Lucky 6 Roulette",
      platFormCode: "PP",
    },
    {
      gameType: "LIVE",
      casinoType: "PP-LIVE-078",
      Name: "Treasure Island",
      platFormCode: "PP",
    },
    {
      gameType: "LIVE",
      casinoType: "PP-LIVE-079",
      Name: "Sic Bo",
      platFormCode: "PP",
    },
    {
      gameType: "LIVE",
      casinoType: "PP-LIVE-080",
      Name: "Chinese Speed Baccarat 1",
      platFormCode: "PP",
    },
    {
      gameType: "LIVE",
      casinoType: "PP-LIVE-081",
      Name: "Turkish Mega Roulette",
      platFormCode: "PP",
    },
    {
      gameType: "LIVE",
      casinoType: "PP-LIVE-082",
      Name: "Blackjack X 1",
      platFormCode: "PP",
    },
    {
      gameType: "LIVE",
      casinoType: "PP-LIVE-083",
      Name: "Blackjack X 2",
      platFormCode: "PP",
    },
    {
      gameType: "LIVE",
      casinoType: "PP-LIVE-084",
      Name: "Blackjack X 3",
      platFormCode: "PP",
    },
    {
      gameType: "LIVE",
      casinoType: "PP-LIVE-085",
      Name: "Blackjack X 4",
      platFormCode: "PP",
    },
    {
      gameType: "LIVE",
      casinoType: "PP-LIVE-086",
      Name: "Blackjack X 5",
      platFormCode: "PP",
    },
    {
      gameType: "LIVE",
      casinoType: "PP-LIVE-087",
      Name: "Blackjack X 6",
      platFormCode: "PP",
    },
    {
      gameType: "LIVE",
      casinoType: "PP-LIVE-088",
      Name: "Blackjack X 7",
      platFormCode: "PP",
    },
    {
      gameType: "LIVE",
      casinoType: "PP-LIVE-089",
      Name: "Blackjack X 8",
      platFormCode: "PP",
    },
    {
      gameType: "LIVE",
      casinoType: "PP-LIVE-090",
      Name: "Blackjack X 9",
      platFormCode: "PP",
    },
    {
      gameType: "LIVE",
      casinoType: "PP-LIVE-091",
      Name: "Blackjack X 10",
      platFormCode: "PP",
    },
    {
      gameType: "LIVE",
      casinoType: "PP-LIVE-092",
      Name: "Blackjack X 14",
      platFormCode: "PP",
    },
    {
      gameType: "LIVE",
      casinoType: "PP-LIVE-093",
      Name: "Blackjack X 15",
      platFormCode: "PP",
    },
    {
      gameType: "LIVE",
      casinoType: "PP-LIVE-094",
      Name: "Blackjack X 16",
      platFormCode: "PP",
    },
    {
      gameType: "LIVE",
      casinoType: "PP-LIVE-095",
      Name: "Blackjack X 17",
      platFormCode: "PP",
    },
    {
      gameType: "LIVE",
      casinoType: "PP-LIVE-096",
      Name: "Blackjack X 18",
      platFormCode: "PP",
    },
    {
      gameType: "LIVE",
      casinoType: "PP-LIVE-097",
      Name: "Blackjack X 19",
      platFormCode: "PP",
    },
    {
      gameType: "LIVE",
      casinoType: "PP-LIVE-098",
      Name: "Blackjack X 20",
      platFormCode: "PP",
    },
    {
      gameType: "LIVE",
      casinoType: "PP-LIVE-099",
      Name: "Japanese Speed Baccarat 3",
      platFormCode: "PP",
    },
    {
      gameType: "LIVE",
      casinoType: "PP-LIVE-103",
      Name: "BlackjackX 30",
      platFormCode: "PP",
    },
    {
      gameType: "LIVE",
      casinoType: "PP-LIVE-104",
      Name: "BlackjackX 29",
      platFormCode: "PP",
    },
    {
      gameType: "LIVE",
      casinoType: "PP-LIVE-105",
      Name: "BlackjackX 28",
      platFormCode: "PP",
    },
    {
      gameType: "LIVE",
      casinoType: "PP-LIVE-106",
      Name: "BlackjackX 27 ",
      platFormCode: "PP",
    },
    {
      gameType: "LIVE",
      casinoType: "PP-LIVE-107",
      Name: "BlackjackX 26",
      platFormCode: "PP",
    },
    {
      gameType: "LIVE",
      casinoType: "PP-LIVE-108",
      Name: "BlackjackX 23",
      platFormCode: "PP",
    },
    {
      gameType: "LIVE",
      casinoType: "PP-LIVE-109",
      Name: "BlackjackX 22",
      platFormCode: "PP",
    },
    {
      gameType: "LIVE",
      casinoType: "PP-LIVE-110",
      Name: "BlackjackX 13",
      platFormCode: "PP",
    },
    {
      gameType: "LIVE",
      casinoType: "PP-LIVE-111",
      Name: "BlackjackX 12",
      platFormCode: "PP",
    },
    {
      gameType: "LIVE",
      casinoType: "PP-LIVE-112",
      Name: "BlackjackX 11",
      platFormCode: "PP",
    },
    {
      gameType: "LIVE",
      casinoType: "PP-LIVE-113",
      Name: "Korean Speed Baccarat 6",
      platFormCode: "PP",
    },
    {
      gameType: "LIVE",
      casinoType: "PP-LIVE-114",
      Name: "Chinese Speed Baccarat 2",
      platFormCode: "PP",
    },
    {
      gameType: "LIVE",
      casinoType: "PP-LIVE-115",
      Name: "Vietnamese Speed Baccarat 1",
      platFormCode: "PP",
    },
    {
      gameType: "LIVE",
      casinoType: "PP-LIVE-116",
      Name: "Punto Banco Italia Tricolore",
      platFormCode: "PP",
    },
    {
      gameType: "LIVE",
      casinoType: "PP-LIVE-117",
      Name: "Korean Speed Baccarat 5",
      platFormCode: "PP",
    },
    {
      gameType: "LIVE",
      casinoType: "PP-LIVE-118",
      Name: "Japanese Speed Baccarat 1",
      platFormCode: "PP",
    },
    {
      gameType: "LIVE",
      casinoType: "PP-LIVE-119",
      Name: "Japanese Speed Baccarat 2",
      platFormCode: "PP",
    },
    {
      gameType: "LIVE",
      casinoType: "PP-LIVE-120",
      Name: "BlackjackX 21",
      platFormCode: "PP",
    },
    {
      gameType: "LIVE",
      casinoType: "PP-LIVE-121",
      Name: "BlackjackX 24",
      platFormCode: "PP",
    },
    {
      gameType: "LIVE",
      casinoType: "PP-LIVE-122",
      Name: "BlackjackX 25 ",
      platFormCode: "PP",
    },
    {
      gameType: "LIVE",
      casinoType: "PP-LIVE-123",
      Name: "Football Blitz Top Card",
      platFormCode: "PP",
    },
    {
      gameType: "LIVE",
      casinoType: "PP-LIVE-139",
      Name: "Chinese Speed Baccarat 3",
      platFormCode: "PP",
    },
    {
      gameType: "LIVE",
      casinoType: "PP-LIVE-140",
      Name: "Mega Sic Bao",
      platFormCode: "PP",
    },
    {
      gameType: "LIVE",
      casinoType: "PP-LIVE-141",
      Name: "Mega Roulette - Brazilian",
      platFormCode: "PP",
    },
    {
      gameType: "LIVE",
      casinoType: "PP-LIVE-142",
      Name: "VIP Auto Roulette",
      platFormCode: "PP",
    },
    {
      gameType: "LIVE",
      casinoType: "PP-LIVE-143",
      Name: "Bet Behind Pro Blackjack ",
      platFormCode: "PP",
    },
    {
      gameType: "LIVE",
      casinoType: "PP-LIVE-145",
      Name: "Italian Mega Roulette",
      platFormCode: "PP",
    },
    {
      gameType: "LIVE",
      casinoType: "PP-LIVE-146",
      Name: "Indonesian Roulette",
      platFormCode: "PP",
    },
    {
      gameType: "LIVE",
      casinoType: "PP-LIVE-147",
      Name: "Indonesian BlackjackX1",
      platFormCode: "PP",
    },
    {
      gameType: "LIVE",
      casinoType: "PP-LIVE-148",
      Name: "Indonesian BlackjackX2",
      platFormCode: "PP",
    },
    {
      gameType: "LIVE",
      casinoType: "PP-LIVE-149",
      Name: "Indonesian BlackjackX3",
      platFormCode: "PP",
    },
    {
      gameType: "LIVE",
      casinoType: "PP-LIVE-150",
      Name: "Indonesian BlackjackX4",
      platFormCode: "PP",
    },
    {
      gameType: "LIVE",
      casinoType: "PP-LIVE-151",
      Name: "Indonesian BlackjackX5",
      platFormCode: "PP",
    },
    {
      gameType: "LIVE",
      casinoType: "PP-LIVE-152",
      Name: "BlackjackX31",
      platFormCode: "PP",
    },
    {
      gameType: "LIVE",
      casinoType: "PP-LIVE-153",
      Name: "BlackjackX32",
      platFormCode: "PP",
    },
    {
      gameType: "LIVE",
      casinoType: "PP-LIVE-154",
      Name: "BlackjackX33",
      platFormCode: "PP",
    },
    {
      gameType: "LIVE",
      casinoType: "PP-LIVE-155",
      Name: "BlackjackX34",
      platFormCode: "PP",
    },
    {
      gameType: "LIVE",
      casinoType: "PP-LIVE-156",
      Name: "BlackjackX35",
      platFormCode: "PP",
    },
    {
      gameType: "LIVE",
      casinoType: "PP-LIVE-157",
      Name: "BlackjackX36",
      platFormCode: "PP",
    },
    {
      gameType: "LIVE",
      casinoType: "PP-LIVE-158",
      Name: "BlackjackX37",
      platFormCode: "PP",
    },
    {
      gameType: "LIVE",
      casinoType: "PP-LIVE-159",
      Name: "BlackjackX38",
      platFormCode: "PP",
    },
    {
      gameType: "LIVE",
      casinoType: "PP-LIVE-160",
      Name: "BlackjackX39",
      platFormCode: "PP",
    },
    {
      gameType: "LIVE",
      casinoType: "PP-LIVE-161",
      Name: "BlackjackX40",
      platFormCode: "PP",
    },
    {
      gameType: "LIVE",
      casinoType: "PP-LIVE-162",
      Name: "Thai Speed Baccarat 2",
      platFormCode: "PP",
    },
    {
      gameType: "LIVE",
      casinoType: "PP-LIVE-163",
      Name: "Fortune Roulette",
      platFormCode: "PP",
    },
    {
      gameType: "LIVE",
      casinoType: "PP-LIVE-164",
      Name: "Indonesian BlackjackX6",
      platFormCode: "PP",
    },
    {
      gameType: "LIVE",
      casinoType: "PP-LIVE-165",
      Name: "Indonesian BlackjackX7",
      platFormCode: "PP",
    },
    {
      gameType: "LIVE",
      casinoType: "PP-LIVE-166",
      Name: "Indonesian BlackjackX8",
      platFormCode: "PP",
    },
    {
      gameType: "LIVE",
      casinoType: "PP-LIVE-167",
      Name: "Indonesian BlackjackX9",
      platFormCode: "PP",
    },
    {
      gameType: "LIVE",
      casinoType: "PP-LIVE-168",
      Name: "Indonesian BlackjackX10",
      platFormCode: "PP",
    },
    {
      gameType: "LIVE",
      casinoType: "PP-LIVE-169",
      Name: "Indonesian BlackjackX11",
      platFormCode: "PP",
    },
    {
      gameType: "LIVE",
      casinoType: "PP-LIVE-170",
      Name: "Indonesian BlackjackX12",
      platFormCode: "PP",
    },
    {
      gameType: "LIVE",
      casinoType: "PP-LIVE-171",
      Name: "Indonesian BlackjackX13",
      platFormCode: "PP",
    },
    {
      gameType: "LIVE",
      casinoType: "PP-LIVE-172",
      Name: "Indonesian BlackjackX14",
      platFormCode: "PP",
    },
    {
      gameType: "LIVE",
      casinoType: "PP-LIVE-173",
      Name: "Indonesian BlackjackX15",
      platFormCode: "PP",
    },
    {
      gameType: "LIVE",
      casinoType: "PP-LIVE-174",
      Name: "Vietnamese Speed Baccarat 2",
      platFormCode: "PP",
    },
    {
      gameType: "LIVE",
      casinoType: "PP-LIVE-175",
      Name: "Immersive Roulette Deluxe",
      platFormCode: "PP",
    },
    {
      gameType: "LIVE",
      casinoType: "PP-LIVE-176",
      Name: "American Roulette",
      platFormCode: "PP",
    },
    {
      gameType: "LIVE",
      casinoType: "PP-LIVE-177",
      Name: "Vietnamese Speed Baccarat 3",
      platFormCode: "PP",
    },
    {
      gameType: "LIVE",
      casinoType: "PP-LIVE-178",
      Name: "Thai Roulette",
      platFormCode: "PP",
    },
    {
      gameType: "LIVE",
      casinoType: "PP-LIVE-179",
      Name: "Squeeze Baccarat",
      platFormCode: "PP",
    },
    {
      gameType: "LIVE",
      casinoType: "PP-LIVE-180",
      Name: "Korean Baccarat 2",
      platFormCode: "PP",
    },
    {
      gameType: "LIVE",
      casinoType: "PP-LIVE-181",
      Name: "French Roulette",
      platFormCode: "PP",
    },
    {
      gameType: "LIVE",
      casinoType: "PP-LIVE-182",
      Name: "Casino Hold’em",
      platFormCode: "PP",
    },
    {
      gameType: "LIVE",
      casinoType: "PP-LIVE-183",
      Name: "Jacks or Better Draw Poker",
      platFormCode: "PP",
    },
    {
      gameType: "LIVE",
      casinoType: "PP-LIVE-184",
      Name: "Privé Lounge Roulette Deluxe",
      platFormCode: "PP",
    },
    {
      gameType: "LIVE",
      casinoType: "PP-LIVE-188",
      Name: "Money Time",
      platFormCode: "PP",
    },
    {
      gameType: "LIVE",
      casinoType: "PP-LIVE-189",
      Name: "Mega Roulette 3000",
      platFormCode: "PP",
    },
    {
      gameType: "LIVE",
      casinoType: "PP-LIVE-190",
      Name: "24D Spin",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-001",
      Name: "Fishin' Reels",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-002",
      Name: "Gates of Olympus",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-003",
      Name: "Hot to Burn Hold and Spin",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-004",
      Name: "Joker King",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-005",
      Name: "The Hand of Midas",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-006",
      Name: "Eye of the Storm",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-007",
      Name: "Dragon Kingdom - Eyes of Fire",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-008",
      Name: "Madame Destiny Megaways",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-009",
      Name: "Congo Cash",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-010",
      Name: "Emerald King Rainbow Road",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-011",
      Name: "Mysterious Egypt",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-012",
      Name: "Golden Ox",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-013",
      Name: "Voodoo Magic",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-014",
      Name: "Big Bass Bonanza",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-015",
      Name: "Bonanza Gold",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-016",
      Name: "John Hunter and the Mayan Gods",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-017",
      Name: "Spartan King",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-018",
      Name: "Christmas Carol Megaways",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-019",
      Name: "Cowboys Gold",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-020",
      Name: "Pirate Gold Deluxe",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-021",
      Name: "Emerald King",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-022",
      Name: "The Dragon Tiger",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-023",
      Name: "Book of Kingdoms",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-024",
      Name: "Return of the Dead",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-025",
      Name: "Gems Bonanza",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-026",
      Name: "Wild Walker",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-027",
      Name: "Rise of Samurai",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-028",
      Name: "5 Lions Dance",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-029",
      Name: "Star Bounty",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-030",
      Name: "Great Rhino Deluxe",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-031",
      Name: "Wild Wild Riches",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-032",
      Name: "Ultra Hold and Spin",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-033",
      Name: "Curse of the Werewolf Megaways",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-034",
      Name: "Jungle Gorilla",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-035",
      Name: "Aztec Gems Deluxe",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-036",
      Name: "The Dog House Megaways",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-037",
      Name: "The Tiger Warrior",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-038",
      Name: "Street Racer",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-039",
      Name: "Fu Fu Fu",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-040",
      Name: "Drago - Jewels of Fortune",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-042",
      Name: "Pyramid King",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-043",
      Name: "Ultra Burn",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-044",
      Name: "Money Money Money",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-045",
      Name: "Starz Megaways",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-046",
      Name: "Fruit Party",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-047",
      Name: "John Hunter and the Book of Tut",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-048",
      Name: "Three Star Fortune",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-049",
      Name: "Great Rhino Megaways",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-050",
      Name: "Hot to Burn",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-051",
      Name: "Dance Party",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-052",
      Name: "Wild West Gold",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-053",
      Name: "Lucky Dragon Ball",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-054",
      Name: "Fruit Rainbow",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-055",
      Name: "The Wild Machine",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-056",
      Name: "Aztec Bonanza",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-057",
      Name: "Mysterious",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-059",
      Name: "Master Joker",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-060",
      Name: "Super 7s",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-061",
      Name: "Release the Kraken",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-062",
      Name: "Buffalo King",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-063",
      Name: "Magic Journey",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-064",
      Name: "Money Mouse",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-065",
      Name: "Aladdin and the Sorcerer",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-066",
      Name: "Greek Gods",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-067",
      Name: "Sweet Bonanza Xmas",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-068",
      Name: "Hercules and Pegasus",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-069",
      Name: "Fire Strike",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-070",
      Name: "Honey Honey Honey",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-071",
      Name: "Super JOKER",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-072",
      Name: "John Hunter and the Tomb of the Scarab Queen",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-073",
      Name: "Tree of Riches",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-074",
      Name: "The Great Chicken Escape",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-075",
      Name: "Vampires VS Wolves",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-076",
      Name: "Hot Chilli",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-077",
      Name: "John Hunter and the Aztec Treasure",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-078",
      Name: "Monkey Warrior",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-080",
      Name: "5 Lions Gold",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-081",
      Name: "Wild Pixies",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-082",
      Name: "Sweet Bonanza",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-083",
      Name: "Caishen's Cash",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-084",
      Name: "Pirate Gold",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-085",
      Name: "The Dog House",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-086",
      Name: "Egyptian Fortunes",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-087",
      Name: "Extra Juicy",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-088",
      Name: "Wild Gladiators",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-089",
      Name: "Golden Pig",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-090",
      Name: "Treasure Horse",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-091",
      Name: "Safari King",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-092",
      Name: "Leprechaun Carol",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-093",
      Name: "Mustang Gold",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-094",
      Name: "Triple Dragons",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-095",
      Name: "Ancient Egypt Classic",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-096",
      Name: "Vegas Magic",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-097",
      Name: "Master Chen's Fortune",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-098",
      Name: "Da Vinci's Treasure",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-099",
      Name: "Peking Luck",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-100",
      Name: "Leprechaun Song",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-101",
      Name: "Jade Butterfly",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-102",
      Name: "Madame Destiny",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-103",
      Name: "Asgard",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-104",
      Name: "5 Lions",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-106",
      Name: "Great Rhino",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-107",
      Name: "Joker's Jewels",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-108",
      Name: "Fairytale Fortune",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-109",
      Name: "Fire 88",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-110",
      Name: "Chilli Heat",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-111",
      Name: "Aztec Gems",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-112",
      Name: "Ancient Egypt",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-113",
      Name: "Lucky New Year",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-114",
      Name: "Gold Rush",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-115",
      Name: "Santa",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-116",
      Name: "Panda's Fortune",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-117",
      Name: "7 Piggies",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-118",
      Name: "Diamond Strike",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-119",
      Name: "Vegas Nights",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-120",
      Name: "Wild Spells",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-121",
      Name: "Caishen's Gold",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-122",
      Name: "Pixie Wings",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-123",
      Name: "Gold Train",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-125",
      Name: "8 Dragons",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-126",
      Name: "3 Kingdoms - Battle of Red Cliffs",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-127",
      Name: "Wolf Gold",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-131",
      Name: "Dragon Kingdom",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-132",
      Name: "Hercules Son Of Zeus",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-133",
      Name: "3 Genie Wishes",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-135",
      Name: "Journey to the West",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-137",
      Name: "Lucky Dragons",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-139",
      Name: "Dwarven Gold Deluxe",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-141",
      Name: "Hot Safari",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-143",
      Name: "Mighty Kong",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-144",
      Name: "Lady Godiva",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-156",
      Name: "Great Reef",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-160",
      Name: "Devil's 13",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-162",
      Name: "Busy Bees",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-163",
      Name: "7 Monkeys",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-164",
      Name: "Triple Tigers",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-165",
      Name: "Monkey Madness",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-166",
      Name: "Money Roll",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-167",
      Name: "888 Dragons",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-168",
      Name: "Irish Charms",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-169",
      Name: "888 Gold",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-170",
      Name: "Diamonds are Forever 3 Lines",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-171",
      Name: "Temujin Treasures",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-172",
      Name: "Juicy Fruits",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-173",
      Name: "Wild Booster",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-174",
      Name: "Power of Thor Megaways",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-175",
      Name: "Hot Fiesta",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-176",
      Name: "Buffalo King Megaways",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-177",
      Name: "Floating Dragon",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-178",
      Name: "Panda Fortune 2",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-179",
      Name: "Amazing Money Machine",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-180",
      Name: "Aztec King",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-181",
      Name: "The Magic Cauldron - Enchanted Brew",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-182",
      Name: "Cash Elevator",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-183",
      Name: "5 Lions Megaways",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-184",
      Name: "Dragon Hot Hold and Spin",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-185",
      Name: "Yum Yum Powerways",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-186",
      Name: "Rise of Giza PowerNudge",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-187",
      Name: "Pyramid Bonanza",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-188",
      Name: "Raging Bull",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-189",
      Name: "Starlight Princess",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-190",
      Name: "Bigger Bass Bonanza",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-191",
      Name: "Heart of Rio",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-192",
      Name: "Lucky Lightning",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-193",
      Name: "Empty the Bank",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-194",
      Name: "Fruit Party 2",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-195",
      Name: "Phoenix Forge",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-196",
      Name: "Chicken Drop",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-197",
      Name: "Lucky Grace And Charm",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-198",
      Name: "Aztec King Megaways",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-199",
      Name: "Chilli Heat Megaways",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-200",
      Name: "Treasure Wild",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-201",
      Name: "Cash Bonanza",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-202",
      Name: "Piggy Bank Bills",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-203",
      Name: "Day of Dead",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-204",
      Name: "Candy Village",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-205",
      Name: "Mystic Chief",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-206",
      Name: "The Tweety House",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-207",
      Name: "Star Pirates Code",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-208",
      Name: "John Hunter and the Quest for Bermuda Riches",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-209",
      Name: "Big Juan",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-210",
      Name: "Santa's Wonderland",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-211",
      Name: "Christmas Big Bass Bonanza",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-212",
      Name: "Book of Fallen",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-213",
      Name: "Bubble Pop",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-214",
      Name: "Bounty Gold",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-215",
      Name: "Hockey Attack",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-216",
      Name: "Big Bass Bonanza Megaways",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-217",
      Name: "Fortune of Giza",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-218",
      Name: "Super X",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-219",
      Name: "Lucky New Year - Tiger Treasures",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-220",
      Name: "Emperor Caishen",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-221",
      Name: "Crystal Caverns Megaways",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-222",
      Name: "Smugglers Cove",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-223",
      Name: "Magician's Secrets",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-224",
      Name: "Extra Juicy Megaways",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-225",
      Name: "Wild Depths",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-226",
      Name: "Gates of Valhalla",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-227",
      Name: "Gold Party",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-228",
      Name: "Elemental Gems Megaways",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-229",
      Name: "Rock Vegas",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-230",
      Name: "Cash Patrol",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-231",
      Name: "The Ultimate 5",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-232",
      Name: "Colossal Cash Zone",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-233",
      Name: "Wild West Gold Megaways",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-234",
      Name: "Spirit of Adventure",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-235",
      Name: "Fire Strike 2",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-236",
      Name: "Barn Festival",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-237",
      Name: "Chicken Chase",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-238",
      Name: "Goblin Heist Powernudge",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-239",
      Name: "Eye of Cleopatra",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-240",
      Name: "The Great Stick-Up",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-241",
      Name: "Book of Aztec King",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-242",
      Name: "Bull Fiesta",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-243",
      Name: "Might of Ra",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-244",
      Name: "Rainbow Gold",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-245",
      Name: "Sugar Rush",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-246",
      Name: "Snakes and Ladders Megadice",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-247",
      Name: "Disco Lady",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-248",
      Name: "Tic Tac Take",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-249",
      Name: "Queenie",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-250",
      Name: "Drill that Gold",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-251",
      Name: "Clover Gold",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-252",
      Name: "Zombie Carnival",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-253",
      Name: "North Guardians",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-254",
      Name: "Koi Pond",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-255",
      Name: "Cleocatra",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-256",
      Name: "Little Gem",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-257",
      Name: "Queen of Gods",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-258",
      Name: "Cosmic Cash",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-259",
      Name: "Bomb Bonanza",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-260",
      Name: "Mahjong Panda",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-261",
      Name: "Big Bass Splash",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-262",
      Name: "Tropical Tiki",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-263",
      Name: "Coffee Wild",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-264",
      Name: "Cheeky Emperor",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-265",
      Name: "Hot to Burn Extreme",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-266",
      Name: "Magic Money Maze",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-267",
      Name: "Shining Hot 100",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-268",
      Name: "Shining Hot 40",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-269",
      Name: "Shining Hot 20",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-270",
      Name: "Shining Hot 5",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-271",
      Name: "Octobeer Fortunes",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-272",
      Name: "Gorilla Mayhem",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-273",
      Name: "Fire Hot 5",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-274",
      Name: "Fire Hot 20",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-275",
      Name: "Fire Hot 40",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-276",
      Name: "Fire Hot 100",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-277",
      Name: "Greedy Wolf",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-278",
      Name: "Down The Rails",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-279",
      Name: "Floating Dragon Megaways",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-280",
      Name: "Wildman Super Bonanza",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-281",
      Name: "Candy Stars",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-282",
      Name: "Black Bull",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-283",
      Name: "Muertos Multiplier Megaways",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-284",
      Name: "Crown of Fire",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-285",
      Name: "Snakes & Ladders - Snake Eyes",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-286",
      Name: "Striking Hot 5",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-287",
      Name: "Wild Hop & Drop",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-288",
      Name: "Book of Golden Sands",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-289",
      Name: "Sword of Ares",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-290",
      Name: "Spin & Score Megaways",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-291",
      Name: "John Hunter & the Book of Tut Respin",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-292",
      Name: "Bigger Bass Blizzard - Christmas Catch",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-293",
      Name: "Kingdom of Asgard",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-294",
      Name: "Release the Kraken 2",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-295",
      Name: "Santa's Great Gifts",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-296",
      Name: "Aztec Blaze",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-297",
      Name: "Starlight Christmas",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-298",
      Name: "Towering Fortunes",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-299",
      Name: "Firebird Spirit",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-300",
      Name: "Pirate Golden Age",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-301",
      Name: "Gems of Serengeti",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-302",
      Name: "Shield of Sparta",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-303",
      Name: "Gates of Gatot Kaca",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-304",
      Name: "Big Bass Bonanza - Keeping it Reel",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-305",
      Name: "Lucky Fishing Megaways",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-306",
      Name: "5 Rabbits Megaways",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-307",
      Name: "Dragon Hero",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-308",
      Name: "PIZZA! PIZZA? PIZZA!",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-309",
      Name: "Reel Banks",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-310",
      Name: "Sweet Powernudge",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-311",
      Name: "Hot Pepper",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-312",
      Name: "Gates of Aztec",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-313",
      Name: "Fury of Odin Megaways",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-314",
      Name: "Mammoth Gold Megaways",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-315",
      Name: "Wild Wild Bananas",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-316",
      Name: "Secret City Gold",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-317",
      Name: "Pinup Girls",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-318",
      Name: "Monster Superlanche",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-319",
      Name: "Fish Eye",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-320",
      Name: "Gatot Kaca's Fury",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-321",
      Name: "Club Tropicana",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-322",
      Name: "Fire Archer",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-323",
      Name: "Wild Wild Riches Megaways",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-324",
      Name: "Peak Power",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-325",
      Name: "Wild West Duels",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-326",
      Name: "Mystery Of The Orient",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-327",
      Name: "The Dog House Multihold",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-328",
      Name: "Rabbit Garden",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-329",
      Name: "Fruits of the Amazon",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-330",
      Name: "The Knight King",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-331",
      Name: "Moonshot",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-332",
      Name: "The Red Queen",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-333",
      Name: "Big Bass Bonanza - Hold & Spinner",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-334",
      Name: "3 Dancing Monkeys",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-335",
      Name: "African Elephant",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-336",
      Name: "Gods of Giza",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-337",
      Name: "Wild Celebrity Bus Megaways",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-338",
      Name: "Jane Hunter and the Mask of Montezuma",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-339",
      Name: "Cowboy Coins",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-340",
      Name: "Kingdom of The Dead",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-341",
      Name: "Jasmine Dreams",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-342",
      Name: "Diamonds of Egypt",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-343",
      Name: "Wild Bison Charge",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-344",
      Name: "Excalibur Unleashed",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-345",
      Name: "Knight Hot Spotz",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-346",
      Name: "Zeus vs Hades - Gods of War",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-347",
      Name: "Floating Dragon - Dragon Boat Festival",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-348",
      Name: "Sticky Bees",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-349",
      Name: "Robber Strike",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-350",
      Name: "Frogs & Bugs",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-351",
      Name: "Lamp Of Infinity",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-352",
      Name: "Pirates Pub",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-353",
      Name: "Jewel Rush",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-354",
      Name: "Wisdom of Athena",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-355",
      Name: "Fat Panda",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-356",
      Name: "Big Bass Amazon Xtreme",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-357",
      Name: "Heist for the Golden Nuggets",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-358",
      Name: "Joker Race",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-359",
      Name: "Hellvis Wild",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-360",
      Name: "Cash Box",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-361",
      Name: "Kraken's Sky Bounty",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-362",
      Name: "Power of Merlin Megaways",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-363",
      Name: "Spellbinding Mystery",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-364",
      Name: "Starlight Princess 1000",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-365",
      Name: "3 Buzzing Wilds",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-366",
      Name: "Lobster Bob's Crazy Crab Shack",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-367",
      Name: "Diamond Cascade",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-368",
      Name: "Mustang Trail",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-369",
      Name: "Rocket Blast Megaways",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-370",
      Name: "Piggy Bankers",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-371",
      Name: "Pub Kings",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-372",
      Name: "Mahjong Wins",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-373",
      Name: "Forge of Olympus",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-375",
      Name: "Cyclops Smash",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-376",
      Name: "Big Bass Hold & Spinner Megaways",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-377",
      Name: "Frozen Tropics",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-378",
      Name: "Gold Oasis",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-379",
      Name: "8 Golden Dragon Challenge",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-380",
      Name: "Book of Tut Megaways",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-381",
      Name: "Candy Blitz",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-382",
      Name: "Fortunes of Aztec",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-384",
      Name: "Infective Wild",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-385",
      Name: "Gravity Bonanza",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-386",
      Name: "Tundra's Fortune",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-387",
      Name: "Cash Chips",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-388",
      Name: "Sweet Bonanza Dice",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-389",
      Name: "Big Bass Halloween",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-390",
      Name: "Rainbow Reels",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-391",
      Name: "888 Bonanza",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-392",
      Name: "The Money Men Megaways",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-393",
      Name: "Demon Pots",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-394",
      Name: "Twilight Princess",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-395",
      Name: "Rujak Bonanza",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-396",
      Name: "Viking Forge",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-397",
      Name: "Sugar Supreme Powernudge",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-398",
      Name: "Joker Jewels Dice",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-399",
      Name: "Chase for Glory",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-400",
      Name: "Timber Stacks",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-401",
      Name: "Big Bass Christmas Bash",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-402",
      Name: "Nile Fortune",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-403",
      Name: "Sugar Rush Xmas",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-404",
      Name: "Holiday Ride",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-406",
      Name: "Year of the Dragon King",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-407",
      Name: "Good Luck & Good Fortune",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-408",
      Name: "Castle of Fire",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-409",
      Name: "Fortune Dragon",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-410",
      Name: "The Big Dawgs",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-411",
      Name: "Gates of Olympus 1000",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-413",
      Name: "Mahjong Wins Bonus",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-414",
      Name: "Blade & Fangs",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-415",
      Name: "Loki's Riches",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-416",
      Name: "The Dog House Dice Show",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-417",
      Name: "Ding Dong Christmas Bells",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-418",
      Name: "5 Frozen Charms Megaways",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-419",
      Name: "Sea Fantasy",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-420",
      Name: "Fire Stampede",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-421",
      Name: "Candy Jar Clusters",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-422",
      Name: "The Wild Gang",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-423",
      Name: "Floating Dragon New Year Festival Ultra Megaways",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-424",
      Name: "Juicy Fruits Multihold",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-425",
      Name: "Trees of Treasure",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-426",
      Name: "Fortune Ace",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-427",
      Name: "Blazing Wilds Megaways",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-428",
      Name: "Wheel O' Gold",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-429",
      Name: "Pompeii Megareels Megaways",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-430",
      Name: "Big Bass Floats My Boat",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-431",
      Name: "The Alter Ego",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-432",
      Name: "Mighty Munching Melons",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-433",
      Name: "Strawberry Cocktail",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-434",
      Name: "Great Lagoon",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-435",
      Name: "Power of Ninja",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-436",
      Name: "Gates of Olympus Dice",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-437",
      Name: "Zombie Train",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-438",
      Name: "Gears of Horus",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-439",
      Name: "Gates of Gatot Kaca 1000",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-440",
      Name: "Beware The Deep Megaways",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-441",
      Name: "Big Bass Day at the Races",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-442",
      Name: "Pot of Fortune",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-443",
      Name: "Sugar Rush 1000",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-444",
      Name: "Fire Portals",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-445",
      Name: "The Dog House - Dog or Alive",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-446",
      Name: "Release the Bison",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-447",
      Name: "Aztec Powernudge",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-448",
      Name: "Big Burger Load it up with Xtra Cheese",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-449",
      Name: "Ripe Rewards",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-450",
      Name: "Big Bass Secrets of the Golden Lake",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-451",
      Name: "Ice Lobster",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-452",
      Name: "Barnyard Megahays Megaways",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-453",
      Name: "Candy Blitz Bombs",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-454",
      Name: "Joker's Jewels Wild",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-455",
      Name: "Heroic Spin",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-456",
      Name: "Lobster Bob's Sea Food and Win It",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-457",
      Name: "Heart of Cleopatra",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-458",
      Name: "Odds On Winner",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-459",
      Name: "Dwarf & Dragon",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-460",
      Name: "Rise of Pyramids",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-461",
      Name: "Fruity Treats",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-462",
      Name: "Revenge of Loki Megaways",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-463",
      Name: "Starlight Princess Pachi",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-464",
      Name: "Sweet Bonanza 1000",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-465",
      Name: "Wildies",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-466",
      Name: "Devilicious",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-467",
      Name: "Big Bass Bonanza - Reel Action",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-468",
      Name: "Medusa's Stone",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-469",
      Name: "Big Bass Mission Fishin’",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-470",
      Name: "Buffalo King Untamed Megaways",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-472",
      Name: "Hand of Midas 2",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-473",
      Name: "Sweet Kingdom",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-474",
      Name: "Crank It Up",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-475",
      Name: "Samurai Code",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-476",
      Name: "Hot to Burn Multiplier",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-477",
      Name: "6 Jokers",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-478",
      Name: "Dynamite Diggin Doug",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-479",
      Name: "Joker's Jewels Hot",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-480",
      Name: "Sumo Supreme Megaways",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-481",
      Name: "Bow of Artemis",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-482",
      Name: "Money Stacks",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-483",
      Name: "Running Sushi",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-484",
      Name: "Yeti Quest",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-485",
      Name: "Jackpot Hunter",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-486",
      Name: "Forging Wilds",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-487",
      Name: "Hot to Burn - 7 Deadly Free Spins",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-488",
      Name: "Aztec Treasure Hunt",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-489",
      Name: "Dragon Gold 88",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-490",
      Name: "Gem Elevator",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-491",
      Name: "Angel vs Sinner",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-492",
      Name: "Mustang Gold Megaways",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-493",
      Name: "Big Bass Vegas Double Down Deluxe ",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-494",
      Name: "Congo Cash XL",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-495",
      Name: "Oodles of Noodles",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-496",
      Name: "Mystery Mice",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-497",
      Name: "Badge Blitz",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-499",
      Name: "Wisdom of Athena 1000",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-500",
      Name: "The Dog House - Muttley Crew",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-501",
      Name: "Fortune Hit’n Roll",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-502",
      Name: "Chests of Cai Shen",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-503",
      Name: "Release the Kraken Megaways",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-504",
      Name: "Big Bass Halloween 2",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-505",
      Name: "Vampy Party",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-506",
      Name: "Fangtastic Freespins",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-507",
      Name: "7 Clovers of Fortune",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-508",
      Name: "Candy Corner",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-517",
      Name: "Moleionaire",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-518",
      Name: "Wolf Gold Ultimate",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-519",
      Name: "Himalayan Wild",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-520",
      Name: "Eternal Empress - Freeze Time",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-521",
      Name: "Big Bass Xmas Xtreme",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-522",
      Name: "Might of Freya Megaways",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-523",
      Name: "Penguins Christmas Party Time",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-524",
      Name: "Gates of Olympus Xmas 1000",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-525",
      Name: "Santa's Xmas Rush",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-526",
      Name: "Tiny Toads",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-527",
      Name: "Dragon King Hot Pots",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-528",
      Name: "Money Stacks Megaways",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-529",
      Name: "Big Bass Bonanza 3 Reeler",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-530",
      Name: "Mining Rush",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-531",
      Name: "Aztec Smash",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-532",
      Name: "Fonzo’s Feline Fortunes",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-533",
      Name: "Floating Dragon - Year of the Snake",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-534",
      Name: "Brick House Bonanza",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-535",
      Name: "Aztec Gems Megaways",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-536",
      Name: "Wild Wild Pearls",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-537",
      Name: "Irish Crown",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-538",
      Name: "Wild Wildebeest Wins",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-539",
      Name: "Escape the Pyramid - Fire & Ice",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-540",
      Name: "Ancient Island Megaways",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-541",
      Name: "John Hunter and Galileo’s Secrets",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-542",
      Name: "Savannah Legend",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-543",
      Name: "Bigger Bass Splash",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-544",
      Name: "Big Bass Return to the Races",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-545",
      Name: "Peppe Pepperoni Pizza Plaza",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-546",
      Name: "5 Lions Megaways™ 2",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-547",
      Name: "Greedy Fortune Pig",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-548",
      Name: "Raging Waterfall Megaways",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-549",
      Name: "Wild Wild Joker",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-550",
      Name: "Lucky's Wild Pub",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-551",
      Name: "Volcano Goddess",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-552",
      Name: "The Dog House - Royal Hunt",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-553",
      Name: "Triple Pot Gold",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-554",
      Name: "Book of Monsters",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-555",
      Name: "Blitz Super Wheel",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-556",
      Name: "Bandit Megaways",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-557",
      Name: "Joker’s Jewels Cash",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-558",
      Name: "Ride The Lightning ",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-559",
      Name: "5 Lions Reborn",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-560",
      Name: "Big Bass Bonanza 1000",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-561",
      Name: "Cash Surge",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-562",
      Name: "Gates of Olympus Super Scatter",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-563",
      Name: "Witch Heart Megaways",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-564",
      Name: "Sleeping Dragon",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-565",
      Name: "Fiesta Fortune",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-566",
      Name: "Jumbo Safari",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-567",
      Name: "Resurrecting Riches",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-568",
      Name: "Majestic Express - Gold Run",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-569",
      Name: "Gates of Hades",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-570",
      Name: "Eye of Spartacus",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-571",
      Name: "Mummy's Jewels",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-572",
      Name: "Big Bass Boxing Bonus Round",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-573",
      Name: "Temple Guardians",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-574",
      Name: "Gold Party 2 - After Hours",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-575",
      Name: "Finger Lick'n Free Spins",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-576",
      Name: "Wild West Gold Blazing Bounty",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-577",
      Name: "Gem Fire Fortune",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-578",
      Name: "Waves of Poseidon",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-579",
      Name: "Club Tropicana - Happy Hour",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-580",
      Name: "Alien Invaders",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-581",
      Name: "You Can Piggy Bank On It",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-582",
      Name: "Chilli Heat Spicy Spins",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-583",
      Name: "Gem Trio",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-584",
      Name: "Wolf Gold 4 Pack",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-585",
      Name: "Big Bass Reel Repeat",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-586",
      Name: "Sweet Bonanza Super Scatter",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-587",
      Name: "Argonauts",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-588",
      Name: "Ice Mints",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-589",
      Name: "Spell Master",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-590",
      Name: "Zombie School Megaways",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-591",
      Name: "Fire Stampede 2",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-592",
      Name: "Jackpot Blaze",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-593",
      Name: "Genie's Gem Bonanza",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-594",
      Name: "Captain Kraken Megaways",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-595",
      Name: "Lobster House",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-596",
      Name: "Bee Keeper",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-597",
      Name: "Bounty Hunter",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-598",
      Name: "Fortune Ace Super Scatter",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-599",
      Name: "Bigger Barn House Bonanza",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-600",
      Name: "Hundreds and Thousands",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-601",
      Name: "Sweet Rush Bonanza",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-602",
      Name: "Mermaid's Treasure Trove",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-603",
      Name: "Big Bass Halloween 3",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-604",
      Name: "Hokkaido Wolf",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-605",
      Name: "Chests of Cai Shen 2",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-606",
      Name: "Lava Balls",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-607",
      Name: "Bingo Mania",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-608",
      Name: "Frightening Frankie",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-609",
      Name: "Pandemic Rising",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-610",
      Name: "Starlight Princess Super Scatter",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-611",
      Name: "Oracle of Gold",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-612",
      Name: "Big Bass Christmas - Frozen Lake",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-613",
      Name: "Wealthy Frog",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-614",
      Name: "Emotiwins",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-615",
      Name: "Lucky Tiger",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-616",
      Name: "Lucky Mouse",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-617",
      Name: "Lucky Ox",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-618",
      Name: "Jelly Candy",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-619",
      Name: "Plushie Wins",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-620",
      Name: "Lucky Dog",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-621",
      Name: "Lucky Monkey",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-622",
      Name: "Lucky Tiger 1000",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-623",
      Name: "Lucky Phoenix",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-624",
      Name: "Starlight Wins",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-625",
      Name: "Pig Farm",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-626",
      Name: "Fortune of Aztec",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-627",
      Name: "Olympus Wins",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-628",
      Name: "Master Gems",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-629",
      Name: "777 Rush",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-630",
      Name: "Dino Drop",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-631",
      Name: "Code of Cairo",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-632",
      Name: "Mystic Wishes",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-633",
      Name: "Lucky Dice",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-634",
      Name: "Happy Nets",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-635",
      Name: "Lucky Panda",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-636",
      Name: "DJ Neko",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-654",
      Name: "Big Bass Splash 1000",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-655",
      Name: "Wild Wild Riches Returns",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-656",
      Name: "Duel of Night & Day",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-658",
      Name: "Starlight Archer 1000",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-659",
      Name: "Super Gummy Strike",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-660",
      Name: "Santa’s Slay",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-661",
      Name: "Zeus vs Typhon",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-662",
      Name: "Wisdom of Athena 1000 Xmas",
      platFormCode: "PP",
    },
    {
      gameType: "SLOT",
      casinoType: "PP-SLOT-663",
      Name: "Gates of Gatot Kaca Super Scatter  ",
      platFormCode: "PP",
    },
    {
      gameType: "TABLE",
      casinoType: "PP-TABLE-001",
      Name: "DragonTiger",
      platFormCode: "PP",
    },
    {
      gameType: "TABLE",
      casinoType: "PP-TABLE-002",
      Name: "Dragon Bonus Baccarat",
      platFormCode: "PP",
    },
    {
      gameType: "TABLE",
      casinoType: "PP-TABLE-003",
      Name: "Baccarat",
      platFormCode: "PP",
    },
    {
      gameType: "TABLE",
      casinoType: "PP-TABLE-004",
      Name: "American Blackjack",
      platFormCode: "PP",
    },
    {
      gameType: "TABLE",
      casinoType: "PP-TABLE-005",
      Name: "Multihand Blackjack",
      platFormCode: "PP",
    },
    {
      gameType: "TABLE",
      casinoType: "PP-TABLE-006",
      Name: "Roulette",
      platFormCode: "PP",
    },
  ],
  PG: [
    {
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-001",
      Name: "Honey Trap of Diao Chan",
    },
    {
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-002",
      Name: "Gem Saviour",
    },
    {
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-003",
      Name: "Fortune Gods",
    },
    {
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-005",
      Name: "Medusa2",
    },
    {
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-006",
      Name: "Medusa",
    },
    {
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-009",
      Name: "Hood vs Wolf",
    },
    {
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-011",
      Name: "Win Win Won",
    },
    {
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-012",
      Name: "Plushie Frenzy",
    },
    {
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-013",
      Name: "Tree of Fortune",
    },
    {
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-015",
      Name: "Hotpot",
    },
    {
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-016",
      Name: "Dragon Legend",
    },
    {
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-017",
      Name: "Hip Hop Panda",
    },
    {
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-018",
      Name: "Legend of Hou Yi",
    },
    {
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-019",
      Name: "Mr Hallow-Jackpot!",
    },
    {
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-020",
      Name: "Prosperity Lion",
    },
    {
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-021",
      Name: "Santas Gift Rush",
    },
    {
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-022",
      Name: "Gem Saviour Sword",
    },
    {
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-023",
      Name: "Piggy Gold",
    },
    {
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-024",
      Name: "Jungle Delight",
    },
    {
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-025",
      Name: "Symbols of Egypt",
    },
    {
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-026",
      Name: "Ganesha Gold",
    },
    {
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-028",
      Name: "Emperors Favour",
    },
    {
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-030",
      Name: "Double Fortune",
    },
    {
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-032",
      Name: "The Great Icescape",
    },
    {
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-034",
      Name: "Captains Bounty",
    },
    {
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-035",
      Name: "Dragon Tiger Luck",
    },
    {
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-036",
      Name: "Flirting Scholar",
    },
    {
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-037",
      Name: "Journey To The Wealth",
    },
    {
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-038",
      Name: "Leprechaun Riches",
    },
    {
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-039",
      Name: "Muay Thai Champion",
    },
    {
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-040",
      Name: "Ninja vs Samurai",
    },
    {
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-041",
      Name: "Mahjong Ways",
    },
    {
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-042",
      Name: "Dragon Hatch",
    },
    {
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-043",
      Name: "Fortune Mouse",
    },
    {
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-044",
      Name: "Reel Love",
    },
    {
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-045",
      Name: "Gem Saviour Conquest",
    },
    {
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-046",
      Name: "Shaolin Soccer",
    },
    {
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-047",
      Name: "Caishen Wins",
    },
    {
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-048",
      Name: "Candy Burst",
    },
    {
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-049",
      Name: "Bikini Paradise",
    },
    {
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-050",
      Name: "Mahjong Ways 2",
    },
    {
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-051",
      Name: "Egypt's Book of Mystery",
    },
    {
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-052",
      Name: "Ganesha Fortune",
    },
    {
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-053",
      Name: "Phoenix Rises",
    },
    {
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-054",
      Name: "Dream of Macau",
    },
    {
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-055",
      Name: "Wild Fireworks",
    },
    {
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-057",
      Name: "Genie's 3 Wishes",
    },
    {
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-058",
      Name: "Treasures of Aztec",
    },
    {
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-059",
      Name: "Circus Delight",
    },
    {
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-060",
      Name: "Thai River Wonders",
    },
    {
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-061",
      Name: "Secret of Cleopatra",
    },
    {
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-062",
      Name: "Vampire's Charm",
    },
    {
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-063",
      Name: "Queen of Bounty",
    },
    {
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-064",
      Name: "Jewels of Prosperity",
    },
    {
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-065",
      Name: "Lucky Neko",
    },
    {
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-066",
      Name: "Jack Frost's Winter",
    },
    {
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-067",
      Name: "Galactic Gems",
    },
    {
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-068",
      Name: "Guardians of Ice and Fire",
    },
    {
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-069",
      Name: "Opera Dynasty",
    },
    {
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-070",
      Name: "Fortune Ox",
    },
    {
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-071",
      Name: "Bali Vacation",
    },
    {
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-072",
      Name: "Crypto Gold",
    },
    {
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-073",
      Name: "Majestic Treasures",
    },
    {
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-074",
      Name: "Candy Bonanza",
    },
    {
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-075",
      Name: "Wild Bandito",
    },
    {
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-076",
      Name: "Ways of the Qilin",
    },
    {
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-077",
      Name: "Heist Stakes",
    },
    {
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-078",
      Name: "Rise of the Sun God",
    },
    {
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-079",
      Name: "Jurassic Kingdom",
    },
    {
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-081",
      Name: "Mermaid Riches",
    },
    {
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-083",
      Name: "Raider Jane's Crypt of Fortune",
    },
    {
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-084",
      Name: "Supermarket Spree",
    },
    {
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-085",
      Name: "Buffalo Win",
    },
    {
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-086",
      Name: "Legendary Monkey King",
    },
    {
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-087",
      Name: "Spirited Wonders",
    },
    {
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-089",
      Name: "Emoji Riches",
    },
    {
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-090",
      Name: "Cocktail Nights",
    },
    {
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-091",
      Name: "Mask Carnival",
    },
    {
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-092",
      Name: "Oriental Prosperity",
    },
    {
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-093",
      Name: "Fortune Tiger",
    },
    {
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-094",
      Name: "Garuda Gems",
    },
    {
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-095",
      Name: "Destiny of sun and moon",
    },
    {
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-096",
      Name: "Butterfly Blossom",
    },
    {
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-097",
      Name: "Rooster Rumble",
    },
    {
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-098",
      Name: "The Queen's Banquet",
    },
    {
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-099",
      Name: "Battleground Royale",
    },
    {
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-100",
      Name: "Win Win Fish Prawn Crab",
    },
    {
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-101",
      Name: "Lucky Piggy",
    },
    {
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-102",
      Name: "Speed Winner",
    },
    {
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-103",
      Name: "Legend of Perseus",
    },
    {
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-104",
      Name: "Wild Coaster",
    },
    {
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-105",
      Name: "Wild Bounty Showdown",
    },
    {
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-106",
      Name: "Prosperity Fortune Tree",
    },
    {
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-107",
      Name: "Totem Wonders",
    },
    {
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-108",
      Name: "Alchemy Gold",
    },
    {
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-109",
      Name: "Diner Delights",
    },
    {
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-110",
      Name: "Asgardian Rising",
    },
    {
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-111",
      Name: "Midas Fortune",
    },
    {
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-112",
      Name: "Fortune Rabbit",
    },
    {
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-113",
      Name: "Rave Party Fever",
    },
    {
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-114",
      Name: "Hawaiian Tiki",
    },
    {
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-115",
      Name: "Bakery Bonanza",
    },
    {
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-116",
      Name: "Songkran Splash",
    },
    {
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-117",
      Name: "Mystical Spirits",
    },
    {
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-118",
      Name: "Super Golf Drive",
    },
    {
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-119",
      Name: "Lucky Clover Riches",
    },
    {
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-120",
      Name: "Fruity Candy",
    },
    {
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-121",
      Name: "Cruise Royale",
    },
    {
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-122",
      Name: "Safari Wilds",
    },
    {
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-123",
      Name: "Gladiator's Glory",
    },
    {
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-124",
      Name: "Ninja Raccoon Frenzy",
    },
    {
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-125",
      Name: "Ultimate Striker",
    },
    {
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-126",
      Name: "Wild Heist Cashout",
    },
    {
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-127",
      Name: "Forge of Wealth",
    },
    {
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-128",
      Name: "Mafia Mayhem",
    },
    {
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-129",
      Name: "Tsar Treasures",
    },
    {
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-130",
      Name: "Werewolf's Hunt",
    },
    {
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-131",
      Name: "Dragon Hatch 2",
    },
    {
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-132",
      Name: "Fortune Dragon",
    },
    {
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-133",
      Name: "Gemstones Gold",
    },
    {
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-134",
      Name: "Cash Mania",
    },
    {
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-135",
      Name: "Wild Ape",
    },
    {
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-136",
      Name: "Pinata Wins",
    },
    {
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-137",
      Name: "Mystic Potion",
    },
    {
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-138",
      Name: "Anubis Wrath",
    },
    {
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-139",
      Name: "Zombie Outbreak",
    },
    {
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-140",
      Name: "Chicky Run",
    },
    {
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-141",
      Name: "Futebol Fever",
    },
    {
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-142",
      Name: "Shark Bounty",
    },
    {
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-143",
      Name: "Yakuza Honor",
    },
    {
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-144",
      Name: "Wings of Iguazu",
    },
    {
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-145",
      Name: "Three Crazy Piggies",
    },
    {
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-146",
      Name: "Oishi Delights",
    },
    {
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-147",
      Name: "Museum Wonders",
    },
    {
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-148",
      Name: "Rio Fantasia",
    },
    {
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-149",
      Name: "Chocolate Deluxe",
    },
    {
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-150",
      Name: "Geisha's Revenge",
    },
    {
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-151",
      Name: "Fortune Snake",
    },
    {
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-152",
      Name: "Incan Wonders",
    },
    {
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-153",
      Name: "Mr. Treasure’s Fortune",
    },
    {
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-154",
      Name: "Graffiti Rush",
    },
    {
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-155",
      Name: "Doomsday Rampage",
    },
    {
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-156",
      Name: "Knockout Riches",
    },
    {
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-157",
      Name: "Dead Man's Riches",
    },
    {
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-158",
      Name: "Jack the Giant Hunter",
    },
    {
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-159",
      Name: "Diner Frenzy Spins",
    },
    {
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-160",
      Name: "Dragon's Treasure Quest",
    },
    {
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-161",
      Name: "Galaxy Miner",
    },
    {
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-162",
      Name: "Grimms' Bounty: Hansel & Gretel",
    },
    {
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-163",
      Name: "Majestic Empire",
    },
    {
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-164",
      Name: "Kraken Gold Rush",
    },
    {
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-165",
      Name: "Pharaoh Royals",
    },
    {
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-166",
      Name: "Skylight Wonders",
    },
    {
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-167",
      Name: "Alibaba's Cave of Fortune",
    },
    {
      platFormCode: "PG",
      gameType: "TABLE",
      casinoType: "PG-TABLE-001",
      Name: "Baccarat Deluxe",
    },
  ],
  EVOULUTION: [
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-001",
      Name: "Roulette",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-002",
      Name: "Blackjack A",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-003",
      Name: "Craps",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-004",
      Name: "Dragon Tiger",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-005",
      Name: "Super Sic Bo",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-006",
      Name: "Crazy Time",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-007",
      Name: "MONOPOLY Live",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-008",
      Name: "Instant Roulette",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-009",
      Name: "Triple Card Poker",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-010",
      Name: "Mega Ball",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-011",
      Name: "Lightning Dice",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-012",
      Name: "Infinite Blackjack",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-013",
      Name: "First Person Roulette",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-014",
      Name: "Crazy Coin Flip",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-015",
      Name: "Casino Hold'em",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-016",
      Name: "Power Blackjack",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-017",
      Name: "First Person Baccarat",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-018",
      Name: "MONOPOLY Big Baller",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-020",
      Name: "American Roulette",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-021",
      Name: "2 Hand Casino Hold'em",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-023",
      Name: "First Person Dream Catcher",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-024",
      Name: "Caribbean Stud Poker",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-025",
      Name: "Deal or No Deal",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-026",
      Name: "Teen Patti",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-027",
      Name: "Texas Hold'em Bonus Poker",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-029",
      Name: "First Person Blackjack",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-030",
      Name: "First Person Football Studio",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-031",
      Name: "First Person Craps",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-032",
      Name: "Extreme Texas Hold'em",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-033",
      Name: "First Person Dragon Tiger",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-034",
      Name: "First Person Mega Ball",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-035",
      Name: "Dream Catcher",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-036",
      Name: "Baccarat Squeeze",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-037",
      Name: "Infinite Free Bet Blackjack",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-038",
      Name: "No Commission Baccarat",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-039",
      Name: "Blackjack VIP B",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-040",
      Name: "Lightning Roulette",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-041",
      Name: "Baccarat Control Squeeze",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-042",
      Name: "Blackjack Party",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-043",
      Name: "Double Ball Roulette",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-044",
      Name: "Football Studio Dice",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-045",
      Name: "Football Studio",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-046",
      Name: "First Person Golden Wealth Baccarat",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-047",
      Name: "Emperor Sic Bo",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-049",
      Name: "Blackjack VIP U",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-050",
      Name: "Blackjack VIP 1",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-051",
      Name: "Blackjack Silver E",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-052",
      Name: "Blackjack VIP 25",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-053",
      Name: "Blackjack Silver B",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-054",
      Name: "Blackjack VIP 12",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-055",
      Name: "Blackjack VIP 15",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-056",
      Name: "Blackjack Silver C",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-057",
      Name: "Blackjack VIP X",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-058",
      Name: "Blackjack VIP Alpha",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-059",
      Name: "Blackjack VIP D",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-060",
      Name: "Blackjack VIP Gamma",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-061",
      Name: "Blackjack VIP G",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-062",
      Name: "Blackjack VIP V",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-063",
      Name: "Blackjack VIP 20",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-064",
      Name: "Blackjack VIP 7",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-065",
      Name: "Blackjack VIP I",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-066",
      Name: "Blackjack VIP 16",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-067",
      Name: "Blackjack VIP Beta",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-068",
      Name: "Blackjack Silver G",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-069",
      Name: "Blackjack VIP E",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-070",
      Name: "Blackjack Silver F",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-071",
      Name: "Blackjack VIP M",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-072",
      Name: "Blackjack VIP 14",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-073",
      Name: "Blackjack VIP 10",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-074",
      Name: "Blackjack Silver D",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-075",
      Name: "Blackjack Silver A",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-076",
      Name: "Blackjack VIP Z",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-077",
      Name: "Emperor Dragon Tiger",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-078",
      Name: "Speed Roulette",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-079",
      Name: "VIP Roulette",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-080",
      Name: "Emperor Roulette",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-081",
      Name: "Salon Privé Roulette",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-082",
      Name: "Blackjack B",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-083",
      Name: "Blackjack C",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-084",
      Name: "Blackjack VIP 11",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-085",
      Name: "Blackjack VIP 13",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-086",
      Name: "Blackjack VIP 17",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-087",
      Name: "Blackjack VIP 18",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-088",
      Name: "Blackjack VIP 19",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-089",
      Name: "Blackjack VIP 2",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-090",
      Name: "Blackjack VIP 21",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-091",
      Name: "Blackjack VIP 22",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-092",
      Name: "Blackjack VIP 26",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-093",
      Name: "Blackjack VIP 27",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-094",
      Name: "Blackjack VIP 3",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-095",
      Name: "Blackjack VIP 4",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-096",
      Name: "Blackjack VIP 5",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-097",
      Name: "Blackjack VIP 6",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-098",
      Name: "Blackjack VIP 8",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-099",
      Name: "Blackjack VIP 9",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-100",
      Name: "Blackjack VIP A",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-101",
      Name: "Blackjack VIP C",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-102",
      Name: "Blackjack VIP F",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-103",
      Name: "Blackjack VIP H",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-104",
      Name: "Blackjack VIP J",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-105",
      Name: "Blackjack VIP K",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-106",
      Name: "Blackjack VIP L",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-107",
      Name: "Blackjack VIP N",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-108",
      Name: "Blackjack VIP O",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-109",
      Name: "Blackjack VIP P",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-110",
      Name: "Blackjack VIP Q",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-111",
      Name: "Blackjack VIP R",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-112",
      Name: "Blackjack VIP S",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-113",
      Name: "Blackjack VIP T",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-114",
      Name: "Crazy Time A",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-115",
      Name: "Blackjack Fortune VIP",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-116",
      Name: "Blackjack Grand VIP",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-117",
      Name: "Blackjack Platinum VIP",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-118",
      Name: "Blackjack Diamond VIP",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-120",
      Name: "Baccarat A",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-121",
      Name: "Salon Privé Baccarat G",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-122",
      Name: "Baccarat B",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-123",
      Name: "Baccarat C",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-124",
      Name: "Salon Privé Baccarat B",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-125",
      Name: "Salon Privé Baccarat A",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-126",
      Name: "Salon Privé Baccarat C",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-127",
      Name: "Salon Privé Baccarat D",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-128",
      Name: "Salon Privé Baccarat E",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-129",
      Name: "Salon Privé Baccarat F",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-130",
      Name: "Salon Privé Baccarat H",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-131",
      Name: "Salon Privé Baccarat I",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-132",
      Name: "Salon Privé Baccarat J",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-133",
      Name: "Lightning Baccarat",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-134",
      Name: "No Commission Speed Baccarat A",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-135",
      Name: "No Commission Speed Baccarat B",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-136",
      Name: "No Commission Speed Baccarat C",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-137",
      Name: "Speed Baccarat F",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-138",
      Name: "Speed Baccarat I",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-139",
      Name: "Speed Baccarat B",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-140",
      Name: "Speed Baccarat H",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-141",
      Name: "Speed Baccarat Q",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-142",
      Name: "Speed Baccarat M",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-143",
      Name: "Speed Baccarat X",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-144",
      Name: "Speed Baccarat O",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-145",
      Name: "Speed Baccarat A",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-146",
      Name: "Speed Baccarat C",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-147",
      Name: "Emperor Speed Baccarat B",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-148",
      Name: "Speed Baccarat E",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-149",
      Name: "Speed Baccarat P",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-150",
      Name: "Emperor Speed Baccarat A",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-151",
      Name: "Speed Baccarat K",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-152",
      Name: "Speed Baccarat W",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-153",
      Name: "Emperor Speed Baccarat C",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-154",
      Name: "Speed Baccarat G",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-155",
      Name: "Speed Baccarat L",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-156",
      Name: "Speed Baccarat N",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-157",
      Name: "Speed Baccarat J",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-158",
      Name: "Speed Baccarat D",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-159",
      Name: "Speed Baccarat 1",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-160",
      Name: "Speed Baccarat 2",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-161",
      Name: "Speed Baccarat 3",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-162",
      Name: "Speed Baccarat R",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-163",
      Name: "Speed Baccarat S",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-164",
      Name: "Speed Baccarat T",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-165",
      Name: "Speed Baccarat U",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-166",
      Name: "Speed Baccarat V",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-167",
      Name: "Speed Baccarat Z",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-168",
      Name: "Extra Chili Epic Spins",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-169",
      Name: "Imperial Quest",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-170",
      Name: "Auto-Roulette",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-171",
      Name: "Auto-Roulette VIP",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-172",
      Name: "Bac Bo",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-173",
      Name: "Speed Blackjack H",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-175",
      Name: "Cash Or Crash",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-176",
      Name: "Dead or Alive: Saloon",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-177",
      Name: "Speed Blackjack D",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-178",
      Name: "Fan Tan",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-179",
      Name: "Golden Wealth Baccarat",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-180",
      Name: "Immersive Roulette",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-181",
      Name: "Lightning Blackjack",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-182",
      Name: "Peek Baccarat",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-183",
      Name: "Funky Time",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-184",
      Name: "Speed Blackjack E",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-185",
      Name: "Speed Blackjack G",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-186",
      Name: "Speed Blackjack I",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-187",
      Name: "Speed Blackjack J",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-188",
      Name: "Speed Blackjack K",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-189",
      Name: "Speed Blackjack L",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-190",
      Name: "Speed Blackjack M",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-191",
      Name: "Speed VIP Blackjack A",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-192",
      Name: "Speed VIP Blackjack B",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-193",
      Name: "Speed VIP Blackjack C",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-194",
      Name: "Speed VIP Blackjack D",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-195",
      Name: "Speed VIP Blackjack E",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-196",
      Name: "Speed VIP Blackjack F",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-197",
      Name: "Speed VIP Blackjack G",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-198",
      Name: "Speed VIP Blackjack H",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-199",
      Name: "Speed VIP Blackjack I",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-200",
      Name: "Speed VIP Blackjack J",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-201",
      Name: "Speed VIP Blackjack K",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-202",
      Name: "Speed VIP Blackjack L",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-203",
      Name: "Speed VIP Blackjack M",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-204",
      Name: "Super Andar Bahar",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-205",
      Name: "XXXtreme Lightning Roulette",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-206",
      Name: "First Person American Roulette",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-207",
      Name: "First Person Lightning Baccarat",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-208",
      Name: "First Person Lightning Blackjack",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-209",
      Name: "First Person Lightning Roulette",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-210",
      Name: "Emperor Speed Baccarat D",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-211",
      Name: "Emperor Sic Bo A",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-212",
      Name: "Speed Auto Roulette",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-214",
      Name: "Football Studio Roulette",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-215",
      Name: "Salon Privé Blackjack A",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-216",
      Name: "Salon Privé Blackjack B",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-217",
      Name: "Salon Privé Blackjack C",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-218",
      Name: "Salon Privé Blackjack D",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-219",
      Name: "Salon Privé Blackjack E",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-220",
      Name: "Salon Privé Blackjack F",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-221",
      Name: "Salon Privé Blackjack G",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-222",
      Name: "Salon Privé Blackjack H",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-223",
      Name: "Salon Privé Blackjack I",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-224",
      Name: "Salon Privé Blackjack J",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-225",
      Name: "First Person Deal or No Deal",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-226",
      Name: "First Person XXXtreme Lightning Roulette",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-227",
      Name: "Video Poker",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-228",
      Name: "Gold Vault Roulette",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-229",
      Name: "Hindi Speed Baccarat",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-230",
      Name: "Emperor Bac Bo",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-231",
      Name: "Bonsai Speed Baccarat A",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-232",
      Name: "Bonsai Speed Baccarat B",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-233",
      Name: "Bonsai Speed Baccarat C",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-234",
      Name: "Blackjack VIP 28",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-235",
      Name: "Blackjack VIP 29",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-236",
      Name: "Salon Privé Baccarat K",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-237",
      Name: "Salon Privé Baccarat L",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-238",
      Name: "Speed VIP Blackjack N",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-239",
      Name: "Speed VIP Blackjack O",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-240",
      Name: "Speed VIP Blackjack P",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-241",
      Name: "Speed VIP Blackjack Q",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-242",
      Name: "Speed VIP Blackjack R",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-243",
      Name: "Blackjack VIP 30",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-244",
      Name: "First Person Prosperity Tree Baccarat",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-245",
      Name: "Prosperity Tree Baccarat",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-246",
      Name: "Gonzo's Treasure Map",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-247",
      Name: "Speed Baccarat 4",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-248",
      Name: "Speed Baccarat 5",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-249",
      Name: "Speed Baccarat 6",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-250",
      Name: "Speed Baccarat 9",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-253",
      Name: "Speed Baccarat 10",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-254",
      Name: "Speed Baccarat 11",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-255",
      Name: "XXXtreme lightning Baccarat",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-256",
      Name: "First person XXXtreme lightning Baccarat",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-257",
      Name: "Red Door Roulette",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-258",
      Name: "First person Video Poker",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-259",
      Name: "First Person Super Sic Bo",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-260",
      Name: "Speed Super Sic Bo",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-261",
      Name: "Crazy Pachinko",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-262",
      Name: "Speed Baccarat 12",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-263",
      Name: "Evo Speed Blackjack 1",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-264",
      Name: "Evo Speed Blackjack 2",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-265",
      Name: "Evo Speed Blackjack 3",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-266",
      Name: "Evo Speed Blackjack 4",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-267",
      Name: "Evo Speed Blackjack 5",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-268",
      Name: "Evo Speed Blackjack 6",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-269",
      Name: "Evo Speed Blackjack 7",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-270",
      Name: "Evo Speed Blackjack 8",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-271",
      Name: "Salon Privé Baccarat M",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-272",
      Name: "Salon Privé Baccarat N",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-273",
      Name: "Speed Baccarat 7",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-274",
      Name: "Speed Baccarat 8",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-275",
      Name: "Blackjack VIP 31",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-276",
      Name: "Blackjack VIP 32",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-277",
      Name: "Hindi Speed Baccarat B",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-278",
      Name: "Evo Speed Blackjack 9",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-279",
      Name: "Evo Speed Blackjack 10",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-280",
      Name: "Evo Speed Blackjack 11",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-281",
      Name: "Blackjack VIP 33",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-282",
      Name: "Blackjack VIP 34",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-283",
      Name: "Blackjack VIP 35",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-286",
      Name: "Blackjack VIP 38",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-287",
      Name: "Blackjack VIP 41",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-288",
      Name: "Blackjack VIP 42",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-289",
      Name: "Blackjack VIP 43",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-290",
      Name: "Blackjack VIP 44",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-291",
      Name: "Stock Market",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-292",
      Name: "First Person Stock Market",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-314",
      Name: "Free Bet VIP Blackjack A",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-332",
      Name: "Blackjack VIP 36",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-333",
      Name: "Blackjack VIP 37",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-339",
      Name: "Blackjack VIP 50",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-344",
      Name: "Lightning Dragon Tiger",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-362",
      Name: "Lightning Sic Bo",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-363",
      Name: "Balloon Race",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-364",
      Name: "First Person HiLo",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-365",
      Name: "Salon Privé Blackjack K",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-366",
      Name: "Salon Privé Blackjack L",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-367",
      Name: "Salon Privé Blackjack M",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-368",
      Name: "Salon Privé Blackjack N",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-369",
      Name: "Lightning Storm",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-376",
      Name: "Lightning Ball",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-377",
      Name: "Platinum Privé Blackjack 1",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-378",
      Name: "Platinum Privé Blackjack 2",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-379",
      Name: "Platinum Privé Blackjack 3",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-380",
      Name: "Platinum Privé Blackjack 4",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-381",
      Name: "Platinum Privé Blackjack 5",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-382",
      Name: "Platinum Privé Blackjack 6",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-383",
      Name: "Platinum Privé Blackjack 7",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-386",
      Name: "Salon Privé Blackjack O",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-387",
      Name: "Salon Privé Blackjack P",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-388",
      Name: "Salon Privé Blackjack Q",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-397",
      Name: "Infinite Fun Fun 21 Blackjack",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-398",
      Name: "Super Speed Baccarat",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-408",
      Name: "Bet with Streamers",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-409",
      Name: "Crazy Balls",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-410",
      Name: "Always 8 Baccarat",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-411",
      Name: "Lotus Sic Bo",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-412",
      Name: "Infinite Bet Stacker Blackjack",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-413",
      Name: "Easy Blackjack",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-414",
      Name: "Emperor Golden Wealth Baccarat",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-415",
      Name: "Thai Speed Baccarat A",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-416",
      Name: "Lotus Speed Baccarat A",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-417",
      Name: "Lotus Roulette",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-420",
      Name: "Lotus Speed Baccarat B",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-421",
      Name: "Lotus Speed Baccarat C",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-422",
      Name: "VIP Bet Stacker Blackjack 1",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-423",
      Name: "VIP Bet Stacker Blackjack 2",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-424",
      Name: "VIP Bet Stacker Blackjack 3",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-425",
      Name: "VIP Bet Stacker Blackjack 4",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-426",
      Name: "Race Track",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-427",
      Name: "Race Track A",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-428",
      Name: "Bet with Streamers",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-429",
      Name: "Hindi Lightning Roulette",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-430",
      Name: "Hindi Roulette",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-431",
      Name: "War",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-432",
      Name: "Thai Speed Baccarat B",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-433",
      Name: "Thai Speed Baccarat C",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-434",
      Name: "Marble Race",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-435",
      Name: "Super Color Game",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-436",
      Name: "Fireball Roulette",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-440",
      Name: "Lightning Bac Bo",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-441",
      Name: "Dynasty Speed  Baccarat 1",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-442",
      Name: "Dynasty Speed  Baccarat 2",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-443",
      Name: "Dynasty Speed  Baccarat 3",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-444",
      Name: "Dynasty Speed  Baccarat 4",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-445",
      Name: "Dynasty Speed  Baccarat 5",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-446",
      Name: "Dynasty Speed  Baccarat 6",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-447",
      Name: "Dynasty Speed  Baccarat 7",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-448",
      Name: "Dynasty Speed  Baccarat 8",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-449",
      Name: "Ice Fishing",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-450",
      Name: "Dynasty Lightning Roulette",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-451",
      Name: "Super Speed Dragon Tiger ",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-453",
      Name: "Dragon Tiger Phoenix",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-454",
      Name: "Always 9 Baccarat",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-455",
      Name: "Red Baron",
    },
    {
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-456",
      Name: "Red Baron A",
    },
  ],
  ROYALGAMMING: [
    {
      platFormCode: "ROYALGAMING",
      gameType: "LIVE",
      casinoType: "RG-LIVE-001",
      Name: "Royal Gaming Live Lobby",
    },
    {
      platFormCode: "ROYALGAMING",
      gameType: "LIVE",
      casinoType: "RG-LIVE-002",
      Name: "7 Up Down",
    },
    {
      platFormCode: "ROYALGAMING",
      gameType: "LIVE",
      casinoType: "RG-LIVE-003",
      Name: "Teen Patti",
    },
    {
      platFormCode: "ROYALGAMING",
      gameType: "LIVE",
      casinoType: "RG-LIVE-004",
      Name: "Dragon Tiger",
    },
    {
      platFormCode: "ROYALGAMING",
      gameType: "LIVE",
      casinoType: "RG-LIVE-005",
      Name: "Cricket War",
    },
    {
      platFormCode: "ROYALGAMING",
      gameType: "LIVE",
      casinoType: "RG-LIVE-006",
      Name: "Baccarat",
    },
    {
      platFormCode: "ROYALGAMING",
      gameType: "LIVE",
      casinoType: "RG-LIVE-007",
      Name: "Amar Akbar Anthony",
    },
    {
      platFormCode: "ROYALGAMING",
      gameType: "LIVE",
      casinoType: "RG-LIVE-008",
      Name: "3 Cards Judgement",
    },
    {
      platFormCode: "ROYALGAMING",
      gameType: "LIVE",
      casinoType: "RG-LIVE-009",
      Name: "Worli Matka",
    },
    {
      platFormCode: "ROYALGAMING",
      gameType: "LIVE",
      casinoType: "RG-LIVE-010",
      Name: "Lottery",
    },
    {
      platFormCode: "ROYALGAMING",
      gameType: "LIVE",
      casinoType: "RG-LIVE-011",
      Name: "HighLow",
    },
    {
      platFormCode: "ROYALGAMING",
      gameType: "LIVE",
      casinoType: "RG-LIVE-012",
      Name: "Muflis Teen Patti",
    },
    {
      platFormCode: "ROYALGAMING",
      gameType: "LIVE",
      casinoType: "RG-LIVE-013",
      Name: "One Day Teenpatti",
    },
    {
      platFormCode: "ROYALGAMING",
      gameType: "LIVE",
      casinoType: "RG-LIVE-014",
      Name: "Lucky7",
    },
    {
      platFormCode: "ROYALGAMING",
      gameType: "LIVE",
      casinoType: "RG-LIVE-015",
      Name: "Akbar Romeo Walter",
    },
    {
      platFormCode: "ROYALGAMING",
      gameType: "LIVE",
      casinoType: "RG-LIVE-016",
      Name: "2 Cards Teenpatti",
    },
    {
      platFormCode: "ROYALGAMING",
      gameType: "LIVE",
      casinoType: "RG-LIVE-017",
      Name: "Dragon Tiger One day",
    },
    {
      platFormCode: "ROYALGAMING",
      gameType: "LIVE",
      casinoType: "RG-LIVE-018",
      Name: "Dragon Tiger Lion",
    },
    {
      platFormCode: "ROYALGAMING",
      gameType: "LIVE",
      casinoType: "RG-LIVE-019",
      Name: "Trio",
    },
    {
      platFormCode: "ROYALGAMING",
      gameType: "LIVE",
      casinoType: "RG-LIVE-020",
      Name: "2 Card Teen Patti One Day",
    },
    {
      platFormCode: "ROYALGAMING",
      gameType: "LIVE",
      casinoType: "RG-LIVE-021",
      Name: "Center Card",
    },
    {
      platFormCode: "ROYALGAMING",
      gameType: "LIVE",
      casinoType: "RG-LIVE-022",
      Name: "Test Teenpatti",
    },
    {
      platFormCode: "ROYALGAMING",
      gameType: "LIVE",
      casinoType: "RG-LIVE-023",
      Name: "Instant Teenpatti 2",
    },
    {
      platFormCode: "ROYALGAMING",
      gameType: "LIVE",
      casinoType: "RG-LIVE-024",
      Name: "Roulette Classic",
    },
    {
      platFormCode: "ROYALGAMING",
      gameType: "LIVE",
      casinoType: "RG-LIVE-025",
      Name: "Diamond Roulette",
    },
    {
      platFormCode: "ROYALGAMING",
      gameType: "LIVE",
      casinoType: "RG-LIVE-026",
      Name: "Diamond Teen Patti",
    },
    {
      platFormCode: "ROYALGAMING",
      gameType: "LIVE",
      casinoType: "RG-LIVE-027",
      Name: "Speed Auto Roulette",
    },
    {
      platFormCode: "ROYALGAMING",
      gameType: "LIVE",
      casinoType: "RG-LIVE-028",
      Name: "Auto Roulette A",
    },
    {
      platFormCode: "ROYALGAMING",
      gameType: "LIVE",
      casinoType: "RG-LIVE-029",
      Name: "Auto Roulette",
    },
    {
      platFormCode: "ROYALGAMING",
      gameType: "LIVE",
      casinoType: "RG-LIVE-030",
      Name: "Casino War",
    },
    {
      platFormCode: "ROYALGAMING",
      gameType: "LIVE",
      casinoType: "RG-LIVE-031",
      Name: "Bollywood Casino",
    },
    {
      platFormCode: "ROYALGAMING",
      gameType: "LIVE",
      casinoType: "RG-LIVE-032",
      Name: "Roulette",
    },
    {
      platFormCode: "ROYALGAMING",
      gameType: "LIVE",
      casinoType: "RG-LIVE-033",
      Name: "VIP TeenPatti",
    },
    {
      platFormCode: "ROYALGAMING",
      gameType: "LIVE",
      casinoType: "RG-LIVE-034",
      Name: "Casino War",
    },
    {
      platFormCode: "ROYALGAMING",
      gameType: "LIVE",
      casinoType: "RG-LIVE-035",
      Name: "Bollywood Casino",
    },
    {
      platFormCode: "ROYALGAMING",
      gameType: "LIVE",
      casinoType: "RG-LIVE-036",
      Name: "20-20 Cricket",
    },
  ],
  LADYLUCK: [
    {
      platFormCode: "LADYLUCK",
      gameType: "SLOT",
      casinoType: "LADYLUCK-SLOT-001",
      Name: "Cherry Supreme",
    },
    {
      platFormCode: "LADYLUCK",
      gameType: "SLOT",
      casinoType: "LADYLUCK-SLOT-002",
      Name: "Cuddles Royal",
    },
    {
      platFormCode: "LADYLUCK",
      gameType: "SLOT",
      casinoType: "LADYLUCK-SLOT-003",
      Name: "Lucky Heaven",
    },
    {
      platFormCode: "LADYLUCK",
      gameType: "SLOT",
      casinoType: "LADYLUCK-SLOT-004",
      Name: "Orango Tango",
    },
    {
      platFormCode: "LADYLUCK",
      gameType: "SLOT",
      casinoType: "LADYLUCK-SLOT-005",
      Name: "Popeye",
    },
    {
      platFormCode: "LADYLUCK",
      gameType: "SLOT",
      casinoType: "LADYLUCK-SLOT-006",
      Name: "Quartz SiO2",
    },
    {
      platFormCode: "LADYLUCK",
      gameType: "SLOT",
      casinoType: "LADYLUCK-SLOT-007",
      Name: "Ruler of Egypt",
    },
    {
      platFormCode: "LADYLUCK",
      gameType: "SLOT",
      casinoType: "LADYLUCK-SLOT-008",
      Name: "Spinjoy Society",
    },
    {
      platFormCode: "LADYLUCK",
      gameType: "SLOT",
      casinoType: "LADYLUCK-SLOT-009",
      Name: "SpinJoy Society Megaways",
    },
    {
      platFormCode: "LADYLUCK",
      gameType: "SLOT",
      casinoType: "LADYLUCK-SLOT-010",
      Name: "Total Summer Bliss",
    },
    {
      platFormCode: "LADYLUCK",
      gameType: "SLOT",
      casinoType: "LADYLUCK-SLOT-011",
      Name: "Valhöll Wild Hammers",
    },
    {
      platFormCode: "LADYLUCK",
      gameType: "SLOT",
      casinoType: "LADYLUCK-SLOT-012",
      Name: "Valley of the Muses",
    },
    {
      platFormCode: "LADYLUCK",
      gameType: "SLOT",
      casinoType: "LADYLUCK-SLOT-013",
      Name: "Weight of the Gun",
    },
    {
      platFormCode: "LADYLUCK",
      gameType: "SLOT",
      casinoType: "LADYLUCK-SLOT-014",
      Name: "Xmas at the Cabin",
    },
    {
      platFormCode: "LADYLUCK",
      gameType: "SLOT",
      casinoType: "LADYLUCK-SLOT-015",
      Name: "Astro Anna",
    },
    {
      platFormCode: "LADYLUCK",
      gameType: "SLOT",
      casinoType: "LADYLUCK-SLOT-016",
      Name: "The treasures of Tizoc",
    },
    {
      platFormCode: "LADYLUCK",
      gameType: "SLOT",
      casinoType: "LADYLUCK-SLOT-017",
      Name: "Valhöll Hall of the Slain",
    },
    {
      platFormCode: "LADYLUCK",
      gameType: "SLOT",
      casinoType: "LADYLUCK-SLOT-018",
      Name: "Lucky Mr Wild",
    },
    {
      platFormCode: "LADYLUCK",
      gameType: "SLOT",
      casinoType: "LADYLUCK-SLOT-019",
      Name: "Mr. Alchemister",
    },
    {
      platFormCode: "LADYLUCK",
      gameType: "SLOT",
      casinoType: "LADYLUCK-SLOT-020",
      Name: "Madame Clues",
    },
  ],
  YL: [
    {
      platFormCode: "YL",
      gameType: "FH",
      casinoType: "YL-FISH-001",
      Name: "Fishing 2",
    },
    {
      platFormCode: "YL",
      gameType: "FH",
      casinoType: "YL-FISH-002",
      Name: "Shark Hunter",
    },
    {
      platFormCode: "YL",
      gameType: "FH",
      casinoType: "YL-FISH-003",
      Name: "New Fishing Season",
    },
    {
      platFormCode: "YL",
      gameType: "FH",
      casinoType: "YL-FISH-004",
      Name: "Jackpot Fishery",
    },
    {
      platFormCode: "YL",
      gameType: "FH",
      casinoType: "YL-FISH-005",
      Name: "Heroes of the Deep Sea",
    },
    {
      platFormCode: "YL",
      gameType: "EGAME",
      casinoType: "YL-EGAME-001",
      Name: "Fruit",
    },
    {
      platFormCode: "YL",
      gameType: "EGAME",
      casinoType: "YL-EGAME-002",
      Name: "Gold Shark",
    },
    {
      platFormCode: "YL",
      gameType: "EGAME",
      casinoType: "YL-EGAME-003",
      Name: "Shark",
    },
    {
      platFormCode: "YL",
      gameType: "EGAME",
      casinoType: "YL-EGAME-004",
      Name: "Forest Dance",
    },
    {
      platFormCode: "YL",
      gameType: "EGAME",
      casinoType: "YL-EGAME-005",
      Name: "Happy Fruit",
    },
    {
      platFormCode: "YL",
      gameType: "EGAME",
      casinoType: "YL-EGAME-006",
      Name: "Cockfighting",
    },
    {
      platFormCode: "YL",
      gameType: "EGAME",
      casinoType: "YL-EGAME-007",
      Name: "Solo king",
    },
    {
      platFormCode: "YL",
      gameType: "EGAME",
      casinoType: "YL-EGAME-008",
      Name: "Lucky five",
    },
    {
      platFormCode: "YL",
      gameType: "EGAME",
      casinoType: "YL-EGAME-009",
      Name: "PokerGo",
    },
    {
      platFormCode: "YL",
      gameType: "EGAME",
      casinoType: "YL-EGAME-010",
      Name: "DiamondDeal",
    },
    {
      platFormCode: "YL",
      gameType: "EGAME",
      casinoType: "YL-EGAME-011",
      Name: "Mercedes-Benz BMW",
    },
    {
      platFormCode: "YL",
      gameType: "EGAME",
      casinoType: "YL-EGAME-012",
      Name: "Guess",
    },
    {
      platFormCode: "YL",
      gameType: "EGAME",
      casinoType: "YL-EGAME-013",
      Name: "Mines",
    },
    {
      platFormCode: "YL",
      gameType: "EGAME",
      casinoType: "YL-EGAME-014",
      Name: "Tower",
    },
    {
      platFormCode: "YL",
      gameType: "EGAME",
      casinoType: "YL-EGAME-015",
      Name: "Ojisan",
    },
    {
      platFormCode: "YL",
      gameType: "EGAME",
      casinoType: "YL-EGAME-016",
      Name: "Crash",
    },
    {
      platFormCode: "YL",
      gameType: "EGAME",
      casinoType: "YL-EGAME-017",
      Name: "Dice",
    },
    {
      platFormCode: "YL",
      gameType: "EGAME",
      casinoType: "YL-EGAME-018",
      Name: "Plinko",
    },
    {
      platFormCode: "YL",
      gameType: "EGAME",
      casinoType: "YL-EGAME-019",
      Name: "KittyGold",
    },
    {
      platFormCode: "YL",
      gameType: "EGAME",
      casinoType: "YL-EGAME-020",
      Name: "Gems Miner",
    },
    {
      platFormCode: "YL",
      gameType: "EGAME",
      casinoType: "YL-EGAME-021",
      Name: "Wheel",
    },
    {
      platFormCode: "YL",
      gameType: "EGAME",
      casinoType: "YL-EGAME-022",
      Name: "HILO",
    },
    {
      platFormCode: "YL",
      gameType: "EGAME",
      casinoType: "YL-EGAME-023",
      Name: "Tower2",
    },
    {
      platFormCode: "YL",
      gameType: "EGAME",
      casinoType: "YL-EGAME-024",
      Name: "Thai HILO",
    },
    {
      platFormCode: "YL",
      gameType: "EGAME",
      casinoType: "YL-EGAME-025",
      Name: "Video Poker",
    },
    {
      platFormCode: "YL",
      gameType: "EGAME",
      casinoType: "YL-EGAME-026",
      Name: "Aviator",
    },
    {
      platFormCode: "YL",
      gameType: "EGAME",
      casinoType: "YL-EGAME-027",
      Name: "MahjongWays",
    },
  ],
  YESBINGO: [
    {
      platFormCode: "YESBINGO",
      gameType: "BINGO",
      casinoType: "YesBingo-BINGO-001",
      Name: "Win Cai Shen",
    },
    {
      platFormCode: "YESBINGO",
      gameType: "BINGO",
      casinoType: "YesBingo-BINGO-002",
      Name: "OpenSesame",
    },
    {
      platFormCode: "YESBINGO",
      gameType: "BINGO",
      casinoType: "YesBingo-BINGO-003",
      Name: "BingoBonanza",
    },
    {
      platFormCode: "YESBINGO",
      gameType: "BINGO",
      casinoType: "YesBingo-BINGO-004",
      Name: "BingoBingo",
    },
    {
      platFormCode: "YESBINGO",
      gameType: "BINGO",
      casinoType: "YesBingo-BINGO-005",
      Name: "Atlantis",
    },
    {
      platFormCode: "YESBINGO",
      gameType: "BINGO",
      casinoType: "YesBingo-BINGO-006",
      Name: "Beasty Bingo",
    },
    {
      platFormCode: "YESBINGO",
      gameType: "BINGO",
      casinoType: "YesBingo-BINGO-007",
      Name: "Money Bingo",
    },
    {
      platFormCode: "YESBINGO",
      gameType: "BINGO",
      casinoType: "YesBingo-BINGO-008",
      Name: "Heat Bingo",
    },
    {
      platFormCode: "YESBINGO",
      gameType: "BINGO",
      casinoType: "YesBingo-BINGO-009",
      Name: "Lightning Bingo",
    },
    {
      platFormCode: "YESBINGO",
      gameType: "BINGO",
      casinoType: "YesBingo-BINGO-010",
      Name: "Joy Bingo",
    },
    {
      platFormCode: "YESBINGO",
      gameType: "BINGO",
      casinoType: "YesBingo-BINGO-011",
      Name: "EZ Bingo",
    },
    {
      platFormCode: "YESBINGO",
      gameType: "BINGO",
      casinoType: "YesBingo-BINGO-012",
      Name: "Super 30 BINGO",
    },
    {
      platFormCode: "YESBINGO",
      gameType: "FH",
      casinoType: "YesBingo-FH-001",
      Name: "OceanPhoenix",
    },
    {
      platFormCode: "YESBINGO",
      gameType: "SLOT",
      casinoType: "YesBingo-SLOT-001",
      Name: "Fortune Treasure",
    },
    {
      platFormCode: "YESBINGO",
      gameType: "SLOT",
      casinoType: "YesBingo-SLOT-002",
      Name: "Money Horse",
    },
    {
      platFormCode: "YESBINGO",
      gameType: "SLOT",
      casinoType: "YesBingo-SLOT-003",
      Name: "Drago Nova",
    },
    {
      platFormCode: "YESBINGO",
      gameType: "SLOT",
      casinoType: "YesBingo-SLOT-004",
      Name: "Power Fortune",
    },
    {
      platFormCode: "YESBINGO",
      gameType: "SLOT",
      casinoType: "YesBingo-SLOT-005",
      Name: "Power Lion",
    },
    {
      platFormCode: "YESBINGO",
      gameType: "SLOT",
      casinoType: "YesBingo-SLOT-006",
      Name: "Power Mask",
    },
    {
      platFormCode: "YESBINGO",
      gameType: "SLOT",
      casinoType: "YesBingo-SLOT-007",
      Name: "FaFaDragon",
    },
    {
      platFormCode: "YESBINGO",
      gameType: "SLOT",
      casinoType: "YesBingo-SLOT-008",
      Name: "MagicLamp",
    },
    {
      platFormCode: "YESBINGO",
      gameType: "SLOT",
      casinoType: "YesBingo-SLOT-009",
      Name: "Gladiator",
    },
    {
      platFormCode: "YESBINGO",
      gameType: "SLOT",
      casinoType: "YesBingo-SLOT-010",
      Name: "Lucky Star",
    },
    {
      platFormCode: "YESBINGO",
      gameType: "SLOT",
      casinoType: "YesBingo-SLOT-011",
      Name: "Rolling 7",
    },
    {
      platFormCode: "YESBINGO",
      gameType: "SLOT",
      casinoType: "YesBingo-SLOT-012",
      Name: "Thor Fortune",
    },
    {
      platFormCode: "YESBINGO",
      gameType: "SLOT",
      casinoType: "YesBingo-SLOT-013",
      Name: "Fancy Egypt",
    },
    {
      platFormCode: "YESBINGO",
      gameType: "SLOT",
      casinoType: "YesBingo-SLOT-014",
      Name: "Fortune Cat",
    },
    {
      platFormCode: "YESBINGO",
      gameType: "SLOT",
      casinoType: "YesBingo-SLOT-015",
      Name: "Casino Fantasy",
    },
    {
      platFormCode: "YESBINGO",
      gameType: "SLOT",
      casinoType: "YesBingo-SLOT-016",
      Name: "Golden Bunny",
    },
    {
      platFormCode: "YESBINGO",
      gameType: "SLOT",
      casinoType: "YesBingo-SLOT-017",
      Name: "King Arthur Gold",
    },
    {
      platFormCode: "YESBINGO",
      gameType: "SLOT",
      casinoType: "YesBingo-SLOT-018",
      Name: "Boom Boom Marmot",
    },
    {
      platFormCode: "YESBINGO",
      gameType: "SLOT",
      casinoType: "YesBingo-SLOT-019",
      Name: "Golden Aztec",
    },
    {
      platFormCode: "YESBINGO",
      gameType: "SLOT",
      casinoType: "YesBingo-SLOT-020",
      Name: "Rolling Fortune ",
    },
    {
      platFormCode: "YESBINGO",
      gameType: "SLOT",
      casinoType: "YesBingo-SLOT-021",
      Name: "Mermaid Slingo",
    },
    {
      platFormCode: "YESBINGO",
      gameType: "SLOT",
      casinoType: "YesBingo-SLOT-022",
      Name: "Royal Ace",
    },
    {
      platFormCode: "YESBINGO",
      gameType: "SLOT",
      casinoType: "YesBingo-SLOT-023",
      Name: "MagicLampLink",
    },
    {
      platFormCode: "YESBINGO",
      gameType: "SLOT",
      casinoType: "YesBingo-SLOT-024",
      Name: "GladiatorLink",
    },
    {
      platFormCode: "YESBINGO",
      gameType: "SLOT",
      casinoType: "YesBingo-SLOT-025",
      Name: "Super Egypt",
    },
    {
      platFormCode: "YESBINGO",
      gameType: "SLOT",
      casinoType: "YesBingo-SLOT-026",
      Name: "Golden Aztec Mega",
    },
    {
      platFormCode: "YESBINGO",
      gameType: "SLOT",
      casinoType: "YesBingo-SLOT-027",
      Name: "Sugar Crush",
    },
    {
      platFormCode: "YESBINGO",
      gameType: "SLOT",
      casinoType: "YesBingo-SLOT-029",
      Name: "Crazy Money",
    },
    {
      platFormCode: "YESBINGO",
      gameType: "SLOT",
      casinoType: "YesBingo-SLOT-030",
      Name: "Lucky Meow",
    },
    {
      platFormCode: "YESBINGO",
      gameType: "SLOT",
      casinoType: "YesBingo-SLOT-031",
      Name: "Royal Hunter",
    },
    {
      platFormCode: "YESBINGO",
      gameType: "SLOT",
      casinoType: "YesBingo-SLOT-032",
      Name: "Dragon Gems",
    },
    {
      platFormCode: "YESBINGO",
      gameType: "SLOT",
      casinoType: "YesBingo-SLOT-034",
      Name: "LIGHT OF APOLLO",
    },
    {
      platFormCode: "YESBINGO",
      gameType: "SLOT",
      casinoType: "YesBingo-SLOT-035",
      Name: "Magical Alchemist",
    },
    {
      platFormCode: "YESBINGO",
      gameType: "SLOT",
      casinoType: "YesBingo-SLOT-036",
      Name: "Dragon Gems Super Buy",
    },
    {
      platFormCode: "YESBINGO",
      gameType: "SLOT",
      casinoType: "YesBingo-SLOT-037",
      Name: "Pirate Legends",
    },
    {
      platFormCode: "YESBINGO",
      gameType: "SLOT",
      casinoType: "YesBingo-SLOT-038",
      Name: "Dragon Gems Wheel",
    },
    {
      platFormCode: "YESBINGO",
      gameType: "SLOT",
      casinoType: "YesBingo-SLOT-042",
      Name: "Golden X Ace",
    },
    {
      platFormCode: "YESBINGO",
      gameType: "SLOT",
      casinoType: "YesBingo-SLOT-043",
      Name: "Fortune X Ace",
    },
    {
      platFormCode: "YESBINGO",
      gameType: "SLOT",
      casinoType: "YesBingo-SLOT-044",
      Name: "Sexy Joker",
    },
    {
      platFormCode: "YESBINGO",
      gameType: "EGAME",
      casinoType: "YesBingo-EGAME-001",
      Name: "Crazy Color",
    },
    {
      platFormCode: "YESBINGO",
      gameType: "EGAME",
      casinoType: "YesBingo-EGAME-002",
      Name: "Diamond Mines",
    },
    {
      platFormCode: "YESBINGO",
      gameType: "EGAME",
      casinoType: "YesBingo-EGAME-003",
      Name: "Money Blast",
    },
  ],
  VRLOTTO: [
    {
      platFormCode: "VRLOTTO",
      gameType: "LOTTO",
      casinoType: "VRLOTTO-LOTTO-001",
      Name: "VR Venus 1.5 Lottery",
    },
    {
      platFormCode: "VRLOTTO",
      gameType: "LOTTO",
      casinoType: "VRLOTTO-LOTTO-002",
      Name: "VR Racetrack Lottery",
    },
    {
      platFormCode: "VRLOTTO",
      gameType: "LOTTO",
      casinoType: "VRLOTTO-LOTTO-003",
      Name: "VR 3 Lottery",
    },
    {
      platFormCode: "VRLOTTO",
      gameType: "LOTTO",
      casinoType: "VRLOTTO-LOTTO-004",
      Name: "VR Baccarat",
    },
    {
      platFormCode: "VRLOTTO",
      gameType: "LOTTO",
      casinoType: "VRLOTTO-LOTTO-005",
      Name: "VR Mark Six",
    },
    {
      platFormCode: "VRLOTTO",
      gameType: "LOTTO",
      casinoType: "VRLOTTO-LOTTO-006",
      Name: "VR Fu Xing 1.5 minute lottery",
    },
    {
      platFormCode: "VRLOTTO",
      gameType: "LOTTO",
      casinoType: "VRLOTTO-LOTTO-010",
      Name: "VR Vietnam-27-1.5 minute lottery",
    },
    {
      platFormCode: "VRLOTTO",
      gameType: "LOTTO",
      casinoType: "VRLOTTO-LOTTO-011",
      Name: "VR Vietnam-27-3minute lottery",
    },
    {
      platFormCode: "VRLOTTO",
      gameType: "LOTTO",
      casinoType: "VRLOTTO-LOTTO-012",
      Name: "VR Vietnam-18-1.5 minute lottery",
    },
    {
      platFormCode: "VRLOTTO",
      gameType: "LOTTO",
      casinoType: "VRLOTTO-LOTTO-013",
      Name: "VR Vietnam-18-3minute lottery",
    },
    {
      platFormCode: "VRLOTTO",
      gameType: "LOTTO",
      casinoType: "VRLOTTO-LOTTO-014",
      Name: "VR Vietnam-18-5 minute lottery",
    },
    {
      platFormCode: "VRLOTTO",
      gameType: "LOTTO",
      casinoType: "VRLOTTO-LOTTO-018",
      Name: "Hanoi",
    },
    {
      platFormCode: "VRLOTTO",
      gameType: "LOTTO",
      casinoType: "VRLOTTO-LOTTO-019",
      Name: "Phu Yen",
    },
    {
      platFormCode: "VRLOTTO",
      gameType: "LOTTO",
      casinoType: "VRLOTTO-LOTTO-020",
      Name: "Hue",
    },
    {
      platFormCode: "VRLOTTO",
      gameType: "LOTTO",
      casinoType: "VRLOTTO-LOTTO-021",
      Name: "Quang Nam",
    },
    {
      platFormCode: "VRLOTTO",
      gameType: "LOTTO",
      casinoType: "VRLOTTO-LOTTO-022",
      Name: "Dak Lak",
    },
    {
      platFormCode: "VRLOTTO",
      gameType: "LOTTO",
      casinoType: "VRLOTTO-LOTTO-023",
      Name: "Da Nang",
    },
    {
      platFormCode: "VRLOTTO",
      gameType: "LOTTO",
      casinoType: "VRLOTTO-LOTTO-024",
      Name: "Khanh Hoa",
    },
    {
      platFormCode: "VRLOTTO",
      gameType: "LOTTO",
      casinoType: "VRLOTTO-LOTTO-025",
      Name: "Binh Dinh",
    },
    {
      platFormCode: "VRLOTTO",
      gameType: "LOTTO",
      casinoType: "VRLOTTO-LOTTO-026",
      Name: "Quang Binh",
    },
    {
      platFormCode: "VRLOTTO",
      gameType: "LOTTO",
      casinoType: "VRLOTTO-LOTTO-027",
      Name: "Gia Lai",
    },
    {
      platFormCode: "VRLOTTO",
      gameType: "LOTTO",
      casinoType: "VRLOTTO-LOTTO-028",
      Name: "Ninh Thuan",
    },
    {
      platFormCode: "VRLOTTO",
      gameType: "LOTTO",
      casinoType: "VRLOTTO-LOTTO-029",
      Name: "Quang Ngai",
    },
    {
      platFormCode: "VRLOTTO",
      gameType: "LOTTO",
      casinoType: "VRLOTTO-LOTTO-030",
      Name: "Kon Tum",
    },
    {
      platFormCode: "VRLOTTO",
      gameType: "LOTTO",
      casinoType: "VRLOTTO-LOTTO-031",
      Name: "Ho Chi Minh City",
    },
    {
      platFormCode: "VRLOTTO",
      gameType: "LOTTO",
      casinoType: "VRLOTTO-LOTTO-032",
      Name: "Dong Thap",
    },
    {
      platFormCode: "VRLOTTO",
      gameType: "LOTTO",
      casinoType: "VRLOTTO-LOTTO-033",
      Name: "Thanh pho Ca Mau",
    },
    {
      platFormCode: "VRLOTTO",
      gameType: "LOTTO",
      casinoType: "VRLOTTO-LOTTO-034",
      Name: "Thanh pho Vung Tau",
    },
    {
      platFormCode: "VRLOTTO",
      gameType: "LOTTO",
      casinoType: "VRLOTTO-LOTTO-035",
      Name: "Tinh Bac Lieu",
    },
    {
      platFormCode: "VRLOTTO",
      gameType: "LOTTO",
      casinoType: "VRLOTTO-LOTTO-036",
      Name: "Dong Nai",
    },
    {
      platFormCode: "VRLOTTO",
      gameType: "LOTTO",
      casinoType: "VRLOTTO-LOTTO-037",
      Name: "Soc Trang",
    },
    {
      platFormCode: "VRLOTTO",
      gameType: "LOTTO",
      casinoType: "VRLOTTO-LOTTO-038",
      Name: "Can Tho",
    },
    {
      platFormCode: "VRLOTTO",
      gameType: "LOTTO",
      casinoType: "VRLOTTO-LOTTO-039",
      Name: "Tay Ninh",
    },
    {
      platFormCode: "VRLOTTO",
      gameType: "LOTTO",
      casinoType: "VRLOTTO-LOTTO-040",
      Name: "An Giang",
    },
    {
      platFormCode: "VRLOTTO",
      gameType: "LOTTO",
      casinoType: "VRLOTTO-LOTTO-041",
      Name: "Binh Thuan",
    },
    {
      platFormCode: "VRLOTTO",
      gameType: "LOTTO",
      casinoType: "VRLOTTO-LOTTO-042",
      Name: "Vinh Long",
    },
    {
      platFormCode: "VRLOTTO",
      gameType: "LOTTO",
      casinoType: "VRLOTTO-LOTTO-043",
      Name: "Bình Dng",
    },
    {
      platFormCode: "VRLOTTO",
      gameType: "LOTTO",
      casinoType: "VRLOTTO-LOTTO-044",
      Name: "Tra Vinh",
    },
    {
      platFormCode: "VRLOTTO",
      gameType: "LOTTO",
      casinoType: "VRLOTTO-LOTTO-045",
      Name: "Bình Phc",
    },
    {
      platFormCode: "VRLOTTO",
      gameType: "LOTTO",
      casinoType: "VRLOTTO-LOTTO-046",
      Name: "Hau Giang",
    },
    {
      platFormCode: "VRLOTTO",
      gameType: "LOTTO",
      casinoType: "VRLOTTO-LOTTO-047",
      Name: "Tien Giang",
    },
    {
      platFormCode: "VRLOTTO",
      gameType: "LOTTO",
      casinoType: "VRLOTTO-LOTTO-048",
      Name: "Kien Giang",
    },
    {
      platFormCode: "VRLOTTO",
      gameType: "LOTTO",
      casinoType: "VRLOTTO-LOTTO-049",
      Name: "Da Lat",
    },
    {
      platFormCode: "VRLOTTO",
      gameType: "LOTTO",
      casinoType: "VRLOTTO-LOTTO-050",
      Name: "VR Speed Racing",
    },
    {
      platFormCode: "VRLOTTO",
      gameType: "LOTTO",
      casinoType: "VRLOTTO-LOTTO-051",
      Name: "VR LUCK",
    },
    {
      platFormCode: "VRLOTTO",
      gameType: "LOTTO",
      casinoType: "VRLOTTO-LOTTO-052",
      Name: "VR Bai Fu 3 Minute Lottery",
    },
    {
      platFormCode: "VRLOTTO",
      gameType: "LOTTO",
      casinoType: "VRLOTTO-LOTTO-053",
      Name: "VR Wan Fu Mark Six",
    },
    {
      platFormCode: "VRLOTTO",
      gameType: "LOTTO",
      casinoType: "VRLOTTO-LOTTO-055",
      Name: "Greece-KENO",
    },
  ],
  VIACASINO: [
    {
      gameType: "LIVE",
      casinoType: "VIACASINO-LIVE-001",
      Name: "Classic Baccarat",
      platFormCode: "VIACASINO",
    },
    {
      gameType: "LIVE",
      casinoType: "VIACASINO-LIVE-002",
      Name: "Speed Baccarat",
      platFormCode: "VIACASINO",
    },
    {
      gameType: "LIVE",
      casinoType: "VIACASINO-LIVE-003",
      Name: "Lucky Natural ",
      platFormCode: "VIACASINO",
    },
    {
      gameType: "LIVE",
      casinoType: "VIACASINO-LIVE-004",
      Name: "Pair Baccarat",
      platFormCode: "VIACASINO",
    },
    {
      gameType: "LIVE",
      casinoType: "VIACASINO-LIVE-005",
      Name: "Wealth SuperSix",
      platFormCode: "VIACASINO",
    },
    {
      gameType: "LIVE",
      casinoType: "VIACASINO-LIVE-006",
      Name: "Dragon Tiger",
      platFormCode: "VIACASINO",
    },
    {
      gameType: "LIVE",
      casinoType: "VIACASINO-LIVE-007",
      Name: "Classic Sic Bo",
      platFormCode: "VIACASINO",
    },
    {
      gameType: "LIVE",
      casinoType: "VIACASINO-LIVE-008",
      Name: "Thai Hi Lo",
      platFormCode: "VIACASINO",
    },
    {
      gameType: "LIVE",
      casinoType: "VIACASINO-LIVE-009",
      Name: "Tai Xiu",
      platFormCode: "VIACASINO",
    },
    {
      gameType: "LIVE",
      casinoType: "VIACASINO-LIVE-010",
      Name: "Color Game",
      platFormCode: "VIACASINO",
    },
    {
      gameType: "LIVE",
      casinoType: "VIACASINO-LIVE-011",
      Name: "Thai Fish Prawn Crab",
      platFormCode: "VIACASINO",
    },
    {
      gameType: "LIVE",
      casinoType: "VIACASINO-LIVE-012",
      Name: "Viet Fish Prawn Crab",
      platFormCode: "VIACASINO",
    },
    {
      gameType: "LIVE",
      casinoType: "VIACASINO-LIVE-015",
      Name: "Xoc Dia",
      platFormCode: "VIACASINO",
    },
    {
      gameType: "LIVE",
      casinoType: "VIACASINO-LIVE-016",
      Name: "Rocket HiLo ​​Baccarat",
      platFormCode: "VIACASINO",
    },
    {
      gameType: "LIVE",
      casinoType: "VIACASINO-LIVE-017",
      Name: "Blockchain Classic Sic Bo",
      platFormCode: "VIACASINO",
    },
    {
      gameType: "LIVE",
      casinoType: "VIACASINO-LIVE-018",
      Name: "BlockchainThai Hi Lo",
      platFormCode: "VIACASINO",
    },
    {
      gameType: "LIVE",
      casinoType: "VIACASINO-LIVE-019",
      Name: "Blockchain Tai Xiu",
      platFormCode: "VIACASINO",
    },
    {
      gameType: "LIVE",
      casinoType: "VIACASINO-LIVE-020",
      Name: "Lotto Baccarat",
      platFormCode: "VIACASINO",
    },
    {
      gameType: "LIVE",
      casinoType: "VIACASINO-LIVE-021",
      Name: "Lotto Super Six",
      platFormCode: "VIACASINO",
    },
    {
      gameType: "LIVE",
      casinoType: "VIACASINO-LIVE-022",
      Name: "Lotto Lucky Natural ",
      platFormCode: "VIACASINO",
    },
    {
      gameType: "LIVE",
      casinoType: "VIACASINO-LIVE-023",
      Name: "Lotto Xoc Dia",
      platFormCode: "VIACASINO",
    },
    {
      gameType: "LIVE",
      casinoType: "VIACASINO-LIVE-024",
      Name: "Lotto Lucky Wheel",
      platFormCode: "VIACASINO",
    },
    {
      gameType: "LIVE",
      casinoType: "VIACASINO-LIVE-025",
      Name: "Crazy Marbles ",
      platFormCode: "VIACASINO",
    },
    {
      gameType: "LIVE",
      casinoType: "VIACASINO-LIVE-026",
      Name: "Tornado Marbles",
      platFormCode: "VIACASINO",
    },
    {
      gameType: "LIVE",
      casinoType: "VIACASINO-LIVE-027",
      Name: "Blockchain Thai FishShrimpCrab",
      platFormCode: "VIACASINO",
    },
    {
      gameType: "LIVE",
      casinoType: "VIACASINO-LIVE-028",
      Name: "Blockchain Viet FishShrimpCrab",
      platFormCode: "VIACASINO",
    },
    {
      gameType: "LIVE",
      casinoType: "VIACASINO-LIVE-029",
      Name: "Blockchain Xoc Dia",
      platFormCode: "VIACASINO",
    },
    {
      gameType: "LIVE",
      casinoType: "VIACASINO-LIVE-030",
      Name: "Blockchain Color Game",
      platFormCode: "VIACASINO",
    },
  ],
  PT: [
    {
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-001",
      Name: "Baccarat",
    },
    {
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-002",
      Name: "Dragon Tiger",
    },
    {
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-003",
      Name: "SicBo Deluxe",
    },
    {
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-004",
      Name: "Andar Bahar Live",
    },
    {
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-005",
      Name: "Bet on Baccarat Live",
    },
    {
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-007",
      Name: "All Bets Blackjack",
    },
    {
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-009",
      Name: "Sette E Mezzo",
    },
    {
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-010",
      Name: "Unlimited Blackjack",
    },
    {
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-011",
      Name: "Adventures Beyond Wonderland",
    },
    {
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-015",
      Name: "Spin a Win",
    },
    {
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-016",
      Name: "3 Card Brag",
    },
    {
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-017",
      Name: "Casino HoldÂ´em",
    },
    {
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-019",
      Name: "Bet on Poker Live",
    },
    {
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-021",
      Name: "American Roulette",
    },
    {
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-022",
      Name: "Deutsches Speed Roulette",
    },
    {
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-023",
      Name: "Football French Roulette",
    },
    {
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-024",
      Name: "Football Roulette",
    },
    {
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-025",
      Name: "French Roulette",
    },
    {
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-026",
      Name: "Quantum Auto Roulette",
    },
    {
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-027",
      Name: "Spread Bet Roulette",
    },
    {
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-028",
      Name: "Mega Fire Blaze Roulette Live",
    },
    {
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-030",
      Name: "Bet On Dragon Tiger Live",
    },
    {
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-031",
      Name: "Italian Cashback Blackjack",
    },
    {
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-032",
      Name: "Roulette",
    },
    {
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-034",
      Name: "Grand Baccarat",
    },
    {
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-035",
      Name: "Speed 6 Scanner Baccarat",
    },
    {
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-037",
      Name: "Grand Baccarat NC",
    },
    {
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-038",
      Name: "Speed 6 Scanner Baccarat NC",
    },
    {
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-041",
      Name: "Blackjack Italiano 1",
    },
    {
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-042",
      Name: "Blackjack Italiano 2",
    },
    {
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-043",
      Name: "Blackjack Italiano VIP",
    },
    {
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-044",
      Name: "Deutsches Blackjack",
    },
    {
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-045",
      Name: "Royale Blackjack 1",
    },
    {
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-052",
      Name: "Royale Blackjack 3",
    },
    {
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-054",
      Name: "Soho All Bets Blackjack",
    },
    {
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-055",
      Name: "Greek Roulette",
    },
    {
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-056",
      Name: "Hindi Roulette",
    },
    {
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-057",
      Name: "Prestige Roulette",
    },
    {
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-058",
      Name: "Speed Auto Roulette",
    },
    {
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-059",
      Name: "Roleta Brasileira",
    },
    {
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-060",
      Name: "Roulette Italiana",
    },
    {
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-061",
      Name: "Auto Roulette",
    },
    {
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-063",
      Name: "Bucharest Roulette",
    },
    {
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-064",
      Name: "Turkish Roulette",
    },
    {
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-066",
      Name: "Bucharest French Roulette",
    },
    {
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-067",
      Name: "Quantum Roulette Live",
    },
    {
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-068",
      Name: "Blackjack 9",
    },
    {
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-069",
      Name: "Blackjack 3",
    },
    {
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-070",
      Name: "Blackjack 4",
    },
    {
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-071",
      Name: "Blackjack 5",
    },
    {
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-072",
      Name: "Blackjack 6",
    },
    {
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-073",
      Name: "Blackjack 7",
    },
    {
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-074",
      Name: "Blackjack 8",
    },
    {
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-075",
      Name: "Baccarat NC",
    },
    {
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-076",
      Name: "Greek Quantum Roulette",
    },
    {
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-077",
      Name: "Ruleta Automatica Cuantica",
    },
    {
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-078",
      Name: "Arabic Roulette",
    },
    {
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-079",
      Name: "Quantum Ruleta España",
    },
    {
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-080",
      Name: "Ruyi French Roulette",
    },
    {
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-081",
      Name: "Ruyi Roulette",
    },
    {
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-083",
      Name: "Slingshot Ruleta Espana",
    },
    {
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-086",
      Name: "The Greatest Cards Show",
    },
    {
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-088",
      Name: "Spin a Win Wild Live",
    },
    {
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-091",
      Name: "Japanese Squeeze Baccarat",
    },
    {
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-092",
      Name: "Japanese Squeeze Baccarat NC",
    },
    {
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-093",
      Name: "Ru Yi Speed Baccarat",
    },
    {
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-094",
      Name: "Ru Yi Speed Baccarat NC",
    },
    {
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-095",
      Name: "Speed Baccarat Korean ",
    },
    {
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-096",
      Name: "Speed Baccarat Korean NC",
    },
    {
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-097",
      Name: "Baccarat Brasileira",
    },
    {
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-098",
      Name: "Baccarat Brasileira NC",
    },
    {
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-099",
      Name: "Speed SicBo",
    },
    {
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-100",
      Name: "Auto Roulette 2",
    },
    {
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-102",
      Name: "x1000 Quantum Roulette",
    },
    {
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-106",
      Name: "Mega Fire Blaze Blackjack Live",
    },
    {
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-108",
      Name: "Mega Fire Blaze Lucky Ball Brasileiro",
    },
    {
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-109",
      Name: "Speed Baccarat",
    },
    {
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-110",
      Name: "Mega Fire Blaze Lucky Ball Live",
    },
    {
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-111",
      Name: "Blackjack Soirée 1",
    },
    {
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-112",
      Name: "Blackjack Soirée 2",
    },
    {
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-113",
      Name: "Blackjack Soirée 3",
    },
    {
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-114",
      Name: "Soirée Privée Blackjack",
    },
    {
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-115",
      Name: "Baccarat Soirée",
    },
    {
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-117",
      Name: "Gangnam Speed Baccarat",
    },
    {
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-118",
      Name: "Gangnam Speed Baccarat NC",
    },
    {
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-119",
      Name: "Emperor Baccarat",
    },
    {
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-120",
      Name: "Emperor Baccarat NC",
    },
    {
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-121",
      Name: "Blackjack Soirée Gold 1",
    },
    {
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-122",
      Name: "Blackjack Soirée Gold 2",
    },
    {
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-123",
      Name: "Blackjack Soirée Gold 3",
    },
    {
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-124",
      Name: "Blackjack Soirée Gold 4",
    },
    {
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-125",
      Name: "Punto Banco Soirée Gold",
    },
    {
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-126",
      Name: "All Bets Blackjack Brasileira",
    },
    {
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-127",
      Name: "Blackjack 10",
    },
    {
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-128",
      Name: "Sticky Bandits Roulette Live",
    },
    {
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-129",
      Name: "Baccarat Soirée NC",
    },
    {
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-130",
      Name: "Lucky Ball Roulette Live",
    },
    {
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-131",
      Name: "Cash Collect Roulette Live",
    },
    {
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-132",
      Name: "Blackjack VZN 1",
    },
    {
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-133",
      Name: "Blackjack VZN 2",
    },
    {
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-134",
      Name: "Blackjack VZN 3",
    },
    {
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-135",
      Name: "Blackjack VZN 4",
    },
    {
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-136",
      Name: "Blackjack VZN 5",
    },
    {
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-137",
      Name: "Blackjack VZN 6",
    },
    {
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-138",
      Name: "Blackjack VZN 7",
    },
    {
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-139",
      Name: "Blackjack VZN 8",
    },
    {
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-140",
      Name: "Blackjack VZN 9",
    },
    {
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-141",
      Name: "Blackjack VZN 10",
    },
    {
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-142",
      Name: "Elite Roulette",
    },
    {
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-143",
      Name: "Quantum Baccarat Live",
    },
    {
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-144",
      Name: "Speed Baccarat 1",
    },
    {
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-145",
      Name: "Speed Baccarat 2",
    },
    {
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-146",
      Name: "Super Speed Baccarat",
    },
    {
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-147",
      Name: "Super Card Blackjack Live",
    },
    {
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-148",
      Name: "Lucky Tree Baccarat",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-001",
      Name: "Triple Monkey",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-002",
      Name: "Arowanas Luck",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-003",
      Name: "Buffalo Blitz",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-005",
      Name: "Long Long Long",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-006",
      Name: "Great Blue",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-007",
      Name: "Sky Queen",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-008",
      Name: "Blue Wizard",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-009",
      Name: "Golden Tour",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-010",
      Name: "Funky Monkey",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-011",
      Name: "Highway Kings",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-012",
      Name: "Zhao Cai Jin Bao",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-013",
      Name: "Jin Qian Wa",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-014",
      Name: "Zhao Cai Tong Zi",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-015",
      Name: "Ugga Bugga",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-016",
      Name: "Safari Heat",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-017",
      Name: "Buffalo Blitz II",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-018",
      Name: "Bonus Bears",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-019",
      Name: "Gem Queen",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-020",
      Name: "Feng Kuang Ma Jiang",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-021",
      Name: "Epic Ape",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-022",
      Name: "Ni Shu Shen Me",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-023",
      Name: "Chaoji 888",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-024",
      Name: "Vacation Station Deluxe",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-025",
      Name: "Eternal Lady",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-026",
      Name: "Golden Macaque",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-027",
      Name: "Fei Long Zai Tian",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-028",
      Name: "Yun Cong Long",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-029",
      Name: "Jinfu Long",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-030",
      Name: "Hot Gems",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-031",
      Name: "Lie Yan Zuan Shi",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-032",
      Name: "Dolphin Reef",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-033",
      Name: "Jinns Moon",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-034",
      Name: "Tiger, Turtle, Dragon, Phoenix",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-036",
      Name: "Heavenly Ruler",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-037",
      Name: "Ox Riches",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-038",
      Name: "Ice Cave",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-039",
      Name: "Queen of Wands",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-040",
      Name: "Si Xiang",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-041",
      Name: "Panther Moon",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-043",
      Name: "Asian Fantasy",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-044",
      Name: "Fortune Lions",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-045",
      Name: "Hot KTV",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-046",
      Name: "Fortune Day",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-047",
      Name: "Ri Ri Jin Cai",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-050",
      Name: "Jade Emperor Yu Huang Da Di",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-051",
      Name: "Halloween Fortune 2",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-052",
      Name: "The Riches of Don Quixote",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-054",
      Name: "Secrets of the Amazon",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-055",
      Name: "White King",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-056",
      Name: "Santa Surprise",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-057",
      Name: "Irish Luck",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-058",
      Name: "Cat Queen",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-059",
      Name: "A Night Out",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-060",
      Name: "Chinese Kitchen",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-061",
      Name: "Geisha Story",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-062",
      Name: "Fortunes of the Fox",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-063",
      Name: "Mr. Cashback",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-065",
      Name: "Miss Fortune",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-066",
      Name: "Desert Treasure",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-067",
      Name: "Easter Surprise",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-068",
      Name: "Lotto Madness",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-069",
      Name: "Atlantis Queen",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-070",
      Name: "Heart of the Frontier",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-071",
      Name: "Thai Paradise",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-072",
      Name: "Legacy of the Wild",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-073",
      Name: "Archer",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-074",
      Name: "Fire Blaze Quattro: Celtic Charm",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-076",
      Name: "Gold Hit: O'Reilly's Riches",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-077",
      Name: "Halloween Fortune",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-078",
      Name: "Magical Stacks",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-079",
      Name: "RomeandGlory",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-080",
      Name: "Plenty O'Fortune",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-081",
      Name: "Sinbad's Golden Voyage",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-082",
      Name: "Football Rules",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-086",
      Name: "Jurassic Island",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-087",
      Name: "Hit Bar",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-088",
      Name: "Diamond Rise",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-089",
      Name: "Fishin' Bonanza",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-090",
      Name: "Leprechaun's Luck: Cash Collect",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-091",
      Name: "Mega Fire Blaze: Wild Pistolero",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-092",
      Name: "Mega Fire Blaze: Big Circus!",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-093",
      Name: "Power Zones: Thunder Birds",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-094",
      Name: "Fire Blaze: Blue Wizard Megaways",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-095",
      Name: "Heroes Arrow",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-096",
      Name: "Jurassic Island 2",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-097",
      Name: "Atlantis Cash Collect",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-098",
      Name: "Glorious Guardians",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-099",
      Name: "Pyramid Valley: Power Zones",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-100",
      Name: "Chili Eruption Thundershots",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-101",
      Name: "Sahara Riches: Cash Collect",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-102",
      Name: "Mayan Blocks",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-103",
      Name: "Anaconda Uncoiled",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-104",
      Name: "Chilli Xtreme",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-105",
      Name: "Mighty Hat: Lamp of Gold",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-106",
      Name: "Koi Harmony",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-107",
      Name: "Silver Bullet Bandit: Cash Collect",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-108",
      Name: "Joker Rush",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-110",
      Name: "Monster Multipliers",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-113",
      Name: "Age of Egypt",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-114",
      Name: "Treasures of the Lamps",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-115",
      Name: "Luminous Life",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-116",
      Name: "Ways of the Phoenix",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-117",
      Name: "Tiger Claw",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-118",
      Name: "Vacation Station",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-119",
      Name: "Bermuda Triangle",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-120",
      Name: "Anaconda Wild",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-121",
      Name: "Penguin Vacation",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-122",
      Name: "Bai Shi",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-123",
      Name: "Wu Long",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-124",
      Name: "Crazy 7",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-125",
      Name: "White King II",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-126",
      Name: "Pharaoh's Secrets",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-128",
      Name: "Gem Heat",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-131",
      Name: "Jungle Giants",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-135",
      Name: "Silver Bullet",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-136",
      Name: "Dragon Champions",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-137",
      Name: "Neptune's Kingdom",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-138",
      Name: "Silent Samurai",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-139",
      Name: "True Love",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-140",
      Name: "Piggies and the Wolf",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-141",
      Name: "Haunted House",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-142",
      Name: "Gaelic Luck",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-150",
      Name: "Curse of Anubis",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-152",
      Name: "Monkey and Rat",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-153",
      Name: "Mega Fire Blaze: Khonsu God of Moon",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-154",
      Name: "Sorcerer's Guild of Magic",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-155",
      Name: "Absolutely Mammoth",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-156",
      Name: "Ishtar",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-157",
      Name: "Fire Blaze Golden: Tundra Wolf",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-158",
      Name: "Dragons Hall: Thundershots",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-159",
      Name: "Wild Linx",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-160",
      Name: "Full Moon: White Panda",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-162",
      Name: "Eye of Anubis",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-164",
      Name: "Zodiac Charms",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-165",
      Name: "Fire Blaze Golden: Buccaneer Bells",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-166",
      Name: "Gold Pile: Orangutan",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-167",
      Name: "Fire Blaze: Red Wizard",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-168",
      Name: "Fire Blaze: River Empress",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-169",
      Name: "Fire Blaze: Sisters Gift",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-170",
      Name: "Breakout Bob",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-171",
      Name: "Ways Boost: Hot Gems™ Xtreme",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-172",
      Name: "Jane Jones In Book Of King 2",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-173",
      Name: "Gold Pile: Tigers Pride",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-175",
      Name: "Record Riches",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-176",
      Name: "Lovefool",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-177",
      Name: "Toad's Gift",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-178",
      Name: "Pearls Pearls Pearls",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-179",
      Name: "Anaconda Wild II",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-180",
      Name: "Zhao Cai Jin Bao 2",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-181",
      Name: "Fire Blaze Golden: Amazing Factory",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-182",
      Name: "Bee Frenzy",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-183",
      Name: "Gold Pile: Toltec Treasure",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-184",
      Name: "Wild Lava",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-185",
      Name: "Gold Pile: New Years Gold",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-186",
      Name: "28 Mansions",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-187",
      Name: "Frog's Gift",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-188",
      Name: "Legacy of the Wilds 2",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-189",
      Name: "Caishen Ways",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-190",
      Name: "Golden Ways",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-191",
      Name: "Dragon Chi",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-192",
      Name: "Quest West",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-193",
      Name: "Legacy of the Tiger",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-194",
      Name: "Legend of Hydra",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-195",
      Name: "Dragon Spark",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-196",
      Name: "Better Wilds",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-197",
      Name: "Panda Luck",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-198",
      Name: "Adventure Trail",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-199",
      Name: "Blazing Bells",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-200",
      Name: "Stallion Strike",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-201",
      Name: "Wild West Wilds",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-202",
      Name: "Book of Kings",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-203",
      Name: "Midnight Wilds",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-204",
      Name: "Egyptian Emeralds",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-205",
      Name: "Dragon Bond",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-206",
      Name: "Fat Choy Choy Sun",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-207",
      Name: "Jinfu Xingyun",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-208",
      Name: "Tiger Stacks",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-209",
      Name: "Hainan Ice",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-210",
      Name: "Tsai Shen's Gift",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-212",
      Name: "Tip Top Totems",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-213",
      Name: "Pharaoh's Daughter",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-216",
      Name: "Lucky Emeralds",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-220",
      Name: "Savage Jungle",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-227",
      Name: "Starmada Exiles",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-228",
      Name: "Cascading Cave",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-230",
      Name: "Panther Pays",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-231",
      Name: "Retro Rush",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-232",
      Name: "Fire Blaze: Fire Fighter",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-233",
      Name: "Wushu Punch",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-234",
      Name: "Qin's Empire: Caishen's Temple",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-235",
      Name: "Sahara Riches MegaWays: Cash Collect",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-237",
      Name: "Yu Tu Jin Cai: Cash Collect",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-238",
      Name: "Football! Cash Collect",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-240",
      Name: "Pigeons from Space",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-241",
      Name: "Sakura Fortune",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-242",
      Name: "Wheels of Flame",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-243",
      Name: "Triple Stop: Mermaids Find",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-244",
      Name: "Mega Fire Blaze: Emperor of Rome",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-245",
      Name: "FIRE 4: Cash Collect Quattro",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-246",
      Name: "Wild Lava Scratch",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-247",
      Name: "Hot Gems Xtreme Scratch",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-248",
      Name: "Big Bad Wolf",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-249",
      Name: "Cash Truck",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-250",
      Name: "Wins of Fortune",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-251",
      Name: "Eastern Emeralds Megaways",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-252",
      Name: "Eastern Emeralds",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-253",
      Name: "Dragon Shrine",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-254",
      Name: "Sakura Fortune 2",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-255",
      Name: "Big Bad Wolf Megaways",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-256",
      Name: "Raven Rising",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-257",
      Name: "Hammer of Vulcan",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-258",
      Name: "Ready to Blow Thundershots",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-259",
      Name: "Gold Hit: Shrine of Anubis",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-260",
      Name: "Cash IT",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-261",
      Name: "Honey Gems",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-262",
      Name: "Devil Wilds",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-263",
      Name: "Grand Junction: Mountain Express",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-264",
      Name: "Fire Blaze: Toltec Blocks",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-267",
      Name: "Diamond Match",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-268",
      Name: "Gold Trio: Sinbad’s Riches",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-269",
      Name: "Joker Rush: Cash collect",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-270",
      Name: "Silent Samurai: Mega Cash Collect",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-271",
      Name: "Gold hit & link: J.P. Bacon & Co",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-318",
      Name: "Macabra Linx",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-319",
      Name: "Oink Oink Oink",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-320",
      Name: "Leprechaun's Luck - Cash Collect TM Megaways TM",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-321",
      Name: "Veils of Venice",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-323",
      Name: "Rich Roll: Lust for Gold!",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-324",
      Name: "Azteca: Cash Collect",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-325",
      Name: "Lockdown Loot",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-326",
      Name: "Rogues Draw",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-327",
      Name: "Gold Hit: Dragon Bonanza",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-328",
      Name: "Mega Fire Blaze: Piggies and the Bank",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-330",
      Name: "Alohawaii: Cash Collect",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-332",
      Name: "Divine 9",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-333",
      Name: "Lock & Hit: Red Knight",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-334",
      Name: "Hit Bar: Gold",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-336",
      Name: "Fire Blaze: Green Wizard",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-337",
      Name: "Witches: Cash Collect",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-343",
      Name: "Mega Fire Blaze: Dwarves and Goblins",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-344",
      Name: "Panther Moon: Bonus Lines",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-345",
      Name: "Fire Blaze: Sky Queen Megaways",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-346",
      Name: "Samurai Fury",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-347",
      Name: "Gold Trio",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-348",
      Name: "Feng Shui Flip",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-349",
      Name: "Elephant Riches",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-350",
      Name: "Wolves! Cash Collect & Link",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-351",
      Name: "Candy Roll",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-352",
      Name: "Circuit Shock",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-353",
      Name: "Xtreme Fire Blaze Roulette",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-354",
      Name: "Breach the Vault",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-355",
      Name: "Queen's Mystery",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-356",
      Name: "Sweet n' Juicy",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-357",
      Name: "Gold Hit & Link: Tiger Jones",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-358",
      Name: "Lucky Bass: Mega Cash Collect",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-359",
      Name: "Full Moon: White King",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-360",
      Name: "Diamond Match Deluxe",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-361",
      Name: "Lil Demon: Mega Cash Collect",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-407",
      Name: "Tree Wishes",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-408",
      Name: "Lights of Luck",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-409",
      Name: "Goood Heavens",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-410",
      Name: "Fluffy Favourites: Cash Collect",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-411",
      Name: "Streak of Luck: Double Dice",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-412",
      Name: "Piggies and the Bank: Cash Collect & Link",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-413",
      Name: "Lil Sphinx",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-414",
      Name: "Reaction Link",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-415",
      Name: "El Ranchero Cash Collect Diamond Path",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-416",
      Name: "Gold Trio: Leprechaun's Luck BF",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-417",
      Name: "Drop for Top",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-418",
      Name: "Pyramid Linx",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-419",
      Name: "Wild Roll",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-423",
      Name: "Ocean Frenzy",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-424",
      Name: "Mad Hit Diamonds",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-425",
      Name: "Blue Wizard: Cash Collect & Link",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-426",
      Name: "Adventures Beyond Wonderland Magical Maze",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-427",
      Name: "Stampede Rush Trident",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-428",
      Name: "Azticons Chaos Clusters",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-429",
      Name: "Betty Bonkers",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-430",
      Name: "Giga Match Bunny",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-431",
      Name: "Beastwood",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-432",
      Name: "J Mania Loco Habanero",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-433",
      Name: "Piggy Mania",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-434",
      Name: "Sticky Bandits Thunder Rail",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-435",
      Name: "Immortal Ways Gallina Harvest",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-436",
      Name: "Buffalo Blitz Cash Collect",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-437",
      Name: "J Mania 3 Buffalo",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-438",
      Name: "Lil Demo Double Heat",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-439",
      Name: "Mega Fire Blaze Lucky Bass",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-440",
      Name: "Oink Oink Oink Pharaohs",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-441",
      Name: "Shields of Lambda",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-442",
      Name: "Gold Trio: Lil Demon",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-443",
      Name: "Joker Spin & Roll",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-444",
      Name: "Cash Truck Begins",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-445",
      Name: "Ten Ton Ways Stampede",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-446",
      Name: "Immortal Ways Volcano",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-447",
      Name: "Giga Match Egypt",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-448",
      Name: "Flip Royale",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-449",
      Name: "Bubblegum Burst",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-450",
      Name: "20 Stars Ablaze",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-453",
      Name: "Sahara Riches: Cash Collect Max",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-454",
      Name: "The Racaroon",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-455",
      Name: "Mine & Melt",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-456",
      Name: "Mad Hit Jokester",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-457",
      Name: "Wizzy Trix",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-458",
      Name: "Mad Hit Gorillatron",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-459",
      Name: "Giga Match Gems",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-460",
      Name: "Primal Spirits",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-461",
      Name: "Mystic Mines",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-462",
      Name: "Spinions Game Day",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-463",
      Name: "Scatter Monsters",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-464",
      Name: "J Mania Hot Asses",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-465",
      Name: "Go High Safari",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-466",
      Name: "Giga Match Moolah",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-467",
      Name: "Toucan Mania",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-468",
      Name: "Blackbeard’s Hoard Cash Sacks",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-469",
      Name: "Ka Ching Boom",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-470",
      Name: "Fire Blaze: White Witch",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-471",
      Name: "4 Crazy Cluckers",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-472",
      Name: "King of Giza: Mega Cash Collect & Link",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-473",
      Name: "J Mania Maniac",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-474",
      Name: "Giga Match Phantasmal",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-475",
      Name: "J Mania Lucky Pyggs",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-476",
      Name: "Mad Hit Devil",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-477",
      Name: "Epic Fish: Marlin Madness",
    },
    {
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-478",
      Name: "Jo Blitz",
    },
  ],
  SPRIBE: [
    {
      platFormCode: "SPRIBE",
      gameType: "EGAME",
      casinoType: "SPRIBE-EGAME-001",
      Name: "Aviator",
    },
    {
      platFormCode: "SPRIBE",
      gameType: "EGAME",
      casinoType: "SPRIBE-EGAME-002",
      Name: "Goal",
    },
    {
      platFormCode: "SPRIBE",
      gameType: "EGAME",
      casinoType: "SPRIBE-EGAME-003",
      Name: "Dice",
    },
    {
      platFormCode: "SPRIBE",
      gameType: "EGAME",
      casinoType: "SPRIBE-EGAME-004",
      Name: "Plinko",
    },
    {
      platFormCode: "SPRIBE",
      gameType: "EGAME",
      casinoType: "SPRIBE-EGAME-005",
      Name: "Mines",
    },
    {
      platFormCode: "SPRIBE",
      gameType: "EGAME",
      casinoType: "SPRIBE-EGAME-006",
      Name: "Hilo",
    },
    {
      platFormCode: "SPRIBE",
      gameType: "EGAME",
      casinoType: "SPRIBE-EGAME-007",
      Name: "Keno",
    },
    {
      platFormCode: "SPRIBE",
      gameType: "EGAME",
      casinoType: "SPRIBE-EGAME-008",
      Name: "Mini Roulette",
    },
    {
      platFormCode: "SPRIBE",
      gameType: "EGAME",
      casinoType: "SPRIBE-EGAME-009",
      Name: "Hotline",
    },
  ],
  SPADE: [
    {
      platFormCode: "SPADE",
      gameType: "EGAME",
      casinoType: "SG-EGAME-003",
      Name: "Space Crasher",
    },
    {
      platFormCode: "SPADE",
      gameType: "FH",
      casinoType: "SG-FISH-001",
      Name: "Fishing God",
    },
    {
      platFormCode: "SPADE",
      gameType: "FH",
      casinoType: "SG-FISH-002",
      Name: "Fishing War",
    },
    {
      platFormCode: "SPADE",
      gameType: "FH",
      casinoType: "SG-FISH-003",
      Name: "Alien Hunter",
    },
    {
      platFormCode: "SPADE",
      gameType: "FH",
      casinoType: "SG-FISH-004",
      Name: "Zombie Party",
    },
    {
      platFormCode: "SPADE",
      gameType: "FH",
      casinoType: "SG-FISH-005",
      Name: "Fishing Legend",
    },
    {
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-001",
      Name: "Candy Pop",
    },
    {
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-003",
      Name: "FaFaFa2",
    },
    {
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-005",
      Name: "PrincessWang",
    },
    {
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-006",
      Name: "WowProsperity",
    },
    {
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-008",
      Name: "FirstLove",
    },
    {
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-009",
      Name: "GoldenMonkey",
    },
    {
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-012",
      Name: "JungleKing",
    },
    {
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-014",
      Name: "TigerWarrior",
    },
    {
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-016",
      Name: "ZEUS",
    },
    {
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-017",
      Name: "Ho Yeah Monkey",
    },
    {
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-018",
      Name: "Golden Chicken",
    },
    {
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-019",
      Name: "Dragon Gold SA",
    },
    {
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-021",
      Name: "Big Prosperity SA",
    },
    {
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-022",
      Name: "Great Stars SA",
    },
    {
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-023",
      Name: "Iceland SA",
    },
    {
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-030",
      Name: "5 Fortune SA",
    },
    {
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-031",
      Name: "Baby Cai Shen",
    },
    {
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-032",
      Name: "Golden Lotus SE",
    },
    {
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-034",
      Name: "King Pharaoh",
    },
    {
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-037",
      Name: "Cai Shen 888",
    },
    {
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-038",
      Name: "Double Fortunes",
    },
    {
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-039",
      Name: "5 Fortune Dragons",
    },
    {
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-041",
      Name: "LuckyKoi",
    },
    {
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-045",
      Name: "Fafafa",
    },
    {
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-046",
      Name: "Lucky Feng Shui",
    },
    {
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-049",
      Name: "Highway Fortune",
    },
    {
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-055",
      Name: "Da Fu Xiao Fu",
    },
    {
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-058",
      Name: "Golden Whale",
    },
    {
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-060",
      Name: "LuckyMeow",
    },
    {
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-068",
      Name: "HeroesGame",
    },
    {
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-069",
      Name: "888",
    },
    {
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-070",
      Name: "DancingFever",
    },
    {
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-071",
      Name: "MoneyMouse",
    },
    {
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-072",
      Name: "SweetBakery",
    },
    {
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-073",
      Name: "ThreeLuckyStars",
    },
    {
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-074",
      Name: "Mega7",
    },
    {
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-075",
      Name: "JokersTreasure",
    },
    {
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-076",
      Name: "DoubleFlame",
    },
    {
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-077",
      Name: "BookofMyth",
    },
    {
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-078",
      Name: "CrazyBomber",
    },
    {
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-079",
      Name: "FierySevens",
    },
    {
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-080",
      Name: "MagicalLamp",
    },
    {
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-081",
      Name: "TriplePanda",
    },
    {
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-082",
      Name: "GoldPanther",
    },
    {
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-083",
      Name: "MrChuTycoon",
    },
    {
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-084",
      Name: "BrothersKingdom",
    },
    {
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-085",
      Name: "ProsperityGods",
    },
    {
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-086",
      Name: "Mayan Gems",
    },
    {
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-087",
      Name: "Rise Of Werewolves",
    },
    {
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-089",
      Name: "Hugon Quest",
    },
    {
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-091",
      Name: "Magic Kitty",
    },
    {
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-092",
      Name: "Sugar Bonanza",
    },
    {
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-093",
      Name: "Love Idol",
    },
    {
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-095",
      Name: "Poker Ways",
    },
    {
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-096",
      Name: "Rich Caishen",
    },
    {
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-097",
      Name: "Muay Thai Fighter",
    },
    {
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-098",
      Name: "Royal Katt",
    },
    {
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-099",
      Name: "Wild Wet Win",
    },
    {
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-100",
      Name: "Gold Rush Cowboy",
    },
    {
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-101",
      Name: "Candy Candy",
    },
    {
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-102",
      Name: "Roma",
    },
    {
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-103",
      Name: "Sexy Vegas",
    },
    {
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-104",
      Name: "Tiger Dance",
    },
    {
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-105",
      Name: "Royale House",
    },
    {
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-106",
      Name: "Fiery Sevens Exclusive",
    },
    {
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-107",
      Name: "Lucky Koi Exclusive",
    },
    {
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-108",
      Name: "Joker's Treasure Exclusive",
    },
    {
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-109",
      Name: "Caishen",
    },
    {
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-110",
      Name: "Space Conquest",
    },
    {
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-111",
      Name: "Gold Panther Maxways",
    },
    {
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-112",
      Name: "Fruits Mania",
    },
    {
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-113",
      Name: "Journey to the Wild",
    },
    {
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-114",
      Name: "Captain Golds Fortune",
    },
    {
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-115",
      Name: "Sugar Party",
    },
    {
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-116",
      Name: "Legacy Of Kong Maxways",
    },
    {
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-117",
      Name: "Halloween Vacation",
    },
    {
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-119",
      Name: "Christmas Miracles",
    },
    {
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-120",
      Name: "Rabbit Riches",
    },
    {
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-121",
      Name: "CAISHEN DELUXE MAXWAYS",
    },
    {
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-122",
      Name: "Farmland Frenzy Maxways",
    },
    {
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-123",
      Name: "Candy Pop 2",
    },
    {
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-124",
      Name: "Hammer of Thunder",
    },
    {
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-126",
      Name: "Gemstone Rush",
    },
    {
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-127",
      Name: "Moji Mania",
    },
    {
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-139",
      Name: "Clash of the Giants",
    },
    {
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-140",
      Name: "Royale Vegas",
    },
    {
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-141",
      Name: "Dragon Wish",
    },
    {
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-142",
      Name: "Galaxy Guardian",
    },
    {
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-143",
      Name: "Brothers Kingdom 2",
    },
    {
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-144",
      Name: "Secrets of Anubis",
    },
    {
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-145",
      Name: "Alchemy Quest Level Up",
    },
    {
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-146",
      Name: " Fury Max Lucky Road",
    },
    {
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-147",
      Name: "Lucky Twin Sea",
    },
    {
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-148",
      Name: "Gold West",
    },
    {
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-149",
      Name: "Happy Neko",
    },
    {
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-150",
      Name: "Fruit Ninja Fury",
    },
    {
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-151",
      Name: "Santa Wild Drop",
    },
    {
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-152",
      Name: "Lucky Snake Wheel",
    },
    {
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-153",
      Name: "Fiery Sevens Hot 5",
    },
    {
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-154",
      Name: "Fiery Sevens Hot 20",
    },
    {
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-155",
      Name: "Fiery Sevens Hot 50",
    },
    {
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-156",
      Name: "Fiery Sevens Hot 100",
    },
    {
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-157",
      Name: "Mahjong Riches",
    },
    {
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-158",
      Name: "Golden Pixiu",
    },
    {
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-159",
      Name: "Juicy Market",
    },
    {
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-160",
      Name: "Legacy of Ramakien",
    },
    {
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-161",
      Name: "Pirates Gold Rush",
    },
    {
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-162",
      Name: "Mister Cashmore",
    },
    {
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-163",
      Name: "Hallo Win Party",
    },
    {
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-164",
      Name: "Ping Pong Panda",
    },
  ],
  RT: [
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-001",
      Name: "Ancient Script",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-002",
      Name: "Arcade Bomb",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-003",
      Name: "Blue Diamond",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-004",
      Name: "Chinese Treasures",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-005",
      Name: "Cinderella's Ball",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-006",
      Name: "Crazy Genie",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-007",
      Name: "Devil's Number",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-008",
      Name: "Divine Ways",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-009",
      Name: "Dragon's Fire",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-010",
      Name: "Dragon's Luck",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-011",
      Name: "Dragon's Luck Power Reels",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-012",
      Name: "Elven Magic",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-013",
      Name: "Emerald Diamond",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-014",
      Name: "Epic Journey",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-015",
      Name: "Esqueleto Mariachi",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-016",
      Name: "Five Star",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-017",
      Name: "Five Star Power Reels",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-018",
      Name: "Flaming Fox",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-019",
      Name: "Fortune Charm",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-020",
      Name: "Fortune Fest",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-021",
      Name: "Fortune House",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-022",
      Name: "Fruit Blox",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-023",
      Name: "Gems Gone Wild",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-024",
      Name: "Gemtastic",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-025",
      Name: "God Of Wealth",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-026",
      Name: "Gold Star",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-027",
      Name: "Golden Lotus",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-028",
      Name: "Golden Offer",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-029",
      Name: "Grand Wheel",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-030",
      Name: "Imperial Palace",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-031",
      Name: "Jack In A Pot",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-032",
      Name: "Jackpot Quest",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-033",
      Name: "Jade Charms",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-034",
      Name: "Jester Spins",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-035",
      Name: "Jingle Bells",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-036",
      Name: "Laser Fruit",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-037",
      Name: "Lion Dance",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-038",
      Name: "Lucky Easter",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-039",
      Name: "Lucky Fortune Cat",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-040",
      Name: "Lucky Halloween",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-041",
      Name: "Lucky Valentine",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-042",
      Name: "Lucky Wizard",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-043",
      Name: "Magic Gate",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-044",
      Name: "Masquerade",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-045",
      Name: "Mayan Gods",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-046",
      Name: "Mega Jade",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-047",
      Name: "Mega Pyramid",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-048",
      Name: "Mega Rise",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-049",
      Name: "Midas Gold",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-050",
      Name: "Mystery Reels",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-051",
      Name: "Mystery Reels MegaWays",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-052",
      Name: "Mystic Wheel",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-053",
      Name: "Ninja Ways",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-054",
      Name: "Ocean Fortune",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-055",
      Name: "Persian Fortune",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-056",
      Name: "Phoenix Fire Power Reels",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-057",
      Name: "Piggy Pirates",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-058",
      Name: "Pirates Plenty MegaWays",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-059",
      Name: "Puss'n Boots",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-060",
      Name: "Rainbow Jackpots",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-061",
      Name: "Ra's Legend",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-062",
      Name: "Reactor",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-063",
      Name: "Red Diamond",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-064",
      Name: "Phoenix",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-065",
      Name: "Reel Heist",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-066",
      Name: "Rocket Men",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-067",
      Name: "Royal Gems",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-068",
      Name: "Snow Wild And The 7 Features",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-069",
      Name: "Spin Town",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-070",
      Name: "Stage 888",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-071",
      Name: "Sumo Spins",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-072",
      Name: "Golden Temple",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-073",
      Name: "Ten Elements",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-074",
      Name: "The Equalizer",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-075",
      Name: "The Greatest Train Robbery",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-076",
      Name: "Thor's Lightning",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-077",
      Name: "Three Musketeers",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-078",
      Name: "Tiki Fruits",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-079",
      Name: "Totem Lightning",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-080",
      Name: "Totem Lightning Power Reels",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-081",
      Name: "Treasure Mine",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-082",
      Name: "Vicky Ventura",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-083",
      Name: "Wild Circus",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-084",
      Name: "Wild Fight",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-085",
      Name: "Wild Nords",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-086",
      Name: "Wild Spartans",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-087",
      Name: "Wild Wild Chest",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-088",
      Name: "Winter Wonders",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-089",
      Name: "Aztec Spins",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-090",
      Name: "Cash Volt",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-091",
      Name: "Dragon's Fire MegaWays",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-092",
      Name: "Dragon's Luck MegaWays",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-093",
      Name: "Dynamite Riches",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-094",
      Name: "Fruit Snap",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-095",
      Name: "Golden Cryptex",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-096",
      Name: "Leprechaun's Magic",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-097",
      Name: "Pirates' Plenty Battle for Gold",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-098",
      Name: "Rainbow Jackpots Power Lines",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-099",
      Name: "Rio Stars",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-100",
      Name: "Vault Of Anubis",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-101",
      Name: "Wild Cats Multiline",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-102",
      Name: "Zillard King",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-103",
      Name: "777 Strike",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-104",
      Name: "Aurum Codex",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-105",
      Name: "Gods of Troy",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-106",
      Name: "Santa Spins",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-107",
      Name: "10001 Nights",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-108",
      Name: "Ancients Blessing",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-109",
      Name: "10,001 Nights MegaWays",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-110",
      Name: "Zeus' Lightning Power Reels",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-111",
      Name: "4 Squad",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-112",
      Name: "Agent Royale",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-113",
      Name: "Atlantis",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-114",
      Name: "24 Hour Grand Prix",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-115",
      Name: "5 Families",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-116",
      Name: "Dragon's Luck Deluxe",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-117",
      Name: "Dragons Clusterbuster",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-118",
      Name: "Mega Dragon",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-119",
      Name: "Dragon's Fire INFINIREELS",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-120",
      Name: "Dragon King: Legend of the Seas",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-121",
      Name: "Dragon Pearl",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-122",
      Name: "Legend Of Athena",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-123",
      Name: "Cash Ultimate",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-124",
      Name: "Bounty Raid",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-125",
      Name: "Path of Destiny",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-126",
      Name: "Multiplier Riches",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-127",
      Name: "Dice Dice Dice",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-128",
      Name: "Shah Mat",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-129",
      Name: "Cake and Ice Cream",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-130",
      Name: "Reel King Mega",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-131",
      Name: "Age Of Akkadia",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-132",
      Name: "Viral Spiral",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-133",
      Name: "Diamond Blitz",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-134",
      Name: "Crystal Mirror",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-135",
      Name: "Mystic Staxx",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-136",
      Name: "Hammer Gods",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-137",
      Name: "Peggy Sweets",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-138",
      Name: "Regal Streak",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-139",
      Name: "Tricks and Treats",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-140",
      Name: "Pirates' Plenty",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-141",
      Name: "Wings Of Ra",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-142",
      Name: "Betty, Boris and Boo",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-143",
      Name: "Bombuster",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-144",
      Name: "Cirque Dе La Fortune",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-145",
      Name: "Clash of the Beasts",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-146",
      Name: "Da Vinci's Mystery",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-147",
      Name: "Eagle Riches",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-148",
      Name: "Gems Gone Wild Power Reels",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-149",
      Name: "Golden Leprechaun MegaWays",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-150",
      Name: "Golden Tsar",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-151",
      Name: "Gonzo's Quest™ MegaWays",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-152",
      Name: "Hoard of Poseidon",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-153",
      Name: "Jewel Scarabs",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-154",
      Name: "Jingle Bells Power Reels",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-155",
      Name: "Legendary Excalibur",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-156",
      Name: "Lucky Fridays",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-157",
      Name: "Lucky Oktoberfest",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-158",
      Name: "Mystery Reels Power Reels",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-159",
      Name: "Piggy Riches™ MegaWays",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-160",
      Name: "Reel Keeper",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-161",
      Name: "Regal Beasts",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-162",
      Name: "Riddle Of The Sphinx",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-163",
      Name: "Sylvan Spirits",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-164",
      Name: "The Wild Hatter",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-165",
      Name: "Thor's Vengeance",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-166",
      Name: "Trillionaire",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-167",
      Name: "Vault Cracker",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-168",
      Name: "War of Gods",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-169",
      Name: "Well Of Wishes",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-170",
      Name: "Yucatan's Mystery",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-171",
      Name: "Jingle Ways Megaways",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-172",
      Name: "Blazing Clusters",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-173",
      Name: "Hustling",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-174",
      Name: "Get the Gold INFINIREELS",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-175",
      Name: "Fa Fa Babies",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-176",
      Name: "Last Chance Saloon",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-177",
      Name: "Doggy Riches Megaways",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-178",
      Name: "Genie Nights",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-179",
      Name: "Cash or Nothing",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-180",
      Name: "Bulls Run Wild",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-181",
      Name: "Mayhem",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-182",
      Name: "Big Cat Rescue Megaways",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-183",
      Name: "Diamond Royale",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-184",
      Name: "Flodder",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-185",
      Name: "Risque Megaways",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-186",
      Name: "Zaida's Fortune",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-187",
      Name: "Apache Way",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-188",
      Name: "Majestic Mysteries Power Reels",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-189",
      Name: "Wild Tundra",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-190",
      Name: "Bass Boss",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-191",
      Name: "Rock'n'Lock",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-192",
      Name: "Gonzita's Quest",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-193",
      Name: "Great Gold",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-194",
      Name: "Mystery Reels Deluxe",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-195",
      Name: "Win Escalator",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-196",
      Name: "Lucky Little Devil",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-197",
      Name: "Three Kingdoms",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-198",
      Name: "Wild Elements",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-199",
      Name: "Wild O'Clock",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-200",
      Name: "Harle Coin",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-201",
      Name: "Joe Exotic",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-202",
      Name: "Night Roller",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-203",
      Name: "Primate King",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-204",
      Name: "Reptizillions Power Reels",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-205",
      Name: "Tiki Fruits Totem Frenzy",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-206",
      Name: "What The Fox MegaWays",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-207",
      Name: "Neon Links",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-208",
      Name: "Wild Hot Chilli Reels",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-209",
      Name: "The Wisecracker Lightning",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-210",
      Name: "Treasure Mine Power Reels",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-211",
      Name: "NFT Megaways",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-212",
      Name: "Dynamite Riches MW + PowerWheel",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-213",
      Name: "Forever 7's",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-214",
      Name: "Well of Wilds MegaWays + PowerWheel",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-215",
      Name: "Lion's Hoard",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-216",
      Name: "Fortune House Power Reels",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-217",
      Name: "Beriched",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-218",
      Name: "Wild Expedition",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-219",
      Name: "Hot Hot Chilli Pot",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-220",
      Name: "Dracula Awakening",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-221",
      Name: "1942: Sky Warrior",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-222",
      Name: "Narcos Mexico",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-223",
      Name: "Robin Hood's Wild Forest",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-224",
      Name: "Stolen Treasures",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-225",
      Name: "Shadow Society",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-226",
      Name: "Athens MegaWays",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-227",
      Name: "In the Rabbit Hole",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-228",
      Name: "Good Luck Clusterbuster",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-229",
      Name: "Pinatas & Ponies",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-230",
      Name: "Cai Shen 168",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-231",
      Name: "Blood Suckers™ Megaways",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-232",
      Name: "Ancient Disco",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-233",
      Name: "Blobsters ClusterBuster",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-234",
      Name: "Buffalo Mania MegaWays",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-235",
      Name: "Bugsy’s Bar",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-236",
      Name: "Happy Apples",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-237",
      Name: "Transylvanian: Night of Blood",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-238",
      Name: "Wrigley's World",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-239",
      Name: "Sheep Gone Wild",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-240",
      Name: "Reel Keeper Power Reels",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-241",
      Name: "Red Hot BBQ",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-242",
      Name: "Magic Powers Megaways",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-243",
      Name: "Knights Of Avalon",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-244",
      Name: "Wolfkin",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-245",
      Name: "Alexander The Great World Conqueror",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-246",
      Name: "Jelly Multihops",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-247",
      Name: "Ali Baba's Luck",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-248",
      Name: "Steam Squad",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-249",
      Name: "Giga Blast",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-250",
      Name: "Christmas Morning",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-251",
      Name: "Christmas MULTIHOPS",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-252",
      Name: "Sea Boat Adventure",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-253",
      Name: "Astronaut",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-254",
      Name: "Bounty Raid 2",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-255",
      Name: "Case Closed",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-256",
      Name: "Cyber Attack",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-257",
      Name: "Desert Legends",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-258",
      Name: "Easy Gold",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-259",
      Name: "Egypt Megaways",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-260",
      Name: "Gems Inferno Megaways",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-261",
      Name: "Goddess of the Moon MegaWays",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-262",
      Name: "Here Kitty Kitty",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-263",
      Name: "Judgement Day Megaways",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-264",
      Name: "London Tube",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-265",
      Name: "Magic Tricks",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-266",
      Name: "Monsters Unchained",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-267",
      Name: "Sugar Monster",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-268",
      Name: "Sugarlicious EveryWay",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-269",
      Name: "Year-Round Riches Clusterbuster",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-270",
      Name: "Hansel & Gretel Candyhouse",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-271",
      Name: "Siren's Riches",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-272",
      Name: "Spooky Carnival",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-273",
      Name: "Dragon's Mirror",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-274",
      Name: "Vault Cracker MegaWays",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-275",
      Name: "Casino Spin",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-276",
      Name: "Cobra Queen",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-277",
      Name: "Cotton Gang Affair",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-278",
      Name: "Dream Destiny",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-279",
      Name: "Epic Treasure",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-280",
      Name: "Wanted Wildz",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-281",
      Name: "Astros",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-282",
      Name: "Play with the Devil",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-283",
      Name: "Sakura Masks",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-284",
      Name: "The Wild Kiss",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-285",
      Name: "Redline Rush",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-286",
      Name: "777 Super Strike",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-287",
      Name: "Clover Craze",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-288",
      Name: "Midnight Romance",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-289",
      Name: "Gold Mine Mistress",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-290",
      Name: "80s Spins",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-291",
      Name: "Ali Baba's Luck Megaways",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-292",
      Name: "Ali Baba's Luck Power Reels",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-293",
      Name: "Amazon Island Megaways",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-294",
      Name: "Asian Fortune",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-295",
      Name: "Chinese Wilds",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-296",
      Name: "Dont Hit Plz",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-297",
      Name: "DrFrancashstein",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-298",
      Name: "Elephant Treasure",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-299",
      Name: "Fishtastic",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-300",
      Name: "Golden Lamps",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-301",
      Name: "Golden Toad",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-302",
      Name: "Leprechauns Magic Megaways",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-303",
      Name: "Leprechauns Magic Power Reels",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-304",
      Name: "Lucky Carnival",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-305",
      Name: "Macau Racing",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-306",
      Name: "Midnight Thirst",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-307",
      Name: "Nightmare Family Megaways",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-308",
      Name: "Primate King MegaWays",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-309",
      Name: "Red Hot Slot",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-310",
      Name: "Wanted Wildz Extreme",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-311",
      Name: "Viking's Legacy EveryWay",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-312",
      Name: "Fruit Flash",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-313",
      Name: "Rainbow Jackpots MegaWays",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-314",
      Name: "Cannonball Cash",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-315",
      Name: "Emperor of India",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-316",
      Name: "Piggy Riches 2™ MegaWays",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-317",
      Name: "Purr Power",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-318",
      Name: "Sword Stomp",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-319",
      Name: "Epic Treasure 2",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-320",
      Name: "Ultra Rich",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-321",
      Name: "Buffalo Collector",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-322",
      Name: "Fa Fa Babies 2",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-323",
      Name: "Diamond Blitz 2",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-324",
      Name: "Glow Dig",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-325",
      Name: "Turtle Paradise",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-326",
      Name: "Roman Emperors",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-327",
      Name: "Egypt Clusterbuster",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-328",
      Name: "Savannah Pride",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-329",
      Name: "Los Muertos Locos",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-330",
      Name: "Moon Spell ",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-331",
      Name: "The Good, The Bad and The Rich",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-332",
      Name: "Diamond Doggies",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-333",
      Name: "Sea Boat Adventure MegaWays",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-334",
      Name: "Zeus Lightning MegaWays",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-335",
      Name: "Wings of Ra Megaways",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-336",
      Name: "Dear Santa",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-337",
      Name: "7's Luck",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-338",
      Name: "Dragons’ Lock",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-339",
      Name: "Cash Explorer",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-340",
      Name: "Wild Touchdown Megaways",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-341",
      Name: "Trick of the Dead Wild Candies Megaways",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-342",
      Name: "Wild Hot Chilli Reels 2",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-343",
      Name: "Trophy Fish",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-344",
      Name: "Wolf Stacks MegaWays",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-345",
      Name: "Trillionaire MegaWays",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-346",
      Name: "Diamonds Up",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-347",
      Name: "Legends of Forbidden Love Megaways",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-348",
      Name: "Serpent King",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-349",
      Name: "Gods of Troy MegaWays",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-350",
      Name: "Bass Boss MegaWays",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-351",
      Name: "Rise of Cleopatra",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-352",
      Name: "777 Diamond Strike",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-353",
      Name: "Cash Goddess",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-354",
      Name: "Miami Rise",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-355",
      Name: "Zillard King MegaWays",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-356",
      Name: "Jackrabbit Jackpots",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-357",
      Name: "Farmtastic",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-358",
      Name: "Big Gains",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-359",
      Name: "Gladiator Ways",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-360",
      Name: "Thor's Rage",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-361",
      Name: "Aztec Shamans MegaWays",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-362",
      Name: "Play With the Devil MegaWays",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-363",
      Name: "Fish N Fish",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-364",
      Name: "Lava Joker",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-365",
      Name: "Take the Money",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-366",
      Name: "Cash Lamps",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-367",
      Name: "Book Of Desert Legends",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-368",
      Name: "Land of Riches",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-369",
      Name: "Arc Of Zeus",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-370",
      Name: "Spartan Wildz",
    },
    {
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-371",
      Name: "Bloody Murder",
    },
    {
      platFormCode: "RT",
      gameType: "TABLE",
      casinoType: "RT-TABLE-001",
      Name: "Punto Banco",
    },
    {
      platFormCode: "RT",
      gameType: "TABLE",
      casinoType: "RT-TABLE-002",
      Name: "European Roulette",
    },
    {
      platFormCode: "RT",
      gameType: "TABLE",
      casinoType: "RT-TABLE-003",
      Name: "Classic Blackjack",
    },
  ],
  RELAX: [
    {
      platFormCode: "RELAX",
      gameType: "EGAME",
      casinoType: "RELAX-EGAME-001",
      Name: "1000x Busta",
    },
    {
      platFormCode: "RELAX",
      gameType: "EGAME",
      casinoType: "RELAX-EGAME-002",
      Name: "100 Bit Dice",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-001",
      Name: "6 Wild Sharks",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-002",
      Name: "123 Boom!",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-020",
      Name: "Hypernova Megaways",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-021",
      Name: "Joker Super Reels",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-022",
      Name: "Caveman Bob",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-023",
      Name: "Dragons Awakening",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-024",
      Name: "Emerald's Infinity Reels",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-025",
      Name: "Epic Joker",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-026",
      Name: "Erik the Red",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-027",
      Name: "Frequent Flyer",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-028",
      Name: "Hellcatraz",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-029",
      Name: "Heroes' Gathering",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-030",
      Name: "Ignite The Night",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-031",
      Name: "Iron Bank",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-032",
      Name: "King of Kings",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-033",
      Name: "Kluster Krystals Megaclusters",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-034",
      Name: "La Fiesta",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-035",
      Name: "Let's get ready to Rumble",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-036",
      Name: "Marching Legions",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-037",
      Name: "Mega Flip",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-038",
      Name: "Mega Masks",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-039",
      Name: "Money Train",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-040",
      Name: "Money Train 2",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-041",
      Name: "Multiplier Odyssey",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-042",
      Name: "Powerspin",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-043",
      Name: "Ramses Revenge",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-044",
      Name: "Snake Arena",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-045",
      Name: "Templar Tumble",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-046",
      Name: "Temple Tumble",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-047",
      Name: "The Great Pigsby",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-048",
      Name: "TNT Tumble",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-049",
      Name: "Tower Tumble",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-050",
      Name: "Wildchemy",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-051",
      Name: "Zombie Circus",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-052",
      Name: "Book of 99",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-053",
      Name: "Sails of Fortune",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-054",
      Name: "Wild Chapo",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-055",
      Name: "Top Dawg$",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-056",
      Name: "Spirit of The Beast",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-057",
      Name: "Chip Spin",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-059",
      Name: "3 Secret Cities",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-060",
      Name: "Money Cart 2",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-061",
      Name: "Deep Descent",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-062",
      Name: "Troll's Gold",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-065",
      Name: "Dead Man's Trail",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-066",
      Name: "Volatile Vikings",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-067",
      Name: "Helios Fury",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-068",
      Name: "Mega Mine",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-070",
      Name: "Joker Jackpot",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-071",
      Name: "Super Boost",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-072",
      Name: "Sherlock Bones",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-073",
      Name: "Desert Shark",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-075",
      Name: "Twisted Turbine",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-076",
      Name: "Serpent Shrine",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-077",
      Name: "Maze Escape",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-078",
      Name: "Elemento",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-079",
      Name: "Golden Castle",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-080",
      Name: "Hades River of Souls",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-081",
      Name: "Bounty Showdown",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-082",
      Name: "Heroes Hunt 2",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-083",
      Name: "Fruit Strike",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-084",
      Name: "Splendour Forest",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-085",
      Name: "Christmas Santa",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-086",
      Name: "Book of Destiny",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-087",
      Name: "Crystal Golem",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-091",
      Name: "10,000 Wonders",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-092",
      Name: "Atlantis Megaways",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-093",
      Name: "Big Bucks Bandits Megaways",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-094",
      Name: "Cluster Tumble",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-095",
      Name: "Santa's Stack",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-096",
      Name: "Thor Infinity Reels",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-097",
      Name: "Golden Gods",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-098",
      Name: "Money Cart",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-099",
      Name: "Royal Potato",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-100",
      Name: "Plunderland",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-101",
      Name: "Medallion Megaways",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-102",
      Name: "Star Pops",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-103",
      Name: "Hazakura Ways",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-104",
      Name: "Arto And The Seven Deadly Spins",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-105",
      Name: "Space Miners",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-106",
      Name: "Beast Mode",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-107",
      Name: "Tiger Kingdom Infinity Reels",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-108",
      Name: "Caravan of Riches",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-111",
      Name: "HEX",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-112",
      Name: "Wild Esqueleto Lightning Chase",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-113",
      Name: "98 Bounty Hot 1",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-114",
      Name: "Alice in Adventureland",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-115",
      Name: "7 Elements",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-116",
      Name: "Jurassic Party",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-117",
      Name: "Magikspell",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-118",
      Name: "Megaways Mob",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-119",
      Name: "Alchemy",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-120",
      Name: "Out of The Ice",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-121",
      Name: "Temple Tumble 2",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-122",
      Name: "Midnight Marauder",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-124",
      Name: "Clover Fortunes",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-125",
      Name: "Curse of the Mummies",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-126",
      Name: "Blender Blitz",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-127",
      Name: "Flower Fortune Supreme",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-128",
      Name: "Banana Town",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-130",
      Name: "4 Secret Pyramids",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-132",
      Name: "Shamrock Money Pot 10K Ways",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-133",
      Name: "Lucky Money",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-134",
      Name: "Dead Riders Trail",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-135",
      Name: "Animal Carnival",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-136",
      Name: "Wild Buccaneers Megaways",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-137",
      Name: "Money Train 3",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-138",
      Name: "4 Deals With The Devil",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-140",
      Name: "Wild Donuts",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-141",
      Name: "Diamonds",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-143",
      Name: "Volatile Vikings 2",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-144",
      Name: "Huntress: Wild Vengeance",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-145",
      Name: "The Great Pigsby Megaways",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-148",
      Name: "Templar Tumble 2",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-149",
      Name: "9K Kong in Vegas",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-150",
      Name: "Hot Rod Racers",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-151",
      Name: "Wild Yield",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-152",
      Name: "Wins of Winter",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-154",
      Name: "Reapers",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-155",
      Name: "Napoleon vs Rabbits",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-156",
      Name: "Net Gains",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-157",
      Name: "Pine of Plinko",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-159",
      Name: "Book of Power",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-160",
      Name: "Grim The Splitter",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-161",
      Name: "Horror Hotel",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-162",
      Name: "Volatile Egypt",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-164",
      Name: "Wild Hike",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-165",
      Name: "Wild Chapo 2",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-166",
      Name: "Holy Hand Grenade",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-167",
      Name: "Fortune Llama",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-168",
      Name: "Tsai Shen 10K Ways",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-169",
      Name: "Neko Night",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-170",
      Name: "Beellionaires",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-171",
      Name: "Ticket To Fortune",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-173",
      Name: "Money Cart 3",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-174",
      Name: "5K Gold Mine",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-176",
      Name: "Hellcatraz 2",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-177",
      Name: "Mega Heist",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-178",
      Name: "Fly Cat$",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-180",
      Name: "Dueling Jokers",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-181",
      Name: "Cash Defense",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-182",
      Name: "Money Train Origins",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-183",
      Name: "Shark Wash",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-184",
      Name: "Everest",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-186",
      Name: "Rich Raptors",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-187",
      Name: "5 Doggy Dollars",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-188",
      Name: "Shinobi Spirit",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-189",
      Name: "Sloth Tumble",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-190",
      Name: "Abrakadabra",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-192",
      Name: "5 Monsters",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-193",
      Name: "Safari Sun",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-194",
      Name: "Torii Tumble",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-195",
      Name: "Temple of Fury",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-197",
      Name: "Pinata Popper",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-198",
      Name: "Money Train 4",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-199",
      Name: "Royal Potato 2",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-200",
      Name: "Joker Split",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-201",
      Name: "Titan Strike",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-202",
      Name: "Mystic Spells",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-204",
      Name: "Darkness",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-205",
      Name: "Snakes Gold",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-206",
      Name: "Lure of Fortune",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-207",
      Name: "Bloodaxe",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-211",
      Name: "Looney Pop",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-213",
      Name: "Hercules 10K Ways",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-214",
      Name: "Galactic Racers",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-215",
      Name: "Bucks and Doe 10K Ways",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-216",
      Name: "21 Thor Lightning Ways",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-217",
      Name: "Pine of Plinko 2",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-219",
      Name: "Aussie vs Emus",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-220",
      Name: "Bill & Coin",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-221",
      Name: "Money Cart 4",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-223",
      Name: "Wins of Mermaid Multipower",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-224",
      Name: "Cyber Vault",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-225",
      Name: "Tarasque",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-226",
      Name: "Sweetopia Royale",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-227",
      Name: "Firewins Factory",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-228",
      Name: "Gnomes & Giants",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-229",
      Name: "Sultan Spins",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-232",
      Name: "Pirate Multi Coins",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-233",
      Name: "The Wild Drifter",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-234",
      Name: "Attila The Hun",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-235",
      Name: "La Fiesta 5K",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-236",
      Name: "La Fiesta 10K",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-237",
      Name: "Plunderland 5K",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-238",
      Name: "Plunderland 10K",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-239",
      Name: "TNT Tumble 5K",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-240",
      Name: "TNT Tumble 10K",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-241",
      Name: "Wild Chapo 5K",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-242",
      Name: "Wild Chapo 10K",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-243",
      Name: "Payday Megaways",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-244",
      Name: "Epic Dreams",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-245",
      Name: "Curse of Ra",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-247",
      Name: "Honey Hunters",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-248",
      Name: "10000 Years Before Cash",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-249",
      Name: "Gem Pops",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-251",
      Name: "Ancient Tumble",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-252",
      Name: "Atlantis Crush",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-253",
      Name: "7 Gold Fruits",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-254",
      Name: "St Louis 1904",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-255",
      Name: "Shadow Summoner Elementals",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-256",
      Name: "Eldritch Dungeon",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-257",
      Name: "Circle of Sylvan",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-258",
      Name: "Cowabunga",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-259",
      Name: "Totem Guardians",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-260",
      Name: "Bone Raiders",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-261",
      Name: "Win-O-Mart",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-262",
      Name: "The Tumbles",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-263",
      Name: "Donkey & The GOATS",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-264",
      Name: "Beanstalk Grows Wild",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-265",
      Name: "Quackin Reels",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-266",
      Name: "Freaked Out Fish",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-267",
      Name: "Feather Fury",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-268",
      Name: "Dreadworks",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-269",
      Name: "Pay Pig 10K WAYS",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-270",
      Name: "3 Bears",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-271",
      Name: "Witchy Poppins",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-272",
      Name: "Winter Champions",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-273",
      Name: "Big Bucks Bison 10K Ways",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-274",
      Name: "Buffalo Blow",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-275",
      Name: "Magawa vs Mines",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-276",
      Name: "Pond of Plinko",
    },
    {
      platFormCode: "RELAX",
      gameType: "SLOT",
      casinoType: "RELAX-SLOT-277",
      Name: "Immortal 5",
    },
    {
      platFormCode: "RELAX",
      gameType: "TABLE",
      casinoType: "RELAX-TABLE-001",
      Name: "Blackjack Neo",
    },
    {
      platFormCode: "RELAX",
      gameType: "TABLE",
      casinoType: "RELAX-TABLE-002",
      Name: "Roulette Nouveau",
    },
  ],
  NLC: [
    {
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-001",
      Name: "Das xBoot",
    },
    {
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-002",
      Name: "Mental",
    },
    {
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-003",
      Name: "Punk Toilet",
    },
    {
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-004",
      Name: "Serial",
    },
    {
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-005",
      Name: "Tomb of Akhenaten",
    },
    {
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-006",
      Name: "Tombstone RIP",
    },
    {
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-007",
      Name: "Folsom Prison",
    },
    {
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-008",
      Name: "Fire In The Hole xBomb",
    },
    {
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-009",
      Name: "Dead Canary",
    },
    {
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-010",
      Name: "Deadwood xNudge",
    },
    {
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-011",
      Name: "Evil Goblins xBomb",
    },
    {
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-012",
      Name: "Punk Rocker",
    },
    {
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-013",
      Name: "xWays Hoarder xSplit",
    },
    {
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-014",
      Name: "Infectious 5 xWays",
    },
    {
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-015",
      Name: "Misery Mining",
    },
    {
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-016",
      Name: "Book Of Shadows",
    },
    {
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-017",
      Name: "Remember Gulag",
    },
    {
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-018",
      Name: "Pearl Harbor",
    },
    {
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-019",
      Name: "Road Rage",
    },
    {
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-020",
      Name: "Bonus Bunnies",
    },
    {
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-021",
      Name: "Little Bighorn",
    },
    {
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-022",
      Name: "The Border",
    },
    {
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-023",
      Name: "The Rave",
    },
    {
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-024",
      Name: "Karen Maneater",
    },
    {
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-025",
      Name: "True Grit Redemption",
    },
    {
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-026",
      Name: "Legion X",
    },
    {
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-027",
      Name: "El Paso Gunfight xNudge",
    },
    {
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-028",
      Name: "Bushido Way xNudge",
    },
    {
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-029",
      Name: "East Coast Vs West Coast",
    },
    {
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-030",
      Name: "San Quentin xWays",
    },
    {
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-031",
      Name: "Warrior Graveyard xNudge",
    },
    {
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-032",
      Name: "Monkey's Gold xPays",
    },
    {
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-033",
      Name: "Buffalo Hunter",
    },
    {
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-034",
      Name: "Immortal Fruits",
    },
    {
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-035",
      Name: "Golden Genie And The Walking Wilds",
    },
    {
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-036",
      Name: "Milky Ways",
    },
    {
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-037",
      Name: "Harlequin Carnival",
    },
    {
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-038",
      Name: "Gaelic Gold",
    },
    {
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-039",
      Name: "Barbarian Fury",
    },
    {
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-040",
      Name: "Poison Eve",
    },
    {
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-041",
      Name: "Dragon Tribe",
    },
    {
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-042",
      Name: "Tomb of Nefertiti",
    },
    {
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-043",
      Name: "Manhattan Goes Wild",
    },
    {
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-044",
      Name: "Pixies vs Pirates",
    },
    {
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-045",
      Name: "Hot 4 Cash",
    },
    {
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-046",
      Name: "Thor: Hammer Time",
    },
    {
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-047",
      Name: "Tractor Beam",
    },
    {
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-048",
      Name: "Mayan Magic Wildfire",
    },
    {
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-049",
      Name: "Tombstone",
    },
    {
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-050",
      Name: "Starstruck",
    },
    {
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-051",
      Name: "Owls",
    },
    {
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-052",
      Name: "Fruits",
    },
    {
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-053",
      Name: "Ice Ice Yeti",
    },
    {
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-054",
      Name: "Dungeon Quest",
    },
    {
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-055",
      Name: "Hot Nudge",
    },
    {
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-056",
      Name: "Coins of Fortune",
    },
    {
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-057",
      Name: "Tesla Jolt",
    },
    {
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-058",
      Name: "Casino Win Spin",
    },
    {
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-060",
      Name: "WiXX",
    },
    {
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-061",
      Name: "The Creepy Carnival",
    },
    {
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-062",
      Name: "Rock Bottom",
    },
    {
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-063",
      Name: "Walk of Shame",
    },
    {
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-064",
      Name: "Benji Killed in Vegas",
    },
    {
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-065",
      Name: "Blood & Shadow",
    },
    {
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-066",
      Name: "Kiss My Chainsaw",
    },
    {
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-067",
      Name: "Disturbed",
    },
    {
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-068",
      Name: "Whacked",
    },
    {
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-069",
      Name: "gluttony",
    },
    {
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-070",
      Name: "Bounty Hunters xNudge",
    },
    {
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-071",
      Name: "DJ Psycho",
    },
    {
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-072",
      Name: "The Cage",
    },
    {
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-073",
      Name: "The Crypt",
    },
    {
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-074",
      Name: "True kult",
    },
    {
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-075",
      Name: "Brick Snake 2000",
    },
    {
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-076",
      Name: "D Day",
    },
    {
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-077",
      Name: "Devil's Crossroad",
    },
    {
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-078",
      Name: "Fire In The Hole 2",
    },
    {
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-079",
      Name: "Jingle Balls",
    },
    {
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-080",
      Name: "Land Of The Free",
    },
    {
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-081",
      Name: "Possessed",
    },
    {
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-082",
      Name: "Tombstone No Mercy",
    },
    {
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-083",
      Name: "Nine To Five",
    },
    {
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-084",
      Name: "Roadkill",
    },
    {
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-085",
      Name: "Space Donkey",
    },
    {
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-086",
      Name: "Ugliest Catch",
    },
    {
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-087",
      Name: "Kenneth Must Die",
    },
    {
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-088",
      Name: "LONER",
    },
    {
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-089",
      Name: "Punk Rocker 2",
    },
    {
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-090",
      Name: "Beheaded",
    },
    {
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-091",
      Name: "Deadwood R.I.P",
    },
    {
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-092",
      Name: "Apocalypse Super xNudge®",
    },
    {
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-093",
      Name: "Outsourced",
    },
    {
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-094",
      Name: "Stockholm Syndrome",
    },
    {
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-095",
      Name: "Skate or Die",
    },
    {
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-096",
      Name: "San Quentin 2: Death Row",
    },
    {
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-097",
      Name: "Brute Force",
    },
    {
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-099",
      Name: "Munchies",
    },
    {
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-100",
      Name: "Blood & Shadow 2",
    },
    {
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-101",
      Name: "Outsourced Payday",
    },
    {
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-102",
      Name: "Tanked",
    },
    {
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-103",
      Name: "Duck Hunters",
    },
    {
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-104",
      Name: "Tombstone Slaughter",
    },
    {
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-105",
      Name: "xWays Hoarder 2",
    },
    {
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-106",
      Name: "Dead, Dead, or Deader",
    },
    {
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-107",
      Name: "Mental 2",
    },
    {
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-108",
      Name: "Home of the Brave",
    },
    {
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-109",
      Name: "Blood Diamond",
    },
    {
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-110",
      Name: "Highway to Hell",
    },
    {
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-111",
      Name: "Kill Em All",
    },
    {
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-112",
      Name: "Flight Mode",
    },
    {
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-113",
      Name: "Fire in the Hole 3",
    },
    {
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-114",
      Name: "Brute Force: Alien Onslaught",
    },
    {
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-115",
      Name: "Tsar Wars",
    },
    {
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-116",
      Name: "Seamen",
    },
    {
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-117",
      Name: "Gator Hunters",
    },
    {
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-118",
      Name: "Dead Men Walking",
    },
    {
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-119",
      Name: "Breakout",
    },
  ],
  NETENT: [
    {
      platFormCode: "NETENT",
      gameType: "TABLE",
      casinoType: "NETENT-TABLE-001",
      Name: "Blackjack Classic",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-001",
      Name: "Reel Rush",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-002",
      Name: "Dracula",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-003",
      Name: "Riches of Midgard: Land and Expand",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-004",
      Name: "Dark King: Forbidden Riches",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-005",
      Name: "Dead or Alive 2™ Feature Buy",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-006",
      Name: "Parthenon: Quest for Immortality",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-007",
      Name: "Jungle Spirit: Call of the Wild",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-008",
      Name: "Starburst",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-009",
      Name: "Gonzo's Quest",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-010",
      Name: "Finn's Golden Tavern",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-011",
      Name: "Wild Water",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-012",
      Name: "Rome:The Golden Age",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-013",
      Name: "Fruit Shop",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-014",
      Name: "Divine Fortune™ Megaways",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-015",
      Name: "Space Wars",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-016",
      Name: "Cupcakes",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-017",
      Name: "Starburst™ XXXtreme",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-018",
      Name: "Twin Spin",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-019",
      Name: "Dead or Alive 2",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-020",
      Name: "Steam Tower",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-022",
      Name: "Motörhead Video Slot",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-023",
      Name: "Jack Hammer",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-024",
      Name: "Dazzle Me",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-025",
      Name: "Jimi Hendrix Online Slot",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-026",
      Name: "Dead or Alive",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-027",
      Name: "Wild Wild West: The Great Train Heist",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-028",
      Name: "Ozzy Osbourne Video Slots",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-029",
      Name: "Finn and the Swirly Spin",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-030",
      Name: "Pyramid: Quest for Immortality",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-031",
      Name: "Jingle Spin",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-032",
      Name: "Aloha! Cluster Pays",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-033",
      Name: "Piggy Riches",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-034",
      Name: "Jumanji",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-035",
      Name: "Jack and the Beanstalk",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-036",
      Name: "Turn Your Fortune",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-037",
      Name: "Narcos",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-038",
      Name: "Street Fighter™ II: The World Warrior Slot",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-039",
      Name: "Gordon Ramsay Hell’s Kitchen",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-040",
      Name: "Fruit Shop™ Megaways",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-041",
      Name: "Twin Spin™ Megaways",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-042",
      Name: "Blood Suckers",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-043",
      Name: "Aloha! Christmas",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-044",
      Name: "Hotline",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-045",
      Name: "Victorious",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-046",
      Name: "Blood Suckers II",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-047",
      Name: "Butterfly Staxx",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-048",
      Name: "Fruit Shop Christmas Edition",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-049",
      Name: "Serengeti Kings",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-050",
      Name: "Irish Pot Luck",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-051",
      Name: "Hotline 2",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-052",
      Name: "Rage of the Seas",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-053",
      Name: "Gorilla Kingdom",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-054",
      Name: "Elements: The Awakening",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-055",
      Name: "Willy's Hot Chillies",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-056",
      Name: "Codex of Fortune",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-057",
      Name: "American Roulette",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-058",
      Name: "Secrets of Atlantis",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-060",
      Name: "Jack Hammer 2",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-061",
      Name: "Warlords: Crystals of Power",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-062",
      Name: "Fruit Spin",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-063",
      Name: "Secret of the Stones",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-064",
      Name: "European Roulette",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-065",
      Name: "Secrets of Christmas",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-066",
      Name: "French Roulette",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-067",
      Name: "Drive: Multiplier Mayhem",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-068",
      Name: "Wild Worlds ",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-069",
      Name: "Scruffy Duck",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-070",
      Name: "Butterfly Staxx 2",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-071",
      Name: "Fairytale Legends: Red Riding Hood",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-072",
      Name: "Flowers",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-073",
      Name: "Asgardian Stones",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-074",
      Name: "The Invisible Man",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-075",
      Name: "Koi Princess",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-076",
      Name: "Dazzle Me™ Megaways",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-077",
      Name: "Double Stacks",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-078",
      Name: "Vikings Video Slot",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-079",
      Name: "Reef Raider",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-080",
      Name: "Lost Relics",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-082",
      Name: "Joker Pro",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-083",
      Name: "Creature from the Black Lagoon",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-084",
      Name: "Gods Of Gold: InfiniReels",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-086",
      Name: "Football: Champions Cup",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-087",
      Name: "Fairytale Legends: Hansel and Gretel",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-088",
      Name: "Casino Hold'em",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-089",
      Name: "Mythic Maiden",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-090",
      Name: "EggOMatic",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-091",
      Name: "Fairytale Legends: Mirror Mirror",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-092",
      Name: "Cash-o-Matic",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-093",
      Name: "Halloween Jack",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-094",
      Name: "Grand Spinn",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-095",
      Name: "Cash Noire",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-096",
      Name: "Disco Danny",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-097",
      Name: "Druids' Dream",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-098",
      Name: "Ocean's Treasure",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-099",
      Name: "Jacks or Better Double Up",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-100",
      Name: "Excalibur",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-101",
      Name: "Scudamore's Super Stakes",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-102",
      Name: "King of Slots",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-103",
      Name: "Neon Staxx",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-104",
      Name: "Spinata Grande",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-105",
      Name: "The Legend of Shangri-La: Cluster Pays",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-106",
      Name: "Rise of Maya",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-107",
      Name: "Lights",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-108",
      Name: "Magic Maid Cafe",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-109",
      Name: "Silverback Gold",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-110",
      Name: "Super Striker",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-111",
      Name: "The Wolf's Bane",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-113",
      Name: "Sweety Honey Fruity",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-114",
      Name: "Wings of Riches",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-115",
      Name: "Wolf Cub",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-116",
      Name: "Trollpot 5000",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-117",
      Name: "Wilderland",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-118",
      Name: "Wild Bazaar",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-119",
      Name: "Gonzo’s Gold",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-120",
      Name: "Reel Steal",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-121",
      Name: "Knight Rider",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-122",
      Name: "Roulette Touch",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-123",
      Name: "Reel Rush 2",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-124",
      Name: "Golden Grimoire",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-125",
      Name: "Spinsane",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-126",
      Name: "Funk Master",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-127",
      Name: "Space Wars 2: Powerpoints",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-128",
      Name: "Bee Hive Bonanza",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-129",
      Name: "Cornelius",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-130",
      Name: "Temple of Nudges",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-131",
      Name: "Superstars",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-132",
      Name: "Wonders of Christmas",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-133",
      Name: "Milkshake™ XXXtreme",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-134",
      Name: "Let It Burn",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-135",
      Name: "Magic Portals",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-136",
      Name: "Twin Spin Deluxe",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-137",
      Name: "Bollywood Story",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-138",
      Name: "Spellcast",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-139",
      Name: "Coins of Egypt",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-140",
      Name: "Long Pao",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-141",
      Name: "Ghost Pirates",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-142",
      Name: "King of 3 Kingdoms",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-143",
      Name: "Who's the Bride",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-144",
      Name: "Arcane: Reel Chaos",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-145",
      Name: "Robin Hood: Shifting Riches",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-146",
      Name: "Stickers",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-147",
      Name: "The Wish Master",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-148",
      Name: "Wild Turkey",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-149",
      Name: "Twin Happiness",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-150",
      Name: "Fruit Case",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-151",
      Name: "Santa vs Rudolf",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-152",
      Name: "Happy Riches",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-153",
      Name: "Berry burst",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-154",
      Name: "East Sea Dragon King",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-155",
      Name: "Fortune Rangers",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-156",
      Name: "Archangels Salvation",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-157",
      Name: "Wild-O-Tron 3000",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-158",
      Name: "Strolling Staxx: Cubic Fruits",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-159",
      Name: "Copy Cats",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-160",
      Name: "Theme Park Tickets of Fortune",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-161",
      Name: "Witchcraft Academy",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-162",
      Name: "Flowers Christmas Edition",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-163",
      Name: "Go Bananas!",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-164",
      Name: "Hook's Heroes",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-165",
      Name: "Swipe & Roll",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-166",
      Name: "Berry burst MAX",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-167",
      Name: "Sparks",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-168",
      Name: "Lucky Angler: A Snowy Catch",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-169",
      Name: "Fire Siege Fortress",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-170",
      Name: "Moonshine Riches",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-171",
      Name: "Wonderland Protector",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-172",
      Name: "Pirate From the East",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-173",
      Name: "Buster's Bones",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-174",
      Name: "Taco Fury XXXtreme",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-175",
      Name: "Twin Spin XXXtreme",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-176",
      Name: "The Wish Master™ Megaways",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-177",
      Name: "101 Candies",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-178",
      Name: "Big Bang Boom",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-179",
      Name: "Crab Trap",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-180",
      Name: "Jack and the Beanstalk Remastered",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-181",
      Name: "Thrill to Grill",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-182",
      Name: "Pirates Party",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-183",
      Name: "Jelly Belly Megaways",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-184",
      Name: "Buckshot Wilds",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-185",
      Name: "Elk Hunter",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-186",
      Name: "Finn and The Candy Spin",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-187",
      Name: "Cursed treasure",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-188",
      Name: "Jack Hammer™ 3: Diamond Affair",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-189",
      Name: "Rage",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-190",
      Name: "Golden Wheels of Egypt",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-191",
      Name: "Golden Realms",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-192",
      Name: "Jungle Spirit Megaways",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-193",
      Name: "Magic lab",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-194",
      Name: "Good Old 7's",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-195",
      Name: "Rainforest Gold",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-196",
      Name: "Pandora's Treasure",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-197",
      Name: "Leprechaun Joy",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-198",
      Name: "Beach Invaders",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-199",
      Name: "Don’t Eat the Candy",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-200",
      Name: "Fruit Shop Frenzy",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-201",
      Name: "Gem Crush",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-202",
      Name: "Jingle Bells Bonanza",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-203",
      Name: "Lights, Camera, Cash!",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-204",
      Name: "Lost Relics 2",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-205",
      Name: "Wild Turkey™ Megaways",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-206",
      Name: "Druid's Magic",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-207",
      Name: "Royal Nuts",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-208",
      Name: "Gladiator Clash",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-209",
      Name: "Big Money Wheel",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-210",
      Name: "Lock and Pop",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-211",
      Name: "Space Wars Megaways XXXtreme",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-212",
      Name: "Babylon Riches",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-213",
      Name: "Ticket To Wild",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-214",
      Name: "Casino Night",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-215",
      Name: "Mermaids",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-216",
      Name: "Rabid Randy",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-217",
      Name: "Ms Robin Hood",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-218",
      Name: "Mine Blown",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-219",
      Name: "Mummy™ MegaWays",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-220",
      Name: "Starburst Galaxy",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-221",
      Name: "Cornelius Milk Hunter Megaways",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-222",
      Name: "Dragons Playground",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-223",
      Name: "Twister",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-224",
      Name: "Dazzle Me™ Christmas ",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-225",
      Name: "Wild Mining XXXtreme",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-226",
      Name: "Finn and the Dragon Tales",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-227",
      Name: "Golden Egg Invaders",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-228",
      Name: "Jack Hammer™ 4: Chasing the Dragon",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-229",
      Name: "Reel Rush XXXtreme",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-230",
      Name: "Divine Fortune Black",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-231",
      Name: "Piggy Riches™ 3: Hog Heaven",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-232",
      Name: "Dead West",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-233",
      Name: "Gonzo's Quest 2",
    },
    {
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-234",
      Name: "Rabid Randy Dark Trails",
    },
  ],
  JOKER: [
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-001",
      Name: "A Night Out",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-002",
      Name: "Aladdin",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-003",
      Name: "Alice",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-004",
      Name: "Alice In Wonderland",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-005",
      Name: "Ancient Artifact",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-006",
      Name: "Ancient Egypt",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-007",
      Name: "Ancient Rome Deluxe",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-008",
      Name: "Archer",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-009",
      Name: "Arctic Treasure",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-010",
      Name: "Aztec Temple",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-011",
      Name: "Azteca",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-012",
      Name: "Bagua",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-013",
      Name: "Bagua 2",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-014",
      Name: "Bali",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-015",
      Name: "Beach Life",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-016",
      Name: "Beanstalk",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-017",
      Name: "Big Game Safari",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-018",
      Name: "Black Beard Legacy",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-019",
      Name: "Bonus Bear",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-020",
      Name: "Book Of Ra",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-021",
      Name: "Book Of Ra Deluxe",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-022",
      Name: "Bounty Hunter",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-023",
      Name: "Buccaneer Deluxe",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-024",
      Name: "Burning Pearl",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-025",
      Name: "Bushido Blade",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-026",
      Name: "Caishen Riches",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-027",
      Name: "Captain's Treasure",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-028",
      Name: "Captains Treasure Pro",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-029",
      Name: "Captains Treasure Progressive",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-030",
      Name: "Chilli Hunter",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-031",
      Name: "China",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-032",
      Name: "Chinese Boss",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-033",
      Name: "Cluster Mania",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-034",
      Name: "Columbus",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-035",
      Name: "Critter Mania Deluxe",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-036",
      Name: "Cryptomania",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-037",
      Name: "Cursed Deluxe",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-038",
      Name: "Cyber Race",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-039",
      Name: "Dia De Los Muertos Deluxe",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-040",
      Name: "Dolphin Reef",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-041",
      Name: "Dolphin Treasure",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-042",
      Name: "Dolphins Pearl Deluxe",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-043",
      Name: "Dragon Of The Eastern Sea",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-044",
      Name: "Dragon Phoenix",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-045",
      Name: "Dragon Power Flame",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-046",
      Name: "Dragon's Realm",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-047",
      Name: "Dynamite Reels",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-048",
      Name: "Egypt Queen",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-049",
      Name: "Empress Regnant",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-050",
      Name: "Enchanted Forest",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-051",
      Name: "Enter The KTV",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-052",
      Name: "Fabulous Eights",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-053",
      Name: "Fat Choy Choy Sun",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-054",
      Name: "Fei Long Zai Tian",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-055",
      Name: "Feng Huang",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-056",
      Name: "Fifty Dragons",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-057",
      Name: "Fifty Lions",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-058",
      Name: "Fire Reel",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-059",
      Name: "Fire Reign",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-060",
      Name: "Five Tiger Generals",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-061",
      Name: "Flames Of Fortune",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-062",
      Name: "Football Rules",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-063",
      Name: "Forest Treasure",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-064",
      Name: "Fortune Festival",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-065",
      Name: "Four Dragons",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-066",
      Name: "Four Tigers",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-067",
      Name: "Fruit Paradise",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-068",
      Name: "Geisha",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-069",
      Name: "Genie",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-070",
      Name: "Genie 2",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-071",
      Name: "Gold Trail",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-072",
      Name: "Golden Dragon",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-073",
      Name: "Golden Island",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-074",
      Name: "Golden Monkey King",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-075",
      Name: "Golden Rooster",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-076",
      Name: "Great Blue",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-077",
      Name: "Happy Buddha",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-078",
      Name: "Happy Party",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-079",
      Name: "Haunted House",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-080",
      Name: "Heist Deluxe",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-081",
      Name: "Hercules",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-082",
      Name: "Highway Kings",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-083",
      Name: "HighwayKings JP",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-084",
      Name: "Horus Eye",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-085",
      Name: "Hot Fruits",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-086",
      Name: "Huga",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-087",
      Name: "Immortals",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-088",
      Name: "Jin Fu Xing Yun",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-089",
      Name: "Joker Madness",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-090",
      Name: "Journey To The West",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-091",
      Name: "Jungle Island",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-092",
      Name: "Just Jewels Deluxe",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-093",
      Name: "Lady Hawk",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-094",
      Name: "League Of Legends",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-095",
      Name: "Lightning God",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-096",
      Name: "Lions Dance",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-097",
      Name: "Lord Of The Ocean",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-098",
      Name: "Lucky Drum",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-099",
      Name: "Lucky God",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-100",
      Name: "Lucky God Progressive",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-101",
      Name: "Lucky God Progressive 2",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-102",
      Name: "Lucky Joker",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-103",
      Name: "Lucky Lady Charm",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-104",
      Name: "Lucky Panda",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-105",
      Name: "Lucky Rooster",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-106",
      Name: "Lucky Streak",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-107",
      Name: "Majapahit",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-108",
      Name: "Mammamia",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-109",
      Name: "Mayan Gems",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-110",
      Name: "Miami",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-111",
      Name: "MoneyBangBang",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-112",
      Name: "Money Vault",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-113",
      Name: "Monkey King",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-114",
      Name: "Mulan",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-115",
      Name: "Mythical Sand",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-116",
      Name: "Mythological",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-117",
      Name: "Neptune Treasure",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-118",
      Name: "Ni Shu Shen Me",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-119",
      Name: "Nugget Hunter",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-120",
      Name: "Oasis",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-121",
      Name: "Ocean Paradise",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-122",
      Name: "Ocean Spray",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-123",
      Name: "Octagon Gem",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-124",
      Name: "Octagon Gem 2",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-125",
      Name: "Ong Bak 2",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-126",
      Name: "Ong Bak Deluxe",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-127",
      Name: "Pan Jin Lian",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-128",
      Name: "Pan Jin Lian 2",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-129",
      Name: "Panther Moon",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-130",
      Name: "Peach Banquet",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-131",
      Name: "Pharaoh's Tomb",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-132",
      Name: "Phoenix 888",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-133",
      Name: "Power Stars",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-134",
      Name: "Qatar 2022",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-135",
      Name: "Queen",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-136",
      Name: "Queen 2",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-137",
      Name: "Queen Of The Nile",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-138",
      Name: "Rancher's Wealth",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-139",
      Name: "Respin Mania",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-140",
      Name: "Robin Hood",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-141",
      Name: "Roma",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-142",
      Name: "Roma Legacy",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-143",
      Name: "Safari Heat",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-144",
      Name: "Safari Life",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-145",
      Name: "Santa Surprise",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-146",
      Name: "Santa's Workshop",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-147",
      Name: "Scheherazade",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-148",
      Name: "Shaolin",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-149",
      Name: "Silver Bullet",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-150",
      Name: "SilverBullet Progressive",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-151",
      Name: "Sizzling Hot",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-152",
      Name: "Sparta",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-153",
      Name: "Streets Of Chicago",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-154",
      Name: "Super Stars",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-155",
      Name: "Supreme Caishen",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-156",
      Name: "Tai Shang Lao Jun",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-158",
      Name: "Thai Paradise",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-159",
      Name: "The 4 Invention",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-160",
      Name: "The Legend Of White Snake",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-161",
      Name: "Third Prince's Journey",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-162",
      Name: "Three Kingdoms 2",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-163",
      Name: "Three Kingdoms Quest",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-164",
      Name: "Thug Life",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-165",
      Name: "Thunder God",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-166",
      Name: "Tigers Lair",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-167",
      Name: "Tropical Crush",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-168",
      Name: "Tsai Shen's Gift",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-169",
      Name: "Water Margin",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-170",
      Name: "Water Reel",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-171",
      Name: "Wealth God",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-172",
      Name: "White Snake",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-173",
      Name: "Wild Fairies",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-174",
      Name: "Wild Giant Panda",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-175",
      Name: "Wild Spirit",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-176",
      Name: "Winter Sweets",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-177",
      Name: "Witch's Brew",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-178",
      Name: "Wizard Deluxe",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-179",
      Name: "Wukong",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-180",
      Name: "Xuan Pu Lian Huan",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-181",
      Name: "Yakuza",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-182",
      Name: "Yeh Hsien Deluxe",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-183",
      Name: "Yggdrasil",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-184",
      Name: "Zhao Cai Jin Bao",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-185",
      Name: "Zodiac Deluxe",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-186",
      Name: "Date With Miyo",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-187",
      Name: "Kraken Hunter",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-188",
      Name: "Leprechaun",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-189",
      Name: "Warrior",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-190",
      Name: "Sweet Tooth",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-191",
      Name: "Lion Of The East",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-192",
      Name: "Mermaid Treasure",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-193",
      Name: "Panda Chef",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-194",
      Name: "Safari Life 2",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-195",
      Name: "Sour Candy",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-196",
      Name: "Love Letter",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-197",
      Name: "Pubg",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-198",
      Name: "Sweetie Crush",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-199",
      Name: "Silver Hand",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-200",
      Name: "Huang Fei Hong",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-201",
      Name: "Gates Of Wealth",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-202",
      Name: "Masquerade",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-203",
      Name: "Golden Sea",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-204",
      Name: "Trick Or Treat",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-205",
      Name: "Bull Street",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-206",
      Name: "Wild Watermelon",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-207",
      Name: "Hot Wheels",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-208",
      Name: "Mahjong Reactor",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-209",
      Name: "Christmas Eve",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-210",
      Name: "Hawaii Vacay",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-211",
      Name: "Snake Of Fortune",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-212",
      Name: "Chocolate Shop",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-213",
      Name: "Black Knight",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-214",
      Name: "Carnaval Do Rio",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-215",
      Name: "World Of Emoji",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-216",
      Name: "Legend Of Persia",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-217",
      Name: "Winds Of Wealth",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-218",
      Name: "Fortune Crown",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-219",
      Name: "Fire Temple",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-220",
      Name: "Roma Deluxe",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-221",
      Name: "Ramesses Relics",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-222",
      Name: "Inca",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-223",
      Name: "Super Wild Watermelon",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-224",
      Name: "Savage Frontier",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-225",
      Name: "Fortune Crown 25",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-226",
      Name: "Seven Seas",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-227",
      Name: "Steamboat Ride Hold And Win",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-228",
      Name: "Chilli Hunter Bandidos",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-229",
      Name: "Mahjong King",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-230",
      Name: "Fortune Crown Gold Gift",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-231",
      Name: "Dragon Ball",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-232",
      Name: "Fire Master Hold And Win",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-233",
      Name: "Super Seven Seas",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-234",
      Name: "Maya Ways",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-235",
      Name: "Moon Goddess",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-236",
      Name: "Super Fortune Crown",
      platFormCode: "JOKER",
    },
    {
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-237",
      Name: "Jiang Shi Night",
      platFormCode: "JOKER",
    },
  ],
  JDB: [
    {
      platFormCode: "JDB",
      gameType: "EGAME",
      casinoType: "JDB-EGAME-001",
      Name: "Crazy King Kong",
    },
    {
      platFormCode: "JDB",
      gameType: "EGAME",
      casinoType: "JDB-EGAME-002",
      Name: "Lucky Color Game",
    },
    {
      platFormCode: "JDB",
      gameType: "EGAME",
      casinoType: "JDB-EGAME-003",
      Name: "Birds and Animals",
    },
    {
      platFormCode: "JDB",
      gameType: "EGAME",
      casinoType: "JDB-EGAME-004",
      Name: "Happy New Year",
    },
    {
      platFormCode: "JDB",
      gameType: "EGAME",
      casinoType: "JDB-EGAME-005",
      Name: "CAISHEN PARTY",
    },
    {
      platFormCode: "JDB",
      gameType: "EGAME",
      casinoType: "JDB-EGAME-006",
      Name: "King Of Football",
    },
    {
      platFormCode: "JDB",
      gameType: "EGAME",
      casinoType: "JDB-EGAME-007",
      Name: "Super Super Fruit",
    },
    {
      platFormCode: "JDB",
      gameType: "EGAME",
      casinoType: "JDB-EGAME-008",
      Name: "Huaguoshan Legends",
    },
    {
      platFormCode: "JDB",
      gameType: "EGAME",
      casinoType: "JDB-EGAME-009",
      Name: "Classic Mario",
    },
    {
      platFormCode: "JDB",
      gameType: "EGAME",
      casinoType: "JDB-EGAME-010",
      Name: "Beer Tycoon",
    },
    {
      platFormCode: "JDB",
      gameType: "EGAME",
      casinoType: "JDB-EGAME-011",
      Name: "Jogo Do Bicho",
    },
    {
      platFormCode: "JDB",
      gameType: "EGAME",
      casinoType: "JDB-EGAME-012",
      Name: "Galaxy Burst",
    },
    {
      platFormCode: "JDB",
      gameType: "EGAME",
      casinoType: "JDB-EGAME-013",
      Name: "MINES",
    },
    {
      platFormCode: "JDB",
      gameType: "EGAME",
      casinoType: "JDB-EGAME-014",
      Name: "FIREWORK BURST",
    },
    {
      platFormCode: "JDB",
      gameType: "EGAME",
      casinoType: "JDB-EGAME-015",
      Name: "GOAL",
    },
    {
      platFormCode: "JDB",
      gameType: "EGAME",
      casinoType: "JDB-EGAME-016",
      Name: "HILO",
    },
    {
      platFormCode: "JDB",
      gameType: "EGAME",
      casinoType: "JDB-EGAME-017",
      Name: "Plinko",
    },
    {
      platFormCode: "JDB",
      gameType: "EGAME",
      casinoType: "JDB-EGAME-018",
      Name: "Dice",
    },
    {
      platFormCode: "JDB",
      gameType: "EGAME",
      casinoType: "JDB-EGAME-019",
      Name: "MINES 2",
    },
    {
      platFormCode: "JDB",
      gameType: "EGAME",
      casinoType: "JDB-EGAME-020",
      Name: "Mole Crash",
    },
    {
      platFormCode: "JDB",
      gameType: "EGAME",
      casinoType: "JDB-EGAME-021",
      Name: "CRICKET BURST",
    },
    {
      platFormCode: "JDB",
      gameType: "EGAME",
      casinoType: "JDB-EGAME-022",
      Name: "Aviator Extra Bet",
    },
    {
      platFormCode: "JDB",
      gameType: "EGAME",
      casinoType: "JDB-EGAME-023",
      Name: "Piggy Bank TapTap",
    },
    {
      platFormCode: "JDB",
      gameType: "FH",
      casinoType: "JDB-FISH-008",
      Name: "Cai Shen Fishing",
    },
    {
      platFormCode: "JDB",
      gameType: "FH",
      casinoType: "JDB-FISH-009",
      Name: "Shade Dragons Fishing",
    },
    {
      platFormCode: "JDB",
      gameType: "FH",
      casinoType: "JDB-FISH-010",
      Name: "Fishing Yi Lu Fa",
    },
    {
      platFormCode: "JDB",
      gameType: "FH",
      casinoType: "JDB-FISH-011",
      Name: "Dragon Master",
    },
    {
      platFormCode: "JDB",
      gameType: "FH",
      casinoType: "JDB-FISH-012",
      Name: "Fishing Disco",
    },
    {
      platFormCode: "JDB",
      gameType: "FH",
      casinoType: "JDB-FISH-013",
      Name: "Spirit Tide Legend",
    },
    {
      platFormCode: "JDB",
      gameType: "FH",
      casinoType: "JDB-FISH-014",
      Name: "Fighter Fire",
    },
    {
      platFormCode: "JDB",
      gameType: "FH",
      casinoType: "JDB-FISH-015",
      Name: "Dragon Fishing II",
    },
    {
      platFormCode: "JDB",
      gameType: "FH",
      casinoType: "JDB-FISH-016",
      Name: "Dragon Fishing",
    },
    {
      platFormCode: "JDB",
      gameType: "FH",
      casinoType: "JDB-FISH-017",
      Name: "Dragon of Demons",
    },
    {
      platFormCode: "JDB",
      gameType: "SLOT",
      casinoType: "JDB-SLOT-009",
      Name: "Beauty And The Kingdom",
    },
    {
      platFormCode: "JDB",
      gameType: "SLOT",
      casinoType: "JDB-SLOT-010",
      Name: "Flirting Scholar Tang",
    },
    {
      platFormCode: "JDB",
      gameType: "SLOT",
      casinoType: "JDB-SLOT-011",
      Name: "Winning Mask",
    },
    {
      platFormCode: "JDB",
      gameType: "SLOT",
      casinoType: "JDB-SLOT-012",
      Name: "Wu kong",
    },
    {
      platFormCode: "JDB",
      gameType: "SLOT",
      casinoType: "JDB-SLOT-013",
      Name: "Llama Adventure",
    },
    {
      platFormCode: "JDB",
      gameType: "SLOT",
      casinoType: "JDB-SLOT-014",
      Name: "Formosa Bear",
    },
    {
      platFormCode: "JDB",
      gameType: "SLOT",
      casinoType: "JDB-SLOT-016",
      Name: "New Year",
    },
    {
      platFormCode: "JDB",
      gameType: "SLOT",
      casinoType: "JDB-SLOT-017",
      Name: "Four Treasures",
    },
    {
      platFormCode: "JDB",
      gameType: "SLOT",
      casinoType: "JDB-SLOT-018",
      Name: "Open Sesame",
    },
    {
      platFormCode: "JDB",
      gameType: "SLOT",
      casinoType: "JDB-SLOT-019",
      Name: "Banana Saga",
    },
    {
      platFormCode: "JDB",
      gameType: "SLOT",
      casinoType: "JDB-SLOT-020",
      Name: "Olympian Temple",
    },
    {
      platFormCode: "JDB",
      gameType: "SLOT",
      casinoType: "JDB-SLOT-025",
      Name: "Dragon",
    },
    {
      platFormCode: "JDB",
      gameType: "SLOT",
      casinoType: "JDB-SLOT-026",
      Name: "Rooster In Love",
    },
    {
      platFormCode: "JDB",
      gameType: "SLOT",
      casinoType: "JDB-SLOT-028",
      Name: "Moonlight Treasure",
    },
    {
      platFormCode: "JDB",
      gameType: "SLOT",
      casinoType: "JDB-SLOT-029",
      Name: "Mahjong",
    },
    {
      platFormCode: "JDB",
      gameType: "SLOT",
      casinoType: "JDB-SLOT-031",
      Name: "Billionaire",
    },
    {
      platFormCode: "JDB",
      gameType: "SLOT",
      casinoType: "JDB-SLOT-032",
      Name: "Dragon Warrior",
    },
    {
      platFormCode: "JDB",
      gameType: "SLOT",
      casinoType: "JDB-SLOT-033",
      Name: "Kingsman",
    },
    {
      platFormCode: "JDB",
      gameType: "SLOT",
      casinoType: "JDB-SLOT-041",
      Name: "Lucky Seven",
    },
    {
      platFormCode: "JDB",
      gameType: "SLOT",
      casinoType: "JDB-SLOT-042",
      Name: "Orient Animals",
    },
    {
      platFormCode: "JDB",
      gameType: "SLOT",
      casinoType: "JDB-SLOT-043",
      Name: "Triple King Kong",
    },
    {
      platFormCode: "JDB",
      gameType: "SLOT",
      casinoType: "JDB-SLOT-044",
      Name: "Legendary 5",
    },
    {
      platFormCode: "JDB",
      gameType: "SLOT",
      casinoType: "JDB-SLOT-045",
      Name: "Lucky Dragons",
    },
    {
      platFormCode: "JDB",
      gameType: "SLOT",
      casinoType: "JDB-SLOT-048",
      Name: "Napoleon",
    },
    {
      platFormCode: "JDB",
      gameType: "SLOT",
      casinoType: "JDB-SLOT-050",
      Name: "WinningMask II",
    },
    {
      platFormCode: "JDB",
      gameType: "SLOT",
      casinoType: "JDB-SLOT-051",
      Name: "Open Sesame II",
    },
    {
      platFormCode: "JDB",
      gameType: "SLOT",
      casinoType: "JDB-SLOT-053",
      Name: "Fortune Horse",
    },
    {
      platFormCode: "JDB",
      gameType: "SLOT",
      casinoType: "JDB-SLOT-054",
      Name: "Xi Yang Yang",
    },
    {
      platFormCode: "JDB",
      gameType: "SLOT",
      casinoType: "JDB-SLOT-066",
      Name: "Birds Party",
    },
    {
      platFormCode: "JDB",
      gameType: "SLOT",
      casinoType: "JDB-SLOT-067",
      Name: "Go Lai Fu",
    },
    {
      platFormCode: "JDB",
      gameType: "SLOT",
      casinoType: "JDB-SLOT-069",
      Name: "Dragons World",
    },
    {
      platFormCode: "JDB",
      gameType: "SLOT",
      casinoType: "JDB-SLOT-070",
      Name: "Super Niubi",
    },
    {
      platFormCode: "JDB",
      gameType: "SLOT",
      casinoType: "JDB-SLOT-072",
      Name: "Fortune Treasure",
    },
    {
      platFormCode: "JDB",
      gameType: "SLOT",
      casinoType: "JDB-SLOT-074",
      Name: "Mjoinir",
    },
    {
      platFormCode: "JDB",
      gameType: "SLOT",
      casinoType: "JDB-SLOT-075",
      Name: "Treasure Bowl",
    },
    {
      platFormCode: "JDB",
      gameType: "SLOT",
      casinoType: "JDB-SLOT-076",
      Name: "Funky King Kong",
    },
    {
      platFormCode: "JDB",
      gameType: "SLOT",
      casinoType: "JDB-SLOT-077",
      Name: "Super Niubi Deluxe",
    },
    {
      platFormCode: "JDB",
      gameType: "SLOT",
      casinoType: "JDB-SLOT-084",
      Name: "Golden Disco",
    },
    {
      platFormCode: "JDB",
      gameType: "SLOT",
      casinoType: "JDB-SLOT-085",
      Name: "Miner Babe",
    },
    {
      platFormCode: "JDB",
      gameType: "SLOT",
      casinoType: "JDB-SLOT-086",
      Name: "Moneybags Man",
    },
    {
      platFormCode: "JDB",
      gameType: "SLOT",
      casinoType: "JDB-SLOT-087",
      Name: "Double Wilds",
    },
    {
      platFormCode: "JDB",
      gameType: "SLOT",
      casinoType: "JDB-SLOT-089",
      Name: "Spindrift",
    },
    {
      platFormCode: "JDB",
      gameType: "SLOT",
      casinoType: "JDB-SLOT-090",
      Name: "Spindrift 2",
    },
    {
      platFormCode: "JDB",
      gameType: "SLOT",
      casinoType: "JDB-SLOT-092",
      Name: "Dragons Gate",
    },
    {
      platFormCode: "JDB",
      gameType: "SLOT",
      casinoType: "JDB-SLOT-093",
      Name: "Lucky Diamond",
    },
    {
      platFormCode: "JDB",
      gameType: "SLOT",
      casinoType: "JDB-SLOT-094",
      Name: "Kong",
    },
    {
      platFormCode: "JDB",
      gameType: "SLOT",
      casinoType: "JDB-SLOT-097",
      Name: "Wonder Elephant",
    },
    {
      platFormCode: "JDB",
      gameType: "SLOT",
      casinoType: "JDB-SLOT-098",
      Name: "MarvelousIV",
    },
    {
      platFormCode: "JDB",
      gameType: "SLOT",
      casinoType: "JDB-SLOT-099",
      Name: "Maya Gold Crazy",
    },
    {
      platFormCode: "JDB",
      gameType: "SLOT",
      casinoType: "JDB-SLOT-100",
      Name: "Prosperity Tiger",
    },
    {
      platFormCode: "JDB",
      gameType: "SLOT",
      casinoType: "JDB-SLOT-101",
      Name: "BlossomOfWealth",
    },
    {
      platFormCode: "JDB",
      gameType: "SLOT",
      casinoType: "JDB-SLOT-103",
      Name: "Glamorous Girl",
    },
    {
      platFormCode: "JDB",
      gameType: "SLOT",
      casinoType: "JDB-SLOT-105",
      Name: "BookOfMystery",
    },
    {
      platFormCode: "JDB",
      gameType: "SLOT",
      casinoType: "JDB-SLOT-106",
      Name: "FortuneNeko",
    },
    {
      platFormCode: "JDB",
      gameType: "SLOT",
      casinoType: "JDB-SLOT-107",
      Name: "Trump Card",
    },
    {
      platFormCode: "JDB",
      gameType: "SLOT",
      casinoType: "JDB-SLOT-108",
      Name: "Moneybags Man 2",
    },
    {
      platFormCode: "JDB",
      gameType: "SLOT",
      casinoType: "JDB-SLOT-109",
      Name: "Birds Party Deluxe",
    },
    {
      platFormCode: "JDB",
      gameType: "SLOT",
      casinoType: "JDB-SLOT-110",
      Name: "Elemental Link Fire",
    },
    {
      platFormCode: "JDB",
      gameType: "SLOT",
      casinoType: "JDB-SLOT-111",
      Name: "Elemental Link Water",
    },
    {
      platFormCode: "JDB",
      gameType: "SLOT",
      casinoType: "JDB-SLOT-112",
      Name: "CooCoo Farm",
    },
    {
      platFormCode: "JDB",
      gameType: "SLOT",
      casinoType: "JDB-SLOT-113",
      Name: "CaiShen Coming",
    },
    {
      platFormCode: "JDB",
      gameType: "SLOT",
      casinoType: "JDB-SLOT-114",
      Name: "Fruity Bonanza",
    },
    {
      platFormCode: "JDB",
      gameType: "SLOT",
      casinoType: "JDB-SLOT-115",
      Name: "LanternWealth",
    },
    {
      platFormCode: "JDB",
      gameType: "SLOT",
      casinoType: "JDB-SLOT-117",
      Name: "BigThreeDragons",
    },
    {
      platFormCode: "JDB",
      gameType: "SLOT",
      casinoType: "JDB-SLOT-119",
      Name: "Open Sesame Mega",
    },
    {
      platFormCode: "JDB",
      gameType: "SLOT",
      casinoType: "JDB-SLOT-120",
      Name: "Pop Pop Candy",
    },
    {
      platFormCode: "JDB",
      gameType: "SLOT",
      casinoType: "JDB-SLOT-121",
      Name: "Dragon Soar",
    },
    {
      platFormCode: "JDB",
      gameType: "SLOT",
      casinoType: "JDB-SLOT-122",
      Name: "Wealthway",
    },
    {
      platFormCode: "JDB",
      gameType: "SLOT",
      casinoType: "JDB-SLOT-123",
      Name: "Piggy Bank",
    },
    {
      platFormCode: "JDB",
      gameType: "SLOT",
      casinoType: "JDB-SLOT-124",
      Name: "Magic Ace",
    },
    {
      platFormCode: "JDB",
      gameType: "SLOT",
      casinoType: "JDB-SLOT-125",
      Name: "Dragon Soar - Hyper Wild",
    },
    {
      platFormCode: "JDB",
      gameType: "SLOT",
      casinoType: "JDB-SLOT-126",
      Name: "Bull Treasure",
    },
    {
      platFormCode: "JDB",
      gameType: "SLOT",
      casinoType: "JDB-SLOT-127",
      Name: "Magic Ace WILD LOCK",
    },
    {
      platFormCode: "JDB",
      gameType: "SLOT",
      casinoType: "JDB-SLOT-128",
      Name: "Fortune Jewel",
    },
    {
      platFormCode: "JDB",
      gameType: "SLOT",
      casinoType: "JDB-SLOT-129",
      Name: "Pop Pop Candy 1000",
    },
    {
      platFormCode: "JDB",
      gameType: "SLOT",
      casinoType: "JDB-SLOT-130",
      Name: "Fruity Bonanza Combo",
    },
    {
      platFormCode: "JDB",
      gameType: "SLOT",
      casinoType: "JDB-SLOT-131",
      Name: "Fishin' Fever X-Huge",
    },
    {
      platFormCode: "JDB",
      gameType: "SLOT",
      casinoType: "JDB-SLOT-132",
      Name: "Koi Trio",
    },
    {
      platFormCode: "JDB",
      gameType: "SLOT",
      casinoType: "JDB-SLOT-133",
      Name: "Ragnarok : Thor VS Loki",
    },
    {
      platFormCode: "JDB",
      gameType: "SLOT",
      casinoType: "JDB-SLOT-134",
      Name: "Olympig",
    },
    {
      platFormCode: "JDB",
      gameType: "SLOT",
      casinoType: "JDB-SLOT-135",
      Name: "Lucky Elephant X-Huge",
    },
    {
      platFormCode: "JDB",
      gameType: "TABLE",
      casinoType: "JDB-TABLE-001",
      Name: "PUSOY ",
    },
    {
      platFormCode: "JDB",
      gameType: "TABLE",
      casinoType: "JDB-TABLE-002",
      Name: "TONGITS",
    },
    {
      platFormCode: "JDB",
      gameType: "TABLE",
      casinoType: "JDB-TABLE-003",
      Name: "TONGITS FIGHT",
    },
    {
      platFormCode: "JDB",
      gameType: "TABLE",
      casinoType: "JDB-TABLE-004",
      Name: "PUSOY RUSH",
    },
    {
      platFormCode: "JDB",
      gameType: "TABLE",
      casinoType: "JDB-TABLE-005",
      Name: "TONGITS RUSH",
    },
    {
      platFormCode: "JDB",
      gameType: "TABLE",
      casinoType: "JDB-TABLE-006",
      Name: "Dragon Tiger - Joker Bonus",
    },
    {
      platFormCode: "JDB",
      gameType: "TABLE",
      casinoType: "JDB-TABLE-007",
      Name: "Teen Patti 20-20",
    },
    {
      platFormCode: "JDB",
      gameType: "TABLE",
      casinoType: "JDB-TABLE-009",
      Name: "Rummy",
    },
    {
      platFormCode: "JDB",
      gameType: "TABLE",
      casinoType: "JDB-TABLE-010",
      Name: "Andar Bahar",
    },
    {
      platFormCode: "JDB",
      gameType: "TABLE",
      casinoType: "JDB-TABLE-011",
      Name: "Pusoy Go",
    },
    {
      platFormCode: "JDB",
      gameType: "TABLE",
      casinoType: "JDB-TABLE-012",
      Name: "Tongits Go",
    },
  ],
  HOTROAD: [
    {
      platFormCode: "HOTROAD",
      gameType: "LIVE",
      casinoType: "HOTROAD-LIVE-001",
      Name: "BACCARAT",
    },
    {
      platFormCode: "HOTROAD",
      gameType: "LIVE",
      casinoType: "HOTROAD-LIVE-002",
      Name: "Roulette",
    },
    {
      platFormCode: "HOTROAD",
      gameType: "LIVE",
      casinoType: "HOTROAD-LIVE-003",
      Name: "Dragon Tiger",
    },
    {
      platFormCode: "HOTROAD",
      gameType: "LIVE",
      casinoType: "HOTROAD-LIVE-004",
      Name: "HOT ROULETTE",
    },
    {
      platFormCode: "HOTROAD",
      gameType: "LIVE",
      casinoType: "HOTROAD-LIVE-005",
      Name: "HOT COLOR GAME",
    },
    {
      platFormCode: "HOTROAD",
      gameType: "LIVE",
      casinoType: "HOTROAD-LIVE-006",
      Name: "HOT SICBO",
    },
    {
      platFormCode: "HOTROAD",
      gameType: "LIVE",
      casinoType: "HOTROAD-LIVE-007",
      Name: " HOT Baccarat",
    },
    {
      platFormCode: "HOTROAD",
      gameType: "LIVE",
      casinoType: "HOTROAD-LIVE-008",
      Name: "HOT 7up 7down",
    },
    {
      platFormCode: "HOTROAD",
      gameType: "LIVE",
      casinoType: "HOTROAD-LIVE-009",
      Name: "HOT Thai HI-LO",
    },
    {
      platFormCode: "HOTROAD",
      gameType: "LIVE",
      casinoType: "HOTROAD-LIVE-010",
      Name: "Xoc Dia",
    },
    {
      platFormCode: "HOTROAD",
      gameType: "LIVE",
      casinoType: "HOTROAD-LIVE-011",
      Name: "TIGER BACCARAT",
    },
    {
      platFormCode: "HOTROAD",
      gameType: "LIVE",
      casinoType: "HOTROAD-LIVE-012",
      Name: "HOT 8 Baccarat",
    },
    {
      platFormCode: "HOTROAD",
      gameType: "LIVE",
      casinoType: "HOTROAD-LIVE-013",
      Name: "Lucky 7 Baccarat",
    },
    {
      platFormCode: "HOTROAD",
      gameType: "LIVE",
      casinoType: "HOTROAD-LIVE-014",
      Name: "THREE CARD POKER",
    },
  ],
  FC: [
    {
      platFormCode: "FC",
      gameType: "EGAME",
      casinoType: "FC-EGAME-001",
      Name: "MONEY TREE DOZER",
    },
    {
      platFormCode: "FC",
      gameType: "EGAME",
      casinoType: "FC-EGAME-002",
      Name: "FA CHAI DOZER",
    },
    {
      platFormCode: "FC",
      gameType: "EGAME",
      casinoType: "FC-EGAME-003",
      Name: "CIRCUS DOZER",
    },
    {
      platFormCode: "FC",
      gameType: "EGAME",
      casinoType: "FC-EGAME-004",
      Name: "LIGHTNING BOMB",
    },
    {
      platFormCode: "FC",
      gameType: "EGAME",
      casinoType: "FC-EGAME-005",
      Name: "Super Color Game",
    },
    {
      platFormCode: "FC",
      gameType: "EGAME",
      casinoType: "FC-EGAME-006",
      Name: "GO GO RISE",
    },
    {
      platFormCode: "FC",
      gameType: "EGAME",
      casinoType: "FC-EGAME-007",
      Name: "MINES",
    },
    {
      platFormCode: "FC",
      gameType: "EGAME",
      casinoType: "FC-EGAME-008",
      Name: "TOWER",
    },
    {
      platFormCode: "FC",
      gameType: "FH",
      casinoType: "FC-FISH-001",
      Name: "MONKEY KING FISHING",
    },
    {
      platFormCode: "FC",
      gameType: "FH",
      casinoType: "FC-FISH-002",
      Name: "BAO CHUAN FISHING",
    },
    {
      platFormCode: "FC",
      gameType: "FH",
      casinoType: "FC-FISH-004",
      Name: "FIERCE FISHING",
    },
    {
      platFormCode: "FC",
      gameType: "FH",
      casinoType: "FC-FISH-005",
      Name: "STAR HUNTER",
    },
    {
      platFormCode: "FC",
      gameType: "FH",
      casinoType: "FC-FISH-006",
      Name: "GODS GRANT FORTUNE",
    },
    {
      platFormCode: "FC",
      gameType: "SLOT",
      casinoType: "FC-SLOT-001",
      Name: "GOLDEN PANTHER",
    },
    {
      platFormCode: "FC",
      gameType: "SLOT",
      casinoType: "FC-SLOT-002",
      Name: "THREE LITTLE PIGS",
    },
    {
      platFormCode: "FC",
      gameType: "SLOT",
      casinoType: "FC-SLOT-003",
      Name: "HOT POT PARTY",
    },
    {
      platFormCode: "FC",
      gameType: "SLOT",
      casinoType: "FC-SLOT-004",
      Name: "NIGHT MARKET",
    },
    {
      platFormCode: "FC",
      gameType: "SLOT",
      casinoType: "FC-SLOT-005",
      Name: "PONG PONG HU",
    },
    {
      platFormCode: "FC",
      gameType: "SLOT",
      casinoType: "FC-SLOT-006",
      Name: "PANDA DRAGON BOAT",
    },
    {
      platFormCode: "FC",
      gameType: "SLOT",
      casinoType: "FC-SLOT-007",
      Name: "CHINESE NEW YEAR",
    },
    {
      platFormCode: "FC",
      gameType: "SLOT",
      casinoType: "FC-SLOT-008",
      Name: "FORTUNE KOI",
    },
    {
      platFormCode: "FC",
      gameType: "SLOT",
      casinoType: "FC-SLOT-009",
      Name: "HAPPY DUO BAO",
    },
    {
      platFormCode: "FC",
      gameType: "SLOT",
      casinoType: "FC-SLOT-010",
      Name: "DA LE MEN",
    },
    {
      platFormCode: "FC",
      gameType: "SLOT",
      casinoType: "FC-SLOT-011",
      Name: "ANIMAL RACING",
    },
    {
      platFormCode: "FC",
      gameType: "SLOT",
      casinoType: "FC-SLOT-012",
      Name: "LUXURY GOLDEN PANTHER",
    },
    {
      platFormCode: "FC",
      gameType: "SLOT",
      casinoType: "FC-SLOT-013",
      Name: "MAGIC BEANS",
    },
    {
      platFormCode: "FC",
      gameType: "SLOT",
      casinoType: "FC-SLOT-014",
      Name: "COWBOYS",
    },
    {
      platFormCode: "FC",
      gameType: "SLOT",
      casinoType: "FC-SLOT-015",
      Name: "WAR OF THE UNIVERSE",
    },
    {
      platFormCode: "FC",
      gameType: "SLOT",
      casinoType: "FC-SLOT-016",
      Name: "TREASURE CRUISE",
    },
    {
      platFormCode: "FC",
      gameType: "SLOT",
      casinoType: "FC-SLOT-017",
      Name: "GOLD RUSH",
    },
    {
      platFormCode: "FC",
      gameType: "SLOT",
      casinoType: "FC-SLOT-018",
      Name: "RICH MAN",
    },
    {
      platFormCode: "FC",
      gameType: "SLOT",
      casinoType: "FC-SLOT-019",
      Name: "GLORY OF ROME",
    },
    {
      platFormCode: "FC",
      gameType: "SLOT",
      casinoType: "FC-SLOT-020",
      Name: "Robin Hood",
    },
    {
      platFormCode: "FC",
      gameType: "SLOT",
      casinoType: "FC-SLOT-021",
      Name: "Lucky Fortunes",
    },
    {
      platFormCode: "FC",
      gameType: "SLOT",
      casinoType: "FC-SLOT-022",
      Name: "CHINESE NEW YEAR 2",
    },
    {
      platFormCode: "FC",
      gameType: "SLOT",
      casinoType: "FC-SLOT-023",
      Name: "GRAND BLUE",
    },
    {
      platFormCode: "FC",
      gameType: "SLOT",
      casinoType: "FC-SLOT-024",
      Name: "TREASURE RAIDERS",
    },
    {
      platFormCode: "FC",
      gameType: "SLOT",
      casinoType: "FC-SLOT-025",
      Name: "SUGAR BANG BANG",
    },
    {
      platFormCode: "FC",
      gameType: "SLOT",
      casinoType: "FC-SLOT-026",
      Name: "CRAZY BUFFALO",
    },
    {
      platFormCode: "FC",
      gameType: "SLOT",
      casinoType: "FC-SLOT-027",
      Name: "MERGE MAGIC",
    },
    {
      platFormCode: "FC",
      gameType: "SLOT",
      casinoType: "FC-SLOT-028",
      Name: "GOLDEN GENIE",
    },
    {
      platFormCode: "FC",
      gameType: "SLOT",
      casinoType: "FC-SLOT-029",
      Name: "ZEUS",
    },
    {
      platFormCode: "FC",
      gameType: "SLOT",
      casinoType: "FC-SLOT-030",
      Name: "WIN WIN NEKO",
    },
    {
      platFormCode: "FC",
      gameType: "SLOT",
      casinoType: "FC-SLOT-031",
      Name: "FORTUNE EGG",
    },
    {
      platFormCode: "FC",
      gameType: "SLOT",
      casinoType: "FC-SLOT-032",
      Name: "NIGHT MARKET 2",
    },
    {
      platFormCode: "FC",
      gameType: "SLOT",
      casinoType: "FC-SLOT-033",
      Name: "SUPER ELEMENTS",
    },
    {
      platFormCode: "FC",
      gameType: "SLOT",
      casinoType: "FC-SLOT-034",
      Name: "LEGEND OF INCA",
    },
    {
      platFormCode: "FC",
      gameType: "SLOT",
      casinoType: "FC-SLOT-035",
      Name: "EGYPT BONANZA",
    },
    {
      platFormCode: "FC",
      gameType: "SLOT",
      casinoType: "FC-SLOT-036",
      Name: "CHILIHUAHUA",
    },
    {
      platFormCode: "FC",
      gameType: "SLOT",
      casinoType: "FC-SLOT-037",
      Name: "FORTUNE SHEEP",
    },
    {
      platFormCode: "FC",
      gameType: "SLOT",
      casinoType: "FC-SLOT-038",
      Name: "LUCKY FORTUNES 3x3",
    },
    {
      platFormCode: "FC",
      gameType: "SLOT",
      casinoType: "FC-SLOT-039",
      Name: "FORTUNE MONEY BOOM",
    },
    {
      platFormCode: "FC",
      gameType: "SLOT",
      casinoType: "FC-SLOT-040",
      Name: "QUEEN OF INCA",
    },
    {
      platFormCode: "FC",
      gameType: "SLOT",
      casinoType: "FC-SLOT-041",
      Name: "FORTUNE GODDESS",
    },
    {
      platFormCode: "FC",
      gameType: "SLOT",
      casinoType: "FC-SLOT-042",
      Name: "ROMA GLADIATRIX",
    },
    {
      platFormCode: "FC",
      gameType: "SLOT",
      casinoType: "FC-SLOT-043",
      Name: "CHINESE NEW YEAR MOREWAYS",
    },
    {
      platFormCode: "FC",
      gameType: "SLOT",
      casinoType: "FC-SLOT-044",
      Name: "POKER WIN",
    },
    {
      platFormCode: "FC",
      gameType: "SLOT",
      casinoType: "FC-SLOT-045",
      Name: "BOXING RICHES",
    },
    {
      platFormCode: "FC",
      gameType: "SLOT",
      casinoType: "FC-SLOT-048",
      Name: "SUGAR BANG BANG 2",
    },
    {
      platFormCode: "FC",
      gameType: "SLOT",
      casinoType: "FC-SLOT-050",
      Name: "PHOENIX FEVER",
    },
    {
      platFormCode: "FC",
      gameType: "SLOT",
      casinoType: "FC-SLOT-051",
      Name: "JUNGLE BANG BANG",
    },
    {
      platFormCode: "FC",
      gameType: "SLOT",
      casinoType: "FC-SLOT-052",
      Name: "TREASURES OF ODIN",
    },
    {
      platFormCode: "FC",
      gameType: "SLOT",
      casinoType: "FC-SLOT-053",
      Name: "SWORD OF KING",
    },
    {
      platFormCode: "FC",
      gameType: "SLOT",
      casinoType: "FC-SLOT-054",
      Name: "BUFFALO WAYS",
    },
    {
      platFormCode: "FC",
      gameType: "SLOT",
      casinoType: "FC-SLOT-055",
      Name: "CYBER GOD OF FORTUNE⁺",
    },
    {
      platFormCode: "FC",
      gameType: "SLOT",
      casinoType: "FC-SLOT-056",
      Name: "CATLA'S MONEY MACHINE",
    },
    {
      platFormCode: "FC",
      gameType: "SLOT",
      casinoType: "FC-SLOT-057",
      Name: "POKER WIN 2",
    },
  ],
  FASTSPIN: [
    {
      gameType: "FH",
      casinoType: "FastSpin-FISH-001",
      Name: "Fishing Treasure",
      platFormCode: "FASTSPIN",
    },
    {
      gameType: "FH",
      casinoType: "FastSpin-FISH-002",
      Name: "Ocean Carnival",
      platFormCode: "FASTSPIN",
    },
    {
      gameType: "SLOT",
      casinoType: "FastSpin-SLOT-001",
      Name: "Royale House",
      platFormCode: "FASTSPIN",
    },
    {
      gameType: "SLOT",
      casinoType: "FastSpin-SLOT-002",
      Name: "Sexy Vegas",
      platFormCode: "FASTSPIN",
    },
    {
      gameType: "SLOT",
      casinoType: "FastSpin-SLOT-003",
      Name: "Roma",
      platFormCode: "FASTSPIN",
    },
    {
      gameType: "SLOT",
      casinoType: "FastSpin-SLOT-004",
      Name: "Gold Rush Cowboy",
      platFormCode: "FASTSPIN",
    },
    {
      gameType: "SLOT",
      casinoType: "FastSpin-SLOT-005",
      Name: "Wild Wet Win",
      platFormCode: "FASTSPIN",
    },
    {
      gameType: "SLOT",
      casinoType: "FastSpin-SLOT-006",
      Name: "Royal Katt",
      platFormCode: "FASTSPIN",
    },
    {
      gameType: "SLOT",
      casinoType: "FastSpin-SLOT-007",
      Name: "Rich Caishen",
      platFormCode: "FASTSPIN",
    },
    {
      gameType: "SLOT",
      casinoType: "FastSpin-SLOT-008",
      Name: "Muay Thai Fighter",
      platFormCode: "FASTSPIN",
    },
    {
      gameType: "SLOT",
      casinoType: "FastSpin-SLOT-009",
      Name: "Poker Ways",
      platFormCode: "FASTSPIN",
    },
    {
      gameType: "SLOT",
      casinoType: "FastSpin-SLOT-010",
      Name: "Triple Happiness",
      platFormCode: "FASTSPIN",
    },
    {
      gameType: "SLOT",
      casinoType: "FastSpin-SLOT-011",
      Name: "Lucky Fortune",
      platFormCode: "FASTSPIN",
    },
    {
      gameType: "SLOT",
      casinoType: "FastSpin-SLOT-012",
      Name: "Fruits Mania",
      platFormCode: "FASTSPIN",
    },
    {
      gameType: "SLOT",
      casinoType: "FastSpin-SLOT-013",
      Name: "Fiery Lava",
      platFormCode: "FASTSPIN",
    },
    {
      gameType: "SLOT",
      casinoType: "FastSpin-SLOT-014",
      Name: "God of Wealth",
      platFormCode: "FASTSPIN",
    },
    {
      gameType: "SLOT",
      casinoType: "FastSpin-SLOT-015",
      Name: "Legend of Eagle",
      platFormCode: "FASTSPIN",
    },
    {
      gameType: "SLOT",
      casinoType: "FastSpin-SLOT-016",
      Name: "Neon Fantasy",
      platFormCode: "FASTSPIN",
    },
    {
      gameType: "SLOT",
      casinoType: "FastSpin-SLOT-017",
      Name: "Space Conquest",
      platFormCode: "FASTSPIN",
    },
    {
      gameType: "SLOT",
      casinoType: "FastSpin-SLOT-018",
      Name: "Loki",
      platFormCode: "FASTSPIN",
    },
    {
      gameType: "SLOT",
      casinoType: "FastSpin-SLOT-019",
      Name: "Fortune Lions",
      platFormCode: "FASTSPIN",
    },
    {
      gameType: "SLOT",
      casinoType: "FastSpin-SLOT-020",
      Name: "Honey Trap",
      platFormCode: "FASTSPIN",
    },
    {
      gameType: "SLOT",
      casinoType: "FastSpin-SLOT-021",
      Name: "Oceanic Melodies",
      platFormCode: "FASTSPIN",
    },
    {
      gameType: "SLOT",
      casinoType: "FastSpin-SLOT-022",
      Name: "The Maya Myth",
      platFormCode: "FASTSPIN",
    },
    {
      gameType: "SLOT",
      casinoType: "FastSpin-SLOT-023",
      Name: "Spin and Win",
      platFormCode: "FASTSPIN",
    },
    {
      gameType: "SLOT",
      casinoType: "FastSpin-SLOT-024",
      Name: "Safari Blitz",
      platFormCode: "FASTSPIN",
    },
    {
      gameType: "SLOT",
      casinoType: "FastSpin-SLOT-025",
      Name: "Goddess Of Egypt",
      platFormCode: "FASTSPIN",
    },
    {
      gameType: "SLOT",
      casinoType: "FastSpin-SLOT-026",
      Name: "Heavenly Fortunes 2",
      platFormCode: "FASTSPIN",
    },
    {
      gameType: "SLOT",
      casinoType: "FastSpin-SLOT-027",
      Name: "Ganesha Luck",
      platFormCode: "FASTSPIN",
    },
    {
      gameType: "SLOT",
      casinoType: "FastSpin-SLOT-028",
      Name: "Heavenly Fortunes",
      platFormCode: "FASTSPIN",
    },
    {
      gameType: "SLOT",
      casinoType: "FastSpin-SLOT-029",
      Name: "Mining Bonanza",
      platFormCode: "FASTSPIN",
    },
    {
      gameType: "SLOT",
      casinoType: "FastSpin-SLOT-030",
      Name: "The Nutcrackers",
      platFormCode: "FASTSPIN",
    },
    {
      gameType: "SLOT",
      casinoType: "FastSpin-SLOT-031",
      Name: "Legend of Nian",
      platFormCode: "FASTSPIN",
    },
    {
      gameType: "SLOT",
      casinoType: "FastSpin-SLOT-032",
      Name: "The Great Safari",
      platFormCode: "FASTSPIN",
    },
    {
      gameType: "SLOT",
      casinoType: "FastSpin-SLOT-033",
      Name: "Tiki Rush",
      platFormCode: "FASTSPIN",
    },
    {
      gameType: "SLOT",
      casinoType: "FastSpin-SLOT-034",
      Name: "Neko Riches",
      platFormCode: "FASTSPIN",
    },
    {
      gameType: "SLOT",
      casinoType: "FastSpin-SLOT-035",
      Name: "Mighty Sevens",
      platFormCode: "FASTSPIN",
    },
    {
      gameType: "SLOT",
      casinoType: "FastSpin-SLOT-036",
      Name: "Mushroom Bandit",
      platFormCode: "FASTSPIN",
    },
    {
      gameType: "SLOT",
      casinoType: "FastSpin-SLOT-037",
      Name: "City of Jewels",
      platFormCode: "FASTSPIN",
    },
    {
      gameType: "SLOT",
      casinoType: "FastSpin-SLOT-038",
      Name: "Sweet Frenzy",
      platFormCode: "FASTSPIN",
    },
    {
      gameType: "SLOT",
      casinoType: "FastSpin-SLOT-039",
      Name: "Leprechaun Bonanza",
      platFormCode: "FASTSPIN",
    },
    {
      gameType: "SLOT",
      casinoType: "FastSpin-SLOT-040",
      Name: "Money Empire",
      platFormCode: "FASTSPIN",
    },
    {
      gameType: "SLOT",
      casinoType: "FastSpin-SLOT-041",
      Name: "Yeti Boom",
      platFormCode: "FASTSPIN",
    },
    {
      gameType: "SLOT",
      casinoType: "FastSpin-SLOT-042",
      Name: "Ranger Showdown",
      platFormCode: "FASTSPIN",
    },
    {
      gameType: "SLOT",
      casinoType: "FastSpin-SLOT-043",
      Name: "Money Dragon",
      platFormCode: "FASTSPIN",
    },
    {
      gameType: "SLOT",
      casinoType: "FastSpin-SLOT-044",
      Name: "Adventure To The West",
      platFormCode: "FASTSPIN",
    },
    {
      gameType: "SLOT",
      casinoType: "FastSpin-SLOT-045",
      Name: "Farm Of Fortune",
      platFormCode: "FASTSPIN",
    },
    {
      gameType: "SLOT",
      casinoType: "FastSpin-SLOT-046",
      Name: "Caribbean Riches",
      platFormCode: "FASTSPIN",
    },
    {
      gameType: "SLOT",
      casinoType: "FastSpin-SLOT-047",
      Name: "Mahjong Princess",
      platFormCode: "FASTSPIN",
    },
    {
      gameType: "SLOT",
      casinoType: "FastSpin-SLOT-048",
      Name: "Pai Gow Ways",
      platFormCode: "FASTSPIN",
    },
    {
      gameType: "SLOT",
      casinoType: "FastSpin-SLOT-049",
      Name: "Nezha",
      platFormCode: "FASTSPIN",
    },
    {
      gameType: "SLOT",
      casinoType: "FastSpin-SLOT-050",
      Name: "Apollo Ray of Luck",
      platFormCode: "FASTSPIN",
    },
    {
      gameType: "SLOT",
      casinoType: "FastSpin-SLOT-051",
      Name: "Pumpkins Go Lucky",
      platFormCode: "FASTSPIN",
    },
    {
      gameType: "SLOT",
      casinoType: "FastSpin-SLOT-052",
      Name: "Beasts Of Luck",
      platFormCode: "FASTSPIN",
    },
    {
      gameType: "SLOT",
      casinoType: "FastSpin-SLOT-053",
      Name: "Guardian of The Museum",
      platFormCode: "FASTSPIN",
    },
    {
      gameType: "SLOT",
      casinoType: "FastSpin-SLOT-054",
      Name: "Snake Treasure",
      platFormCode: "FASTSPIN",
    },
    {
      gameType: "SLOT",
      casinoType: "FastSpin-SLOT-055",
      Name: "Alien Smash",
      platFormCode: "FASTSPIN",
    },
    {
      gameType: "SLOT",
      casinoType: "FastSpin-SLOT-056",
      Name: "Wild Mafia",
      platFormCode: "FASTSPIN",
    },
    {
      gameType: "SLOT",
      casinoType: "FastSpin-SLOT-057",
      Name: "Blade of Fortune",
      platFormCode: "FASTSPIN",
    },
    {
      gameType: "SLOT",
      casinoType: "FastSpin-SLOT-058",
      Name: "Jungle Quest",
      platFormCode: "FASTSPIN",
    },
    {
      gameType: "SLOT",
      casinoType: "FastSpin-SLOT-059",
      Name: "Candy Super Tumble",
      platFormCode: "FASTSPIN",
    },
    {
      gameType: "SLOT",
      casinoType: "FastSpin-SLOT-060",
      Name: "Wild Calavera",
      platFormCode: "FASTSPIN",
    },
    {
      gameType: "SLOT",
      casinoType: "FastSpin-SLOT-061",
      Name: "Fortune Jewels I",
      platFormCode: "FASTSPIN",
    },
    {
      gameType: "SLOT",
      casinoType: "FastSpin-SLOT-062",
      Name: "Golden Moon Empire",
      platFormCode: "FASTSPIN",
    },
    {
      gameType: "SLOT",
      casinoType: "FastSpin-SLOT-063",
      Name: "Boxing Fury",
      platFormCode: "FASTSPIN",
    },
    {
      gameType: "SLOT",
      casinoType: "FastSpin-SLOT-064",
      Name: "Fortune Jewels 2",
      platFormCode: "FASTSPIN",
    },
    {
      gameType: "SLOT",
      casinoType: "FastSpin-SLOT-065",
      Name: "Nutty Riches",
      platFormCode: "FASTSPIN",
    },
  ],
  DREAMGAMMING: [
    {
      platFormCode: "DREAMGAMING",
      gameType: "LIVE",
      casinoType: "DREAMGAMING-LIVE-001",
      Name: "Baccarat",
    },
    {
      platFormCode: "DREAMGAMING",
      gameType: "LIVE",
      casinoType: "DREAMGAMING-LIVE-002",
      Name: "Baccarat",
    },
    {
      platFormCode: "DREAMGAMING",
      gameType: "LIVE",
      casinoType: "DREAMGAMING-LIVE-003",
      Name: "Baccarat",
    },
    {
      platFormCode: "DREAMGAMING",
      gameType: "LIVE",
      casinoType: "DREAMGAMING-LIVE-004",
      Name: "Baccarat",
    },
    {
      platFormCode: "DREAMGAMING",
      gameType: "LIVE",
      casinoType: "DREAMGAMING-LIVE-005",
      Name: "Baccarat",
    },
    {
      platFormCode: "DREAMGAMING",
      gameType: "LIVE",
      casinoType: "DREAMGAMING-LIVE-006",
      Name: "Baccarat",
    },
    {
      platFormCode: "DREAMGAMING",
      gameType: "LIVE",
      casinoType: "DREAMGAMING-LIVE-007",
      Name: "Baccarat",
    },
    {
      platFormCode: "DREAMGAMING",
      gameType: "LIVE",
      casinoType: "DREAMGAMING-LIVE-008",
      Name: "Baccarat",
    },
    {
      platFormCode: "DREAMGAMING",
      gameType: "LIVE",
      casinoType: "DREAMGAMING-LIVE-009",
      Name: "Baccarat",
    },
    {
      platFormCode: "DREAMGAMING",
      gameType: "LIVE",
      casinoType: "DREAMGAMING-LIVE-010",
      Name: "Bid Baccarat",
    },
    {
      platFormCode: "DREAMGAMING",
      gameType: "LIVE",
      casinoType: "DREAMGAMING-LIVE-011",
      Name: "Bid Baccarat",
    },
    {
      platFormCode: "DREAMGAMING",
      gameType: "LIVE",
      casinoType: "DREAMGAMING-LIVE-012",
      Name: "InBaccarat",
    },
    {
      platFormCode: "DREAMGAMING",
      gameType: "LIVE",
      casinoType: "DREAMGAMING-LIVE-013",
      Name: "InBaccarat",
    },
    {
      platFormCode: "DREAMGAMING",
      gameType: "LIVE",
      casinoType: "DREAMGAMING-LIVE-014",
      Name: "DragonTiger",
    },
    {
      platFormCode: "DREAMGAMING",
      gameType: "LIVE",
      casinoType: "DREAMGAMING-LIVE-015",
      Name: "DragonTiger",
    },
    {
      platFormCode: "DREAMGAMING",
      gameType: "LIVE",
      casinoType: "DREAMGAMING-LIVE-016",
      Name: "Roulette",
    },
    {
      platFormCode: "DREAMGAMING",
      gameType: "LIVE",
      casinoType: "DREAMGAMING-LIVE-017",
      Name: "Sicbo",
    },
    {
      platFormCode: "DREAMGAMING",
      gameType: "LIVE",
      casinoType: "DREAMGAMING-LIVE-018",
      Name: "Bull",
    },
    {
      platFormCode: "DREAMGAMING",
      gameType: "LIVE",
      casinoType: "DREAMGAMING-LIVE-019",
      Name: "ThreeCard",
    },
    {
      platFormCode: "DREAMGAMING",
      gameType: "LIVE",
      casinoType: "DREAMGAMING-LIVE-020",
      Name: "Three Face",
    },
    {
      platFormCode: "DREAMGAMING",
      gameType: "LIVE",
      casinoType: "DREAMGAMING-LIVE-021",
      Name: "Baccarat",
    },
    {
      platFormCode: "DREAMGAMING",
      gameType: "LIVE",
      casinoType: "DREAMGAMING-LIVE-022",
      Name: "Baccarat",
    },
    {
      platFormCode: "DREAMGAMING",
      gameType: "LIVE",
      casinoType: "DREAMGAMING-LIVE-023",
      Name: "Baccarat",
    },
    {
      platFormCode: "DREAMGAMING",
      gameType: "LIVE",
      casinoType: "DREAMGAMING-LIVE-024",
      Name: "Baccarat",
    },
    {
      platFormCode: "DREAMGAMING",
      gameType: "LIVE",
      casinoType: "DREAMGAMING-LIVE-025",
      Name: "InBaccarat",
    },
    {
      platFormCode: "DREAMGAMING",
      gameType: "LIVE",
      casinoType: "DREAMGAMING-LIVE-026",
      Name: "DragonTiger",
    },
    {
      platFormCode: "DREAMGAMING",
      gameType: "LIVE",
      casinoType: "DREAMGAMING-LIVE-027",
      Name: "Roulette",
    },
    {
      platFormCode: "DREAMGAMING",
      gameType: "LIVE",
      casinoType: "DREAMGAMING-LIVE-028",
      Name: "Sedie",
    },
    {
      platFormCode: "DREAMGAMING",
      gameType: "LIVE",
      casinoType: "DREAMGAMING-LIVE-029",
      Name: "AndarBahar",
    },
    {
      platFormCode: "DREAMGAMING",
      gameType: "LIVE",
      casinoType: "DREAMGAMING-LIVE-030",
      Name: "Site Baccarat",
    },
    {
      platFormCode: "DREAMGAMING",
      gameType: "LIVE",
      casinoType: "DREAMGAMING-LIVE-031",
      Name: "Site Baccarat",
    },
    {
      platFormCode: "DREAMGAMING",
      gameType: "LIVE",
      casinoType: "DREAMGAMING-LIVE-032",
      Name: "Site Baccarat",
    },
    {
      platFormCode: "DREAMGAMING",
      gameType: "LIVE",
      casinoType: "DREAMGAMING-LIVE-033",
      Name: "Site Baccarat",
    },
    {
      platFormCode: "DREAMGAMING",
      gameType: "LIVE",
      casinoType: "DREAMGAMING-LIVE-034",
      Name: "Site DragonTiger",
    },
    {
      platFormCode: "DREAMGAMING",
      gameType: "LIVE",
      casinoType: "DREAMGAMING-LIVE-035",
      Name: "Site Roulette",
    },
    {
      platFormCode: "DREAMGAMING",
      gameType: "LIVE",
      casinoType: "DREAMGAMING-LIVE-036",
      Name: "FanTan",
    },
    {
      platFormCode: "DREAMGAMING",
      gameType: "LIVE",
      casinoType: "DREAMGAMING-LIVE-037",
      Name: "Baccarat",
    },
    {
      platFormCode: "DREAMGAMING",
      gameType: "LIVE",
      casinoType: "DREAMGAMING-LIVE-038",
      Name: "Baccarat",
    },
    {
      platFormCode: "DREAMGAMING",
      gameType: "LIVE",
      casinoType: "DREAMGAMING-LIVE-039",
      Name: "Baccarat",
    },
    {
      platFormCode: "DREAMGAMING",
      gameType: "LIVE",
      casinoType: "DREAMGAMING-LIVE-040",
      Name: "Baccarat",
    },
    {
      platFormCode: "DREAMGAMING",
      gameType: "LIVE",
      casinoType: "DREAMGAMING-LIVE-041",
      Name: "Baccarat",
    },
    {
      platFormCode: "DREAMGAMING",
      gameType: "LIVE",
      casinoType: "DREAMGAMING-LIVE-042",
      Name: "Blockchain Baccarat",
    },
    {
      platFormCode: "DREAMGAMING",
      gameType: "LIVE",
      casinoType: "DREAMGAMING-LIVE-043",
      Name: "Blockchain Baccarat",
    },
    {
      platFormCode: "DREAMGAMING",
      gameType: "LIVE",
      casinoType: "DREAMGAMING-LIVE-044",
      Name: "Blockchain Baccarat",
    },
    {
      platFormCode: "DREAMGAMING",
      gameType: "LIVE",
      casinoType: "DREAMGAMING-LIVE-045",
      Name: "Blockchain Baccarat",
    },
    {
      platFormCode: "DREAMGAMING",
      gameType: "LIVE",
      casinoType: "DREAMGAMING-LIVE-046",
      Name: "Blockchain Baccarat",
    },
    {
      platFormCode: "DREAMGAMING",
      gameType: "LIVE",
      casinoType: "DREAMGAMING-LIVE-047",
      Name: "Blockchain Baccarat",
    },
    {
      platFormCode: "DREAMGAMING",
      gameType: "LIVE",
      casinoType: "DREAMGAMING-LIVE-048",
      Name: "Blockchain DragonTiger",
    },
    {
      platFormCode: "DREAMGAMING",
      gameType: "LIVE",
      casinoType: "DREAMGAMING-LIVE-049",
      Name: "Blockchain DragonTiger",
    },
    {
      platFormCode: "DREAMGAMING",
      gameType: "LIVE",
      casinoType: "DREAMGAMING-LIVE-050",
      Name: "Blockchain Three Cards",
    },
    {
      platFormCode: "DREAMGAMING",
      gameType: "LIVE",
      casinoType: "DREAMGAMING-LIVE-051",
      Name: "Blockchain Bull bull",
    },
    {
      platFormCode: "DREAMGAMING",
      gameType: "LIVE",
      casinoType: "DREAMGAMING-LIVE-052",
      Name: "Blockchain ThreeFace",
    },
    {
      platFormCode: "DREAMGAMING",
      gameType: "LIVE",
      casinoType: "DREAMGAMING-LIVE-053",
      Name: "Blockchain AndarBahar",
    },
    {
      platFormCode: "DREAMGAMING",
      gameType: "LIVE",
      casinoType: "DREAMGAMING-LIVE-054",
      Name: "Site Baccarat",
    },
    {
      platFormCode: "DREAMGAMING",
      gameType: "LIVE",
      casinoType: "DREAMGAMING-LIVE-055",
      Name: "Blockchain Baccarat",
    },
    {
      platFormCode: "DREAMGAMING",
      gameType: "LIVE",
      casinoType: "DREAMGAMING-LIVE-056",
      Name: "Blockchain Baccarat",
    },
    {
      platFormCode: "DREAMGAMING",
      gameType: "LIVE",
      casinoType: "DREAMGAMING-LIVE-057",
      Name: "Blockchain Baccarat",
    },
    {
      platFormCode: "DREAMGAMING",
      gameType: "LIVE",
      casinoType: "DREAMGAMING-LIVE-058",
      Name: "Blockchain Baccarat",
    },
    {
      platFormCode: "DREAMGAMING",
      gameType: "LIVE",
      casinoType: "DREAMGAMING-LIVE-059",
      Name: "Blockchain Baccarat",
    },
    {
      platFormCode: "DREAMGAMING",
      gameType: "LIVE",
      casinoType: "DREAMGAMING-LIVE-060",
      Name: "Blockchain Baccarat",
    },
    {
      platFormCode: "DREAMGAMING",
      gameType: "LIVE",
      casinoType: "DREAMGAMING-LIVE-061",
      Name: "Blockchain DragonTiger",
    },
    {
      platFormCode: "DREAMGAMING",
      gameType: "LIVE",
      casinoType: "DREAMGAMING-LIVE-062",
      Name: "Blockchain DragonTiger",
    },
    {
      platFormCode: "DREAMGAMING",
      gameType: "LIVE",
      casinoType: "DREAMGAMING-LIVE-063",
      Name: "Blockchain Three Cards",
    },
    {
      platFormCode: "DREAMGAMING",
      gameType: "LIVE",
      casinoType: "DREAMGAMING-LIVE-064",
      Name: "Blockchain Bull bull",
    },
    {
      platFormCode: "DREAMGAMING",
      gameType: "LIVE",
      casinoType: "DREAMGAMING-LIVE-065",
      Name: "Blockchain ThreeFace",
    },
    {
      platFormCode: "DREAMGAMING",
      gameType: "LIVE",
      casinoType: "DREAMGAMING-LIVE-066",
      Name: "Blockchain AndarBahar",
    },
    {
      platFormCode: "DREAMGAMING",
      gameType: "LIVE",
      casinoType: "DREAMGAMING-LIVE-067",
      Name: "Blockchain Sicbo",
    },
    {
      platFormCode: "DREAMGAMING",
      gameType: "LIVE",
      casinoType: "DREAMGAMING-LIVE-068",
      Name: "Blockchain Sicbo",
    },
    {
      platFormCode: "DREAMGAMING",
      gameType: "LIVE",
      casinoType: "DREAMGAMING-LIVE-069",
      Name: "Sicbo",
    },
    {
      platFormCode: "DREAMGAMING",
      gameType: "LIVE",
      casinoType: "DREAMGAMING-LIVE-070",
      Name: "Blockchain Roulette",
    },
    {
      platFormCode: "DREAMGAMING",
      gameType: "LIVE",
      casinoType: "DREAMGAMING-LIVE-071",
      Name: "Blockchain Roulette",
    },
    {
      platFormCode: "DREAMGAMING",
      gameType: "LIVE",
      casinoType: "DREAMGAMING-LIVE-072",
      Name: "Blockchain Blackjack",
    },
    {
      platFormCode: "DREAMGAMING",
      gameType: "LIVE",
      casinoType: "DREAMGAMING-LIVE-073",
      Name: "Blockchain Blackjack",
    },
    {
      platFormCode: "DREAMGAMING",
      gameType: "LIVE",
      casinoType: "DREAMGAMING-LIVE-074",
      Name: "Blockchain Blackjack",
    },
    {
      platFormCode: "DREAMGAMING",
      gameType: "LIVE",
      casinoType: "DREAMGAMING-LIVE-075",
      Name: "Blockchain Blackjack",
    },
    {
      platFormCode: "DREAMGAMING",
      gameType: "LIVE",
      casinoType: "DREAMGAMING-LIVE-076",
      Name: "Blackjack",
    },
    {
      platFormCode: "DREAMGAMING",
      gameType: "LIVE",
      casinoType: "DREAMGAMING-LIVE-077",
      Name: "Blockchain Blackjack",
    },
    {
      platFormCode: "DREAMGAMING",
      gameType: "LIVE",
      casinoType: "DREAMGAMING-LIVE-078",
      Name: "Blockchain Blackjack",
    },
    {
      platFormCode: "DREAMGAMING",
      gameType: "LIVE",
      casinoType: "DREAMGAMING-LIVE-079",
      Name: "Blockchain Blackjack",
    },
    {
      platFormCode: "DREAMGAMING",
      gameType: "LIVE",
      casinoType: "DREAMGAMING-LIVE-080",
      Name: "Blockchain Blackjack",
    },
    {
      platFormCode: "DREAMGAMING",
      gameType: "LIVE",
      casinoType: "DREAMGAMING-LIVE-081",
      Name: "Baccarat",
    },
    {
      platFormCode: "DREAMGAMING",
      gameType: "LIVE",
      casinoType: "DREAMGAMING-LIVE-082",
      Name: "Baccarat",
    },
    {
      platFormCode: "DREAMGAMING",
      gameType: "LIVE",
      casinoType: "DREAMGAMING-LIVE-083",
      Name: "Sedie",
    },
    {
      platFormCode: "DREAMGAMING",
      gameType: "LIVE",
      casinoType: "DREAMGAMING-LIVE-084",
      Name: "Sedie",
    },
    {
      platFormCode: "DREAMGAMING",
      gameType: "LIVE",
      casinoType: "DREAMGAMING-LIVE-085",
      Name: "Blockchain Sedie",
    },
    {
      platFormCode: "DREAMGAMING",
      gameType: "LIVE",
      casinoType: "DREAMGAMING-LIVE-086",
      Name: "Blockchain Sedie",
    },
  ],
  DRAGONSOFT: [
    {
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-001",
      Name: "Coin Cat",
    },
    {
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-002",
      Name: "Phoenix",
    },
    {
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-003",
      Name: "777",
    },
    {
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-004",
      Name: "Get Money",
    },
    {
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-005",
      Name: "Rich Now",
    },
    {
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-006",
      Name: "Chef Lady",
    },
    {
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-007",
      Name: "Doggy Wealth",
    },
    {
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-008",
      Name: "Dracula",
    },
    {
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-009",
      Name: "Maya King",
    },
    {
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-010",
      Name: "Pirate King",
    },
    {
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-011",
      Name: "Diamond Mogul",
    },
    {
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-012",
      Name: "Over Dragon's Gate",
    },
    {
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-013",
      Name: "Great Lion",
    },
    {
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-014",
      Name: "Ultra Treasure",
    },
    {
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-015",
      Name: "Egypt Oracle",
    },
    {
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-016",
      Name: "Caishen Coming",
    },
    {
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-017",
      Name: "Candy Dynasty",
    },
    {
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-018",
      Name: "Rich Lion",
    },
    {
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-019",
      Name: "Monkey King",
    },
    {
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-020",
      Name: "Bust Treasury",
    },
    {
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-021",
      Name: "5 God Beast",
    },
    {
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-022",
      Name: "Get High",
    },
    {
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-023",
      Name: "Arab",
    },
    {
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-024",
      Name: "Wolf Legend",
    },
    {
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-025",
      Name: "Crystal Fruits",
    },
    {
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-026",
      Name: "Golf",
    },
    {
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-027",
      Name: "Tiger Lord",
    },
    {
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-028",
      Name: "Zeus",
    },
    {
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-029",
      Name: "Alice",
    },
    {
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-030",
      Name: "Stone Hominid",
    },
    {
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-031",
      Name: "T-Rex",
    },
    {
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-032",
      Name: "Greatest Circus",
    },
    {
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-033",
      Name: "Midas Touch",
    },
    {
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-034",
      Name: "Fruits Bar",
    },
    {
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-035",
      Name: "Rich Dragon",
    },
    {
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-036",
      Name: "JIN HOU YE",
    },
    {
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-037",
      Name: "Fushen Coming",
    },
    {
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-038",
      Name: "Pandaria",
    },
    {
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-039",
      Name: "Triple Monkey",
    },
    {
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-040",
      Name: "ZHAO YUN",
    },
    {
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-041",
      Name: "LU LING QI",
    },
    {
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-042",
      Name: "Booming Gems",
    },
    {
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-043",
      Name: "Many Beauties",
    },
    {
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-044",
      Name: "More Beauties",
    },
    {
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-045",
      Name: "Immortal Heroes",
    },
    {
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-046",
      Name: "Coin Rat",
    },
    {
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-047",
      Name: "Ore Power",
    },
    {
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-048",
      Name: "Icy Bar",
    },
    {
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-049",
      Name: "Golden Eye",
    },
    {
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-050",
      Name: "Chicken Dinner",
    },
    {
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-051",
      Name: "Farm Family",
    },
    {
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-052",
      Name: "Roman",
    },
    {
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-053",
      Name: "Big Diamond",
    },
    {
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-054",
      Name: "Muay Thai",
    },
    {
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-055",
      Name: "Egypt Dynasty",
    },
    {
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-056",
      Name: "Dragon's Treasure",
    },
    {
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-057",
      Name: "You Will Win",
    },
    {
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-059",
      Name: "Rich Ox",
    },
    {
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-060",
      Name: "Diamond 7",
    },
    {
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-061",
      Name: "Bonus Cat",
    },
    {
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-062",
      Name: "Bakufu Shogun",
    },
    {
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-063",
      Name: "Bengal Tiger",
    },
    {
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-064",
      Name: "Dragonburst",
    },
    {
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-065",
      Name: "Buffalo Burst",
    },
    {
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-066",
      Name: "Roll in Money",
    },
    {
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-067",
      Name: "Worldie",
    },
    {
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-068",
      Name: "Grand Sheriff",
    },
    {
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-069",
      Name: "Overlord & Concubine",
    },
    {
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-070",
      Name: "King's Sword",
    },
    {
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-071",
      Name: "Party Night",
    },
    {
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-072",
      Name: "Wonderful Christmas",
    },
    {
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-073",
      Name: "Golf2",
    },
    {
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-074",
      Name: "Halloween Win",
    },
    {
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-075",
      Name: "Mahjong Win",
    },
    {
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-076",
      Name: "Super Hoo Hey How",
    },
    {
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-077",
      Name: "Fortune Twins",
    },
    {
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-078",
      Name: "Dancing Samba",
    },
    {
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-079",
      Name: "Midas Hand",
    },
    {
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-080",
      Name: "Fire Ball Blaze Phoenix",
    },
    {
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-081",
      Name: "Much Richer",
    },
    {
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-082",
      Name: "Odin Territory",
    },
    {
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-083",
      Name: "Zhen Long Ju Bao",
    },
    {
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-084",
      Name: "Bounty Clash",
    },
    {
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-085",
      Name: "Lucky Bunny",
    },
    {
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-086",
      Name: "Volcanic Legend",
    },
    {
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-087",
      Name: "Red Dragon’s Treasure",
    },
    {
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-088",
      Name: "Mahjong Win 2",
    },
    {
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-089",
      Name: "Neko Treasures",
    },
  ],
  CG: [
    {
      platFormCode: "CG",
      gameType: "EGAME",
      casinoType: "CG-EGAME-001",
      Name: "Lucky5",
    },
    {
      platFormCode: "CG",
      gameType: "EGAME",
      casinoType: "CG-EGAME-002",
      Name: "Deuces Wild",
    },
    {
      platFormCode: "CG",
      gameType: "EGAME",
      casinoType: "CG-EGAME-003",
      Name: "Dragon Game Poker",
    },
    {
      platFormCode: "CG",
      gameType: "EGAME",
      casinoType: "CG-EGAME-004",
      Name: "Rich Runner",
    },
    {
      platFormCode: "CG",
      gameType: "EGAME",
      casinoType: "CG-EGAME-005",
      Name: "Pig Racing",
    },
    {
      platFormCode: "CG",
      gameType: "EGAME",
      casinoType: "CG-EGAME-006",
      Name: "Kings Queen",
    },
    {
      platFormCode: "CG",
      gameType: "EGAME",
      casinoType: "CG-EGAME-007",
      Name: "Benz BMW",
    },
    {
      platFormCode: "CG",
      gameType: "EGAME",
      casinoType: "CG-EGAME-008",
      Name: "Little Mary",
    },
    {
      platFormCode: "CG",
      gameType: "EGAME",
      casinoType: "CG-EGAME-009",
      Name: "Street Fighter V",
    },
    {
      platFormCode: "CG",
      gameType: "EGAME",
      casinoType: "CG-EGAME-010",
      Name: "plinko",
    },
    {
      platFormCode: "CG",
      gameType: "EGAME",
      casinoType: "CG-EGAME-011",
      Name: "Pikachu Volleyball",
    },
    {
      platFormCode: "CG",
      gameType: "EGAME",
      casinoType: "CG-EGAME-012",
      Name: "KOFXV",
    },
    {
      platFormCode: "CG",
      gameType: "EGAME",
      casinoType: "CG-EGAME-013",
      Name: "Captain Tsubasa",
    },
    {
      platFormCode: "CG",
      gameType: "EGAME",
      casinoType: "CG-EGAME-014",
      Name: "Mariokart 8",
    },
    {
      platFormCode: "CG",
      gameType: "EGAME",
      casinoType: "CG-EGAME-015",
      Name: "Kart Crash",
    },
    {
      platFormCode: "CG",
      gameType: "EGAME",
      casinoType: "CG-EGAME-016",
      Name: "Richman Crash",
    },
    {
      platFormCode: "CG",
      gameType: "EGAME",
      casinoType: "CG-EGAME-017",
      Name: "CrossyRoad Crash",
    },
    {
      platFormCode: "CG",
      gameType: "EGAME",
      casinoType: "CG-EGAME-018",
      Name: "Angry Birds",
    },
    {
      platFormCode: "CG",
      gameType: "EGAME",
      casinoType: "CG-EGAME-019",
      Name: "Astronaut",
    },
    {
      platFormCode: "CG",
      gameType: "EGAME",
      casinoType: "CG-EGAME-020",
      Name: "JOJO",
    },
    {
      platFormCode: "CG",
      gameType: "EGAME",
      casinoType: "CG-EGAME-021",
      Name: "Jump Force",
    },
    {
      platFormCode: "CG",
      gameType: "EGAME",
      casinoType: "CG-EGAME-022",
      Name: "Street Fighter 6",
    },
    {
      platFormCode: "CG",
      gameType: "EGAME",
      casinoType: "CG-EGAME-023",
      Name: "RoosterFightingClub",
    },
    {
      platFormCode: "CG",
      gameType: "EGAME",
      casinoType: "CG-EGAME-024",
      Name: "Bingo Baccarat",
    },
    {
      platFormCode: "CG",
      gameType: "EGAME",
      casinoType: "CG-EGAME-025",
      Name: "TEKKEN7",
    },
    {
      platFormCode: "CG",
      gameType: "EGAME",
      casinoType: "CG-EGAME-026",
      Name: "NARUTO4",
    },
    {
      platFormCode: "CG",
      gameType: "EGAME",
      casinoType: "CG-EGAME-028",
      Name: "2024CyclingTrack",
    },
    {
      platFormCode: "CG",
      gameType: "EGAME",
      casinoType: "CG-EGAME-029",
      Name: "2024Hockey2024",
    },
    {
      platFormCode: "CG",
      gameType: "EGAME",
      casinoType: "CG-EGAME-031",
      Name: "2024Volleyball",
    },
    {
      platFormCode: "CG",
      gameType: "EGAME",
      casinoType: "CG-EGAME-032",
      Name: "2024Weightlifting",
    },
    {
      platFormCode: "CG",
      gameType: "EGAME",
      casinoType: "CG-EGAME-033",
      Name: "DragonBallXV2",
    },
    {
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-001",
      Name: "Richman",
    },
    {
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-002",
      Name: "Jurassic Park",
    },
    {
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-003",
      Name: "Halloween",
    },
    {
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-004",
      Name: "Amazing Circus",
    },
    {
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-005",
      Name: "Tai Wang Si Shen",
    },
    {
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-006",
      Name: "BreakAway",
    },
    {
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-007",
      Name: "1c dafudacai-5Treasures",
    },
    {
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-008",
      Name: "1c dafudacai-88Fortunes",
    },
    {
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-009",
      Name: "1c dafudacai-DiamondEternity",
    },
    {
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-010",
      Name: "1c dafudacai-DancingDrum",
    },
    {
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-011",
      Name: "1c dafudacai-FlowerOfRiches",
    },
    {
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-012",
      Name: "Platinum",
    },
    {
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-013",
      Name: "1c JuFuNaCai-Golden Tale",
    },
    {
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-014",
      Name: "1c JuFuNaCai-Eternal Diamond",
    },
    {
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-015",
      Name: "1c JuFuNaCai-Fountain Of Wealth",
    },
    {
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-016",
      Name: "1c JuFuNaCai-Blooming Riches",
    },
    {
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-017",
      Name: "1c JuFuNaCai-Rhythm Of Fortune",
    },
    {
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-018",
      Name: "Funky Monkey",
    },
    {
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-019",
      Name: "Long Long Long",
    },
    {
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-020",
      Name: "Fa Fa Fa",
    },
    {
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-021",
      Name: "777",
    },
    {
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-022",
      Name: "Chaoji 8",
    },
    {
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-023",
      Name: "Arcadia",
    },
    {
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-024",
      Name: "City Of Poli",
    },
    {
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-025",
      Name: "Dragon Skies",
    },
    {
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-026",
      Name: "As The Gods Will",
    },
    {
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-027",
      Name: "Hungry Hungry Shark",
    },
    {
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-028",
      Name: "Jo ma ji",
    },
    {
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-029",
      Name: "Tarzan",
    },
    {
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-030",
      Name: "Diamond Slot",
    },
    {
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-031",
      Name: "50 Lions",
    },
    {
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-032",
      Name: "Speed Racing",
    },
    {
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-033",
      Name: "Marvel Tsum Tsum",
    },
    {
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-034",
      Name: "New Get Rich",
    },
    {
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-035",
      Name: "Special Chef",
    },
    {
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-036",
      Name: "Wu Lu Cai Shen",
    },
    {
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-037",
      Name: "Fishing Expert",
    },
    {
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-038",
      Name: "Zhao Cai Tong Zi",
    },
    {
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-039",
      Name: "Zhao Cai Jin Bao",
    },
    {
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-040",
      Name: "Money Farm 3",
    },
    {
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-041",
      Name: "Fish Party",
    },
    {
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-042",
      Name: "Queen Of Cash",
    },
    {
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-043",
      Name: "Lucky Twins",
    },
    {
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-044",
      Name: "Sun Quest",
    },
    {
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-045",
      Name: "5 Dragons",
    },
    {
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-046",
      Name: "Lucky Pig",
    },
    {
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-047",
      Name: "True Zhao Cai Jin Bao",
    },
    {
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-048",
      Name: "Money Farm",
    },
    {
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-049",
      Name: "5 Dealers",
    },
    {
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-050",
      Name: "Seven Lucky God",
    },
    {
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-051",
      Name: "Wu Zi Ci Mile",
    },
    {
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-052",
      Name: "Six Lions",
    },
    {
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-053",
      Name: "Black Sheep",
    },
    {
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-054",
      Name: "Maple Story",
    },
    {
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-055",
      Name: "Taiko Master",
    },
    {
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-056",
      Name: "Onmyoji",
    },
    {
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-057",
      Name: "Pirates",
    },
    {
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-058",
      Name: "WarShip Girls",
    },
    {
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-059",
      Name: "Infinity War",
    },
    {
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-060",
      Name: "War Hammer 40K",
    },
    {
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-061",
      Name: "Travel Frog",
    },
    {
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-062",
      Name: "Crossy Road",
    },
    {
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-063",
      Name: "Zombie Hunter",
    },
    {
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-064",
      Name: "Artificial Girl",
    },
    {
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-065",
      Name: "Falling Sakura",
    },
    {
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-066",
      Name: "Lion Dance",
    },
    {
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-067",
      Name: "Bright & Abyss",
    },
    {
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-068",
      Name: "Alice",
    },
    {
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-069",
      Name: "Tomb",
    },
    {
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-072",
      Name: "Military",
    },
    {
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-073",
      Name: "Might Magic",
    },
    {
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-074",
      Name: "Magic Candy",
    },
    {
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-075",
      Name: "Geisha",
    },
    {
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-076",
      Name: "Tropical Island",
    },
    {
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-077",
      Name: "Aladdin",
    },
    {
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-078",
      Name: "Odin",
    },
    {
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-079",
      Name: "Lost in Egypt",
    },
    {
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-080",
      Name: "Ninja Warrior",
    },
    {
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-081",
      Name: "Fox Spirit",
    },
    {
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-082",
      Name: "Bean Stalk",
    },
    {
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-083",
      Name: "Chinese New Year",
    },
    {
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-084",
      Name: "Horizon",
    },
    {
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-085",
      Name: "Ice Storm",
    },
    {
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-086",
      Name: "Lost City Of Gold",
    },
    {
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-087",
      Name: "Aladdin2",
    },
    {
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-088",
      Name: "Rugby World Cup",
    },
    {
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-089",
      Name: "Scarab",
    },
    {
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-090",
      Name: "Great Blue",
    },
    {
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-091",
      Name: "PUBG",
    },
    {
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-092",
      Name: "Good Fortune",
    },
    {
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-093",
      Name: "POPMART",
    },
    {
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-094",
      Name: "Evil Cat",
    },
    {
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-095",
      Name: "Electro Rebel",
    },
    {
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-096",
      Name: "Halloween Party",
    },
    {
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-097",
      Name: "Love and Thunder",
    },
    {
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-098",
      Name: "Slam Dunk",
    },
    {
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-100",
      Name: "Cricket Star ITP",
    },
    {
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-101",
      Name: "Basketball Star ITP",
    },
    {
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-102",
      Name: "Treasure Frog",
    },
    {
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-103",
      Name: "TrialByViking",
    },
    {
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-104",
      Name: "BAKI",
    },
    {
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-105",
      Name: "KIMBA",
    },
    {
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-106",
      Name: "Dragon Black Gold",
    },
    {
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-107",
      Name: "EPICAPE",
    },
    {
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-108",
      Name: "Kleo Patra",
    },
    {
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-109",
      Name: "Atocha Treasure",
    },
    {
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-110",
      Name: "Case Closed",
    },
    {
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-111",
      Name: "TreasureIsland",
    },
    {
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-112",
      Name: "Gold Musa I",
    },
    {
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-113",
      Name: "Chinese Halloween",
    },
    {
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-114",
      Name: "Gold Meow Sushi Legend",
    },
    {
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-115",
      Name: "The Wizard of OZ",
    },
    {
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-116",
      Name: "Mystic Witch",
    },
    {
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-117",
      Name: "Gold Aynu",
    },
    {
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-118",
      Name: "Pharaoh Resort Hotel",
    },
    {
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-119",
      Name: "DJ Remix",
    },
    {
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-120",
      Name: "Triple Monkey",
    },
    {
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-121",
      Name: "Mystic Nine",
    },
  ],
  BTG: [
    {
      platFormCode: "BTG",
      gameType: "SLOT",
      casinoType: "BTG-SLOT-001",
      Name: "Apollo Pays",
    },
    {
      platFormCode: "BTG",
      gameType: "SLOT",
      casinoType: "BTG-SLOT-002",
      Name: "Castle of Terror",
    },
    {
      platFormCode: "BTG",
      gameType: "SLOT",
      casinoType: "BTG-SLOT-003",
      Name: "Rasputin Megaways",
    },
    {
      platFormCode: "BTG",
      gameType: "SLOT",
      casinoType: "BTG-SLOT-004",
      Name: "Bonanza",
    },
    {
      platFormCode: "BTG",
      gameType: "SLOT",
      casinoType: "BTG-SLOT-005",
      Name: "Extra Chilli",
    },
    {
      platFormCode: "BTG",
      gameType: "SLOT",
      casinoType: "BTG-SLOT-006",
      Name: "White Rabbit",
    },
    {
      platFormCode: "BTG",
      gameType: "SLOT",
      casinoType: "BTG-SLOT-007",
      Name: "Millionaire Megaways",
    },
    {
      platFormCode: "BTG",
      gameType: "SLOT",
      casinoType: "BTG-SLOT-008",
      Name: "Golden Catch",
    },
    {
      platFormCode: "BTG",
      gameType: "SLOT",
      casinoType: "BTG-SLOT-009",
      Name: "Danger High Voltage",
    },
    {
      platFormCode: "BTG",
      gameType: "SLOT",
      casinoType: "BTG-SLOT-010",
      Name: "Christmas Bonanza",
    },
    {
      platFormCode: "BTG",
      gameType: "SLOT",
      casinoType: "BTG-SLOT-011",
      Name: "Gifts of Fortune",
    },
    {
      platFormCode: "BTG",
      gameType: "SLOT",
      casinoType: "BTG-SLOT-012",
      Name: "The Race",
    },
    {
      platFormCode: "BTG",
      gameType: "SLOT",
      casinoType: "BTG-SLOT-013",
      Name: "Over The Moon",
    },
    {
      platFormCode: "BTG",
      gameType: "SLOT",
      casinoType: "BTG-SLOT-014",
      Name: "Vegas Rush",
    },
    {
      platFormCode: "BTG",
      gameType: "SLOT",
      casinoType: "BTG-SLOT-015",
      Name: "Beef Lightning",
    },
    {
      platFormCode: "BTG",
      gameType: "SLOT",
      casinoType: "BTG-SLOT-016",
      Name: "Gold Megaways",
    },
    {
      platFormCode: "BTG",
      gameType: "SLOT",
      casinoType: "BTG-SLOT-017",
      Name: "Big Bad Bison",
    },
    {
      platFormCode: "BTG",
      gameType: "SLOT",
      casinoType: "BTG-SLOT-018",
      Name: "Millionaire Rush",
    },
    {
      platFormCode: "BTG",
      gameType: "SLOT",
      casinoType: "BTG-SLOT-019",
      Name: "Max Megaways",
    },
    {
      platFormCode: "BTG",
      gameType: "SLOT",
      casinoType: "BTG-SLOT-020",
      Name: "Royal Mint",
    },
    {
      platFormCode: "BTG",
      gameType: "SLOT",
      casinoType: "BTG-SLOT-021",
      Name: "Christmas Catch",
    },
    {
      platFormCode: "BTG",
      gameType: "SLOT",
      casinoType: "BTG-SLOT-022",
      Name: "Bonanza Falls",
    },
    {
      platFormCode: "BTG",
      gameType: "SLOT",
      casinoType: "BTG-SLOT-023",
      Name: "Outlaw",
    },
    {
      platFormCode: "BTG",
      gameType: "SLOT",
      casinoType: "BTG-SLOT-024",
      Name: "Vegas Megaways",
    },
    {
      platFormCode: "BTG",
      gameType: "SLOT",
      casinoType: "BTG-SLOT-025",
      Name: "Star Clusters",
    },
    {
      platFormCode: "BTG",
      gameType: "SLOT",
      casinoType: "BTG-SLOT-026",
      Name: "Wild Portals",
    },
    {
      platFormCode: "BTG",
      gameType: "SLOT",
      casinoType: "BTG-SLOT-027",
      Name: "Max Megaways 2",
    },
    {
      platFormCode: "BTG",
      gameType: "SLOT",
      casinoType: "BTG-SLOT-028",
      Name: "Slot Vegas Fully Loaded",
    },
    {
      platFormCode: "BTG",
      gameType: "SLOT",
      casinoType: "BTG-SLOT-029",
      Name: "Pirate Pays",
    },
    {
      platFormCode: "BTG",
      gameType: "SLOT",
      casinoType: "BTG-SLOT-030",
      Name: "Wild Flower",
    },
    {
      platFormCode: "BTG",
      gameType: "SLOT",
      casinoType: "BTG-SLOT-031",
      Name: "Pop",
    },
    {
      platFormCode: "BTG",
      gameType: "SLOT",
      casinoType: "BTG-SLOT-032",
      Name: "Kingmaker Fully Loaded",
    },
    {
      platFormCode: "BTG",
      gameType: "SLOT",
      casinoType: "BTG-SLOT-033",
      Name: "Wild Unicorns",
    },
    {
      platFormCode: "BTG",
      gameType: "SLOT",
      casinoType: "BTG-SLOT-034",
      Name: "Diamond Fruits",
    },
    {
      platFormCode: "BTG",
      gameType: "SLOT",
      casinoType: "BTG-SLOT-035",
      Name: "Donuts",
    },
    {
      platFormCode: "BTG",
      gameType: "SLOT",
      casinoType: "BTG-SLOT-036",
      Name: "Lil Devil",
    },
    {
      platFormCode: "BTG",
      gameType: "SLOT",
      casinoType: "BTG-SLOT-038",
      Name: "Opal Fruits",
    },
    {
      platFormCode: "BTG",
      gameType: "SLOT",
      casinoType: "BTG-SLOT-039",
      Name: "Sanctuary",
    },
    {
      platFormCode: "BTG",
      gameType: "SLOT",
      casinoType: "BTG-SLOT-040",
      Name: "Panda Money",
    },
    {
      platFormCode: "BTG",
      gameType: "SLOT",
      casinoType: "BTG-SLOT-041",
      Name: "Fireworks Megaways",
    },
    {
      platFormCode: "BTG",
      gameType: "SLOT",
      casinoType: "BTG-SLOT-042",
      Name: "The Final Countdown",
    },
    {
      platFormCode: "BTG",
      gameType: "SLOT",
      casinoType: "BTG-SLOT-043",
      Name: "Spicy Meatballs",
    },
    {
      platFormCode: "BTG",
      gameType: "SLOT",
      casinoType: "BTG-SLOT-044",
      Name: "Chocolates",
    },
    {
      platFormCode: "BTG",
      gameType: "SLOT",
      casinoType: "BTG-SLOT-045",
      Name: "King of Cats",
    },
    {
      platFormCode: "BTG",
      gameType: "SLOT",
      casinoType: "BTG-SLOT-046",
      Name: "More Turkey",
    },
    {
      platFormCode: "BTG",
      gameType: "SLOT",
      casinoType: "BTG-SLOT-047",
      Name: "Trigger Happy",
    },
    {
      platFormCode: "BTG",
      gameType: "SLOT",
      casinoType: "BTG-SLOT-048",
      Name: "Lucky Streak Mk2",
    },
    {
      platFormCode: "BTG",
      gameType: "SLOT",
      casinoType: "BTG-SLOT-049",
      Name: "Cyberslot Megaclusters",
    },
    {
      platFormCode: "BTG",
      gameType: "SLOT",
      casinoType: "BTG-SLOT-050",
      Name: "Fizzy Pennyslot",
    },
    {
      platFormCode: "BTG",
      gameType: "SLOT",
      casinoType: "BTG-SLOT-051",
      Name: "Holy Diver Megaways",
    },
    {
      platFormCode: "BTG",
      gameType: "SLOT",
      casinoType: "BTG-SLOT-052",
      Name: "Millionaire Mystery Box",
    },
    {
      platFormCode: "BTG",
      gameType: "SLOT",
      casinoType: "BTG-SLOT-053",
      Name: "Book of Gods",
    },
    {
      platFormCode: "BTG",
      gameType: "SLOT",
      casinoType: "BTG-SLOT-054",
      Name: "Boo",
    },
    {
      platFormCode: "BTG",
      gameType: "SLOT",
      casinoType: "BTG-SLOT-055",
      Name: "Queen of Riches",
    },
    {
      platFormCode: "BTG",
      gameType: "SLOT",
      casinoType: "BTG-SLOT-056",
      Name: "Danger High Voltage 2",
    },
    {
      platFormCode: "BTG",
      gameType: "SLOT",
      casinoType: "BTG-SLOT-057",
      Name: "Golden Goose Megaways",
    },
    {
      platFormCode: "BTG",
      gameType: "SLOT",
      casinoType: "BTG-SLOT-058",
      Name: "Burgers",
    },
    {
      platFormCode: "BTG",
      gameType: "SLOT",
      casinoType: "BTG-SLOT-059",
      Name: "Temple Quest Spinfinity",
    },
    {
      platFormCode: "BTG",
      gameType: "SLOT",
      casinoType: "BTG-SLOT-060",
      Name: "Max Megaways 3",
    },
    {
      platFormCode: "BTG",
      gameType: "SLOT",
      casinoType: "BTG-SLOT-061",
      Name: "Big Bucks Deluxe",
    },
    {
      platFormCode: "BTG",
      gameType: "SLOT",
      casinoType: "BTG-SLOT-062",
      Name: "Crystal Towers",
    },
    {
      platFormCode: "BTG",
      gameType: "SLOT",
      casinoType: "BTG-SLOT-063",
      Name: "Big Bucks Deluxe Tapcards",
    },
    {
      platFormCode: "BTG",
      gameType: "SLOT",
      casinoType: "BTG-SLOT-064",
      Name: "Bonanza Tapcards",
    },
    {
      platFormCode: "BTG",
      gameType: "SLOT",
      casinoType: "BTG-SLOT-065",
      Name: "Extra Chili Tapcards",
    },
    {
      platFormCode: "BTG",
      gameType: "SLOT",
      casinoType: "BTG-SLOT-066",
      Name: "Millionaire Tapcards",
    },
    {
      platFormCode: "BTG",
      gameType: "SLOT",
      casinoType: "BTG-SLOT-067",
      Name: "Dragon Born",
    },
    {
      platFormCode: "BTG",
      gameType: "SLOT",
      casinoType: "BTG-SLOT-068",
      Name: "Star Clusters 2",
    },
    {
      platFormCode: "BTG",
      gameType: "SLOT",
      casinoType: "BTG-SLOT-069",
      Name: "Castle of Terror 2",
    },
  ],
  SEXY: [
    {
      platFormCode: "SEXYBCRT",
      gameType: "LIVE",
      casinoType: "MX-LIVE-001",
      Name: "Baccarat Classic",
    },
    {
      platFormCode: "SEXYBCRT",
      gameType: "LIVE",
      casinoType: "MX-LIVE-002",
      Name: "Baccarat",
    },
    {
      platFormCode: "SEXYBCRT",
      gameType: "LIVE",
      casinoType: "MX-LIVE-006",
      Name: "DragonTiger",
    },
    {
      platFormCode: "SEXYBCRT",
      gameType: "LIVE",
      casinoType: "MX-LIVE-009",
      Name: "Roulette",
    },
    {
      platFormCode: "SEXYBCRT",
      gameType: "LIVE",
      casinoType: "MX-LIVE-014",
      Name: "Thai Hi Lo",
    },
    {
      platFormCode: "SEXYBCRT",
      gameType: "LIVE",
      casinoType: "MX-LIVE-015",
      Name: "Thai Fish Prawn Crab",
    },
    {
      platFormCode: "SEXYBCRT",
      gameType: "LIVE",
      casinoType: "MX-LIVE-016",
      Name: "Extra Sicbo",
    },
    {
      platFormCode: "SEXYBCRT",
      gameType: "LIVE",
      casinoType: "MX-LIVE-017",
      Name: "Sedie",
    },
    {
      platFormCode: "SEXYBCRT",
      gameType: "LIVE",
      casinoType: "MX-LIVE-018",
      Name: "Pok Deng",
    },
  ],
  MAC88: [
    {
      platFormCode: "MAC88",
      gameType: "LIVE",
      casinoType: "MAC88-LIVE-001",
      Name: "Mac88 Gaming Lobby",
    },
    {
      platFormCode: "MAC88",
      gameType: "LIVE",
      casinoType: "MAC88-LIVE-002",
      Name: "Bacarrat",
    },
    {
      platFormCode: "MAC88",
      gameType: "LIVE",
      casinoType: "MAC88-LIVE-003",
      Name: "Sic Bo",
    },
    {
      platFormCode: "MAC88",
      gameType: "LIVE",
      casinoType: "MAC88-LIVE-004",
      Name: "Roulette",
    },
    {
      platFormCode: "MAC88",
      gameType: "LIVE",
      casinoType: "MAC88-LIVE-005",
      Name: "Poker 20-20",
    },
    {
      platFormCode: "MAC88",
      gameType: "LIVE",
      casinoType: "MAC88-LIVE-006",
      Name: "Lucky7",
    },
    {
      platFormCode: "MAC88",
      gameType: "LIVE",
      casinoType: "MAC88-LIVE-007",
      Name: "Andar Bahar",
    },
    {
      platFormCode: "MAC88",
      gameType: "LIVE",
      casinoType: "MAC88-LIVE-008",
      Name: "Teenpatti One Day",
    },
    {
      platFormCode: "MAC88",
      gameType: "LIVE",
      casinoType: "MAC88-LIVE-009",
      Name: "32 Cards",
    },
    {
      platFormCode: "MAC88",
      gameType: "LIVE",
      casinoType: "MAC88-LIVE-010",
      Name: "DTL",
    },
    {
      platFormCode: "MAC88",
      gameType: "LIVE",
      casinoType: "MAC88-LIVE-011",
      Name: "Amar Akbar Anthony",
    },
    {
      platFormCode: "MAC88",
      gameType: "LIVE",
      casinoType: "MAC88-LIVE-012",
      Name: "3 Cards Judgement",
    },
    {
      platFormCode: "MAC88",
      gameType: "LIVE",
      casinoType: "MAC88-LIVE-013",
      Name: "Queen Race",
    },
    {
      platFormCode: "MAC88",
      gameType: "LIVE",
      casinoType: "MAC88-LIVE-014",
      Name: "Race 20",
    },
    {
      platFormCode: "MAC88",
      gameType: "LIVE",
      casinoType: "MAC88-LIVE-015",
      Name: "Casino War",
    },
    {
      platFormCode: "MAC88",
      gameType: "LIVE",
      casinoType: "MAC88-LIVE-016",
      Name: "Worli Matka",
    },
    {
      platFormCode: "MAC88",
      gameType: "LIVE",
      casinoType: "MAC88-LIVE-017",
      Name: "Lottery",
    },
    {
      platFormCode: "MAC88",
      gameType: "LIVE",
      casinoType: "MAC88-LIVE-018",
      Name: "Test Teenpatti",
    },
    {
      platFormCode: "MAC88",
      gameType: "LIVE",
      casinoType: "MAC88-LIVE-019",
      Name: "Trio",
    },
    {
      platFormCode: "MAC88",
      gameType: "LIVE",
      casinoType: "MAC88-LIVE-020",
      Name: "29 Baccarat",
    },
    {
      platFormCode: "MAC88",
      gameType: "LIVE",
      casinoType: "MAC88-LIVE-021",
      Name: "Two Card Teenpatti",
    },
    {
      platFormCode: "MAC88",
      gameType: "LIVE",
      casinoType: "MAC88-LIVE-022",
      Name: "Muflis Teenpatti",
    },
    {
      platFormCode: "MAC88",
      gameType: "LIVE",
      casinoType: "MAC88-LIVE-023",
      Name: "Bollywood Casino B",
    },
    {
      platFormCode: "MAC88",
      gameType: "LIVE",
      casinoType: "MAC88-LIVE-024",
      Name: "Poker 1-Day",
    },
    {
      platFormCode: "MAC88",
      gameType: "LIVE",
      casinoType: "MAC88-LIVE-025",
      Name: "20-20 Teenpatti",
    },
    {
      platFormCode: "MAC88",
      gameType: "LIVE",
      casinoType: "MAC88-LIVE-026",
      Name: "Super Over",
    },
    {
      platFormCode: "MAC88",
      gameType: "LIVE",
      casinoType: "MAC88-LIVE-027",
      Name: "5 Five Cricket",
    },
    {
      platFormCode: "MAC88",
      gameType: "LIVE",
      casinoType: "MAC88-LIVE-028",
      Name: "1 Day Dragon Tiger",
    },
    {
      platFormCode: "MAC88",
      gameType: "LIVE",
      casinoType: "MAC88-LIVE-029",
      Name: "Dus Ka Dum",
    },
    {
      platFormCode: "MAC88",
      gameType: "LIVE",
      casinoType: "MAC88-LIVE-030",
      Name: "One Card 20 20",
    },
    {
      platFormCode: "MAC88",
      gameType: "LIVE",
      casinoType: "MAC88-LIVE-032",
      Name: "One Card One Day",
    },
    {
      platFormCode: "MAC88",
      gameType: "LIVE",
      casinoType: "MAC88-LIVE-033",
      Name: "6 Player Poker",
    },
    {
      platFormCode: "MAC88",
      gameType: "LIVE",
      casinoType: "MAC88-LIVE-034",
      Name: "Instant 2 Cards Teenpatti",
    },
    {
      platFormCode: "MAC88",
      gameType: "LIVE",
      casinoType: "MAC88-LIVE-035",
      Name: "Race to 17",
    },
    {
      platFormCode: "MAC88",
      gameType: "LIVE",
      casinoType: "MAC88-LIVE-036",
      Name: "Note Number",
    },
    {
      platFormCode: "MAC88",
      gameType: "LIVE",
      casinoType: "MAC88-LIVE-037",
      Name: "Cricket Match 20-20",
    },
    {
      platFormCode: "MAC88",
      gameType: "LIVE",
      casinoType: "MAC88-LIVE-039",
      Name: "Open Teen patti",
    },
    {
      platFormCode: "MAC88",
      gameType: "LIVE",
      casinoType: "MAC88-LIVE-041",
      Name: "High Low",
    },
    {
      platFormCode: "MAC88",
      gameType: "LIVE",
      casinoType: "MAC88-LIVE-043",
      Name: "10 - 10 cricket",
    },
    {
      platFormCode: "MAC88",
      gameType: "LIVE",
      casinoType: "MAC88-LIVE-044",
      Name: "Muflis Teenpatti",
    },
    {
      platFormCode: "MAC88",
      gameType: "LIVE",
      casinoType: "MAC88-LIVE-045",
      Name: "Instant worli",
    },
    {
      platFormCode: "MAC88",
      gameType: "LIVE",
      casinoType: "MAC88-LIVE-046",
      Name: "Instant Teen Patti",
    },
    {
      platFormCode: "MAC88",
      gameType: "LIVE",
      casinoType: "MAC88-LIVE-047",
      Name: "Andar Bahar 50",
    },
    {
      platFormCode: "MAC88",
      gameType: "LIVE",
      casinoType: "MAC88-LIVE-048",
      Name: "Super Over",
    },
    {
      platFormCode: "MAC88",
      gameType: "LIVE",
      casinoType: "MAC88-LIVE-049",
      Name: "Center card",
    },
    {
      platFormCode: "MAC88",
      gameType: "LIVE",
      casinoType: "MAC88-LIVE-051",
      Name: "Football StudIo",
    },
    {
      platFormCode: "MAC88",
      gameType: "LIVE",
      casinoType: "MAC88-LIVE-052",
      Name: "Dream Wheel",
    },
    {
      platFormCode: "MAC88",
      gameType: "LIVE",
      casinoType: "MAC88-LIVE-053",
      Name: "20 20 Teenpatti 2",
    },
    {
      platFormCode: "MAC88",
      gameType: "LIVE",
      casinoType: "MAC88-LIVE-054",
      Name: "Dragon Tiger 2",
    },
    {
      platFormCode: "MAC88",
      gameType: "LIVE",
      casinoType: "MAC88-LIVE-055",
      Name: "Lucky 5",
    },
    {
      platFormCode: "MAC88",
      gameType: "LIVE",
      casinoType: "MAC88-LIVE-056",
      Name: "AK47 Teenpatti",
    },
    {
      platFormCode: "MAC88",
      gameType: "LIVE",
      casinoType: "MAC88-LIVE-057",
      Name: "Dragon Tiger",
    },
    {
      platFormCode: "MAC88",
      gameType: "LIVE",
      casinoType: "MAC88-LIVE-062",
      Name: "Joker Teenpatti 20-20",
    },
    {
      platFormCode: "MAC88",
      gameType: "LIVE",
      casinoType: "MAC88-LIVE-063",
      Name: "Joker Teenpatti OneDay",
    },
  ],
  ACEWIN: [
    {
      platFormCode: "ACEWIN",
      gameType: "SLOT",
      casinoType: "ACEWIN-SLOT-001",
      Name: "FortuneFirecracker",
    },
    {
      platFormCode: "ACEWIN",
      gameType: "SLOT",
      casinoType: "ACEWIN-SLOT-002",
      Name: "Rich Piggies",
    },
    {
      platFormCode: "ACEWIN",
      gameType: "SLOT",
      casinoType: "ACEWIN-SLOT-003",
      Name: "The First Emperor",
    },
    {
      platFormCode: "ACEWIN",
      gameType: "SLOT",
      casinoType: "ACEWIN-SLOT-004",
      Name: "Lucky Riches",
    },
    {
      platFormCode: "ACEWIN",
      gameType: "SLOT",
      casinoType: "ACEWIN-SLOT-005",
      Name: "DragonBaoBao",
    },
    {
      platFormCode: "ACEWIN",
      gameType: "SLOT",
      casinoType: "ACEWIN-SLOT-006",
      Name: "Fortune Tai Chi",
    },
    {
      platFormCode: "ACEWIN",
      gameType: "SLOT",
      casinoType: "ACEWIN-SLOT-007",
      Name: "Spin of Fate",
    },
    {
      platFormCode: "ACEWIN",
      gameType: "SLOT",
      casinoType: "ACEWIN-SLOT-008",
      Name: "Super AceWin",
    },
    {
      platFormCode: "ACEWIN",
      gameType: "SLOT",
      casinoType: "ACEWIN-SLOT-009",
      Name: "Fist Champion",
    },
    {
      platFormCode: "ACEWIN",
      gameType: "SLOT",
      casinoType: "ACEWIN-SLOT-010",
      Name: "Wild Chips",
    },
    {
      platFormCode: "ACEWIN",
      gameType: "SLOT",
      casinoType: "ACEWIN-SLOT-011",
      Name: "Roma Plus",
    },
    {
      platFormCode: "ACEWIN",
      gameType: "SLOT",
      casinoType: "ACEWIN-SLOT-012",
      Name: "Dragons Legend",
    },
    {
      platFormCode: "ACEWIN",
      gameType: "SLOT",
      casinoType: "ACEWIN-SLOT-013",
      Name: "Hulao Battle",
    },
    {
      platFormCode: "ACEWIN",
      gameType: "SLOT",
      casinoType: "ACEWIN-SLOT-014",
      Name: "Pirate Treasure",
    },
    {
      platFormCode: "ACEWIN",
      gameType: "SLOT",
      casinoType: "ACEWIN-SLOT-015",
      Name: "BingoFortune",
    },
    {
      platFormCode: "ACEWIN",
      gameType: "SLOT",
      casinoType: "ACEWIN-SLOT-016",
      Name: "Fortune Four",
    },
    {
      platFormCode: "ACEWIN",
      gameType: "SLOT",
      casinoType: "ACEWIN-SLOT-017",
      Name: "Jump For Richness",
    },
    {
      platFormCode: "ACEWIN",
      gameType: "SLOT",
      casinoType: "ACEWIN-SLOT-018",
      Name: "Fortune Tree",
    },
    {
      platFormCode: "ACEWIN",
      gameType: "SLOT",
      casinoType: "ACEWIN-SLOT-019",
      Name: "Zeus",
    },
    {
      platFormCode: "ACEWIN",
      gameType: "SLOT",
      casinoType: "ACEWIN-SLOT-020",
      Name: "Mayan Empire",
    },
    {
      platFormCode: "ACEWIN",
      gameType: "SLOT",
      casinoType: "ACEWIN-SLOT-021",
      Name: "Hot Shot",
    },
    {
      platFormCode: "ACEWIN",
      gameType: "SLOT",
      casinoType: "ACEWIN-SLOT-024",
      Name: "Tons Of Money",
    },
    {
      platFormCode: "ACEWIN",
      gameType: "SLOT",
      casinoType: "ACEWIN-SLOT-025",
      Name: "Cake Bonanza",
    },
    {
      platFormCode: "ACEWIN",
      gameType: "SLOT",
      casinoType: "ACEWIN-SLOT-026",
      Name: "FortuneArrow",
    },
    {
      platFormCode: "ACEWIN",
      gameType: "SLOT",
      casinoType: "ACEWIN-SLOT-027",
      Name: "Jungle Adventure",
    },
    {
      platFormCode: "ACEWIN",
      gameType: "SLOT",
      casinoType: "ACEWIN-SLOT-028",
      Name: "Fortune Rabbit",
    },
    {
      platFormCode: "ACEWIN",
      gameType: "SLOT",
      casinoType: "ACEWIN-SLOT-029",
      Name: "Buddha Spin",
    },
    {
      platFormCode: "ACEWIN",
      gameType: "SLOT",
      casinoType: "ACEWIN-SLOT-030",
      Name: "CashKing",
    },
    {
      platFormCode: "ACEWIN",
      gameType: "SLOT",
      casinoType: "ACEWIN-SLOT-031",
      Name: "Lion2Dance",
    },
    {
      platFormCode: "ACEWIN",
      gameType: "SLOT",
      casinoType: "ACEWIN-SLOT-032",
      Name: "Masskara Mania",
    },
    {
      platFormCode: "ACEWIN",
      gameType: "SLOT",
      casinoType: "ACEWIN-SLOT-033",
      Name: "Viking Glory",
    },
    {
      platFormCode: "ACEWIN",
      gameType: "SLOT",
      casinoType: "ACEWIN-SLOT-034",
      Name: "Mummy Mia",
    },
    {
      platFormCode: "ACEWIN",
      gameType: "SLOT",
      casinoType: "ACEWIN-SLOT-035",
      Name: "Fourtune 4ever Dragon",
    },
    {
      platFormCode: "ACEWIN",
      gameType: "FISH",
      casinoType: "ACEWIN-FISH-001",
      Name: "SuperStar",
    },
    {
      platFormCode: "ACEWIN",
      gameType: "FISH",
      casinoType: "ACEWIN-FISH-002",
      Name: "Circus",
    },
    {
      platFormCode: "ACEWIN",
      gameType: "FISH",
      casinoType: "ACEWIN-FISH-003",
      Name: "Aladdin Adventure",
    },
    {
      platFormCode: "ACEWIN",
      gameType: "FISH",
      casinoType: "ACEWIN-FISH-004",
      Name: "Lucky Buddha",
    },
    {
      platFormCode: "ACEWIN",
      gameType: "FISH",
      casinoType: "ACEWIN-FISH-005",
      Name: "Money Tree",
    },
    {
      platFormCode: "ACEWIN",
      gameType: "FISH",
      casinoType: "ACEWIN-FISH-006",
      Name: "Mr Fortune",
    },
    {
      platFormCode: "ACEWIN",
      gameType: "FISH",
      casinoType: "ACEWIN-FISH-007",
      Name: "Jackypot Frenzy",
    },
    {
      platFormCode: "ACEWIN",
      gameType: "FISH",
      casinoType: "ACEWIN-FISH-008",
      Name: "Ocean Pioneers",
    },
    {
      platFormCode: "ACEWIN",
      gameType: "FISH",
      casinoType: "ACEWIN-FISH-009",
      Name: "ICE & FIRE",
    },
    {
      platFormCode: "ACEWIN",
      gameType: "FISH",
      casinoType: "ACEWIN-FISH-010",
      Name: "ZombieAwaken",
    },
  ],
  YGGDRASIL: [
    {
      platFormCode: "YGGDRASIL",
      gameType: "TABLE",
      casinoType: "YGG-TABLE-001",
      Name: "Golden Chip Roulette",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-001",
      Name: "9kYeti",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-002",
      Name: "Moley Moolah",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-003",
      Name: "Atlantis Megaways",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-004",
      Name: "Giza Infinity Reels",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-005",
      Name: "Big Bucks Bandits MegaWays",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-006",
      Name: "El Dorado Infinity Reels",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-007",
      Name: "Ancient Eclipse",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-008",
      Name: "Buster Hammer Carnival",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-009",
      Name: "Johnan Legendarian",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-010",
      Name: "Odin Infinity Reels Megaways",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-011",
      Name: "Thor Infinity Reels",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-012",
      Name: "Desperate Dawgs",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-013",
      Name: "Robin Sherwood Marauders",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-014",
      Name: "Cauldron",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-015",
      Name: "Wild Joker Stacks",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-016",
      Name: "Royal Dragon Infinity Reels",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-017",
      Name: "The Hot Offer",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-019",
      Name: "Fruitoids",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-021",
      Name: "Chibeasties",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-022",
      Name: "Nirvana",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-023",
      Name: "Incinerator",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-024",
      Name: "Seasons",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-025",
      Name: "Legend of the Golden Monkey",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-026",
      Name: "Bicicleta",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-027",
      Name: "Big Blox",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-028",
      Name: "Double Dragons",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-029",
      Name: "Alchymedes",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-030",
      Name: "Beauty and the Beast",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-031",
      Name: "Jungle Books",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-032",
      Name: "Lucha Maniacs",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-033",
      Name: "TutsTwister",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-034",
      Name: "Penguin City",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-035",
      Name: "Wolf Hunters",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-037",
      Name: "Baron Samedi",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-038",
      Name: "Time Travel Tigers",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-039",
      Name: "Wilhelm Tell",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-040",
      Name: "Age of Asgard",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-041",
      Name: "Wild Robo Factory",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-042",
      Name: "Yokozuna Clash",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-043",
      Name: "Aldo's Journey",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-044",
      Name: "Temple Stacks: Splitz",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-045",
      Name: "Brazil Bomba",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-046",
      Name: "Neon Rush: Splitz",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-047",
      Name: "Football Glory",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-048",
      Name: "Vault of Fortune",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-049",
      Name: "Lightning Joker",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-050",
      Name: "Easter Island 2",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-051",
      Name: "Vikings go to Valhalla",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-052",
      Name: "Gator Gold Gigablox",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-053",
      Name: "Suncatcher Gigablox",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-054",
      Name: "Raptor Doublemax",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-055",
      Name: "Golden Fish Tank 2 Gigablox",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-056",
      Name: "Orient Express",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-057",
      Name: "Trolls Bridge",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-058",
      Name: "Royal Family",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-059",
      Name: "Pirates: Smugglers Paradise",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-060",
      Name: "Avatars: Gateway Guardians",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-061",
      Name: "Pirates 2: Mutiny",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-062",
      Name: "Tiki Infinity Reels Megaways",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-064",
      Name: "Gargoyle Infinity Reels",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-065",
      Name: "Golden Gorgon",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-066",
      Name: "Legion Hot1",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-067",
      Name: "12 Trojan Mysteries",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-068",
      Name: "Pushy Cats",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-069",
      Name: "Robin Nottingham Raiders",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-071",
      Name: "Xibalba",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-072",
      Name: "Krazy Klimber",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-073",
      Name: "90k Yeti Gigablox",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-074",
      Name: "Spina Colada",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-075",
      Name: "Crystal Falls",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-077",
      Name: "Lady Merlin Lightning Chase",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-078",
      Name: "Easter Island",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-079",
      Name: "Rainbow Ryan",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-080",
      Name: "Towering Pays Valhalla",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-081",
      Name: "10x Rewind",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-082",
      Name: "The Bounty Hunter",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-083",
      Name: "TIGER_TIGER",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-084",
      Name: "Medusa Hot 1",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-085",
      Name: "Hammer of Gods",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-086",
      Name: "Valley of the Gods",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-087",
      Name: "Bananaz 10K Ways",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-088",
      Name: "Towering Pays Excalibur",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-089",
      Name: "Vikings go to Hell",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-090",
      Name: "Winterberries",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-091",
      Name: "Valkyries",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-092",
      Name: "Valley of the Gods 2",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-093",
      Name: "Multifly!",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-095",
      Name: "Lucky Neko",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-096",
      Name: "Hades",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-097",
      Name: "Carol of the Elves",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-098",
      Name: "Sunny Shores",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-099",
      Name: "Dwarf Mine",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-100",
      Name: "Gem Rocks",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-101",
      Name: "Pumpkin Smash",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-102",
      Name: "Hanzo's Dojo",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-104",
      Name: "Reel Desire",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-105",
      Name: "Five Clans",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-106",
      Name: "Cazino Cosmos",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-107",
      Name: "The One Armed Bandit",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-108",
      Name: "Hyperburst",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-109",
      Name: "Vikings Go Berzerk",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-110",
      Name: "Vikings go Wild",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-111",
      Name: "Sahara Nights",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-112",
      Name: "Champions of Rome",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-113",
      Name: "Syncronite",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-114",
      Name: "Arthur's Fortune",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-115",
      Name: "Blood Moon Wilds",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-116",
      Name: "Cazino Zeppelin",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-117",
      Name: "Golden Fish tank",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-118",
      Name: "Gator Gold Deluxe Gigablox",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-119",
      Name: "Hypernova 10K Ways",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-120",
      Name: "Hunters Moon",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-121",
      Name: "Vikings Go Berzerk: Reloaded",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-122",
      Name: "Serendipity",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-123",
      Name: "Cthulhu",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-124",
      Name: "Monster Blox",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-125",
      Name: "Gems Infinity Reels",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-126",
      Name: "Cazino Zeppelin Reloaded",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-127",
      Name: "ThunderOfThor",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-128",
      Name: "Jumbo Jellies",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-129",
      Name: "Age of Beasts Infinity Reels",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-130",
      Name: "Money Mariachi Infinity Reels",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-131",
      Name: "Super Cash Drop Giga Blox",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-132",
      Name: "Dead Mans Fingers",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-133",
      Name: "60 Second Heist",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-134",
      Name: "Tiki Runner 2 DoubleMax",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-135",
      Name: "Jokrz Wild UltraNudge",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-136",
      Name: "Return of the Valkyrie",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-137",
      Name: "Tempered Steel",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-138",
      Name: "Wild Duel",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-139",
      Name: "Hells Hogs",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-140",
      Name: "Big Benji Bonanza",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-141",
      Name: "4 Fantastic Fish",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-142",
      Name: "Water Blox",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-143",
      Name: "Mega Pearl Gigablox",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-144",
      Name: "ARRR! 10K Ways",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-145",
      Name: "Eye of Persia 2",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-146",
      Name: "Professor Clanks Combinator",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-147",
      Name: "Boilin' Pots",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-148",
      Name: "Monsters VS Gigablox",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-149",
      Name: "MexoMax! Multimax",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-150",
      Name: "Dublin Up",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-151",
      Name: "Buffalo Blox",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-152",
      Name: "Wild One",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-153",
      Name: "Of Sabers and Monsters Wild Fight",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-154",
      Name: "Book HOTFIRE",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-155",
      Name: "Mega Cash Stacks",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-156",
      Name: "Hillbilly Vegas",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-157",
      Name: "Voodoo Hex",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-158",
      Name: "Calavera Crush",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-159",
      Name: "Florageddon!",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-160",
      Name: "Jekyllz Wild UltraNudge",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-161",
      Name: "Arctic Sorcerer Gigablox",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-162",
      Name: "Champion of the Underworld Gigablox Wild Fight",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-163",
      Name: "Wild Fishin' Wild Ways",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-164",
      Name: "Fruit Gemz Splitz",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-165",
      Name: "Desperate Dawgs 2 Gigablox",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-166",
      Name: "7 Gold Gigablox",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-167",
      Name: "Dungeon Tower",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-168",
      Name: "Firekick! Multimax",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-169",
      Name: "Dragon Lore Gigarise",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-170",
      Name: "Christmas Plaza DoubleMax",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-171",
      Name: "Gods Vs Gigablox",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-172",
      Name: "Rainbow Power Potz UltraNudge",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-173",
      Name: "The Legend of Musashi",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-174",
      Name: "Dragon Blox Gigablox",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-175",
      Name: "Festival 10K Ways",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-176",
      Name: "Double Lucky Mushrooms DoubleMax",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-177",
      Name: "Neon Villains DoubleMax",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-178",
      Name: "Lady Merlin Multimax",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-179",
      Name: "Winterberries 2",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-180",
      Name: "Fury of Hyde Megaways",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-181",
      Name: "Pharaoh’s Gaze DoubleMax",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-182",
      Name: "3 Lucky Leprechauns",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-183",
      Name: "Book of Books",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-184",
      Name: "Bugs Money",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-185",
      Name: "Big Bucks Buffalo GigaBlox",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-186",
      Name: "E-Force",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-187",
      Name: "Gold Fever",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-188",
      Name: "Giganimals GigaBlox",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-189",
      Name: "Hyper Respins",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-190",
      Name: "Shadow Raiders MultiMax",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-191",
      Name: "Devour the Weak",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-192",
      Name: "Purrfect Potions",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-193",
      Name: "Nice Catch Doublemax",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-194",
      Name: "Barbarossa DoubleMax",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-195",
      Name: "Fruit Combinator",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-196",
      Name: "4 Fantastic Fish In Egypt",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-197",
      Name: "Ragnawolves",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-198",
      Name: "Orca's Wild Bonanza",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-199",
      Name: "Candyfinity",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-200",
      Name: "Jokrz Wild UltraNudge Gigablox",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-201",
      Name: "Diamond Symphony DoubleMax",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-202",
      Name: "Beasty Blox",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-203",
      Name: "Starfire Fortunes Tophit",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-204",
      Name: "Thunderhawk",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-205",
      Name: "Badger Miners",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-206",
      Name: "Bucks and Doe 10K Ways",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-207",
      Name: "Fast Fruits Doublemax",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-208",
      Name: "Notre-Dame Tales",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-210",
      Name: "Shaker Club",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-211",
      Name: "10000 BC DoubleMax",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-212",
      Name: "Roamin' Romans UltraNudge",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-213",
      Name: "Going Wild in Vegas",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-214",
      Name: "Enchanted Water",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-215",
      Name: "GigaGong GigaBlox",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-216",
      Name: "Hercules 10K Ways",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-217",
      Name: "Blackbeard Battle Of The Seas",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-218",
      Name: "Lotus Warrior",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-219",
      Name: "Fatz's Diner",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-220",
      Name: "Burning Blox",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-221",
      Name: "Vampire Riches",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-222",
      Name: "3 Lucky Witches",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-223",
      Name: "8 Balls of Fire",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-224",
      Name: "Wild Stack Frenzy",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-225",
      Name: "Defenders of Mystica",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-226",
      Name: "Juiced Duomax",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-227",
      Name: "Animafia",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-228",
      Name: "Mega Money Machine",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-230",
      Name: "Diggin for Diamonds",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-231",
      Name: "Rock Star Santa",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-232",
      Name: "Secret of Anubis DoubleMax",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-233",
      Name: "Arctic Catch",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-234",
      Name: "Legend of Dragon Wins",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-235",
      Name: "Frozen Age",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-236",
      Name: "Sidewinder DoubleMax",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-237",
      Name: "Nice Catch 2",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-238",
      Name: "King Arthur 10K Ways",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-240",
      Name: "Tiki Runner GigaBlox",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-241",
      Name: "4 Fantastic Fish Gigablox",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-242",
      Name: "The Runemakers DoubleMax",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-243",
      Name: "Skylantis 2",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-244",
      Name: "Rainbow Ryan 2",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-245",
      Name: "Book of Blarney Gigablox",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-246",
      Name: "5 Sevens Hold and Win",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-247",
      Name: "CleoPatrick",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-248",
      Name: "Ghost Father",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-249",
      Name: "Primal Hunter Gigablox",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-250",
      Name: "Sugar Bomb MultiBoost",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-251",
      Name: "Tumble in the Jungle Wild Fight",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-252",
      Name: "4K Ultra Gold",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-253",
      Name: "Hidden Egypt DoubleMax",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-255",
      Name: "Racing Lovers",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-256",
      Name: "SuperCash Drop",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-257",
      Name: "Gunpowder",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-258",
      Name: "Goblin’s Bargain MultiMax",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-259",
      Name: "Mutant Trawlers",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-260",
      Name: "Diamond Miner DuoMax",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-261",
      Name: "Monkeys Go Bananas",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-262",
      Name: "50 Jokers Hotfire",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-263",
      Name: "Year of Olympia",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-264",
      Name: "Armageddon 10K Ways",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-265",
      Name: "Secret Riches of the Irish",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-266",
      Name: "Vikings Go To Egypt",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-267",
      Name: "Ten Thousand Wonders Multimax",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-268",
      Name: "Hell's Hogs 2 Squealin' Wheels",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-269",
      Name: "Pulled From The Deep UltraNudge",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-270",
      Name: "Wild Storm Legionnaire",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-271",
      Name: "777 Volt",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-272",
      Name: "Big Top Terror",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-273",
      Name: "Dragons Vs Gigablox",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-274",
      Name: "Lions Gigablox",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-275",
      Name: "Mutagenes",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-276",
      Name: "Ultra Hotfire",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-277",
      Name: "Attack of the Zombees WildEnergy",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-278",
      Name: "Mayan Temple Riches",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-279",
      Name: "7x7 Zeus",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-280",
      Name: "Fruitylicious",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-281",
      Name: "24k Gold JailBreak",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-282",
      Name: "Odin Lightning Blitz",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-283",
      Name: "Gates of Thunder",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-284",
      Name: "Bison Wilds",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-285",
      Name: "Mystic Magic",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-286",
      Name: "Book of Evil",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-287",
      Name: "Dolphin Hot 1",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-288",
      Name: "Barbarossa Revenge",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-289",
      Name: "Chilli Champions UltraHitz",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-290",
      Name: "Aphrodite Goes Wild RushingWilds",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-291",
      Name: "2 Sweet 4 U",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-292",
      Name: "Book Extreme",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-293",
      Name: "Silver's Gold PowerLinks",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-294",
      Name: "Shipwrecked",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-295",
      Name: "Riches of Olympus",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-296",
      Name: "4 Fantastic Vikings Go Fishing",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-297",
      Name: "3 Gladiators vs Caesar",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-298",
      Name: "Fiesta Explosiva DuoMax",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-299",
      Name: "Elixir of Wealth MultiBoost",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-300",
      Name: "Ramses Retro",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-301",
      Name: "Lollipop Drop MultiMax",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-302",
      Name: "Merlin's Beard",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-303",
      Name: "Golden Donkey Xmas",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-304",
      Name: "Big Benji's Back WildWays",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-305",
      Name: "The Handsome Bandit",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-306",
      Name: "Valley of the Dead",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-307",
      Name: "American Outlaws Multimax",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-308",
      Name: "10000 BC 2 DoubleMax",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-309",
      Name: "Show Me The Honey",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-310",
      Name: "Greedy Alice",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-311",
      Name: "Legacy of Anubis",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-312",
      Name: "Giga Bass Gigablox",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-313",
      Name: "Xmas Pop Delight",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-314",
      Name: "Golden Fish Tank Party",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-315",
      Name: "Big Game Fishing TopHit",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-316",
      Name: "Double Fruit Frenzy DoubleMax",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-317",
      Name: "Spartacus 10K Ways",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-318",
      Name: "Dog Fighters - Their Finest Hour",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-319",
      Name: "Irish Pots MulitMax",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-320",
      Name: "Major Miners",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-321",
      Name: "Life O'Riley",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-322",
      Name: "3 Wonders New year Carnival",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-323",
      Name: "Killroad 66",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-324",
      Name: "Super Crown 40",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-325",
      Name: "Thor's Hammer Time",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-326",
      Name: "2 Fast 2 Fruity",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-327",
      Name: "Ramesses Gold 10K Ways",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-328",
      Name: "King Power",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-329",
      Name: "Shark Bait",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-330",
      Name: "Trickstar Spins",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-331",
      Name: "Diamond Delirium",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-332",
      Name: "Gold Is All Mine 10K Ways",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-333",
      Name: "Alice In Lollyland",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-334",
      Name: "Castle Cash Megaways",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-335",
      Name: "24k Gold ShamRock On!",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-336",
      Name: "9 Arrows of Odysseus",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-337",
      Name: "Jungle Smash",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-338",
      Name: "Sugar Bomb 2 MultiBoost",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-339",
      Name: "Fantasy Falls",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-340",
      Name: "Jungle Pop",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-341",
      Name: "Street Ninja",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-342",
      Name: "Dawn of Anubis",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-343",
      Name: "Adventures of Captain Cash",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-344",
      Name: "Saber",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-345",
      Name: "Extreme Hot Gems",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-346",
      Name: "Burning Riot",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-347",
      Name: "Wild Joker Blitz",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-348",
      Name: "Pillage The Village 10K Ways",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-349",
      Name: "Golden Triad",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-350",
      Name: "Nautical Treasures",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-351",
      Name: "Mine and Win",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-352",
      Name: "Buffalo Super Stars",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-353",
      Name: "Juicy Jelly Thunder Ways",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-354",
      Name: "Rudis",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-355",
      Name: "4 FOXX Crew WildEnergy™ MultiMax",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-356",
      Name: "Bounty Hunter MultiBoost",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-357",
      Name: "Big Game Fishing Golden Catch",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-358",
      Name: "PopNoir",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-359",
      Name: "Vikings go to Vegas Wild Fight",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-360",
      Name: "The Vigilantes",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-361",
      Name: "4 Fantastic Fish Amazon Adventure",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-362",
      Name: "Fuel the Mule",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-363",
      Name: "Dick the Farmer",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-364",
      Name: "Hall of Wealth",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-365",
      Name: "20 Times Casino",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-366",
      Name: "Lucky Ryan GigaBlox",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-367",
      Name: "Dead Lucky DuoMax",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-368",
      Name: "Runes of Battle",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-369",
      Name: "Gods Gone Wild",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-370",
      Name: "Deadly West",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-371",
      Name: "Cereal Thrillers",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-372",
      Name: "Titan Clash",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-373",
      Name: "Reel The Groove",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-374",
      Name: "Bob Marlin Goes Deep",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-375",
      Name: "Redbeards Rum Runners DoubleMax",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-376",
      Name: "Lock ‘n Load",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-377",
      Name: "Pharaoh’s Rage UltraSpinz",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-378",
      Name: "Roby Dick",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-379",
      Name: "Tiki Runner Clusters",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-380",
      Name: "Crab Chaos",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-381",
      Name: "8K Ultra Gold Ultimate",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-382",
      Name: "Gigablox Kingdom",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-383",
      Name: "5 Crown Hotfire",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-384",
      Name: "Frontier Lock & Load",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-385",
      Name: "Lady Midas",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-386",
      Name: "Speed Freaks",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-387",
      Name: "The Good Farmer",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-388",
      Name: "Hackers Haven",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-389",
      Name: "Angry Tiki DoubleMax",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-390",
      Name: "Power Pack",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-391",
      Name: "FruitPunk",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-392",
      Name: "Maximum Fish",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-393",
      Name: "Eskimo Riches",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-394",
      Name: "40 Crown Hotfire",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-395",
      Name: "Diggin for Diamonds 2",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-396",
      Name: "The Cursed Idol of Montezuma",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-397",
      Name: "4 Wolves of Fortune",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-398",
      Name: "MexoMax 2 WildEnergy™ MultiMax",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-399",
      Name: "Trolls Frenzy",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-400",
      Name: "Lock & Loot Gigablox",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-401",
      Name: "Renegade Revengers",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-402",
      Name: "Fruitjitsu",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-403",
      Name: "Wild Gangs",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-404",
      Name: "Cyber Doom",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-405",
      Name: "Mafioso",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-406",
      Name: "4TP Guns N’ Gold",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-407",
      Name: "Money Flash",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-408",
      Name: "Spellforged",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-409",
      Name: "Scara-Bucks",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-410",
      Name: "Devil’s Delight",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-411",
      Name: "GoldStorm Ultra",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-412",
      Name: "Neon West",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-413",
      Name: "Mow Money MultiMax",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-414",
      Name: "Your Own Island",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-415",
      Name: "3 Wonders Monster Pays",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-416",
      Name: "Fall of Asgard - a Viking Saga",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-417",
      Name: "Bloody Pesos",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-418",
      Name: "Vault Raiders DoubleMax",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-419",
      Name: "Piggy Staxx",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-420",
      Name: "Cosmic Drop",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-421",
      Name: "8 Balls of Fire Blazing Bounty",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-422",
      Name: "Captain Cashmap",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-423",
      Name: "3 Wonders Zoo",
    },
    {
      platFormCode: "YGGDRASIL",
      gameType: "SLOT",
      casinoType: "YGG-SLOT-424",
      Name: "What The Fruit!",
    },
  ],
  TADA: [
    {
      platFormCode: "TADA",
      gameType: "SLOT",
      casinoType: "TADA-SLOT-001",
      Name: "Fortune Gems",
    },
    {
      platFormCode: "TADA",
      gameType: "SLOT",
      casinoType: "TADA-SLOT-002",
      Name: "Fortune Gems 2",
    },
    {
      platFormCode: "TADA",
      gameType: "SLOT",
      casinoType: "TADA-SLOT-003",
      Name: "Money Coming",
    },
    {
      platFormCode: "TADA",
      gameType: "SLOT",
      casinoType: "TADA-SLOT-004",
      Name: "Charge Buffalo-ASCENT",
    },
    {
      platFormCode: "TADA",
      gameType: "SLOT",
      casinoType: "TADA-SLOT-005",
      Name: "Golden Empire",
    },
    {
      platFormCode: "TADA",
      gameType: "SLOT",
      casinoType: "TADA-SLOT-006",
      Name: "Jackpot Joker",
    },
    {
      platFormCode: "TADA",
      gameType: "SLOT",
      casinoType: "TADA-SLOT-007",
      Name: "Mega Ace",
    },
    {
      platFormCode: "TADA",
      gameType: "SLOT",
      casinoType: "TADA-SLOT-008",
      Name: "Party Star",
    },
    {
      platFormCode: "TADA",
      gameType: "SLOT",
      casinoType: "TADA-SLOT-010",
      Name: "Fortune Gems 3",
    },
    {
      platFormCode: "TADA",
      gameType: "SLOT",
      casinoType: "TADA-SLOT-011",
      Name: "Sin City",
    },
    {
      platFormCode: "TADA",
      gameType: "SLOT",
      casinoType: "TADA-SLOT-012",
      Name: "Witches' Night",
    },
    {
      platFormCode: "TADA",
      gameType: "SLOT",
      casinoType: "TADA-SLOT-013",
      Name: "Aztec Priestess",
    },
    {
      platFormCode: "TADA",
      gameType: "SLOT",
      casinoType: "TADA-SLOT-014",
      Name: "Devil Fire",
    },
    {
      platFormCode: "TADA",
      gameType: "SLOT",
      casinoType: "TADA-SLOT-015",
      Name: "Arena Fighter",
    },
    {
      platFormCode: "TADA",
      gameType: "SLOT",
      casinoType: "TADA-SLOT-016",
      Name: "Devil Fire 2",
    },
    {
      platFormCode: "TADA",
      gameType: "SLOT",
      casinoType: "TADA-SLOT-017",
      Name: "Zeus",
    },
    {
      platFormCode: "TADA",
      gameType: "SLOT",
      casinoType: "TADA-SLOT-018",
      Name: "King Arthur",
    },
    {
      platFormCode: "TADA",
      gameType: "SLOT",
      casinoType: "TADA-SLOT-019",
      Name: "Egypt's Glow",
    },
    {
      platFormCode: "TADA",
      gameType: "SLOT",
      casinoType: "TADA-SLOT-020",
      Name: "Bounty Frenzy",
    },
    {
      platFormCode: "TADA",
      gameType: "SLOT",
      casinoType: "TADA-SLOT-021",
      Name: "Super Ace",
    },
    {
      platFormCode: "TADA",
      gameType: "SLOT",
      casinoType: "TADA-SLOT-022",
      Name: "Agent Ace",
    },
    {
      platFormCode: "TADA",
      gameType: "SLOT",
      casinoType: "TADA-SLOT-023",
      Name: "Trial of Phoenix",
    },
    {
      platFormCode: "TADA",
      gameType: "SLOT",
      casinoType: "TADA-SLOT-024",
      Name: "Shōgun",
    },
    {
      platFormCode: "TADA",
      gameType: "SLOT",
      casinoType: "TADA-SLOT-025",
      Name: "Nightfall Hunting",
    },
    {
      platFormCode: "TADA",
      gameType: "SLOT",
      casinoType: "TADA-SLOT-026",
      Name: "Fortune Tree",
    },
    {
      platFormCode: "TADA",
      gameType: "SLOT",
      casinoType: "TADA-SLOT-027",
      Name: "Wild Ace",
    },
    {
      platFormCode: "TADA",
      gameType: "SLOT",
      casinoType: "TADA-SLOT-028",
      Name: "Boxing King",
    },
    {
      platFormCode: "TADA",
      gameType: "SLOT",
      casinoType: "TADA-SLOT-029",
      Name: "Crazy 777",
    },
    {
      platFormCode: "TADA",
      gameType: "SLOT",
      casinoType: "TADA-SLOT-030",
      Name: "Ali Baba",
    },
    {
      platFormCode: "TADA",
      gameType: "SLOT",
      casinoType: "TADA-SLOT-031",
      Name: "Golden Temple",
    },
    {
      platFormCode: "TADA",
      gameType: "SLOT",
      casinoType: "TADA-SLOT-032",
      Name: "Potion Wizard",
    },
    {
      platFormCode: "TADA",
      gameType: "SLOT",
      casinoType: "TADA-SLOT-033",
      Name: "Neko Neko",
    },
    {
      platFormCode: "TADA",
      gameType: "SLOT",
      casinoType: "TADA-SLOT-034",
      Name: "Sweet Land",
    },
    {
      platFormCode: "TADA",
      gameType: "SLOT",
      casinoType: "TADA-SLOT-035",
      Name: "Money Coming Expanded Bets",
    },
    {
      platFormCode: "TADA",
      gameType: "SLOT",
      casinoType: "TADA-SLOT-036",
      Name: "Mayan Empire",
    },
    {
      platFormCode: "TADA",
      gameType: "SLOT",
      casinoType: "TADA-SLOT-037",
      Name: "Fortune Monkey",
    },
    {
      platFormCode: "TADA",
      gameType: "SLOT",
      casinoType: "TADA-SLOT-038",
      Name: "Fa Fa Fa",
    },
    {
      platFormCode: "TADA",
      gameType: "SLOT",
      casinoType: "TADA-SLOT-039",
      Name: "Fortune Pig",
    },
    {
      platFormCode: "TADA",
      gameType: "SLOT",
      casinoType: "TADA-SLOT-040",
      Name: "SevenSevenSeven",
    },
    {
      platFormCode: "TADA",
      gameType: "SLOT",
      casinoType: "TADA-SLOT-041",
      Name: "Lucky Jaguar",
    },
    {
      platFormCode: "TADA",
      gameType: "SLOT",
      casinoType: "TADA-SLOT-042",
      Name: "Money Pot",
    },
    {
      platFormCode: "TADA",
      gameType: "SLOT",
      casinoType: "TADA-SLOT-043",
      Name: "Big Boss",
    },
    {
      platFormCode: "TADA",
      gameType: "SLOT",
      casinoType: "TADA-SLOT-044",
      Name: "Money Pot DELUXE",
    },
    {
      platFormCode: "TADA",
      gameType: "SLOT",
      casinoType: "TADA-SLOT-045",
      Name: "Clover Coins 4x4",
    },
    {
      platFormCode: "TADA",
      gameType: "SLOT",
      casinoType: "TADA-SLOT-046",
      Name: "Fortune Coins 2",
    },
    {
      platFormCode: "TADA",
      gameType: "SLOT",
      casinoType: "TADA-SLOT-047",
      Name: "3 Coin Wild Horse",
    },
    {
      platFormCode: "TADA",
      gameType: "SLOT",
      casinoType: "TADA-SLOT-048",
      Name: "Crazy777 2",
    },
    {
      platFormCode: "TADA",
      gameType: "SLOT",
      casinoType: "TADA-SLOT-049",
      Name: "100 Blazing Clover",
    },
    {
      platFormCode: "TADA",
      gameType: "SLOT",
      casinoType: "TADA-SLOT-050",
      Name: "Devil Fire Twins",
    },
    {
      platFormCode: "TADA",
      gameType: "SLOT",
      casinoType: "TADA-SLOT-051",
      Name: "Fortune Hook Boom",
    },
    {
      platFormCode: "TADA",
      gameType: "SLOT",
      casinoType: "TADA-SLOT-052",
      Name: "Rise Of Egypt",
    },
    {
      platFormCode: "TADA",
      gameType: "SLOT",
      casinoType: "TADA-SLOT-053",
      Name: "Lucky Macaw",
    },
    {
      platFormCode: "TADA",
      gameType: "SLOT",
      casinoType: "TADA-SLOT-054",
      Name: "3 Witch's Lamp",
    },
    {
      platFormCode: "TADA",
      gameType: "SLOT",
      casinoType: "TADA-SLOT-055",
      Name: "Crown of Fortune",
    },
    {
      platFormCode: "TADA",
      gameType: "SLOT",
      casinoType: "TADA-SLOT-056",
      Name: "3 Lucky Baozhu",
    },
    {
      platFormCode: "TADA",
      gameType: "SLOT",
      casinoType: "TADA-SLOT-057",
      Name: "Dice & Drop",
    },
    {
      platFormCode: "TADA",
      gameType: "SLOT",
      casinoType: "TADA-SLOT-058",
      Name: "3 Coin Golden OX",
    },
    {
      platFormCode: "TADA",
      gameType: "SLOT",
      casinoType: "TADA-SLOT-059",
      Name: "Cash Coin",
    },
    {
      platFormCode: "TADA",
      gameType: "SLOT",
      casinoType: "TADA-SLOT-060",
      Name: "Clover Ladybug",
    },
    {
      platFormCode: "TADA",
      gameType: "SLOT",
      casinoType: "TADA-SLOT-063",
      Name: "Supernova",
    },
    {
      platFormCode: "TADA",
      gameType: "EGAME",
      casinoType: "TADA-EGAME-001",
      Name: "Go Rush",
    },
    {
      platFormCode: "TADA",
      gameType: "EGAME",
      casinoType: "TADA-EGAME-002",
      Name: "Wheel",
    },
    {
      platFormCode: "TADA",
      gameType: "EGAME",
      casinoType: "TADA-EGAME-003",
      Name: "Tower",
    },
    {
      platFormCode: "TADA",
      gameType: "EGAME",
      casinoType: "TADA-EGAME-004",
      Name: "Crash Bonus",
    },
    {
      platFormCode: "TADA",
      gameType: "EGAME",
      casinoType: "TADA-EGAME-005",
      Name: "Mines",
    },
    {
      platFormCode: "TADA",
      gameType: "EGAME",
      casinoType: "TADA-EGAME-006",
      Name: "Plinko",
    },
    {
      platFormCode: "TADA",
      gameType: "EGAME",
      casinoType: "TADA-EGAME-007",
      Name: "Mines Gold",
    },
    {
      platFormCode: "TADA",
      gameType: "EGAME",
      casinoType: "TADA-EGAME-008",
      Name: "Cash Stack",
    },
    {
      platFormCode: "TADA",
      gameType: "TABLE",
      casinoType: "TADA-TABLE-001",
      Name: "Fortune Roulette",
    },
    {
      platFormCode: "TADA",
      gameType: "TABLE",
      casinoType: "TADA-TABLE-002",
      Name: "European Roulette",
    },
    {
      platFormCode: "TADA",
      gameType: "TABLE",
      casinoType: "TADA-TABLE-003",
      Name: "Golden Explorer",
    },
    {
      platFormCode: "TADA",
      gameType: "TABLE",
      casinoType: "TADA-TABLE-004",
      Name: "Chicken Dash",
    },
    {
      platFormCode: "TADA",
      gameType: "TABLE",
      casinoType: "TADA-TABLE-005",
      Name: "Lucky Roulette",
    },
    {
      platFormCode: "TADA",
      gameType: "FISH",
      casinoType: "TADA-FISH-001",
      Name: "Ocean King Jackpot",
    },
    {
      platFormCode: "TADA",
      gameType: "FISH",
      casinoType: "TADA-FISH-002",
      Name: "Mega Fishing",
    },
    {
      platFormCode: "TADA",
      gameType: "FISH",
      casinoType: "TADA-FISH-003",
      Name: "Crazy Hunter",
    },
    {
      platFormCode: "TADA",
      gameType: "FISH",
      casinoType: "TADA-FISH-004",
      Name: "Dinosaur Tycoon 2",
    },
    {
      platFormCode: "TADA",
      gameType: "FISH",
      casinoType: "TADA-FISH-005",
      Name: "Fortune Zombie Lightning",
    },
  ],
  PLAYNGO: [
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-001",
      Name: "24k Dragon",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-002",
      Name: "5x Magic",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-003",
      Name: "7 Sins",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-004",
      Name: "Ace of Spades",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-005",
      Name: "Agent Destiny",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-006",
      Name: "Ankh of Anubis",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-007",
      Name: "Annihilator",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-008",
      Name: "Aztec Idols",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-009",
      Name: "Aztec Warrior Princess",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-010",
      Name: "Baker's Treat",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-011",
      Name: "Banana Rock",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-012",
      Name: "Battle Royal",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-013",
      Name: "Big Win 777",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-014",
      Name: "Big Win Cat",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-015",
      Name: "Black Mamba",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-016",
      Name: "Blinged",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-017",
      Name: "Book of Dead",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-018",
      Name: "Bull in a China Shop",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-019",
      Name: "Cash Pump",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-020",
      Name: "Cash Vandal",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-021",
      Name: "Cat Wilde and the Doom of Dead",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-022",
      Name: "Cat Wilde in the Eclipse of the Sun God",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-023",
      Name: "Cats and Cash",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-024",
      Name: "Charlie Chance in Hell to Pay",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-025",
      Name: "Chinese New Year",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-026",
      Name: "Chronos Joker",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-027",
      Name: "Cloud Quest",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-028",
      Name: "Contact",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-029",
      Name: "Cops'n'Robbers",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-030",
      Name: "Rabbit Hole Riches - Court of Hearts",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-031",
      Name: "Coywolf Cash",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-032",
      Name: "Crazy Cows",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-033",
      Name: "Crystal Sun",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-034",
      Name: "Dawn of Egypt",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-035",
      Name: "Demon",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-036",
      Name: "Disco Diamonds",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-037",
      Name: "Divine Showdown",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-038",
      Name: "Doom of Egypt",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-039",
      Name: "Dragon Maiden",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-040",
      Name: "Dragon Ship",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-041",
      Name: "Easter Eggs",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-042",
      Name: "Enchanted Crystals",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-043",
      Name: "Enchanted Meadow",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-044",
      Name: "Energoonz",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-045",
      Name: "Eye of the Kraken",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-046",
      Name: "Feline Fury",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-047",
      Name: "Fire Joker",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-048",
      Name: "Fire Joker Freeze",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-049",
      Name: "Fire Toad",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-050",
      Name: "Firefly Frenzy",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-051",
      Name: "Fortune Teller",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-052",
      Name: "Fortunes of Ali Baba",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-053",
      Name: "Frozen Gems",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-054",
      Name: "FU ER DAI",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-055",
      Name: "Game of Gladiators",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-056",
      Name: "Gemix",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-057",
      Name: "Gold King",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-058",
      Name: "Gold Trophy 2",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-059",
      Name: "Gold Volcano",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-060",
      Name: "Golden Caravan",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-061",
      Name: "Golden Colts",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-062",
      Name: "Golden Legend",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-063",
      Name: "Golden Osiris",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-064",
      Name: "Golden Ticket",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-065",
      Name: "Golden Ticket 2",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-066",
      Name: "Grim Muerto",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-067",
      Name: "Happy Halloween",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-068",
      Name: "Holiday Season",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-069",
      Name: "Holiday Spirits",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-070",
      Name: "House of Doom",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-071",
      Name: "House of Doom 2: The Crypt",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-072",
      Name: "Ice Joker",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-073",
      Name: "Imperial Opera",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-074",
      Name: "Inferno Joker",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-075",
      Name: "Inferno Star",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-076",
      Name: "Irish Gold",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-077",
      Name: "Iron Girl",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-078",
      Name: "Jade Magician",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-079",
      Name: "Jewel Box",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-080",
      Name: "Jolly Roger",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-081",
      Name: "Jolly Roger 2",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-082",
      Name: "Lady of Fortune",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-083",
      Name: "Legacy of Dead",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-084",
      Name: "Legacy of Egypt",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-085",
      Name: "Leprechaun goes Egypt",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-086",
      Name: "Leprechaun Goes Wild",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-087",
      Name: "Lord Merlin and The Lady of The Lake",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-088",
      Name: "Lucky Diamonds",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-089",
      Name: "Madame Ink",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-090",
      Name: "Mahjong 88",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-091",
      Name: "Matsuri",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-092",
      Name: "Mermaid's Diamond",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-093",
      Name: "Merry Xmas",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-094",
      Name: "Miner Donkey Trouble",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-095",
      Name: "Mission Cash",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-096",
      Name: "Moon Princess",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-097",
      Name: "MULTIFRUIT 81",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-098",
      Name: "Mystery Joker",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-099",
      Name: "Mystery Joker 6000",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-100",
      Name: "Myth",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-101",
      Name: "New Year Riches",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-102",
      Name: "Ninja Fruits",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-103",
      Name: "Octopus Treasure",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-104",
      Name: "Pearl Lagoon",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-105",
      Name: "Pearls of India",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-106",
      Name: "Perfect Gems",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-107",
      Name: "Phoenix Reborn",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-108",
      Name: "Photo Safari",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-109",
      Name: "Piggy Bank Farm",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-110",
      Name: "Pimped",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-111",
      Name: "Planet Fortune",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-112",
      Name: "Prissy Princess",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-113",
      Name: "Prosperity Palace",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-114",
      Name: "Queen's Day Tilt",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-115",
      Name: "Rabbit Hole Riches",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-116",
      Name: "Rage to Riches",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-117",
      Name: "Raging Rex",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-118",
      Name: "Rainforest Magic",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-119",
      Name: "Rally 4 Riches",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-120",
      Name: "Reactoonz",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-121",
      Name: "Reactoonz 2",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-122",
      Name: "Rich Wilde & The Shield of Athena",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-123",
      Name: "Rich Wilde and the Amulet of Dead",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-124",
      Name: "Riches of RA",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-125",
      Name: "Riches of Robin",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-126",
      Name: "Riddle Reels: A Case of Riches",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-127",
      Name: "Ring of Odin",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-128",
      Name: "Rise of Athena",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-129",
      Name: "Rise of Dead",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-130",
      Name: "Rise of Merlin",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-131",
      Name: "Rise of Olympus",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-132",
      Name: "Royal Masquerade",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-133",
      Name: "Sabaton",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-134",
      Name: "Sails of Gold",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-135",
      Name: "Samba Carnival",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-136",
      Name: "Sea Hunter",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-137",
      Name: "Sizzling Spins",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-138",
      Name: "Space Race",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-139",
      Name: "Spin Party",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-140",
      Name: "Star Joker",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-141",
      Name: "Sticky Joker",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-142",
      Name: "Street Magic",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-143",
      Name: "Super Flip",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-144",
      Name: "Sweet 27",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-145",
      Name: "Sweet Alchemy",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-146",
      Name: "Testament",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-147",
      Name: "That's Rich",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-148",
      Name: "The Faces of Freya",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-149",
      Name: "The Green Knight",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-150",
      Name: "The Paying Piano Club",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-151",
      Name: "The Shimmering Woods",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-152",
      Name: "The Sword and The Grail",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-153",
      Name: "Thunder Screech",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-154",
      Name: "Tome of Madness",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-155",
      Name: "Tower Quest",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-156",
      Name: "Troll Hunters",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-157",
      Name: "Troll Hunters 2",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-158",
      Name: "Viking Runecraft",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-159",
      Name: "Wild Blood",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-160",
      Name: "Wild Blood 2",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-161",
      Name: "Wild Falls",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-162",
      Name: "Wild Frames",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-163",
      Name: "Wild Melon",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-164",
      Name: "Wild North",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-165",
      Name: "Wild Rails",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-166",
      Name: "Wildhound Derby",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-167",
      Name: "Win-A-Beest",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-168",
      Name: "Wizard of Gems",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-169",
      Name: "Xmas Joker",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-170",
      Name: "Xmas Magic",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-171",
      Name: "3 Clown Monty",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-172",
      Name: "Candy Island Princess",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-173",
      Name: "Charlie Chance",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-174",
      Name: "Prism of Gems",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-175",
      Name: "Scroll of Dead",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-176",
      Name: "Agent of Hearts",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-177",
      Name: "Blazin' Bullfrog",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-178",
      Name: "Coils of Cash",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-179",
      Name: "Diamonds of the Realm",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-180",
      Name: "Free Reelin' Joker",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-181",
      Name: "Gemix 2",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-182",
      Name: "Hotel Yeti-Way",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-183",
      Name: "Pack & Cash",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-184",
      Name: "Sisters of the Sun",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-185",
      Name: "Dr. Toonz",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-186",
      Name: "Ghost of Dead",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-187",
      Name: "The Wild Class",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-188",
      Name: "Charlie Chance and the Curse of Cleopatra",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-189",
      Name: "Muerto en Mictlán",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-190",
      Name: "Sparky & Shortz",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-191",
      Name: "Tales of Asgard: Loki's Fortune",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-192",
      Name: "Legend of the Ice Dragon",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-193",
      Name: "The Last Sundown",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-194",
      Name: "Rich Wilde and the Wandering City",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-195",
      Name: "Merlin and the Ice Queen Morgana",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-196",
      Name: "Moon Princess: Christmas Kingdom",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-197",
      Name: "Hooligan Hustle",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-198",
      Name: "Beasts of Fire",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-199",
      Name: "Captain Xeno's Earth Adventure",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-200",
      Name: "Tale of Kyubiko",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-201",
      Name: "15 Crystal Roses: A Tale of Love",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-202",
      Name: "Love Joker",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-203",
      Name: "Gigantoonz",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-204",
      Name: "Cat Wilde and the Lost Chapter",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-205",
      Name: "Secret of Dead",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-206",
      Name: "Tales of Asgard: Freya's Wedding",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-207",
      Name: "Safari of Wealth",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-208",
      Name: "Fat Frankies",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-209",
      Name: "Raging Rex 2",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-210",
      Name: "Eye of Atum",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-211",
      Name: "Moon Princess 100",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-212",
      Name: "Forge of Gems",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-213",
      Name: "Puebla Parade",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-214",
      Name: "Rise of Gods: Reckoning",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-215",
      Name: "Idol of Fortune",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-216",
      Name: "Animal Madness",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-217",
      Name: "King's Mask",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-218",
      Name: "Wild Trigger",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-219",
      Name: "Derby Wheel",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-220",
      Name: "Rocco Gallo",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-221",
      Name: "Cat Wilde and the Pyramids of Dead",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-222",
      Name: "Merlin's Grimoire",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-223",
      Name: "Rotiki",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-224",
      Name: "Cash of Command",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-225",
      Name: "Mega Don",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-226",
      Name: "Leprechaun's Vault",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-227",
      Name: "Forge of Fortunes",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-228",
      Name: "Bull in a Rodeo",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-229",
      Name: "Champions of Mithrune",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-230",
      Name: "Mount M",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-231",
      Name: "Gates of Troy",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-232",
      Name: "Immortails of Egypt",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-233",
      Name: "Fortune Rewind",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-234",
      Name: "Boat Bonanza",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-235",
      Name: "Count Jokula",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-236",
      Name: "Canine Carnage",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-237",
      Name: "Rise of Olympus 100",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-238",
      Name: "USA Flip",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-239",
      Name: "Clash of Camelot",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-240",
      Name: "Athena Ascending",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-241",
      Name: "Naughty Nick's Book",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-242",
      Name: "Shamrock Miner",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-243",
      Name: "Wild Falls 2",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-244",
      Name: "Cash-a-Cabana",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-245",
      Name: "Invading Vegas",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-246",
      Name: "Pilgrim of Dead",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-247",
      Name: "Game of Gladiators: Uprising",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-248",
      Name: "Moon Princess Trinity",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-249",
      Name: "Legacy of Inca",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-250",
      Name: "Wild Bandolier",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-251",
      Name: "Ternion",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-252",
      Name: "Pandora's Box of Evil",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-253",
      Name: "Slashimi",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-254",
      Name: "Ronin's Honour",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-255",
      Name: "Gerard's Gambit",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-256",
      Name: "Captain Glum: Pirate Hunter",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-257",
      Name: "Luchamigos",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-258",
      Name: "Highway Legends",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-259",
      Name: "Free Reelin' Joker 1000",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-260",
      Name: "Viking Runecraft Apocalypse",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-261",
      Name: "Sweet Alchemy 2",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-262",
      Name: "Sparky & Shortz Hidden Joules",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-263",
      Name: "Fox Mayhem",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-264",
      Name: "Merlin: Journey of Flame",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-265",
      Name: "Scroll of Seth",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-266",
      Name: "Sweet Alchemy 100",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-267",
      Name: "Boat Bonanza Colossal Catch",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-268",
      Name: "Scales of Dead",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-269",
      Name: "Temple of Prosperity",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-270",
      Name: "Piggy Blitz",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-271",
      Name: "Raging Rex 3",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-272",
      Name: "Return of The Green Knight",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-273",
      Name: "Ruff Heist",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-274",
      Name: "Invading Vegas: Las Christmas",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-275",
      Name: "Gargantoonz",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-276",
      Name: "Mega Don Feeding Frenzy",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-277",
      Name: "Viking Runecraft 100",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-278",
      Name: "Pandastic Adventure",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-279",
      Name: "Love is in the Fair",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-280",
      Name: "Cat Wilde and the Incan Quest",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-281",
      Name: "Moon Princess Power of Love",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-282",
      Name: "3 Clown Monty II",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-283",
      Name: "Banquet of Dead",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-284",
      Name: "Boat Bonanza Down Under",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-285",
      Name: "Chambers of Ancients",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-286",
      Name: "Colt Lightning",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-287",
      Name: "Legacy of Dynasties",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-288",
      Name: "Legion Gold",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-289",
      Name: "Legion Gold Unleashed",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-290",
      Name: "Mystery Genie Fortunes of the Lamp Team Blue",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-291",
      Name: "Piranha Pays",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-292",
      Name: "Rascal Riches",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-293",
      Name: "Sherwood Gold",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-294",
      Name: "Tales of Mithrune Syn's Fortune",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-295",
      Name: "Undefeated Xerxes",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-296",
      Name: "Wild Survivor",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-297",
      Name: "Spark of Genius",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-298",
      Name: "Tomb of Gold",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-299",
      Name: "The Sword and the Grail Excalibur",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-300",
      Name: "Fulong 88",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-301",
      Name: "Colt Lightning Firestorm",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-302",
      Name: "Rich Wilde and the Tome of Insanity",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-303",
      Name: "Gold of Fortune God",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-304",
      Name: "Merlin Realm of Charm",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-305",
      Name: "Temple of Tollan",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-306",
      Name: "Journey to Paris",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-307",
      Name: "Oasis of Dead",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-308",
      Name: "Whispering Winds",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-309",
      Name: "King's Mask Eclipse of Gods",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-310",
      Name: "Rise of Olympus Origins",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-311",
      Name: "Mafia Gold",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-312",
      Name: "Joker Flip",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-313",
      Name: "Scourge of Rome",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-314",
      Name: "Ankh of Anubis Awakening",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-315",
      Name: "Gemix 100",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-316",
      Name: "Mirror Joker",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-317",
      Name: "Buildin' Bucks",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-318",
      Name: "Divine Divas",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-319",
      Name: "Lady of Fortune Remastered",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-320",
      Name: "Wildest Gambit",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-321",
      Name: "Rich Wilde and the Pearls of Vishnu",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-322",
      Name: "Piggy Blitz Disco Gold",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-323",
      Name: "Legion Gold and the Sphinx of Dead",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-324",
      Name: "Beasts of Fire Maximum",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-325",
      Name: "Baron: Lord of Saturday",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-326",
      Name: "Stepping Diamonds",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-327",
      Name: "Sobek's Godly Spins",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-328",
      Name: "Hot Dog Heist",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-329",
      Name: "Jolly Roger Wild Kraken",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-330",
      Name: "Midnight Gold",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-331",
      Name: "Tower Quest Legacy",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-332",
      Name: "Treasures of Kongar",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-333",
      Name: "Legacy of Gems Blitzways",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-334",
      Name: "Potion of Madness",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-335",
      Name: "Invading Vegas Revenge on Mars",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-336",
      Name: "Crystal Hall",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-337",
      Name: "Myth of Dead",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-338",
      Name: "Legion Gold Victory!",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-339",
      Name: "Medusa's Madness",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-340",
      Name: "Trinity Impact",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-341",
      Name: "Spinnin' Records Into the Beat",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-342",
      Name: "Loot & Labyrinths",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-343",
      Name: "1001 Mystery Genie Fortunes",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-344",
      Name: "Moon Princess Origins",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-345",
      Name: "Mystery Egg Surprise",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-346",
      Name: "Rich Wilde and the Tome of Dead",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-347",
      Name: "Boat Bonanza CrocoNile!",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-348",
      Name: "Crabby's Gold",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-349",
      Name: "Treats of Terror",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-350",
      Name: "Dragonfate's Favor",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-351",
      Name: "Fire Joker 100",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-352",
      Name: "City of Sound",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-353",
      Name: "King of Sweets",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-354",
      Name: "Viper City Heist",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-355",
      Name: "Tomb of Gold II",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-356",
      Name: "Big Win Cat Pawsperity",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-357",
      Name: "Moon Princess Stargazing",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-358",
      Name: "Rise of Orpheus",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-359",
      Name: "Cashin' Joker",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-360",
      Name: "The Green Knight Oath of Thorns",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-361",
      Name: "Play'n GO Buffalo of Wealth",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-362",
      Name: "Lady of Fortune Destiny Spins",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-363",
      Name: "Super Flip Deluxe",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-364",
      Name: "13th Trial Hercules Abyssways",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-365",
      Name: "Spinnin' Records: Raving Reels",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-366",
      Name: "Leprechaun's Diamond Dig",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-367",
      Name: "Fire Joker Blitz",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-368",
      Name: "Fire Toad 2",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-369",
      Name: "Rise of Olympus Extreme",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-370",
      Name: "Rosy Orbit Treasure Turn",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-371",
      Name: "Lab of Madness It's A-Wild!",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-372",
      Name: "Bullion Xpress",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-373",
      Name: "Fate of Dead Blitzways",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-374",
      Name: "Bao Shi",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-375",
      Name: "Bubblin' Riches",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-376",
      Name: "Reactoonz 100",
    },
    {
      platFormCode: "PLAYNGO",
      gameType: "SLOT",
      casinoType: "PLAYNGO-SLOT-381",
      Name: "Static Nightmare Abyssways",
    },
  ],
  OCTAPLAY: [
    {
      platFormCode: "OCTOPLAY",
      gameType: "SLOT",
      casinoType: "OCTOPLAY-SLOT-001",
      Name: "Aztec Ancients",
    },
    {
      platFormCode: "OCTOPLAY",
      gameType: "SLOT",
      casinoType: "OCTOPLAY-SLOT-002",
      Name: "Blarney's Gold",
    },
    {
      platFormCode: "OCTOPLAY",
      gameType: "SLOT",
      casinoType: "OCTOPLAY-SLOT-003",
      Name: "Blazing Touch",
    },
    {
      platFormCode: "OCTOPLAY",
      gameType: "SLOT",
      casinoType: "OCTOPLAY-SLOT-004",
      Name: "Bullet Bonanza",
    },
    {
      platFormCode: "OCTOPLAY",
      gameType: "SLOT",
      casinoType: "OCTOPLAY-SLOT-005",
      Name: "Caishen's Temple of Gold",
    },
    {
      platFormCode: "OCTOPLAY",
      gameType: "SLOT",
      casinoType: "OCTOPLAY-SLOT-006",
      Name: "Cash Strike",
    },
    {
      platFormCode: "OCTOPLAY",
      gameType: "SLOT",
      casinoType: "OCTOPLAY-SLOT-007",
      Name: "Disco Dive",
    },
    {
      platFormCode: "OCTOPLAY",
      gameType: "SLOT",
      casinoType: "OCTOPLAY-SLOT-008",
      Name: "Gold Chain",
    },
    {
      platFormCode: "OCTOPLAY",
      gameType: "SLOT",
      casinoType: "OCTOPLAY-SLOT-009",
      Name: "Heavy Anchor",
    },
    {
      platFormCode: "OCTOPLAY",
      gameType: "SLOT",
      casinoType: "OCTOPLAY-SLOT-010",
      Name: "Hot Harvest",
    },
    {
      platFormCode: "OCTOPLAY",
      gameType: "SLOT",
      casinoType: "OCTOPLAY-SLOT-011",
      Name: "Lollicat",
    },
    {
      platFormCode: "OCTOPLAY",
      gameType: "SLOT",
      casinoType: "OCTOPLAY-SLOT-012",
      Name: "Mr Piggles",
    },
    {
      platFormCode: "OCTOPLAY",
      gameType: "SLOT",
      casinoType: "OCTOPLAY-SLOT-013",
      Name: "Mutant Potatoes",
    },
    {
      platFormCode: "OCTOPLAY",
      gameType: "SLOT",
      casinoType: "OCTOPLAY-SLOT-014",
      Name: "Panda Bills",
    },
    {
      platFormCode: "OCTOPLAY",
      gameType: "SLOT",
      casinoType: "OCTOPLAY-SLOT-015",
      Name: "Pearly Shores",
    },
    {
      platFormCode: "OCTOPLAY",
      gameType: "SLOT",
      casinoType: "OCTOPLAY-SLOT-016",
      Name: "Salmon King",
    },
    {
      platFormCode: "OCTOPLAY",
      gameType: "SLOT",
      casinoType: "OCTOPLAY-SLOT-017",
      Name: "Spirit Blast",
    },
    {
      platFormCode: "OCTOPLAY",
      gameType: "SLOT",
      casinoType: "OCTOPLAY-SLOT-018",
      Name: "Star Kingdom",
    },
    {
      platFormCode: "OCTOPLAY",
      gameType: "SLOT",
      casinoType: "OCTOPLAY-SLOT-019",
      Name: "Twice as Nice",
    },
    {
      platFormCode: "OCTOPLAY",
      gameType: "SLOT",
      casinoType: "OCTOPLAY-SLOT-020",
      Name: "Super Sundae",
    },
    {
      platFormCode: "OCTOPLAY",
      gameType: "SLOT",
      casinoType: "OCTOPLAY-SLOT-021",
      Name: "Gemstone Guardians",
    },
    {
      platFormCode: "OCTOPLAY",
      gameType: "SLOT",
      casinoType: "OCTOPLAY-SLOT-022",
      Name: "Sheep King",
    },
    {
      platFormCode: "OCTOPLAY",
      gameType: "SLOT",
      casinoType: "OCTOPLAY-SLOT-023",
      Name: "Rune Raiders",
    },
    {
      platFormCode: "OCTOPLAY",
      gameType: "SLOT",
      casinoType: "OCTOPLAY-SLOT-024",
      Name: "Flaming Frenzy",
    },
    {
      platFormCode: "OCTOPLAY",
      gameType: "SLOT",
      casinoType: "OCTOPLAY-SLOT-025",
      Name: "Boom the Buffoon",
    },
    {
      platFormCode: "OCTOPLAY",
      gameType: "SLOT",
      casinoType: "OCTOPLAY-SLOT-026",
      Name: "Happy Honey",
    },
    {
      platFormCode: "OCTOPLAY",
      gameType: "SLOT",
      casinoType: "OCTOPLAY-SLOT-027",
      Name: "Zeus Smash",
    },
    {
      platFormCode: "OCTOPLAY",
      gameType: "SLOT",
      casinoType: "OCTOPLAY-SLOT-028",
      Name: "Sweet Smash",
    },
    {
      platFormCode: "OCTOPLAY",
      gameType: "SLOT",
      casinoType: "OCTOPLAY-SLOT-029",
      Name: "Mole Smash",
    },
    {
      platFormCode: "OCTOPLAY",
      gameType: "SLOT",
      casinoType: "OCTOPLAY-SLOT-030",
      Name: "Bass Smash",
    },
    {
      platFormCode: "OCTOPLAY",
      gameType: "SLOT",
      casinoType: "OCTOPLAY-SLOT-031",
      Name: "Bounty Smash",
    },
    {
      platFormCode: "OCTOPLAY",
      gameType: "SLOT",
      casinoType: "OCTOPLAY-SLOT-032",
      Name: "Caishen Smash",
    },
    {
      platFormCode: "OCTOPLAY",
      gameType: "SLOT",
      casinoType: "OCTOPLAY-SLOT-033",
      Name: "Eggsponential",
    },
    {
      platFormCode: "OCTOPLAY",
      gameType: "SLOT",
      casinoType: "OCTOPLAY-SLOT-034",
      Name: "Christmas Crumble",
    },
    {
      platFormCode: "OCTOPLAY",
      gameType: "SLOT",
      casinoType: "OCTOPLAY-SLOT-035",
      Name: "Santa Smash",
    },
    {
      platFormCode: "OCTOPLAY",
      gameType: "SLOT",
      casinoType: "OCTOPLAY-SLOT-036",
      Name: "Royal Ribbit",
    },
    {
      platFormCode: "OCTOPLAY",
      gameType: "SLOT",
      casinoType: "OCTOPLAY-SLOT-037",
      Name: "Wilfred's Wheel",
    },
    {
      platFormCode: "OCTOPLAY",
      gameType: "SLOT",
      casinoType: "OCTOPLAY-SLOT-038",
      Name: "Buffalo Smash",
    },
    {
      platFormCode: "OCTOPLAY",
      gameType: "SLOT",
      casinoType: "OCTOPLAY-SLOT-039",
      Name: "Teddy's Quest",
    },
    {
      platFormCode: "OCTOPLAY",
      gameType: "SLOT",
      casinoType: "OCTOPLAY-SLOT-040",
      Name: "Eternal Clash",
    },
    {
      platFormCode: "OCTOPLAY",
      gameType: "SLOT",
      casinoType: "OCTOPLAY-SLOT-041",
      Name: "Sphere Smash",
    },
    {
      platFormCode: "OCTOPLAY",
      gameType: "SLOT",
      casinoType: "OCTOPLAY-SLOT-042",
      Name: "Hell Of A Spin",
    },
    {
      platFormCode: "OCTOPLAY",
      gameType: "SLOT",
      casinoType: "OCTOPLAY-SLOT-043",
      Name: "Gold Smash",
    },
    {
      platFormCode: "OCTOPLAY",
      gameType: "SLOT",
      casinoType: "OCTOPLAY-SLOT-044",
      Name: "Lord of the Dunes",
    },
    {
      platFormCode: "OCTOPLAY",
      gameType: "SLOT",
      casinoType: "OCTOPLAY-SLOT-045",
      Name: "Shaolin Panda Chaos Reels",
    },
    {
      platFormCode: "OCTOPLAY",
      gameType: "SLOT",
      casinoType: "OCTOPLAY-SLOT-046",
      Name: "Eternal Clash Reloaded",
    },
    {
      platFormCode: "OCTOPLAY",
      gameType: "SLOT",
      casinoType: "OCTOPLAY-SLOT-047",
      Name: "Doge Life",
    },
    {
      platFormCode: "OCTOPLAY",
      gameType: "SLOT",
      casinoType: "OCTOPLAY-SLOT-048",
      Name: "Cash Inferno Sizzling Scatters",
    },
    {
      platFormCode: "OCTOPLAY",
      gameType: "SLOT",
      casinoType: "OCTOPLAY-SLOT-049",
      Name: "Vault Blast Hold & Win",
    },
    {
      platFormCode: "OCTOPLAY",
      gameType: "SLOT",
      casinoType: "OCTOPLAY-SLOT-050",
      Name: "Midas Moolah: Random Reels",
    },
    {
      platFormCode: "OCTOPLAY",
      gameType: "SLOT",
      casinoType: "OCTOPLAY-SLOT-052",
      Name: "Barhalla",
    },
    {
      platFormCode: "OCTOPLAY",
      gameType: "SLOT",
      casinoType: "OCTOPLAY-SLOT-053",
      Name: "Dystopia: Rebel Road",
    },
    {
      platFormCode: "OCTOPLAY",
      gameType: "SLOT",
      casinoType: "OCTOPLAY-SLOT-054",
      Name: "Jackpot Heist: Daylight Robbery",
    },
    {
      platFormCode: "OCTOPLAY",
      gameType: "SLOT",
      casinoType: "OCTOPLAY-SLOT-055",
      Name: "777 Hot Reels",
    },
    {
      platFormCode: "OCTOPLAY",
      gameType: "SLOT",
      casinoType: "OCTOPLAY-SLOT-056",
      Name: "Mad Melons Chaos Reels",
    },
    {
      platFormCode: "OCTOPLAY",
      gameType: "SLOT",
      casinoType: "OCTOPLAY-SLOT-057",
      Name: "Crop of the Dead",
    },
    {
      platFormCode: "OCTOPLAY",
      gameType: "SLOT",
      casinoType: "OCTOPLAY-SLOT-058",
      Name: "Golden Suns Chain Collect",
    },
    {
      platFormCode: "OCTOPLAY",
      gameType: "SLOT",
      casinoType: "OCTOPLAY-SLOT-059",
      Name: "Christmas Link Express: Hold & Win",
    },
    {
      platFormCode: "OCTOPLAY",
      gameType: "SLOT",
      casinoType: "OCTOPLAY-SLOT-060",
      Name: "Juicy Rolls: Feature Frenzy",
    },
    {
      platFormCode: "OCTOPLAY",
      gameType: "SLOT",
      casinoType: "OCTOPLAY-SLOT-061",
      Name: "Twin Cash: Hold & Win",
    },
    {
      platFormCode: "OCTOPLAY",
      gameType: "SLOT",
      casinoType: "OCTOPLAY-SLOT-062",
      Name: "The Great Jackpot Expedition",
    },
    {
      platFormCode: "OCTOPLAY",
      gameType: "SLOT",
      casinoType: "OCTOPLAY-SLOT-063",
      Name: "Lucky Seven Spin",
    },
    {
      platFormCode: "OCTOPLAY",
      gameType: "SLOT",
      casinoType: "OCTOPLAY-SLOT-064",
      Name: "Cash On Wheels: Hold & Win",
    },
    {
      platFormCode: "OCTOPLAY",
      gameType: "SLOT",
      casinoType: "OCTOPLAY-SLOT-065",
      Name: "Treasure Journey: Genie`s Gold",
    },
    {
      platFormCode: "OCTOPLAY",
      gameType: "SLOT",
      casinoType: "OCTOPLAY-SLOT-066",
      Name: "God Smash: Eternal Chaos",
    },
    {
      platFormCode: "OCTOPLAY",
      gameType: "SLOT",
      casinoType: "OCTOPLAY-SLOT-067",
      Name: "12 Treasures: Aztec Riches",
    },
    {
      platFormCode: "OCTOPLAY",
      gameType: "SLOT",
      casinoType: "OCTOPLAY-SLOT-068",
      Name: "Buffalo Blaze: Wild Wealth",
    },
    {
      platFormCode: "OCTOPLAY",
      gameType: "SLOT",
      casinoType: "OCTOPLAY-SLOT-070",
      Name: "Sugar Splash",
    },
    {
      platFormCode: "OCTOPLAY",
      gameType: "SLOT",
      casinoType: "OCTOPLAY-SLOT-071",
      Name: "Wish for a Cash Star",
    },
    {
      platFormCode: "OCTOPLAY",
      gameType: "SLOT",
      casinoType: "OCTOPLAY-SLOT-072",
      Name: "5 Star Coins: Hold & Win",
    },
    {
      platFormCode: "OCTOPLAY",
      gameType: "SLOT",
      casinoType: "OCTOPLAY-SLOT-073",
      Name: "Kawaii Princess",
    },
    {
      platFormCode: "OCTOPLAY",
      gameType: "SLOT",
      casinoType: "OCTOPLAY-SLOT-074",
      Name: "Joker Jackpots: Prize Mania",
    },
    {
      platFormCode: "OCTOPLAY",
      gameType: "SLOT",
      casinoType: "OCTOPLAY-SLOT-075",
      Name: "5 Rings of Darkness",
    },
    {
      platFormCode: "OCTOPLAY",
      gameType: "SLOT",
      casinoType: "OCTOPLAY-SLOT-076",
      Name: "Blazing Inferno Chaos Reels",
    },
    {
      platFormCode: "OCTOPLAY",
      gameType: "SLOT",
      casinoType: "OCTOPLAY-SLOT-077",
      Name: "Legends: Battle for Earth",
    },
    {
      platFormCode: "OCTOPLAY",
      gameType: "SLOT",
      casinoType: "OCTOPLAY-SLOT-078",
      Name: "Doom's Digging Machine",
    },
    {
      platFormCode: "OCTOPLAY",
      gameType: "SLOT",
      casinoType: "OCTOPLAY-SLOT-079",
      Name: "Walrus King",
    },
    {
      platFormCode: "OCTOPLAY",
      gameType: "SLOT",
      casinoType: "OCTOPLAY-SLOT-080",
      Name: "Thunder Hog Chaos Reels",
    },
    {
      platFormCode: "OCTOPLAY",
      gameType: "SLOT",
      casinoType: "OCTOPLAY-SLOT-081",
      Name: "Grand Link Express: Hold & Win",
    },
    {
      platFormCode: "OCTOPLAY",
      gameType: "SLOT",
      casinoType: "OCTOPLAY-SLOT-082",
      Name: "Wild White Rhino",
    },
    {
      platFormCode: "OCTOPLAY",
      gameType: "SLOT",
      casinoType: "OCTOPLAY-SLOT-083",
      Name: "777 Streak",
    },
    {
      platFormCode: "OCTOPLAY",
      gameType: "SLOT",
      casinoType: "OCTOPLAY-SLOT-084",
      Name: "Pip & Pippa's Pots of Plenty",
    },
    {
      platFormCode: "OCTOPLAY",
      gameType: "SLOT",
      casinoType: "OCTOPLAY-SLOT-085",
      Name: "777 Hot Reels: Supercharged",
    },
    {
      platFormCode: "OCTOPLAY",
      gameType: "SLOT",
      casinoType: "OCTOPLAY-SLOT-086",
      Name: "Flame & Fortune: Hold & Win",
    },
    {
      platFormCode: "OCTOPLAY",
      gameType: "SLOT",
      casinoType: "OCTOPLAY-SLOT-087",
      Name: "Cash Maximus: Battle Arena",
    },
    {
      platFormCode: "OCTOPLAY",
      gameType: "SLOT",
      casinoType: "OCTOPLAY-SLOT-088",
      Name: "3 Pyramids of Gold: Hold & Win",
    },
    {
      platFormCode: "OCTOPLAY",
      gameType: "SLOT",
      casinoType: "OCTOPLAY-SLOT-089",
      Name: "Roaming Wild Buffalo",
    },
    {
      platFormCode: "OCTOPLAY",
      gameType: "SLOT",
      casinoType: "OCTOPLAY-SLOT-090",
      Name: "Bank Busters: The Big Score",
    },
    {
      platFormCode: "OCTOPLAY",
      gameType: "SLOT",
      casinoType: "OCTOPLAY-SLOT-091",
      Name: "3 Golden Baskets: Treasure Tides",
    },
    {
      platFormCode: "OCTOPLAY",
      gameType: "SLOT",
      casinoType: "OCTOPLAY-SLOT-092",
      Name: "Dynamite Trail: Hold & Win",
    },
    {
      platFormCode: "OCTOPLAY",
      gameType: "SLOT",
      casinoType: "OCTOPLAY-SLOT-093",
      Name: "Break the Piggy Bank",
    },
    {
      platFormCode: "OCTOPLAY",
      gameType: "SLOT",
      casinoType: "OCTOPLAY-SLOT-094",
      Name: "Vegas Blitz: Hold & Win",
    },
    {
      platFormCode: "OCTOPLAY",
      gameType: "SLOT",
      casinoType: "OCTOPLAY-SLOT-095",
      Name: "Supersonic Express: Hold & Win",
    },
    {
      platFormCode: "OCTOPLAY",
      gameType: "SLOT",
      casinoType: "OCTOPLAY-SLOT-096",
      Name: "Super Grand Link Express: Hold & Win",
    },
    {
      platFormCode: "OCTOPLAY",
      gameType: "SLOT",
      casinoType: "OCTOPLAY-SLOT-097",
      Name: "Buffalo Smash: Supercharged",
    },
    {
      platFormCode: "OCTOPLAY",
      gameType: "SLOT",
      casinoType: "OCTOPLAY-SLOT-098",
      Name: "4 Leaf Fortune: Hold & Win",
    },
    {
      platFormCode: "OCTOPLAY",
      gameType: "SLOT",
      casinoType: "OCTOPLAY-SLOT-099",
      Name: "Piggy Coin: Hold & Win",
    },
    {
      platFormCode: "OCTOPLAY",
      gameType: "SLOT",
      casinoType: "OCTOPLAY-SLOT-100",
      Name: "3 Energy Diamonds: Hold & Win",
    },
    {
      platFormCode: "OCTOPLAY",
      gameType: "SLOT",
      casinoType: "OCTOPLAY-SLOT-101",
      Name: "Shaolin Panda: Hold & Win",
    },
    {
      platFormCode: "OCTOPLAY",
      gameType: "SLOT",
      casinoType: "OCTOPLAY-SLOT-102",
      Name: "Savannah Gold: Coin of the Wild",
    },
    {
      platFormCode: "OCTOPLAY",
      gameType: "SLOT",
      casinoType: "OCTOPLAY-SLOT-103",
      Name: "Jackpot District: City of Fortune",
    },
    {
      platFormCode: "OCTOPLAY",
      gameType: "SLOT",
      casinoType: "OCTOPLAY-SLOT-104",
      Name: "JJ 1000: Hold & Win",
    },
    {
      platFormCode: "OCTOPLAY",
      gameType: "SLOT",
      casinoType: "OCTOPLAY-SLOT-105",
      Name: "Follow the Cash Rabbit",
    },
    {
      platFormCode: "OCTOPLAY",
      gameType: "SLOT",
      casinoType: "OCTOPLAY-SLOT-106",
      Name: "5 Relics of Power: Hold & Win",
    },
    {
      platFormCode: "OCTOPLAY",
      gameType: "SLOT",
      casinoType: "OCTOPLAY-SLOT-107",
      Name: "Juicy Jewels Supercharged",
    },
    {
      platFormCode: "OCTOPLAY",
      gameType: "SLOT",
      casinoType: "OCTOPLAY-SLOT-108",
      Name: "The Big Bark: Golden Jackpots",
    },
    {
      platFormCode: "OCTOPLAY",
      gameType: "SLOT",
      casinoType: "OCTOPLAY-SLOT-109",
      Name: "Rooster's Gold: Hold & Win",
    },
    {
      platFormCode: "OCTOPLAY",
      gameType: "SLOT",
      casinoType: "OCTOPLAY-SLOT-110",
      Name: "Vegas is Dead: Battle Arena",
    },
    {
      platFormCode: "OCTOPLAY",
      gameType: "SLOT",
      casinoType: "OCTOPLAY-SLOT-111",
      Name: "Coin Bang Bang: Hold & Win",
    },
    {
      platFormCode: "OCTOPLAY",
      gameType: "SLOT",
      casinoType: "OCTOPLAY-SLOT-112",
      Name: "Super Cash: Three Little Wins",
    },
    {
      platFormCode: "OCTOPLAY",
      gameType: "SLOT",
      casinoType: "OCTOPLAY-SLOT-113",
      Name: "Candyland Jackpots",
    },
    {
      platFormCode: "OCTOPLAY",
      gameType: "SLOT",
      casinoType: "OCTOPLAY-SLOT-114",
      Name: "3 Rail Express: Hold & Win",
    },
    {
      platFormCode: "OCTOPLAY",
      gameType: "SLOT",
      casinoType: "OCTOPLAY-SLOT-115",
      Name: "Gates of the Underworld",
    },
    {
      platFormCode: "OCTOPLAY",
      gameType: "SLOT",
      casinoType: "OCTOPLAY-SLOT-116",
      Name: "The Greed Machine",
    },
    {
      platFormCode: "OCTOPLAY",
      gameType: "SLOT",
      casinoType: "OCTOPLAY-SLOT-117",
      Name: "Turbo Diamonds: Hold & Win",
    },
    {
      platFormCode: "OCTOPLAY",
      gameType: "SLOT",
      casinoType: "OCTOPLAY-SLOT-119",
      Name: "Guardian of Gold: Hold & Win",
    },
    {
      platFormCode: "OCTOPLAY",
      gameType: "SLOT",
      casinoType: "OCTOPLAY-SLOT-120",
      Name: "3 Gods Unleashed: Hold & Win",
    },
    {
      platFormCode: "OCTOPLAY",
      gameType: "SLOT",
      casinoType: "OCTOPLAY-SLOT-121",
      Name: "777 Super Wheel: Hold & Win",
    },
    {
      platFormCode: "OCTOPLAY",
      gameType: "SLOT",
      casinoType: "OCTOPLAY-SLOT-122",
      Name: "Crack the Pumpkin Bank",
    },
    {
      platFormCode: "OCTOPLAY",
      gameType: "SLOT",
      casinoType: "OCTOPLAY-SLOT-123",
      Name: "777 Streak: Supercharged",
    },
  ],
  JJ: [
    {
      platFormCode: "JJ",
      casinoType: "2J-SLOT-001",
      Name: "GOD OF WEALTH",
      gameType: "SLOT",
    },
    {
      platFormCode: "JJ",
      casinoType: "2J-SLOT-002",
      Name: "ELVES",
      gameType: "SLOT",
    },
    {
      platFormCode: "JJ",
      casinoType: "2J-SLOT-003",
      Name: "777 FRUIT",
      gameType: "SLOT",
    },
    {
      platFormCode: "JJ",
      casinoType: "2J-SLOT-004",
      Name: "BINGO LUCKY CLOVER",
      gameType: "SLOT",
    },
    {
      platFormCode: "JJ",
      casinoType: "2J-SLOT-005",
      Name: "FOOTBALL",
      gameType: "SLOT",
    },
    {
      platFormCode: "JJ",
      casinoType: "2J-SLOT-006",
      Name: "WILD VEGAS",
      gameType: "SLOT",
    },
    {
      platFormCode: "JJ",
      casinoType: "2J-SLOT-007",
      Name: "LAND OF GEMS",
      gameType: "SLOT",
    },
    {
      platFormCode: "JJ",
      casinoType: "2J-SLOT-008",
      Name: "PHOENIX",
      gameType: "SLOT",
    },
    {
      platFormCode: "JJ",
      casinoType: "2J-SLOT-009",
      Name: "GOD OF FORTUNE",
      gameType: "SLOT",
    },
    {
      platFormCode: "JJ",
      casinoType: "2J-SLOT-010",
      Name: "ZEUS POWER",
      gameType: "SLOT",
    },
    {
      platFormCode: "JJ",
      casinoType: "2J-SLOT-011",
      Name: "RAMPAGE BUFFALO",
      gameType: "SLOT",
    },
    {
      platFormCode: "JJ",
      casinoType: "2J-SLOT-012",
      Name: "FRUIT MARY",
      gameType: "SLOT",
    },
    {
      platFormCode: "JJ",
      casinoType: "2J-SLOT-013",
      Name: "MERMAID'S DANCE",
      gameType: "SLOT",
    },
    {
      platFormCode: "JJ",
      casinoType: "2J-SLOT-014",
      Name: "HALLOWEEN",
      gameType: "SLOT",
    },
    {
      platFormCode: "JJ",
      casinoType: "2J-SLOT-015",
      Name: "RISING FORTUNES",
      gameType: "SLOT",
    },
    {
      platFormCode: "JJ",
      casinoType: "2J-SLOT-016",
      Name: "JUNGLE TIGER",
      gameType: "SLOT",
    },
    {
      platFormCode: "JJ",
      casinoType: "2J-SLOT-017",
      Name: "MR.FRANKENSTEIN",
      gameType: "SLOT",
    },
    {
      platFormCode: "JJ",
      casinoType: "2J-SLOT-018",
      Name: "FORTUNE BAMBOO PANDA",
      gameType: "SLOT",
    },
    {
      platFormCode: "JJ",
      casinoType: "2J-SLOT-019",
      Name: "FORTUNE DRAGON",
      gameType: "SLOT",
    },
    {
      platFormCode: "JJ",
      casinoType: "2J-SLOT-020",
      Name: "LEPRECHAUN'S COIN",
      gameType: "SLOT",
    },
    {
      platFormCode: "JJ",
      casinoType: "2J-SLOT-021",
      Name: "MEDUSA UNLEASHED",
      gameType: "SLOT",
    },
    {
      platFormCode: "JJ",
      casinoType: "2J-SLOT-022",
      Name: "DRAGON & TIGER",
      gameType: "SLOT",
    },
    {
      platFormCode: "JJ",
      casinoType: "2J-SLOT-023",
      Name: "ROMA",
      gameType: "SLOT",
    },
    {
      platFormCode: "JJ",
      casinoType: "2J-SLOT-024",
      Name: "JIN JI MAHJONG",
      gameType: "SLOT",
    },
    {
      platFormCode: "JJ",
      casinoType: "2J-SLOT-026",
      Name: "88 FORTUNES",
      gameType: "SLOT",
    },
    {
      platFormCode: "JJ",
      casinoType: "2J-SLOT-027",
      Name: "FAFAFA",
      gameType: "SLOT",
    },
    {
      platFormCode: "JJ",
      casinoType: "2J-SLOT-028",
      Name: "FORTUNE TIGER",
      gameType: "SLOT",
    },
    {
      platFormCode: "JJ",
      casinoType: "2J-SLOT-029",
      Name: "GOLDEN OX",
      gameType: "SLOT",
    },
    {
      platFormCode: "JJ",
      casinoType: "2J-SLOT-030",
      Name: "ENDLESS TREASURE",
      gameType: "SLOT",
    },
    {
      platFormCode: "JJ",
      casinoType: "2J-SLOT-031",
      Name: "GOLDEN CENTURY",
      gameType: "SLOT",
    },
    {
      platFormCode: "JJ",
      casinoType: "2J-SLOT-032",
      Name: "ORIENTAL RICHES",
      gameType: "SLOT",
    },
    {
      platFormCode: "JJ",
      casinoType: "2J-SLOT-033",
      Name: "JIN LOONG",
      gameType: "SLOT",
    },
    {
      platFormCode: "JJ",
      casinoType: "2J-SLOT-034",
      Name: "GOLD MANIA",
      gameType: "SLOT",
    },
    {
      platFormCode: "JJ",
      casinoType: "2J-SLOT-035",
      Name: "GATES OF OLYMPUS",
      gameType: "SLOT",
    },
    {
      platFormCode: "JJ",
      casinoType: "2J-SLOT-036",
      Name: "TREASURE OF AZTEC",
      gameType: "SLOT",
    },
    {
      platFormCode: "JJ",
      casinoType: "2J-SLOT-037",
      Name: "SUPER ACE",
      gameType: "SLOT",
    },
    {
      platFormCode: "JJ",
      casinoType: "2J-SLOT-038",
      Name: "GOLDEN BUFFALO",
      gameType: "SLOT",
    },
    {
      platFormCode: "JJ",
      casinoType: "2J-SLOT-039",
      Name: "FORTUNE RABBIT",
      gameType: "SLOT",
    },
    {
      platFormCode: "JJ",
      casinoType: "2J-SLOT-040",
      Name: "STARLIGHT PRINCESS 1000",
      gameType: "SLOT",
    },
    {
      platFormCode: "JJ",
      casinoType: "2J-SLOT-041",
      Name: "SWEET BONANZA 1000",
      gameType: "SLOT",
    },
    {
      platFormCode: "JJ",
      casinoType: "2J-SLOT-042",
      Name: "FORTUNE MOUSE",
      gameType: "SLOT",
    },
    {
      platFormCode: "JJ",
      casinoType: "2J-SLOT-043",
      Name: "PUMPKIN PARTY",
      gameType: "SLOT",
    },
    {
      platFormCode: "JJ",
      casinoType: "2J-SLOT-044",
      Name: "CLEOPATRA'S FLAME",
      gameType: "SLOT",
    },
    {
      platFormCode: "JJ",
      casinoType: "2J-SLOT-045",
      Name: "HUFF N PUFF",
      gameType: "SLOT",
    },
    {
      platFormCode: "JJ",
      casinoType: "2J-SLOT-046",
      Name: "ORB OF GANESHA",
      gameType: "SLOT",
    },
    {
      platFormCode: "JJ",
      casinoType: "2J-SLOT-047",
      Name: "PIGGY BANKIN",
      gameType: "SLOT",
    },
    {
      platFormCode: "JJ",
      casinoType: "2J-SLOT-048",
      Name: "RAILROAD RICHES",
      gameType: "SLOT",
    },
    {
      platFormCode: "JJ",
      casinoType: "2J-SLOT-049",
      Name: "BELL DEER",
      gameType: "SLOT",
    },
    {
      platFormCode: "JJ",
      casinoType: "2J-SLOT-050",
      Name: "FORTUNE GEMS",
      gameType: "SLOT",
    },
    {
      platFormCode: "JJ",
      casinoType: "2J-SLOT-051",
      Name: "MONEY MANIA",
      gameType: "SLOT",
    },
    {
      platFormCode: "JJ",
      casinoType: "2J-SLOT-052",
      Name: "FISH ON! BASS HUNTER",
      gameType: "SLOT",
    },
    {
      platFormCode: "JJ",
      casinoType: "2J-SLOT-053",
      Name: "COSMIC BLITZ",
      gameType: "SLOT",
    },
    {
      platFormCode: "JJ",
      casinoType: "2J-SLOT-054",
      Name: "X-PLOSIVE ROCK",
      gameType: "SLOT",
    },
    {
      platFormCode: "JJ",
      casinoType: "2J-SLOT-055",
      Name: "Y-PLOSIVE ROCK",
      gameType: "SLOT",
    },
    {
      platFormCode: "JJ",
      casinoType: "2J-SLOT-056",
      Name: "TRUMP IT",
      gameType: "SLOT",
    },
    {
      platFormCode: "JJ",
      casinoType: "2J-SLOT-057",
      Name: "FATHER KIM",
      gameType: "SLOT",
    },
    {
      platFormCode: "JJ",
      casinoType: "2J-SLOT-058",
      Name: "FPRTUNE GONG",
      gameType: "SLOT",
    },
    {
      platFormCode: "JJ",
      casinoType: "2J-SLOT-059",
      Name: "CHEESE CLASH",
      gameType: "SLOT",
    },
    {
      platFormCode: "JJ",
      casinoType: "2J-SLOT-060",
      Name: "CASHPOWER MANIA",
      gameType: "SLOT",
    },
    {
      platFormCode: "JJ",
      casinoType: "2J-SLOT-061",
      Name: "POWER OF KRAKEN",
      gameType: "SLOT",
    },
    {
      platFormCode: "JJ",
      casinoType: "2J-SLOT-062",
      Name: "KING KONG",
      gameType: "SLOT",
    },
    {
      platFormCode: "JJ",
      casinoType: "2J-SLOT-063",
      Name: "MAGIC DROP",
      gameType: "SLOT",
    },
    {
      platFormCode: "JJ",
      casinoType: "JJ-TABLE-001",
      Name: "DRAGON TIGER",
      gameType: "TABLE",
    },
    {
      platFormCode: "JJ",
      casinoType: "JJ-TABLE-002",
      Name: "RED VS BLACK",
      gameType: "TABLE",
    },
    {
      platFormCode: "JJ",
      casinoType: "JJ-TABLE-003",
      Name: "7 UP DOWN",
      gameType: "TABLE",
    },
    {
      platFormCode: "JJ",
      casinoType: "JJ-TABLE-004",
      Name: "BEST OF FIVE",
      gameType: "TABLE",
    },
    {
      platFormCode: "JJ",
      casinoType: "JJ-TABLE-005",
      Name: "CRICKET BATTLE\n / BEST CLUB",
      gameType: "TABLE",
    },
    {
      platFormCode: "JJ",
      casinoType: "JJ-TABLE-006",
      Name: "THREE DICE",
      gameType: "TABLE",
    },
    {
      platFormCode: "JJ",
      casinoType: "JJ-TABLE-007",
      Name: "ANDAR BAHAR",
      gameType: "TABLE",
    },
    {
      platFormCode: "JJ",
      casinoType: "JJ-TABLE-008",
      Name: "JHANDI MUNDA",
      gameType: "TABLE",
    },
    {
      platFormCode: "JJ",
      casinoType: "JJ-TABLE-009",
      Name: "ROULETTE",
      gameType: "TABLE",
    },
    {
      platFormCode: "JJ",
      casinoType: "JJ-TABLE-010",
      Name: "SIC BO",
      gameType: "TABLE",
    },
    {
      platFormCode: "JJ",
      casinoType: "JJ-TABLE-011",
      Name: "HOURSE RACING",
      gameType: "TABLE",
    },
    {
      platFormCode: "JJ",
      casinoType: "JJ-TABLE-012",
      Name: "LUCKY LOTTERY",
      gameType: "TABLE",
    },
    {
      platFormCode: "JJ",
      casinoType: "JJ-TABLE-013",
      Name: "BẦU CUA/HOO HEY HOW",
      gameType: "TABLE",
    },
    {
      platFormCode: "JJ",
      casinoType: "JJ-TABLE-014",
      Name: "BACCARAT",
      gameType: "TABLE",
    },
    {
      platFormCode: "JJ",
      casinoType: "JJ-TABLE-015",
      Name: "TH SICBO",
      gameType: "TABLE",
    },
    {
      platFormCode: "JJ",
      casinoType: "JJ-TABLE-016",
      Name: "SA BONG",
      gameType: "TABLE",
    },
    {
      platFormCode: "JJ",
      casinoType: "JJ-TABLE-017",
      Name: "CAR ROULETTE",
      gameType: "TABLE",
    },
    {
      platFormCode: "JJ",
      casinoType: "JJ-TABLE-018",
      Name: "COLOR GAME",
      gameType: "TABLE",
    },
    {
      platFormCode: "JJ",
      casinoType: "JJ-TABLE-019",
      Name: "TOSS A COIN",
      gameType: "TABLE",
    },
    {
      platFormCode: "JJ",
      casinoType: "JJ-TABLE-020",
      Name: "MYTHICAL ANIMALS",
      gameType: "TABLE",
    },
    {
      platFormCode: "JJ",
      casinoType: "JJ-TABLE-021",
      Name: "ZOO ROULETTE",
      gameType: "TABLE",
    },
    {
      platFormCode: "JJ",
      casinoType: "JJ-TABLE-022",
      Name: "DIRECTION BOUNTY",
      gameType: "TABLE",
    },
    {
      platFormCode: "JJ",
      casinoType: "JJ-TABLE-023",
      Name: "CRAZY WIN",
      gameType: "TABLE",
    },
    {
      platFormCode: "JJ",
      casinoType: "JJ-TABLE-024",
      Name: "CRICKET",
      gameType: "TABLE",
    },
    {
      platFormCode: "JJ",
      casinoType: "JJ-TABLE-025",
      Name: "POINT RUMMY",
      gameType: "TABLE",
    },
    {
      platFormCode: "JJ",
      casinoType: "JJ-TABLE-026",
      Name: "TEEN PATTI",
      gameType: "TABLE",
    },
    {
      platFormCode: "JJ",
      casinoType: "JJ-TABLE-027",
      Name: "TRUCO",
      gameType: "TABLE",
    },
    {
      platFormCode: "JJ",
      casinoType: "JJ-TABLE-028",
      Name: "CALL BREAK",
      gameType: "TABLE",
    },
    {
      platFormCode: "JJ",
      casinoType: "JJ-TABLE-029",
      Name: "BLACK JACK",
      gameType: "TABLE",
    },
    {
      platFormCode: "JJ",
      casinoType: "JJ-TABLE-030",
      Name: "DOMINO GAPLE",
      gameType: "TABLE",
    },
    {
      platFormCode: "JJ",
      casinoType: "JJ-TABLE-031",
      Name: "POOL RUMMY",
      gameType: "TABLE",
    },
    {
      platFormCode: "JJ",
      casinoType: "JJ-TABLE-032",
      Name: "DOMINO QIUQIU",
      gameType: "TABLE",
    },
    {
      platFormCode: "JJ",
      casinoType: "JJ-TABLE-033",
      Name: "QUICK LUDO",
      gameType: "TABLE",
    },
    {
      platFormCode: "JJ",
      casinoType: "JJ-TABLE-034",
      Name: "REMI",
      gameType: "TABLE",
    },
    {
      platFormCode: "JJ",
      casinoType: "JJ-TABLE-035",
      Name: "TEXAS HOLD'EM",
      gameType: "TABLE",
    },
    {
      platFormCode: "JJ",
      casinoType: "JJ-TABLE-036",
      Name: "BIG TWO",
      gameType: "TABLE",
    },
    {
      platFormCode: "JJ",
      casinoType: "JJ-TABLE-037",
      Name: "MẬU BINH",
      gameType: "TABLE",
    },
    {
      platFormCode: "JJ",
      casinoType: "JJ-TABLE-038",
      Name: "TONGITS",
      gameType: "TABLE",
    },
    {
      platFormCode: "JJ",
      casinoType: "JJ-TABLE-039",
      Name: "POKDENG",
      gameType: "TABLE",
    },
    {
      platFormCode: "JJ",
      casinoType: "JJ-TABLE-040",
      Name: "DUMMY",
      gameType: "TABLE",
    },
    {
      platFormCode: "JJ",
      casinoType: "JJ-TABLE-041",
      Name: "CRAZY LUDO",
      gameType: "TABLE",
    },
    {
      platFormCode: "JJ",
      casinoType: "JJ-TABLE-042",
      Name: "ALL-IN POKER",
      gameType: "TABLE",
    },
    {
      platFormCode: "JJ",
      casinoType: "JJ-TABLE-043",
      Name: "ANDAR BAHAR-BATTLE",
      gameType: "TABLE",
    },
    {
      platFormCode: "JJ",
      casinoType: "JJ-TABLE-044",
      Name: "CRASH",
      gameType: "TABLE",
    },
    {
      platFormCode: "JJ",
      casinoType: "JJ-TABLE-045",
      Name: "CRASH II",
      gameType: "TABLE",
    },
    {
      platFormCode: "JJ",
      casinoType: "2J-EGAME-001",
      Name: "PLINKO",
      gameType: "EGAME",
    },
    {
      platFormCode: "JJ",
      casinoType: "2J-EGAME-002",
      Name: "MINES",
      gameType: "EGAME",
    },
    {
      platFormCode: "JJ",
      casinoType: "2J-EGAME-003",
      Name: "LIMBO",
      gameType: "EGAME",
    },
    {
      platFormCode: "JJ",
      casinoType: "2J-EGAME-004",
      Name: "DICE",
      gameType: "EGAME",
    },
    {
      platFormCode: "JJ",
      casinoType: "2J-EGAME-005",
      Name: "MINES II",
      gameType: "EGAME",
    },
    {
      platFormCode: "JJ",
      casinoType: "2J-EGAME-006",
      Name: "HILO",
      gameType: "EGAME",
    },
    {
      platFormCode: "JJ",
      casinoType: "2J-EGAME-007",
      Name: "SNAKES AND LADDERS",
      gameType: "EGAME",
    },
    {
      platFormCode: "JJ",
      casinoType: "2J-FISH-001",
      Name: "Fishing",
      gameType: "FISH",
    },
    {
      platFormCode: "JJ",
      casinoType: "2J-FISH-002",
      Name: "Fishdom",
      gameType: "FISH",
    },
  ],
  ILOVEU: [
    {
      platFormCode: "ILOVEU",
      gameType: "SLOT",
      casinoType: "ILOVEU-SLOT-001",
      Name: "Jungle",
    },
    {
      platFormCode: "ILOVEU",
      gameType: "SLOT",
      casinoType: "ILOVEU-SLOT-002",
      Name: "Crazy Monkey",
    },
    {
      platFormCode: "ILOVEU",
      gameType: "SLOT",
      casinoType: "ILOVEU-SLOT-003",
      Name: "Qin",
    },
    {
      platFormCode: "ILOVEU",
      gameType: "SLOT",
      casinoType: "ILOVEU-SLOT-004",
      Name: "Ocean",
    },
    {
      platFormCode: "ILOVEU",
      gameType: "SLOT",
      casinoType: "ILOVEU-SLOT-005",
      Name: "Pyramid",
    },
    {
      platFormCode: "ILOVEU",
      gameType: "SLOT",
      casinoType: "ILOVEU-SLOT-006",
      Name: "Pirate Ship",
    },
    {
      platFormCode: "ILOVEU",
      gameType: "SLOT",
      casinoType: "ILOVEU-SLOT-008",
      Name: "Sango",
    },
    {
      platFormCode: "ILOVEU",
      gameType: "SLOT",
      casinoType: "ILOVEU-SLOT-009",
      Name: "Christmas",
    },
    {
      platFormCode: "ILOVEU",
      gameType: "SLOT",
      casinoType: "ILOVEU-SLOT-010",
      Name: "Aladdin",
    },
    {
      platFormCode: "ILOVEU",
      gameType: "SLOT",
      casinoType: "ILOVEU-SLOT-011",
      Name: "White Snake",
    },
    {
      platFormCode: "ILOVEU",
      gameType: "SLOT",
      casinoType: "ILOVEU-SLOT-012",
      Name: "Thai Paradise",
    },
    {
      platFormCode: "ILOVEU",
      gameType: "SLOT",
      casinoType: "ILOVEU-SLOT-013",
      Name: "Thunder God",
    },
    {
      platFormCode: "ILOVEU",
      gameType: "SLOT",
      casinoType: "ILOVEU-SLOT-014",
      Name: "Sparta",
    },
    {
      platFormCode: "ILOVEU",
      gameType: "SLOT",
      casinoType: "ILOVEU-SLOT-015",
      Name: "God Of Fortune",
    },
    {
      platFormCode: "ILOVEU",
      gameType: "SLOT",
      casinoType: "ILOVEU-SLOT-016",
      Name: "Safari Heat",
    },
    {
      platFormCode: "ILOVEU",
      gameType: "SLOT",
      casinoType: "ILOVEU-SLOT-017",
      Name: "Panther Moon",
    },
    {
      platFormCode: "ILOVEU",
      gameType: "SLOT",
      casinoType: "ILOVEU-SLOT-018",
      Name: "Great Blue",
    },
    {
      platFormCode: "ILOVEU",
      gameType: "SLOT",
      casinoType: "ILOVEU-SLOT-019",
      Name: "Huga",
    },
    {
      platFormCode: "ILOVEU",
      gameType: "SLOT",
      casinoType: "ILOVEU-SLOT-020",
      Name: "Beans Talk",
    },
    {
      platFormCode: "ILOVEU",
      gameType: "SLOT",
      casinoType: "ILOVEU-SLOT-021",
      Name: "Money Bang Bang",
    },
    {
      platFormCode: "ILOVEU",
      gameType: "SLOT",
      casinoType: "ILOVEU-SLOT-022",
      Name: "Dolphin Reef",
    },
    {
      platFormCode: "ILOVEU",
      gameType: "SLOT",
      casinoType: "ILOVEU-SLOT-023",
      Name: "Three Kingdoms",
    },
    {
      platFormCode: "ILOVEU",
      gameType: "SLOT",
      casinoType: "ILOVEU-SLOT-024",
      Name: "A Night Out",
    },
    {
      platFormCode: "ILOVEU",
      gameType: "SLOT",
      casinoType: "ILOVEU-SLOT-025",
      Name: "Golden Lotus",
    },
    {
      platFormCode: "ILOVEU",
      gameType: "SLOT",
      casinoType: "ILOVEU-SLOT-026",
      Name: "Penguin Vacation",
    },
    {
      platFormCode: "ILOVEU",
      gameType: "SLOT",
      casinoType: "ILOVEU-SLOT-027",
      Name: "Highway Kings JP",
    },
    {
      platFormCode: "ILOVEU",
      gameType: "SLOT",
      casinoType: "ILOVEU-SLOT-028",
      Name: "Robin Hood",
    },
    {
      platFormCode: "ILOVEU",
      gameType: "SLOT",
      casinoType: "ILOVEU-SLOT-029",
      Name: "Monkey King slot",
    },
    {
      platFormCode: "ILOVEU",
      gameType: "SLOT",
      casinoType: "ILOVEU-SLOT-030",
      Name: "God Of Wealth2",
    },
    {
      platFormCode: "ILOVEU",
      gameType: "SLOT",
      casinoType: "ILOVEU-SLOT-031",
      Name: "Fortune Panda",
    },
    {
      platFormCode: "ILOVEU",
      gameType: "SLOT",
      casinoType: "ILOVEU-SLOT-032",
      Name: "Hercules",
    },
    {
      platFormCode: "ILOVEU",
      gameType: "SLOT",
      casinoType: "ILOVEU-SLOT-033",
      Name: "Queen",
    },
    {
      platFormCode: "ILOVEU",
      gameType: "SLOT",
      casinoType: "ILOVEU-SLOT-034",
      Name: "African Wildilfe",
    },
    {
      platFormCode: "ILOVEU",
      gameType: "SLOT",
      casinoType: "ILOVEU-SLOT-035",
      Name: "Laura",
    },
    {
      platFormCode: "ILOVEU",
      gameType: "SLOT",
      casinoType: "ILOVEU-SLOT-036",
      Name: "Seasons Greetings",
    },
    {
      platFormCode: "ILOVEU",
      gameType: "SLOT",
      casinoType: "ILOVEU-SLOT-037",
      Name: "Big money",
    },
    {
      platFormCode: "ILOVEU",
      gameType: "SLOT",
      casinoType: "ILOVEU-SLOT-039",
      Name: "Fortune God",
    },
    {
      platFormCode: "ILOVEU",
      gameType: "SLOT",
      casinoType: "ILOVEU-SLOT-040",
      Name: "Dragon Fortune",
    },
    {
      platFormCode: "ILOVEU",
      gameType: "SLOT",
      casinoType: "ILOVEU-SLOT-041",
      Name: "Beer Party",
    },
    {
      platFormCode: "ILOVEU",
      gameType: "SLOT",
      casinoType: "ILOVEU-SLOT-042",
      Name: "Legend Of Nezha",
    },
    {
      platFormCode: "ILOVEU",
      gameType: "SLOT",
      casinoType: "ILOVEU-SLOT-043",
      Name: "Fortune Fuwa",
    },
    {
      platFormCode: "ILOVEU",
      gameType: "SLOT",
      casinoType: "ILOVEU-SLOT-044",
      Name: "Fortune Tiger",
    },
    {
      platFormCode: "ILOVEU",
      gameType: "SLOT",
      casinoType: "ILOVEU-SLOT-045",
      Name: "Queen Of Egypt",
    },
    {
      platFormCode: "ILOVEU",
      gameType: "SLOT",
      casinoType: "ILOVEU-SLOT-046",
      Name: "Might Of Zeus",
    },
    {
      platFormCode: "ILOVEU",
      gameType: "SLOT",
      casinoType: "ILOVEU-SLOT-047",
      Name: "FootBall Stars",
    },
    {
      platFormCode: "ILOVEU",
      gameType: "SLOT",
      casinoType: "ILOVEU-SLOT-048",
      Name: "The Lion King",
    },
    {
      platFormCode: "ILOVEU",
      gameType: "SLOT",
      casinoType: "ILOVEU-SLOT-049",
      Name: "Assassin",
    },
    {
      platFormCode: "ILOVEU",
      gameType: "SLOT",
      casinoType: "ILOVEU-SLOT-050",
      Name: "Storm Estate",
    },
    {
      platFormCode: "ILOVEU",
      gameType: "SLOT",
      casinoType: "ILOVEU-SLOT-051",
      Name: "Woodland",
    },
    {
      platFormCode: "ILOVEU",
      gameType: "SLOT",
      casinoType: "ILOVEU-SLOT-052",
      Name: "Temple",
    },
    {
      platFormCode: "ILOVEU",
      gameType: "SLOT",
      casinoType: "ILOVEU-SLOT-053",
      Name: "QinEmperor",
    },
    {
      platFormCode: "ILOVEU",
      gameType: "SLOT",
      casinoType: "ILOVEU-SLOT-055",
      Name: "Fruit 777",
    },
    {
      platFormCode: "ILOVEU",
      gameType: "SLOT",
      casinoType: "ILOVEU-SLOT-056",
      Name: "West Journey",
    },
    {
      platFormCode: "ILOVEU",
      gameType: "SLOT",
      casinoType: "ILOVEU-SLOT-057",
      Name: "Christmas Party",
    },
    {
      platFormCode: "ILOVEU",
      gameType: "SLOT",
      casinoType: "ILOVEU-SLOT-058",
      Name: "Wall Street",
    },
    {
      platFormCode: "ILOVEU",
      gameType: "SLOT",
      casinoType: "ILOVEU-SLOT-059",
      Name: "Gold Train",
    },
    {
      platFormCode: "ILOVEU",
      gameType: "SLOT",
      casinoType: "ILOVEU-SLOT-060",
      Name: "Ocean Quest",
    },
    {
      platFormCode: "ILOVEU",
      gameType: "SLOT",
      casinoType: "ILOVEU-SLOT-061",
      Name: "Mahjong Coming",
    },
    {
      platFormCode: "ILOVEU",
      gameType: "SLOT",
      casinoType: "ILOVEU-SLOT-062",
      Name: "Super Ace",
    },
    {
      platFormCode: "ILOVEU",
      gameType: "SLOT",
      casinoType: "ILOVEU-SLOT-063",
      Name: "Master Ninja",
    },
    {
      platFormCode: "ILOVEU",
      gameType: "SLOT",
      casinoType: "ILOVEU-SLOT-064",
      Name: "Fortune Jewel",
    },
  ],
  BG: [
    {
      platFormCode: "BG",
      gameType: "LIVE",
      casinoType: "BG-LIVE-001",
      Name: "BGLobby",
    },
    {
      platFormCode: "BG",
      gameType: "LIVE",
      casinoType: "BG-LIVE-002",
      Name: "Baccarat",
    },
    {
      platFormCode: "BG",
      gameType: "LIVE",
      casinoType: "BG-LIVE-003",
      Name: "Roulette",
    },
    {
      platFormCode: "BG",
      gameType: "LIVE",
      casinoType: "BG-LIVE-004",
      Name: "Sicbo",
    },
    {
      platFormCode: "BG",
      gameType: "LIVE",
      casinoType: "BG-LIVE-005",
      Name: "Dragontiger",
    },
    {
      platFormCode: "BG",
      gameType: "LIVE",
      casinoType: "BG-LIVE-006",
      Name: "SpeedBaccarat",
    },
    {
      platFormCode: "BG",
      gameType: "LIVE",
      casinoType: "BG-LIVE-007",
      Name: "MiCardBaccarat",
    },
    {
      platFormCode: "BG",
      gameType: "LIVE",
      casinoType: "BG-LIVE-008",
      Name: "FullColorBaccarat",
    },
    {
      platFormCode: "BG",
      gameType: "LIVE",
      casinoType: "BG-LIVE-009",
      Name: "BullBull",
    },
    {
      platFormCode: "BG",
      gameType: "LIVE",
      casinoType: "BG-LIVE-010",
      Name: "WinThreeCards",
    },
    {
      platFormCode: "BG",
      gameType: "LIVE",
      casinoType: "BG-LIVE-011",
      Name: "RedBlack",
    },
    {
      platFormCode: "BG",
      gameType: "LIVE",
      casinoType: "BG-LIVE-012",
      Name: "SpeedSicBo",
    },
    {
      platFormCode: "BG",
      gameType: "LIVE",
      casinoType: "BG-LIVE-013",
      Name: "SeDie",
    },
    {
      platFormCode: "BG",
      gameType: "LIVE",
      casinoType: "BG-LIVE-014",
      Name: "CasinoWar",
    },
  ],
  PLAY8: [
    {
      platFormCode: "PLAY8",
      gameType: "FH",
      casinoType: "P8-FISH-001",
      Name: "Ocean King",
    },
    {
      platFormCode: "PLAY8",
      gameType: "SLOT",
      casinoType: "P8-SLOT-001",
      Name: "Panther Moon",
    },
    {
      platFormCode: "PLAY8",
      gameType: "SLOT",
      casinoType: "P8-SLOT-002",
      Name: "Safari Heat",
    },
    {
      platFormCode: "PLAY8",
      gameType: "SLOT",
      casinoType: "P8-SLOT-003",
      Name: "Great Blue",
    },
    {
      platFormCode: "PLAY8",
      gameType: "SLOT",
      casinoType: "P8-SLOT-004",
      Name: "Jin Qian Wa",
    },
    {
      platFormCode: "PLAY8",
      gameType: "SLOT",
      casinoType: "P8-SLOT-005",
      Name: "Pan Jin Lian",
    },
    {
      platFormCode: "PLAY8",
      gameType: "SLOT",
      casinoType: "P8-SLOT-006",
      Name: "Dolphin Reef",
    },
    {
      platFormCode: "PLAY8",
      gameType: "SLOT",
      casinoType: "P8-SLOT-007",
      Name: "Highroad Kings JP",
    },
    {
      platFormCode: "PLAY8",
      gameType: "SLOT",
      casinoType: "P8-SLOT-008",
      Name: "The Discovery",
    },
    {
      platFormCode: "PLAY8",
      gameType: "SLOT",
      casinoType: "P8-SLOT-009",
      Name: "Silent Samurai",
    },
    {
      platFormCode: "PLAY8",
      gameType: "SLOT",
      casinoType: "P8-SLOT-010",
      Name: "Cherry Love",
    },
    {
      platFormCode: "PLAY8",
      gameType: "SLOT",
      casinoType: "P8-SLOT-011",
      Name: "Thai Paradise",
    },
    {
      platFormCode: "PLAY8",
      gameType: "SLOT",
      casinoType: "P8-SLOT-012",
      Name: "Captain Treasure",
    },
    {
      platFormCode: "PLAY8",
      gameType: "SLOT",
      casinoType: "P8-SLOT-013",
      Name: "Big Shot",
    },
    {
      platFormCode: "PLAY8",
      gameType: "SLOT",
      casinoType: "P8-SLOT-014",
      Name: "Sea Captain",
    },
    {
      platFormCode: "PLAY8",
      gameType: "SLOT",
      casinoType: "P8-SLOT-015",
      Name: "A Night Out",
    },
    {
      platFormCode: "PLAY8",
      gameType: "SLOT",
      casinoType: "P8-SLOT-016",
      Name: "Triple Twister",
    },
    {
      platFormCode: "PLAY8",
      gameType: "SLOT",
      casinoType: "P8-SLOT-017",
      Name: "Emperor Gate",
    },
    {
      platFormCode: "PLAY8",
      gameType: "SLOT",
      casinoType: "P8-SLOT-018",
      Name: "Ice Land",
    },
    {
      platFormCode: "PLAY8",
      gameType: "SLOT",
      casinoType: "P8-SLOT-019",
      Name: "T-Rex",
    },
    {
      platFormCode: "PLAY8",
      gameType: "SLOT",
      casinoType: "P8-SLOT-020",
      Name: "Tally Ho",
    },
    {
      platFormCode: "PLAY8",
      gameType: "SLOT",
      casinoType: "P8-SLOT-021",
      Name: "Fortune",
    },
    {
      platFormCode: "PLAY8",
      gameType: "SLOT",
      casinoType: "P8-SLOT-022",
      Name: "Dragon Gold",
    },
    {
      platFormCode: "PLAY8",
      gameType: "SLOT",
      casinoType: "P8-SLOT-023",
      Name: "Big Prosperity",
    },
    {
      platFormCode: "PLAY8",
      gameType: "SLOT",
      casinoType: "P8-SLOT-024",
      Name: "White King",
    },
    {
      platFormCode: "PLAY8",
      gameType: "SLOT",
      casinoType: "P8-SLOT-025",
      Name: "Golden Slut",
    },
    {
      platFormCode: "PLAY8",
      gameType: "SLOT",
      casinoType: "P8-SLOT-026",
      Name: "Rich Mouse",
    },
    {
      platFormCode: "PLAY8",
      gameType: "SLOT",
      casinoType: "P8-SLOT-027",
      Name: "Super Lucky Cat",
    },
    {
      platFormCode: "PLAY8",
      gameType: "SLOT",
      casinoType: "P8-SLOT-028",
      Name: "Wong Choy",
    },
    {
      platFormCode: "PLAY8",
      gameType: "SLOT",
      casinoType: "P8-SLOT-029",
      Name: "CrazyMonkey",
    },
    {
      platFormCode: "PLAY8",
      gameType: "SLOT",
      casinoType: "P8-SLOT-030",
      Name: "Jungle",
    },
    {
      platFormCode: "PLAY8",
      gameType: "SLOT",
      casinoType: "P8-SLOT-031",
      Name: "Ocean",
    },
    {
      platFormCode: "PLAY8",
      gameType: "SLOT",
      casinoType: "P8-SLOT-032",
      Name: "Pyramid",
    },
    {
      platFormCode: "PLAY8",
      gameType: "SLOT",
      casinoType: "P8-SLOT-033",
      Name: "Qin",
    },
    {
      platFormCode: "PLAY8",
      gameType: "SLOT",
      casinoType: "P8-SLOT-034",
      Name: "SangoWarlord",
    },
  ],
  HACKSAW: [
    {
      platFormCode: "HACKSAW",
      gameType: "EGAME",
      casinoType: "HACKSAW-EGAME-001",
      Name: "Mines",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "EGAME",
      casinoType: "HACKSAW-EGAME-002",
      Name: "Coins",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "EGAME",
      casinoType: "HACKSAW-EGAME-003",
      Name: "Boxes",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "EGAME",
      casinoType: "HACKSAW-EGAME-004",
      Name: "Plinko",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "EGAME",
      casinoType: "HACKSAW-EGAME-005",
      Name: "Hi-Lo",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "EGAME",
      casinoType: "HACKSAW-EGAME-006",
      Name: "Lines",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "EGAME",
      casinoType: "HACKSAW-EGAME-007",
      Name: "Wheel",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "EGAME",
      casinoType: "HACKSAW-EGAME-008",
      Name: "Blocks",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "EGAME",
      casinoType: "HACKSAW-EGAME-009",
      Name: "Colors",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "EGAME",
      casinoType: "HACKSAW-EGAME-010",
      Name: "Twenty-one",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "EGAME",
      casinoType: "HACKSAW-EGAME-011",
      Name: "Baccarat",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "EGAME",
      casinoType: "HACKSAW-EGAME-012",
      Name: "Dice",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "EGAME",
      casinoType: "HACKSAW-EGAME-013",
      Name: "Limbo",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "EGAME",
      casinoType: "HACKSAW-EGAME-014",
      Name: "Speed Crash",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-001",
      Name: "SCRATCH! Platinum",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-002",
      Name: "SCRATCH! Gold",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-003",
      Name: "SCRATCH! Silver",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-004",
      Name: "SCRATCH! Bronze",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-005",
      Name: "Express 200 Scratch",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-006",
      Name: "Scratchy Mini",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-007",
      Name: "Scratchy",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-008",
      Name: "Scratchy Big",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-009",
      Name: "King Treasure",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-010",
      Name: "Queen Treasure",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-011",
      Name: "Prince Treasure",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-012",
      Name: "Happy Scratch",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-013",
      Name: "Lucky Scratch",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-014",
      Name: "Dream Car Urban",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-015",
      Name: "Dream Car SUV",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-016",
      Name: "Dream Car Speed",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-017",
      Name: "Gold Rush",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-018",
      Name: "Ruby Rush",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-019",
      Name: "Diamond Rush",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-020",
      Name: "Lucky Shot",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-021",
      Name: "Lucky Numbers x8",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-022",
      Name: "Lucky Numbers x12",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-023",
      Name: "Lucky Numbers x16",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-024",
      Name: "Lucky Numbers x20",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-025",
      Name: "It's bananas!",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-026",
      Name: "Cash Vault I",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-027",
      Name: "Cash Vault II",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-028",
      Name: "Cut the Grass",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-029",
      Name: "Shave the Beard",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-030",
      Name: "Scratch’em",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-031",
      Name: "Double Salary - 1 Year",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-032",
      Name: "Koi Cash",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-033",
      Name: "Break the Ice",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-034",
      Name: "Gold Coins",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-035",
      Name: "Frogs scratch",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-036",
      Name: "Shave the Sheep",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-037",
      Name: "Rat Riches",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-038",
      Name: "Balloons",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-039",
      Name: "Crazy Donuts",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-040",
      Name: "Go Panda",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-041",
      Name: "Cash Pool",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-042",
      Name: "Cash Scratch",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-043",
      Name: "LOVE is all you need",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-044",
      Name: "Eggstra Cash",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-045",
      Name: "Chaos Crew Scratch",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-046",
      Name: "Football Scratch",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-047",
      Name: "The Perfect Scratch",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-048",
      Name: "Spooky Scary Scratchy",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-049",
      Name: "Snow Scratcher",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-050",
      Name: "Tiger Scratch",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-051",
      Name: "Stack 'em Scratch",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-052",
      Name: "Summer Scratch",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-053",
      Name: "Stick'em",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-054",
      Name: "OmNom",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-055",
      Name: "Miami Multiplier",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-056",
      Name: "Cubes",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-057",
      Name: "Cash Compass",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-058",
      Name: "The Respinners",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-059",
      Name: "Chaos Crew",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-060",
      Name: "Mystery Motel",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-061",
      Name: "Let It Snow",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-062",
      Name: "Cubes 2",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-063",
      Name: "Aztec Twist",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-064",
      Name: "Frutz",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-065",
      Name: "Stack 'Em",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-066",
      Name: "Hop'n'Pop",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-067",
      Name: "Xpander",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-068",
      Name: "Toshi Video Club",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-069",
      Name: "Rocket Reels",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-070",
      Name: "Wanted Dead or a Wild",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-071",
      Name: "Cash Quest",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-072",
      Name: "Tasty Treats",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-073",
      Name: "Joker Bombs",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-074",
      Name: "King Carrot",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-075",
      Name: "Harvest Wilds",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-076",
      Name: "The Bowery Boys",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-077",
      Name: "Double Rainbow",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-078",
      Name: "Warrior Ways",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-079",
      Name: "Gladiator Legends",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-080",
      Name: "Hand of Anubis",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-081",
      Name: "ITERO",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-082",
      Name: "Buffalo Stack'n'Sync",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-083",
      Name: "Outlaws Inc.",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-084",
      Name: "Born Wild",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-085",
      Name: "Dork Unit",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-086",
      Name: "Fruit Duel",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-087",
      Name: "Time Spinners",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-088",
      Name: "Forest Fortune",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-089",
      Name: "Alpha Eagle",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-090",
      Name: "Undead Fortune",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-091",
      Name: "Break Bones",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-092",
      Name: "Pug Life",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-093",
      Name: "Book of Time",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-094",
      Name: "Gronk's Gems",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-095",
      Name: "Rotten",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-096",
      Name: "RIP City",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-097",
      Name: "Frank's Farm",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-098",
      Name: "Bloodthirst",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-099",
      Name: "Magic Piggy",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-100",
      Name: "Keep 'em Cool",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-101",
      Name: "Stormforged",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-102",
      Name: "Fear the Dark",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-103",
      Name: "Cursed Seas",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-104",
      Name: "Mayan Stackways",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-105",
      Name: "Temple of Torment",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-106",
      Name: "Mighty Masks",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-107",
      Name: "Beast Below",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-108",
      Name: "Vending Machine",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-109",
      Name: "Drop'em",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-110",
      Name: "Ronin Stackways",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-111",
      Name: "Le Bandit",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-112",
      Name: "Densho",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-113",
      Name: "Chaos Crew 2",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-114",
      Name: "Benny The Beer",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-115",
      Name: "Eye of the Panda",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-116",
      Name: "Immortal Desire",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-117",
      Name: "Xmas Drop",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-118",
      Name: "Dark Summoning",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-119",
      Name: "2 Wild 2 Die",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-120",
      Name: "Feel The Beat",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-121",
      Name: "Beam Boys",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-122",
      Name: "Fist Of Destruction",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-123",
      Name: "Dawn of Kings",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-124",
      Name: "Bouncy Bombs",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-125",
      Name: "Rusty & Curly",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-126",
      Name: "Orb of Destiny",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-127",
      Name: "Divine Drop",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-128",
      Name: "Jelly Slice",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-129",
      Name: "Cash Crew",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-130",
      Name: "Keep'em",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-131",
      Name: "Slayers Inc",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-132",
      Name: "Cursed Crypt",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-133",
      Name: "Ze Zeus",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-134",
      Name: "Twisted Lab",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-135",
      Name: "Tai the Toad",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-136",
      Name: "SixSixSix",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-137",
      Name: "Dragon's Domain",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-138",
      Name: "Donny Dough",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-139",
      Name: "Evil Eyes",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-140",
      Name: "Octo Attack",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-141",
      Name: "Lord Venom",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-142",
      Name: "Commander of Tridents",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-143",
      Name: "Sleepy Grandpa",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-144",
      Name: "Fireborn",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-145",
      Name: "Mafia Clash",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-146",
      Name: "Merlin's Alchemy",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-147",
      Name: "Piggy Cluster Hunt",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-148",
      Name: "Barrel Bonanza",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-149",
      Name: "Space Zoo",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-150",
      Name: "Junkyard Kings",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-151",
      Name: "Holy Heist",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-152",
      Name: "Pickle Bandits",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-153",
      Name: "Blademaster",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-154",
      Name: "The Cursed King",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-155",
      Name: "Wild Dojo Strike",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-156",
      Name: "Shadow Strike",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-157",
      Name: "Pirate Bonanza",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-158",
      Name: "Le Pharaoh",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-159",
      Name: "Cloud Princess",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-160",
      Name: "Rise of Ymir",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-161",
      Name: "Get the CHEESE",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-162",
      Name: "Wings of Horus",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-163",
      Name: "Duel at Dawn",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-164",
      Name: "Snow Slingers",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-165",
      Name: "Shaolin Master",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-166",
      Name: "Donut Division",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-167",
      Name: "Fire my Laser",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-168",
      Name: "Klowns",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-169",
      Name: "Old Gun",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-170",
      Name: "Jawsome Pirates",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-171",
      Name: "Shadow Treasure",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-172",
      Name: "Desert Temple",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-173",
      Name: "Empress of the Shadows",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-174",
      Name: "Super Twins",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-175",
      Name: "Clumsy Cowboys",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-176",
      Name: "Lucky Multifruit",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-177",
      Name: "Chicken Man",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-178",
      Name: "Merlin's Mania",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-179",
      Name: "Blaze Buddies",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-180",
      Name: "Valhalla: Wild Winter",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-181",
      Name: "Bullet and Bounty",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-183",
      Name: "Gem Ghosts",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-184",
      Name: "Mystery Bats",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-185",
      Name: "Miami Mayhem",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-186",
      Name: "Tiger Legends",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-187",
      Name: "Le Zeus",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-188",
      Name: "Halls of Odin",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-189",
      Name: "Alchemist Wonders",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-190",
      Name: "The Wildwood Curse",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-191",
      Name: "Banana Farm",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-192",
      Name: "Bash Bros",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-193",
      Name: "Forbidden Fury",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-194",
      Name: "The Count",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-195",
      Name: "Sun Princess",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-196",
      Name: "Stormborn",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-197",
      Name: "Chaos Crew 3",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-198",
      Name: "Book Of Whispers",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-199",
      Name: "Grinning Harvest",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-200",
      Name: "Le Cowboy",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-201",
      Name: "Spear of Athena",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-202",
      Name: "Miss Candy's Sweet Escape",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-203",
      Name: "The Luxe H.V.",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-204",
      Name: "Steamrunners",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-205",
      Name: "Le Santa",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-206",
      Name: "Army of Ares",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-207",
      Name: "Neon Frames",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-208",
      Name: "Jaws of Justice",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-209",
      Name: "Donny and Danny",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-210",
      Name: "Toshi Ways Club",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-211",
      Name: "Through the Fire",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-212",
      Name: "Godly Gains",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-213",
      Name: "Coconut Chaos",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-214",
      Name: "Bullride Loot",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-215",
      Name: "Power Pops",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-216",
      Name: "Totem Poles",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-217",
      Name: "Evil Dozen",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-218",
      Name: "Smoking Dragon",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-219",
      Name: "Circle of Life",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-220",
      Name: "Deal With Death",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-221",
      Name: "Captain Coil",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-222",
      Name: "Thurisaz",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-223",
      Name: "Farmhouse",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-224",
      Name: "Mirage City",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-225",
      Name: "Fred's Food Truck",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-226",
      Name: "Penguin Royale",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-227",
      Name: "Superstar Sevens",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-228",
      Name: "Hot Ross",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-229",
      Name: "Lemur Levels",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-230",
      Name: "Dark Spiral",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-231",
      Name: "Ghostly Hallows",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-232",
      Name: "Monkey Frenzy 2: Boss is Here!",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-233",
      Name: "Dusk Princess",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-234",
      Name: "Le Bunny",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-235",
      Name: "3 Arcane Cauldrons",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-237",
      Name: "Jumpasaurs",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-238",
      Name: "Eternal Duel",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-239",
      Name: "Epic Bullets and Bounty",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-240",
      Name: "Crowned Corners",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-241",
      Name: "Power of Ten",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-242",
      Name: "Munchy Milo",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-244",
      Name: "Marlin Masters Atlantis",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-245",
      Name: "Junkyard Kings 2",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-246",
      Name: "Midnight Mirage",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-247",
      Name: "Avalanche!",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-248",
      Name: "The Lost Book of Mummy’s Curse",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-249",
      Name: "Peek & Pounce",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-250",
      Name: "Dynasty of Death",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-251",
      Name: "Le Digger",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-252",
      Name: "Magic Piggy OG",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-253",
      Name: "Bonnie's Buccaneers",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-254",
      Name: "Sand and Ashes",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-255",
      Name: "Red Rascal",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-256",
      Name: "Buzz Patrol",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-257",
      Name: "Demon Queen",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-258",
      Name: "The Jack & Rose",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-259",
      Name: "3 Cursed Chests: Hold & Win",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-260",
      Name: "Gobstopper Grind",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-261",
      Name: "Tikitopia BoosterBelt",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-262",
      Name: "Gearlab Genius",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-263",
      Name: "Rise of Fortuna",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-264",
      Name: "Great Game Rockies",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-265",
      Name: "Raidmark",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-266",
      Name: "Dandy Diamonds",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-267",
      Name: "Nitro Nights",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-268",
      Name: "Death Becomes You",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-269",
      Name: "Behind Bars: Masterplan",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-270",
      Name: "Leatherheads",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-271",
      Name: "Le Football Fan",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-272",
      Name: "Darkside Prairie: Magical Beast",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-273",
      Name: "Le Hooligan",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-274",
      Name: "The Crime File",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-275",
      Name: "Aliens Among Us",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-276",
      Name: "Opa Santorini!",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-277",
      Name: "Crownlings Clusters",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-278",
      Name: "Grug Make Fire",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-279",
      Name: "Arena of Iron",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-280",
      Name: "Le Prechaun",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-281",
      Name: "Henry 8th Calves of Steel",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-282",
      Name: "Crabby Collector",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-283",
      Name: "Drill The Thrill",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-284",
      Name: "Bullshark Brawl",
    },
    {
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-285",
      Name: "Trevor Hunter",
    },
  ],
  SMARTSOFT: [
    {
      platFormCode: "SMARTSOFT",
      gameType: "EGAME",
      casinoType: "SMARTSOFT-EGAME-001",
      Name: "JetX",
    },
    {
      platFormCode: "SMARTSOFT",
      gameType: "EGAME",
      casinoType: "SMARTSOFT-EGAME-002",
      Name: "Balloon",
    },
    {
      platFormCode: "SMARTSOFT",
      gameType: "EGAME",
      casinoType: "SMARTSOFT-EGAME-003",
      Name: "FootballX",
    },
    {
      platFormCode: "SMARTSOFT",
      gameType: "EGAME",
      casinoType: "SMARTSOFT-EGAME-004",
      Name: "PlinkoX",
    },
    {
      platFormCode: "SMARTSOFT",
      gameType: "EGAME",
      casinoType: "SMARTSOFT-EGAME-005",
      Name: "MineIsland",
    },
  ],
};
